import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

// src/icon-base.tsx
function createIcon(body, displayName) {
  function Icon({ size = "1em", className, ...rest }) {
    return /* @__PURE__ */ jsx(
      "svg",
      {
        viewBox: "0 0 14 14",
        width: size,
        height: size,
        fill: "none",
        className: className ? `semo-icon ${className}` : "semo-icon",
        "aria-hidden": rest["aria-label"] || rest["aria-labelledby"] ? void 0 : true,
        focusable: "false",
        ...rest,
        children: body
      }
    );
  }
  Icon.displayName = displayName;
  return Icon;
}
function createStrokeIcon(body, displayName) {
  function Icon({ size = "1em", className, ...rest }) {
    return /* @__PURE__ */ jsx(
      "svg",
      {
        viewBox: "0 0 24 24",
        width: size,
        height: size,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: className ? `semo-icon ${className}` : "semo-icon",
        "aria-hidden": rest["aria-label"] || rest["aria-labelledby"] ? void 0 : true,
        focusable: "false",
        ...rest,
        children: body
      }
    );
  }
  Icon.displayName = displayName;
  return Icon;
}
var Alt = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0C1.10218 0 0.720644 0.158035 0.43934 0.43934 0.158035 0.720644 0 1.10218 0 1.5v11c0 0.3978 0.158035 0.7794 0.43934 1.0607C0.720644 13.842 1.10217 14 1.5 14h11c0.3978 0 0.7794 -0.158 1.0607 -0.4393S14 12.8978 14 12.5v-11c0 -0.39783 -0.158 -0.779356 -0.4393 -1.06066C13.2794 0.158035 12.8978 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.36798 5.14682c-0.14697 -0.44089 -0.55957 -0.73828 -1.02431 -0.73828 -0.46475 0 -0.87735 0.29739 -1.02432 0.73828l-0.76573 2.29719c-0.00326 0.00908 -0.00632 0.01825 -0.00917 0.02751l-0.43243 1.29731c-0.10916 0.32747 0.06782 0.68142 0.39528 0.79057 0.32746 0.10915 0.68141 -0.06782 0.79057 -0.39528l0.29454 -0.88363h1.50251l0.29454 0.88363c0.10916 0.32746 0.46311 0.50443 0.79057 0.39528 0.32746 -0.10915 0.50444 -0.4631 0.39528 -0.79057l-0.43243 -1.2973c-0.00285 -0.00927 -0.00591 -0.01844 -0.00917 -0.02752l-0.76573 -2.29719Zm-1.3589 1.88367 0.33459 -1.00376 0.33458 1.00376h-0.66917Zm3.7143 -2.62195c0.34517 0 0.625 0.27982 0.625 0.625v3.30793h1.66921c0.34517 0 0.625 0.27983 0.625 0.625 0 0.34518 -0.27983 0.625 -0.625 0.625H6.72338c-0.34518 0 -0.625 -0.27982 -0.625 -0.625V5.03354c0 -0.34518 0.27982 -0.625 0.625 -0.625Zm6.19662 0.625c0 0.34518 -0.2798 0.625 -0.625 0.625h-0.6859v3.30793c0 0.34518 -0.2799 0.625 -0.625 0.625 -0.3452 0 -0.625 -0.27982 -0.625 -0.625V5.65854h-0.68603c-0.34517 0 -0.625 -0.27982 -0.625 -0.625s0.27983 -0.625 0.625 -0.625H12.295c0.3452 0 0.625 0.27982 0.625 0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Alt"
);
var ArrowBendLeftDown2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.5 4a2 2 0 0 1 2 -2H11a1 1 0 1 0 0 -2H8.5a4 4 0 0 0 -4 4l0 6h-2a0.5 0.5 0 0 0 -0.354 0.854l3 3a0.5 0.5 0 0 0 0.708 0l3 -3A0.5 0.5 0 0 0 8.5 10h-2l0 -6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowBendLeftDown2"
);
var ArrowBendRightDown2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 0c-0.55228 0 -1 0.447715 -1 1 0 0.55228 0.44772 1 1 1h2.5c1.10457 0 2 0.89543 2 2v6H5.49997c-0.20223 0 -0.38455 0.1218 -0.46194 0.3087 -0.07739 0.1868 -0.03461 0.4019 0.10839 0.5449l3 3c0.09376 0.0937 0.22094 0.1464 0.35355 0.1464 0.13261 0 0.25979 -0.0527 0.35355 -0.1464l2.99998 -3c0.143 -0.143 0.1858 -0.3581 0.1084 -0.5449C11.8845 10.1218 11.7022 10 11.5 10h-2V4c0 -2.20914 -1.79086 -4 -4 -4H3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowBendRightDown2"
);
var ArrowCrossoverDown = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.707 1.707A1 1 0 0 0 12.293 0.293L2.146 10.439 0.854 9.146A0.5 0.5 0 0 0 0 9.5v4a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.354 -0.854L3.56 11.854 13.707 1.707Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.707 0.293A1 1 0 0 0 0.293 1.707l10.146 10.147 -1.293 1.292A0.5 0.5 0 0 0 9.5 14h4a0.5 0.5 0 0 0 0.5 -0.5v-4a0.5 0.5 0 0 0 -0.854 -0.354l-1.292 1.293L1.707 0.293Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCrossoverDown"
);
var ArrowCrossoverLeft = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.854 0.854 3.56 2.146l10.146 10.147a1 1 0 0 1 -1.414 1.414L2.146 3.56 0.854 4.854A0.5 0.5 0 0 1 0 4.5v-4A0.5 0.5 0 0 1 0.5 0h4a0.5 0.5 0 0 1 0.354 0.854Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.707 0.293a1 1 0 0 1 0 1.414L3.561 11.854l1.293 1.292A0.5 0.5 0 0 1 4.5 14h-4a0.5 0.5 0 0 1 -0.5 -0.5v-4a0.5 0.5 0 0 1 0.854 -0.354l1.292 1.293L12.293 0.293a1 1 0 0 1 1.414 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCrossoverLeft"
);
var ArrowCrossoverRight = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.293 0.293a1 1 0 0 1 1.414 0l10.147 10.146 1.292 -1.293A0.5 0.5 0 0 1 14 9.5v4a0.5 0.5 0 0 1 -0.5 0.5h-4a0.5 0.5 0 0 1 -0.354 -0.854l1.293 -1.292L0.293 1.707a1 1 0 0 1 0 -1.414Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.5 0h-4a0.5 0.5 0 0 0 -0.354 0.854l1.293 1.292L0.293 12.293a1 1 0 1 0 1.414 1.414L11.854 3.561l1.292 1.293A0.5 0.5 0 0 0 14 4.5v-4a0.5 0.5 0 0 0 -0.5 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCrossoverRight"
);
var ArrowCrossoverUp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.038 0.309A0.5 0.5 0 0 1 9.5 0h4a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 1 -0.854 0.354L11.853 3.56 1.707 13.707a1 1 0 1 1 -1.414 -1.414L10.439 2.146 9.146 0.854a0.5 0.5 0 0 1 -0.108 -0.545Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 1V0.5A0.5 0.5 0 0 1 0.5 0h4a0.5 0.5 0 0 1 0.354 0.854L3.56 2.146l10.146 10.147a1 1 0 0 1 -1.414 1.414L2.146 3.561 0.854 4.854A0.5 0.5 0 0 1 0 4.5V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCrossoverUp"
);
var ArrowCursor1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.85846 0.0434611c-0.25062 -0.0616781 -0.51291 -0.0576469 -0.76151 0.0117036C0.848344 0.124515 0.621841 0.256839 0.43934 0.43934 0.256839 0.621841 0.124515 0.848344 0.0551647 1.09695c-0.0693505 0.2486 -0.0733817 0.51089 -0.0117036 0.76151l0.0001349 0.00055L2.3336 11.119l0.00048 0.002c0.06486 0.2577 0.19705 0.4937 0.38305 0.6836 0.18599 0.1899 0.41911 0.3269 0.67549 0.3971 0.25638 0.0702 0.52681 0.071 0.7836 0.0024 0.25636 -0.0686 0.48993 -0.2039 0.6769 -0.3922l0.00096 -0.0009 1.64489 -1.6449 3.64643 3.6464c0.1944 0.1944 0.5091 0.1954 0.7047 0.0024l3 -2.96c0.0949 -0.0936 0.1484 -0.2211 0.1489 -0.3542 0.0004 -0.1332 -0.0523 -0.2611 -0.1465 -0.3553l-3.6464 -3.64643 1.6464 -1.64644 0.0022 -0.00224c0.1888 -0.19119 0.3228 -0.42957 0.388 -0.69025 0.0651 -0.26067 0.059 -0.53405 -0.0176 -0.79158 -0.0766 -0.25753 -0.2211 -0.48974 -0.4181 -0.67236 -0.1952 -0.1808 -0.4348 -0.30643 -0.6944 -0.36408L1.85901 0.0435957 1.85846 0.0434611Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCursor1"
);
var ArrowCursor2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m1.972 0.08 -0.002 0A1.49 1.49 0 0 0 0.08 1.97l0.473 -0.162 -0.473 0.163 0.001 0.002 0.002 0.006 0.008 0.024 0.032 0.092 0.12 0.35L0.675 3.7a30731.61 30731.61 0 0 1 3.07 8.944l0.128 0.373 0.035 0.104 0.01 0.03a0.995 0.995 0 0 0 1.73 0.56 0.989 0.989 0 0 0 0.193 -0.26c0.045 -0.088 0.078 -0.187 0.11 -0.279l0.001 -0.004 0.995 -2.87 0.65 -1.876 0.213 -0.613 0.002 -0.005 0.007 -0.002 0.617 -0.218 1.885 -0.667a322.95 322.95 0 0 0 2.878 -1.027l0.046 -0.018c0.11 -0.043 0.307 -0.118 0.465 -0.276a0.994 0.994 0 0 0 0 -1.406l-0.01 -0.01a1.276 1.276 0 0 0 -0.182 -0.164 1.221 1.221 0 0 0 -0.373 -0.169l-0.002 0 -0.035 -0.012L13 3.8l-0.382 -0.127 -1.298 -0.436A5548.437 5548.437 0 0 1 3.687 0.66L2.441 0.24 2.093 0.12 2 0.091l-0.023 -0.01L1.972 0.08Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCursor2"
);
var ArrowCurvyUpDown1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.058 0.227a0.996 0.996 0 0 1 1.248 -0.016 0.995 0.995 0 0 1 0.093 0.082L13.707 2.6A1 1 0 0 1 13 4.308h-1.308v6.846a2.847 2.847 0 0 1 -5.692 0V2.846a0.846 0.846 0 0 0 -1.692 0v7.841l0 0.005V13a1 1 0 0 1 -1.707 0.707L0.293 11.4A1 1 0 0 1 1 9.692h1.308V2.846a2.846 2.846 0 0 1 5.692 0v8.308a0.846 0.846 0 1 0 1.692 0V1a0.997 0.997 0 0 1 0.366 -0.773Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCurvyUpDown1"
);
var ArrowCurvyUpDown2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.808 1.515c-0.797 0 -1.443 0.646 -1.443 1.443V8.57h1.25a0.5 0.5 0 0 1 0.354 0.854l-1.604 1.603v0.015H3.35l-0.381 0.382a0.5 0.5 0 0 1 -0.708 0l-0.38 -0.382h-0.016v-0.015L0.261 9.424a0.5 0.5 0 0 1 0.354 -0.854h1.25V2.958a2.942 2.942 0 0 1 5.885 0l0 8.084a1.442 1.442 0 0 0 2.885 0V5.368h-1.25a0.5 0.5 0 0 1 -0.354 -0.854l2 -2a0.5 0.5 0 0 1 0.707 0l2 2a0.5 0.5 0 0 1 -0.353 0.854h-1.25v5.674a2.942 2.942 0 1 1 -5.885 0l0 -8.084c0 -0.797 -0.646 -1.443 -1.442 -1.443Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowCurvyUpDown2"
);
var ArrowDown2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 13a1 1 0 0 1 1 -1h6a1 1 0 1 1 0 2H4a1 1 0 0 1 -1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8 1a1 1 0 0 0 -2 0v5H4a0.5 0.5 0 0 0 -0.354 0.854l3 3a0.5 0.5 0 0 0 0.708 0l3 -3A0.5 0.5 0 0 0 10 6H8V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowDown2"
);
var ArrowDownDashedSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.03835 12.5h1.92307c0.41422 0 0.75 0.3358 0.75 0.75s-0.33578 0.75 -0.75 0.75H6.03835c-0.41422 0 -0.75 -0.3358 -0.75 -0.75s0.33578 -0.75 0.75 -0.75Zm0 -11c-0.41422 0 -0.75 -0.33579 -0.75 -0.75 0 -0.414213 0.33578 -0.75 0.75 -0.75h1.92307c0.41422 0 0.75 0.335787 0.75 0.75 0 0.41421 -0.33578 0.75 -0.75 0.75l-1.92307 0Zm4.36805 11.8459c-0.1095 -0.3995 0.1256 -0.8121 0.5251 -0.9216 0.6997 -0.1917 1.2575 -0.7328 1.4725 -1.4231 0.1232 -0.3955 0.5436 -0.6162 0.9391 -0.493 0.3955 0.1232 0.6162 0.5436 0.493 0.9391 -0.3666 1.1771 -1.3138 2.0963 -2.5082 2.4237 -0.3995 0.1095 -0.8121 -0.1256 -0.9215 -0.5251Zm-6.81277 0c0.10948 -0.3995 -0.12562 -0.812 -0.5251 -0.9215 -0.6997 -0.1918 -1.25752 -0.7328 -1.47253 -1.4231 -0.12318 -0.3955 -0.54363 -0.6162 -0.939108 -0.4931 -0.395474 0.1232 -0.6162119 0.5437 -0.493032 0.9391 0.366634 1.1771 1.31378 2.0964 2.50822 2.4237 0.39948 0.1095 0.81208 -0.1256 0.92155 -0.5251ZM0.749878 8.71155c0.414212 0 0.750002 -0.33579 0.750002 -0.75l0 -1.92308c0 -0.41421 -0.33579 -0.75 -0.750002 -0.75 -0.414213 0 -0.74999933 0.33579 -0.749999485 0.75l-5.85e-7 1.92308c-1.56e-7 0.41421 0.33578607 0.75 0.75000007 0.75Zm11.750222 -0.75c0 0.41421 0.3358 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75l0 -1.92308c0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75l0 1.92308ZM0.656892 3.4917c0.395478 0.12318 0.815928 -0.09755 0.939108 -0.49303 0.21501 -0.69032 0.77283 -1.23136 1.47253 -1.42311 0.39948 -0.10947 0.63458 -0.52207 0.5251 -0.921551 -0.10947 -0.399485 -0.52207 -0.6345825 -0.92155 -0.525106C1.47764 0.456232 0.530493 1.37551 0.16386 2.5526c-0.12318 0.39547 0.097558 0.81592 0.493032 0.9391ZM12.404 2.99867c0.1232 0.39548 0.5436 0.61621 0.9391 0.49303 0.3955 -0.12318 0.6162 -0.54363 0.493 -0.9391 -0.3666 -1.17709 -1.3138 -2.096368 -2.5082 -2.423697 -0.3995 -0.1094765 -0.8121 0.125621 -0.9215 0.525106 -0.1095 0.399481 0.1256 0.812081 0.5251 0.921551 0.6997 0.19175 1.2575 0.73279 1.4725 1.42311Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.00001 3.25c0.41422 0 0.75 0.33579 0.75 0.75v3.5h1.25c0.20224 0 0.38455 0.12182 0.46194 0.30866 0.0774 0.18684 0.03462 0.40189 -0.10838 0.54489l-2 2.00005c-0.09377 0.0937 -0.22095 0.1464 -0.35356 0.1464 -0.1326 0 -0.25978 -0.0527 -0.35355 -0.1464l-2 -2.00005c-0.143 -0.143 -0.18578 -0.35805 -0.10839 -0.54489 0.0774 -0.18684 0.25971 -0.30866 0.46194 -0.30866h1.25V4c0 -0.41421 0.33579 -0.75 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowDownDashedSquare"
);
var ArrowExpand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 1v3.5a0.5 0.5 0 0 0 0.854 0.354L2.146 3.56l2.147 2.146a1 1 0 0 0 1.414 -1.414L3.561 2.146 4.854 0.854A0.5 0.5 0 0 0 4.5 0h-4a0.5 0.5 0 0 0 -0.5 0.5V1Zm5.707 8.707a1 1 0 0 0 -1.414 -1.414l-2.147 2.146L0.854 9.146A0.5 0.5 0 0 0 0 9.5v4a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.354 -0.854L3.56 11.854l2.146 -2.147Zm2.586 -1.414a1 1 0 0 1 1.414 0l2.147 2.146 1.292 -1.293A0.5 0.5 0 0 1 14 9.5v4a0.5 0.5 0 0 1 -0.5 0.5h-4a0.5 0.5 0 0 1 -0.354 -0.854l1.293 -1.292 -2.146 -2.147a1 1 0 0 1 0 -1.414ZM9.5 0a0.5 0.5 0 0 0 -0.354 0.854l1.293 1.292 -2.146 2.147a1 1 0 0 0 1.414 1.414l2.147 -2.146 1.292 1.293A0.5 0.5 0 0 0 14 4.5v-4a0.5 0.5 0 0 0 -0.5 -0.5h-4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowExpand"
);
var ArrowInfiniteLoop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.109 3.155a0.75 0.75 0 0 0 -1.28 -0.53L7.915 4.538a0.748 0.748 0 0 0 -0.104 0.946 0.75 0.75 0 0 0 0.629 0.34h1.916l0.017 0.001a6.036 6.036 0 0 1 0.36 0.02c0.243 0.02 0.438 0.05 0.517 0.079a1.89 1.89 0 0 1 1.241 1.958 0.745 0.745 0 0 0 0 0.143 1.89 1.89 0 0 1 -2.06 2.061 0.744 0.744 0 0 0 -0.072 -0.003c-0.37 0 -0.774 -0.2 -1.265 -0.684 -0.491 -0.484 -0.962 -1.144 -1.482 -1.879l-0.022 -0.032c-0.494 -0.696 -1.036 -1.461 -1.63 -2.048 -0.596 -0.587 -1.35 -1.102 -2.282 -1.115A3.39 3.39 0 0 0 0.009 7.954a3.39 3.39 0 0 0 3.675 3.628 3.025 3.025 0 0 0 1.885 -0.727 0.75 0.75 0 1 0 -0.976 -1.139c-0.27 0.23 -0.61 0.36 -0.965 0.367a0.709 0.709 0 0 0 -0.058 0.003 1.89 1.89 0 0 1 -2.061 -2.06 0.75 0.75 0 0 0 0 -0.144 1.89 1.89 0 0 1 2.06 -2.06 0.751 0.751 0 0 0 0.072 0.003c0.37 0 0.774 0.199 1.265 0.683 0.491 0.484 0.962 1.145 1.482 1.88l0.022 0.03c0.494 0.698 1.036 1.462 1.63 2.049 0.596 0.587 1.35 1.102 2.282 1.115a3.39 3.39 0 0 0 3.669 -3.628 3.388 3.388 0 0 0 -2.234 -3.442 3.1 3.1 0 0 0 -0.648 -0.137v-1.22Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowInfiniteLoop"
);
var ArrowMove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.761 7.549a0.748 0.748 0 0 0 0 -1.057l-1.994 -1.995a0.748 0.748 0 0 0 -0.778 -0.16 0.738 0.738 0 0 0 -0.499 0.689v0.997a0.25 0.25 0 0 1 -0.249 0.25H7.997a0.25 0.25 0 0 1 -0.25 -0.25V3.779a0.25 0.25 0 0 1 0.25 -0.25h0.997a0.738 0.738 0 0 0 0.689 -0.498 0.748 0.748 0 0 0 -0.16 -0.818L7.529 0.22a0.748 0.748 0 0 0 -1.058 0L4.477 2.213a0.748 0.748 0 0 0 -0.16 0.818 0.738 0.738 0 0 0 0.688 0.499h0.998a0.25 0.25 0 0 1 0.249 0.25v2.243a0.25 0.25 0 0 1 -0.25 0.25H3.76a0.25 0.25 0 0 1 -0.25 -0.25v-0.997a0.748 0.748 0 0 0 -1.276 -0.529L0.24 6.492a0.748 0.748 0 0 0 0 1.057l1.994 1.994c0.141 0.139 0.33 0.217 0.529 0.22a0.748 0.748 0 0 0 0.249 -0.06 0.738 0.738 0 0 0 0.499 -0.688v-0.998a0.25 0.25 0 0 1 0.249 -0.249h2.244a0.25 0.25 0 0 1 0.249 0.25v2.243a0.25 0.25 0 0 1 -0.25 0.25h-0.997a0.738 0.738 0 0 0 -0.688 0.458 0.748 0.748 0 0 0 0.16 0.818l1.994 1.994a0.748 0.748 0 0 0 1.058 0l1.994 -1.994a0.748 0.748 0 0 0 0.16 -0.778 0.738 0.738 0 0 0 -0.689 -0.498h-0.997a0.25 0.25 0 0 1 -0.25 -0.25V8.017a0.25 0.25 0 0 1 0.25 -0.249h2.244a0.25 0.25 0 0 1 0.25 0.25v0.997a0.738 0.738 0 0 0 0.458 0.688c0.091 0.039 0.19 0.06 0.29 0.06a0.768 0.768 0 0 0 0.528 -0.22L13.76 7.55Z" }),
    " "
  ] }) }),
  "ArrowMove"
);
var ArrowReloadHorizontal1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.354 0.146A0.5 0.5 0 0 0 8.5 0.5V2h-6A2.5 2.5 0 0 0 0 4.5V6a1 1 0 0 0 2 0V4.5a0.5 0.5 0 0 1 0.5 -0.5h6v1.5a0.5 0.5 0 0 0 0.854 0.354l2.5 -2.5a0.5 0.5 0 0 0 0 -0.708l-2.5 -2.5ZM5.19 8.038a0.5 0.5 0 0 1 0.31 0.462V10h6a0.5 0.5 0 0 0 0.5 -0.5V8a1 1 0 1 1 2 0v1.5a2.5 2.5 0 0 1 -2.5 2.5h-6v1.5a0.5 0.5 0 0 1 -0.854 0.354l-2.5 -2.5a0.5 0.5 0 0 1 0 -0.708l2.5 -2.5a0.5 0.5 0 0 1 0.545 -0.108Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowReloadHorizontal1"
);
var ArrowReloadHorizontal2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 5.543 4 4.25l-1 0a1 1 0 0 0 -1 1l0 3.5a1 1 0 0 0 1 1l1 0a1 1 0 0 1 0 2l-1 0a3 3 0 0 1 -3 -3l0 -3.5a3 3 0 0 1 3 -3l1 0L4 0.957a0.5 0.5 0 0 1 0.854 -0.353l2.292 2.293a0.5 0.5 0 0 1 0 0.707L4.854 5.896A0.5 0.5 0 0 1 4 5.543Zm6 6.207 0 1.293a0.5 0.5 0 0 1 -0.854 0.354l-2.292 -2.293a0.5 0.5 0 0 1 0 -0.707l2.292 -2.293a0.5 0.5 0 0 1 0.854 0.353l0 1.293 1 0a1 1 0 0 0 1 -1l0 -3.5a1 1 0 0 0 -1 -1l-1 0a1 1 0 1 1 0 -2l1 0a3 3 0 0 1 3 3l0 3.5a3 3 0 0 1 -3 3l-1 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowReloadHorizontal2"
);
var ArrowReloadVertical1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 0a1 1 0 0 0 0 2h1.5a0.5 0.5 0 0 1 0.5 0.5v6H8.5a0.5 0.5 0 0 0 -0.354 0.854l2.5 2.5a0.5 0.5 0 0 0 0.708 0l2.5 -2.5A0.5 0.5 0 0 0 13.5 8.5H12v-6A2.5 2.5 0 0 0 9.5 0H8ZM3.354 2.146a0.5 0.5 0 0 0 -0.708 0l-2.5 2.5A0.5 0.5 0 0 0 0.5 5.5H2v6A2.5 2.5 0 0 0 4.5 14H6a1 1 0 1 0 0 -2H4.5a0.5 0.5 0 0 1 -0.5 -0.5v-6h1.5a0.5 0.5 0 0 0 0.354 -0.854l-2.5 -2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowReloadVertical1"
);
var ArrowReloadVertical2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.4571 4H9.75V3c0 -0.55228 -0.44772 -1 -1 -1h-3.5c-0.55229 0 -1 0.44772 -1 1v1c0 0.55228 -0.44772 1 -1 1 -0.55229 0 -1 -0.44772 -1 -1V3c0 -1.65685 1.34314 -3 3 -3h3.5c1.6569 0 3 1.34315 3 3v1h1.2929c0.4454 0 0.6685 0.53857 0.3535 0.85355l-2.2929 2.2929c-0.1952 0.19526 -0.5118 0.19526 -0.7071 0l-2.29285 -2.2929C7.78857 4.53857 8.01165 4 8.4571 4ZM2.25 10H0.957104c-0.445453 0 -0.668537 -0.53857 -0.353555 -0.85355l2.292891 -2.2929c0.19527 -0.19526 0.51185 -0.19526 0.70711 0l2.29289 2.2929c0.31499 0.31498 0.0919 0.85355 -0.35355 0.85355H4.25v1c0 0.5523 0.44771 1 1 1h3.5c0.55228 0 1 -0.4477 1 -1v-1c0 -0.55229 0.4477 -1 1 -1s1 0.44771 1 1v1c0 1.6569 -1.3431 3 -3 3h-3.5c-1.65686 0 -3 -1.3431 -3 -3v-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowReloadVertical2"
);
var ArrowRoadmap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1 1a1 1 0 0 0 0 2h9.75a1.25 1.25 0 1 1 0 2.5H3.5a3.5 3.5 0 1 0 0 7H11v1a0.5 0.5 0 0 0 0.854 0.353l2 -2a0.5 0.5 0 0 0 0 -0.707l-2 -2A0.5 0.5 0 0 0 11 9.5v1H3.5a1.5 1.5 0 1 1 0 -3h7.25a3.25 3.25 0 0 0 0 -6.5H1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.5 2a2 2 0 1 1 -4 0 2 2 0 0 1 4 0Zm1 9.5a2 2 0 1 1 -4 0 2 2 0 0 1 4 0Zm1 -3a2 2 0 1 0 0 -4 2 2 0 0 0 0 4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowRoadmap"
);
var ArrowRoundLeft = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.351 1.002a0.75 0.75 0 0 0 -1.28 -0.53l-2.4 2.4a0.75 0.75 0 0 0 0 1.06l2.4 2.399a0.75 0.75 0 0 0 1.28 -0.53V4.4H7a3.798 3.798 0 1 1 -3.798 3.8 1 1 0 1 0 -2 0A5.798 5.798 0 1 0 7 2.401H5.351V1.002Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowRoundLeft"
);
var ArrowRoundRight = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.64904 1.00245c0 -0.303349 0.18273 -0.576826 0.46299 -0.692912 0.28025 -0.116085 0.60284 -0.051918 0.81734 0.16258L12.3284 2.87114c0.2929 0.29289 0.2929 0.76777 0 1.06066L9.92937 6.33082c-0.2145 0.2145 -0.53709 0.27867 -0.81734 0.16258 -0.28026 -0.11608 -0.46299 -0.38956 -0.46299 -0.69291V4.40137H7.00002c-2.0976 0 -3.79805 1.70045 -3.79805 3.79805 0 2.09758 1.70045 3.79808 3.79805 3.79808s3.79808 -1.7005 3.79808 -3.79808c0 -0.55229 0.4477 -1 1 -1 0.5522 0 1 0.44771 1 1 0 3.20218 -2.5959 5.79808 -5.79808 5.79808 -3.20217 0 -5.79805 -2.5959 -5.79805 -5.79808 0 -3.20217 2.59588 -5.79805 5.79805 -5.79805h1.64902V1.00245Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowRoundRight"
);
var ArrowShrinkDiagonal1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.707 1.707A1 1 0 0 0 12.293 0.293l-2.147 2.146 -1.292 -1.293A0.5 0.5 0 0 0 8 1.5v4a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.354 -0.854L11.56 3.854l2.146 -2.147Zm-8.56 11.147L3.853 11.56l-2.147 2.146a1 1 0 0 1 -1.414 -1.414l2.146 -2.147 -1.293 -1.292A0.5 0.5 0 0 1 1.5 8h4a0.5 0.5 0 0 1 0.5 0.5v4a0.5 0.5 0 0 1 -0.854 0.354Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowShrinkDiagonal1"
);
var ArrowShrinkDiagonal2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.707 0.293A1 1 0 0 0 0.293 1.707l2.146 2.147 -1.293 1.292A0.5 0.5 0 0 0 1.5 6h4a0.5 0.5 0 0 0 0.5 -0.5v-4a0.5 0.5 0 0 0 -0.854 -0.354L3.854 2.44 1.707 0.293Zm11.147 8.56 -1.293 1.293 2.146 2.147a1 1 0 0 1 -1.414 1.414l-2.147 -2.146 -1.292 1.293A0.5 0.5 0 0 1 8 12.5v-4a0.5 0.5 0 0 1 0.5 -0.5h4a0.5 0.5 0 0 1 0.354 0.854Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowShrinkDiagonal2"
);
var ArrowShrink = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.293 0.293a1 1 0 0 1 1.414 0l1.397 1.396L4.146 0.646A0.5 0.5 0 0 1 5 1v3.5a0.5 0.5 0 0 1 -0.5 0.5H1a0.5 0.5 0 0 1 -0.354 -0.854L1.69 3.104 0.293 1.707a1 1 0 0 1 0 -1.414Zm9.016 0.245a0.5 0.5 0 0 1 0.545 0.108l1.043 1.043L12.293 0.293a1 1 0 1 1 1.414 1.414l-1.396 1.397 1.043 1.042A0.5 0.5 0 0 1 13 5H9.5a0.5 0.5 0 0 1 -0.5 -0.5V1a0.5 0.5 0 0 1 0.309 -0.462ZM1 9a0.5 0.5 0 0 0 -0.354 0.854l1.043 1.043 -1.396 1.396a1 1 0 1 0 1.414 1.414l1.397 -1.396 1.042 1.043A0.5 0.5 0 0 0 5 13V9.5a0.5 0.5 0 0 0 -0.5 -0.5H1Zm8 0.5a0.5 0.5 0 0 1 0.5 -0.5H13a0.5 0.5 0 0 1 0.354 0.854l-1.043 1.043 1.396 1.396a1 1 0 0 1 -1.414 1.414l-1.397 -1.396 -1.042 1.043A0.5 0.5 0 0 1 9 13V9.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowShrink"
);
var ArrowTransferDiagonal1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.998 1.068a0.996 0.996 0 0 1 -0.29 0.64l-2 2 -7 7A1 1 0 0 1 0.292 9.292L6.586 3 5.293 1.707A1 1 0 0 1 6 0h4a1 1 0 0 1 0.674 0.261m0.082 0.084ZM7.414 11l6.293 -6.293a1 1 0 0 0 -1.414 -1.414l-7 7 -2 2a0.996 0.996 0 0 0 -0.05 1.36A0.996 0.996 0 0 0 4 14h4a1 1 0 0 0 0.707 -1.708L7.414 11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowTransferDiagonal1"
);
var ArrowTransferDiagonal2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 0a1 1 0 0 1 0.707 1.707L7.406 3.008l6.3 6.284a1 1 0 0 1 -1.412 1.416L3.278 1.716a1 1 0 0 1 0.28 -1.613A0.999 0.999 0 0 1 4 0h4ZM6.586 11 0.293 4.707a1 1 0 0 1 1.414 -1.414l7 7 2 2a0.996 0.996 0 0 1 0.05 1.36A0.996 0.996 0 0 1 10 14H6a1 1 0 0 1 -0.707 -1.708L6.586 11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowTransferDiagonal2"
);
var ArrowTransferDiagonal3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6 0h3.5c0.27614 0 0.5 0.223858 0.5 0.5V4c0 0.20223 -0.12182 0.38455 -0.30866 0.46194 -0.18684 0.07739 -0.40189 0.03461 -0.54489 -0.10839l-1.0429 -1.04289 -5.89644 5.89645c-0.39053 0.39052 -1.02369 0.39052 -1.414217 0 -0.390524 -0.39053 -0.390524 -1.02369 0 -1.41422L6.68934 1.89645 5.64645 0.853553c-0.143 -0.142999 -0.18578 -0.358058 -0.10839 -0.544895C5.61545 0.121821 5.79777 0 6 0Zm7.2071 6.20711c0.3905 -0.39053 0.3905 -1.02369 0 -1.41422 -0.3905 -0.39052 -1.0237 -0.39052 -1.4142 0L5.89645 10.6893l-1.0429 -1.04285c-0.143 -0.143 -0.35805 -0.18578 -0.54489 -0.10839S4 9.79777 4 10v3.5c0 0.2761 0.22386 0.5 0.5 0.5H8c0.20223 0 0.38455 -0.1218 0.46194 -0.3087 0.07739 -0.1868 0.03461 -0.4019 -0.10839 -0.5449l-1.04289 -1.0428 5.89644 -5.89649Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowTransferDiagonal3"
);
var ArrowUp1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.646 0.146a0.5 0.5 0 0 1 0.708 0l3.5 3.5a0.5 0.5 0 0 1 -0.354 0.854H8V13a1 1 0 1 1 -2 0V4.5H3.5a0.5 0.5 0 0 1 -0.354 -0.854l3.5 -3.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowUp1"
);
var ArrowUpDashedSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m7.962 1.5 -1.923 0a0.75 0.75 0 0 1 0 -1.5h1.923a0.75 0.75 0 0 1 0 1.5Zm0 11a0.75 0.75 0 0 1 0 1.5H6.039a0.75 0.75 0 0 1 0 -1.5h1.923ZM10.406 0.654a0.75 0.75 0 0 0 0.525 0.922 2.14 2.14 0 0 1 1.473 1.423 0.75 0.75 0 1 0 1.432 -0.446A3.64 3.64 0 0 0 11.328 0.129a0.75 0.75 0 0 0 -0.922 0.525Zm-6.812 0a0.75 0.75 0 0 1 -0.525 0.922 2.14 2.14 0 0 0 -1.473 1.423 0.75 0.75 0 1 1 -1.432 -0.446A3.64 3.64 0 0 1 2.672 0.129a0.75 0.75 0 0 1 0.922 0.525Zm9.656 4.634a0.75 0.75 0 0 0 -0.75 0.75l0 1.924a0.75 0.75 0 0 0 1.5 0l0 -1.924a0.75 0.75 0 0 0 -0.75 -0.75Zm-11.75 0.75a0.75 0.75 0 0 0 -1.5 0l0 1.924a0.75 0.75 0 0 0 1.5 0l0 -1.924Zm11.843 4.47a0.75 0.75 0 0 0 -0.939 0.493 2.14 2.14 0 0 1 -1.473 1.423 0.75 0.75 0 0 0 0.397 1.447 3.64 3.64 0 0 0 2.508 -2.424 0.75 0.75 0 0 0 -0.493 -0.939Zm-11.747 0.493a0.75 0.75 0 0 0 -1.432 0.446 3.64 3.64 0 0 0 2.508 2.424 0.75 0.75 0 1 0 0.397 -1.447 2.14 2.14 0 0 1 -1.473 -1.423Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.462 6.191A0.5 0.5 0 0 1 9 6.5H7.75V10a0.75 0.75 0 0 1 -1.5 0V6.5H5a0.5 0.5 0 0 1 -0.354 -0.854l2 -2a0.5 0.5 0 0 1 0.708 0l2 2a0.5 0.5 0 0 1 0.108 0.545Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArrowUpDashedSquare"
);
var ExpandHorizontal1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0a0.75 0.75 0 0 1 0.75 0.75v12.5a0.75 0.75 0 0 1 -1.5 0V0.75A0.75 0.75 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.98 3.87a0.5 0.5 0 0 0 -0.854 -0.353L0.26 6.384a0.86 0.86 0 0 0 0 1.233l2.867 2.867a0.5 0.5 0 0 0 0.854 -0.354V3.87Zm6.349 -0.462a0.5 0.5 0 0 1 0.545 0.109l2.867 2.867a0.862 0.862 0 0 1 0 1.233l-2.867 2.867a0.5 0.5 0 0 1 -0.854 -0.354V3.87a0.5 0.5 0 0 1 0.309 -0.462Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ExpandHorizontal1"
);
var ExpandWindow2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M14 11.5a2.5 2.5 0 0 1 -2.5 2.5h-9A2.5 2.5 0 0 1 0 11.5l0 -9A2.5 2.5 0 0 1 2.5 0L7 0a1 1 0 0 1 0 2L2.5 2a0.5 0.5 0 0 0 -0.5 0.5l0 9a0.5 0.5 0 0 0 0.5 0.5h9a0.5 0.5 0 0 0 0.5 -0.5L12 7a1 1 0 1 1 2 0l0 4.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.293 6.293a1 1 0 0 0 1.414 1.414l4.397 -4.396 1.042 1.043A0.5 0.5 0 0 0 14 4V0.5a0.5 0.5 0 0 0 -0.5 -0.5L10 0a0.5 0.5 0 0 0 -0.354 0.854l1.043 1.042 -4.396 4.397Z" }),
    " "
  ] }) }),
  "ExpandWindow2"
);
var Expand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.49997 4.99951c0 -0.82843 0.67157 -1.5 1.5 -1.5h4c0.82843 0 1.50003 0.67157 1.50003 1.5v4c0 0.82843 -0.6716 1.49999 -1.50003 1.49999h-4c-0.82843 0 -1.5 -0.67156 -1.5 -1.49999v-4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 1.75c0 -0.13807 0.11193 -0.25 0.25 -0.25h0.5c0.41421 0 0.75 -0.33579 0.75 -0.75C3 0.335786 2.66421 0 2.25 0h-0.5C0.783502 0 0 0.783502 0 1.75v0.5c0 0.41421 0.335786 0.75 0.75 0.75 0.41421 0 0.75 -0.33579 0.75 -0.75v-0.5ZM11.75 0c-0.4142 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.3358 0.75 0.75 0.75h0.5c0.1381 0 0.25 0.11193 0.25 0.25v0.5c0 0.41421 0.3358 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-0.5C14 0.783502 13.2165 0 12.25 0h-0.5Zm1.5 11c0.4142 0 0.75 0.3358 0.75 0.75v0.5c0 0.9665 -0.7835 1.75 -1.75 1.75h-0.5c-0.4142 0 -0.75 -0.3358 -0.75 -0.75s0.3358 -0.75 0.75 -0.75h0.5c0.1381 0 0.25 -0.1119 0.25 -0.25v-0.5c0 -0.4142 0.3358 -0.75 0.75 -0.75Zm-11.74988 0.75c0 -0.4142 -0.33578 -0.75 -0.749998 -0.75 -0.414213 0 -0.74999993 0.3358 -0.74999993 0.75v0.5c0 0.9665 0.78350193 1.75 1.74999793 1.75h0.5c0.41422 0 0.75 -0.3358 0.75 -0.75s-0.33578 -0.75 -0.75 -0.75h-0.5c-0.13807 0 -0.25 -0.1119 -0.25 -0.25v-0.5ZM5.25 13.25c0 -0.4142 0.33579 -0.75 0.75 -0.75h2c0.41421 0 0.75 0.3358 0.75 0.75S8.41421 14 8 14H6c-0.41421 0 -0.75 -0.3358 -0.75 -0.75ZM6 0c-0.41421 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.33579 0.75 0.75 0.75h2c0.41421 0 0.75 -0.33579 0.75 -0.75C8.75 0.335786 8.41421 0 8 0H6ZM0.75 5.25c0.41421 0 0.75 0.33579 0.75 0.75v2c0 0.41421 -0.33579 0.75 -0.75 0.75C0.335786 8.75 0 8.41421 0 8V6c0 -0.41421 0.335786 -0.75 0.75 -0.75ZM14 6c0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v2c0 0.41421 0.3358 0.75 0.75 0.75S14 8.41421 14 8V6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Expand"
);
var Login1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h7a1.5 1.5 0 0 0 1.5 -1.5V9.25h-0.516a2 2 0 0 1 -3.398 1.164l-2 -2a2 2 0 0 1 0 -2.828l2 -2A2 2 0 0 1 9.484 4.75H10V1.5A1.5 1.5 0 0 0 8.5 0h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.25 5a0.75 0.75 0 0 0 -1.28 -0.53l-2 2a0.75 0.75 0 0 0 0 1.06l2 2A0.75 0.75 0 0 0 8.25 9V8H13a1 1 0 1 0 0 -2H8.25V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Login1"
);
var Logout1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h7a1.5 1.5 0 0 0 1.5 -1.5v-1.939a2 2 0 0 1 -0.734 -1.311H5.75a2.25 2.25 0 0 1 0 -4.5h3.516A2 2 0 0 1 10 3.439V1.5A1.5 1.5 0 0 0 8.5 0h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.5 5a0.75 0.75 0 0 1 1.28 -0.53l2 2a0.75 0.75 0 0 1 0 1.06l-2 2A0.75 0.75 0 0 1 10.5 9V8H5.75a1 1 0 1 1 0 -2h4.75V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Logout1"
);
var MinimizeWindow2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 2.5A2.5 2.5 0 0 1 2.5 0h9A2.5 2.5 0 0 1 14 2.5v9a2.5 2.5 0 0 1 -2.5 2.5H7a1 1 0 1 1 0 -2h4.5a0.5 0.5 0 0 0 0.5 -0.5v-9a0.5 0.5 0 0 0 -0.5 -0.5h-9a0.5 0.5 0 0 0 -0.5 0.5V7a1 1 0 0 1 -2 0V2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.707 7.707a1 1 0 0 0 -1.414 -1.414l-4.397 4.396L0.854 9.646A0.5 0.5 0 0 0 0 10v3.5a0.5 0.5 0 0 0 0.5 0.5H4a0.5 0.5 0 0 0 0.354 -0.854L3.31 12.104l4.396 -4.397Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MinimizeWindow2"
);
var MoveLeft = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 1.5A1.5 1.5 0 0 1 10 0h2.5A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5H10a1.5 1.5 0 0 1 -1.5 -1.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.191 4.038A0.5 0.5 0 0 1 3.5 4.5V6h3a1 1 0 0 1 0 2h-3v1.5a0.5 0.5 0 0 1 -0.854 0.354l-2.5 -2.5a0.5 0.5 0 0 1 0 -0.708l2.5 -2.5a0.5 0.5 0 0 1 0.545 -0.108Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MoveLeft"
);
var MoveRight = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0H4a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 4 14H1.5A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.809 4.038a0.5 0.5 0 0 1 0.545 0.108l2.5 2.5a0.5 0.5 0 0 1 0 0.708l-2.5 2.5A0.5 0.5 0 0 1 10.5 9.5V8h-3a1 1 0 1 1 0 -2h3V4.5a0.5 0.5 0 0 1 0.309 -0.462Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MoveRight"
);
var NavigationArrowOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.898 13.724a0.5 0.5 0 0 0 0.908 -0.03l5.02 -11.864a0.5 0.5 0 0 0 -0.656 -0.656L0.305 6.194a0.5 0.5 0 0 0 -0.029 0.908l4.266 2.133a0.5 0.5 0 0 1 0.223 0.223l2.133 4.266Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NavigationArrowOff"
);
var NavigationArrowOn = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.96 0.695a0.5 0.5 0 0 0 -0.655 -0.655l-13 5.5a0.5 0.5 0 0 0 -0.029 0.907l4.851 2.426 2.426 4.85a0.5 0.5 0 0 0 0.907 -0.028l5.5 -13Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NavigationArrowOn"
);
var Next = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13 2.5a1 1 0 0 1 1 1v7a1 1 0 1 1 -2 0v-7a1 1 0 0 1 1 -1ZM6 8.25l-4.75 0a1.25 1.25 0 1 1 0 -2.5l4.75 0V3.707a0.5 0.5 0 0 1 0.854 -0.353l3.292 3.292a0.5 0.5 0 0 1 0 0.708l-3.292 3.292A0.5 0.5 0 0 1 6 10.293V8.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Next"
);
var Return2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.545 0.998a1 1 0 0 0 0 2h2.728a2.638 2.638 0 0 1 0 5.275H4.817V6.545a1 1 0 0 0 -1.707 -0.707L0.384 8.564a1.004 1.004 0 0 0 -0.22 1.09c0.049 0.119 0.121 0.23 0.218 0.327l2.728 2.728a1 1 0 0 0 1.707 -0.707v-1.729h4.456a4.638 4.638 0 1 0 0 -9.275H6.545Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Return2"
);
var Shift = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.646 0.854 1.354 6.146A0.5 0.5 0 0 0 1.707 7H3.5v6a0.5 0.5 0 0 0 0.5 0.5h6a0.5 0.5 0 0 0 0.5 -0.5V7h1.793a0.5 0.5 0 0 0 0.353 -0.854L7.354 0.854a0.5 0.5 0 0 0 -0.708 0Z" }),
    " "
  ] }) }),
  "Shift"
);
var ShrinkHorizontal1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0.75a0.75 0.75 0 0 0 -1.5 0v12.5a0.75 0.75 0 0 0 1.5 0V0.75Zm12.5 0a0.75 0.75 0 0 0 -1.5 0v12.5a0.75 0.75 0 0 0 1.5 0V0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.809 4.038a0.5 0.5 0 0 1 0.545 0.108l2.5 2.5a0.5 0.5 0 0 1 0 0.708l-2.5 2.5A0.5 0.5 0 0 1 2.5 9.5v-5a0.5 0.5 0 0 1 0.309 -0.462ZM11.5 4.5a0.5 0.5 0 0 0 -0.854 -0.354l-2.5 2.5a0.5 0.5 0 0 0 0 0.708l2.5 2.5A0.5 0.5 0 0 0 11.5 9.5v-5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShrinkHorizontal1"
);
var SplitVertical = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 0.5v4c0 0.20223 0.121821 0.38455 0.308658 0.46194 0.186837 0.07739 0.401896 0.03461 0.544895 -0.10839L2.14645 3.56066 6 7.41421v5.58099c0 0.5523 0.44772 1 1 1s1 -0.4477 1 -1V7.41421l3.8536 -3.85355 1.2928 1.29289c0.143 0.143 0.3581 0.18578 0.5449 0.10839C13.8782 4.88455 14 4.70223 14 4.5v-4c0 -0.276142 -0.2239 -0.5 -0.5 -0.5h-4c-0.20223 0 -0.38455 0.121821 -0.46194 0.308658 -0.07739 0.186837 -0.03461 0.401896 0.10839 0.544895L10.4393 2.14645 7 5.58579 3.56066 2.14645 4.85355 0.853553c0.143 -0.142999 0.18578 -0.358058 0.10839 -0.544895C4.88455 0.121821 4.70223 0 4.5 0h-4C0.223858 0 0 0.223858 0 0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SplitVertical"
);
var SynchronizeDisable = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m10.929 0.757 -0.322 0.537a6.751 6.751 0 0 1 -0.794 11.844 0.75 0.75 0 0 1 -0.626 -1.364 5.25 5.25 0 0 0 0.648 -9.194l-0.406 0.677a0.5 0.5 0 0 1 -0.914 -0.136l-0.5 -2a0.5 0.5 0 0 1 0.364 -0.606l2 -0.5a0.5 0.5 0 0 1 0.55 0.742ZM4.813 2.226A0.75 0.75 0 1 0 4.187 0.863a6.75 6.75 0 0 0 -0.794 11.843l-0.322 0.537a0.5 0.5 0 0 0 0.55 0.742l2 -0.5a0.5 0.5 0 0 0 0.364 -0.606l-0.5 -2a0.5 0.5 0 0 0 -0.914 -0.136l-0.406 0.677a5.25 5.25 0 0 1 0.648 -9.194Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 0 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SynchronizeDisable"
);
var SynchronizeWarning = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 3.5a0.75 0.75 0 0 0 -1.5 0v4a0.75 0.75 0 0 0 1.5 0v-4ZM7 11a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m0.757 3.071 0.537 0.322a6.751 6.751 0 0 1 11.844 0.794 0.75 0.75 0 1 1 -1.364 0.626 5.25 5.25 0 0 0 -9.194 -0.648l0.677 0.406a0.5 0.5 0 0 1 -0.136 0.914l-2 0.5a0.5 0.5 0 0 1 -0.606 -0.364l-0.5 -2a0.5 0.5 0 0 1 0.742 -0.55ZM11.42 9.835l-0.677 -0.406a0.5 0.5 0 0 1 0.136 -0.914l2 -0.5a0.5 0.5 0 0 1 0.606 0.364l0.5 2a0.5 0.5 0 0 1 -0.742 0.55l-0.537 -0.322A6.751 6.751 0 0 1 0.862 9.813a0.75 0.75 0 1 1 1.364 -0.626 5.25 5.25 0 0 0 9.194 0.648Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SynchronizeWarning"
);
var Add1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 1a1 1 0 0 0 -2 0v5H1a1 1 0 0 0 0 2h5v5a1 1 0 1 0 2 0V8h5a1 1 0 1 0 0 -2H8V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Add1"
);
var AddCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 4a0.75 0.75 0 0 0 -1.5 0v2.25H4a0.75 0.75 0 0 0 0 1.5h2.25V10a0.75 0.75 0 0 0 1.5 0V7.75H10a0.75 0.75 0 0 0 0 -1.5H7.75V4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AddCircle"
);
var AddSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0h7S14 0 14 3.5v7s0 3.5 -3.5 3.5h-7S0 14 0 10.5v-7S0 0 3.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 4a0.75 0.75 0 0 0 -1.5 0v2.25H4a0.75 0.75 0 0 0 0 1.5h2.25V10a0.75 0.75 0 0 0 1.5 0V7.75H10a0.75 0.75 0 0 0 0 -1.5H7.75V4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AddSquare"
);
var Bookmark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4 0c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C2.65804 0.720644 2.5 1.10218 2.5 1.5v12c0 0.2022 0.12182 0.3845 0.30866 0.4619 0.18684 0.0774 0.40189 0.0347 0.54489 -0.1083L7 10.2071l3.6464 3.6465c0.143 0.143 0.3581 0.1857 0.5449 0.1083 0.1869 -0.0774 0.3087 -0.2597 0.3087 -0.4619v-12c0 -0.39783 -0.158 -0.779356 -0.4393 -1.06066C10.7794 0.158035 10.3978 0 10 0H4Z" }),
    " "
  ] }) }),
  "Bookmark"
);
var ButtonPower1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 1a1 1 0 0 0 -2 0v5.077a1 1 0 1 0 2 0V1ZM3.923 3.059a1 1 0 0 0 -1.23 -1.577 7 7 0 1 0 8.615 0 1 1 0 0 0 -1.231 1.577 5 5 0 1 1 -6.154 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonPower1"
);
var CheckSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0h7S14 0 14 3.5v7s0 3.5 -3.5 3.5h-7S0 14 0 10.5v-7S0 0 3.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.386 4.164a0.75 0.75 0 0 1 0.117 1.055l-4 5a0.75 0.75 0 0 1 -1.036 0.131l-2 -1.5a0.75 0.75 0 1 1 0.9 -1.2l1.419 1.064L9.33 4.282a0.75 0.75 0 0 1 1.055 -0.118Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CheckSquare"
);
var Check = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.637 1.198a1 1 0 0 1 0.134 1.408l-8.04 9.73 -0.003 0.002a1.924 1.924 0 0 1 -1.5 0.693 1.924 1.924 0 0 1 -1.5 -0.75L0.21 9.045a1 1 0 1 1 1.578 -1.228l2.464 3.167 7.976 -9.652a1 1 0 0 1 1.408 -0.134Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Check"
);
var Cog = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m5.557 0.69 -0.463 1.195 -1.594 0.904 -1.27 -0.194a1.077 1.077 0 0 0 -1.078 0.528l-0.43 0.754a1.077 1.077 0 0 0 0.086 1.217l0.807 1.001v1.81L0.83 8.906a1.077 1.077 0 0 0 -0.086 1.217l0.43 0.754a1.077 1.077 0 0 0 1.078 0.528l1.27 -0.194 1.573 0.904 0.463 1.196a1.076 1.076 0 0 0 1 0.689h0.905a1.076 1.076 0 0 0 1.002 -0.69l0.463 -1.195 1.572 -0.904 1.27 0.194a1.077 1.077 0 0 0 1.078 -0.528l0.43 -0.754a1.077 1.077 0 0 0 -0.086 -1.217l-0.807 -1.001v-1.81l0.786 -1.001a1.077 1.077 0 0 0 0.086 -1.217l-0.43 -0.754a1.076 1.076 0 0 0 -1.078 -0.528l-1.27 0.194 -1.573 -0.904L8.443 0.689A1.077 1.077 0 0 0 7.442 0h-0.884a1.077 1.077 0 0 0 -1.001 0.69ZM7 9.25a2.25 2.25 0 1 0 0 -4.5 2.25 2.25 0 0 0 0 4.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cog"
);
var Cut = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.5 9.75a0.75 0.75 0 0 0 0 1.5H9a0.75 0.75 0 0 0 0 -1.5H7.5Zm4.25 0a0.75 0.75 0 0 0 0 1.5h1.5a0.75 0.75 0 0 0 0 -1.5h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3 0a3 3 0 0 0 -1.222 5.74L3.892 7 1.778 8.26a3 3 0 1 0 2.707 0.133l0.873 -0.52 1.296 0.771a0.75 0.75 0 1 0 0.767 -1.288L6.824 7l6.81 -4.056a0.75 0.75 0 0 0 -0.768 -1.288L5.358 6.127l-0.873 -0.52A3 3 0 0 0 3 0Zm-0.546 4.398a1.5 1.5 0 1 0 -0.23 -0.114 0.736 0.736 0 0 1 0.16 0.072l0.07 0.042ZM1.5 11a1.5 1.5 0 0 1 0.724 -1.284 0.752 0.752 0 0 0 0.16 -0.072l0.07 -0.042A1.5 1.5 0 1 1 1.5 11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cut"
);
var Delete1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.707 0.293A1 1 0 0 0 0.293 1.707L5.586 7 0.293 12.293a1 1 0 1 0 1.414 1.414L7 8.414l5.293 5.293a1 1 0 0 0 1.414 -1.414L8.414 7l5.293 -5.293A1 1 0 0 0 12.293 0.293L7 5.586 1.707 0.293Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Delete1"
);
var DeleteKeyboard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.316 10.463a2 2 0 0 0 1.523 0.703h6.182a2 2 0 0 0 2 -2V4.834a2 2 0 0 0 -2 -2l-6.182 0a2 2 0 0 0 -1.523 0.703L1.471 5.703a2 2 0 0 0 0 2.594l1.845 2.166Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.948 5.63a0.625 0.625 0 0 0 -0.884 -0.885l-1.35 1.35 -1.35 -1.35a0.625 0.625 0 0 0 -0.883 0.884l1.35 1.35 -1.35 1.35a0.625 0.625 0 1 0 0.884 0.884l1.35 -1.35 1.35 1.35a0.625 0.625 0 1 0 0.883 -0.884l-1.35 -1.35 1.35 -1.35Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DeleteKeyboard"
);
var DisableHeart = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.35654 1.88038c0.87336 0.06106 1.77873 0.47993 2.64344 1.32023 0.86472 -0.8403 1.77008 -1.25917 2.64345 -1.32023 1.00047 -0.06996 1.88377 0.33562 2.51927 0.97355 1.2492 1.25378 1.6265 3.52212 0.0314 5.07917l-0.0095 0.00903 -4.16454 3.85747c-0.28735 0.267 -0.65497 0.4008 -1.02053 0.4011 -0.36555 -0.0003 -0.73228 -0.1341 -1.01963 -0.4011L1.80581 7.9331C0.210782 6.37605 0.588038 4.10771 1.83721 2.85393c0.63559 -0.63793 1.51883 -1.04351 2.51933 -0.97355Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.21967 0.21967c0.292893 -0.2928933 0.767767 -0.2928933 1.06066 0L13.7803 12.7197c0.2929 0.2929 0.2929 0.7677 0 1.0606 -0.2929 0.2929 -0.7677 0.2929 -1.0606 0L0.21967 1.28033c-0.2928933 -0.292893 -0.2928933 -0.767767 0 -1.06066Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DisableHeart"
);
var Filter2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.5 0a0.5 0.5 0 0 0 -0.407 0.79L5 7.66v5.84a0.5 0.5 0 0 0 0.777 0.416l3 -2A0.5 0.5 0 0 0 9 11.5V7.66L13.907 0.79A0.5 0.5 0 0 0 13.5 0H0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Filter2"
);
var HelpQuestion1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 5.25A1.25 1.25 0 1 1 7 6.5a0.75 0.75 0 0 0 -0.75 0.75v0.646a0.75 0.75 0 1 0 1.5 0 2.751 2.751 0 1 0 -3.5 -2.646 0.75 0.75 0 0 0 1.5 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 11.5a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "HelpQuestion1"
);
var HorizontalMenuCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 7a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HorizontalMenuCircle"
);
var InformationCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 4a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm-3.125 6c0 -0.345 0.28 -0.625 0.625 -0.625h0.875v-2.25H6a0.625 0.625 0 1 1 0 -1.25h1c0.345 0 0.625 0.28 0.625 0.625v2.875H8.5a0.625 0.625 0 1 1 0 1.25h-3A0.625 0.625 0 0 1 4.875 10Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InformationCircle"
);
var MagnifyingGlassCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.625 6.5a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1 -3.75 0ZM6.5 3.375a3.125 3.125 0 1 0 1.724 5.732l1.334 1.335a0.625 0.625 0 1 0 0.884 -0.884L9.107 8.223A3.125 3.125 0 0 0 6.5 3.375Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MagnifyingGlassCircle"
);
var MagnifyingGlass = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1 6a5 5 0 1 0 10 0A5 5 0 1 0 1 6" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 6c0 -2.20914 1.79086 -4 4 -4s4 1.79086 4 4 -1.79086 4 -4 4 -4 -1.79086 -4 -4Zm4 -6C2.68629 0 0 2.68629 0 6s2.68629 6 6 6c1.29578 0 2.49562 -0.4108 3.47642 -1.1092l2.81648 2.8165c0.3905 0.3905 1.0237 0.3905 1.4142 0 0.3905 -0.3905 0.3905 -1.0237 0 -1.4142l-2.8164 -2.81645C11.5892 8.49581 12 7.29588 12 6c0 -3.31371 -2.68629 -6 -6 -6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MagnifyingGlass"
);
var SearchVisual = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.25 6.25a3 3 0 1 0 6 0 3 3 0 1 0 -6 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.573 1.573A0.25 0.25 0 0 1 1.75 1.5h1.5a0.75 0.75 0 0 0 0 -1.5h-1.5A1.75 1.75 0 0 0 0 1.75v1.5a0.75 0.75 0 0 0 1.5 0v-1.5a0.25 0.25 0 0 1 0.073 -0.177ZM14 10.75a0.75 0.75 0 0 0 -1.5 0v1.5a0.25 0.25 0 0 1 -0.25 0.25h-1.5a0.75 0.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25v-1.5ZM0.75 10a0.75 0.75 0 0 1 0.75 0.75v1.5a0.25 0.25 0 0 0 0.25 0.25h1.5a0.75 0.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 0 12.25v-1.5A0.75 0.75 0 0 1 0.75 10Zm10 -10a0.75 0.75 0 0 0 0 1.5h1.5a0.25 0.25 0 0 1 0.25 0.25v1.5a0.75 0.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 0h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 6.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1 -4.5 0ZM6.25 2.5a3.75 3.75 0 1 0 2.068 6.879L9.97 11.03a0.75 0.75 0 1 0 1.06 -1.06L9.38 8.318A3.75 3.75 0 0 0 6.25 2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SearchVisual"
);
var Subtract1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 7a1 1 0 0 1 1 -1h12a1 1 0 1 1 0 2H1a1 1 0 0 1 -1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Subtract1"
);
var SubtractCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.25 7A0.75 0.75 0 0 1 4 6.25h6a0.75 0.75 0 0 1 0 1.5H4A0.75 0.75 0 0 1 3.25 7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SubtractCircle"
);
var SubtractSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0h7S14 0 14 3.5v7s0 3.5 -3.5 3.5h-7S0 14 0 10.5v-7S0 0 3.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.25 7c0 -0.41421 0.33579 -0.75 0.75 -0.75h6c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75H4c-0.41421 0 -0.75 -0.33579 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SubtractSquare"
);
var Target3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.3231 6.25h-0.8314c-0.4142 0 -0.75 0.33579 -0.75 0.75s0.3358 0.75 0.75 0.75h0.8314c-0.3307 2.3684 -2.2047 4.2424 -4.5731 4.5731v-0.8314c0 -0.4142 -0.33579 -0.75 -0.75 -0.75s-0.75 0.3358 -0.75 0.75v0.8314c-2.3684 -0.3307 -4.24243 -2.2047 -4.57309 -4.5731h0.83142c0.41422 0 0.75 -0.33579 0.75 -0.75s-0.33578 -0.75 -0.75 -0.75h-0.83142C2.00757 3.8816 3.8816 2.00757 6.25 1.67691v0.83142c0 0.41422 0.33579 0.75 0.75 0.75s0.75 -0.33578 0.75 -0.75v-0.83142c2.3684 0.33066 4.2424 2.20469 4.5731 4.57309ZM0.125 7C0.125 3.20304 3.20304 0.125 7 0.125c3.797 0 6.875 3.07804 6.875 6.875 0 3.797 -3.078 6.875 -6.875 6.875C3.20304 13.875 0.125 10.797 0.125 7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 5.39624c0 -0.41421 0.33579 -0.75 0.75 -0.75s0.75 0.33579 0.75 0.75V6.25h0.85366c0.41422 0 0.75 0.33579 0.75 0.75s-0.33578 0.75 -0.75 0.75H7.75v0.85366c0 0.41422 -0.33579 0.75 -0.75 0.75s-0.75 -0.33578 -0.75 -0.75l0 -0.85366h-0.85376c-0.41421 0 -0.75 -0.33579 -0.75 -0.75s0.33579 -0.75 0.75 -0.75H6.25l0 -0.85376Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Target3"
);
var Target = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.485 0.378744c-0.0436 -0.174758 -0.178 -0.3125054 -0.3516 -0.3605897 -0.1736 -0.0480844 -0.3596 0.0009287 -0.487 0.1283037L8.64642 2.14646c-0.12419 0.12419 -0.17412 0.30443 -0.13152 0.47482l0.36081 1.44326c-0.00483 0.00458 -0.00961 0.00923 -0.01434 0.01397L6.46921 6.47066c-0.29289 0.2929 -0.29289 0.76777 0 1.06066 0.2929 0.2929 0.76777 0.2929 1.06066 0l2.39216 -2.39215c0.00484 -0.00485 0.00961 -0.00974 0.01429 -0.01468l1.44238 0.36059c0.1704 0.0426 0.3506 -0.00732 0.4748 -0.13151l2 -2.00001c0.1274 -0.12737 0.1764 -0.31342 0.1283 -0.48702 -0.0481 -0.17359 -0.1858 -0.30791 -0.3606 -0.3516l-1.7089 -0.42724L11.485 0.378744ZM7.31715 0.758091c0.02871 0.413219 -0.283 0.771469 -0.69622 0.800179 -1.04464 0.07257 -2.04649 0.44349 -2.88653 1.06869 -0.84004 0.6252 -1.48295 1.47841 -1.85236 2.45824 -0.36941 0.97984 -0.44978 2.04512 -0.23157 3.0693 0.21821 1.02417 0.72583 1.9642 1.46255 2.7083 0.73673 0.7442 1.67158 1.2612 2.69351 1.4897 1.02193 0.2285 2.08796 0.1589 3.07146 -0.2007 0.9835 -0.3595 1.84311 -0.9938 2.47671 -1.8275 0.6336 -0.83375 1.0146 -1.83183 1.0977 -2.87568 0.0328 -0.41291 0.3942 -0.721 0.8071 -0.68815 0.4129 0.03286 0.721 0.39423 0.6881 0.80714 -0.1058 1.33013 -0.5912 2.60189 -1.3986 3.66429 -0.8074 1.0623 -1.9028 1.8706 -3.15598 2.3287 -1.25322 0.4582 -2.61161 0.5469 -3.91379 0.2558 -1.30218 -0.2912 -2.49342 -0.95 -3.43218 -1.8982 -0.93877 -0.9483 -1.5856 -2.14609 -1.863652 -3.45113C-0.0946537 7.16203 0.00776154 5.8046 0.478476 4.55605 0.949191 3.3075 1.76842 2.22031 2.83883 1.42365 3.90925 0.626994 5.18585 0.15435 6.51698 0.0618737c0.41321 -0.0287072 0.77146 0.2830003 0.80017 0.6962173ZM6.64541 4.05796c0.151 0.38571 -0.03927 0.8208 -0.42498 0.9718 -0.32822 0.12849 -0.61923 0.33677 -0.84672 0.606 -0.22749 0.26923 -0.38429 0.59092 -0.4562 0.93598 -0.07192 0.34505 -0.0567 0.7026 0.0443 1.04029 0.10099 0.33769 0.28457 0.64489 0.53412 0.8938 0.24956 0.24892 0.55722 0.4317 0.89518 0.53182 0.33795 0.10013 0.69553 0.11443 1.0404 0.04163 0.34487 -0.07281 0.66616 -0.23043 0.9348 -0.45861 0.26864 -0.22819 0.47617 -0.51973 0.60382 -0.84828 0.15 -0.3861 0.5846 -0.57749 0.9707 -0.42748 0.38607 0.15001 0.57747 0.5846 0.42747 0.9707 -0.2179 0.56094 -0.57225 1.05872 -1.03092 1.44831 -0.45867 0.38958 -1.00722 0.65868 -1.59603 0.78298 -0.58882 0.1243 -1.19933 0.0999 -1.77634 -0.071 -0.577 -0.171 -1.10229 -0.48306 -1.52837 -0.90804 -0.42608 -0.42499 -0.73951 -0.94948 -0.91194 -1.52604 -0.17243 -0.57656 -0.19843 -1.18701 -0.07564 -1.77614 0.12279 -0.58914 0.3905 -1.13837 0.7789 -1.59804 0.38841 -0.45967 0.88527 -0.81528 1.44565 -1.03466 0.38571 -0.151 0.8208 0.03927 0.9718 0.42498Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Target"
);
var VerticalSliderSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.875 11 0 -5.115a1.75 1.75 0 1 1 1.25 0l0 5.115a0.625 0.625 0 1 1 -1.25 0Zm6.25 -1.615a1.75 1.75 0 0 0 0 -3.27l0 -3.115a0.625 0.625 0 0 0 -1.25 0l0 3.115a1.75 1.75 0 0 0 0 3.27l0 1.615a0.625 0.625 0 1 0 1.25 0l0 -1.615Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VerticalSliderSquare"
);
var WarningTriangle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.006a1.5 1.5 0 0 0 -1.335 0.816l-0.002 0.004 -5.5 10.999A1.5 1.5 0 0 0 1.5 14l0.001 0h11l0.002 0a1.5 1.5 0 0 0 1.335 -2.174l0 -0.001L8.336 0.826 8.335 0.822A1.5 1.5 0 0 0 7 0.006Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 4.875a0.75 0.75 0 0 0 -1.5 0v3.25a0.75 0.75 0 0 0 1.5 0v-3.25Zm-0.75 7a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WarningTriangle"
);
var Wrench = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.477 0.086a4.3 4.3 0 0 0 -4.884 5.68L0.461 10.898a1.5 1.5 0 0 0 0.022 2.143l0.56 0.538a1.5 1.5 0 0 0 2.094 -0.016L8.34 8.417a4.31 4.31 0 0 0 5.56 -4.913 1.258 1.258 0 0 0 -0.579 -0.844 0.5 0.5 0 0 0 -0.615 0.073l-2 2 -0.006 0.006a0.5 0.5 0 0 1 -0.72 0 0.499 0.499 0 0 0 -0.027 -0.025l-0.746 -0.668a0.5 0.5 0 0 1 0.008 -0.688l1.998 -1.998a0.5 0.5 0 0 0 0.107 -0.55 1.26 1.26 0 0 0 -0.843 -0.724Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Wrench"
);
var ArchiveBox = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13 5H1v6.75a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5 -1.5V5Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0.75A1.5 1.5 0 0 0 0 2.25v1.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5 -1.5v-1.5a1.5 1.5 0 0 0 -1.5 -1.5h-11Zm4 6.875a0.625 0.625 0 1 0 0 1.25h3a0.625 0.625 0 1 0 0 -1.25h-3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArchiveBox"
);
var BlankNotepad = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 3.5A1.5 1.5 0 0 1 1.5 2h11A1.5 1.5 0 0 1 14 3.5v9a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-9Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0V1a1 1 0 0 1 1 -1ZM7 0a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0V1a1 1 0 0 1 1 -1Zm4.5 1a1 1 0 1 0 -2 0v2a1 1 0 0 0 2 0V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BlankNotepad"
);
var BoxSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0C0.671573 0 0 0.671573 0 1.5v11c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5v-11c0 -0.828427 -0.6716 -1.5 -1.5 -1.5h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.75959 2.93146c0.2226 0.10163 0.36542 0.32383 0.36542 0.56854v4.33429c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625V4.86893l-0.96562 0.83705c-0.26082 0.22609 -0.65555 0.19794 -0.88164 -0.06288 -0.2261 -0.26082 -0.19795 -0.65555 0.06288 -0.88164l2 -1.73372c0.18491 -0.16029 0.44635 -0.19792 0.66896 -0.09628ZM2.87501 10.5c0 -0.3452 0.27982 -0.625 0.625 -0.625H10.5c0.3452 0 0.625 0.2798 0.625 0.625s-0.2798 0.625 -0.625 0.625H3.50001c-0.34518 0 -0.625 -0.2798 -0.625 -0.625Zm6.03438 -7.47226c-0.18491 -0.16029 -0.44635 -0.19792 -0.66896 -0.09628 -0.2226 0.10163 -0.36542 0.32383 -0.36542 0.56854v4.33429c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625V4.86893l0.96559 0.83705c0.2608 0.22609 0.6556 0.19794 0.8817 -0.06288 0.2261 -0.26082 0.1979 -0.65555 -0.0629 -0.88164L8.90939 3.02774Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BoxSign"
);
var ClipboardAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 2.5A1.5 1.5 0 0 1 2.75 1h8.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1 -1.5 1.5h-8.5a1.5 1.5 0 0 1 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v0.5a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1V1ZM7 5.251a0.75 0.75 0 0 1 0.75 0.75v1.75H9.5a0.75 0.75 0 1 1 0 1.5H7.75v1.75a0.75 0.75 0 0 1 -1.5 0v-1.75H4.5a0.75 0.75 0 0 1 0 -1.5h1.75v-1.75a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ClipboardAdd"
);
var ClipboardCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 2.5A1.5 1.5 0 0 1 2.75 1h8.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1 -1.5 1.5h-8.5a1.5 1.5 0 0 1 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 0a1 1 0 0 0 -1 1v0.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1h-3Zm4.6 6.95a0.75 0.75 0 0 0 -1.2 -0.9L6.326 9.482l-0.91 -0.606a0.75 0.75 0 0 0 -0.832 1.248l1.5 1A0.75 0.75 0 0 0 7.1 10.95l3 -4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ClipboardCheck"
);
var ClipboardRemove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 2.5A1.5 1.5 0 0 1 2.75 1h8.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1 -1.5 1.5h-8.5a1.5 1.5 0 0 1 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 0a1 1 0 0 0 -1 1v0.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1h-3Zm-1 7.75a0.75 0.75 0 0 0 0 1.5h5a0.75 0.75 0 0 0 0 -1.5h-5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ClipboardRemove"
);
var CopyPaste = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.42417 0.269439C1.56667 0.0986972 1.77759 0 1.99998 0h5.00001c0.22239 0 0.43331 0.0986972 0.57581 0.269439 0.1425 0.170743 0.20187 0.39592 0.16209 0.614725l-0.02382 0.130996C8.4411 1.11905 9 1.74425 9 2.5v0.75H7.25c-1.65685 0 -3 1.34315 -3 3V11H1.5C0.671573 11 0 10.3284 0 9.5v-7c0 -0.75574 0.55889 -1.38094 1.2859 -1.48484L1.26208 0.884164c-0.03978 -0.218805 0.01959 -0.443982 0.16209 -0.614725ZM2.89864 1.5l0.11531 0.63416c0.06484 0.35662 0.37543 0.61584 0.7379 0.61584h1.49627c0.36247 0 0.67306 -0.25922 0.7379 -0.61584L6.10133 1.5H2.89864Z", clipRule: "evenodd" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.25 4.5c-0.9665 0 -1.75 0.7835 -1.75 1.75v6c0 0.9665 0.7835 1.75 1.75 1.75h5c0.9665 0 1.75 -0.7835 1.75 -1.75v-6c0 -0.9665 -0.7835 -1.75 -1.75 -1.75h-5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 9.875c-0.34518 0 -0.625 0.2798 -0.625 0.625s0.27982 0.625 0.625 0.625H11c0.3452 0 0.625 -0.2798 0.625 -0.625s-0.2798 -0.625 -0.625 -0.625H8.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.875 8c0 -0.34518 0.27982 -0.625 0.625 -0.625H11c0.3452 0 0.625 0.27982 0.625 0.625s-0.2798 0.625 -0.625 0.625H8.5c-0.34518 0 -0.625 -0.27982 -0.625 -0.625Z" }),
    " "
  ] }) }),
  "CopyPaste"
);
var DownloadBox1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.383 0h7.234a1.5 1.5 0 0 1 1.312 0.772L14 4.5H0L2.071 0.772A1.5 1.5 0 0 1 3.383 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.625 4.5V0h-1.25v4.5H0v8A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-8H7.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m6.646 12.647 -2.292 -2.293a0.5 0.5 0 0 1 0.353 -0.854H6v-2a1 1 0 0 1 2 0v2h1.293a0.5 0.5 0 0 1 0.353 0.854l-2.292 2.293a0.5 0.5 0 0 1 -0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "DownloadBox1"
);
var DownloadCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m7.354 11.104 2.792 -2.793a0.5 0.5 0 0 0 -0.353 -0.854H8L8 3.75a1 1 0 1 0 -2 0l0 3.707H4.207a0.5 0.5 0 0 0 -0.353 0.854l2.792 2.793a0.5 0.5 0 0 0 0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "DownloadCircle"
);
var DownloadComputer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.293 2.957H9.25L9.25 1c0 -0.172 -0.02 -0.339 -0.056 -0.5h3.35C13.347 0.5 14 1.152 14 1.957v7.586c0 0.805 -0.652 1.457 -1.457 1.457H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h3.349a2.257 2.257 0 0 0 -0.056 0.5l0 1.957h-0.043c-1.559 0 -2.34 1.885 -1.237 2.988l2.293 2.293a1.75 1.75 0 0 0 2.474 0l2.293 -2.293c1.103 -1.103 0.322 -2.988 -1.237 -2.988Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.354 7.354 9.646 5.06a0.5 0.5 0 0 0 -0.353 -0.854H8L8 1a1 1 0 1 0 -2 0l0 3.207H4.707a0.5 0.5 0 0 0 -0.353 0.854l2.292 2.293a0.5 0.5 0 0 0 0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "DownloadComputer"
);
var DownloadFile = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-8a0.5 0.5 0 0 0 -0.146 -0.354l-4 -4A0.5 0.5 0 0 0 8.5 0h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.29 10.838 -0.103 0.104a0.625 0.625 0 0 1 -0.884 0l-0.104 -0.104a1.006 1.006 0 0 1 -0.292 -0.292L4.053 8.692a0.625 0.625 0 0 1 0.442 -1.067h1.25l0 -3.625a1 1 0 0 1 2 0v3.625h1.25a0.625 0.625 0 0 1 0.442 1.067l-1.854 1.854a1.006 1.006 0 0 1 -0.292 0.292Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DownloadFile"
);
var EmptyClipboard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 2.5A1.5 1.5 0 0 1 2.75 1h8.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1 -1.5 1.5h-8.5a1.5 1.5 0 0 1 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.5 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v0.5a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1V1Z" }),
    " "
  ] }) }),
  "EmptyClipboard"
);
var FileAddAlternate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.44 0.44A1.5 1.5 0 0 1 3.5 0h6a0.5 0.5 0 0 1 0.354 0.146l4 4A0.5 0.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1 -1.5 1.5H5.105c0.093 -0.232 0.145 -0.485 0.145 -0.75v-0.5h0.5a2 2 0 1 0 0 -4h-0.5v-0.5A2 2 0 0 0 2 6.689V1.5c0 -0.398 0.158 -0.78 0.44 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.25 7.5a0.75 0.75 0 0 1 0.75 0.75V10h1.75a0.75 0.75 0 0 1 0 1.5H4v1.75a0.75 0.75 0 0 1 -1.5 0V11.5H0.75a0.75 0.75 0 0 1 0 -1.5H2.5V8.25a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FileAddAlternate"
);
var FileDeleteAlternate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.44 0.44A1.5 1.5 0 0 1 3.5 0h6a0.5 0.5 0 0 1 0.354 0.146l4 4A0.5 0.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1 -1.5 1.5H6.845a2 2 0 0 0 -0.44 -2.164l-0.707 -0.706 0.706 -0.706a2 2 0 1 0 -2.828 -2.828l-0.706 0.706 -0.706 -0.706A2.021 2.021 0 0 0 2 7.449V1.5c0 -0.398 0.158 -0.78 0.44 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.52 9.54a0.75 0.75 0 0 0 -1.06 -1.06l-1.59 1.59 -1.59 -1.59A0.75 0.75 0 0 0 0.22 9.54l1.59 1.59 -1.59 1.59a0.75 0.75 0 1 0 1.06 1.06l1.59 -1.59 1.59 1.59a0.75 0.75 0 0 0 1.06 -1.06l-1.59 -1.59 1.59 -1.59Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FileDeleteAlternate"
);
var FileRemoveAlternate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.44 0.44A1.5 1.5 0 0 1 3.5 0h6a0.5 0.5 0 0 1 0.354 0.146l4 4A0.5 0.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1 -1.5 1.5h-9A1.5 1.5 0 0 1 2 12.5v-0.25h3.75a2 2 0 1 0 0 -4H2V1.5c0 -0.398 0.158 -0.78 0.44 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 9.5a0.75 0.75 0 0 1 0 1.5h-5a0.75 0.75 0 0 1 0 -1.5h5Z" }),
    " "
  ] }) }),
  "FileRemoveAlternate"
);
var FolderAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.127 0.805A1.5 1.5 0 0 0 5.183 0.5H1.5A1.5 1.5 0 0 0 0 2v10a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 12V4a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.502 1.502 0 0 0 -0.548 -0.835Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 5.5a0.75 0.75 0 0 0 -1.5 0v1.75H4.5a0.75 0.75 0 0 0 0 1.5h1.75v1.75a0.75 0.75 0 0 0 1.5 0V8.75H9.5a0.75 0.75 0 0 0 0 -1.5H7.75V5.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FolderAdd"
);
var FolderCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.127 0.805A1.5 1.5 0 0 0 5.183 0.5H1.5A1.5 1.5 0 0 0 0 2v10a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 12V4a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.502 1.502 0 0 0 -0.548 -0.835Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.45 5.4a0.75 0.75 0 0 1 0.15 1.05l-3 4a0.75 0.75 0 0 1 -1.016 0.174l-1.5 -1a0.75 0.75 0 0 1 0.832 -1.248l0.91 0.606L8.4 5.55a0.75 0.75 0 0 1 1.05 -0.15Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FolderCheck"
);
var FolderDelete = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.127 0.805A1.5 1.5 0 0 0 5.183 0.5H1.5A1.5 1.5 0 0 0 0 2v10a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 12V4a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.502 1.502 0 0 0 -0.548 -0.835Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 8a0.75 0.75 0 0 1 0.75 -0.75h5a0.75 0.75 0 0 1 0 1.5h-5A0.75 0.75 0 0 1 3.75 8Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FolderDelete"
);
var LocalStorageFolder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.582a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 0 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M14 4.565c0 0.24 -0.194 0.435 -0.434 0.435h-4.77a0.435 0.435 0 0 1 -0.435 -0.435V0.435A0.435 0.435 0 0 1 8.796 0H10.4a0.435 0.435 0 0 1 0.435 0.33l0.122 0.54h2.608a0.435 0.435 0 0 1 0.435 0.434v3.261Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.111 0.5H1.457C0.652 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543v-3.35a1.687 1.687 0 0 1 -0.434 0.057h-4.77a1.685 1.685 0 0 1 -1.685 -1.685V0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LocalStorageFolder"
);
var MultipleFile2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4 1.5C4 0.671573 4.67157 0 5.5 0H11c0.8284 0 1.5 0.671573 1.5 1.5V10c0 0.8284 -0.6716 1.5 -1.5 1.5H5.5c-0.82843 0 -1.5 -0.6716 -1.5 -1.5V1.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.49991 4c0 -0.82843 0.67157 -1.5 1.5 -1.5h5.5c0.82843 0 1.5 0.67157 1.5 1.5v8.5c0 0.8284 -0.67157 1.5 -1.5 1.5h-5.5c-0.82843 0 -1.5 -0.6716 -1.5 -1.5V4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.1246 5c0 -0.34518 0.27983 -0.625 0.625 -0.625h4c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625h-4c-0.34517 0 -0.625 -0.27982 -0.625 -0.625Zm0.00049 2.5c0 -0.34518 0.27982 -0.625 0.625 -0.625h4c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625h-4c-0.34518 0 -0.625 -0.27982 -0.625 -0.625Zm0.62424 1.875c-0.34518 0 -0.625 0.27982 -0.625 0.625 0 0.3452 0.27982 0.625 0.625 0.625h2c0.34518 0 0.625 -0.2798 0.625 -0.625 0 -0.34518 -0.27982 -0.625 -0.625 -0.625h-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MultipleFile2"
);
var NewFile = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5V5a0.5 0.5 0 0 0 -0.146 -0.354l-4.5 -4.5A0.5 0.5 0 0 0 8 0H2.5Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13 5a0.5 0.5 0 0 0 -0.146 -0.354l-4.5 -4.5A0.5 0.5 0 0 0 8 0v4.5a0.5 0.5 0 0 0 0.5 0.5H13Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "NewFile"
);
var NewFolder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.127 0.805A1.5 1.5 0 0 0 5.183 0.5H1.5A1.5 1.5 0 0 0 0 2v10a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 12V4a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.502 1.502 0 0 0 -0.548 -0.835Z" }),
    " "
  ] }) }),
  "NewFolder"
);
var NewStickyNote = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 14h6.87868c0.39782 0 0.77936 -0.158 1.06066 -0.4393l4.12136 -4.12136C13.842 9.15804 14 8.7765 14 8.37868V1.5c0 -0.828427 -0.6716 -1.5 -1.5 -1.5h-11C0.671573 0 0 0.671573 0 1.5v11c0 0.8284 0.671573 1.5 1.5 1.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.9951 8.5H9c-0.27614 0 -0.5 0.22386 -0.5 0.5v4.9951c0.35341 -0.0287 0.68677 -0.1819 0.93934 -0.4344l4.12136 -4.12136c0.2525 -0.25257 0.4057 -0.58593 0.4344 -0.93934Z" }),
    " "
  ] }) }),
  "NewStickyNote"
);
var PageSetting = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.21 0.334 7.565 5.626a0.603 0.603 0 0 0 0.54 0.874h5.29c0.45 0 0.741 -0.472 0.54 -0.874L11.29 0.334a0.604 0.604 0 0 0 -1.08 0ZM0 1A0.5 0.5 0 0 1 0.5 0.5h5A0.5 0.5 0 0 1 6 1v5a0.5 0.5 0 0 1 -0.5 0.5h-5A0.5 0.5 0 0 1 0 6V1Zm3 13a3 3 0 1 0 0 -6 3 3 0 0 0 0 6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.5 8a0.75 0.75 0 0 0 0 1.5H13A0.75 0.75 0 0 0 13 8H8.5Zm-0.75 3a0.75 0.75 0 0 1 0.75 -0.75H13a0.75 0.75 0 0 1 0 1.5H8.5a0.75 0.75 0 0 1 -0.75 -0.75Zm0 2.25a0.75 0.75 0 0 1 0.75 -0.75H13a0.75 0.75 0 0 1 0 1.5H8.5a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PageSetting"
);
var Paperclip1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.383 1.5a1.165 1.165 0 0 0 -0.827 0.345l-0.002 0.001 -6.069 6.088a1.673 1.673 0 0 0 0.002 2.345l1.705 1.734a1.629 1.629 0 0 0 1.788 0.36c0.2 -0.083 0.38 -0.206 0.531 -0.36l0.003 -0.002 5.697 -5.746a0.75 0.75 0 0 1 1.065 1.057l-5.694 5.742 -0.002 0.001a3.124 3.124 0 0 1 -4.458 0l-1.704 -1.733a3.173 3.173 0 0 1 0 -4.452l0.003 -0.003L7.491 0.788a2.665 2.665 0 0 1 3.783 0l0.001 0 0.676 0.676 0 0.001a2.664 2.664 0 0 1 0.001 3.782l-0.001 0.001 -5.377 5.396 -0.001 0.001a1.708 1.708 0 0 1 -2.424 0l-0.005 -0.006 -0.331 -0.34a1.708 1.708 0 0 1 0.005 -2.42l3.61 -3.58a0.75 0.75 0 0 1 1.056 1.064l-3.61 3.581a0.208 0.208 0 0 0 0 0.295l0.01 0.01 0.332 0.34a0.207 0.207 0 0 0 0.293 -0.001l0 -0.001 5.382 -5.4 0.003 -0.004a1.166 1.166 0 0 0 0 -1.654l-0.002 -0.002 -0.68 -0.68 -0.002 -0.002a1.165 1.165 0 0 0 -0.827 -0.345Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Paperclip1"
);
var RecycleBin2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 2.823a0.5 0.5 0 0 0 -0.5 0.5v9.145c0 0.4 0.156 0.784 0.437 1.069 0.28 0.285 0.663 0.447 1.063 0.447h7c0.4 0 0.783 -0.162 1.063 -0.447 0.28 -0.285 0.437 -0.67 0.437 -1.07V3.324a0.5 0.5 0 0 0 -0.5 -0.5h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.625 7.124a0.625 0.625 0 1 0 -1.25 0v4.002a0.625 0.625 0 0 0 1.25 0V7.124Zm4 0a0.625 0.625 0 1 0 -1.25 0v4.002a0.625 0.625 0 0 0 1.25 0V7.124Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.5a1.75 1.75 0 0 0 -1.677 1.25h3.354A1.75 1.75 0 0 0 7 1.5Zm3.211 1.25a3.25 3.25 0 0 0 -6.422 0H1a0.75 0.75 0 0 0 0 1.5h12a0.75 0.75 0 0 0 0 -1.5h-2.789Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RecycleBin2"
);
var Shredder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.0761 5.5V2.74339c0 -0.26522 -0.1054 -0.51957 -0.2929 -0.70711L9.03978 0.292894C8.85224 0.105357 8.59789 0 8.33267 0H3.42395c-0.27614 0 -0.5 0.223858 -0.5 0.5v5" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.470422 5.13255C0.755714 4.89179 1.12702 4.76749 1.5 4.76749h11c0.373 0 0.7443 0.1243 1.0296 0.36506 0.2878 0.2429 0.4704 0.59238 0.4704 0.97885v3.79759c0 0.38651 -0.1826 0.73591 -0.4704 0.97881 -0.2853 0.2408 -0.6566 0.3651 -1.0296 0.3651H10V9H4v2.2529H1.5c-0.37298 0 -0.744286 -0.1243 -1.029578 -0.3651C0.182585 10.6449 0 10.2955 0 9.90899V6.1114c0 -0.38647 0.182585 -0.73595 0.470422 -0.97885Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 8.25c-0.41421 0 -0.75 0.33579 -0.75 0.75s0.33579 0.75 0.75 0.75h0.53898v1.9117c0 0.1375 -0.05459 0.2693 -0.15176 0.3664 -0.09718 0.0972 -0.22898 0.1518 -0.36641 0.1518 -0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75c0.53526 0 1.04859 -0.2126 1.42707 -0.5911 0.37848 -0.3785 0.5911 -0.8918 0.5911 -1.4271V9.75H6.25v3.447c0 0.4142 0.33579 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75V9.75h1.21082v1.9117c0 0.5353 0.21262 1.0486 0.5911 1.4271 0.37849 0.3785 0.89178 0.5911 1.42708 0.5911 0.4142 0 0.75 -0.3358 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75c-0.1374 0 -0.2692 -0.0546 -0.3664 -0.1518 -0.0972 -0.0971 -0.1518 -0.2289 -0.1518 -0.3664V9.75H11c0.4142 0 0.75 -0.33579 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75H3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shredder"
);
var UploadBox1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.383 0h7.234a1.5 1.5 0 0 1 1.312 0.772L14 4.5H0L2.071 0.772A1.5 1.5 0 0 1 3.383 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.625 4.5V0h-1.25v4.5H0v8A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-8H7.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.646 6.647 4.354 8.939a0.5 0.5 0 0 0 0.353 0.854H6v2a1 1 0 1 0 2 0v-2h1.293a0.5 0.5 0 0 0 0.353 -0.854L7.354 6.647a0.5 0.5 0 0 0 -0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "UploadBox1"
);
var UploadCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m7.354 2.897 2.792 2.793a0.5 0.5 0 0 1 -0.353 0.853H8l0 3.707a1 1 0 1 1 -2 0l0 -3.707H4.207a0.5 0.5 0 0 1 -0.353 -0.853l2.792 -2.793a0.5 0.5 0 0 1 0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "UploadCircle"
);
var UploadComputer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 0 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.293 4.543H9.25l0 1.957a2.25 2.25 0 0 1 -4.5 0l0 -1.957h-0.043c-1.559 0 -2.34 -1.885 -1.237 -2.987L4.525 0.5H1.457C0.652 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348 0.5 12.543 0.5H9.475l1.055 1.056c1.103 1.102 0.322 2.987 -1.237 2.987Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.354 0.147 9.646 2.44a0.5 0.5 0 0 1 -0.353 0.853H8L8 6.5a1 1 0 1 1 -2 0l0 -3.207H4.707a0.5 0.5 0 0 1 -0.353 -0.853L6.646 0.147a0.5 0.5 0 0 1 0.708 0Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "UploadComputer"
);
var UploadFile = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-8a0.5 0.5 0 0 0 -0.146 -0.354l-4 -4A0.5 0.5 0 0 0 8.5 0h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.29 3.537 -0.103 -0.104a0.625 0.625 0 0 0 -0.884 0l-0.104 0.104a1.006 1.006 0 0 0 -0.292 0.292L4.053 5.683a0.625 0.625 0 0 0 0.442 1.067h1.25l0 3.625a1 1 0 1 0 2 0V6.75h1.25a0.625 0.625 0 0 0 0.442 -1.067L7.583 3.83a1.005 1.005 0 0 0 -0.292 -0.292Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UploadFile"
);
var AddBellNotification = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.75 0a0.75 0.75 0 0 1 0.75 0.75V2.5h1.75a0.75 0.75 0 0 1 0 1.5H11.5v1.75a0.75 0.75 0 0 1 -1.5 0V4H8.25a0.75 0.75 0 0 1 0 -1.5H10V0.75a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.086 1.623A4.849 4.849 0 0 0 6 1.5a4.725 4.725 0 0 0 -3.22 1.247c-0.862 0.804 -1.352 1.901 -1.352 3.053v3.775c0 0.234 -0.1 0.466 -0.289 0.642 -0.219 0.204 -0.391 0.283 -0.639 0.283a0.5 0.5 0 0 0 0 1h11a0.5 0.5 0 1 0 0 -1c-0.248 0 -0.42 -0.079 -0.64 -0.283a0.879 0.879 0 0 1 -0.287 -0.642V7.742A2 2 0 0 1 8.75 5.75v-0.5h-0.5a2 2 0 0 1 -1.164 -3.627ZM5 12.5A0.75 0.75 0 0 0 5 14h2a0.75 0.75 0 0 0 0 -1.5H5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AddBellNotification"
);
var AnnouncementMegaphone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.615 3.497a0.5 0.5 0 1 0 -0.866 0.5l0.018 0.032 -6.413 6.86a0.5 0.5 0 0 0 -0.068 0.592l0.609 1.055a0.5 0.5 0 0 0 0.546 0.237l1.708 -0.397 0.338 0.586 0.001 0.002A1.921 1.921 0 0 0 7 11.482l3.59 -0.834 0.017 0.03a0.5 0.5 0 1 0 0.866 -0.5l-0.188 -0.326a0.497 0.497 0 0 0 -0.028 -0.049l-3.424 -5.93a0.497 0.497 0 0 0 -0.028 -0.047l-0.19 -0.33Zm-1.592 8.212 -1.856 0.43 0.185 0.322a0.921 0.921 0 0 0 1.671 -0.752Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.181 0a0.75 0.75 0 0 1 0.75 0.75v1.253a0.75 0.75 0 0 1 -1.5 0V0.75a0.75 0.75 0 0 1 0.75 -0.75Zm6.806 6.806a0.75 0.75 0 0 1 -0.75 0.75h-1.253a0.75 0.75 0 0 1 0 -1.5h1.253a0.75 0.75 0 0 1 0.75 0.75Zm-11.608 0.75a0.75 0.75 0 1 0 0 -1.5H1.126a0.75 0.75 0 1 0 0 1.5h1.253ZM4.315 3.94a0.75 0.75 0 0 1 -1.06 0l-0.887 -0.886a0.75 0.75 0 1 1 1.06 -1.06l0.887 0.886a0.75 0.75 0 0 1 0 1.06Zm7.679 -0.886a0.75 0.75 0 0 0 -1.06 -1.06l-0.887 0.886a0.75 0.75 0 0 0 1.06 1.06l0.887 -0.886Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AnnouncementMegaphone"
);
var CallCenterSupportService = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.084 0.186c-0.66 0 -1.22 0.422 -1.428 1.01a0.625 0.625 0 0 0 1.179 0.416 0.264 0.264 0 0 1 0.25 -0.176H7.7a0.24 0.24 0 0 1 0.096 0.462l-1.319 0.577a1.514 1.514 0 0 0 -0.907 1.387v0.505c0 0.345 0.28 0.625 0.625 0.625h2.37a0.625 0.625 0 1 0 0 -1.25H6.85a0.264 0.264 0 0 1 0.13 -0.122l1.318 -0.577A1.49 1.49 0 0 0 7.7 0.186h-0.616Zm5.3 0a0.829 0.829 0 0 0 -0.624 0.283L9.8 2.71a0.84 0.84 0 0 0 0.632 1.394h1.53v0.264a0.625 0.625 0 1 0 1.25 0v-0.265a0.625 0.625 0 0 0 0 -1.248v-1.84a0.829 0.829 0 0 0 -0.829 -0.828Zm-0.422 1.95 -0.627 0.717h0.627v-0.717Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7.166 13.384a2.7 2.7 0 0 0 3.37 -0.36l0.38 -0.38a0.91 0.91 0 0 0 0 -1.28l-1.6 -1.59a0.9 0.9 0 0 0 -1.27 0 0.91 0.91 0 0 1 -1.28 0l-2.55 -2.55a0.91 0.91 0 0 1 0 -1.28 0.9 0.9 0 0 0 0 -1.27l-1.54 -1.6a0.91 0.91 0 0 0 -1.28 0l-0.38 0.38a2.7 2.7 0 0 0 -0.41 3.37 24.23 24.23 0 0 0 6.56 6.56Z" }),
    " "
  ] }) }),
  "CallCenterSupportService"
);
var CallHangUp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.2942 0.108032c0.408 0 0.7998 0.159706 1.0915 0.444939l0.4374 0.447159c0.5926 0.58619 0.9657 1.35824 1.0569 2.18685 0.0913 0.83014 -0.1059 1.66648 -0.5586 2.36825l-0.0066 0.00962c-1.0432 1.53753 -2.2297 2.96747 -3.54127 4.27173 -0.00425 0.00423 -0.00857 0.00837 -0.01297 0.01244l-1.4996 1.38778c-0.00439 0.0041 -0.00886 0.008 -0.0134 0.012 -0.85526 0.7362 -1.75443 1.4233 -2.69352 2.057l-0.00868 0.0056c-0.70177 0.4527 -1.53804 0.65 -2.36818 0.5587 -0.82861 -0.0911 -1.60067 -0.4643 -2.186866 -1.0568l-0.439262 -0.4294 -0.007877 -0.008c-0.285235 -0.2918 -0.4449389 -0.6836 -0.4449389 -1.0916 0 -0.408 0.1596569 -0.7999 0.4448899 -1.0916L2.42622 8.3293l0.00122 -0.00121c0.29018 -0.28517 0.68075 -0.44496 1.0876 -0.44496 0.40662 0 0.79699 0.15961 1.08711 0.4445l-0.00045 -0.00045 -0.34945 0.35744 0.35038 -0.35653c-0.00016 -0.00015 -0.00032 -0.00031 -0.00048 -0.00046 0.10486 0.10228 0.24555 0.15954 0.39205 0.15954 0.14592 0 0.28608 -0.05681 0.39081 -0.15834l2.94617 -2.94618 0.0026 -0.00257c0.05116 -0.05041 0.09178 -0.11049 0.11951 -0.17674 0.02772 -0.06625 0.042 -0.13735 0.042 -0.20917s-0.01428 -0.14292 -0.042 -0.20917c-0.02773 -0.06625 -0.0684 -0.12628 -0.11955 -0.17669l-0.00561 -0.00571c-0.28518 -0.29018 -0.44497 -0.68075 -0.44497 -1.0876 0 -0.40684 0.15978 -0.79743 0.44495 -1.0876L10.1985 0.55692l0.0041 -0.003949c0.2917 -0.285233 0.6835 -0.444939 1.0916 -0.444939Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.218984 0.218938c-0.2928928 0.292893 -0.2928928 0.767766 0 1.060662L12.7203 13.781c0.2929 0.2928 0.7678 0.2928 1.0607 0 0.2929 -0.2929 0.2929 -0.7678 0 -1.0607L1.27964 0.218938c-0.292889 -0.2928937 -0.767763 -0.2928937 -1.060656 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CallHangUp"
);
var ChatBubbleOvalNotification = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.468 5.014a2.482 2.482 0 1 0 0 -4.964 2.482 2.482 0 0 0 0 4.964Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.549 0.22A6.954 6.954 0 0 0 1.07 10.633l-0.994 2.646a0.5 0.5 0 0 0 0.557 0.667L4.1 13.32a6.953 6.953 0 0 0 9.684 -7.854l-0.003 -0.015A3.723 3.723 0 0 1 8.549 0.22Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleOvalNotification"
);
var ChatBubbleOval = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.0202 0.735614C9.07748 0.281386 8.04439 0.0457911 6.99794 0.0463867H6.9978C5.74005 0.0468047 4.50595 0.388355 3.42696 1.03466 2.34792 1.681 1.4644 2.60791 0.870497 3.71667c-0.5939 1.10876 -0.87593902 2.35785 -0.8160761 3.61422C0.110161 8.50074 0.460382 9.63611 1.07073 10.6324l-0.9942297 2.6452c-0.0633143 0.1685 -0.0312223 0.3579 0.0840307 0.4961 0.115252 0.1382 0.295884 0.2039 0.472969 0.1718l3.46598 -0.6267c0.89932 0.4131 1.87708 0.6297 2.86799 0.6346 1.04648 0.0052 2.08064 -0.2259 3.02539 -0.676 0.94474 -0.4501 1.77574 -1.1077 2.43094 -1.9237 0.6552 -0.816 1.1178 -1.76932 1.3533 -2.78897 0.2355 -1.01966 0.2378 -2.07932 0.0068 -3.09999 -0.2311 -1.02067 -0.6895 -1.97603 -1.3412 -2.79486 -0.6516 -0.81883 -1.4797 -1.48002 -2.4225 -1.934266Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleOval"
);
var ChatBubbleSquareQuestion = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C1.15804 0.720644 1 1.10218 1 1.5v8.9189l-0.9743417 2.923c-0.0577086 0.1731 -0.01651259 0.3639 0.1074807 0.4978 0.123993 0.1339 0.311087 0.1896 0.488129 0.1454L4.56155 13H12.5c0.3978 0 0.7794 -0.158 1.0607 -0.4393S14 11.8978 14 11.5v-10c0 -0.39783 -0.158 -0.779356 -0.4393 -1.06066C13.2794 0.158035 12.8978 0 12.5 0h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.71375 3.57184c-0.19531 -0.03885 -0.39775 -0.01891 -0.58172 0.05729 -0.18397 0.07621 -0.34122 0.20525 -0.45185 0.37083 -0.11063 0.16557 -0.16968 0.36023 -0.16968 0.55936 0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625c0 -0.44636 0.13236 -0.88269 0.38034 -1.25383 0.24799 -0.37113 0.60045 -0.66039 1.01284 -0.83121 0.41238 -0.17081 0.86615 -0.2155 1.30393 -0.12842 0.43778 0.08708 0.83991 0.30202 1.15554 0.61764 0.31562 0.31562 0.53056 0.71775 0.61764 1.15553 0.08708 0.43779 0.04239 0.89156 -0.12842 1.30394 -0.17082 0.41238 -0.46008 0.76485 -0.83122 1.01283 -0.19436 0.12988 -0.40661 0.22804 -0.62882 0.29208v0.55116c0 0.34517 -0.27983 0.625 -0.625 0.625 -0.34518 0 -0.625 -0.27983 -0.625 -0.625V6.19115c0 -0.34518 0.27982 -0.625 0.625 -0.625 0.19913 0 0.39379 -0.05905 0.55936 -0.16968s0.29462 -0.26788 0.37083 -0.45185c0.0762 -0.18398 0.09614 -0.38642 0.05729 -0.58172 -0.03885 -0.19531 -0.13474 -0.37471 -0.27555 -0.51552 -0.1408 -0.1408 -0.3202 -0.23669 -0.51551 -0.27554Zm-0.19638 7.05186c-0.49445 -0.0011 -0.89493 -0.4022 -0.89493 -0.89692 0 -0.49539 0.40158 -0.89698 0.89697 -0.89698 0.00067 0 0.00135 0.00001 0.00202 0.00001 0.49445 0.0011 0.89493 0.40226 0.89493 0.89697 0 0.49542 -0.40158 0.89692 -0.89697 0.89692l-0.00202 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleSquareQuestion"
);
var ChatBubbleSquareWarning = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C1.15804 0.720644 1 1.10218 1 1.5v8.9189l-0.9743417 2.923c-0.0577086 0.1731 -0.01651259 0.3639 0.1074807 0.4978 0.123993 0.1339 0.311087 0.1896 0.488129 0.1454L4.56155 13H12.5c0.3978 0 0.7794 -0.158 1.0607 -0.4393S14 11.8978 14 11.5v-10c0 -0.39783 -0.158 -0.779356 -0.4393 -1.06066C13.2794 0.158035 12.8978 0 12.5 0h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.56824 2.17017c0.34518 0 0.625 0.27982 0.625 0.625l0 3.65863c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625l0 -3.65863c0 -0.34518 0.27982 -0.625 0.625 -0.625ZM6.57056 9.5811c0 -0.55101 0.44668 -0.9977 0.99769 -0.9977s0.99769 0.44669 0.99769 0.9977c0 0.551 -0.44668 0.9977 -0.99769 0.9977s-0.99769 -0.4467 -0.99769 -0.9977Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleSquareWarning"
);
var ChatBubbleSquareWrite = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m8.994 7.506 -3 0.54 0.5 -3.04 4.73 -4.71a1 1 0 0 1 1.42 0l1.06 1.06a0.998 0.998 0 0 1 0 1.42l-4.71 4.73Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.216 8.736a1.25 1.25 0 0 0 0.664 -0.348L14 4.25v7.25a1.5 1.5 0 0 1 -1.5 1.5H4.562l-3.94 0.985a0.5 0.5 0 0 1 -0.596 -0.643L1 10.419V1.5A1.5 1.5 0 0 1 2.5 0h7.25L5.612 4.12a1.25 1.25 0 0 0 -0.351 0.683l-0.5 3.04a1.25 1.25 0 0 0 1.455 1.433l3 -0.54Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleSquareWrite"
);
var ChatBubbleTextSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v8.919l-0.974 2.923a0.5 0.5 0 0 0 0.595 0.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5 -1.5v-10A1.5 1.5 0 0 0 12.5 0h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 4.22a0.625 0.625 0 1 0 0 1.25h6a0.625 0.625 0 1 0 0 -1.25h-6Zm0 3.31a0.625 0.625 0 1 0 0 1.25h4a0.625 0.625 0 1 0 0 -1.25h-4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleTextSquare"
);
var ChatBubbleTypingOval = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.02 0.736a6.954 6.954 0 0 0 -8.95 9.897l-0.993 2.645a0.5 0.5 0 0 0 0.556 0.667L4.1 13.32A6.953 6.953 0 0 0 10.02 0.736Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 8a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Zm4 -1a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm3 0a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleTypingOval"
);
var ChatTwoBubblesOval = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.515 0A5.515 5.515 0 0 0 0.921 8.565l-0.737 1.972a0.3 0.3 0 0 0 0.335 0.4l2.582 -0.465A5.514 5.514 0 1 0 5.515 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M9.5 5a4.5 4.5 0 0 1 3.748 6.988l0.568 1.518a0.3 0.3 0 0 1 -0.334 0.4l-2.012 -0.361A4.5 4.5 0 1 1 9.5 5Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "ChatTwoBubblesOval"
);
var ContactPhonebook2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.046 9.576a2.177 2.177 0 1 0 0 4.354h7.47a0.75 0.75 0 0 0 0.75 -0.75v-2.854a0.75 0.75 0 0 0 -0.75 -0.75h-7.47Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.046 0.063h8.086a1.701 1.701 0 0 1 1.701 1.7v7.611a1.7 1.7 0 0 1 -1.701 1.702H3.046a0.677 0.677 0 1 0 0 1.354h9.037a0.75 0.75 0 0 1 0 1.5H3.046a2.177 2.177 0 0 1 -2.177 -2.177c0 -0.035 0.002 -0.068 0.005 -0.1A2.035 2.035 0 0 1 0.87 11.5V2.201l0 -0.02A2.199 2.199 0 0 1 3.046 0.062Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.524 8.236a1.702 1.702 0 0 0 1.957 -0.461l0.246 -0.247a0.533 0.533 0 0 0 0.096 -0.732l-0.796 -0.795a0.533 0.533 0 0 0 -0.732 0.095 0.533 0.533 0 0 1 -0.731 0.095L6.29 4.92a0.533 0.533 0 0 1 0.095 -0.732 0.533 0.533 0 0 0 0.096 -0.732l-0.796 -0.796a0.533 0.533 0 0 0 -0.732 0.096L4.708 3a1.71 1.71 0 0 0 -0.462 1.957 9.546 9.546 0 0 0 3.278 3.278Z" }),
    " "
  ] }) }),
  "ContactPhonebook2"
);
var CustomerSupport1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 1.5a3.25 3.25 0 0 0 -3.25 3.25v2.5a0.75 0.75 0 0 1 -1.5 0v-2.5A4.75 4.75 0 0 1 7 0h0.25A4.75 4.75 0 0 1 12 4.75v5.382c0 0.892 -0.448 1.667 -0.993 2.198 -0.534 0.521 -1.274 0.92 -2.007 0.92a0.75 0.75 0 0 1 0 -1.5c0.221 0 0.606 -0.148 0.96 -0.493 0.341 -0.334 0.54 -0.743 0.54 -1.125V4.75A3.25 3.25 0 0 0 7.25 1.5H7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5 12.5A1.5 1.5 0 0 1 6.5 11H8a1.5 1.5 0 0 1 0 3H6.5A1.5 1.5 0 0 1 5 12.5Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 6.5A1.5 1.5 0 0 1 1.5 5h2.25v4a1 1 0 0 1 -1 1H1.5A1.5 1.5 0 0 1 0 8.5v-2Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.5 5h2A1.5 1.5 0 0 1 14 6.5v2a1.5 1.5 0 0 1 -1.5 1.5h-2V5Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "CustomerSupport1"
);
var DisableBellNotification = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.508 1.451a4.939 4.939 0 0 1 8.43 3.493v4.409c0 0.308 0.123 0.605 0.342 0.823 0.248 0.248 0.442 0.341 0.715 0.341a0.5 0.5 0 0 1 0 1H1.005a0.5 0.5 0 1 1 0 -1c0.273 0 0.467 -0.093 0.715 -0.34 0.219 -0.22 0.341 -0.516 0.341 -0.824v-4.41c0 -1.31 0.52 -2.565 1.447 -3.492ZM5.25 13.244a0.75 0.75 0 0 1 0.75 -0.75h1.998a0.75 0.75 0 0 1 0 1.5H6.001a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.297 0.298a0.75 0.75 0 0 0 0 1.06l12.345 12.345a0.75 0.75 0 1 0 1.06 -1.06L1.359 0.297a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DisableBellNotification"
);
var DiscussionConverstionReply = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.0133 2.375c-0.01892 0 -0.03707 0.00752 -0.05045 0.02089 -0.01337 0.01338 -0.02089 0.03153 -0.02089 0.05045v2.72948l0.05487 -0.05487c0.29289 -0.2929 0.76777 -0.2929 1.06066 0 0.29289 0.29289 0.29289 0.76776 0 1.06066L2.70877 7.53033c-0.2929 0.29289 -0.76777 0.29289 -1.06066 0L0.299382 6.18161c-0.29289342 -0.2929 -0.29289336 -0.76777 0 -1.06066 0.292893 -0.2929 0.767768 -0.2929 1.060658 0l0.08192 0.08191V2.44634c0 -0.41675 0.16555 -0.81642 0.46023 -1.11111C2.19688 1.04055 2.59655 0.875 3.0133 0.875h7.9869c0.4167 0 0.8164 0.16555 1.1111 0.46023 0.2947 0.29469 0.4602 0.69436 0.4602 1.11111v0.26482c0 0.41421 -0.3358 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-0.26482c0 -0.01892 -0.0075 -0.03707 -0.0209 -0.05045 -0.0134 -0.01337 -0.0315 -0.02089 -0.0504 -0.02089H3.0133Zm9.5582 4.35596 0.0689 0.06887c0.2929 0.29289 0.7678 0.29289 1.0606 0 0.2929 -0.29289 0.2929 -0.76777 0 -1.06066l-1.3487 -1.34872c-0.2929 -0.2929 -0.7677 -0.2929 -1.0606 0L9.94294 5.73917c-0.2929 0.29289 -0.2929 0.76777 0 1.06066 0.29286 0.29289 0.76776 0.29289 1.06066 0l0.0679 -0.06791v4.00038c0 0.0189 -0.0075 0.0371 -0.0209 0.0505 -0.0134 0.0133 -0.0315 0.0209 -0.0504 0.0209H4.65597c-0.06132 0 -0.12241 0.0075 -0.1819 0.0224l-1.95989 0.4899 0.38929 -1.1678c0.02549 -0.0765 0.03849 -0.1566 0.03849 -0.23721v-0.68712c0 -0.41421 -0.33579 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v0.56541L0.659109 12.1378c-0.086563 0.2597 -0.024769 0.5459 0.16122 0.7468 0.185991 0.2008 0.466631 0.2844 0.732191 0.218l3.19578 -0.7989h6.2519c0.4167 0 0.8164 -0.1656 1.1111 -0.4603 0.2947 -0.2947 0.4602 -0.6943 0.4602 -1.1111V6.73096Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscussionConverstionReply"
);
var GroupMeetingCall = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.218 0C1.545 0 1 0.545 1 1.218v4.57c0 0.674 0.545 1.22 1.218 1.22h9.564c0.673 0 1.218 -0.546 1.218 -1.22v-4.57C13 0.545 12.455 0 11.782 0H2.218Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 3.708a1.35 1.35 0 1 0 0 -2.701 1.35 1.35 0 0 0 0 2.7Zm-2.374 2.9a2.408 2.408 0 0 1 4.748 0c0.037 0.218 -0.146 0.4 -0.368 0.4H4.994c-0.222 0 -0.405 -0.182 -0.368 -0.4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.48 10.886a1.441 1.441 0 1 0 0 -2.882 1.441 1.441 0 0 0 0 2.883Zm7.045 0a1.441 1.441 0 1 0 0 -2.882 1.441 1.441 0 0 0 0 2.883Zm-7.046 0.779a2.336 2.336 0 0 0 -2.303 1.947c-0.035 0.212 0.143 0.388 0.358 0.388h3.891c0.215 0 0.393 -0.176 0.358 -0.388a2.336 2.336 0 0 0 -2.304 -1.947Zm4.743 1.947a2.336 2.336 0 0 1 4.607 0c0.035 0.212 -0.143 0.388 -0.358 0.388H8.58c-0.214 0 -0.392 -0.176 -0.357 -0.388Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GroupMeetingCall"
);
var HangUp1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.459 4.236a3.048 3.048 0 0 1 2.405 2.995l0.006 0.51a1.363 1.363 0 0 1 -1.348 1.347l-2.155 0a1.355 1.355 0 0 1 -1.343 -1.343 0.347 0.347 0 0 0 -0.35 -0.357l-3.388 0a0.362 0.362 0 0 0 -0.356 0.358 1.351 1.351 0 0 1 -1.343 1.342l-2.155 0.01A1.363 1.363 0 0 1 0.084 7.753l0.006 -0.51a3.048 3.048 0 0 1 2.405 -2.995c2.946 -0.603 6.014 -0.576 8.964 -0.011Z" }),
    " "
  ] }) }),
  "HangUp1"
);
var HangUp2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.438 2.982a3.048 3.048 0 0 1 2.405 2.995l0.006 0.51a1.363 1.363 0 0 1 -1.347 1.347l-2.156 0A1.354 1.354 0 0 1 9.003 6.49a0.346 0.346 0 0 0 -0.35 -0.357l-3.387 0a0.363 0.363 0 0 0 -0.356 0.358 1.351 1.351 0 0 1 -1.343 1.342l-2.156 0.011A1.363 1.363 0 0 1 0.064 6.498l0.006 -0.51a3.048 3.048 0 0 1 2.405 -2.994c2.946 -0.604 6.013 -0.577 8.963 -0.012Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 7.314c0.345 0 0.625 0.28 0.625 0.625l0 2.22 1.247 0a0.625 0.625 0 0 1 0.442 1.067l-1.872 1.872a0.623 0.623 0 0 1 -0.89 -0.006l-1.866 -1.866a0.625 0.625 0 0 1 0.442 -1.067l1.247 0 0 -2.22c0 -0.346 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HangUp2"
);
var HelpChat2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.02 0.736a6.954 6.954 0 0 0 -8.95 9.897l-0.993 2.645a0.5 0.5 0 0 0 0.556 0.668l3.466 -0.627A6.953 6.953 0 0 0 10.02 0.736Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.194 4.388a0.995 0.995 0 0 0 -1.19 0.976 0.625 0.625 0 1 1 -1.25 0 2.245 2.245 0 1 1 2.87 2.157v0.544a0.625 0.625 0 1 1 -1.25 0v-1.08c0 -0.346 0.28 -0.625 0.626 -0.625a0.995 0.995 0 0 0 0.194 -1.972ZM7 11.39a0.895 0.895 0 0 1 0.002 -1.79l0.002 0a0.895 0.895 0 0 1 -0.002 1.79l-0.002 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HelpChat2"
);
var InboxFavoriteHeart = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.58 0h9.311c0.857 0 1.552 0.695 1.552 1.552v5.263a2.652 2.652 0 0 0 -1.665 0.317 3.012 3.012 0 0 0 -0.42 0.281 3.035 3.035 0 0 0 -0.433 -0.302 2.64 2.64 0 0 0 -2.158 -0.229c-1.073 0.35 -1.84 1.311 -2.088 2.43h-4.1a1.552 1.552 0 0 1 -1.55 -1.554V1.552A1.55 1.55 0 0 1 1.58 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.443 1.63 6.235 4.732 0.028 1.629v1.398L5.956 5.99a0.625 0.625 0 0 0 0.559 0l5.928 -2.964V1.629Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.344 9.491c1.17 -2.595 3.5 -1.293 3.5 0.651 0 2.555 -3.5 3.858 -3.5 3.858s-3.5 -1.303 -3.5 -3.908c0 -1.944 2.33 -3.246 3.5 -0.601Z" }),
    " "
  ] }) }),
  "InboxFavoriteHeart"
);
var InboxFavorite = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.56 0h9.31c0.858 0 1.553 0.695 1.553 1.552v6.207c0 0.047 -0.002 0.094 -0.006 0.14l-0.201 -0.512a1.84 1.84 0 0 0 -3.428 0l-0.328 0.835h-0.852A1.86 1.86 0 0 0 5.9 9.312H1.56A1.552 1.552 0 0 1 0.008 7.758V1.552C0.008 0.695 0.702 0 1.56 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.952 7.842a0.59 0.59 0 0 1 1.1 0l0.64 1.63h1.71a0.61 0.61 0 0 1 0.56 0.39 0.59 0.59 0 0 1 -0.16 0.65l-1.51 1.35 0.64 1.28a0.58 0.58 0 0 1 -0.12 0.69 0.61 0.61 0 0 1 -0.7 0.1l-1.61 -0.91 -1.61 0.88a0.61 0.61 0 0 1 -0.7 -0.1 0.58 0.58 0 0 1 -0.12 -0.69l0.64 -1.28 -1.51 -1.36a0.59 0.59 0 0 1 -0.16 -0.65 0.61 0.61 0 0 1 0.56 -0.35h1.71l0.64 -1.63Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.423 1.63 6.215 4.732 0.008 1.629v1.398L5.936 5.99a0.625 0.625 0 0 0 0.559 0l5.928 -2.964V1.629Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InboxFavorite"
);
var InboxTray1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 8.33a0.5 0.5 0 0 0 -0.5 0.5v3.67A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5V8.83a0.5 0.5 0 0 0 -0.5 -0.5h-2.973a1.5 1.5 0 0 0 -1.5 1.5c0 0.974 -0.976 1.732 -2.03 1.725 -1.024 -0.007 -1.97 -0.768 -1.97 -1.725a1.5 1.5 0 0 0 -1.5 -1.5H0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.76a0.75 0.75 0 1 0 -1.5 0v2.75H4.5a0.75 0.75 0 0 0 -0.53 1.28l2.5 2.5a0.75 0.75 0 0 0 1.06 0l2.5 -2.5a0.75 0.75 0 0 0 -0.53 -1.28H7.75V0.76Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InboxTray1"
);
var InboxTray2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 8.33a0.5 0.5 0 0 0 -0.5 0.5v3.67A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5V8.83a0.5 0.5 0 0 0 -0.5 -0.5h-2.973a1.5 1.5 0 0 0 -1.5 1.5c0 0.974 -0.976 1.732 -2.03 1.725 -1.024 -0.007 -1.97 -0.768 -1.97 -1.725a1.5 1.5 0 0 0 -1.5 -1.5H0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.5 4.01a0.75 0.75 0 0 0 0.53 -1.281l-2.5 -2.5a0.75 0.75 0 0 0 -1.06 0l-2.5 2.5a0.75 0.75 0 0 0 0.53 1.28h1.75l0 2.75a0.75 0.75 0 1 0 1.5 0l0 -2.75H9.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InboxTray2"
);
var IncomingCall = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.737 13.28a2.7 2.7 0 0 1 -3.37 -0.36l-0.38 -0.38a0.91 0.91 0 0 1 0 -1.28l1.6 -1.59a0.9 0.9 0 0 1 1.27 0 0.91 0.91 0 0 0 1.28 0l2.55 -2.55a0.91 0.91 0 0 0 0 -1.28 0.9 0.9 0 0 1 0 -1.27l1.54 -1.6a0.91 0.91 0 0 1 1.28 0l0.38 0.38a2.7 2.7 0 0 1 0.41 3.37 24.23 24.23 0 0 1 -6.56 6.56Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.4 5.995a0.747 0.747 0 0 1 -0.69 0.461l-0.002 0 -3.266 0a0.75 0.75 0 0 1 -0.53 -1.28l1.102 -1.103L0.512 1.571a0.75 0.75 0 1 1 1.06 -1.06l2.503 2.502L5.177 1.91a0.75 0.75 0 0 1 1.28 0.53v3.266c0 0.103 -0.02 0.2 -0.057 0.29Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "IncomingCall"
);
var MailIncoming = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.394 4.171H2.086c-0.905 0 -1.638 0.734 -1.638 1.638v6.553c0 0.905 0.733 1.638 1.638 1.638h9.828c0.905 0 1.639 -0.733 1.639 -1.638V5.809c0 -0.904 -0.734 -1.638 -1.639 -1.638h-1.308c-0.08 0.284 -0.23 0.55 -0.448 0.767l-1.92 1.92a1.75 1.75 0 0 1 -2.475 0l-1.921 -1.92a1.748 1.748 0 0 1 -0.448 -0.767Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.792a0.75 0.75 0 0 0 -1.5 0V3.2H5.08a0.5 0.5 0 0 0 -0.354 0.854l1.92 1.92a0.5 0.5 0 0 0 0.708 0l1.92 -1.92a0.5 0.5 0 0 0 -0.353 -0.854H7.75V0.792Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.553 5.955 7 9.773 0.448 5.955v1.447l6.237 3.635a0.625 0.625 0 0 0 0.63 0l6.237 -3.635V5.955Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MailIncoming"
);
var MailSearch = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.567 0h9.31c0.858 0 1.553 0.695 1.553 1.552V6.22a4.501 4.501 0 0 0 -6.89 3.091H1.566A1.552 1.552 0 0 1 0.015 7.76V1.552C0.015 0.695 0.709 0 1.567 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.43 1.63 6.222 4.732 0.015 1.629v1.398L5.943 5.99a0.625 0.625 0 0 0 0.559 0l5.928 -2.964V1.629Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.237 10a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1 -3.5 0Zm1.75 -3.25a3.25 3.25 0 1 0 1.716 6.01l1.016 1.02a0.75 0.75 0 0 0 1.062 -1.06l-1.021 -1.024A3.25 3.25 0 0 0 9.987 6.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MailSearch"
);
var MailSendEmailMessage = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.967 0.68a0.5 0.5 0 0 0 -0.647 -0.647l-13 5a0.5 0.5 0 0 0 -0.027 0.922l5.33 2.423 2.422 5.329a0.5 0.5 0 0 0 0.922 -0.027l5 -13Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.954 9.107 9.03 6.03a0.75 0.75 0 0 0 -1.06 -1.06L4.893 8.046l0.73 0.332 0.33 0.729Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MailSendEmailMessage"
);
var MailSendEnvelope = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 1.25A1.5 1.5 0 0 0 0 2.75v8.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5 -1.5v-8.5a1.5 1.5 0 0 0 -1.5 -1.5h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 3.092 7.383 7.504A0.72 0.72 0 0 1 7 7.607a0.72 0.72 0 0 1 -0.383 -0.103L0 3.092v1.502l5.927 3.952 0.005 0.004c0.315 0.205 0.693 0.307 1.068 0.307 0.375 0 0.753 -0.102 1.068 -0.307L14 4.594V3.092Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MailSendEnvelope"
);
var MailSendReplyAll = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.014 2.553a0.75 0.75 0 0 0 -1.28 -0.53L4.006 4.75a0.75 0.75 0 0 0 0 1.06l2.728 2.728a0.75 0.75 0 0 0 1.28 -0.53V6.03h1.58a2.886 2.886 0 0 1 2.887 2.886v1.818a0.75 0.75 0 0 0 1.5 0V8.917A4.386 4.386 0 0 0 9.595 4.53H8.014V2.553Zm-3.987 0.53a0.75 0.75 0 1 0 -1.061 -1.06L0.239 4.75a0.75 0.75 0 0 0 0 1.06l2.727 2.728a0.75 0.75 0 1 0 1.06 -1.06L1.83 5.28l2.197 -2.197Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MailSendReplyAll"
);
var Megaphone2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 3.5H3c-1.65685 0 -3 1.34315 -3 3 0 1.30622 0.834808 2.41746 2 2.82929V10.5c0 1.6569 1.34315 3 3 3h0.5c0.55228 0 1 -0.4477 1 -1s-0.44772 -1 -1 -1H5c-0.55228 0 -1 -0.4477 -1 -1v-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.6634 0.794702 3.99591 3.49994v6l7.74679 2.34186c1.1105 0.3238 2.2573 -0.3992 2.2573 -1.423V2.19271C14 1.13767 12.7877 0.412306 11.6634 0.794702Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Megaphone2"
);
var MissedCall = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.355 1.695a1.57 1.57 0 0 1 2.181 0l0.01 0.01 0.377 0.385a3.387 3.387 0 0 1 0.463 4.243l-0.008 0.012a25.681 25.681 0 0 1 -6.886 6.869l-0.01 0.007a3.387 3.387 0 0 1 -4.243 -0.463l-0.386 -0.377 -0.01 -0.01a1.57 1.57 0 0 1 0 -2.181l0.007 -0.008 1.654 -1.636 0.001 -0.002a1.56 1.56 0 0 1 2.175 0 0.326 0.326 0 0 0 0.213 0.073 0.307 0.307 0 0 0 0.218 -0.072L8.705 5.95l0.003 -0.004a0.302 0.302 0 0 0 0 -0.417l-0.007 -0.007a1.56 1.56 0 0 1 0 -2.175l0.004 -0.003L10.35 1.7l0.005 -0.005Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.043 0.918a0.625 0.625 0 0 0 0.135 0.68l0.627 0.627 -1.666 1.666a0.25 0.25 0 0 1 -0.353 0l-1.44 -1.44a0.75 0.75 0 0 0 -1.06 1.061l1.439 1.44a1.75 1.75 0 0 0 2.475 0l1.665 -1.666 0.627 0.627A0.625 0.625 0 0 0 7.56 3.47V1.157a0.625 0.625 0 0 0 -0.625 -0.625H4.62a0.625 0.625 0 0 0 -0.577 0.386Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MissedCall"
);
var NotificationApplication1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 2.5H2a2 2 0 0 0 -2 2V12a2 2 0 0 0 2 2h7.5a2 2 0 0 0 2 -2l0 -5.75A3.75 3.75 0 0 1 7.75 2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.5 5a2.5 2.5 0 1 0 0 -5 2.5 2.5 0 0 0 0 5Z" }),
    " "
  ] }) }),
  "NotificationApplication1"
);
var NotificationApplication2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.648 2.5v0.899c0 0.448 0.147 0.861 0.396 1.195a2.068 2.068 0 0 0 2.456 3.19V12a2 2 0 0 1 -2 2H2a2 2 0 0 1 -2 -2V4.5a2 2 0 0 1 2 -2h6.648Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.523 0.899a0.875 0.875 0 1 0 -1.75 0v2.5a0.875 0.875 0 0 0 1.75 0v-2.5Zm-0.875 4a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NotificationApplication2"
);
var NotificationMessageAlert = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.6 0a5.252 5.252 0 0 0 -1.85 4l0 0.007c0.003 0.52 0.08 1.034 0.23 1.53l-0.492 1.151a1.45 1.45 0 0 0 1.515 2.009l1.34 -0.17A5.25 5.25 0 0 0 10 9.25v3A1.75 1.75 0 0 1 8.25 14h-6.5a1.44 1.44 0 0 1 -0.602 -0.15c-0.17 -0.08 -0.342 -0.19 -0.498 -0.322 -0.289 -0.246 -0.65 -0.686 -0.65 -1.278V1.75C0 0.784 0.784 0 1.75 0H6.6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 10.5a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10 0a4 4 0 0 0 -4 4 4.17 4.17 0 0 0 0.32 1.58l-0.683 1.6a0.2 0.2 0 0 0 0.21 0.276L7.64 7.23A4 4 0 1 0 10 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.5 2a0.5 0.5 0 1 0 -1 0v1.5a0.5 0.5 0 1 0 1 0V2Zm0.25 3.5a0.75 0.75 0 1 0 -1.5 0 0.75 0.75 0 0 0 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NotificationMessageAlert"
);
var OutgoingCall = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.737 13.28a2.7 2.7 0 0 1 -3.37 -0.36l-0.38 -0.38a0.91 0.91 0 0 1 0 -1.28l1.6 -1.59a0.9 0.9 0 0 1 1.27 0 0.91 0.91 0 0 0 1.28 0l2.55 -2.55a0.91 0.91 0 0 0 0 -1.28 0.9 0.9 0 0 1 0 -1.27l1.54 -1.6a0.91 0.91 0 0 1 1.28 0l0.38 0.38a2.7 2.7 0 0 1 0.41 3.37 24.232 24.232 0 0 1 -6.56 6.56Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.308 0.29a0.75 0.75 0 0 1 0.53 1.281L3.736 2.674l2.502 2.502a0.75 0.75 0 0 1 -1.06 1.06L2.674 3.735 1.573 4.837a0.75 0.75 0 0 1 -1.28 -0.53V1.04a0.748 0.748 0 0 1 0.75 -0.75h3.265Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OutgoingCall"
);
var RingingBellNotification = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 1.25c-1.19347 0 -2.33807 0.47411 -3.18198 1.31802C2.97411 3.41193 2.5 4.55653 2.5 5.75v3.5c0 0.26522 -0.10536 0.51957 -0.29289 0.70711 -0.18754 0.18749 -0.44189 0.29289 -0.70711 0.29289 -0.27614 0 -0.5 0.2239 -0.5 0.5s0.22386 0.5 0.5 0.5h11c0.2761 0 0.5 -0.2239 0.5 -0.5s-0.2239 -0.5 -0.5 -0.5c-0.2652 0 -0.5196 -0.1054 -0.7071 -0.29289 -0.1875 -0.18754 -0.2929 -0.44189 -0.2929 -0.70711v-3.5c0 -1.19347 -0.4741 -2.33807 -1.318 -3.18198C9.33807 1.72411 8.19347 1.25 7 1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.76302 0.3125c0.24163 0.336438 0.16476 0.80505 -0.17167 1.04667 -0.64676 0.46449 -1.17372 1.07619 -1.53736 1.78457 -0.36365 0.70838 -0.55354 1.49311 -0.55399 2.28938 -0.00023 0.41421 -0.33621 0.74981 -0.750425 0.74957C0.335362 6.18246 -0.000234425 5.84648 0 5.43227c0.000585794 -1.03423 0.247225 -2.05348 0.719545 -2.97356C1.19186 1.53863 1.87631 0.744126 2.71635 0.140825c0.33643 -0.241624 0.80505 -0.1647628 1.04667 0.171675ZM5.25 13.25c0 -0.4142 0.33579 -0.75 0.75 -0.75h2c0.41421 0 0.75 0.3358 0.75 0.75S8.41421 14 8 14H6c-0.41421 0 -0.75 -0.3358 -0.75 -0.75ZM11.2837 0.140825c-0.3364 -0.241624 -0.8051 -0.1647628 -1.0467 0.171675 -0.24161 0.336438 -0.1647 0.80505 0.1717 1.04667 0.6467 0.46449 1.1737 1.07619 1.5374 1.78457 0.3636 0.70838 0.5535 1.49311 0.5539 2.28938 0.0003 0.41421 0.3362 0.74981 0.7505 0.74957 0.4142 -0.00023 0.7498 -0.33621 0.7495 -0.75042 -0.0005 -1.03423 -0.2472 -2.05348 -0.7195 -2.97356 -0.4723 -0.92008 -1.1568 -1.714584 -1.9968 -2.317885Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RingingBellNotification"
);
var SendEmail = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.7219 0.0367172c-0.3 -0.0654306 -0.6122 -0.04423501 -0.9005 0.0610159L1.10787 3.67225l0 -0.00001 -0.00337 0.00115c-0.27285 0.09319 -0.515863 0.25756 -0.703923 0.47612 -0.186781 0.21707 -0.3126225 0.47977 -0.3647391 0.76128 -0.0520494 0.25768 -0.03977407 0.52424 0.0357814 0.77609 0.0760967 0.25366 0.2139987 0.48444 0.4013217 0.67163l0.000126 0.00013 0.000058 0.00005L3.05875 8.94432 2.9744 12.1967c-0.00459 0.1767 0.08452 0.3428 0.23434 0.4366 0.14983 0.0939 0.3381 0.1017 0.49515 0.0205l2.01406 -1.0415 1.91734 1.9086c0.19397 0.1978 0.43602 0.3418 0.70245 0.4179 0.26667 0.0762 0.54856 0.0818 0.81798 0.0161 0.26937 -0.0632 0.51808 -0.1943 0.72238 -0.381 0.2049 -0.1872 0.3582 -0.4239 0.4453 -0.6873l0.0002 -0.0007 3.574 -10.71201c0.1052 -0.28823 0.1264 -0.60051 0.061 -0.90043 -0.0661 -0.302923 -0.2178 -0.580503 -0.437 -0.799741 -0.2192 -0.219238 -0.4968 -0.370916 -0.7997 -0.4370018Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.05875 8.94434 2.9744 12.1967c-0.00459 0.1767 0.08452 0.3428 0.23434 0.4367 0.14983 0.0938 0.33809 0.1016 0.49515 0.0204l2.01406 -1.0415 -2.6592 -2.66796Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.05699 9.01302 10.102 3.89561c0.2792 -0.20286 0.3412 -0.59371 0.1383 -0.87299 -0.2028 -0.27927 -0.59369 -0.34122 -0.87297 -0.13835L2.20285 8.08848l0.85592 0.85592 -0.00178 0.06862Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SendEmail"
);
var GenderEquality = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.335 0.764a0.75 0.75 0 0 1 0.75 -0.75h2.672a0.75 0.75 0 0 1 0.75 0.75v2.673a0.75 0.75 0 1 1 -1.5 0v-0.863l-1.39 1.39a3.856 3.856 0 0 1 -2.454 5.927v0.813h1.031a0.75 0.75 0 0 1 0 1.5H7.163v1.031a0.75 0.75 0 1 1 -1.5 0v-1.031H4.63a0.75 0.75 0 1 1 0 -1.5h1.032V9.89a3.856 3.856 0 1 1 2.892 -6.987l1.39 -1.39h-0.86a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.073 4.337a0.625 0.625 0 1 0 0 1.25h2.68a0.625 0.625 0 1 0 0 -1.25h-2.68Zm0 2.294a0.625 0.625 0 1 0 0 1.25h2.68a0.625 0.625 0 0 0 0 -1.25h-2.68Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GenderEquality"
);
var ManSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 0.75c0 -0.414214 0.33579 -0.75 0.75 -0.75h4.5c0.1017 0 0.1987 0.0202391 0.2871 0.0569091 0.0884 0.0365999 0.1713 0.0908539 0.2432 0.1627609 0.0719 0.071907 0.1262 0.154783 0.1628 0.243242C13.9798 0.551342 14 0.648308 14 0.75v4.5c0 0.41421 -0.3358 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75V2.56066l-3.4739 3.4739C9.63821 6.86422 10 7.88986 10 9c0 2.7614 -2.23858 5 -5 5s-5 -2.2386 -5 -5c0 -2.76142 2.23858 -5 5 -5 1.11014 0 2.13578 0.36179 2.96544 0.9739L11.4393 1.5H8.75C8.33579 1.5 8 1.16421 8 0.75Zm-0.59376 5.70833C6.77901 5.86432 5.93205 5.5 5 5.5 3.067 5.5 1.5 7.067 1.5 9s1.567 3.5 3.5 3.5S8.5 10.933 8.5 9c0 -0.93205 -0.36432 -1.77901 -0.95833 -2.40624 -0.025 -0.01934 -0.04906 -0.04049 -0.072 -0.06343 -0.02294 -0.02294 -0.04409 -0.047 -0.06343 -0.072Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ManSymbol"
);
var OfficeWorker = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.5 2a2 2 0 1 1 -4 0 2 2 0 0 1 4 0Zm0.045 7.97V10H5.5l-0.445 3.562a0.5 0.5 0 0 1 -0.496 0.438H2.44a0.5 0.5 0 0 1 -0.496 -0.438L1.5 10h-1a0.5 0.5 0 0 1 -0.5 -0.5v-1a3.5 3.5 0 0 1 6.9 -0.832A2.632 2.632 0 0 0 5.545 9.97Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.677 7.937a0.25 0.25 0 0 1 0.25 -0.25h0.913a0.25 0.25 0 0 1 0.25 0.25v0.651H9.677v-0.65Zm-1.5 0.651v-0.65c0 -0.967 0.784 -1.75 1.75 -1.75h0.913c0.966 0 1.75 0.783 1.75 1.75v0.65c0.763 0 1.381 0.62 1.381 1.383v2.647c0 0.763 -0.619 1.382 -1.382 1.382H8.177a1.382 1.382 0 0 1 -1.382 -1.382V9.97c0 -0.763 0.619 -1.382 1.382 -1.382Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OfficeWorker"
);
var PoliticsCompaign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.00001 0.0374756C3.15474 0.0374756 0.0375366 3.15468 0.0375366 6.99995c0 3.84525 3.1172034 6.96245 6.9624734 6.96245 3.84529 0 6.96249 -3.1172 6.96249 -6.96245 0 -3.84527 -3.1172 -6.9624744 -6.96249 -6.9624744Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.22441 3.95691H0.715405l-0.187976 0.47303C0.211038 5.22611 0.0374756 6.09373 0.0374756 7.00007c0 0.90628 0.1735394 1.77385 0.4898914 2.56998l0.187968 0.47305H13.2846l0.1879 -0.47305c0.3164 -0.79613 0.4899 -1.6637 0.4899 -2.56998 0 -0.90634 -0.1735 -1.77396 -0.4899 -2.57013l-0.188 -0.47303H1.22441Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.44856 5.35474c0.27614 0 0.5 0.22385 0.5 0.5v0.36878l0.40439 -0.13479c0.26197 -0.08733 0.54513 0.05425 0.63245 0.31623 0.08733 0.26197 -0.05425 0.54513 -0.31623 0.63245l-0.44146 0.14716 0.34521 0.51782c0.15318 0.22976 0.09109 0.5402 -0.13868 0.69337 -0.22976 0.15318 -0.54019 0.09109 -0.69337 -0.13867l-0.29231 -0.43847 -0.29231 0.43847c-0.15317 0.22976 -0.46361 0.29185 -0.69337 0.13867 -0.22977 -0.15317 -0.29185 -0.46361 -0.13868 -0.69337l0.34521 -0.51782 -0.44146 -0.14716c-0.26197 -0.08732 -0.40355 -0.37048 -0.31623 -0.63245 0.08732 -0.26198 0.37048 -0.40356 0.63245 -0.31623l0.40439 0.13479v-0.36878c0 -0.27615 0.22386 -0.5 0.5 -0.5Zm3.51196 0c0.27615 0 0.5 0.22385 0.5 0.5v0.36878l0.40439 -0.13479c0.26197 -0.08733 0.54513 0.05425 0.63245 0.31623 0.08733 0.26197 -0.05425 0.54513 -0.31622 0.63245l-0.44147 0.14716 0.34521 0.51782c0.15318 0.22976 0.09109 0.5402 -0.13867 0.69337 -0.22977 0.15318 -0.5402 0.09109 -0.69338 -0.13867l-0.29231 -0.43847 -0.2923 0.43847c-0.15318 0.22976 -0.46362 0.29185 -0.69338 0.13867 -0.22976 -0.15317 -0.29185 -0.46361 -0.13867 -0.69337l0.34521 -0.51782 -0.44147 -0.14716c-0.26197 -0.08732 -0.40355 -0.37048 -0.31623 -0.63245 0.08733 -0.26198 0.37049 -0.40356 0.63246 -0.31623l0.40438 0.13479v-0.36878c0 -0.27615 0.22386 -0.5 0.5 -0.5Zm4.01198 0.5c0 -0.27615 -0.2239 -0.5 -0.5 -0.5 -0.2762 0 -0.50001 0.22385 -0.50001 0.5v0.36878l-0.40439 -0.13479c-0.26197 -0.08733 -0.54513 0.05425 -0.63246 0.31623 -0.08732 0.26197 0.05426 0.54513 0.31623 0.63245l0.44147 0.14716 -0.34521 0.51782c-0.15318 0.22976 -0.09109 0.5402 0.13867 0.69337 0.22977 0.15318 0.5402 0.09109 0.6934 -0.13867l0.2923 -0.43847 0.2923 0.43847c0.1532 0.22976 0.4636 0.29185 0.6934 0.13867 0.2297 -0.15317 0.2918 -0.46361 0.1386 -0.69337l-0.3452 -0.51782 0.4415 -0.14716c0.262 -0.08732 0.4036 -0.37048 0.3162 -0.63245 -0.0873 -0.26198 -0.3705 -0.40356 -0.6324 -0.31623l-0.4044 0.13479v-0.36878Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PoliticsCompaign"
);
var PoliticsSpeech = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.68 1.67999c0 0.92783 -0.75216 1.67999 -1.67999 1.67999 -0.92784 0 -1.67999 -0.75216 -1.67999 -1.67999C5.32002 0.752157 6.07217 0 7.00001 0 7.92784 0 8.68 0.752157 8.68 1.67999ZM4.20621 6.53235H9.7938c-0.0965 -1.45892 -1.31044 -2.61239 -2.79379 -2.61239s-2.69729 1.15347 -2.7938 2.61239Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.2088 7.28235c0 -0.41421 0.33579 -0.75 0.75 -0.75h10.0824c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75h-0.8872l-0.3633 5.39585c-0.0177 0.2625 -0.2358 0.4664 -0.4989 0.4664H3.70811c-0.2631 0 -0.4812 -0.2039 -0.49887 -0.4664l-0.36325 -5.39585H1.9588c-0.41421 0 -0.75 -0.33579 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.44837 8.97794c-0.08423 -0.17067 -0.25804 -0.27872 -0.44836 -0.27872 -0.19033 0 -0.36414 0.10805 -0.44837 0.27872l-0.26198 0.53081 -0.58579 0.08512c-0.18834 0.02737 -0.34481 0.15929 -0.40363 0.3403 -0.05881 0.18103 -0.00976 0.37973 0.12653 0.51253l0.42388 0.4132 -0.10007 0.5834c-0.03217 0.1876 0.04494 0.3772 0.19891 0.4891 0.15398 0.1118 0.35811 0.1266 0.52657 0.038l0.52395 -0.2754 0.52394 0.2754c0.16846 0.0886 0.37259 0.0738 0.52657 -0.038 0.15397 -0.1119 0.23108 -0.3015 0.19891 -0.4891l-0.10007 -0.5834 0.42388 -0.4132c0.13629 -0.1328 0.18534 -0.3315 0.12653 -0.51253 -0.05882 -0.18101 -0.21529 -0.31293 -0.40363 -0.3403l-0.58579 -0.08512 -0.26198 -0.53081Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PoliticsSpeech"
);
var PoliticsVote2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.99932 5.63647H2.27197c-0.82842 0 -1.499997 0.67158 -1.499997 1.5v6.33633c0 0.2761 0.223857 0.5 0.499997 0.5H12.1789c0.2762 0 0.5 -0.2239 0.5 -0.5V7.13647c0 -0.82842 -0.6715 -1.5 -1.5 -1.5H9.62247L8.04834 7.21061c-0.68342 0.68342 -1.79146 0.68342 -2.47488 0L3.99932 5.63647Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.42631 4.06484 7.16442 6.32673c-0.19526 0.19526 -0.51184 0.19526 -0.70711 0L3.45318 3.32259c-0.19526 -0.19526 -0.19526 -0.51184 0 -0.7071L5.71507 0.3536c0.19526 -0.195262 0.51184 -0.195262 0.7071 0l3.00414 3.00414c0.19526 0.19526 0.19526 0.51184 0 0.7071Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.29071 7.14819h1.22033l0.06242 0.06242c0.68342 0.68342 1.79146 0.68342 2.47488 0l0.06242 -0.06242h1.04941c0.34517 0 0.625 0.27983 0.625 0.625 0 0.34518 -0.27983 0.625 -0.625 0.625H4.29071c-0.34518 0 -0.625 -0.27982 -0.625 -0.625 0 -0.34517 0.27982 -0.625 0.625 -0.625ZM0.771973 13.4728V10H12.6789v3.4728c0 0.2761 -0.2238 0.5 -0.5 0.5H1.27197c-0.27614 0 -0.499997 -0.2239 -0.499997 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PoliticsVote2"
);
var ReducedInequalities = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.63 4.766a0.75 0.75 0 0 0 0 1.5h2.684a0.75 0.75 0 1 0 0 -1.5H5.63Zm0 2.79a0.75 0.75 0 0 0 0 1.5h2.684a0.75 0.75 0 1 0 0 -1.5H5.63Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.885 3.258a0.5 0.5 0 0 1 -0.353 -0.853L6.618 0.318a0.5 0.5 0 0 1 0.707 0l2.087 2.087a0.5 0.5 0 0 1 -0.354 0.853l-4.173 0Zm4.635 7.614a0.5 0.5 0 0 0 -0.462 -0.309H4.885a0.5 0.5 0 0 0 -0.353 0.854l2.086 2.086a0.5 0.5 0 0 0 0.707 0l2.087 -2.086a0.5 0.5 0 0 0 0.108 -0.545Zm1.413 -6.51a0.5 0.5 0 0 0 -0.309 0.462l0 4.173a0.5 0.5 0 0 0 0.854 0.354l2.087 -2.087a0.5 0.5 0 0 0 0 -0.707L11.478 4.47a0.5 0.5 0 0 0 -0.545 -0.108ZM3.011 9.46a0.5 0.5 0 0 0 0.308 -0.462l0 -4.173a0.5 0.5 0 0 0 -0.853 -0.354L0.379 6.557a0.5 0.5 0 0 0 0 0.707l2.087 2.087a0.5 0.5 0 0 0 0.545 0.108Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ReducedInequalities"
);
var UserAddPlus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2 3a3 3 0 1 0 6 0 3 3 0 1 0 -6 0" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.75 8.69269C7.83382 7.65466 6.49337 6.99997 5 6.99997c-2.76142 0 -5 2.23858 -5 5.00003 0 0.2761 0.223858 0.5 0.5 0.5h6.78095C6.66612 12.1588 6.25 11.503 6.25 10.75c0 -1.10458 0.89543 -2.00001 2 -2.00001h0.5v-0.0573Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.75 7.5c0.4142 0 0.75 0.33579 0.75 0.75V10h1.75c0.4142 0 0.75 0.3358 0.75 0.75s-0.3358 0.75 -0.75 0.75H11.5v1.75c0 0.4142 -0.3358 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75V11.5H8.25c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75H10V8.25c0 -0.41421 0.3358 -0.75 0.75 -0.75Z", clipRule: "evenodd" }),
      " "
    ] }),
    " "
  ] }) }),
  "UserAddPlus"
);
var UserCheckValidate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5 6a3 3 0 1 0 0 -6 3 3 0 0 0 0 6ZM0.5 12.5h5.55a2 2 0 0 1 2.998 -2.434l0.6 0.405 0.077 -0.111A5.002 5.002 0 0 0 0 12a0.5 0.5 0 0 0 0.5 0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.7 8.15a0.75 0.75 0 0 1 0.15 1.05l-3.12 4.5a0.75 0.75 0 0 1 -1.05 0.15l-2.25 -1.56a0.75 0.75 0 1 1 0.9 -1.2l1.65 1.11 2.67 -3.9a0.75 0.75 0 0 1 1.05 -0.15Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserCheckValidate"
);
var UserCircleSingle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.5 5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.243 10.5A5.489 5.489 0 0 0 7 8.5a5.489 5.489 0 0 0 -4.243 2A5.489 5.489 0 0 0 7 12.5a5.489 5.489 0 0 0 4.243 -2Z" }),
    " "
  ] }) }),
  "UserCircleSingle"
);
var UserIdentifierCard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 3a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1H1a1 1 0 0 1 -1 -1V3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 7a1.5 1.5 0 1 0 0 -3 1.5 1.5 0 0 0 0 3ZM1.547 9.302A3.99 3.99 0 0 1 4.5 8a3.99 3.99 0 0 1 2.953 1.302c0.26 0.284 0.03 0.698 -0.355 0.698H1.902c-0.385 0 -0.615 -0.414 -0.355 -0.698ZM8.875 5.5c0 -0.345 0.28 -0.625 0.625 -0.625h2a0.625 0.625 0 1 1 0 1.25h-2a0.625 0.625 0 0 1 -0.625 -0.625ZM9.5 7.875a0.625 0.625 0 1 0 0 1.25h2a0.625 0.625 0 1 0 0 -1.25h-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserIdentifierCard"
);
var UserMultipleCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.75 13.78A7.051 7.051 0 0 1 7 14a6.995 6.995 0 0 1 -5.95 -3.312c0.841 -1.176 2.016 -2 3.52 -2 2.588 0 3.95 2.131 4.146 4.471 0.017 0.2 0.03 0.412 0.035 0.62Zm4.324 -3.298a7.028 7.028 0 0 1 -3.312 2.952c0.03 -0.125 0.04 -0.255 0.028 -0.388 -0.107 -1.286 -0.54 -2.595 -1.385 -3.608a5.062 5.062 0 0 0 -0.14 -0.16 3.743 3.743 0 0 1 4.196 0.56l0.613 0.644Zm-6.1 -4.994a2.245 2.245 0 1 0 -4.49 0 2.245 2.245 0 0 0 4.49 0ZM9.938 4.28a1.86 1.86 0 1 1 0 3.72 1.86 1.86 0 0 1 0 -3.72Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserMultipleCircle"
);
var UserMultipleGroup = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 7.5a3 3 0 1 0 0 -6 3 3 0 0 0 0 6Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 13.5a5 5 0 0 1 10 0 0.5 0.5 0 0 1 -0.5 0.5h-9a0.5 0.5 0 0 1 -0.5 -0.5Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.178 14H13.5a0.5 0.5 0 0 0 0.5 -0.5 5 5 0 0 0 -5.242 -4.994A6.24 6.24 0 0 1 11.25 13.5c0 0.174 -0.025 0.342 -0.072 0.5ZM8.132 7.373a3 3 0 1 0 0 -5.745A4.235 4.235 0 0 1 9.25 4.5a4.235 4.235 0 0 1 -1.118 2.873Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserMultipleGroup"
);
var UserProfileFocus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.573 1.573A0.25 0.25 0 0 1 1.75 1.5h1.5a0.75 0.75 0 0 0 0 -1.5h-1.5A1.75 1.75 0 0 0 0 1.75v1.5a0.75 0.75 0 0 0 1.5 0v-1.5a0.25 0.25 0 0 1 0.073 -0.177ZM14 10.75a0.75 0.75 0 0 0 -1.5 0v1.5a0.25 0.25 0 0 1 -0.25 0.25h-1.5a0.75 0.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25v-1.5ZM0.75 10a0.75 0.75 0 0 1 0.75 0.75v1.5a0.25 0.25 0 0 0 0.25 0.25h1.5a0.75 0.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 0 12.25v-1.5A0.75 0.75 0 0 1 0.75 10Zm10 -10a0.75 0.75 0 0 0 0 1.5h1.5a0.25 0.25 0 0 1 0.25 0.25v1.5a0.75 0.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 0h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.208 4.46a2.21 2.21 0 1 1 -4.421 0 2.21 2.21 0 0 1 4.421 0Zm-6.353 6.195a4.423 4.423 0 0 1 8.288 0c0.112 0.299 -0.126 0.595 -0.446 0.595H3.301c-0.32 0 -0.558 -0.296 -0.446 -0.595Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserProfileFocus"
);
var UserRemoveSubtract = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2 3a3 3 0 1 0 6 0 3 3 0 1 0 -6 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.25 10c0.4142 0 0.75 0.3358 0.75 0.75s-0.3358 0.75 -0.75 0.75h-5c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75h5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 12c0 -2.76145 2.23858 -5.00003 5 -5.00003 1.52067 0 2.88278 0.67885 3.79982 1.75003H8.25c-1.10457 0 -2 0.89543 -2 2 0 0.753 0.41612 1.4088 1.03094 1.75H0.5c-0.276142 0 -0.5 -0.2239 -0.5 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserRemoveSubtract"
);
var UserSingleNeutralMale = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 8.49a6.99 6.99 0 0 0 -6.656 4.855 0.5 0.5 0 0 0 0.476 0.653h12.36a0.5 0.5 0 0 0 0.476 -0.653A6.99 6.99 0 0 0 7 8.489Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 0.002a4.73 4.73 0 1 0 0 9.46 4.73 4.73 0 0 0 0 -9.46Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.498 3.305a4.734 4.734 0 0 1 9.148 0.56 0.5 0.5 0 0 1 -0.488 0.595l-0.031 0a4.611 4.611 0 0 1 -3.09 -1.184A4.611 4.611 0 0 1 4.944 4.46c-0.8 0 -1.554 -0.203 -2.211 -0.562a0.5 0.5 0 0 1 -0.236 -0.593Zm2.837 2.29a0.625 0.625 0 0 1 0.84 0.275c0.091 0.179 0.381 0.363 0.825 0.363 0.444 0 0.734 -0.184 0.825 -0.363a0.625 0.625 0 0 1 1.114 0.566C8.552 7.197 7.7 7.483 7 7.483s-1.552 -0.286 -1.939 -1.047a0.625 0.625 0 0 1 0.274 -0.84Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserSingleNeutralMale"
);
var UserSyncOnlineInPerson = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 7a1.5 1.5 0 1 0 0 -2.999A1.5 1.5 0 0 0 7 7ZM4.483 8.892A2.998 2.998 0 0 1 7 7.525c1.055 0 1.982 0.544 2.517 1.367 0.188 0.29 -0.05 0.633 -0.395 0.633H4.878c-0.345 0 -0.583 -0.343 -0.395 -0.633Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.577 1.689a5.488 5.488 0 0 1 4.636 0.848l-0.61 0.61A0.5 0.5 0 0 0 9.957 4h2.293a0.5 0.5 0 0 0 0.5 -0.5V1.207a0.5 0.5 0 0 0 -0.854 -0.353l-0.612 0.612A6.999 6.999 0 0 0 0.12 8.287a0.75 0.75 0 1 0 1.475 -0.277 5.499 5.499 0 0 1 3.982 -6.321Zm8.303 4.024a0.75 0.75 0 0 0 -1.475 0.277 5.499 5.499 0 0 1 -8.618 5.473l0.61 -0.61A0.5 0.5 0 0 0 4.042 10H1.75a0.5 0.5 0 0 0 -0.5 0.5v2.293a0.5 0.5 0 0 0 0.854 0.353l0.612 -0.612a6.999 6.999 0 0 0 11.164 -6.82Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserSyncOnlineInPerson"
);
var WomanSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.5A3.25 3.25 0 1 0 7 8a3.25 3.25 0 0 0 0 -6.5Zm4.75 3.25a4.751 4.751 0 0 1 -4 4.691v1.309h0.75a0.75 0.75 0 0 1 0 1.5h-0.75v1a0.75 0.75 0 0 1 -1.5 0v-1H5.5a0.75 0.75 0 0 1 0 -1.5h0.75V9.441a4.751 4.751 0 1 1 5.5 -4.691Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WomanSymbol"
);
var ButtonFastForward1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.497 5.894 1.27 2.424a0.83 0.83 0 0 0 -0.92 0.056 0.823 0.823 0 0 0 -0.35 0.648v7.72l0 0.003c0 0.638 0.735 1.05 1.27 0.724l5.227 -3.449 0 2.722 0 0.002c0 0.639 0.734 1.052 1.27 0.725l5.867 -3.872c0.488 -0.316 0.488 -1.067 0 -1.384L7.767 2.424a0.832 0.832 0 0 0 -0.92 0.056 0.823 0.823 0 0 0 -0.35 0.648l0 2.766Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonFastForward1"
);
var ButtonFastForward2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 3.234a1 1 0 1 0 -2 0v2l-4.233 -2.81a0.832 0.832 0 0 0 -0.92 0.056 0.823 0.823 0 0 0 -0.35 0.648l0 2.766 -5.227 -3.47a0.83 0.83 0 0 0 -0.92 0.056 0.823 0.823 0 0 0 -0.35 0.648v7.72l0 0.003c0 0.638 0.735 1.05 1.27 0.724l5.227 -3.449 0 2.722 0 0.002c0 0.639 0.734 1.052 1.27 0.725L12 8.782v1.984a1 1 0 1 0 2 0V3.234Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonFastForward2"
);
var ButtonNext = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.51212 6.056 1.6931 0.656892C1.29745 0.406346 0.815218 0.473133 0.466699 0.735097 0.198102 0.936989 0.00892463 1.25481 0.0000077775 1.63264V12.3333C0.000002589 12.3347 0 12.3362 0 12.3376c9.627e-7 0.884 0.978943 1.4562 1.6931 1.0039l7.81902 -5.36654c0.65048 -0.43882 0.65048 -1.48014 0 -1.91896Zm4.23778 -4.31384c0 -0.55229 -0.4477 -1.000003 -1 -1.000003 -0.5522 0 -1 0.447713 -1 1.000003l0 10.51564c0 0.5523 0.4478 1 1 1 0.5523 0 1 -0.4477 1 -1l0 -10.51564Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonNext"
);
var ButtonPause2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0H4a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 4 14H1.5A1.5 1.5 0 0 1 0 12.5v-11ZM10 0a1.5 1.5 0 0 0 -1.5 1.5v11A1.5 1.5 0 0 0 10 14h2.5a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0H10Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonPause2"
);
var ButtonPlay = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.67593 0.019165c-0.29576 0 -0.58657 0.0753875 -0.84499 0.218948 -0.26314 0.134139 -0.48525 0.336896 -0.64277 0.58693 -0.15979 0.253627 -0.247004 0.546207 -0.252169 0.845927l-0.000075 0V12.3396H0.935852l0.000149 0.0086c0.005165 0.2997 0.092379 0.5923 0.252169 0.8459 0.15752 0.2501 0.37963 0.4528 0.64277 0.587 0.25842 0.1435 0.54923 0.2189 0.84499 0.2189 0.29995 0 0.59481 -0.0775 0.85596 -0.2251 0.00575 -0.0032 0.01143 -0.0066 0.01704 -0.0101l8.62977 -5.33745c0.2617 -0.13189 0.4826 -0.33282 0.6388 -0.5813 0.1611 -0.25659 0.2467 -0.55345 0.2467 -0.85647 0 -0.30301 -0.0856 -0.59988 -0.2467 -0.85646 -0.1563 -0.24874 -0.3776 -0.44984 -0.6396 -0.58172L3.54751 0.253465c-0.00515 -0.00316 -0.01036 -0.006227 -0.01562 -0.009199 -0.26115 -0.1475588 -0.55601 -0.225101 -0.85596 -0.225101Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonPlay"
);
var ButtonPrevious = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m4.238 6.056 7.819 -5.4c0.396 -0.25 0.878 -0.183 1.226 0.08 0.269 0.201 0.458 0.519 0.467 0.897v10.7l0 0.004c0 0.884 -0.979 1.457 -1.693 1.005l-7.82 -5.367c-0.65 -0.439 -0.65 -1.48 0 -1.919ZM0 1.742a1 1 0 1 1 2 0l0 10.516a1 1 0 1 1 -2 0V1.742Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonPrevious"
);
var ButtonRecord3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 14c3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7 -3.86599 0 -7 3.13401 -7 7 0 3.866 3.13401 7 7 7Z" }),
    " "
  ] }) }),
  "ButtonRecord3"
);
var ButtonRewind1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.503 5.894 5.227 -3.47c0.296 -0.181 0.658 -0.133 0.92 0.056a0.823 0.823 0 0 1 0.35 0.648v7.72l0 0.003c0 0.638 -0.735 1.05 -1.27 0.724L7.503 8.126l0 2.722 0 0.002c0 0.639 -0.734 1.052 -1.27 0.725L0.366 7.703c-0.488 -0.316 -0.488 -1.067 0 -1.384l5.867 -3.895a0.832 0.832 0 0 1 0.92 0.056 0.823 0.823 0 0 1 0.35 0.648l0 2.766Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonRewind1"
);
var ButtonRewind2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 3.234a1 1 0 0 1 2 0l0 2 4.233 -2.81a0.832 0.832 0 0 1 0.92 0.056 0.823 0.823 0 0 1 0.35 0.648l0 2.766 5.227 -3.47c0.296 -0.181 0.658 -0.133 0.92 0.056a0.823 0.823 0 0 1 0.35 0.648v7.72l0 0.002c0 0.639 -0.734 1.052 -1.27 0.725L7.503 8.126l0 2.722 0 0.002c0 0.639 -0.734 1.052 -1.27 0.725L2 8.782l0 1.984a1 1 0 1 1 -2 0V3.234Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonRewind2"
);
var ButtonStop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ButtonStop"
);
var EditImagePhoto = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.67 0.67c0.372 -0.372 0.876 -0.58 1.402 -0.58h9.856a1.982 1.982 0 0 1 1.982 1.98v5.17l-1.456 -1.456a1.25 1.25 0 0 0 -1.769 0l-4.61 4.62a1.25 1.25 0 0 0 -0.352 0.71L5.429 13.2a1.25 1.25 0 0 0 0.108 0.71H2.072A1.982 1.982 0 0 1 0.09 11.929V2.07c0 -0.525 0.209 -1.03 0.58 -1.401Zm5.996 12.706 0 -0.002v0.002l2.09 -0.285 -0.803 0.11 -1.287 0.175Z", clipRule: "evenodd" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.94 5.547a1.478 1.478 0 1 0 0 -2.956 1.478 1.478 0 0 0 0 2.956Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.703 8.791a26.3 26.3 0 0 0 -0.733 -0.555A11.19 11.19 0 0 0 1.841 7c-0.595 0 -1.18 0.046 -1.751 0.136v4.793a1.982 1.982 0 0 0 1.982 1.982H5.52a1.25 1.25 0 0 1 -0.095 -0.68l0.296 -2.1a1.25 1.25 0 0 1 0.353 -0.708l1.628 -1.632Zm-1.04 4.614 0.001 -0.001v0.001Z", clipRule: "evenodd" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m13.405 8.477 -4.642 4.641 -2.099 0.286 0.296 -2.1 4.631 -4.64 1.814 1.813Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "EditImagePhoto"
);
var Eject = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.5 11.976a1 1 0 0 1 1 -1h11a1 1 0 0 1 0 2h-11a1 1 0 0 1 -1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.1 1.503a1.5 1.5 0 0 0 -2.2 0L0.94 6.846c-0.892 0.96 -0.21 2.52 1.099 2.52h9.922c1.31 0 1.99 -1.56 1.1 -2.52L8.099 1.503Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Eject"
);
var FilmRoll1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.25 5.5c0.4142 0 0.75 0.33579 0.75 0.75v5c0 0.4142 0.3358 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75 0.3358 -0.75 0.75 -0.75 0.75 0.3358 0.75 0.75c0 1.2426 -1.0074 2.25 -2.25 2.25S9.5 12.4926 9.5 11.25v-5c0 -0.41421 0.33579 -0.75 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.5 0.5C2.46243 0.5 0 2.96243 0 6s2.46243 5.5 5.5 5.5S11 9.03757 11 6 8.53757 0.5 5.5 0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 4.375c0.48325 0 0.875 -0.39175 0.875 -0.875s-0.39175 -0.875 -0.875 -0.875 -0.875 0.39175 -0.875 0.875 0.39175 0.875 0.875 0.875ZM3.19531 6.88281c0.48325 0 0.875 -0.39175 0.875 -0.875s-0.39175 -0.875 -0.875 -0.875 -0.875 0.39175 -0.875 0.875 0.39175 0.875 0.875 0.875Zm5.48438 -0.875c0 0.48325 -0.39175 0.875 -0.875 0.875s-0.875 -0.39175 -0.875 -0.875 0.39175 -0.875 0.875 -0.875 0.875 0.39175 0.875 0.875ZM5.5 9.24219c0.48325 0 0.875 -0.39175 0.875 -0.875s-0.39175 -0.875 -0.875 -0.875 -0.875 0.39175 -0.875 0.875 0.39175 0.875 0.875 0.875Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FilmRoll1"
);
var FilmSlate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.00653 6.07639 12.8011 2.91605l-0.529 -1.974257c-0.143 -0.533466 -0.6913 -0.8500491 -1.2248 -0.707107L1.18464 2.87738c-0.533469 0.14294 -0.850052 0.69128 -0.70711 1.22475l0.529 1.97426Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.54137 4.32542c0.00087 -0.00402 0.00179 -0.00805 0.00274 -0.01207L8.34053 0.960003l1.372 -0.367627c-0.00072 0.003273 -0.00147 0.006545 -0.00225 0.009817L8.91333 3.9578l-1.37196 0.36762Zm-2.87361 0.76998 0.77657 -3.34633c0.00107 -0.00461 0.00209 -0.00923 0.00305 -0.01385l-1.36813 0.36659 -0.76923 3.31469c-0.00348 0.01502 -0.0064 0.03005 -0.00875 0.04505l1.36649 -0.36615Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.00806 6.07639H13.2187v6.71471c0 0.5523 -0.4478 1 -1 1H2.00806c-0.55229 0 -1 -0.4477 -1 -1V6.07639Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.18201 11.0796c0 -0.3452 0.27982 -0.625 0.625 -0.625h1.3645c0.34518 0 0.625 0.2798 0.625 0.625s-0.27982 0.625 -0.625 0.625h-1.3645c-0.34518 0 -0.625 -0.2798 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FilmSlate"
);
var GifFormat = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.9375 4.65625c0 -1.38071 -1.1193 -2.5 -2.5 -2.5h-8.875c-1.38071 0 -2.5 1.11929 -2.5 2.5V8.9449c0 1.3807 1.11929 2.5 2.5 2.5h8.875c1.3807 0 2.5 -1.1193 2.5 -2.5V4.65625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.26907 5.87449c0 -0.23527 0.19073 -0.426 0.42601 -0.426h0.61734c0.1847 0 0.34317 0.11782 0.40189 0.28396 0.09202 0.26036 0.37769 0.39682 0.63804 0.3048 0.26036 -0.09202 0.39683 -0.37768 0.3048 -0.63804 -0.19552 -0.55319 -0.72306 -0.95072 -1.34473 -0.95072h-0.61734c-0.78756 0 -1.42601 0.63844 -1.42601 1.426v1.85202c0 0.78756 0.63845 1.426 1.42601 1.426h0.61734c0.78756 0 1.426 -0.63844 1.426 -1.426v-0.61734c0 -0.27614 -0.22385 -0.5 -0.5 -0.5h-0.926c-0.27615 0 -0.5 0.22386 -0.5 0.5s0.22385 0.5 0.5 0.5h0.426v0.11734c0 0.23527 -0.19073 0.426 -0.426 0.426h-0.61734c-0.23528 0 -0.42601 -0.19073 -0.42601 -0.426V5.87449Zm5.53687 -1.42588 -0.92563 0 -0.0004 0 -0.0004 0 -0.92558 0c-0.27615 0 -0.5 0.22386 -0.5 0.5s0.22385 0.5 0.5 0.5h0.42598l0 2.70402h-0.42598c-0.27615 0 -0.5 0.22386 -0.5 0.5 0 0.27615 0.22385 0.5 0.5 0.5h1.85201c0.27614 0 0.5 -0.22385 0.5 -0.5 0 -0.27614 -0.22386 -0.5 -0.5 -0.5h-0.42603l0 -2.70402h0.42603c0.27614 0 0.5 -0.22386 0.5 -0.5s-0.22386 -0.5 -0.5 -0.5Zm1.45566 0.49988c0 -0.27615 0.22385 -0.5 0.5 -0.5h2.4693c0.2762 0 0.5 0.22385 0.5 0.5 0 0.27614 -0.2238 0.5 -0.5 0.5h-1.9693v0.69775h1.6607c0.2761 0 0.5 0.22386 0.5 0.5s-0.2239 0.5 -0.5 0.5h-1.6607v1.50627c0 0.27614 -0.2239 0.5 -0.5 0.5 -0.27615 0 -0.5 -0.22386 -0.5 -0.5V4.94849Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GifFormat"
);
var ImageBlur = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0C3.13401 0 0 3.13401 0 7c0 3.866 3.13401 7 7 7 3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.54168 3.41297c-0.35469 0 -0.64222 -0.28753 -0.64222 -0.64222s0.28753 -0.64213 0.64222 -0.64213 0.64222 0.28744 0.64222 0.64213 -0.28753 0.64222 -0.64222 0.64222Zm3.06249 0.96206c-0.56379 0 -1.02084 0.45704 -1.02084 1.02083 0 0.56379 0.45705 1.02083 1.02084 1.02083S9.625 5.95965 9.625 5.39586c0 -0.56379 -0.45704 -1.02083 -1.02083 -1.02083Zm-2.1875 4.22912c0 0.56379 -0.45705 1.02084 -1.02084 1.02084S4.375 9.16794 4.375 8.60415s0.45704 -1.02083 1.02083 -1.02083c0.56379 0 1.02084 0.45704 1.02084 1.02083Zm1.16666 0c0 0.56379 0.45705 1.02084 1.02084 1.02084S9.625 9.16794 9.625 8.60415s-0.45704 -1.02083 -1.02083 -1.02083c-0.56379 0 -1.02084 0.45704 -1.02084 1.02083ZM6.41667 5.39586c0 -0.56379 -0.45705 -1.02083 -1.02084 -1.02083S4.375 4.83207 4.375 5.39586c0 0.56379 0.45704 1.02083 1.02083 1.02083 0.56379 0 1.02084 -0.45704 1.02084 -1.02083ZM4.89946 11.2291c0 0.3547 0.28753 0.6422 0.64222 0.6422s0.64222 -0.2875 0.64222 -0.6422 -0.28753 -0.6421 -0.64222 -0.6421 -0.64222 0.2874 -0.64222 0.6421Zm-2.1286 -5.04526c-0.35468 0 -0.64222 -0.28753 -0.64222 -0.64222s0.28754 -0.64213 0.64222 -0.64213c0.35469 0 0.64223 0.28744 0.64223 0.64213s-0.28754 0.64222 -0.64223 0.64222Zm7.81614 -0.64222c0 0.35469 0.2875 0.64222 0.6422 0.64222s0.6423 -0.28753 0.6423 -0.64222 -0.2876 -0.64213 -0.6423 -0.64213c-0.3547 0 -0.6422 0.28744 -0.6422 0.64213ZM2.77086 9.10053c-0.35468 0 -0.64222 -0.28753 -0.64222 -0.64222s0.28754 -0.64213 0.64222 -0.64213c0.35469 0 0.64223 0.28744 0.64223 0.64213s-0.28754 0.64222 -0.64223 0.64222Zm5.04525 -6.32978c0 0.35469 0.28753 0.64222 0.64222 0.64222s0.64223 -0.28753 0.64223 -0.64222 -0.28754 -0.64213 -0.64223 -0.64213c-0.35469 0 -0.64222 0.28744 -0.64222 0.64213Zm3.41309 6.32978c-0.3547 0 -0.6422 -0.28753 -0.6422 -0.64222s0.2875 -0.64213 0.6422 -0.64213 0.6423 0.28744 0.6423 0.64213 -0.2876 0.64222 -0.6423 0.64222ZM7.81611 11.2291c0 0.3547 0.28753 0.6422 0.64222 0.6422s0.64223 -0.2875 0.64223 -0.6422 -0.28754 -0.6421 -0.64223 -0.6421c-0.35469 0 -0.64222 0.2874 -0.64222 0.6421Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ImageBlur"
);
var ImageSaturation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.46466 0.224519c0.29286 -0.2927327 0.77411 -0.2958739 1.06698 -0.003141 0.26708 0.26998 0.52494 0.549121 0.77832 0.831932 0.4616 0.51522 1.0786 1.2397 1.69734 2.07465 0.6171 0.83265 1.2468 1.78968 1.7249 2.76936 0.4731 0.96941 0.8275 2.02053 0.8275 3.02575 0 0.01386 -0.0004 0.02771 -0.0012 0.04154 -0.0781 1.40809 -0.7106 2.72799 -1.7592 3.67129C9.72104 13.6059 8.08624 14 6.99982 14c-1.08641 0 -2.72123 -0.3941 -3.79952 -1.3641 -1.04858 -0.9433 -1.68109 -2.2632 -1.75921 -3.67129 -0.00076 -0.01383 -0.00115 -0.02768 -0.00115 -0.04154 0 -1.00522 0.35443 -2.05634 0.82753 -3.02575 0.47811 -0.97968 1.10778 -1.93671 1.72484 -2.76936 0.61877 -0.83495 1.23577 -1.55943 1.69737 -2.07465 0.2523 -0.281605 0.50857 -0.560377 0.77498 -0.828791Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.30996 1.05308c0.4616 0.51521 1.07861 1.23969 1.69734 2.07465 0.6171 0.83264 1.2468 1.78968 1.7249 2.76935 0.4731 0.96942 0.8275 2.02053 0.8275 3.02576 0 0.01385 -0.0004 0.02771 -0.0012 0.04154 -0.0781 1.40812 -0.7106 2.72792 -1.7592 3.67122 -1.07825 0.9701 -2.71306 1.3642 -3.79948 1.3642V0.00315857c0.19297 -0.00036087 0.38581 0.07204093 0.53182 0.21798543 0.26708 0.269981 0.52494 0.549121 0.77832 0.831936Z" }),
    " "
  ] }) }),
  "ImageSaturation"
);
var InsertCloudVideo = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.171 7.525a0.5 0.5 0 0 1 0.765 -0.424l3.52 2.2a0.5 0.5 0 0 1 0 0.848l-3.52 2.2a0.5 0.5 0 0 1 -0.765 -0.424v-4.4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.685 2.05a3.93 3.93 0 0 1 6.21 1.835l0.11 0.006a3.17 3.17 0 0 1 -0.032 6.329h-0.103a1.747 1.747 0 0 0 -0.752 -1.979l-3.52 -2.2c-1.165 -0.728 -2.677 0.11 -2.677 1.484v2.695h-0.553a3.17 3.17 0 1 1 -0.017 -6.33l0.07 -0.005A3.93 3.93 0 0 1 4.686 2.05Zm4.657 8.17 0.114 -0.071 -0.114 0.071Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InsertCloudVideo"
);
var Landscape2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.5 14a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 3.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1 -3.5 0ZM12.5 14a1.5 1.5 0 0 0 1.5 -1.5v-3L9.687 6.481a1 1 0 0 0 -1.28 0.112l-7.343 7.343A1.5 1.5 0 0 0 1.5 14h11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Landscape2"
);
var LandscapeSetting = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.5 12.5A1.5 1.5 0 0 0 14 11V3a1.5 1.5 0 0 0 -1.5 -1.5h-11A1.5 1.5 0 0 0 0 3v8a1.5 1.5 0 0 0 1.5 1.5h11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.006 5.462a1.23 1.23 0 1 0 -0.013 0 2.154 2.154 0 0 0 -2.147 2.153v0.923h0.923L6.077 11h1.846l0.308 -2.462h0.923v-0.923a2.154 2.154 0 0 0 -2.148 -2.153Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LandscapeSetting"
);
var LiveVideo = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.5 8.88192V5.11799c0 -0.74338 0.78231 -1.22688 1.44721 -0.89443l3.76394 1.88197c0.73705 0.36852 0.73705 1.42033 -0.00001 1.78885L5.94721 9.77635C5.28231 10.1088 4.5 9.6253 4.5 8.88192Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.09005 0.0844444c-0.40923 -0.0640442 -0.7929 0.2157866 -0.85694 0.6250186 -0.06405 0.409237 0.21578 0.792897 0.62501 0.856947C10.4879 1.97797 12.5 4.25469 12.5 6.99996 12.5 10.0375 10.0376 12.5 6.99999 12.5c-2.32137 0 -4.30861 -1.4384 -5.11556 -3.47534 -0.15257 -0.3851 -0.58842 -0.5736 -0.973517 -0.42104 -0.385094 0.15256 -0.573599 0.58842 -0.421037 0.97351C1.51571 12.1665 4.04283 14 6.99999 14 10.866 14 14 10.866 14 6.99996 14 3.50439 11.4385 0.608473 8.09005 0.0844444ZM5.62443 1.57478c0.40114 -0.10325 0.64263 -0.51214 0.53938 -0.913276 -0.10324 -0.40114 -0.51213 -0.6426302 -0.91327 -0.539384 -0.32213 0.08291 -0.63529 0.188156 -0.9377 0.31397 -0.38243 0.159108 -0.56348 0.59812 -0.40437 0.98055 0.15911 0.38244 0.59812 0.56348 0.98055 0.40437 0.23722 -0.09869 0.4828 -0.18122 0.73541 -0.24623ZM3.16945 2.95477c0.29721 -0.28852 0.30425 -0.76334 0.01574 -1.06054 -0.28852 -0.29721 -0.76334 -0.30426 -1.06054 -0.01574 -0.47159 0.45779 -0.87904 0.98162 -1.20744 1.55682 -0.205375 0.35971 -0.080258 0.81781 0.27946 1.02318 0.35971 0.20538 0.8178 0.08026 1.02318 -0.27945 0.25799 -0.45188 0.57841 -0.86393 0.9496 -1.22427Zm-1.6153 3.17126c0.05781 -0.41016 -0.22782 -0.78952 -0.637984 -0.84733 -0.41016 -0.05781 -0.789524 0.22782 -0.8473338 0.63798C0.0234281 6.23882 0 6.56765 0 6.90152c0 0.41422 0.335786 0.75 0.75 0.75 0.41421 0 0.75 -0.33578 0.75 -0.75 0 -0.26362 0.01849 -0.52249 0.05415 -0.77549Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LiveVideo"
);
var Loop1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.564 4.884a1.913 1.913 0 0 0 -1.523 0.542 1.872 1.872 0 0 0 -0.442 0.691 2.54 2.54 0 0 0 -0.08 0.511c-0.02 0.255 -0.02 0.49 0 0.744 0.02 0.241 0.052 0.434 0.08 0.51A1.872 1.872 0 0 0 2.74 9.015c0.263 0.094 0.545 0.129 0.824 0.102a0.75 0.75 0 0 1 0.07 -0.003c0.373 0 0.78 -0.2 1.271 -0.68 0.392 -0.384 0.77 -0.879 1.172 -1.433 -0.401 -0.554 -0.78 -1.049 -1.172 -1.432 -0.491 -0.482 -0.898 -0.681 -1.27 -0.681a0.75 0.75 0 0 1 -0.071 -0.003ZM7 8.277a10.8 10.8 0 0 1 -1.045 1.227c-0.598 0.585 -1.352 1.096 -2.284 1.109a3.414 3.414 0 0 1 -2.687 -0.974 3.372 3.372 0 0 1 -0.796 -1.246c-0.104 -0.287 -0.144 -0.664 -0.163 -0.9A5.96 5.96 0 0 1 0 7c0 -0.164 0.01 -0.33 0.024 -0.493 0.02 -0.236 0.06 -0.613 0.163 -0.9a3.372 3.372 0 0 1 2.048 -2.034c0.46 -0.164 0.95 -0.227 1.435 -0.186 0.932 0.013 1.686 0.524 2.284 1.109 0.368 0.36 0.716 0.789 1.045 1.227a10.8 10.8 0 0 1 1.045 -1.227c0.598 -0.585 1.352 -1.096 2.284 -1.109a3.412 3.412 0 0 1 2.687 0.974c0.354 0.352 0.626 0.777 0.796 1.246 0.104 0.287 0.144 0.664 0.163 0.9 0.014 0.164 0.024 0.329 0.025 0.493 0 0.164 -0.011 0.33 -0.025 0.493 -0.02 0.236 -0.06 0.613 -0.163 0.9a3.372 3.372 0 0 1 -2.048 2.034c-0.46 0.164 -0.95 0.227 -1.435 0.186 -0.932 -0.013 -1.686 -0.524 -2.284 -1.109a10.8 10.8 0 0 1 -1.045 -1.227Zm5.48 -0.905c-0.02 0.241 -0.051 0.434 -0.079 0.51a1.872 1.872 0 0 1 -1.141 1.132 1.913 1.913 0 0 1 -0.823 0.102 0.752 0.752 0 0 0 -0.072 -0.003c-0.372 0 -0.779 -0.2 -1.27 -0.68 -0.392 -0.384 -0.77 -0.879 -1.172 -1.433 0.401 -0.554 0.78 -1.049 1.172 -1.432 0.491 -0.482 0.898 -0.681 1.27 -0.681a0.752 0.752 0 0 0 0.072 -0.003 1.913 1.913 0 0 1 1.522 0.542c0.197 0.196 0.348 0.432 0.442 0.691 0.028 0.077 0.06 0.27 0.08 0.511 0.02 0.255 0.02 0.49 0 0.744Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Loop1"
);
var MusicEqualizer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.851a0.75 0.75 0 0 0 -1.5 0V13.15a0.75 0.75 0 0 0 1.5 0V0.851ZM4 2.466a0.75 0.75 0 0 1 0.75 0.75v7.568a0.75 0.75 0 1 1 -1.5 0V3.216a0.75 0.75 0 0 1 0.75 -0.75ZM1 4.831a0.75 0.75 0 0 1 0.75 0.75V8.42a0.75 0.75 0 0 1 -1.5 0V5.581a0.75 0.75 0 0 1 0.75 -0.75Zm9 -2.365a0.75 0.75 0 0 1 0.75 0.75v7.568a0.75 0.75 0 1 1 -1.5 0V3.216a0.75 0.75 0 0 1 0.75 -0.75Zm3.75 3.115a0.75 0.75 0 0 0 -1.5 0V8.42a0.75 0.75 0 0 0 1.5 0V5.581Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicEqualizer"
);
var MusicFolderSong = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.127 0.556A1.5 1.5 0 0 0 5.183 0.25H1.5A1.5 1.5 0 0 0 0 1.75v10.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5 -1.5v-8.5a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.5 1.5 0 0 0 -0.548 -0.834Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.04 4.494a0.967 0.967 0 0 1 1.22 0.928l0 0.004 0 3.683 0 0.05a1.536 1.536 0 1 1 -1.5 -1.535l0 -1.302 -2.408 0.668 0 3.286 0 0.008a1.536 1.536 0 1 1 -1.5 -1.536l0 -2.357 0 -0.005a0.967 0.967 0 0 1 0.712 -0.927l3.471 -0.963 0.006 -0.002Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicFolderSong"
);
var MusicNote1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.44473 0.126343c-0.55228 0 -1 0.447715 -1 0.999997v6.58881c-0.36907 -0.14892 -0.77232 -0.2309 -1.19473 -0.2309 -1.76438 0 -3.1947 1.43032 -3.1947 3.19475 0 1.7643 1.43032 3.1947 3.1947 3.1947 1.76439 0 3.19471 -1.4304 3.19471 -3.1947 0 -0.0058 -0.00002 -0.0115 -0.00005 -0.0172 0.00005 -0.0041 0.00007 -0.0081 0.00007 -0.0122V2.23056c0.25345 0.0535 0.50184 0.12733 0.74232 0.22085 0.55063 0.21413 1.04702 0.52649 1.4623 0.91638 0.41515 0.38977 0.74085 0.84905 0.96185 1.34983 0.2208 0.50059 0.3335 1.0347 0.3335 1.5724 0 0.55228 0.4477 1 1 1s1 -0.44772 1 -1c0 -0.8185 -0.1718 -1.62733 -0.5037 -2.37971 -0.3319 -0.75219 -0.8164 -1.43139 -1.4227 -2.00061C10.4121 1.34061 9.69588 0.892263 8.91193 0.587398 8.12805 0.282559 7.28987 0.126343 6.44473 0.126343Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicNote1"
);
var MusicNote2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.781 0.23a1.227 1.227 0 0 0 -0.555 0.02l-0.006 0 -7.633 2.119a1.227 1.227 0 0 0 -0.905 1.177V9.04a2.477 2.477 0 1 0 1.5 2.277l0 -0.01 0 -0.005V6.076l7.09 -1.97V6.57a2.477 2.477 0 1 0 1.5 2.345V8.85l0 -0.004 0 -0.005V3.12l0 -1.687 0 -0.002v-0.028a1.226 1.226 0 0 0 -0.99 -1.172Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicNote2"
);
var MusicNoteOff1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.445 0.126a1 1 0 0 0 -1 1v6.59a3.195 3.195 0 1 0 2 2.934V2.23c0.253 0.054 0.502 0.128 0.742 0.221 0.55 0.215 1.047 0.527 1.462 0.917 0.416 0.39 0.741 0.849 0.962 1.35 0.221 0.5 0.334 1.034 0.334 1.572a1 1 0 1 0 2 0c0 -0.818 -0.172 -1.627 -0.504 -2.38a6.155 6.155 0 0 0 -1.423 -2A6.537 6.537 0 0 0 8.912 0.587a6.812 6.812 0 0 0 -2.467 -0.46Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.78 13.78a0.75 0.75 0 0 0 0 -1.06L1.28 0.22A0.75 0.75 0 0 0 0.22 1.28l12.5 12.5a0.75 0.75 0 0 0 1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicNoteOff1"
);
var MusicNoteOff2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.734 0.33a1.217 1.217 0 0 0 -0.55 0.019L4.605 2.452a1.217 1.217 0 0 0 -0.897 1.167V9.06a2.463 2.463 0 1 0 1.488 2.09V5.162l0.827 0.736 6.205 -1.745v2.458a2.463 2.463 0 1 0 1.488 2.09l0 -7.18 0 -0.003A1.216 1.216 0 0 0 12.734 0.33Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MusicNoteOff2"
);
var PicturesFolderMemories = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.177 0.813A1.457 1.457 0 0 0 5.26 0.516H1.734A1.457 1.457 0 0 0 0.276 1.974v10.053a1.458 1.458 0 0 0 1.458 1.458h10.532a1.458 1.458 0 0 0 1.458 -1.458V3.89a1.458 1.458 0 0 0 -1.458 -1.458H6.912l-0.202 -0.807a1.46 1.46 0 0 0 -0.533 -0.811Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.858 7.566a1.5 1.5 0 1 1 0 -3 1.5 1.5 0 0 1 0 3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.314 13.484 5.504 7.23a0.662 0.662 0 0 0 -0.837 0l-4.39 3.096v1.701a1.458 1.458 0 0 0 1.457 1.458h10.532l0.048 -0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PicturesFolderMemories"
);
var PlayList4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.954 9.494V4.646a0.46 0.46 0 0 1 0.696 -0.392L9.8 6.666a0.46 0.46 0 0 1 0 0.797L5.65 9.886a0.46 0.46 0 0 1 -0.696 -0.392Z" }),
    " "
  ] }) }),
  "PlayList4"
);
var PlayList5 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.235 2.76c-0.815 0 -1.476 0.66 -1.476 1.475v8.29c0 0.814 0.66 1.475 1.476 1.475h8.29c0.814 0 1.475 -0.66 1.475 -1.475v-8.29c0 -0.815 -0.66 -1.476 -1.475 -1.476h-8.29Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.475 0C0.661 0 0 0.66 0 1.475v8.29c0 0.815 0.66 1.476 1.475 1.476h8.29c0.815 0 1.476 -0.66 1.476 -1.476v-8.29A1.477 1.477 0 0 0 9.765 0h-8.29Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.167 1.88a0.75 0.75 0 0 0 -0.75 0.75v3.238a1.756 1.756 0 1 0 1.5 1.72v-4.09c0.306 0.098 0.583 0.256 0.81 0.462 0.4 0.361 0.608 0.835 0.608 1.312a0.75 0.75 0 0 0 1.5 0c0 -0.925 -0.407 -1.795 -1.101 -2.424a3.829 3.829 0 0 0 -2.567 -0.968Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PlayList5"
);
var PlayList8 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.23458 2.75928c-0.81479 0 -1.4753 0.66051 -1.4753 1.4753v8.29012c0 0.8148 0.66051 1.4753 1.4753 1.4753h8.29012C13.3395 14 14 13.3395 14 12.5247V4.23458c0 -0.81479 -0.6605 -1.4753 -1.4753 -1.4753H4.23458Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.49008 0.029541C0.675288 0.029541 0.0147705 0.690059 0.0147705 1.50485v8.29011c0 0.81484 0.6605175 1.47534 1.4753095 1.47534h8.29011c0.81481 0 1.47531 -0.6605 1.47531 -1.47534V1.50485c0 -0.814791 -0.6605 -1.475309 -1.47531 -1.475309H1.49008Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.78592 7.68962V3.61036c0.00035 -0.06825 0.01875 -0.1352 0.05331 -0.19405 0.03457 -0.05886 0.08408 -0.10753 0.14351 -0.14108 0.05944 -0.03355 0.12669 -0.0508 0.19494 -0.04998 0.06825 0.00081 0.13507 0.01965 0.19369 0.05461l3.49381 2.03019c0.05883 0.03399 0.10767 0.08286 0.14163 0.1417 0.03396 0.05884 0.05184 0.12558 0.05184 0.19352s-0.01788 0.13468 -0.05184 0.19352 -0.0828 0.10771 -0.14163 0.1417L4.37137 8.02012c-0.05862 0.03496 -0.12544 0.0538 -0.19369 0.05461 -0.06825 0.00082 -0.1355 -0.01643 -0.19494 -0.04998 -0.05943 -0.03355 -0.10894 -0.08222 -0.14351 -0.14107 -0.03456 -0.05886 -0.05296 -0.1258 -0.05331 -0.19406Z" }),
    " "
  ] }) }),
  "PlayList8"
);
var PlayList9 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.031 1.924a1 1 0 0 1 1 -1h8.71a1 1 0 0 1 1 1v6.788a1 1 0 0 1 -1 1h-8.71a1 1 0 0 1 -1 -1V1.924Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.258 5.288a1 1 0 0 1 1 -1h8.71a1 1 0 0 1 1 1v6.788a1 1 0 0 1 -1 1h-8.71a1 1 0 0 1 -1 -1V5.288Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.932 6.88a0.5 0.5 0 0 1 0.765 -0.423l2.882 1.801a0.5 0.5 0 0 1 0 0.848l-2.882 1.801a0.5 0.5 0 0 1 -0.765 -0.424V6.881Z" }),
    " "
  ] }) }),
  "PlayList9"
);
var PlayListFolder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.508 6.999a0.75 0.75 0 0 0 -0.75 0.75v2.907a1.675 1.675 0 1 0 1.5 1.666l0 -0.01V8.631c0.242 0.089 0.46 0.22 0.643 0.385 0.355 0.321 0.539 0.741 0.539 1.16a0.75 0.75 0 1 0 1.5 0c0 -0.868 -0.382 -1.683 -1.032 -2.272a3.58 3.58 0 0 0 -2.4 -0.905Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.127 1.056A1.5 1.5 0 0 0 5.183 0.75H1.5A1.5 1.5 0 0 0 0 2.25v9.5a1.5 1.5 0 0 0 1.5 1.5h5.31a2.926 2.926 0 0 1 1.699 -3.649V7.75a2 2 0 0 1 1.999 -2 4.83 4.83 0 0 1 3.239 1.228c0.087 0.08 0.172 0.163 0.253 0.248V4.25a1.5 1.5 0 0 0 -1.5 -1.5H6.89l-0.215 -0.86a1.5 1.5 0 0 0 -0.548 -0.834Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PlayListFolder"
);
var PolaroidFour = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.252 6.497c0.574 0 1.039 -0.465 1.039 -1.039v-4.42A1.04 1.04 0 0 0 5.252 0H1.108C0.535 0 0.07 0.465 0.07 1.039v4.42c0 0.573 0.465 1.038 1.038 1.038h4.144Zm0 7.502a1.04 1.04 0 0 0 1.04 -1.04V8.54a1.04 1.04 0 0 0 -1.04 -1.038H1.108C0.535 7.502 0.07 7.966 0.07 8.54v4.42c0 0.573 0.465 1.038 1.038 1.038h4.144Zm8.609 -1.04c0 0.575 -0.465 1.04 -1.039 1.04H8.678a1.039 1.039 0 0 1 -1.039 -1.04V8.54c0 -0.573 0.465 -1.038 1.039 -1.038h4.144c0.574 0 1.039 0.465 1.039 1.038v4.42Zm-1.039 -6.462c0.574 0 1.039 -0.465 1.039 -1.039v-4.42A1.04 1.04 0 0 0 12.822 0H8.678c-0.574 0 -1.039 0.465 -1.039 1.039v4.42c0 0.573 0.465 1.038 1.039 1.038h4.144Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.252 6.497c0.574 0 1.039 -0.465 1.039 -1.039V4H0.07v1.458c0 0.574 0.465 1.039 1.038 1.039h4.144Zm7.57 0c0.574 0 1.039 -0.465 1.039 -1.039V4H7.639v1.458c0 0.574 0.465 1.039 1.039 1.039h4.144ZM6.291 12.96c0 0.573 -0.465 1.038 -1.039 1.038H1.108A1.039 1.039 0 0 1 0.07 12.96V11.5h6.22v1.459Zm6.531 1.038c0.574 0 1.039 -0.464 1.039 -1.038V11.5H7.639v1.459c0 0.573 0.465 1.038 1.039 1.038h4.144Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PolaroidFour"
);
var RecordingTapeBubbleCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.02 0.736a6.954 6.954 0 0 0 -8.95 9.897l-0.993 2.645a0.5 0.5 0 0 0 0.557 0.667L4.1 13.32A6.953 6.953 0 0 0 10.02 0.736Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.278 6.013a1.037 1.037 0 1 0 0 2.074 1.037 1.037 0 0 0 0 -2.074ZM1.992 7.05a2.287 2.287 0 1 1 4.325 1.037H7.78a2.287 2.287 0 1 1 2.039 1.25h-5.54l-0.007 0A2.287 2.287 0 0 1 1.99 7.05Zm7.826 -1.037a1.037 1.037 0 1 0 0 2.074 1.037 1.037 0 0 0 0 -2.074Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RecordingTapeBubbleCircle"
);
var RecordingTapeBubbleSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v8.919l-0.974 2.923a0.5 0.5 0 0 0 0.595 0.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5 -1.5v-10A1.5 1.5 0 0 0 12.5 0h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.825 5.233a1.037 1.037 0 1 0 0 2.074 1.037 1.037 0 0 0 0 -2.074ZM2.54 6.27a2.287 2.287 0 1 1 4.325 1.037h1.462a2.287 2.287 0 1 1 2.039 1.25h-5.54l-0.007 0a2.287 2.287 0 0 1 -2.28 -2.287Zm7.826 -1.037a1.037 1.037 0 1 0 0 2.074 1.037 1.037 0 0 0 0 -2.074Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RecordingTapeBubbleSquare"
);
var Shuffle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.8536 1.64645c-0.143 -0.143 -0.3581 -0.18578 -0.5449 -0.10839C11.1218 1.61545 11 1.79777 11 2v1H9c-0.29678 0 -0.57823 0.13182 -0.76822 0.35981L3.53163 9H1c-0.552285 0 -1 0.44771 -1 1 0 0.5523 0.447715 1 1 1h3c0.29678 0 0.57823 -0.1318 0.76822 -0.3598L9.46837 5H11v1c0 0.20223 0.1218 0.38455 0.3087 0.46194 0.1868 0.07739 0.4019 0.03461 0.5449 -0.10839l2 -2c0.1952 -0.19526 0.1952 -0.51184 0 -0.7071l-2 -2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1 3c-0.552285 0 -1 0.44772 -1 1s0.447715 1 1 1h2.53163l4.70015 5.6402C8.42177 10.8682 8.70322 11 9 11h2v1c0 0.2022 0.1218 0.3845 0.3087 0.4619 0.1868 0.0774 0.4019 0.0347 0.5449 -0.1083l2 -2c0.1952 -0.1953 0.1952 -0.51189 0 -0.70715l-2 -2c-0.143 -0.143 -0.3581 -0.18578 -0.5449 -0.10839C11.1218 7.61545 11 7.79777 11 8v1H9.46837L4.76822 3.35982C4.57823 3.13182 4.29678 3 4 3H1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shuffle"
);
var SongRecommendation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.001 6.09a1.75 1.75 0 0 1 -1.29 1.318v2.394a2.09 2.09 0 1 0 -0.59 4.095 2.09 2.09 0 0 0 2.09 -2.107V7.87l5.164 -1.435v1.451a2.09 2.09 0 1 0 -0.59 4.095 2.09 2.09 0 0 0 2.09 -2.037V5.45l0 -1.31 0 -0.002v-0.02a1.12 1.12 0 0 0 -1.412 -1.057l-0.005 0.002 -3.417 0.948a1.75 1.75 0 0 1 -0.942 0.83l-0.022 0.009a4.903 4.903 0 0 0 -0.452 0.202 2.967 2.967 0 0 0 -0.327 0.187l-0.014 0.01 -0.036 0.076a3.674 3.674 0 0 0 -0.127 0.341 5.819 5.819 0 0 0 -0.115 0.407L7 6.09l0 -0.002Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.818 0.444a0.587 0.587 0 0 1 0.475 -0.253c0.263 0 0.416 0.17 0.476 0.253a0.997 0.997 0 0 1 0.125 0.25c0.043 0.12 0.08 0.275 0.113 0.411l0.012 0.05c0.085 0.346 0.167 0.627 0.284 0.786a0.91 0.91 0 0 0 0.261 0.205c0.138 0.082 0.301 0.157 0.472 0.231l0.126 0.054c0.125 0.053 0.256 0.109 0.356 0.159 0.068 0.033 0.155 0.08 0.23 0.14a0.604 0.604 0 0 1 0.242 0.47c0 0.274 -0.194 0.43 -0.241 0.468 -0.076 0.06 -0.163 0.107 -0.231 0.141 -0.1 0.05 -0.231 0.106 -0.355 0.159l-0.127 0.054a4.31 4.31 0 0 0 -0.472 0.23 0.91 0.91 0 0 0 -0.26 0.206c-0.118 0.159 -0.2 0.44 -0.285 0.786l-0.012 0.05a4.54 4.54 0 0 1 -0.113 0.41 0.997 0.997 0 0 1 -0.125 0.25 0.587 0.587 0 0 1 -0.476 0.254 0.587 0.587 0 0 1 -0.475 -0.253 0.997 0.997 0 0 1 -0.125 -0.25 4.541 4.541 0 0 1 -0.113 -0.412l-0.013 -0.05c-0.084 -0.345 -0.166 -0.626 -0.283 -0.785a0.91 0.91 0 0 0 -0.261 -0.205 4.311 4.311 0 0 0 -0.473 -0.231l-0.126 -0.054a7.119 7.119 0 0 1 -0.355 -0.159 1.316 1.316 0 0 1 -0.23 -0.14 0.604 0.604 0 0 1 -0.242 -0.47c0 -0.274 0.194 -0.43 0.241 -0.468 0.076 -0.06 0.163 -0.108 0.23 -0.141 0.101 -0.05 0.232 -0.106 0.356 -0.159l0.126 -0.054c0.172 -0.074 0.334 -0.149 0.473 -0.23a0.91 0.91 0 0 0 0.26 -0.206c0.118 -0.159 0.2 -0.44 0.284 -0.786l0.013 -0.05c0.033 -0.136 0.07 -0.29 0.113 -0.41a0.997 0.997 0 0 1 0.125 -0.251ZM1.963 5.899a0.75 0.75 0 0 1 0.75 0.75v0.384h0.384a0.75 0.75 0 1 1 0 1.5h-0.384v0.384a0.75 0.75 0 0 1 -1.5 0v-0.384H0.829a0.75 0.75 0 1 1 0 -1.5h0.384V6.65a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SongRecommendation"
);
var TapeCassetteRecord = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.49994 1.5C0.671512 1.5 -0.0000610352 2.17157 -0.0000610352 3v8c0 0.8284 0.6715730352 1.5 1.5000010352 1.5H12.4999c0.8285 0 1.5 -0.6716 1.5 -1.5V3c0 -0.82843 -0.6715 -1.5 -1.5 -1.5H1.49994Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.74994 4c-0.9665 0 -1.75 0.7835 -1.75 1.75s0.7835 1.75 1.75 1.75h6.49996c0.9665 0 1.75 -0.7835 1.75 -1.75S11.2164 4 10.2499 4H3.74994Zm-0.75 1.75c0 -0.41421 0.33579 -0.75 0.75 -0.75h0.91478c0.1909 0.16898 0.3161 0.4088 0.33522 0.67779v0.14431c-0.01912 0.26905 -0.14437 0.50891 -0.33534 0.6779h-0.91466c-0.41421 0 -0.75 -0.33579 -0.75 -0.75Zm6 0.0721c0.01912 0.26905 0.14437 0.50891 0.33534 0.6779h0.91462c0.4143 0 0.75 -0.33579 0.75 -0.75s-0.3357 -0.75 -0.75 -0.75h-0.91474c-0.19091 0.16898 -0.31611 0.4088 -0.33522 0.67779v0.14431Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.86021 9.50439c-0.17499 0 -0.33235 0.10654 -0.39734 0.26902l-0.8559 2.13979c-0.05274 0.1318 -0.03665 0.2812 0.04297 0.3988 0.07961 0.1176 0.21236 0.1881 0.35437 0.1881h5.99133c0.14196 0 0.27476 -0.0705 0.35436 -0.1881s0.0957 -0.267 0.043 -0.3988l-0.85592 -2.13979c-0.06499 -0.16248 -0.22235 -0.26902 -0.39734 -0.26902H4.86021Z" }),
    " "
  ] }) }),
  "TapeCassetteRecord"
);
var VoiceMailOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 6.763a0.75 0.75 0 1 0 -1.5 0 5.25 5.25 0 0 0 5 5.245v1.212a0.75 0.75 0 0 0 1.5 0v-1.213a5.25 5.25 0 0 0 5 -5.244 0.75 0.75 0 0 0 -1.5 0 3.75 3.75 0 0 1 -3.75 3.75h-0.486l-0.014 0 -0.014 0H6.25a3.75 3.75 0 0 1 -3.75 -3.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.75 0a2.946 2.946 0 0 0 -2.946 2.946v3.425a2.946 2.946 0 1 0 5.892 0V2.946A2.946 2.946 0 0 0 6.75 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VoiceMailOff"
);
var VoiceMail = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.75 0a2.946 2.946 0 0 0 -2.946 2.946v3.425a2.946 2.946 0 1 0 5.892 0V2.946A2.946 2.946 0 0 0 6.75 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.5 6.763a0.75 0.75 0 1 0 -1.5 0 5.25 5.25 0 0 0 5 5.245v1.212a0.75 0.75 0 0 0 1.5 0v-1.213a5.25 5.25 0 0 0 5 -5.244 0.75 0.75 0 0 0 -1.5 0 3.75 3.75 0 0 1 -3.75 3.75h-0.486l-0.014 0 -0.014 0H6.25a3.75 3.75 0 0 1 -3.75 -3.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VoiceMail"
);
var VolumeDown = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.063 7a0.75 0.75 0 0 1 0.75 -0.75h2.376a0.75 0.75 0 0 1 0 1.5h-2.377a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.716 1.779A1.454 1.454 0 0 1 9 3.005v8.006c-0.026 1.186 -1.403 1.882 -2.374 1.21l-0.008 -0.005L2.84 9.5H1.5C0.68 9.5 0 8.82 0 8V6c0 -0.82 0.68 -1.5 1.5 -1.5h1.342l3.87 -2.72 0.003 -0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeDown"
);
var VolumeLevelHigh = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.797 3.513a0.75 0.75 0 0 0 -1.156 0.956c0.566 0.684 0.831 1.53 0.831 2.531 0 1.002 -0.265 1.847 -0.83 2.53a0.75 0.75 0 1 0 1.155 0.957c0.83 -1.003 1.175 -2.207 1.175 -3.487 0 -1.28 -0.346 -2.484 -1.175 -3.487Zm-1.6 2.137a0.75 0.75 0 0 0 -1.358 0.635c0.098 0.21 0.145 0.444 0.134 0.68a0.751 0.751 0 0 0 0 0.07 1.44 1.44 0 0 1 -0.134 0.68 0.75 0.75 0 1 0 1.358 0.635A2.94 2.94 0 0 0 11.473 7a2.94 2.94 0 0 0 -0.276 -1.35Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.716 1.779A1.454 1.454 0 0 1 9 3.005v8.006c-0.026 1.186 -1.403 1.882 -2.374 1.21l-0.008 -0.005L2.84 9.5H1.5C0.68 9.5 0 8.82 0 8V6c0 -0.82 0.68 -1.5 1.5 -1.5h1.342l3.87 -2.72 0.003 -0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeLevelHigh"
);
var VolumeLevelLow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.3577 4.9221c0.3191 -0.26401 0.7919 -0.21928 1.0559 0.09989 0.4591 0.55505 0.6982 1.25899 0.6727 1.97803 0.0255 0.71904 -0.2136 1.42298 -0.6727 1.97803 -0.264 0.31917 -0.7368 0.3639 -1.0559 0.09989 -0.3192 -0.26401 -0.36394 -0.73677 -0.0999 -1.05595 0.2286 -0.27635 0.3458 -0.62806 0.3287 -0.9863 -0.0011 -0.02377 -0.0011 -0.04757 0 -0.07134 0.0171 -0.35824 -0.1001 -0.70995 -0.3287 -0.9863 -0.26404 -0.31918 -0.2193 -0.79194 0.0999 -1.05595Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.71551 1.77885C7.69756 1.09936 9.02347 1.81466 9 3.0054v8.0057l-0.00012 0c-0.02634 1.1862 -1.40299 1.8822 -2.37437 1.2101l-0.00735 -0.0051 0.00004 -0.0001 -3.77923 -2.71596H1.5c-0.820809 0 -1.5 -0.67919 -1.5 -1.5v-2c0 -0.82081 0.679191 -1.5 1.5 -1.5h1.34193l3.87065 -2.71915 0.00292 -0.00205 0.00001 0.00001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeLevelLow"
);
var VolumeLevelOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.716 1.779A1.454 1.454 0 0 1 9 3.005v8.006c-0.026 1.186 -1.403 1.882 -2.374 1.21l-0.008 -0.005L2.84 9.5H1.5C0.68 9.5 0 8.82 0 8V6c0 -0.82 0.68 -1.5 1.5 -1.5h1.342l3.87 -2.72 0.003 -0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeLevelOff"
);
var VolumeMute = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.78 6.155a0.75 0.75 0 0 0 -1.06 -1.06l-0.845 0.844 -0.845 -0.844a0.75 0.75 0 1 0 -1.06 1.06l0.844 0.845 -0.844 0.845a0.75 0.75 0 0 0 1.06 1.06l0.845 -0.844 0.845 0.844a0.75 0.75 0 1 0 1.06 -1.06L12.936 7l0.844 -0.845Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.716 1.779A1.454 1.454 0 0 1 9 3.005v8.006c-0.026 1.186 -1.403 1.882 -2.374 1.21l-0.008 -0.005L2.84 9.5H1.5C0.68 9.5 0 8.82 0 8V6c0 -0.82 0.68 -1.5 1.5 -1.5h1.342l3.87 -2.72 0.003 -0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeMute"
);
var VolumeOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.716 1.578A1.454 1.454 0 0 1 11 2.805v8.005c-0.027 1.186 -1.403 1.883 -2.374 1.21l-0.008 -0.005L4.84 9.3H3.5C2.68 9.3 2 8.62 2 7.8v-2c0 -0.82 0.68 -1.5 1.5 -1.5h1.342l3.87 -2.719 0.004 -0.002Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VolumeOff"
);
var BackCamera1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.731 0c-0.405 0 -0.778 0.147 -1.047 0.432 -0.267 0.283 -0.395 0.663 -0.395 1.068v11c0 0.405 0.128 0.785 0.395 1.068 0.27 0.286 0.642 0.432 1.047 0.432h6.538a1.41 1.41 0 0 0 1.047 -0.432c0.267 -0.283 0.395 -0.663 0.395 -1.068v-11c0 -0.405 -0.128 -0.785 -0.395 -1.068A1.412 1.412 0 0 0 10.27 0H3.731Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6 3a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" }),
    " "
  ] }) }),
  "BackCamera1"
);
var BatteryAlert1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.5 5.5A0.5 0.5 0 0 0 13 5h-0.5V3.5a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V9h0.5a0.5 0.5 0 0 0 0.5 -0.5v-3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.125 4.5a0.625 0.625 0 1 0 -1.25 0V7a0.625 0.625 0 1 0 1.25 0V4.5Zm0.125 4.75a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryAlert1"
);
var BatteryCharging = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.5 5.5A0.5 0.5 0 0 0 13 5h-0.5V3.5a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V9h0.5a0.5 0.5 0 0 0 0.5 -0.5v-3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.361 4.28a0.625 0.625 0 0 1 0.13 0.875l-0.919 1.243H7.5a0.625 0.625 0 0 1 0.546 0.928l-1.182 2.13A0.625 0.625 0 1 1 5.77 8.85l0.667 -1.202H5.332a0.625 0.625 0 0 1 -0.503 -0.997l1.658 -2.24a0.625 0.625 0 0 1 0.874 -0.13Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryCharging"
);
var BatteryEmpty1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h10a1.5 1.5 0 0 0 1.5 -1.5v-1a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1v-1A1.5 1.5 0 0 0 11.5 2h-10Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryEmpty1"
);
var BatteryEmpty2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.5 5.5A0.5 0.5 0 0 0 13 5h-0.5V3.5a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V9h0.5a0.5 0.5 0 0 0 0.5 -0.5v-3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.219 0.219a0.75 0.75 0 0 0 0 1.06L12.72 13.782a0.75 0.75 0 0 0 1.061 -1.06L1.28 0.218a0.75 0.75 0 0 0 -1.061 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryEmpty2"
);
var BatteryFull1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h10a1.5 1.5 0 0 0 1.5 -1.5v-1a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1v-1A1.5 1.5 0 0 0 11.5 2h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.75 4.375c0.345 0 0.625 0.28 0.625 0.625v4a0.625 0.625 0 1 1 -1.25 0V5c0 -0.345 0.28 -0.625 0.625 -0.625Zm3.5 0c0.345 0 0.625 0.28 0.625 0.625v4a0.625 0.625 0 1 1 -1.25 0V5c0 -0.345 0.28 -0.625 0.625 -0.625ZM10.375 5a0.625 0.625 0 1 0 -1.25 0v4a0.625 0.625 0 1 0 1.25 0V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryFull1"
);
var BatteryLow1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h10a1.5 1.5 0 0 0 1.5 -1.5v-1a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1v-1A1.5 1.5 0 0 0 11.5 2h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.75 4.375c0.345 0 0.625 0.28 0.625 0.625v4a0.625 0.625 0 1 1 -1.25 0V5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryLow1"
);
var BatteryMedium1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h10a1.5 1.5 0 0 0 1.5 -1.5v-1a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1v-1A1.5 1.5 0 0 0 11.5 2h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.375 5a0.625 0.625 0 1 0 -1.25 0v4a0.625 0.625 0 1 0 1.25 0V5Zm3.5 0a0.625 0.625 0 1 0 -1.25 0v4a0.625 0.625 0 1 0 1.25 0V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BatteryMedium1"
);
var Camera1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 1.5a0.5 0.5 0 0 0 -0.4 0.2L3.25 3.5H1.5A1.5 1.5 0 0 0 0 5v6a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 11V5a1.5 1.5 0 0 0 -1.5 -1.5h-1.75L9.4 1.7a0.5 0.5 0 0 0 -0.4 -0.2H5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 10.173A2.461 2.461 0 1 0 7 5.25a2.461 2.461 0 0 0 0 4.923Z" }),
    " "
  ] }) }),
  "Camera1"
);
var CameraDisabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.5 5a1 1 0 0 0 -1 -1h-2L9 2H5L3.5 4h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h11a1 1 0 0 0 1 -1V5ZM7 9.75a2.266 2.266 0 1 0 0 -4.531A2.266 2.266 0 0 0 7 9.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.219 0.219a0.75 0.75 0 0 0 0 1.06L12.72 13.782a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.218a0.75 0.75 0 0 0 -1.061 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CameraDisabled"
);
var CameraLoading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5 1.5a0.5 0.5 0 0 0 -0.4 0.2L3.25 3.5H1.5A1.5 1.5 0 0 0 0 5v6a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 11V5a1.5 1.5 0 0 0 -1.5 -1.5h-1.75L9.4 1.7a0.5 0.5 0 0 0 -0.4 -0.2H5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.05 7.75a0.758 0.758 0 1 1 -1.516 0 0.758 0.758 0 0 1 1.516 0Zm2.596 0a0.758 0.758 0 1 1 -1.516 0 0.758 0.758 0 0 1 1.516 0Zm2.104 0.758a0.758 0.758 0 1 0 0 -1.516 0.758 0.758 0 0 0 0 1.516Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CameraLoading"
);
var CameraSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.504 5.46c0.205 0.204 0.32 0.482 0.32 0.772v2.731a1.092 1.092 0 0 1 -1.092 1.093H4.268a1.093 1.093 0 0 1 -1.092 -1.093V6.232a1.093 1.093 0 0 1 1.092 -1.093h0.547L5.907 3.5h2.186l1.092 1.639h0.547c0.29 0 0.567 0.115 0.772 0.32ZM5.81 7.47a1.191 1.191 0 1 1 2.382 0 1.191 1.191 0 0 1 -2.382 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CameraSquare"
);
var CameraVideo = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.52361 7.99707c-0.89014 0 -1.61174 0.7216 -1.61174 1.61175v2.77938c0 0.8901 0.7216 1.6117 1.61174 1.6117h6.11463c0.89016 0 1.61176 -0.7216 1.61176 -1.6117V9.60882c0 -0.89015 -0.7216 -1.61175 -1.61176 -1.61175H3.52361Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0C1.567 0 0 1.567 0 3.5S1.567 7 3.5 7 7 5.433 7 3.5 5.433 0 3.5 0Zm7 2C9.11929 2 8 3.11929 8 4.5S9.11929 7 10.5 7C11.8807 7 13 5.88071 13 4.5S11.8807 2 10.5 2Zm3.3782 7.74854c0 -0.41422 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33578 -0.75 0.75v2.49996c0 0.4142 0.3358 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75V9.74854Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CameraVideo"
);
var ComputerPcDesktop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.955a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1H8c-0.042 0 -0.084 -0.002 -0.125 -0.007a1.996 1.996 0 0 0 0.104 -0.99 2.75 2.75 0 0 0 2.271 -2.708v-4A2.75 2.75 0 0 0 7.5 3.5H7v-0.545Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13 1.612a1 1 0 0 1 1 1v4.625l-3.75 0V6.25A2.75 2.75 0 0 0 7.5 3.5H7v-0.888a1 1 0 0 1 1 -1h5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.14 3.799a0.766 0.766 0 1 0 1.532 0 0.766 0.766 0 1 0 -1.532 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 11.75h1.5v0.75H6A0.75 0.75 0 0 1 6 14H3a0.75 0.75 0 0 1 0 -1.5h0.75v-0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 4.75A1.5 1.5 0 0 0 0 6.25v4a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5 -1.5v-4a1.5 1.5 0 0 0 -1.5 -1.5h-6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ComputerPcDesktop"
);
var DesktopChat = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.429 4.648a1 1 0 0 0 1 1h2.214v1.208a0.5 0.5 0 0 0 0.777 0.416l2.437 -1.624H13a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H6.429a1 1 0 0 0 -1 1v3.648Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.429 6.898h0.964c0.03 1.372 1.57 2.182 2.72 1.414l2.123 -1.414H13c0.36 0 0.699 -0.085 1 -0.234v2.88c0 0.804 -0.652 1.456 -1.457 1.456H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h2.777a2.28 2.28 0 0 0 -0.055 0.5v3.648a2.25 2.25 0 0 0 2.25 2.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopChat"
);
var DesktopCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.748 0.19a0.75 0.75 0 0 1 0.063 1.058l-4 4.5A0.75 0.75 0 0 1 8.8 5.85l-2 -1.5a0.75 0.75 0 0 1 0.9 -1.2l1.448 1.086L12.69 0.252a0.75 0.75 0 0 1 1.058 -0.063Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.796 0.5h-9.34C0.653 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V2.917l-3.255 3.662a2 2 0 0 1 -2.695 0.271l-2 -1.5a2 2 0 1 1 2.4 -3.2l0.528 0.396L10.796 0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopCheck"
);
var DesktopDelete = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.78 1.28A0.75 0.75 0 0 0 12.72 0.22L11 1.94 9.28 0.22a0.75 0.75 0 1 0 -1.06 1.06L9.94 3 8.22 4.72a0.75 0.75 0 0 0 1.06 1.06L11 4.06l1.72 1.72a0.75 0.75 0 1 0 1.06 -1.06L12.06 3l1.72 -1.72Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.766 0.5h-5.31C0.653 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V7.105a2 2 0 0 1 -2.164 -0.44L11 5.827l-0.836 0.836a2 2 0 1 1 -2.828 -2.828L8.172 3l-0.836 -0.836A1.997 1.997 0 0 1 6.766 0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopDelete"
);
var DesktopFavoriteStar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m10.819 0.166 0.846 1.713a0.3 0.3 0 0 0 0.19 0.19l1.894 0.274a0.292 0.292 0 0 1 0.16 0.5l-1.352 1.352a0.314 0.314 0 0 0 -0.082 0.258l0.33 1.837a0.293 0.293 0 0 1 -0.423 0.31l-1.692 -0.888a0.278 0.278 0 0 0 -0.269 0L8.73 6.6a0.292 0.292 0 0 1 -0.423 -0.31l0.325 -1.883a0.314 0.314 0 0 0 -0.083 -0.258L7.196 2.797a0.292 0.292 0 0 1 0.14 -0.48l1.893 -0.273a0.299 0.299 0 0 0 0.217 -0.165l0.846 -1.713a0.292 0.292 0 0 1 0.527 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m8.733 0.5 -0.188 0.38 -1.388 0.2a1.542 1.542 0 0 0 -0.845 2.6l1.003 1.003 -0.24 1.393a1.542 1.542 0 0 0 2.234 1.63l1.246 -0.653 1.246 0.653a1.545 1.545 0 0 0 1.627 -0.12 1.542 1.542 0 0 0 0.572 -0.82v2.777c0 0.805 -0.652 1.457 -1.457 1.457H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h7.276Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopFavoriteStar"
);
var DesktopHelp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.813 1.516a0.853 0.853 0 0 0 -1.019 0.837 0.75 0.75 0 0 1 -1.5 0 2.353 2.353 0 1 1 3.103 2.23v0.174a0.75 0.75 0 1 1 -1.5 0v-0.801a0.75 0.75 0 0 1 0.75 -0.75 0.853 0.853 0 0 0 0.166 -1.69Zm-0.166 6.37a0.875 0.875 0 0 1 0 -1.75 0.875 0.875 0 1 1 0 1.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.647 4.314v0.443c0 0.37 0.1 0.716 0.275 1.013a2.125 2.125 0 1 0 3.45 0 1.99 1.99 0 0 0 0.162 -0.348 3.63 3.63 0 0 0 0.466 -0.34v4.461c0 0.805 -0.652 1.457 -1.457 1.457H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h7.1a3.603 3.603 0 0 0 -0.513 1.853 2 2 0 0 0 1.603 1.96Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopHelp"
);
var Earpods = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.46 0.707a3.146 3.146 0 0 0 -1.742 -0.523 3.146 3.146 0 0 0 -3.145 3.145v9.217a1.31 1.31 0 0 0 2.621 0V6.475c0.174 0.016 0.35 0.016 0.524 0 0.623 0 1.229 -0.183 1.742 -0.524 0.238 -0.157 0.355 -0.436 0.355 -0.721V1.428c0 -0.285 -0.117 -0.564 -0.354 -0.722ZM0.54 0.707A3.146 3.146 0 0 1 2.281 0.184a3.146 3.146 0 0 1 3.145 3.145v9.217a1.31 1.31 0 0 1 -2.621 0V6.475c-0.174 0.016 -0.35 0.016 -0.524 0A3.146 3.146 0 0 1 0.539 5.95c-0.237 -0.156 -0.354 -0.435 -0.354 -0.72V1.429c0 -0.285 0.117 -0.564 0.354 -0.722Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Earpods"
);
var ElectricCord1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.25 0.813a0.75 0.75 0 0 0 -1.5 0V3.53h1.5V0.812Zm5 2.718h-1.5V0.812a0.75 0.75 0 0 1 1.5 0v2.72Zm-4 7h1.5v2.688a0.75 0.75 0 0 1 -1.5 0l0 -2.688Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M9 10.531H5a3 3 0 0 1 -3 -3v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3a3 3 0 0 1 -3 3Z" }),
    " "
  ] }) }),
  "ElectricCord1"
);
var ElectricCord3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.533a5.5 5.5 0 0 0 -2.75 10.265 0.75 0.75 0 0 1 -0.75 1.299 7 7 0 1 1 4.615 0.849c-1.083 0.172 -1.865 -0.735 -1.865 -1.663v-1.452a3.642 3.642 0 0 0 1.5 0v1.452c0 0.073 0.03 0.128 0.06 0.158 0.015 0.013 0.027 0.02 0.035 0.022a0.066 0.066 0 0 0 0.032 0A5.502 5.502 0 0 0 7 1.534Zm2.313 3.448V3.815a0.75 0.75 0 1 0 -1.5 0V4.98h1.5Zm-3.126 0V3.815a0.75 0.75 0 1 0 -1.5 0V4.98h1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.123 4.981a0.75 0.75 0 0 0 -0.75 0.75v1.55a3.628 3.628 0 1 0 7.255 0V5.73a0.75 0.75 0 0 0 -0.75 -0.75H4.123Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ElectricCord3"
);
var FireAlarm2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.311 4.28c-0.227 -0.097 -0.432 0.13 -0.335 0.291 0.341 0.594 0.568 1.246 0.67 1.922 0.14 0.955 0 2.002 -0.616 2.775a0.26 0.26 0 0 1 -0.194 0.097 0.26 0.26 0 0 1 -0.205 -0.086c-0.279 -0.288 -0.567 -0.58 -0.756 -0.94 -0.054 -0.107 -0.248 -0.28 -0.529 0 -0.678 0.559 -1.09 1.416 -1.004 2.29 0.035 1.935 1.746 3.348 3.62 3.371 1.912 0.023 3.599 -1.393 3.614 -3.371a6.208 6.208 0 0 0 -1.08 -3.499 7.699 7.699 0 0 0 -3.185 -2.85Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.548 0.75a0.75 0.75 0 0 0 -0.75 -0.75A4.748 4.748 0 0 0 0.051 4.747a0.75 0.75 0 1 0 1.5 0A3.247 3.247 0 0 1 4.798 1.5a0.75 0.75 0 0 0 0.75 -0.75ZM9.202 0a0.75 0.75 0 0 0 0 1.5 3.247 3.247 0 0 1 3.247 3.247 0.75 0.75 0 0 0 1.5 0A4.748 4.748 0 0 0 9.202 0Zm0 2.498a0.75 0.75 0 0 0 0 1.5 0.75 0.75 0 0 1 0.75 0.75 0.75 0.75 0 1 0 1.5 0 2.25 2.25 0 0 0 -2.25 -2.25Zm-4.404 0a0.75 0.75 0 1 1 0 1.5 0.75 0.75 0 0 0 -0.75 0.75 0.75 0.75 0 1 1 -1.5 0 2.25 2.25 0 0 1 2.25 -2.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FireAlarm2"
);
var FireExtinguisherSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.26562 4.5c0 -0.75939 0.61561 -1.375 1.375 -1.375H4.875V4.5c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625V3.125H9.5c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H2.64062C1.19088 1.875 0.015625 3.05025 0.015625 4.5v2c0 0.34518 0.279822 0.625 0.625 0.625s0.624995 -0.27982 0.624995 -0.625v-2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.7575 0.170243C13.3886 0.012456 14 0.489814 14 1.14039v2.71922c0 0.65057 -0.6114 1.12793 -1.2425 0.97014l-3.00004 -0.75C9.3123 3.96846 9 3.56848 9 3.10961V1.89039c0 -0.45887 0.3123 -0.85886 0.75746 -0.970147l3.00004 -0.75ZM2 7.5C2 5.567 3.567 4 5.5 4S9 5.567 9 7.5v5c0 0.8284 -0.67157 1.5 -1.5 1.5h-4c-0.82843 0 -1.5 -0.6716 -1.5 -1.5v-5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6 8h3v3H6c-0.55228 0 -1 -0.4477 -1 -1V9c0 -0.55228 0.44772 -1 1 -1Z" }),
    " "
  ] }) }),
  "FireExtinguisherSign"
);
var FloppyDisk = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m4.91 0 -0.002 0a1.5 1.5 0 0 0 -1.05 0.435l-0.002 0.001 -3.42 3.42 -0.001 0.002A1.5 1.5 0 0 0 0 4.908V12.5A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0L4.91 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.241 14V9a0.46 0.46 0 0 0 -0.177 -0.354 0.677 0.677 0 0 0 -0.429 -0.146h-7.27a0.677 0.677 0 0 0 -0.429 0.146A0.46 0.46 0 0 0 2.76 9v5" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.241 0v3.5a0.47 0.47 0 0 1 -0.168 0.354 0.62 0.62 0 0 1 -0.406 0.146H6.074a0.62 0.62 0 0 1 -0.406 -0.146A0.47 0.47 0 0 1 5.5 3.5V0" }),
    " "
  ] }) }),
  "FloppyDisk"
);
var FrontCamera = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 1a0.5 0.5 0 0 0 -0.4 0.2L3.25 3H1.5A1.5 1.5 0 0 0 0 4.5v7A1.5 1.5 0 0 0 1.5 13h11a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 12.5 3h-1.75L9.4 1.2A0.5 0.5 0 0 0 9 1H5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 6.25a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0ZM4.117 8.412a0.625 0.625 0 0 1 0.884 0.007c0.358 0.365 1.039 0.742 1.997 0.742 0.96 0 1.64 -0.377 1.998 -0.742a0.625 0.625 0 1 1 0.891 0.877c-0.594 0.604 -1.596 1.115 -2.889 1.115 -1.292 0 -2.294 -0.51 -2.888 -1.115a0.625 0.625 0 0 1 0.007 -0.884ZM9.25 7a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FrontCamera"
);
var Gramophone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.236328 8c0 -0.41421 0.335787 -0.75 0.75 -0.75l5.513652 0c0.41421 0 0.75 0.33579 0.75 0.75s-0.33579 0.75 -0.75 0.75l-5.513652 0c-0.414214 0 -0.75 -0.33579 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.2168 10H1.5c-0.39783 0 -0.779356 0.158 -1.06066 0.4393C0.158035 10.7206 0 11.1022 0 11.5v1c0 0.3978 0.158035 0.7794 0.43934 1.0607C0.720644 13.842 1.10217 14 1.5 14h11c0.3978 0 0.7794 -0.158 1.0607 -0.4393S14 12.8978 14 12.5v-2c0 -0.1692 -0.0018 -0.3359 -0.0052 -0.5h-2.778Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.12629 0.16784c0.1502 -0.16897449 0.3951 -0.2161377 0.59731 -0.1150313l0.00158 0.0007944 0.00022 0.0001076 0.00173 0.000879 0.01926 0.0100407c0.25067 0.1334136 0.48131 0.3076506 0.69871 0.4887816 0.4089 0.340743 0.9421 0.876068 1.4709 1.669258C12.9328 3.74781 13.9152 6.19909 13.9948 10h-2.7781c-0.2598 -1.32816 -1.0436 -2.39682 -2.04703 -3.16556 -1.14408 -0.87647 -2.53882 -1.33442 -3.66968 -1.33442 -0.19689 0 -0.37546 -0.11555 -0.45612 -0.29517 -0.08066 -0.17962 -0.04839 -0.38985 0.08242 -0.53701l4 -4.5Z" }),
    " "
  ] }) }),
  "Gramophone"
);
var HardDisk = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.99 1.897A3.875 3.875 0 0 0 4 8.237l0.882 -1.387c0.298 -0.468 0.76 -0.768 1.284 -0.843 0.49 -0.071 0.946 0.064 1.293 0.285 0.348 0.221 0.664 0.578 0.807 1.051a1.825 1.825 0 0 1 -0.22 1.52l-0.471 0.74a3.876 3.876 0 0 0 -0.585 -7.706Zm-0.744 5.374a0.624 0.624 0 0 1 0.745 0.921l-1.75 2.75a0.625 0.625 0 0 1 -1.054 -0.67l1.75 -2.75a0.574 0.574 0 0 1 0.401 -0.277 0.628 0.628 0 0 0 -0.092 0.026Zm0.826 0.44a0.623 0.623 0 0 1 -0.08 0.481 0.577 0.577 0 0 0 0.08 -0.48Zm0.177 3.895c0 -0.345 0.28 -0.625 0.625 -0.625h2.5a0.625 0.625 0 0 1 0 1.25h-2.5a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HardDisk"
);
var HardDrive1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.647 0.317A1.5 1.5 0 0 0 10.694 0H3.3l-0.003 0a1.5 1.5 0 0 0 -1.452 1.158L0.018 7.868A0.5 0.5 0 0 0 0 8v0.5a0.5 0.5 0 0 0 0.5 0.5h13a0.5 0.5 0 0 0 0.5 -0.5V8a0.5 0.5 0 0 0 -0.017 -0.13l-1.798 -6.71a1.5 1.5 0 0 0 -0.538 -0.843Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.923 7.27H1.077C0.482 7.27 0 7.75 0 8.345v4.308c0 0.595 0.482 1.077 1.077 1.077h11.846c0.595 0 1.077 -0.482 1.077 -1.077V8.346c0 -0.595 -0.482 -1.077 -1.077 -1.077Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.503 10.5a0.997 0.997 0 1 1 1.994 0 0.997 0.997 0 0 1 -1.994 0ZM3.5 9.875a0.625 0.625 0 1 0 0 1.25h3a0.625 0.625 0 1 0 0 -1.25h-3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HardDrive1"
);
var KeyboardVirtual = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0.203c-0.79 0 -1.5 0.6 -1.5 1.422v5.531c0 0.823 0.71 1.422 1.5 1.422h11c0.79 0 1.5 -0.599 1.5 -1.422V1.625c0 -0.823 -0.71 -1.422 -1.5 -1.422h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 3.047a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 1 1 0 1h-1a0.5 0.5 0 0 1 -0.5 -0.5Zm0.5 2a0.5 0.5 0 1 0 0 1h1a0.5 0.5 0 0 0 0 -1h-1Zm8 0a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 0 0 0 -1h-1Zm-5 0a0.5 0.5 0 1 0 0 1h3a0.5 0.5 0 0 0 0 -1h-3Zm-0.333 -2.5a0.5 0.5 0 1 0 0 1h1a0.5 0.5 0 0 0 0 -1h-1Zm2.166 0.5a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 1 1 0 1h-1a0.5 0.5 0 0 1 -0.5 -0.5Zm3.167 -0.5a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 0 0 0 -1h-1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 10.797a0.5 0.5 0 0 0 -0.354 0.853l2 2a0.5 0.5 0 0 0 0.708 0l2 -2A0.5 0.5 0 0 0 9 10.797H5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "KeyboardVirtual"
);
var KeyboardWireless2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.078a9.75 9.75 0 0 0 -3.792 0.767 0.75 0.75 0 1 0 0.584 1.382 8.25 8.25 0 0 1 6.416 0 0.75 0.75 0 1 0 0.584 -1.382A9.75 9.75 0 0 0 7 0.078Zm2.441 2.847a7.53 7.53 0 0 0 -4.842 0 0.75 0.75 0 0 0 0.482 1.42 6.03 6.03 0 0 1 3.878 0 0.75 0.75 0 0 0 0.482 -1.42Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 5.547c-0.79 0 -1.5 0.6 -1.5 1.422v5.532c0 0.822 0.71 1.421 1.5 1.421h11c0.79 0 1.5 -0.599 1.5 -1.421V6.969c0 -0.823 -0.71 -1.422 -1.5 -1.422h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 8.391a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0 1h-1a0.5 0.5 0 0 1 -0.5 -0.5Zm0.5 2a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 1 0 0 -1h-1Zm8 0a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 1 0 0 -1h-1Zm-5 0a0.5 0.5 0 0 0 0 1h3a0.5 0.5 0 1 0 0 -1h-3Zm-0.333 -2.5a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 1 0 0 -1h-1Zm2.166 0.5a0.5 0.5 0 0 1 0.5 -0.5h1a0.5 0.5 0 0 1 0 1h-1a0.5 0.5 0 0 1 -0.5 -0.5Zm3.167 -0.5a0.5 0.5 0 0 0 0 1h1a0.5 0.5 0 0 0 0 -1h-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "KeyboardWireless2"
);
var Keyboard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.5 0.0547485c0.4142 0 0.75 0.3357865 0.75 0.7500005 0 0.712781 -0.302 1.386051 -0.8224 1.874751 -0.5188 0.48719 -1.2129 0.75335 -1.9276 0.75335h-4c-0.34621 0 -0.66948 0.12959 -0.90081 0.34681 -0.22972 0.21572 -0.34919 0.49786 -0.34919 0.78129V5.5c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-0.93905c0 -0.71278 0.30196 -1.38605 0.82238 -1.87475C4.0912 2.199 4.78534 1.93285 5.5 1.93285h4c0.34621 0 0.6695 -0.12959 0.9008 -0.34681 0.2297 -0.21573 0.3492 -0.49786 0.3492 -0.781291 0 -0.414214 0.3358 -0.7500005 0.75 -0.7500005Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 5C0.671573 5 0 5.67157 0 6.5v6c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5v-6c0 -0.82843 -0.6716 -1.5 -1.5 -1.5h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.59778 8.15622c0 -0.27614 0.22386 -0.5 0.5 -0.5h1.08939c0.27614 0 0.5 0.22386 0.5 0.5s-0.22386 0.5 -0.5 0.5H2.09778c-0.27614 0 -0.5 -0.22386 -0.5 -0.5Zm0.5 2.18758c-0.27614 0 -0.5 0.2239 -0.5 0.5s0.22386 0.5 0.5 0.5h1.08939c0.27614 0 0.5 -0.2239 0.5 -0.5s-0.22386 -0.5 -0.5 -0.5H2.09778Zm8.71512 0c-0.2761 0 -0.5 0.2239 -0.5 0.5s0.2239 0.5 0.5 0.5h1.0894c0.2761 0 0.5 -0.2239 0.5 -0.5s-0.2239 -0.5 -0.5 -0.5h-1.0894Zm-5.44699 0c-0.27615 0 -0.5 0.2239 -0.5 0.5s0.22385 0.5 0.5 0.5h3.26817c0.27614 0 0.5 -0.2239 0.5 -0.5s-0.22386 -0.5 -0.5 -0.5H5.36591Zm-0.3631 -2.68758c-0.27614 0 -0.5 0.22386 -0.5 0.5s0.22386 0.5 0.5 0.5H6.0922c0.27614 0 0.5 -0.22386 0.5 -0.5s-0.22386 -0.5 -0.5 -0.5H5.00281Zm2.40503 0.5c0 -0.27614 0.22385 -0.5 0.5 -0.5h1.08939c0.27614 0 0.5 0.22386 0.5 0.5s-0.22386 0.5 -0.5 0.5H7.90784c-0.27615 0 -0.5 -0.22386 -0.5 -0.5Zm3.40506 -0.5c-0.2762 0 -0.5 0.22386 -0.5 0.5s0.2238 0.5 0.5 0.5h1.0894c0.2761 0 0.5 -0.22386 0.5 -0.5s-0.2239 -0.5 -0.5 -0.5h-1.0894Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Keyboard"
);
var LaptopCamera = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.592 4H3.5A1.5 1.5 0 0 0 2 5.5V10a0.5 0.5 0 0 0 0.5 0.5h9a0.5 0.5 0 0 0 0.5 -0.5V7.403H7.842a2.25 2.25 0 0 1 -2.25 -2.25V4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.193 12.21 2 9.5h10l1.807 2.71a1.152 1.152 0 0 1 -0.958 1.79H1.15a1.151 1.151 0 0 1 -0.958 -1.79Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.842 2.653a1 1 0 0 0 -1 -1h-0.5l-1 -1.5h-2l-1 1.5h-0.5a1 1 0 0 0 -1 1v2.5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1v-2.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.342 3.653a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LaptopCamera"
);
var LaptopCharging = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.295584 12.0566 2 9.5h10l1.7044 2.5566c0.5538 0.8307 -0.0417 1.9434 -1.04 1.9434H1.33565C0.337277 14 -0.258212 12.8873 0.295584 12.0566Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.8741 0.12595c0.3447 0.229765 0.4378 0.695417 0.208 1.04006l-1.056 1.58398h1.3487c0.2766 0 0.5307 0.15224 0.6612 0.3961 0.1305 0.24387 0.1162 0.53978 -0.0372 0.76992l-1.8333 2.75c-0.2298 0.34465 -0.6955 0.43778 -1.0401 0.20802 -0.34465 -0.22977 -0.43778 -0.69542 -0.20801 -1.04007l1.05601 -1.58397H9.62476c-0.2766 0 -0.53074 -0.15224 -0.66126 -0.39611 -0.13051 -0.24387 -0.11621 -0.53977 0.03722 -0.76992L10.8341 0.333963c0.2297 -0.3446465 0.6954 -0.437777 1.04 -0.208013Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.68822 3H3.5C2.67157 3 2 3.67157 2 4.5v5h10V7.61884c-0.6565 0.7012 -1.7424 0.8456 -2.56798 0.29523 -0.86344 -0.57563 -1.13489 -1.70648 -0.6565 -2.60335 -0.38348 -0.1799 -0.70711 -0.48025 -0.91411 -0.86704 -0.24057 -0.4495 -0.29663 -0.96531 -0.17319 -1.44368Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LaptopCharging"
);
var MobilePhoneCamera = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m7.942 0 -0.273 0.41a2.25 2.25 0 0 0 -2.077 2.243v2.5a2.25 2.25 0 0 0 2.25 2.25H10v4.847A1.75 1.75 0 0 1 8.25 14h-6.5a1.44 1.44 0 0 1 -0.602 -0.15c-0.17 -0.08 -0.342 -0.19 -0.498 -0.322 -0.289 -0.246 -0.65 -0.686 -0.65 -1.278V1.75C0 0.784 0.784 0 1.75 0h6.192Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 11a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M14 2.5a1 1 0 0 0 -1 -1h-0.5l-1 -1.5h-2l-1 1.5H8a1 1 0 0 0 -1 1V5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1V2.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.5 3.5a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MobilePhoneCamera"
);
var MouseWireless1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 4.922a3.5 3.5 0 0 0 -3.5 3.5v2a3.5 3.5 0 0 0 7 0v-2a3.5 3.5 0 0 0 -3.5 -3.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 6.672a0.75 0.75 0 0 1 0.75 0.75v1a0.75 0.75 0 1 1 -1.5 0v-1a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.078a9.625 9.625 0 0 0 -3.743 0.757 0.625 0.625 0 0 0 0.486 1.152 8.375 8.375 0 0 1 6.514 0 0.625 0.625 0 1 0 0.486 -1.152A9.625 9.625 0 0 0 7 0.078Zm2.401 2.84a7.405 7.405 0 0 0 -4.762 0 0.625 0.625 0 0 0 0.402 1.184 6.155 6.155 0 0 1 3.958 0 0.625 0.625 0 0 0 0.402 -1.183Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MouseWireless1"
);
var MouseWireless = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a5 5 0 0 0 -5 5v4a5 5 0 0 0 10 0V5a5 5 0 0 0 -5 -5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.875c0.345 0 0.625 0.28 0.625 0.625V5a0.625 0.625 0 1 1 -1.25 0V3.5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MouseWireless"
);
var Mouse = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.75 1.53a1.5 1.5 0 0 0 -1.5 1.5v4.25a0.75 0.75 0 1 1 -1.5 0V3.03a3 3 0 1 1 6 0v0.25a1.25 1.25 0 0 0 2.5 0v-1.5a0.75 0.75 0 0 1 1.5 0v1.5a2.75 2.75 0 1 1 -5.5 0v-0.25a1.5 1.5 0 0 0 -1.5 -1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7.97 7.061a3.47 3.47 0 0 0 -6.94 0v3.47a3.47 3.47 0 1 0 6.94 0V7.06Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 5.375c0.345 0 0.625 0.28 0.625 0.625v1a0.625 0.625 0 1 1 -1.25 0V6c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Mouse"
);
var PhoneMobilePhone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.75 0A1.75 1.75 0 0 0 2 1.75v10.5c0 0.592 0.361 1.032 0.65 1.278 0.156 0.133 0.328 0.243 0.498 0.322 0.154 0.073 0.37 0.15 0.602 0.15h6.5A1.75 1.75 0 0 0 12 12.25V1.75A1.75 1.75 0 0 0 10.25 0h-6.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.75 10.5a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PhoneMobilePhone"
);
var PhoneQr = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 0c-0.9665 0 -1.75 0.783502 -1.75 1.75v10.5c0 0.5919 0.36126 1.0316 0.65 1.2778 0.15613 0.1331 0.32809 0.2431 0.49782 0.3227C3.55218 13.9229 3.76778 14 4 14h6.5c0.9665 0 1.75 -0.7835 1.75 -1.75V1.75C12.25 0.783502 11.4665 0 10.5 0H4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.19952 2.73108c-0.34517 0 -0.625 0.27982 -0.625 0.625v1.23028c0 0.34517 0.27983 0.625 0.625 0.625 0.34518 0 0.625 -0.27983 0.625 -0.625v-0.60528h0.19519c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625h-0.82019Zm4.72595 4.31583c0 -0.34518 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27982 -0.625 0.625v0.19518h-0.19518c-0.34518 0 -0.625 0.27982 -0.625 0.625s0.27982 0.625 0.625 0.625h0.82018c0.34518 0 0.625 -0.27982 0.625 -0.625v-0.82018Zm-5.35095 -0.26468c0 -0.34518 0.27983 -0.625 0.625 -0.625H6.2844c0.34517 0 0.625 0.27982 0.625 0.625V7.8671c0 0.34518 -0.27983 0.625 -0.625 0.625 -0.34518 0 -0.625 -0.27982 -0.625 -0.625v-0.45987h-0.45988c-0.34517 0 -0.625 -0.27983 -0.625 -0.625Zm3.49561 -4.05115c-0.34518 0 -0.625 0.27982 -0.625 0.625s0.27982 0.625 0.625 0.625h0.60528v1.1352c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625v-1.7602c0 -0.34518 -0.27982 -0.625 -0.625 -0.625H8.07013ZM6.36792 4.95966c0.15437 -0.30874 0.52979 -0.43388 0.83853 -0.27951l0.646 0.323c0.30874 0.15437 0.43388 0.52979 0.27951 0.83853 -0.15437 0.30873 -0.52979 0.43387 -0.83853 0.2795l-0.646 -0.323c-0.30873 -0.15436 -0.43387 -0.52979 -0.27951 -0.83852ZM6.75 9.75c-0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75h1c0.41421 0 0.75 -0.3358 0.75 -0.75s-0.33579 -0.75 -0.75 -0.75h-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PhoneQr"
);
var PhoneRinging1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.978 13.46a2.7 2.7 0 0 1 -3.37 -0.36l-0.38 -0.38a0.91 0.91 0 0 1 0 -1.28l1.6 -1.59a0.9 0.9 0 0 1 1.27 0 0.91 0.91 0 0 0 1.28 0l2.55 -2.55a0.91 0.91 0 0 0 0 -1.28 0.9 0.9 0 0 1 0 -1.27l1.54 -1.6a0.91 0.91 0 0 1 1.28 0l0.38 0.38a2.7 2.7 0 0 1 0.41 3.37 24.23 24.23 0 0 1 -6.56 6.56Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.302 0.11a0.75 0.75 0 0 1 0 1.5 5.75 5.75 0 0 0 -5.75 5.75 0.75 0.75 0 1 1 -1.5 0A7.25 7.25 0 0 1 7.302 0.11Zm0.314 2.893a0.75 0.75 0 0 1 0 1.5 3.25 3.25 0 0 0 -3.25 3.25 0.75 0.75 0 0 1 -1.5 0 4.75 4.75 0 0 1 4.75 -4.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PhoneRinging1"
);
var PhoneRinging2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.617 1C0.744 1 0.036 1.708 0.036 2.582v9.149c0 0.873 0.708 1.581 1.581 1.581H7.44c0.874 0 1.582 -0.708 1.582 -1.581V2.58A1.583 1.583 0 0 0 7.44 1H1.617Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.362 10.483a0.75 0.75 0 0 1 0.75 -0.75h0.832a0.75 0.75 0 1 1 0 1.5h-0.832a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.75 4.803c1.134 1.291 1.134 3.415 0 4.707a0.625 0.625 0 1 0 0.94 0.824c1.547 -1.763 1.547 -4.592 0 -6.356a0.625 0.625 0 1 0 -0.94 0.825Zm-1.886 0.948c0.249 0.362 0.392 0.868 0.392 1.405s-0.143 1.044 -0.392 1.405a0.625 0.625 0 0 0 1.028 0.71c0.421 -0.61 0.614 -1.378 0.614 -2.115 0 -0.737 -0.193 -1.504 -0.614 -2.115a0.625 0.625 0 1 0 -1.028 0.71Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PhoneRinging2"
);
var Phone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.17 13.24a3.317 3.317 0 0 1 -4.161 -0.457l-0.468 -0.458a1.123 1.123 0 0 1 0 -1.57l1.986 -1.966a1.113 1.113 0 0 1 1.56 0 1.123 1.123 0 0 0 1.571 0l3.12 -3.12a1.103 1.103 0 0 0 0 -1.571 1.113 1.113 0 0 1 0 -1.56L10.756 0.56a1.123 1.123 0 0 1 1.57 0l0.458 0.468a3.318 3.318 0 0 1 0.458 4.16A30.103 30.103 0 0 1 5.17 13.24Z" }),
    " "
  ] }) }),
  "Phone"
);
var Printer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.25 0.5v4h7.5v-4a0.5 0.5 0 0 0 -0.5 -0.5h-6.5a0.5 0.5 0 0 0 -0.5 0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 4.393c-0.388 0 -0.766 0.145 -1.05 0.41 -0.284 0.268 -0.45 0.637 -0.45 1.03v4.227c0 0.393 0.166 0.762 0.45 1.03 0.284 0.265 0.662 0.41 1.05 0.41h11c0.388 0 0.766 -0.145 1.05 -0.41 0.284 -0.268 0.45 -0.637 0.45 -1.03V5.833c0 -0.393 -0.166 -0.762 -0.45 -1.03a1.534 1.534 0 0 0 -1.05 -0.41h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.315 6.248c0 -0.345 0.28 -0.625 0.625 -0.625l1.637 0a0.625 0.625 0 1 1 0 1.25l-1.637 0a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.388 9.5V13c0 0.133 0.047 0.26 0.13 0.354a0.421 0.421 0 0 0 0.314 0.146h6.336a0.421 0.421 0 0 0 0.314 -0.146 0.533 0.533 0 0 0 0.13 -0.354V9.5H3.388Z" }),
    " "
  ] }) }),
  "Printer"
);
var Radio = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.362 1.498A0.75 0.75 0 1 0 12.935 0.06L1.316 3.511A1.5 1.5 0 0 0 0 5v7.5A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5V5a1.5 1.5 0 0 0 -1.5 -1.5H6.622l6.74 -2.002Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.338 12.33a1.83 1.83 0 1 0 0 -3.66 1.83 1.83 0 0 0 0 3.66Zm4.537 -2.898c0 -0.345 0.28 -0.625 0.625 -0.625H11a0.625 0.625 0 0 1 0 1.25H9.5a0.625 0.625 0 0 1 -0.625 -0.625Zm0.625 1.875a0.625 0.625 0 1 0 0 1.25H11a0.625 0.625 0 0 0 0 -1.25H9.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.362 1.498A0.75 0.75 0 1 0 12.935 0.06L1.316 3.511A1.5 1.5 0 0 0 0 5v1.5h14V5a1.5 1.5 0 0 0 -1.5 -1.5H6.622l6.74 -2.002Z" }),
    " "
  ] }) }),
  "Radio"
);
var Scanner3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.338 0.094A1.224 1.224 0 0 0 0.114 1.317v3.789a0.75 0.75 0 0 0 1.5 0V1.594h3.512a0.75 0.75 0 0 0 0 -1.5H1.338Zm7.577 0a0.75 0.75 0 1 0 0 1.5h3.512v3.512a0.75 0.75 0 0 0 1.5 0V1.317A1.223 1.223 0 0 0 12.703 0.094H8.915Zm4.262 8.05a0.75 0.75 0 0 1 0.75 0.75v3.789a1.224 1.224 0 0 1 -1.224 1.223H8.915a0.75 0.75 0 1 1 0 -1.5h3.512V8.894a0.75 0.75 0 0 1 0.75 -0.75Zm-11.563 0.75a0.75 0.75 0 1 0 -1.5 0v3.789a1.224 1.224 0 0 0 1.224 1.223h3.788a0.75 0.75 0 1 0 0 -1.5H1.614V8.894Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.418a0.75 0.75 0 0 1 0.75 0.75v0.528a2 2 0 0 1 1.553 1.306 0.75 0.75 0 0 1 -1.414 0.5 0.5 0.5 0 0 0 -0.472 -0.334H6.45a0.366 0.366 0 0 0 -0.079 0.723l1.474 0.323a2 2 0 0 1 -0.095 3.927v0.527a0.75 0.75 0 0 1 -1.5 0v-0.527a2.003 2.003 0 0 1 -1.552 -1.306 0.75 0.75 0 1 1 1.414 -0.5 0.5 0.5 0 0 0 0.472 0.333h0.833a0.5 0.5 0 0 0 0.107 -0.989l-1.473 -0.322a1.866 1.866 0 0 1 0.2 -3.678v-0.51a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Scanner3"
);
var Scanner = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 7c0 -0.41421 0.335786 -0.75 0.75 -0.75h12.5c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75H0.75C0.335786 7.75 0 7.41421 0 7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 1.75c0 -0.13807 0.11193 -0.25 0.25 -0.25H3.5c0.41421 0 0.75 -0.33579 0.75 -0.75C4.25 0.335786 3.91421 0 3.5 0H1.75C0.783502 0 0 0.783502 0 1.75V3.5c0 0.41421 0.335786 0.75 0.75 0.75 0.41421 0 0.75 -0.33579 0.75 -0.75V1.75Zm9 -1.75c-0.4142 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.3358 0.75 0.75 0.75h1.75c0.1381 0 0.25 0.11193 0.25 0.25V3.5c0 0.41421 0.3358 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75V1.75C14 0.783502 13.2165 0 12.25 0H10.5Zm2.75 9.75c0.4142 0 0.75 0.3358 0.75 0.75v1.75c0 0.9665 -0.7835 1.75 -1.75 1.75H10.5c-0.4142 0 -0.75 -0.3358 -0.75 -0.75s0.3358 -0.75 0.75 -0.75h1.75c0.1381 0 0.25 -0.1119 0.25 -0.25V10.5c0 -0.4142 0.3358 -0.75 0.75 -0.75Zm-11.74988 0.75c0 -0.4142 -0.33578 -0.75 -0.749998 -0.75 -0.414213 0 -0.74999993 0.3358 -0.74999993 0.75v1.7499c0 0.9665 0.78350193 1.75 1.74999793 1.75H3.5c0.41421 0 0.75 -0.3358 0.75 -0.75s-0.33579 -0.75 -0.75 -0.75H1.75012c-0.13807 0 -0.25 -0.1119 -0.25 -0.25V10.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Scanner"
);
var Screen1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.5C0.652 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348 0.5 12.543 0.5H1.457Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Screen1"
);
var Screen2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 11.135a2.605 2.605 0 0 1 2.575 2.212 0.75 0.75 0 1 0 1.483 -0.226 4.105 4.105 0 0 0 -8.116 0 0.75 0.75 0 1 0 1.483 0.226A2.604 2.604 0 0 1 7 11.135Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.543 0.5C13.348 0.5 14 1.152 14 1.957v7.586c0 0.805 -0.652 1.457 -1.457 1.457H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h11.086Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Screen2"
);
var ScreenCurve = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 10.687a0.75 0.75 0 0 0 -1.5 0V12.3H4.639a0.75 0.75 0 0 0 0 1.5H9.36a0.75 0.75 0 0 0 0 -1.5H7.75v-1.612Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M14 2.495C14 1.32 12.904 0.542 11.853 0.73 10.62 0.952 8.737 1.145 7 1.145c-1.737 0 -3.619 -0.193 -4.853 -0.415C1.097 0.542 0 1.32 0 2.495v7.01c0 1.175 1.096 1.954 2.147 1.765 1.234 -0.222 3.116 -0.415 4.853 -0.415 1.737 0 3.619 0.193 4.853 0.415 1.05 0.189 2.147 -0.59 2.147 -1.765v-7.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ScreenCurve"
);
var ScreensaverMonitorWallpaper = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.332a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 0 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.25C0.652 0.25 0 0.902 0 1.707v7.586c0 0.805 0.652 1.457 1.457 1.457h11.086c0.805 0 1.457 -0.652 1.457 -1.457V1.707C14 0.902 13.348 0.25 12.543 0.25H1.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.945 5.008a1.5 1.5 0 1 0 0 -3 1.5 1.5 0 0 0 0 3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12 6.334 9.422 4.48a1.182 1.182 0 0 0 -1.52 0.032L3.377 8.75H12V6.334Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ScreensaverMonitorWallpaper"
);
var SmokeDetector = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.0485 6.65067c0.32345 0.25876 0.37589 0.73073 0.11713 1.05418 -0.39639 0.49549 -0.43632 0.82811 -0.40431 1.07612 0.04016 0.31129 0.20452 0.61892 0.46985 1.08325l0.02569 0.04492c0.2328 0.40666 0.54767 0.95676 0.62946 1.59056 0.09299 0.7208 -0.11708 1.4506 -0.72069 2.2051 -0.25875 0.3235 -0.73072 0.3759 -1.05417 0.1172 -0.32344 -0.2588 -0.37589 -0.7307 -0.11713 -1.0542 0.3964 -0.4955 0.43632 -0.8281 0.40432 -1.0761 -0.04017 -0.3113 -0.20452 -0.6189 -0.46985 -1.0833l-0.0257 -0.0449c-0.23279 -0.4067 -0.54767 -0.95676 -0.62945 -1.59057 -0.093 -0.72074 0.11708 -1.45062 0.72068 -2.20513 0.25876 -0.32344 0.73073 -0.37588 1.05417 -0.11713Zm3.42005 0c0.32345 0.25876 0.37589 0.73073 0.11713 1.05418 -0.3964 0.49549 -0.43632 0.82811 -0.40432 1.07612 0.04017 0.31129 0.20452 0.61892 0.46985 1.08325l0.0257 0.04492c0.23279 0.40666 0.54767 0.95676 0.62945 1.59056 0.093 0.7208 -0.11708 1.4506 -0.72068 2.2051 -0.25876 0.3235 -0.73073 0.3759 -1.05417 0.1172 -0.32345 -0.2588 -0.37589 -0.7307 -0.11713 -1.0542 0.39639 -0.4955 0.43632 -0.8281 0.40431 -1.0761 -0.04016 -0.3113 -0.20452 -0.6189 -0.46984 -1.0833l-0.0257 -0.0449c-0.2328 -0.4067 -0.54767 -0.95676 -0.62946 -1.59057 -0.09299 -0.72074 0.11708 -1.45062 0.72069 -2.20513 0.25875 -0.32344 0.73072 -0.37588 1.05417 -0.11713Zm3.53715 1.05418c0.2587 -0.32345 0.2063 -0.79542 -0.1172 -1.05418 -0.3234 -0.25875 -0.7954 -0.20631 -1.05414 0.11713 -0.60361 0.75451 -0.81368 1.48439 -0.72068 2.20513 0.08178 0.63381 0.39666 1.18387 0.62945 1.59057l0.0257 0.0449c0.26537 0.4644 0.42967 0.772 0.46987 1.0833 0.032 0.248 -0.0079 0.5806 -0.40434 1.0761 -0.25876 0.3235 -0.20632 0.7954 0.11713 1.0542 0.32341 0.2587 0.79541 0.2063 1.05421 -0.1172 0.6036 -0.7545 0.8136 -1.4843 0.7206 -2.2051 -0.0817 -0.6338 -0.3966 -1.1839 -0.6294 -1.59056l-0.0257 -0.04492c-0.2653 -0.46433 -0.4297 -0.77196 -0.4699 -1.08325 -0.032 -0.24801 0.008 -0.58063 0.4044 -1.07612Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.75531c0 -0.414214 0.33579 -0.74999994 0.75 -0.74999994h9c0.4142 0 0.75 0.33578594 0.75 0.74999994 0 0.41421 -0.3358 0.75 -0.75 0.75h-0.5078c-0.0607 0.96963 -0.4728 1.88742 -1.16377 2.57843C9.07828 4.83388 8.06087 5.25531 7 5.25531s-2.07828 -0.42143 -2.82843 -1.17157c-0.691 -0.69101 -1.10307 -1.6088 -1.16376 -2.57843H2.5c-0.41421 0 -0.75 -0.33579 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmokeDetector"
);
var Speaker1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.526 0.113A1.987 1.987 0 0 0 0.908 3.675a6.964 6.964 0 0 0 -0.85 3.175 6.893 6.893 0 0 0 0.671 3.133c-0.799 0.699 -0.902 1.958 -0.209 2.776 0.734 0.865 2.06 0.888 2.862 0.168a6.915 6.915 0 0 0 7.235 0.001c0.833 0.756 2.215 0.68 2.93 -0.273 0.629 -0.838 0.47 -2.01 -0.278 -2.67a6.876 6.876 0 0 0 0.562 -4.224 6.964 6.964 0 0 0 -0.739 -2.086A1.986 1.986 0 1 0 10.33 0.912a6.935 6.935 0 0 0 -6.66 0 1.987 1.987 0 0 0 -1.144 -0.8Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 11.043a4.038 4.038 0 1 0 0 -8.076 4.038 4.038 0 0 0 0 8.076Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 5.454a1.55 1.55 0 1 0 0 3.101 1.55 1.55 0 0 0 0 -3.1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Speaker1"
);
var Speaker2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3 0c-0.82843 0 -1.5 0.671573 -1.5 1.5v11c0 0.8284 0.67157 1.5 1.5 1.5h8c0.8284 0 1.5 -0.6716 1.5 -1.5v-11C12.5 0.671573 11.8284 0 11 0H3Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.83142 3.05562c0 -0.64536 0.52317 -1.16854 1.16854 -1.16854 0.64536 0 1.16853 0.52318 1.16853 1.16854 0 0.64536 -0.52317 1.16854 -1.16853 1.16854 -0.64537 0 -1.16854 -0.52318 -1.16854 -1.16854Zm4.45928 5.94439c0 1.81739 -1.47329 3.29079 -3.29072 3.29079 -1.81743 0 -3.29075 -1.4734 -3.29075 -3.29079 0 -1.81743 1.47332 -3.29075 3.29075 -3.29075s3.29072 1.47332 3.29072 3.29075Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.00001 7.8418c-0.63963 0 -1.15815 0.51852 -1.15815 1.15815 0 0.63962 0.51852 1.15815 1.15815 1.15815s1.15815 -0.51853 1.15815 -1.15815c0 -0.63963 -0.51852 -1.15815 -1.15815 -1.15815Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Speaker2"
);
var UsbDrive = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 0.375A0.25 0.25 0 0 1 4 0.125h6a0.25 0.25 0 0 1 0.25 0.25v3.781h-6.5V0.375Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 9.375V5.156a1 1 0 0 1 1 -1h7a1 1 0 0 1 1 1v4.219a4.5 4.5 0 1 1 -9 0Z" }),
    " "
  ] }) }),
  "UsbDrive"
);
var VideoSwapCamera = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 1a0.5 0.5 0 0 0 -0.4 0.2L3.25 3H1.5A1.5 1.5 0 0 0 0 4.5v7A1.5 1.5 0 0 0 1.5 13h11a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 12.5 3h-1.75L9.4 1.2A0.5 0.5 0 0 0 9 1H5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m10.178 7.436 0.058 0.008a0.625 0.625 0 0 1 0.29 1.118l-0.84 0.636a0.625 0.625 0 0 1 -0.876 -0.122l-0.635 -0.841a0.625 0.625 0 0 1 0.584 -0.996l0.16 0.022A1.955 1.955 0 0 0 6.247 5.63a0.625 0.625 0 1 1 -0.466 -1.16 3.205 3.205 0 0 1 4.398 2.966Zm-5.92 -1.705a0.625 0.625 0 0 1 0.876 0.122l0.636 0.84a0.625 0.625 0 0 1 -0.585 0.996l-0.16 -0.022a1.955 1.955 0 0 0 2.673 1.63 0.625 0.625 0 0 1 0.467 1.16 3.205 3.205 0 0 1 -4.398 -2.965l-0.058 -0.008a0.625 0.625 0 0 1 -0.291 -1.118l0.84 -0.635Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VideoSwapCamera"
);
var VirtualReality = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.20903 0.860229c-0.63035 0 -1.19345 0.394101 -1.40931 0.986341L0.0376758 6.68109c-0.0199983 0.05487 -0.03022951 0.11281 -0.03022951 0.17121v1.46332H14.0005V6.8523c0 -0.05859 -0.0103 -0.11673 -0.0304 -0.17176l-1.7688 -4.83559c-0.2163 -0.5914 -0.779 -0.984715 -1.4087 -0.984716L3.20903 0.860229Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 6.5c-0.276142 0 -0.5 0.22386 -0.5 0.5v5c0 0.8284 0.671573 1.5 1.5 1.5h3.01938c0.45567 0 0.88664 -0.2071 1.1713 -0.563l0.91889 -1.1486c0.20016 -0.2502 0.5807 -0.2502 0.78086 0l0.91889 1.1486c0.28466 0.3559 0.71563 0.563 1.17131 0.563H12.5c0.8284 0 1.5 -0.6716 1.5 -1.5V7c0 -0.27614 -0.2239 -0.5 -0.5 -0.5H0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VirtualReality"
);
var VrHeadset1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.07143 0C2.71827 0 0 2.71827 0 6.07143c0 2.14315 1.11066 4.02637 2.78571 5.10627V13.5c0 0.2761 0.22386 0.5 0.5 0.5h5.57143c0.27615 0 0.5 -0.2239 0.5 -0.5v-1.8214h1.35716c0.789 0 1.4286 -0.6396 1.4286 -1.4286V7.92857c0 -0.02654 -0.0022 -0.05305 -0.0064 -0.07925l-0.7453 -4.64286c-0.0097 -0.06027 -0.0303 -0.11827 -0.0609 -0.17111C10.2813 1.2219 8.31934 0 6.07143 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.5 7.81316H9.94644V3.40112H12.5c0.5523 0 1 0.44772 1 1v2.41204c0 0.55229 -0.4477 1 -1 1ZM8.20553 3.40112h0.49091v4.41204h-0.49091c-1.00125 0 -1.84671 -0.66704 -2.11622 -1.58098l-6.08722283 0C0.000698595 6.17876 0 6.12518 0 6.07143c0 -0.37184 0.0334266 -0.73587 0.0974387 -1.08925H6.08929c0.26949 -0.91398 1.11496 -1.58106 2.11624 -1.58106Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VrHeadset1"
);
var VrHeadset2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.14288 0.928711c-0.25216 0 -0.46486 0.187769 -0.49614 0.437979l-0.46429 3.71429c-0.01779 0.14231 0.02639 0.2854 0.1213 0.39292 0.09492 0.10751 0.23143 0.1691 0.37484 0.1691h4.64286c0.14341 0 0.27993 -0.06159 0.37484 -0.1691 0.09491 -0.10752 0.13909 -0.25061 0.1213 -0.39292L9.3533 1.36669c-0.03127 -0.25021 -0.24398 -0.437979 -0.49614 -0.437979H5.14288Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.35714 4.64282C1.05731 4.64282 0 5.69269 0 6.99218v3.66362c0 1.5366 1.44118 2.6388 2.9146 2.3767 1.248 -0.222 2.78061 -0.4327 4.0854 -0.4327 1.30479 0 2.8374 0.2107 4.0854 0.4327C12.5588 13.2946 14 12.1924 14 10.6558V6.99218c0 -1.29949 -1.0573 -2.34936 -2.3571 -2.34936H2.35714Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.58929 7.92871c0 -0.34518 0.27983 -0.625 0.625 -0.625h5.57143c0.34518 0 0.62498 0.27982 0.62498 0.625s-0.2798 0.625 -0.62498 0.625H4.21429c-0.34517 0 -0.625 -0.27982 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VrHeadset2"
);
var WebcamVideoCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m10.135 5.25 -1.52 0.673v-0.808a0.539 0.539 0 0 0 -0.538 -0.539h-4.04a0.539 0.539 0 0 0 -0.538 0.539v3.77a0.539 0.539 0 0 0 0.539 0.539h4.04a0.539 0.539 0 0 0 0.538 -0.539v-0.808l1.519 0.674a0.269 0.269 0 0 0 0.366 -0.254V5.503a0.27 0.27 0 0 0 -0.366 -0.253Z" }),
    " "
  ] }) }),
  "WebcamVideoCircle"
);
var WebcamVideoOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H9a1.5 1.5 0 0 0 1.5 -1.5v-0.742l2.106 0.903A1 1 0 0 0 14 9.74V4.259a1 1 0 0 0 -1.394 -0.919l-2.106 0.903V3.5A1.5 1.5 0 0 0 9 2H1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 0 0 1.06l12.5 12.5a0.75 0.75 0 1 0 1.06 -1.06L1.28 0.22a0.75 0.75 0 0 0 -1.06 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WebcamVideoOff"
);
var WebcamVideo = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12H9a1.5 1.5 0 0 0 1.5 -1.5v-0.742l2.106 0.903A1 1 0 0 0 14 9.74V4.259a1 1 0 0 0 -1.394 -0.919l-2.106 0.903V3.5A1.5 1.5 0 0 0 9 2H1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WebcamVideo"
);
var Webcam = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.107 12.655a0.75 0.75 0 1 1 -1.114 1.005 6.648 6.648 0 0 0 -1.864 -1.441l-6.258 0a6.65 6.65 0 0 0 -1.864 1.441 0.75 0.75 0 0 1 -1.114 -1.005 8.152 8.152 0 0 1 1.653 -1.4l8.908 0a8.15 8.15 0 0 1 1.653 1.4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.5 6.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 1 0 -13 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 3.27a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0 -6.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6 6.52a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Webcam"
);
var AiChipSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.714 0.04a0.75 0.75 0 0 1 0.75 0.75v1.188h-1.5V0.79a0.75 0.75 0 0 1 0.75 -0.75Zm-2.68 1.938V0.79a0.75 0.75 0 1 0 -1.5 0v1.188h1.5ZM2 4.514H0.782a0.75 0.75 0 0 0 0 1.5H2v-1.5Zm0 3.43H0.782a0.75 0.75 0 1 0 0 1.5H2v-1.5Zm2.535 4.033v1.233a0.75 0.75 0 0 0 1.5 0v-1.233h-1.5Zm3.43 0v1.233a0.75 0.75 0 0 0 1.5 0v-1.233h-1.5ZM12 9.443h1.219a0.75 0.75 0 0 0 0 -1.5h-1.22v1.5Zm0 -3.43h1.219a0.75 0.75 0 0 0 0 -1.5h-1.22v1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.499 1.978a1.5 1.5 0 0 0 -1.5 1.5v7a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5 -1.5v-7a1.5 1.5 0 0 0 -1.5 -1.5h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.746 4.54c-0.183 -0.803 -1.327 -0.798 -1.503 0.006l-0.007 0.03 -0.012 0.057A2.082 2.082 0 0 1 4.548 6.23c-0.838 0.146 -0.837 1.349 0 1.495a2.08 2.08 0 0 1 1.677 1.606l0.018 0.078c0.176 0.804 1.32 0.809 1.503 0.007l0.02 -0.092a2.096 2.096 0 0 1 1.685 -1.598c0.839 -0.146 0.839 -1.35 0 -1.497A2.096 2.096 0 0 1 7.77 4.644l-0.016 -0.07 -0.008 -0.035Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiChipSpark"
);
var AiCloudSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.041 0.798a4.368 4.368 0 0 1 6.645 3.116 3.23 3.23 0 0 1 0.227 6.11c-0.085 -0.841 -0.653 -1.634 -1.704 -1.817a1.443 1.443 0 0 1 -1.175 -1.169l-0.01 -0.044c-0.494 -2.17 -3.589 -2.156 -4.064 0.017l-0.023 0.105A1.426 1.426 0 0 1 3.79 8.208c-0.99 0.173 -1.552 0.887 -1.683 1.673A3.691 3.691 0 0 1 3.3 2.882 4.368 4.368 0 0 1 5.04 0.798Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.805 7.272c-0.197 -0.867 -1.434 -0.862 -1.624 0.007l-0.008 0.036 -0.016 0.071A2.676 2.676 0 0 1 4.004 9.44c-0.903 0.157 -0.903 1.454 0 1.61a2.676 2.676 0 0 1 2.156 2.065l0.02 0.097c0.191 0.869 1.428 0.874 1.625 0.007l0.026 -0.112a2.693 2.693 0 0 1 2.164 -2.054c0.905 -0.158 0.905 -1.457 0 -1.615a2.693 2.693 0 0 1 -2.18 -2.123l-0.01 -0.043Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiCloudSpark"
);
var AiEditSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.2171 3.49902c-0.1998 0 -0.3976 0.03993 -0.5818 0.11743 -0.183 0.07699 -0.3488 0.18952 -0.4879 0.33106L3.90966 10.1452c-0.08388 0.0834 -0.13551 0.1937 -0.14572 0.3115l-0.26 3c-0.01274 0.1471 0.04018 0.2923 0.14458 0.3968 0.10441 0.1044 0.24963 0.1573 0.39673 0.1445l3 -0.26c0.1178 -0.0102 0.22817 -0.0618 0.31152 -0.1457l6.19743 -6.2374 0.0015 -0.00149c0.1399 -0.13914 0.2509 -0.30451 0.3268 -0.48665 0.0762 -0.18278 0.1154 -0.37884 0.1154 -0.57686 0 -0.19802 -0.0392 -0.39408 -0.1154 -0.57687 -0.0758 -0.18208 -0.1869 -0.3474 -0.3267 -0.48651l-1.2662 -1.27618 -0.0015 -0.00146c-0.1394 -0.14219 -0.3057 -0.25519 -0.4892 -0.33243 -0.1842 -0.0775 -0.382 -0.11743 -0.5818 -0.11743Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.48112 0.647275C4.2834 -0.219628 3.04663 -0.214222 2.85649 0.654376L2.8486 0.690551l-0.01572 0.071545C2.59689 1.81884 1.74708 2.62976 0.679573 2.81547c-0.903334 0.15716 -0.903327 1.45393 0 1.61108 1.071237 0.18637 1.923247 1.0023 2.155767 2.06447l0.02115 0.09663c0.19014 0.8686 1.42691 0.87401 1.62463 0.0071l0.02569 -0.11261c0.24135 -1.05816 1.0944 -1.86796 2.16367 -2.05399 0.90512 -0.15747 0.90512 -1.45681 0 -1.61427 -1.0636 -0.18504 -1.91327 -0.98727 -2.15978 -2.037167 -0.00675 -0.028746 -0.01302 -0.056427 -0.01976 -0.086191l0 -0.000012 -0.00982 -0.043235Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiEditSpark"
);
var AiEmailGeneratorSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.617 0.035h9.312c0.857 0 1.552 0.695 1.552 1.552v6.208c0 0.059 -0.004 0.117 -0.01 0.175a1.318 1.318 0 0 1 -0.054 -0.175l-0.016 -0.07 -0.01 -0.04c-0.448 -1.967 -3.254 -1.955 -3.685 0.016l-0.021 0.095c-0.115 0.51 -0.525 0.901 -1.04 0.99 -0.455 0.08 -0.81 0.285 -1.065 0.56H1.617A1.552 1.552 0 0 1 0.066 7.795V1.587C0.066 0.73 0.76 0.035 1.617 0.035Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.48 1.664 6.274 4.768 0.066 1.664v1.398l5.928 2.964a0.625 0.625 0 0 0 0.559 0l5.928 -2.964V1.664Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.332 7.927c-0.19 -0.835 -1.381 -0.83 -1.564 0.007l-0.008 0.033 -0.014 0.064a2.38 2.38 0 0 1 -1.915 1.827c-0.871 0.151 -0.871 1.401 0 1.553a2.38 2.38 0 0 1 1.917 1.836l0.02 0.088c0.183 0.836 1.373 0.841 1.564 0.007l0.023 -0.102a2.396 2.396 0 0 1 1.925 -1.828c0.873 -0.152 0.873 -1.404 0 -1.556a2.396 2.396 0 0 1 -1.921 -1.812l-0.018 -0.078 -0.01 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiEmailGeneratorSpark"
);
var AiGenerateLandscapeImageSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.076 8.846c0 0.943 0.765 1.708 1.708 1.708H5.34c-0.107 -0.993 0.46 -2.059 1.7 -2.275a1.426 1.426 0 0 0 1.147 -1.092l0.023 -0.105c0.304 -1.388 1.677 -1.895 2.758 -1.514V1.77c0 -0.944 -0.765 -1.708 -1.708 -1.708H1.784A1.709 1.709 0 0 0 0.076 1.77v7.075Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.304 3.21a1.371 1.371 0 1 1 -2.742 0 1.371 1.371 0 0 1 2.742 0ZM5.34 10.554c-0.105 -0.973 0.437 -2.016 1.626 -2.26l-0.23 -0.37C5.04 5.67 2.506 5.572 0.076 6.1v2.745c0 0.943 0.765 1.708 1.708 1.708H5.34ZM9.43 7.35c0.19 -0.869 1.427 -0.874 1.625 -0.007l0.01 0.043 0.02 0.086a2.693 2.693 0 0 0 2.16 2.037c0.905 0.158 0.905 1.457 0 1.614a2.692 2.692 0 0 0 -2.164 2.055l-0.026 0.112c-0.198 0.867 -1.434 0.862 -1.625 -0.007l-0.02 -0.097a2.676 2.676 0 0 0 -2.156 -2.064c-0.904 -0.157 -0.904 -1.454 0 -1.611a2.676 2.676 0 0 0 2.153 -2.054l0.016 -0.071 0.007 -0.036Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiGenerateLandscapeImageSpark"
);
var AiGenerateMusicSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m6.12 3.581 -2.356 0.654a1.147 1.147 0 0 0 -0.846 1.101v4.392a2.188 2.188 0 1 0 1.5 2.078l0 -0.016V7.538l4.32 -1.2 -0.014 -0.062 -0.02 -0.087a1.295 1.295 0 0 0 -1.043 -1c-0.936 -0.162 -1.45 -0.86 -1.54 -1.608Zm3.66 4.017c0.569 0.25 1.254 0.215 1.79 -0.108v2.316a2.188 2.188 0 1 1 -1.79 -2.208Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.352 0.63c-0.19 -0.835 -1.381 -0.83 -1.564 0.007L9.78 0.67l-0.014 0.064a2.384 2.384 0 0 1 -1.918 1.83c-0.87 0.15 -0.87 1.401 0 1.553a2.384 2.384 0 0 1 1.92 1.839l0.02 0.087c0.183 0.837 1.374 0.842 1.564 0.007l0.024 -0.102a2.399 2.399 0 0 1 1.927 -1.83c0.873 -0.152 0.873 -1.404 0 -1.556A2.399 2.399 0 0 1 11.38 0.747L11.361 0.67l-0.009 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiGenerateMusicSpark"
);
var AiGeneratePortraitImageSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 0.443A1.5 1.5 0 0 1 1.56 0.004h8a1.5 1.5 0 0 1 1.5 1.5v4.152c-1.09 -0.434 -2.524 0.063 -2.835 1.485l-0.023 0.104a1.426 1.426 0 0 1 -1.147 1.093c-1.406 0.245 -1.947 1.582 -1.621 2.666H1.56a1.5 1.5 0 0 1 -1.5 -1.5v-8c0 -0.398 0.158 -0.78 0.44 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.335 3.25a1.774 1.774 0 1 1 -3.548 0 1.774 1.774 0 0 1 3.548 0ZM5.56 5.904A2.956 2.956 0 0 0 2.605 8.86c0 0.163 0.132 0.296 0.295 0.296h2.818c0.285 -0.405 0.73 -0.713 1.337 -0.819a1.427 1.427 0 0 0 1.093 -0.909A2.955 2.955 0 0 0 5.56 5.905Zm3.885 1.503c0.19 -0.868 1.427 -0.874 1.625 -0.007l0.01 0.044 0.02 0.086a2.693 2.693 0 0 0 2.16 2.037c0.904 0.157 0.904 1.457 0 1.614a2.692 2.692 0 0 0 -2.164 2.054l-0.026 0.113c-0.198 0.867 -1.435 0.861 -1.625 -0.007l-0.02 -0.097a2.676 2.676 0 0 0 -2.157 -2.064c-0.903 -0.158 -0.903 -1.454 0 -1.611a2.676 2.676 0 0 0 2.154 -2.054l0.015 -0.071 0.008 -0.037Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiGeneratePortraitImageSpark"
);
var AiGenerateVariationSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.0848999 1.08973c0 -0.543053 0.4402311 -0.983285 0.9832801 -0.983285h4.17896c0.54306 0 0.98329 0.440232 0.98329 0.983285v4.17896c0 0.54305 -0.44023 0.98328 -0.98329 0.98328H1.06818c-0.543049 0 -0.9832801 -0.44023 -0.9832801 -0.98328V1.08973Zm0.9832901 6.6583c-0.543058 0 -0.9832901 0.44023 -0.9832901 0.98328v4.17899c0 0.543 0.4402321 0.9833 0.9832901 0.9833h4.17895c0.54306 0 0.98329 -0.4403 0.98329 -0.9833V8.73131c0 -0.54305 -0.44023 -0.98328 -0.98329 -0.98328H1.06819Zm7.64158 0c-0.54306 0 -0.98329 0.44023 -0.98329 0.98328v4.17899c0 0.543 0.44023 0.9833 0.98329 0.9833h4.17893c0.5431 0 0.9833 -0.4403 0.9833 -0.9833V8.73131c0 -0.54305 -0.4402 -0.98328 -0.9833 -0.98328H8.70977Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.4701 0.728987c-0.1862 -0.8166164 -1.3513 -0.8115236 -1.53038 0.006689l-0.00681 0.031217 -0.0133 0.060556C9.72431 1.702 9.02101 2.3731 8.13755 2.5268c-0.85235 0.14829 -0.85234 1.37187 0 1.52016 0.88654 0.15423 1.59166 0.82949 1.78409 1.70853l0.01808 0.08259c0.17908 0.81821 1.34418 0.82331 1.53038 0.00669l0.022 -0.09625c0.1997 -0.87589 0.9059 -1.54622 1.791 -1.7002 0.8538 -0.14855 0.8538 -1.37433 0 -1.52288 -0.8804 -0.15317 -1.5838 -0.81722 -1.7878 -1.686269 -0.0057 -0.024289 -0.011 -0.047511 -0.0167 -0.072792l-0.0085 -0.037392Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiGenerateVariationSpark"
);
var AiNavigationSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.034 1.982c-0.952 0.892 -0.646 2.75 0.916 3.021 0.485 0.085 0.871 0.454 0.977 0.936l0.018 0.082c0.174 0.795 0.76 1.25 1.405 1.363 -0.177 1.545 -1.012 3.054 -1.934 4.199a9.464 9.464 0 0 1 -1.623 1.605 4.595 4.595 0 0 1 -0.775 0.482c-0.24 0.114 -0.503 0.2 -0.758 0.2 -0.256 0 -0.518 -0.086 -0.759 -0.2a4.595 4.595 0 0 1 -0.774 -0.482 9.465 9.465 0 0 1 -1.623 -1.605c-1.04 -1.291 -1.97 -3.045 -1.97 -4.79a5.125 5.125 0 0 1 6.9 -4.81Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.552 6.792a1.708 1.708 0 1 0 3.416 0 1.708 1.708 0 1 0 -3.416 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.437 0.727c-0.186 -0.815 -1.349 -0.81 -1.527 0.006l-0.007 0.032 -0.013 0.06a2.2 2.2 0 0 1 -1.77 1.688c-0.851 0.148 -0.851 1.37 0 1.517a2.2 2.2 0 0 1 1.772 1.697l0.018 0.082c0.178 0.817 1.341 0.822 1.527 0.007l0.022 -0.096c0.198 -0.87 0.9 -1.536 1.779 -1.689 0.852 -0.148 0.852 -1.371 0 -1.52A2.214 2.214 0 0 1 11.445 0.764l-0.008 -0.037Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiNavigationSpark"
);
var AiPromptSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.035 2.507c-0.653 1.073 -0.204 2.73 1.344 3 0.545 0.095 0.978 0.51 1.096 1.05l0.02 0.092c0.454 2.073 3.407 2.086 3.878 0.017l0.025 -0.108a1.4 1.4 0 0 1 0.04 -0.139v5.791c0 0.941 -0.764 1.704 -1.705 1.704H1.734A1.704 1.704 0 0 1 0.03 12.21V4.211c0 -0.941 0.763 -1.704 1.704 -1.704h4.3Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.08 7.797a0.625 0.625 0 1 0 -0.883 0.884L3.255 9.74l-1.058 1.058a0.625 0.625 0 0 0 0.884 0.884l1.5 -1.5a0.625 0.625 0 0 0 0 -0.884l-1.5 -1.5Zm2.559 2.817a0.625 0.625 0 1 0 0 1.25h1.5a0.625 0.625 0 0 0 0 -1.25h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.035 2.507c-0.653 1.073 -0.204 2.73 1.344 3 0.318 0.055 0.598 0.22 0.8 0.454H0.028V4.21c0 -0.941 0.764 -1.704 1.705 -1.704h4.3Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.233 0.721C11.04 -0.13 9.825 -0.125 9.638 0.728l-0.007 0.035 -0.015 0.068A2.53 2.53 0 0 1 7.58 2.772c-0.887 0.154 -0.887 1.428 0 1.582a2.53 2.53 0 0 1 2.038 1.952l0.02 0.093c0.187 0.852 1.401 0.858 1.595 0.007l0.025 -0.108a2.546 2.546 0 0 1 2.046 -1.942c0.889 -0.155 0.889 -1.43 0 -1.585A2.546 2.546 0 0 1 11.26 0.844l-0.018 -0.082 -0.01 -0.041Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiPromptSpark"
);
var AiRedoSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.577 1.689a5.488 5.488 0 0 1 4.636 0.848l-0.61 0.61A0.5 0.5 0 0 0 9.957 4h2.293a0.5 0.5 0 0 0 0.5 -0.5V1.207a0.5 0.5 0 0 0 -0.854 -0.353l-0.612 0.612A6.999 6.999 0 0 0 0.12 8.287a0.75 0.75 0 1 0 1.475 -0.277 5.499 5.499 0 0 1 3.982 -6.321Zm8.303 4.024a0.75 0.75 0 0 0 -1.475 0.277 5.499 5.499 0 0 1 -8.618 5.473l0.61 -0.61A0.5 0.5 0 0 0 4.042 10H1.75a0.5 0.5 0 0 0 -0.5 0.5v2.293a0.5 0.5 0 0 0 0.854 0.353l0.612 -0.612a6.999 6.999 0 0 0 11.164 -6.82Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.806 4.026c-0.198 -0.866 -1.435 -0.861 -1.625 0.008l-0.008 0.036 -0.016 0.071a2.676 2.676 0 0 1 -2.153 2.054c-0.903 0.157 -0.903 1.454 0 1.61A2.676 2.676 0 0 1 6.16 9.87l0.021 0.097c0.19 0.868 1.427 0.874 1.625 0.007l0.025 -0.113a2.693 2.693 0 0 1 2.164 -2.054c0.905 -0.157 0.905 -1.457 0 -1.614a2.693 2.693 0 0 1 -2.16 -2.037l-0.02 -0.086 -0.01 -0.044Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiRedoSpark"
);
var AiSettingsSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.495 2.524c-0.453 0.984 -0.008 2.35 1.334 2.583 0.501 0.087 0.9 0.469 1.01 0.966l0.018 0.085c0.146 0.67 0.576 1.106 1.09 1.308V8.82l0.676 0.838a0.9 0.9 0 0 1 0.072 1.017l-0.36 0.63a0.9 0.9 0 0 1 -0.9 0.442l-1.063 -0.162 -1.315 0.756 -0.387 1a0.9 0.9 0 0 1 -0.838 0.576h-0.756a0.9 0.9 0 0 1 -0.838 -0.576l-0.387 -1 -1.315 -0.756 -1.063 0.162a0.9 0.9 0 0 1 -0.9 -0.441l-0.36 -0.63a0.9 0.9 0 0 1 0.072 -1.018l0.657 -0.838V7.307L0.267 6.47a0.9 0.9 0 0 1 -0.072 -1.018l0.36 -0.63a0.9 0.9 0 0 1 0.9 -0.442l1.063 0.162 1.333 -0.756 0.387 -1a0.9 0.9 0 0 1 0.838 -0.576h0.738a0.9 0.9 0 0 1 0.68 0.314Zm0.831 5.54a1.882 1.882 0 1 1 -3.763 0 1.882 1.882 0 0 1 3.763 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.416 0.691c-0.188 -0.825 -1.365 -0.82 -1.546 0.007L9.863 0.73 9.85 0.792A2.29 2.29 0 0 1 8.007 2.55c-0.861 0.15 -0.861 1.386 0 1.536A2.29 2.29 0 0 1 9.852 5.85l0.018 0.085c0.181 0.827 1.358 0.832 1.546 0.007l0.023 -0.099a2.305 2.305 0 0 1 1.852 -1.758c0.862 -0.15 0.862 -1.388 0 -1.538A2.305 2.305 0 0 1 11.425 0.73l-0.009 -0.038Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiSettingsSpark"
);
var AiTechnologySpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.544 13.25a0.75 0.75 0 0 1 0.75 -0.75h3.5a0.75 0.75 0 0 1 0 1.5h-3.5a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.016 8.037c-0.4 0.522 -0.9 0.963 -1.472 1.294V10.5a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1V9.331a5 5 0 1 1 6.159 -7.739 1.29 1.29 0 0 1 -1.037 0.978c-2.072 0.36 -2.072 3.335 0 3.695 0.517 0.09 0.93 0.485 1.042 0.998l0.019 0.088c0.057 0.264 0.158 0.493 0.29 0.686Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.353 1.71c-0.19 -0.834 -1.381 -0.83 -1.564 0.007l-0.007 0.033 -0.015 0.065A2.38 2.38 0 0 1 7.852 3.64c-0.87 0.152 -0.87 1.402 0 1.553A2.38 2.38 0 0 1 9.77 7.031l0.019 0.087c0.183 0.837 1.374 0.842 1.564 0.007l0.023 -0.102a2.396 2.396 0 0 1 1.925 -1.827c0.873 -0.152 0.873 -1.404 0 -1.556a2.395 2.395 0 0 1 -1.939 -1.89l-0.009 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiTechnologySpark"
);
var AiUpscaleSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.5 0a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0 -13Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 6.5a5 5 0 1 1 10 0 5 5 0 0 1 -10 0Zm5 -6.5a6.5 6.5 0 1 0 3.835 11.749l1.958 1.958a1 1 0 0 0 1.414 -1.414l-1.958 -1.958A6.5 6.5 0 0 0 6.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.264 3.9c-0.188 -0.821 -1.36 -0.816 -1.54 0.007l-0.007 0.032 -0.013 0.062a2.261 2.261 0 0 1 -1.82 1.734c-0.857 0.15 -0.857 1.38 0 1.53a2.261 2.261 0 0 1 1.822 1.744l0.018 0.084c0.18 0.823 1.352 0.828 1.54 0.007l0.022 -0.098a2.275 2.275 0 0 1 1.828 -1.736c0.86 -0.15 0.86 -1.383 0 -1.532A2.275 2.275 0 0 1 7.272 3.94l-0.008 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiUpscaleSpark"
);
var AiVehicleSpark1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.267 4.215c0.236 0.488 0.69 0.879 1.361 0.995 0.518 0.09 0.93 0.485 1.042 0.998l0.02 0.088c0.35 1.598 2.261 1.908 3.21 0.92h0.6a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1 -1.5 1.5h-11a1.5 1.5 0 0 1 -1.5 -1.5v-2a1.5 1.5 0 0 1 1.5 -1.5h1.14l0.655 -1.978 0.001 -0.002a1.5 1.5 0 0 1 1.486 -1.02h1.485Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.998 12.467a1.501 1.501 0 1 0 3.002 0 1.501 1.501 0 0 0 -3.002 0Zm7 0a1.501 1.501 0 1 0 3.002 0 1.501 1.501 0 0 0 -3.002 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.316 0.655c-0.19 -0.834 -1.382 -0.83 -1.565 0.007l-0.007 0.033L9.73 0.76a2.38 2.38 0 0 1 -1.916 1.826c-0.87 0.152 -0.87 1.402 0 1.553a2.38 2.38 0 0 1 1.918 1.837l0.02 0.087c0.182 0.837 1.373 0.842 1.563 0.007l0.024 -0.102a2.396 2.396 0 0 1 1.925 -1.827c0.872 -0.152 0.872 -1.404 0 -1.556a2.396 2.396 0 0 1 -1.94 -1.89l-0.008 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiVehicleSpark1"
);
var ApplicationAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.846 0h-3.77C0.483 0 0 0.482 0 1.077v3.77c0 0.594 0.482 1.076 1.077 1.076h3.77c0.594 0 1.076 -0.482 1.076 -1.077v-3.77C5.923 0.483 5.441 0 4.846 0Zm8.077 8.077h-3.77c-0.594 0 -1.076 0.482 -1.076 1.077v3.77c0 0.594 0.482 1.076 1.077 1.076h3.77c0.594 0 1.076 -0.482 1.076 -1.077v-3.77c0 -0.594 -0.482 -1.076 -1.077 -1.076Zm-11.846 0h3.77c0.594 0 1.076 0.482 1.076 1.077v3.77c0 0.594 -0.482 1.076 -1.077 1.076h-3.77A1.077 1.077 0 0 1 0 12.923v-3.77c0 -0.594 0.482 -1.076 1.077 -1.076Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.51 0.75a0.75 0.75 0 1 0 -1.5 0v1.733H8.279a0.75 0.75 0 1 0 0 1.5h1.733v1.732a0.75 0.75 0 0 0 1.5 0V3.983h1.732a0.75 0.75 0 1 0 0 -1.5h-1.732V0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ApplicationAdd"
);
var ArtificialIntelligenceSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.625 5.496c0.44 0.136 0.78 0.5 0.881 0.959l0.02 0.087c0.43 1.971 3.237 1.984 3.686 0.017l0.023 -0.103a1.308 1.308 0 0 1 1.051 -0.998c0.093 -0.016 0.18 -0.037 0.265 -0.063 0.284 0.6 0.449 1.297 0.449 2.004 0 1.093 -0.393 2.404 -1.017 3.074a2.997 2.997 0 0 1 -5.358 2.084V5.495Zm-1.25 -3.148c-0.62 0.698 -0.62 1.824 0 2.522v7.686a2.997 2.997 0 0 1 -5.358 -2.084C0.393 9.803 0 8.493 0 7.4c0 -1.491 0.73 -2.94 1.779 -3.51a2.618 2.618 0 0 1 4.596 -1.982v0.44Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.974 7.494c0.268 -0.39 0.384 -0.817 0.4 -1.022v2.415a2.69 2.69 0 0 1 -1.404 0.584 0.625 0.625 0 0 1 -0.139 -1.242c0.509 -0.057 0.879 -0.349 1.143 -0.735Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.822 4.763c0.27 -0.373 0.594 -0.675 0.957 -0.872a2.648 2.648 0 0 1 -0.016 -0.282c0.039 0.39 0.198 0.681 0.382 0.891 0.229 0.26 0.47 0.367 0.527 0.38a0.625 0.625 0 1 1 -0.278 1.22c-0.359 -0.083 -0.82 -0.355 -1.188 -0.775a2.813 2.813 0 0 1 -0.384 -0.562Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.04 11.168a3.02 3.02 0 0 1 -0.023 -0.695 3.148 3.148 0 0 1 -0.534 -0.836c0.08 -0.09 0.167 -0.172 0.26 -0.245a0.625 0.625 0 0 1 0.774 0.981c-0.178 0.14 -0.364 0.444 -0.478 0.795Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m12.99 10.465 -0.023 -0.001a1.723 1.723 0 0 1 -0.476 -0.11c-0.363 -0.136 -0.801 -0.42 -1.183 -0.975a0.625 0.625 0 0 0 -1.03 0.71c0.53 0.77 1.178 1.211 1.773 1.435 0.265 0.1 0.531 0.16 0.778 0.183a2.99 2.99 0 0 0 0.154 -1.234l0.007 -0.008Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.152 0.902c-0.19 -0.835 -1.382 -0.83 -1.565 0.007L9.58 0.942l-0.014 0.064A2.38 2.38 0 0 1 7.65 2.833c-0.87 0.152 -0.87 1.401 0 1.553a2.38 2.38 0 0 1 1.918 1.836l0.02 0.088c0.182 0.836 1.373 0.842 1.564 0.007l0.023 -0.102A2.396 2.396 0 0 1 13.1 4.387c0.872 -0.151 0.872 -1.404 0 -1.555a2.396 2.396 0 0 1 -1.922 -1.813L11.16 0.942l-0.008 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ArtificialIntelligenceSpark"
);
var BracesCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.25C3.27208 0.25 0.25 3.27208 0.25 7c0 3.7279 3.02208 6.75 6.75 6.75 3.7279 0 6.75 -3.0221 6.75 -6.75C13.75 3.27208 10.7279 0.25 7 0.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 3.875c-0.61987 0 -1.682 0.46964 -1.75729 1.73594 -0.02606 0.43838 -0.16583 0.65185 -0.29795 0.71791l-0.22427 0.11213C3.00875 6.54685 2.875 6.76327 2.875 7c0 0.23673 0.13375 0.45315 0.34549 0.55902l0.22427 0.11213c0.13212 0.06606 0.27189 0.27953 0.29795 0.71791C3.818 9.65536 4.88013 10.125 5.5 10.125c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625c-0.05636 0 -0.18949 -0.02979 -0.30517 -0.12172 -0.09564 -0.07601 -0.19023 -0.20147 -0.20432 -0.43841C4.96748 7.92756 4.8653 7.40768 4.5482 7c0.3171 -0.40768 0.41928 -0.92756 0.44231 -1.31487 0.01409 -0.23694 0.10868 -0.3624 0.20432 -0.43841 0.11568 -0.09193 0.24881 -0.12172 0.30517 -0.12172 0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625Zm3 0c0.61987 0 1.682 0.46964 1.7573 1.73594 0.026 0.43838 0.1658 0.65185 0.2979 0.71791l0.2243 0.11213c0.2117 0.10587 0.3455 0.32229 0.3455 0.55902 0 0.23673 -0.1338 0.45315 -0.3455 0.55902l-0.2243 0.11213c-0.1321 0.06606 -0.2719 0.27953 -0.2979 0.71791C10.182 9.65536 9.11987 10.125 8.5 10.125c-0.34518 0 -0.625 -0.27982 -0.625 -0.625s0.27982 -0.625 0.625 -0.625c0.05636 0 0.18949 -0.02979 0.30517 -0.12172 0.09564 -0.07601 0.19023 -0.20147 0.20432 -0.43841 0.02303 -0.38731 0.12521 -0.90719 0.44231 -1.31487 -0.3171 -0.40768 -0.41928 -0.92756 -0.44231 -1.31487 -0.01409 -0.23694 -0.10868 -0.3624 -0.20432 -0.43841C8.68949 5.15479 8.55636 5.125 8.5 5.125c-0.34518 0 -0.625 -0.27982 -0.625 -0.625s0.27982 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BracesCircle"
);
var Bracket = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.476 2.893a1 1 0 1 0 -1.46 1.367L11.578 7 9.015 9.74a1 1 0 1 0 1.46 1.367l3.204 -3.424a1 1 0 0 0 0 -1.366l-3.203 -3.424ZM4.985 4.26a1 1 0 1 0 -1.46 -1.367L0.32 6.317a1 1 0 0 0 0 1.366l3.203 3.424a1 1 0 0 0 1.46 -1.367L2.422 7l2.564 -2.74Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bracket"
);
var BrowserAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 6.227a0.75 0.75 0 0 0 -1.5 0v1.75H4.5a0.75 0.75 0 0 0 0 1.5h1.75v1.75a0.75 0.75 0 0 0 1.5 0v-1.75H9.5a0.75 0.75 0 0 0 0 -1.5H7.75v-1.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserAdd"
);
var BrowserBuild = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.75 0.790039c0 -0.414214 -0.3358 -0.7499999 -0.75 -0.7499999 -0.41421 0 -0.75 0.3357869 -0.75 0.7499999V1.99677l-8.447693 0c-0.414213 0 -0.7499999 0.33579 -0.7499999 0.75s0.3357869 0.75 0.7499999 0.75l8.447693 0V7.5c0 0.41421 0.33579 0.75 0.75 0.75 0.4142 0 0.75 -0.33579 0.75 -0.75V3.49677l2.46 0c0.4142 0 0.75 -0.33579 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75l-2.46 0V0.790039Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.74541 0.0400391c-0.45229 0 -0.886058 0.1796729 -1.205878 0.4994929S0.0400391 1.29312 0.0400391 1.74541V12.2545c0 0.4523 0.1796729 0.8861 0.4994929 1.2059 0.31982 0.3199 0.753588 0.4995 1.205878 0.4995H12.2545c0.4523 0 0.8861 -0.1796 1.2059 -0.4995 0.3199 -0.3198 0.4995 -0.7536 0.4995 -1.2059V7.47767c0 -0.41421 -0.3358 -0.75 -0.75 -0.75H6.31692V0.790039c0 -0.414214 -0.33579 -0.7499999 -0.75 -0.7499999H1.74541Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.74541 0.0400391c-0.45229 0 -0.886058 0.1796729 -1.205878 0.4994929S0.0400391 1.29312 0.0400391 1.74541V3.5H6.31692V0.790039c0 -0.414214 -0.33579 -0.7499999 -0.75 -0.7499999H1.74541Z" }),
    " "
  ] }) }),
  "BrowserBuild"
);
var BrowserCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.994 6.163a0.75 0.75 0 0 1 0.07 1.058l-3.5 4a0.75 0.75 0 0 1 -1.014 0.106l-2 -1.5a0.75 0.75 0 1 1 0.9 -1.2L5.894 9.71l3.042 -3.477a0.75 0.75 0 0 1 1.058 -0.07Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserCheck"
);
var BrowserDelete = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75058 0.0461426C0.809244 0.0461426 0.0461426 0.809244 0.0461426 1.75058V12.2494c0 0.9413 0.7631014 1.7044 1.7044374 1.7044H12.2494c0.9413 0 1.7044 -0.7631 1.7044 -1.7044V1.75058c0 -0.941336 -0.7631 -1.7044374 -1.7044 -1.7044374H1.75058Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75058 0.0461426C0.809244 0.0461426 0.0461426 0.809244 0.0461426 1.75058v1.74936H13.9538V1.75058c0 -0.941336 -0.7631 -1.7044374 -1.7044 -1.7044374H1.75058Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.53033 6.1966c-0.29289 -0.29289 -0.76777 -0.29289 -1.06066 0s-0.29289 0.76777 0 1.06066l1.46967 1.46967 -1.46967 1.46967c-0.29289 0.2929 -0.29289 0.7678 0 1.0607 0.29289 0.2929 0.76777 0.2929 1.06066 0L7 9.78759l1.46967 1.46971c0.29289 0.2929 0.76777 0.2929 1.06066 0s0.29289 -0.7678 0 -1.0607L8.06066 8.72693l1.46967 -1.46967c0.29289 -0.29289 0.29289 -0.76777 0 -1.06066s-0.76777 -0.29289 -1.06066 0L7 7.66627 5.53033 6.1966Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserDelete"
);
var BrowserHash = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.255 6.319a0.75 0.75 0 1 0 -1.419 -0.486l-0.294 0.857H4.275a0.75 0.75 0 0 0 0 1.5h0.753l-0.42 1.225h-0.787a0.75 0.75 0 0 0 0 1.5h0.274l-0.075 0.22a0.75 0.75 0 0 0 1.419 0.486l0.241 -0.706h1.14l-0.075 0.22a0.75 0.75 0 0 0 1.419 0.486l0.242 -0.706h1.32a0.75 0.75 0 0 0 0 -1.5h-0.807l0.42 -1.225h0.84a0.75 0.75 0 0 0 0 -1.5h-0.326l0.127 -0.371a0.75 0.75 0 1 0 -1.419 -0.486l-0.293 0.857h-1.14l0.127 -0.371Zm0.079 3.096 0.42 -1.225h-1.14l-0.42 1.225h1.14Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserHash"
);
var BrowserMultipleWindow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m4.594 0.03 7.644 0c0.941 0 1.704 0.763 1.704 1.704v6.49c0 0.94 -0.763 1.704 -1.704 1.704H10.81V8.201a2.954 2.954 0 0 0 -2.955 -2.954l-4.966 0V1.734A1.705 1.705 0 0 1 4.594 0.03Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m12.238 0.03 -7.644 0c-0.942 0 -1.705 0.763 -1.705 1.704V3h11.053V1.734c0 -0.941 -0.763 -1.704 -1.704 -1.704Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m7.855 6.497 -6.046 0c-0.941 0 -1.704 0.763 -1.704 1.704v4.032c0 0.941 0.763 1.704 1.704 1.704l6.046 0c0.941 0 1.705 -0.763 1.705 -1.704V8.2c0 -0.941 -0.764 -1.704 -1.705 -1.704Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m7.855 6.497 -6.046 0c-0.941 0 -1.704 0.763 -1.704 1.704V9.5H9.56V8.2c0 -0.941 -0.764 -1.704 -1.705 -1.704Z" }),
    " "
  ] }) }),
  "BrowserMultipleWindow"
);
var BrowserRemove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.128 8.5a0.75 0.75 0 0 1 0.75 -0.75h4.244a0.75 0.75 0 0 1 0 1.5H4.878a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserRemove"
);
var Bug = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.798 3.822a4.05 4.05 0 0 1 3.079 1.404 0.75 0.75 0 1 1 -1.136 0.98 2.55 2.55 0 0 0 -1.939 -0.884 0.75 0.75 0 0 1 -0.004 -1.5ZM0.8 7.16a0.75 0.75 0 1 0 0 1.5h1.908a0.75 0.75 0 0 0 0 -1.5H0.8Zm3.077 3.434a0.75 0.75 0 1 0 -1.136 -0.98 2.55 2.55 0 0 1 -1.939 0.884 0.75 0.75 0 1 0 -0.004 1.5 4.051 4.051 0 0 0 3.079 -1.404Zm7.415 -3.434a0.75 0.75 0 0 0 0 1.5H13.2a0.75 0.75 0 0 0 0 -1.5h-1.908Zm-1.09 2.376a0.75 0.75 0 0 1 1.057 0.078 2.55 2.55 0 0 0 1.939 0.884 0.75 0.75 0 0 1 0.004 1.5 4.05 4.05 0 0 1 -3.079 -1.404 0.75 0.75 0 0 1 0.078 -1.058Zm1.93 -3.984a2.55 2.55 0 0 1 1.066 -0.23 0.75 0.75 0 0 0 0.004 -1.5 4.05 4.05 0 0 0 -3.079 1.404 0.75 0.75 0 1 0 1.136 0.98 2.55 2.55 0 0 1 0.873 -0.654Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.365 1.71a0.75 0.75 0 1 0 -1.5 0 3.135 3.135 0 0 0 1.58 2.721 0.75 0.75 0 0 0 0.744 -1.302 1.635 1.635 0 0 1 -0.824 -1.419Zm4.77 0a0.75 0.75 0 1 0 -1.5 0 1.634 1.634 0 0 1 -0.825 1.42 0.75 0.75 0 0 0 0.744 1.302 3.135 3.135 0 0 0 1.58 -2.72Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2.92a5.06 5.06 0 1 0 0 10.12A5.06 5.06 0 0 0 7 2.92Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 2.92a5.062 5.062 0 0 0 -4.822 3.522h9.644A5.062 5.062 0 0 0 7 2.92Z" }),
    " "
  ] }) }),
  "Bug"
);
var CloudAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.88332 0.0605549C6.89147 -0.05967 5.88837 0.163768 5.04132 0.693609 4.253 1.18671 3.64418 1.91745 3.30086 2.77774c-0.42873 0.0473 -0.84627 0.16939 -1.23354 0.36114 -0.43457 0.21517 -0.8225 0.51382 -1.141648 0.87891 -0.644549 0.73733 -0.9697938 1.70051 -0.904186 2.67765 0.0656077 0.97713 0.516694 1.88818 1.254024 2.53273 0.37776 0.33022 0.81479 0.57663 1.28261 0.72961C2.77333 9.08534 3.56111 8.43839 4.5 8.43839H5v-0.5c0 -1.10457 0.89543 -2 2 -2s2 0.89543 2 2v0.5h0.5c0.9735 0 1.7846 0.69558 1.9633 1.61691 0.5367 -0.12038 1.0376 -0.37667 1.4524 -0.74935 0.588 -0.52837 0.9618 -1.254 1.0507 -2.0395 0.0889 -0.78549 -0.1133 -1.57632 -0.5684 -2.22274 -0.4174 -0.593 -1.021 -1.0267 -1.7119 -1.23428 -0.1253 -0.92328 -0.543 -1.78422 -1.1943 -2.45516C9.79584 0.637401 8.87518 0.18078 7.88332 0.0605549Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 7.93835c0 -0.41421 -0.33579 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v1.75H4.5c-0.41421 0 -0.75 0.33575 -0.75 0.75005 0 0.4142 0.33579 0.75 0.75 0.75h1.75v1.75c0 0.4142 0.33579 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75v-1.75H9.5c0.41421 0 0.75 -0.3358 0.75 -0.75 0 -0.4143 -0.33579 -0.75005 -0.75 -0.75005H7.75v-1.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudAdd"
);
var CloudBlock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.041 0.748a4.368 4.368 0 0 1 6.645 3.115 3.23 3.23 0 0 1 0.208 6.118 4.906 4.906 0 0 0 -9.776 -0.145 3.692 3.692 0 0 1 1.183 -7.004A4.368 4.368 0 0 1 5.04 0.748Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.127 10.325a2.127 2.127 0 0 0 -3.004 -1.939l2.815 2.816a2.12 2.12 0 0 0 0.19 -0.877Zm0.485 2.516a3.627 3.627 0 1 0 -5.225 -5.032 3.627 3.627 0 0 0 5.225 5.032Zm-1.734 -0.578L5.062 9.447a2.127 2.127 0 0 0 2.816 2.816Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudBlock"
);
var CloudCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.041 0.748a4.368 4.368 0 0 1 6.645 3.115 3.23 3.23 0 0 1 -0.91 6.324l-0.003 0h-0.016l0.738 -0.83A2 2 0 1 0 8.505 6.7L5.728 9.823 5.2 9.428a2 2 0 0 0 -2.87 0.5 3.692 3.692 0 0 1 0.97 -7.096A4.368 4.368 0 0 1 5.042 0.748Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.498 7.468a0.75 0.75 0 0 1 0.063 1.059l-4 4.5a0.75 0.75 0 0 1 -1.011 0.101l-2 -1.5a0.75 0.75 0 0 1 0.9 -1.2l1.448 1.086L9.439 7.53a0.75 0.75 0 0 1 1.06 -0.062Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudCheck"
);
var CloudDataTransfer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.883 0.115a4.368 4.368 0 0 0 -4.582 2.717 3.693 3.693 0 0 0 -1.706 6.7 1.998 1.998 0 0 1 0.557 -1.753l2 -2A2 2 0 0 1 7 5.799a2 2 0 0 1 3.434 1.394v2a1.994 1.994 0 0 1 1.56 0.748 3.229 3.229 0 0 0 -0.308 -6.078A4.368 4.368 0 0 0 7.883 0.115Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.316 7.193a0.75 0.75 0 0 0 -1.28 -0.53l-2 2a0.75 0.75 0 1 0 1.06 1.06l0.72 -0.72v4.19a0.75 0.75 0 0 0 1.5 0v-6Zm2.868 4.19v-4.19a0.75 0.75 0 1 0 -1.5 0v6a0.75 0.75 0 0 0 1.28 0.53l2 -2a0.75 0.75 0 0 0 -1.06 -1.06l-0.72 0.72Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudDataTransfer"
);
var CloudRefresh = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.041 0.68a4.368 4.368 0 0 1 6.645 3.115 3.23 3.23 0 0 1 -0.015 6.192l0.207 -0.563a2 2 0 0 0 -2.583 -2.56 4.501 4.501 0 0 0 -6.726 3.083A3.692 3.692 0 0 1 3.3 2.763 4.368 4.368 0 0 1 5.04 0.68Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.25 10.736A1.75 1.75 0 0 1 7.841 9.2l-0.239 0.149a0.75 0.75 0 0 0 0.27 1.375l1.434 0.247a0.747 0.747 0 0 0 0.818 -0.406 0.742 0.742 0 0 0 0.035 -0.085l0.545 -1.487A0.75 0.75 0 0 0 9.602 8.1l-0.397 0.248a3.25 3.25 0 1 0 -0.102 4.865 0.75 0.75 0 0 0 -0.971 -1.143 1.75 1.75 0 0 1 -2.882 -1.335Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudRefresh"
);
var CloudShare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.041 0.68a4.368 4.368 0 0 1 6.645 3.115 3.23 3.23 0 0 1 -0.447 6.288A2.75 2.75 0 1 0 6.36 7.709l-0.4 0.2a2.751 2.751 0 0 0 -3.64 1.949 3.692 3.692 0 0 1 0.98 -7.095A4.368 4.368 0 0 1 5.04 0.68Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.5 8.486a1.5 1.5 0 1 1 0.56 1.168l-1.56 0.78a1.532 1.532 0 0 1 0 0.102l1.56 0.78a1.5 1.5 0 1 1 -0.559 1.118l-1.56 -0.78a1.5 1.5 0 1 1 0 -2.338l1.56 -0.78 -0.001 -0.05Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudShare"
);
var CloudWarning = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.046 0.68a4.375 4.375 0 0 1 6.65 3.115 3.233 3.233 0 0 1 2.283 3.457 3.23 3.23 0 0 1 -3.193 2.867l-0.003 0H9.008V7.14a2 2 0 0 0 -4.003 0v2.98H3.939A3.698 3.698 0 0 1 0.022 6.681a3.69 3.69 0 0 1 3.282 -3.918A4.369 4.369 0 0 1 5.046 0.68Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.757 7.14a0.75 0.75 0 1 0 -1.5 0v3.5a0.75 0.75 0 1 0 1.5 0v-3.5Zm-0.75 6.846a1 1 0 1 0 0 -2.001 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudWarning"
);
var CloudWifi = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.98 0.07c-1.32 0 -2.624 0.31 -3.832 0.907a0.75 0.75 0 0 0 0.664 1.344A7.128 7.128 0 0 1 6.98 1.57c1.084 0 2.16 0.254 3.168 0.752a0.75 0.75 0 1 0 0.664 -1.344A8.628 8.628 0 0 0 6.98 0.069Zm2.098 2.748a5.255 5.255 0 0 0 -4.156 0 0.75 0.75 0 0 0 0.587 1.38 3.755 3.755 0 0 1 2.982 0 0.75 0.75 0 1 0 0.587 -1.38Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.753 5.336A3.757 3.757 0 0 0 3.83 7.63a3.189 3.189 0 0 0 0.593 6.346h5.755l0.003 0a2.8 2.8 0 0 0 0.837 -5.465 3.757 3.757 0 0 0 -3.264 -3.175Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudWifi"
);
var Cloud = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.913 2.38A5 5 0 1 0 5 12h6a3 3 0 0 0 0 -6v0.5l0 -0.5a3.01 3.01 0 0 0 -1.065 0.196 5 5 0 0 0 -3.022 -3.815Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cloud"
);
var CodeAnalysis = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.36 11.953a5.594 5.594 0 1 0 0 -11.187 5.594 5.594 0 0 0 0 11.187Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.516 6.36a4.844 4.844 0 1 1 9.687 0 4.844 4.844 0 0 1 -9.687 0ZM6.359 0.015a6.344 6.344 0 1 0 3.723 11.48l2.195 2.195a1 1 0 0 0 1.415 -1.414l-2.196 -2.195A6.344 6.344 0 0 0 6.36 0.016Zm-0.745 4.026a0.625 0.625 0 0 1 0 0.884L4.056 6.484l1.558 1.558a0.625 0.625 0 0 1 -0.884 0.884l-2 -2a0.625 0.625 0 0 1 0 -0.884l2 -2a0.625 0.625 0 0 1 0.884 0Zm2.5 0a0.625 0.625 0 0 0 -0.884 0.884l1.558 1.558L7.23 8.042a0.625 0.625 0 0 0 0.884 0.884l2 -2a0.625 0.625 0 0 0 0 -0.884l-2 -2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CodeAnalysis"
);
var CodeMonitor1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.105 10.148a0.5 0.5 0 0 0 -0.47 0.332l-0.687 1.918H4a0.75 0.75 0 0 0 0 1.5h6a0.75 0.75 0 0 0 0 -1.5h-0.948l-0.686 -1.918a0.5 0.5 0 0 0 -0.471 -0.332h-1.79Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.518 0.813C0.714 0.813 0.062 1.465 0.062 2.27v7.309c0 0.804 0.652 1.456 1.456 1.456h10.963c0.805 0 1.457 -0.652 1.457 -1.457V2.314a1.5 1.5 0 0 0 -1.5 -1.5H1.518Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.462 3.987a0.75 0.75 0 1 0 -1.424 -0.474l-1.5 4.5a0.75 0.75 0 1 0 1.424 0.474l1.5 -4.5Zm-3.393 0.275a0.75 0.75 0 0 1 -0.08 1.058l-1.077 0.922 0.818 0.682a0.75 0.75 0 1 1 -0.96 1.152l-1.5 -1.25a0.75 0.75 0 0 1 -0.008 -1.145l1.75 -1.5a0.75 0.75 0 0 1 1.057 0.081Zm4.105 0.258a0.75 0.75 0 0 1 1.056 -0.096l1.5 1.25a0.75 0.75 0 0 1 0.008 1.146l-1.75 1.5a0.75 0.75 0 0 1 -0.976 -1.14l1.076 -0.922 -0.818 -0.682a0.75 0.75 0 0 1 -0.096 -1.056Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CodeMonitor1"
);
var CodeMonitor2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.105 10.245a0.5 0.5 0 0 0 -0.47 0.332l-0.687 1.918H4a0.75 0.75 0 1 0 0 1.5h6a0.75 0.75 0 0 0 0 -1.5h-0.948l-0.686 -1.918a0.5 0.5 0 0 0 -0.471 -0.332h-1.79Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.75C0.79 0.75 0.25 1.29 0.25 1.957v7.586c0 0.667 0.54 1.207 1.207 1.207h11.086c0.667 0 1.207 -0.54 1.207 -1.207V1.957c0 -0.667 -0.54 -1.207 -1.207 -1.207H1.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.457 0.75C0.79 0.75 0.25 1.29 0.25 1.957v7.586c0 0.667 0.54 1.207 1.207 1.207H6v-10H1.457Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.897 9.25h4.13a0.25 0.25 0 0 0 0.28 -0.26v-1.2a0.22 0.22 0 0 0 -0.09 -0.19l-1.81 -1.56a1.37 1.37 0 0 0 -1.75 0l-0.88 0.71a0.22 0.22 0 0 0 -0.12 0.17V9a0.25 0.25 0 0 0 0.24 0.25Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.276 3.87h-1.75a0.63 0.63 0 1 0 0 1.26h1.75a0.63 0.63 0 0 0 0 -1.26Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.526 6.37h-1a0.63 0.63 0 1 0 0 1.26h1a0.63 0.63 0 0 0 0 -1.26Z" }),
    " "
  ] }) }),
  "CodeMonitor2"
);
var Command = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.332 2.107a0.908 0.908 0 1 0 -0.347 1.746h0.907v-0.907a0.908 0.908 0 0 0 -0.56 -0.839Zm2.56 1.746v-0.907a2.908 2.908 0 1 0 -2.908 2.907h0.908v2.255h-0.907a2.908 2.908 0 1 0 2.907 2.907v-0.907h2.255v0.907a2.908 2.908 0 1 0 2.908 -2.907h-0.908V5.853h0.908a2.908 2.908 0 1 0 -2.908 -2.907v0.907H5.892Zm0 2v2.255h2.255V5.853H5.892Zm4.255 -2h0.908a0.908 0.908 0 1 0 -0.908 -0.907v0.907Zm0 6.255v0.907a0.908 0.908 0 1 0 0.908 -0.907h-0.908Zm-6.255 0h-0.907a0.908 0.908 0 1 0 0.907 0.907v-0.907Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Command"
);
var ComputerChip1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.85992 0.8573c0 -0.414214 -0.33578 -0.75 -0.75 -0.75 -0.41421 0 -0.75 0.335786 -0.75 0.75v2.36257c0 0.41422 0.33579 0.75 0.75 0.75 0.41422 0 0.75 -0.33578 0.75 -0.75V0.8573Zm3.78016 0c0 -0.414214 -0.33579 -0.75 -0.75 -0.75 -0.41422 0 -0.75 0.335786 -0.75 0.75v2.36257c0 0.41422 0.33578 0.75 0.75 0.75 0.41421 0 0.75 -0.33578 0.75 -0.75V0.8573ZM0.1073 8.89008c0 -0.41422 0.335786 -0.75 0.75 -0.75h2.36257c0.41422 0 0.75 0.33578 0.75 0.75 0 0.41421 -0.33578 0.75 -0.75 0.75H0.8573c-0.414214 0 -0.75 -0.33579 -0.75 -0.75Zm0.75 -4.53016c-0.414214 0 -0.75 0.33579 -0.75 0.75 0 0.41422 0.335786 0.75 0.75 0.75h2.36257c0.41422 0 0.75 -0.33578 0.75 -0.75 0 -0.41421 -0.33578 -0.75 -0.75 -0.75H0.8573Zm8.03278 5.67018c0.41421 0 0.75 0.3358 0.75 0.75v2.3626c0 0.4142 -0.33579 0.75 -0.75 0.75 -0.41422 0 -0.75 -0.3358 -0.75 -0.75v-2.3626c0 -0.4142 0.33578 -0.75 0.75 -0.75Zm-3.03016 0.75c0 -0.4142 -0.33578 -0.75 -0.75 -0.75 -0.41421 0 -0.75 0.3358 -0.75 0.75v2.3626c0 0.4142 0.33579 0.75 0.75 0.75 0.41422 0 0.75 -0.3358 0.75 -0.75v-2.3626Zm4.17018 -5.67018c0 -0.41421 0.3358 -0.75 0.75 -0.75h2.3626c0.4142 0 0.75 0.33579 0.75 0.75 0 0.41422 -0.3358 0.75 -0.75 0.75h-2.3626c-0.4142 0 -0.75 -0.33578 -0.75 -0.75Zm0.75 3.03016c-0.4142 0 -0.75 0.33578 -0.75 0.75 0 0.41421 0.3358 0.75 0.75 0.75h2.3626c0.4142 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.3358 -0.75 -0.75 -0.75h-2.3626Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 2.5c-0.82843 0 -1.5 0.67157 -1.5 1.5v6c0 0.8284 0.67157 1.5 1.5 1.5h6c0.8284 0 1.5 -0.6716 1.5 -1.5V4c0 -0.82843 -0.6716 -1.5 -1.5 -1.5H4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.78394 9c0 -0.34518 0.27982 -0.625 0.625 -0.625h2c0.34517 0 0.62496 0.27982 0.62496 0.625s-0.27979 0.625 -0.62496 0.625h-2c-0.34518 0 -0.625 -0.27982 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ComputerChip1"
);
var ComputerChip2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.057 3.085a0.75 0.75 0 0 1 0.75 -0.75h2.38a0.75 0.75 0 0 1 0 1.5h-2.38a0.75 0.75 0 0 1 -0.75 -0.75Zm0.75 3.165a0.75 0.75 0 0 0 0 1.5h2.38a0.75 0.75 0 0 0 0 -1.5h-2.38Zm0 3.915a0.75 0.75 0 0 0 0 1.5h2.38a0.75 0.75 0 0 0 0 -1.5h-2.38Zm-9.994 0a0.75 0.75 0 0 0 0 1.5h2.38a0.75 0.75 0 0 0 0 -1.5H0.813ZM0.063 7a0.75 0.75 0 0 1 0.75 -0.75h2.38a0.75 0.75 0 0 1 0 1.5H0.813A0.75 0.75 0 0 1 0.063 7Zm0.75 -4.665a0.75 0.75 0 1 0 0 1.5h2.38a0.75 0.75 0 0 0 0 -1.5H0.813Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 0a1.5 1.5 0 0 0 -1.5 1.5v11A1.5 1.5 0 0 0 4 14h6a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 10 0H4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.723 11.807c0 -0.345 0.28 -0.625 0.625 -0.625h2a0.625 0.625 0 1 1 0 1.25h-2a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ComputerChip2"
);
var CurlyBrackets = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.591 0.375c-0.96649 0 -1.75 0.7835 -1.75 1.75v2.76984c0 0.42591 -0.21685 0.8225 -0.57541 1.05235l-0.80364 0.51515c-0.21514 0.13791 -0.34525 0.37587 -0.34525 0.63141 0 0.25554 0.13011 0.4935 0.34525 0.63141l0.80364 0.51515c0.35856 0.22985 0.57541 0.62645 0.57541 1.05235v2.76984c0 0.9665 0.78351 1.75 1.75 1.75h0.38588c0.41422 0 0.75 -0.3358 0.75 -0.75s-0.33578 -0.75 -0.75 -0.75H5.591c-0.13807 0 -0.25 -0.1119 -0.25 -0.25V9.29266c0 -0.86872 -0.41009 -1.68202 -1.09851 -2.19891C4.93091 6.57686 5.341 5.76356 5.341 4.89484V2.125c0 -0.13807 0.11193 -0.25 0.25 -0.25h0.38588c0.41422 0 0.75 -0.33579 0.75 -0.75 0 -0.414214 -0.33578 -0.75 -0.75 -0.75H5.591Zm3.16077 0c0.9665 0 1.75003 0.7835 1.75003 1.75v2.76984c0 0.42591 0.2168 0.8225 0.5754 1.05235l0.8036 0.51515c0.2152 0.13791 0.3453 0.37587 0.3453 0.63141 0 0.25554 -0.1301 0.4935 -0.3453 0.63141l-0.8036 0.51515c-0.3586 0.22985 -0.5754 0.62645 -0.5754 1.05235v2.76984c0 0.9665 -0.78353 1.75 -1.75003 1.75h-0.38588c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75h0.38588c0.13807 0 0.25 -0.1119 0.25 -0.25V9.29266c0 -0.86872 0.41009 -1.68202 1.09853 -2.19891 -0.68844 -0.51689 -1.09853 -1.33019 -1.09853 -2.19891V2.125c0 -0.13807 -0.11193 -0.25 -0.25 -0.25h-0.38588c-0.41421 0 -0.75 -0.33579 -0.75 -0.75 0 -0.414214 0.33579 -0.75 0.75 -0.75h0.38588Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CurlyBrackets"
);
var Cyborg2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 3.187a1.66 1.66 0 0 0 1.5 0v1.782h-1.5V3.187Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.031a1.667 1.667 0 1 0 0 3.334A1.667 1.667 0 0 0 7 0.03Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 4.969a2.5 2.5 0 0 0 -2.5 2.5v4a2.5 2.5 0 0 0 2.5 2.5h7a2.5 2.5 0 0 0 2.5 -2.5v-4a2.5 2.5 0 0 0 -2.5 -2.5h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.042 9.198a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Zm4.137 1.253a0.625 0.625 0 0 1 0.026 0.884c-0.552 0.586 -1.432 0.815 -2.205 0.815 -0.773 0 -1.653 -0.23 -2.205 -0.815a0.625 0.625 0 1 1 0.91 -0.858c0.225 0.24 0.707 0.423 1.295 0.423s1.07 -0.183 1.295 -0.423a0.625 0.625 0 0 1 0.884 -0.026Zm0.53 -2.003a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cyborg2"
);
var Cyborg = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 1.54a0.75 0.75 0 1 0 -1.5 0v2.515a8.567 8.567 0 0 1 1.5 0l0 -2.514Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 4.022c-1.592 0 -3.074 0.428 -4.17 1.291 -1.109 0.874 -1.788 2.17 -1.788 3.81v3.33a1.5 1.5 0 0 0 1.5 1.5h8.916a1.5 1.5 0 0 0 1.5 -1.5v-3.33c0 -1.64 -0.68 -2.936 -1.788 -3.81 -1.096 -0.863 -2.578 -1.29 -4.17 -1.29Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.046a1.562 1.562 0 1 0 0 3.125A1.562 1.562 0 0 0 7 0.046Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 7.75a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0Zm4.5 0a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0Zm3.019 1.737h1.44v1.25h-1.44a0.375 0.375 0 0 0 -0.312 0.168l-0.294 0.441a1.625 1.625 0 0 1 -1.353 0.726H4.44a1.625 1.625 0 0 1 -1.353 -0.726l-0.294 -0.441a0.375 0.375 0 0 0 -0.312 -0.168H1.048l-0.006 0v-1.25l0.006 0H2.48c0.544 0 1.052 0.273 1.353 0.726l0.294 0.441c0.07 0.105 0.186 0.168 0.312 0.168h5.12a0.375 0.375 0 0 0 0.312 -0.168l0.294 -0.441c0.3 -0.453 0.809 -0.726 1.353 -0.726Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cyborg"
);
var DatabaseCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 9.882V2l11.5 0v5.515l-2.588 2.912 -0.528 -0.396a2 2 0 0 0 -3.067 2.319C2.344 12.254 0 11.185 0 9.882Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 7.115V5.46c0.045 0.083 0.12 0.18 0.241 0.292 0.249 0.225 0.643 0.458 1.183 0.665C2.501 6.83 4.03 7.1 5.75 7.1c1.72 0 3.25 -0.27 4.326 -0.684 0.54 -0.207 0.934 -0.44 1.183 -0.665 0.122 -0.111 0.197 -0.209 0.241 -0.292v1.656a6.236 6.236 0 0 1 -0.975 0.468c-1.253 0.482 -2.941 0.767 -4.775 0.767 -1.834 0 -3.522 -0.285 -4.775 -0.767A6.235 6.235 0 0 1 0 7.115Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.682 8.07a0.75 0.75 0 0 1 0.063 1.06l-4 4.5a0.75 0.75 0 0 1 -1.01 0.101l-2 -1.5a0.75 0.75 0 1 1 0.9 -1.2l1.447 1.086 3.542 -3.984a0.75 0.75 0 0 1 1.058 -0.062Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " "
  ] }) }),
  "DatabaseCheck"
);
var DatabaseRefresh = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 9.882V2l11.5 0v4.496a4.484 4.484 0 0 0 -0.762 -0.161c-0.296 -0.036 -0.87 -0.08 -1.413 0.09a1.91 1.91 0 0 0 -0.962 0.655c-0.142 0.187 -0.238 0.39 -0.294 0.598 -0.46 -0.052 -0.94 0.066 -1.338 0.367l-0.841 0.636a1.875 1.875 0 0 0 -0.073 2.934c0.047 0.253 0.117 0.5 0.206 0.739 -0.09 0.002 -0.182 0.003 -0.273 0.003 -3.176 0 -5.75 -1.11 -5.75 -2.475Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 5.46v1.655c0.292 0.176 0.622 0.332 0.975 0.468 1.253 0.482 2.941 0.767 4.775 0.767 0.199 0 0.396 -0.003 0.59 -0.01l0.39 -0.295c0.399 -0.3 0.879 -0.419 1.34 -0.367a1.726 1.726 0 0 1 0.52 -0.843 14.71 14.71 0 0 1 -2.84 0.265c-1.72 0 -3.25 -0.27 -4.326 -0.684 -0.54 -0.207 -0.934 -0.44 -1.183 -0.665A1.128 1.128 0 0 1 0 5.459Zm10.349 0.844a4.477 4.477 0 0 1 1.151 0.192V5.459c-0.044 0.083 -0.12 0.18 -0.241 0.292 -0.205 0.186 -0.508 0.376 -0.91 0.553Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m13.403 10.748 0.058 0.008a0.625 0.625 0 0 1 0.29 1.117l-0.84 0.636a0.625 0.625 0 0 1 -0.876 -0.122l-0.635 -0.84a0.625 0.625 0 0 1 0.585 -0.997l0.16 0.023a1.955 1.955 0 0 0 -2.187 -1.757 0.625 0.625 0 0 1 -0.697 -0.543c-0.093 -0.754 0.818 -0.76 1.326 -0.697a3.205 3.205 0 0 1 2.816 3.172Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.484 9.043a0.625 0.625 0 0 1 0.876 0.121l0.635 0.841a0.625 0.625 0 0 1 -0.584 0.996l-0.161 -0.022a1.955 1.955 0 0 0 2.187 1.757 0.625 0.625 0 1 1 0.153 1.24 3.207 3.207 0 0 1 -3.599 -3.172l-0.057 -0.008a0.625 0.625 0 0 1 -0.29 -1.118l0.84 -0.635Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " "
  ] }) }),
  "DatabaseRefresh"
);
var DatabaseRemove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 2v7.882c0 1.366 2.574 2.475 5.75 2.475 0.525 0 1.033 -0.03 1.516 -0.087a2 2 0 0 1 0.33 -0.434l0.706 -0.706 -0.706 -0.706a2 2 0 0 1 2.828 -2.828l0.706 0.706 0.37 -0.37V1.999L0 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 5.46v1.655c0.292 0.176 0.622 0.332 0.975 0.468 1.253 0.482 2.941 0.767 4.775 0.767 0.475 0 0.941 -0.02 1.392 -0.056a2 2 0 0 1 3.282 -0.698l0.019 0.018 0.082 -0.03c0.353 -0.137 0.683 -0.293 0.975 -0.469V5.46c-0.044 0.083 -0.12 0.18 -0.241 0.292 -0.249 0.225 -0.643 0.458 -1.183 0.665C8.999 6.83 7.47 7.1 5.75 7.1c-1.72 0 -3.25 -0.27 -4.326 -0.684 -0.54 -0.207 -0.934 -0.44 -1.183 -0.665A1.128 1.128 0 0 1 0 5.459Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.78 9.54a0.75 0.75 0 0 0 -1.06 -1.06l-1.59 1.59 -1.59 -1.59a0.75 0.75 0 0 0 -1.06 1.06l1.59 1.59 -1.59 1.59a0.75 0.75 0 1 0 1.06 1.06l1.59 -1.59 1.59 1.59a0.75 0.75 0 1 0 1.06 -1.06l-1.59 -1.59 1.59 -1.59Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " "
  ] }) }),
  "DatabaseRemove"
);
var DatabaseServer1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0.407a1.5 1.5 0 0 0 -1.5 1.5l0 2.925a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5 -1.5l0 -2.925a1.5 1.5 0 0 0 -1.5 -1.5h-11ZM0 9.168a1.5 1.5 0 0 1 1.5 -1.5h11a1.5 1.5 0 0 1 1.5 1.5l0 2.925a1.5 1.5 0 0 1 -1.5 1.5h-11a1.5 1.5 0 0 1 -1.5 -1.5l0 -2.925Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.171 2.245a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0 -2.25ZM2.046 10.63a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1 -2.25 0Zm4.829 -7.26c0 -0.346 0.28 -0.625 0.625 -0.625H11a0.625 0.625 0 1 1 0 1.25H7.5a0.625 0.625 0 0 1 -0.625 -0.625Zm0.625 6.635a0.625 0.625 0 0 0 0 1.25H11a0.625 0.625 0 1 0 0 -1.25H7.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DatabaseServer1"
);
var DatabaseServer2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 10.237a0.75 0.75 0 0 0 -1.5 0v2.25H2a0.75 0.75 0 0 0 0 1.5h10a0.75 0.75 0 0 0 0 -1.5H7.75v-2.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5V3a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 3V1.5A1.5 1.5 0 0 0 12.5 0h-11Zm0 6A1.5 1.5 0 0 0 0 7.5V9a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 14 9V7.5A1.5 1.5 0 0 0 12.5 6h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.75 3a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Zm4.456 -0.75c0 -0.345 0.28 -0.625 0.625 -0.625H11a0.625 0.625 0 1 1 0 1.25H7.83a0.625 0.625 0 0 1 -0.624 -0.625ZM2.75 9a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Zm5.08 -1.375a0.625 0.625 0 1 0 0 1.25H11a0.625 0.625 0 1 0 0 -1.25H7.83Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DatabaseServer2"
);
var DatabaseSetting = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 9.882V2l11.5 0v3.122a1.907 1.907 0 0 0 -2.936 1.575A1.907 1.907 0 0 0 6.658 10a1.907 1.907 0 0 0 -0.788 2.356l-0.12 0C2.574 12.357 0 11.248 0 9.883Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.214 7.093a14.23 14.23 0 0 1 -0.464 0.007c-1.72 0 -3.25 -0.27 -4.326 -0.684 -0.54 -0.207 -0.934 -0.44 -1.183 -0.665A1.128 1.128 0 0 1 0 5.459v1.656c0.292 0.176 0.622 0.332 0.975 0.468 1.248 0.48 2.929 0.765 4.754 0.767a1.898 1.898 0 0 1 0.485 -1.257Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.463 6.063a0.75 0.75 0 0 1 0.75 0.75v0.74c0.386 0.116 0.734 0.32 1.021 0.589l0.641 -0.37a0.75 0.75 0 1 1 0.75 1.3l-0.64 0.369a2.596 2.596 0 0 1 0 1.181l0.64 0.369a0.75 0.75 0 0 1 -0.75 1.3l-0.64 -0.37a2.587 2.587 0 0 1 -1.022 0.59v0.739a0.75 0.75 0 0 1 -1.5 0v-0.74a2.585 2.585 0 0 1 -1.02 -0.59l-0.641 0.37a0.75 0.75 0 0 1 -0.75 -1.299l0.64 -0.37a2.597 2.597 0 0 1 0 -1.18l-0.64 -0.37a0.75 0.75 0 0 1 0.75 -1.299l0.64 0.37a2.587 2.587 0 0 1 1.021 -0.59v-0.74a0.75 0.75 0 0 1 0.75 -0.75ZM9.501 9.52a0.758 0.758 0 0 0 0.04 -0.069 1.088 1.088 0 1 1 0.926 1.668l-0.004 0 -0.003 0A1.089 1.089 0 0 1 9.5 9.52Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " "
  ] }) }),
  "DatabaseSetting"
);
var DatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 9.882V2l11.5 0v4.016a4.662 4.662 0 0 0 -5.23 6.33c-0.172 0.007 -0.345 0.01 -0.52 0.01 -3.176 0 -5.75 -1.108 -5.75 -2.474Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 5.46v1.655c0.292 0.176 0.622 0.332 0.975 0.468 1.253 0.482 2.941 0.767 4.775 0.767 0.255 0 0.508 -0.006 0.757 -0.016a4.683 4.683 0 0 1 1.119 -1.345c-0.588 0.071 -1.218 0.11 -1.876 0.11 -1.72 0 -3.25 -0.269 -4.326 -0.683 -0.54 -0.207 -0.934 -0.44 -1.183 -0.665A1.128 1.128 0 0 1 0 5.459Zm11.01 0.485c0.166 0.015 0.33 0.039 0.49 0.07V5.46c-0.044 0.083 -0.12 0.18 -0.241 0.292 -0.071 0.064 -0.154 0.13 -0.25 0.194Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.588 14a3.412 3.412 0 1 0 0 -6.824 3.412 3.412 0 0 0 0 6.824Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.472 10.588c0 -0.345 0.28 -0.625 0.625 -0.625h2.982a0.625 0.625 0 1 1 0 1.25H9.097a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " "
  ] }) }),
  "DatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinus"
);
var Database = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.488 2.5v8.709C0.488 12.749 3.403 14 7 14c3.597 0 6.512 -1.25 6.512 -2.791V2.5" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 5c3.59 0 6.5 -1.12 6.5 -2.5S10.59 0 7 0 0.5 1.12 0.5 2.5 3.41 5 7 5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.488 8.493V6.845c0.056 0.085 0.135 0.178 0.246 0.279 0.29 0.263 0.745 0.53 1.36 0.766 1.224 0.471 2.959 0.776 4.906 0.776 1.947 0 3.682 -0.305 4.907 -0.776 0.614 -0.237 1.069 -0.503 1.359 -0.766 0.11 -0.101 0.19 -0.194 0.246 -0.28v1.649c-0.341 0.213 -0.732 0.4 -1.156 0.564 -1.402 0.539 -3.295 0.859 -5.356 0.859 -2.06 0 -3.954 -0.32 -5.356 -0.86a6.82 6.82 0 0 1 -1.156 -0.563Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Database"
);
var DesktopCode = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.5C0.652 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348 0.5 12.543 0.5H1.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.53 4.653a0.75 0.75 0 0 0 -1.06 -1.06l-1.5 1.5a0.75 0.75 0 0 0 0 1.06l1.5 1.5a0.75 0.75 0 0 0 1.06 -1.06l-0.97 -0.97 0.97 -0.97Zm4 -1.06a0.75 0.75 0 0 0 -1.06 1.06l0.97 0.97 -0.97 0.97a0.75 0.75 0 0 0 1.06 1.06l1.5 -1.5a0.75 0.75 0 0 0 0 -1.06l-1.5 -1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopCode"
);
var FileCode1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-8a0.5 0.5 0 0 0 -0.146 -0.354l-4 -4A0.5 0.5 0 0 0 8.5 0h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.03 7.03a0.75 0.75 0 0 0 -1.06 -1.06l-2 2a0.75 0.75 0 0 0 0 1.06l2 2a0.75 0.75 0 1 0 1.06 -1.06L4.56 8.5l1.47 -1.47Zm3 -1.06a0.75 0.75 0 0 0 -1.06 1.06L9.44 8.5 7.97 9.97a0.75 0.75 0 1 0 1.06 1.06l2 -2a0.75 0.75 0 0 0 0 -1.06l-2 -2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FileCode1"
);
var MarkdownCircleProgramming = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.53442 4.8868c-0.14015 -0.31148 -0.44994 -0.5118 -0.7915 -0.5118 -0.47934 0 -0.86792 0.38858 -0.86792 0.86792V9c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625V7.02332l0.02282 0.05072c0.15086 0.33531 0.48436 0.55096 0.85205 0.55096 0.36764 0 0.70111 -0.21561 0.852 -0.55086l0.02311 -0.05134V9c0 0.34518 0.27982 0.625 0.625 0.625 0.34517 0 0.625 -0.27982 0.625 -0.625V5.24293c0 -0.47934 -0.38859 -0.86793 -0.86794 -0.86793 -0.34152 0 -0.6513 0.20029 -0.79146 0.51172L4.99991 5.9214l-0.46549 -1.0346ZM10.125 5c0 -0.34518 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27982 -0.625 0.625v2.5H8.5c-0.20223 0 -0.38455 0.12182 -0.46194 0.30866 -0.07739 0.18684 -0.03461 0.40189 0.10839 0.54489l1 1C9.24021 9.44732 9.36739 9.5 9.5 9.5c0.13261 0 0.25979 -0.05268 0.35355 -0.14645l1.00005 -1c0.143 -0.143 0.1857 -0.35805 0.1083 -0.54489C10.8845 7.62182 10.7022 7.5 10.5 7.5h-0.375V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MarkdownCircleProgramming"
);
var MarkdownDocumentProgramming = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-7a0.5 0.5 0 0 0 -0.146 -0.354l-5 -5A0.5 0.5 0 0 0 7.5 0h-5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.534 6.387a0.868 0.868 0 0 0 -1.659 0.356V10.5a0.625 0.625 0 1 0 1.25 0V8.523l0.023 0.051a0.934 0.934 0 0 0 1.704 0l0.023 -0.051V10.5a0.625 0.625 0 1 0 1.25 0V6.743a0.868 0.868 0 0 0 -1.66 -0.356L5 7.42l-0.466 -1.034Zm5.591 0.113a0.625 0.625 0 1 0 -1.25 0V9H8.5a0.5 0.5 0 0 0 -0.354 0.853l1 1a0.5 0.5 0 0 0 0.708 0l1 -1A0.5 0.5 0 0 0 10.5 9h-0.375V6.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MarkdownDocumentProgramming"
);
var ModuleThree = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.88 0a1 1 0 0 0 -1 1v4.25a1 1 0 0 0 1 1h4.25a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H4.88ZM1 7.75a1 1 0 0 0 -1 1V13a1 1 0 0 0 1 1h4.25a1 1 0 0 0 1 -1V8.75a1 1 0 0 0 -1 -1H1Zm6.75 1a1 1 0 0 1 1 -1H13a1 1 0 0 1 1 1V13a1 1 0 0 1 -1 1H8.75a1 1 0 0 1 -1 -1V8.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ModuleThree"
);
var SquareBracketsCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 0.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.625 5.5c0 -0.207 0.168 -0.375 0.375 -0.375h0.5a0.625 0.625 0 1 0 0 -1.25H5c-0.897 0 -1.625 0.728 -1.625 1.625v3c0 0.897 0.728 1.625 1.625 1.625h0.5a0.625 0.625 0 1 0 0 -1.25H5a0.375 0.375 0 0 1 -0.375 -0.375v-3Zm4.75 0A0.375 0.375 0 0 0 9 5.125h-0.5a0.625 0.625 0 1 1 0 -1.25H9c0.897 0 1.625 0.728 1.625 1.625v3c0 0.897 -0.728 1.625 -1.625 1.625h-0.5a0.625 0.625 0 1 1 0 -1.25H9a0.375 0.375 0 0 0 0.375 -0.375v-3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SquareBracketsCircle"
);
var Widget = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 0.5c0.55228 0 1 0.447715 1 1L8 7c0 0.55228 -0.44772 1 -1 1L1.43161 8C0.879326 8 0.431611 7.55228 0.431611 7l0 -5.5c0 -0.552285 0.447715 -1 0.999999 -1L7 0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.5 1c0 -0.276142 -0.2239 -0.5 -0.5 -0.5h-3c-0.27614 0 -0.5 0.223858 -0.5 0.5v2.25c0 0.27614 0.22386 0.5 0.5 0.5h3c0.2761 0 0.5 -0.22386 0.5 -0.5V1ZM13 4.75c0.2761 0 0.5 0.22386 0.5 0.5V7.5c0 0.27614 -0.2239 0.5 -0.5 0.5l-3 0c-0.27614 0 -0.5 -0.22386 -0.5 -0.5V5.25c0 -0.27614 0.22386 -0.5 0.5 -0.5h3Zm-0.5 4.75c0.5523 0 1 0.44771 1 1v2c0 0.5523 -0.4477 1 -1 1l-11 0c-0.552285 0 -1 -0.4477 -1 -1v-2c0 -0.55229 0.447715 -1 1 -1l11 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Widget"
);
var AiNetworkSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.342 1.202c-0.18 0.17 -0.41 0.287 -0.664 0.332 -2.072 0.36 -2.072 3.334 0 3.695 0.518 0.09 0.93 0.484 1.042 0.998l0.02 0.087c0.43 1.971 3.237 1.984 3.685 0.016l0.024 -0.102c0.053 -0.233 0.167 -0.441 0.325 -0.608a6.501 6.501 0 1 1 -4.432 -4.418Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.342 1.202a6.491 6.491 0 0 0 -1.571 -0.25c0.152 0.236 0.296 0.478 0.432 0.723 0.144 -0.063 0.302 -0.111 0.475 -0.141 0.255 -0.045 0.484 -0.163 0.664 -0.332Zm0.409 5.163c0.424 1.742 2.737 1.9 3.495 0.458h0.75l0.009 0a6.586 6.586 0 0 1 0 1.25l-0.01 0H10.06a14.601 14.601 0 0 1 -1.686 5.612c-0.511 0.15 -1.048 0.24 -1.603 0.26a13.314 13.314 0 0 0 2.033 -5.872H4.262a13.314 13.314 0 0 0 2.034 5.872 6.487 6.487 0 0 1 -1.603 -0.26 14.6 14.6 0 0 1 -1.686 -5.612H0.07l-0.008 0a6.581 6.581 0 0 1 0 -1.25l0.008 0h2.937a14.6 14.6 0 0 1 1.686 -5.612 6.49 6.49 0 0 1 1.603 -0.26 13.314 13.314 0 0 0 -2.034 5.872h4.542a13.466 13.466 0 0 0 -0.053 -0.458Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.366 0.674c-0.19 -0.835 -1.382 -0.83 -1.565 0.007l-0.007 0.033 -0.014 0.064a2.38 2.38 0 0 1 -1.916 1.827c-0.87 0.151 -0.87 1.401 0 1.553a2.38 2.38 0 0 1 1.918 1.836l0.02 0.088c0.182 0.836 1.373 0.841 1.564 0.007l0.023 -0.102a2.396 2.396 0 0 1 1.925 -1.828c0.872 -0.152 0.872 -1.404 0 -1.556A2.396 2.396 0 0 1 11.392 0.791l-0.018 -0.078 -0.008 -0.04Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiNetworkSpark"
);
var BluetoothDisabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.216 0.16a0.75 0.75 0 0 1 0.804 0.12l3.789 3.315a0.75 0.75 0 0 1 -0.05 1.169L7.709 7l3.05 2.237a0.75 0.75 0 0 1 0.05 1.17L7.02 13.72a0.75 0.75 0 0 1 -1.244 -0.564v-4.74L3.655 9.972a0.75 0.75 0 1 1 -0.887 -1.21L5.172 7 2.768 5.236a0.75 0.75 0 0 1 0.887 -1.21l2.121 1.556V0.843a0.75 0.75 0 0 1 0.44 -0.683Zm1.06 8.383 1.84 1.35 -1.84 1.61v-2.96Zm0 -3.087v-2.96l1.84 1.61 -1.84 1.35Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.219 0.219a0.75 0.75 0 0 0 0 1.06L12.72 13.782a0.75 0.75 0 0 0 1.061 -1.06L1.28 0.218a0.75 0.75 0 0 0 -1.061 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BluetoothDisabled"
);
var BluetoothSearching = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 0.132a0.75 0.75 0 0 1 0.803 0.118L8.61 3.58a0.75 0.75 0 0 1 -0.05 1.17L5.49 7l3.07 2.25a0.75 0.75 0 0 1 0.05 1.17l-3.806 3.33a0.75 0.75 0 0 1 -1.243 -0.565V8.417L1.422 9.984a0.75 0.75 0 1 1 -0.887 -1.21L2.955 7 0.535 5.226a0.75 0.75 0 1 1 0.887 -1.21L3.56 5.583V0.815A0.75 0.75 0 0 1 4 0.132Zm1.06 8.412 1.858 1.362 -1.858 1.627v-2.99Zm0 -3.087v-2.99l1.858 1.627L5.06 5.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.135 4.2a3.902 3.902 0 0 1 0 5.505 0.75 0.75 0 0 0 1.06 1.06 5.402 5.402 0 0 0 0 -7.626 0.75 0.75 0 1 0 -1.06 1.06ZM9.489 5.918c0.524 0.524 0.524 1.45 0 1.974a0.75 0.75 0 1 0 1.06 1.06c1.11 -1.11 1.11 -2.985 0 -4.095a0.75 0.75 0 1 0 -1.06 1.06Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BluetoothSearching"
);
var Bluetooth = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.272 0.142a1 1 0 0 1 1.042 0.083l4.404 3.213A1 1 0 0 1 11.65 5.1L8.542 7l3.108 1.9a1 1 0 0 1 0.068 1.662l-4.404 3.213a1 1 0 0 1 -1.59 -0.808V8.722l-2.33 1.426A1 1 0 0 1 2.35 8.442L4.708 7 2.35 5.558a1 1 0 1 1 1.043 -1.706l2.332 1.426V1.033a1 1 0 0 1 0.547 -0.891Zm1.453 8.703 1.606 0.982L7.725 11V8.845Zm0 -3.69V3.001L9.33 4.173l-1.606 0.982Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bluetooth"
);
var BrokenLink2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.672 2.779 5.474 4.977a1 1 0 0 1 -1.415 -1.414l2.199 -2.199a4.51 4.51 0 1 1 6.378 6.378l-2.199 2.199a1 1 0 0 1 -1.414 -1.414l2.198 -2.199a2.51 2.51 0 0 0 -3.55 -3.55ZM2.779 6.258a1 1 0 0 1 0 1.414 2.51 2.51 0 0 0 3.55 3.55 1 1 0 0 1 1.413 1.414 4.51 4.51 0 1 1 -6.378 -6.378 1 1 0 0 1 1.415 0Zm6.417 -0.04a1 1 0 0 0 -1.414 -1.414l-1.24 1.24A1 1 0 0 0 7.954 7.46l1.241 -1.24Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.268 0.265a0.745 0.745 0 0 0 0 1.053l12.411 12.41a0.745 0.745 0 1 0 1.053 -1.052L1.322 0.265a0.745 0.745 0 0 0 -1.054 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrokenLink2"
);
var BrowserWebsite1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " "
  ] }) }),
  "BrowserWebsite1"
);
var BrowserWifi = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.73317 0.0923462C0.793227 0.0923462 0.03125 0.854323 0.03125 1.79427v1.90385H13.9062V1.79427c0 -0.939947 -0.7619 -1.7019238 -1.7019 -1.7019238H1.73317Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.03125 3.69812H13.9062v8.56728c0 0.94 -0.7619 1.702 -1.7019 1.702H1.73317c-0.939943 0 -1.70192 -0.762 -1.70192 -1.702V3.69812Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.5609 8.23611c-1.40955 -1.40954 -3.71233 -1.40954 -5.12188 0 -0.29289 0.2929 -0.76777 0.2929 -1.06066 0 -0.29289 -0.29289 -0.29289 -0.76776 0 -1.06066 1.99533 -1.99533 5.24787 -1.99533 7.24324 0 0.2929 0.2929 0.2929 0.76777 0 1.06066 -0.2929 0.2929 -0.76781 0.2929 -1.0607 0ZM8.09388 9.85522c-0.58171 -0.5817 -1.60614 -0.5817 -2.18785 0 -0.29289 0.29288 -0.76776 0.29288 -1.06066 0 -0.29289 -0.29289 -0.29289 -0.76776 0 -1.06066 1.16749 -1.16749 3.14168 -1.16749 4.30917 0 0.29289 0.2929 0.29289 0.76777 0 1.06066 -0.2929 0.29288 -0.76777 0.29288 -1.06066 0ZM6.99995 11.9475c0.41422 0 0.75 -0.3358 0.75 -0.75s-0.33578 -0.75 -0.75 -0.75c-0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserWifi"
);
var CellularNetwork4g = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.695 2.236a0.625 0.625 0 0 0 0.806 0.956 7.325 7.325 0 0 1 4.503 -1.717 7.313 7.313 0 0 1 4.495 1.717 0.625 0.625 0 1 0 0.806 -0.955A8.563 8.563 0 0 0 6.987 0.226a8.576 8.576 0 0 0 -5.291 2.01Zm2.456 1.976a0.625 0.625 0 1 0 0.72 1.021c0.673 -0.474 1.406 -0.733 2.146 -0.774 0.74 0.039 1.477 0.297 2.15 0.771a0.625 0.625 0 0 0 0.72 -1.022c-0.863 -0.607 -1.836 -0.954 -2.843 -1l-0.058 0c-1.004 0.049 -1.975 0.397 -2.835 1.004Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.98 9.257c0 -0.368 0.3 -0.673 0.68 -0.673h0.87a0.68 0.68 0 0 1 0.643 0.45 0.625 0.625 0 1 0 1.178 -0.42 1.93 1.93 0 0 0 -1.82 -1.28H9.66c-1.063 0 -1.93 0.857 -1.93 1.923v2.595c0 1.066 0.867 1.923 1.93 1.923h0.87a1.927 1.927 0 0 0 1.931 -1.923v-0.865a0.625 0.625 0 0 0 -0.625 -0.625h-1.305a0.625 0.625 0 1 0 0 1.25h0.68v0.24a0.677 0.677 0 0 1 -0.68 0.673H9.66a0.677 0.677 0 0 1 -0.68 -0.673V9.257ZM5.345 7.334a0.925 0.925 0 0 0 -0.694 0.314l-2.879 3.27a0.94 0.94 0 0 0 0.705 1.56H5.02v0.672a0.625 0.625 0 1 0 1.25 0v-0.673h0.245a0.625 0.625 0 1 0 0 -1.25H6.27V8.26a0.925 0.925 0 0 0 -0.925 -0.925ZM5.021 9.12v2.107H3.166L5.02 9.12Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CellularNetwork4g"
);
var CellularNetwork5g = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.772 2.219a0.625 0.625 0 0 0 0.81 0.953 7.16 7.16 0 0 1 4.421 -1.697 7.147 7.147 0 0 1 4.416 1.697 0.625 0.625 0 0 0 0.809 -0.953A8.396 8.396 0 0 0 6.987 0.225 8.41 8.41 0 0 0 1.772 2.22ZM4.19 4.174a0.625 0.625 0 0 0 0.723 1.02c0.66 -0.468 1.379 -0.725 2.103 -0.765 0.726 0.038 1.448 0.294 2.11 0.762a0.625 0.625 0 1 0 0.721 -1.02c-0.85 -0.602 -1.81 -0.947 -2.803 -0.992l-0.059 0c-0.99 0.047 -1.948 0.394 -2.795 0.995Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.64 9.296a0.66 0.66 0 0 1 0.66 -0.66h0.857a0.66 0.66 0 0 1 0.622 0.44 0.625 0.625 0 0 0 1.179 -0.417 1.91 1.91 0 0 0 -1.801 -1.273H9.3a1.91 1.91 0 0 0 -1.91 1.91v2.57a1.91 1.91 0 0 0 1.91 1.91h0.857a1.91 1.91 0 0 0 1.91 -1.91v-0.857a0.625 0.625 0 0 0 -0.626 -0.625h-1.284a0.625 0.625 0 1 0 0 1.25h0.66v0.231a0.66 0.66 0 0 1 -0.66 0.66H9.3a0.66 0.66 0 0 1 -0.66 -0.66v-2.57Zm-2.835 -0.657 -2.252 0 -0.16 0.96c0.218 -0.046 0.44 -0.07 0.665 -0.07h0.677a1.91 1.91 0 0 1 1.91 1.91v0.427a1.909 1.909 0 0 1 -1.91 1.91H3.88a1.91 1.91 0 0 1 -1.8 -1.274 0.625 0.625 0 1 1 1.179 -0.416 0.66 0.66 0 0 0 0.621 0.44h0.856a0.659 0.659 0 0 0 0.66 -0.66l0 -0.428a0.659 0.659 0 0 0 -0.66 -0.659h-0.677c-0.302 0 -0.6 0.07 -0.87 0.205l-0.313 0.157a0.625 0.625 0 0 1 -0.896 -0.662l0.428 -2.568a0.625 0.625 0 0 1 0.616 -0.522l2.782 0a0.625 0.625 0 1 1 0 1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CellularNetwork5g"
);
var CellularNetworkLte = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.636 7.926a0.625 0.625 0 1 0 -1.25 0v5.223c0 0.345 0.28 0.625 0.625 0.625h3.047a0.625 0.625 0 1 0 0 -1.25H1.636V7.926Zm6.779 0c0 0.345 -0.28 0.625 -0.625 0.625l-1.116 0v4.598a0.625 0.625 0 1 1 -1.25 0V8.55H4.308a0.625 0.625 0 1 1 0 -1.25H7.79c0.345 0 0.625 0.28 0.625 0.625Zm0.689 -0.442a0.625 0.625 0 0 1 0.442 -0.183h3.482a0.625 0.625 0 1 1 0 1.25h-2.857v1.144h2.422a0.625 0.625 0 1 1 0 1.25H10.17v1.579h2.857a0.625 0.625 0 1 1 0 1.25H9.546a0.625 0.625 0 0 1 -0.625 -0.625V7.926c0 -0.166 0.066 -0.325 0.183 -0.442Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.693 2.25a0.625 0.625 0 0 0 0.809 0.954 7.287 7.287 0 0 1 4.501 -1.728 7.275 7.275 0 0 1 4.495 1.727 0.625 0.625 0 1 0 0.809 -0.952A8.529 8.529 0 0 0 6.987 0.226 8.537 8.537 0 0 0 1.692 2.25ZM4.15 4.238a0.625 0.625 0 1 0 0.724 1.02c0.671 -0.477 1.404 -0.738 2.143 -0.78 0.74 0.04 1.475 0.3 2.15 0.777a0.625 0.625 0 0 0 0.721 -1.02c-0.862 -0.611 -1.836 -0.961 -2.844 -1.007l-0.058 0c-1.005 0.049 -1.976 0.4 -2.836 1.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CellularNetworkLte"
);
var LinkChain = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.671 2.743 -0.964 0.964a1 1 0 0 1 -1.414 -1.414l0.964 -0.965a4.536 4.536 0 0 1 6.415 6.415l-0.965 0.964a1 1 0 1 1 -1.414 -1.414l0.964 -0.965a2.536 2.536 0 0 0 -3.585 -3.585Zm-3.964 2.55a1 1 0 0 1 0 1.414l-0.964 0.965a2.536 2.536 0 0 0 3.585 3.585l0.965 -0.964a1 1 0 0 1 1.414 1.414l-0.964 0.964a4.536 4.536 0 0 1 -6.415 -6.414l0.965 -0.964a1 1 0 0 1 1.414 0Zm5.5 0.914a1 1 0 0 0 -1.414 -1.414l-3 3a1 1 0 0 0 1.414 1.414l3 -3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LinkChain"
);
var Network = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 9.5a0.75 0.75 0 0 0 -1.5 0v2.946H2a0.75 0.75 0 0 0 0 1.5h10a0.75 0.75 0 0 0 0 -1.5H7.75V9.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 10.463A5.231 5.231 0 1 0 7 0a5.231 5.231 0 0 0 0 10.463Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.39 0.187A5.237 5.237 0 0 0 5.598 0.19c-0.899 1.417 -1.405 2.89 -1.482 4.416h-2.31a5.286 5.286 0 0 0 0 1.25h2.342c0.15 1.476 0.693 2.963 1.61 4.458a5.243 5.243 0 0 0 2.517 -0.007c0.926 -1.472 1.472 -2.957 1.61 -4.45h2.31a5.284 5.284 0 0 0 0 -1.25h-2.29C9.81 3.096 9.298 1.621 8.39 0.186ZM6.998 0.35C8.01 1.78 8.549 3.198 8.65 4.606H5.367c0.086 -1.43 0.62 -2.846 1.63 -4.255Zm0.013 9.607C6.083 8.53 5.56 7.165 5.405 5.856h3.223c-0.145 1.329 -0.674 2.695 -1.618 4.102Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Network"
);
var RssSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.04 2.832a0.625 0.625 0 0 0 0 1.25A5.877 5.877 0 0 1 9.919 9.96a0.625 0.625 0 1 0 1.25 0A7.127 7.127 0 0 0 4.04 2.832Zm-0.624 3.625c0 -0.345 0.28 -0.625 0.625 -0.625A4.127 4.127 0 0 1 8.167 9.96a0.625 0.625 0 1 1 -1.25 0 2.877 2.877 0 0 0 -2.876 -2.877 0.625 0.625 0 0 1 -0.625 -0.625Zm0.625 2.418a1.084 1.084 0 1 0 0 2.168 1.084 1.084 0 0 0 0 -2.168Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RssSquare"
);
var RssSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.102 9.935a1.972 1.972 0 1 0 0 3.945 1.972 1.972 0 0 0 0 -3.945Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.857 0.052a1 1 0 1 0 0 2 10.091 10.091 0 0 1 10.091 10.091 1 1 0 0 0 2 0A12.092 12.092 0 0 0 1.858 0.052Zm0 4.71a1 1 0 1 0 0 2 5.38 5.38 0 0 1 5.38 5.381 1 1 0 0 0 2 0 7.38 7.38 0 0 0 -7.38 -7.38Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RssSymbol"
);
var SatelliteDish = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.058 13.406 4 7l2 2 1.307 4.356a0.5 0.5 0 0 1 -0.479 0.644H0.39a0.39 0.39 0 0 1 -0.332 -0.594Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.707 2.293a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1 -1.414 -1.414l2 -2a1 1 0 0 1 1.414 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5.354 0.146a0.5 0.5 0 0 0 -0.708 0 6.51 6.51 0 1 0 9.208 9.208 0.5 0.5 0 0 0 0 -0.708l-8.5 -8.5Z" }),
    " "
  ] }) }),
  "SatelliteDish"
);
var ScreenBroadcast = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.58 1.961A1.92 1.92 0 0 1 1.937 1.4H12.06a1.92 1.92 0 0 1 1.92 1.92v7.362a1.92 1.92 0 0 1 -1.92 1.92H6.995A6.283 6.283 0 0 0 0.017 5.524V3.32c0 -0.51 0.202 -0.998 0.563 -1.358Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.768 6.73a0.75 0.75 0 1 0 0 1.5 3.533 3.533 0 0 1 3.533 3.532 0.75 0.75 0 0 0 1.5 0A5.033 5.033 0 0 0 0.768 6.73Zm0 2.676a0.75 0.75 0 0 0 0 1.5 0.856 0.856 0 0 1 0.856 0.856 0.75 0.75 0 1 0 1.5 0A2.356 2.356 0 0 0 0.768 9.406Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ScreenBroadcast"
);
var ShareLink = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.394 2.053a1 1 0 0 1 -0.447 1.341L4.737 7l7.21 3.606a1 1 0 1 1 -0.894 1.788l-9 -4.5a1 1 0 0 1 0 -1.788l9 -4.5a1 1 0 0 1 1.341 0.447Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 2.75a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 1 0 -5.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 11.25a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 1 0 -5.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 7a2.75 2.75 0 1 0 5.5 0A2.75 2.75 0 1 0 0 7" }),
    " "
  ] }) }),
  "ShareLink"
);
var SignalFull = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13 1h-2.662a0.5 0.5 0 0 0 -0.5 0.5v12a0.5 0.5 0 0 0 0.5 0.5h2.663a0.5 0.5 0 0 0 0.5 -0.5v-12A0.5 0.5 0 0 0 13 1ZM3.163 8H0.5a0.5 0.5 0 0 0 -0.5 0.5v5a0.5 0.5 0 0 0 0.5 0.5h2.662a0.5 0.5 0 0 0 0.5 -0.5v-5a0.5 0.5 0 0 0 -0.5 -0.5ZM5.42 5h2.663a0.5 0.5 0 0 1 0.5 0.5v8a0.5 0.5 0 0 1 -0.5 0.5H5.419a0.5 0.5 0 0 1 -0.5 -0.5v-8a0.5 0.5 0 0 1 0.5 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignalFull"
);
var SignalLoading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.724 5.018a0.75 0.75 0 1 0 -1.085 -1.036l-2.387 2.5a0.75 0.75 0 0 0 0 1.036l2.387 2.5a0.75 0.75 0 0 0 1.085 -1.036L1.832 7l1.892 -1.982Zm7.637 -1.036a0.75 0.75 0 0 0 -1.085 1.036L12.17 7l-1.893 1.982a0.75 0.75 0 0 0 1.085 1.036l2.387 -2.5a0.75 0.75 0 0 0 0 -1.036l-2.387 -2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.25 7a0.75 0.75 0 1 0 -1.5 0 0.75 0.75 0 0 0 1.5 0ZM7 6.25a0.75 0.75 0 1 1 0 1.5 0.75 0.75 0 0 1 0 -1.5Zm2.5 0a0.75 0.75 0 1 1 0 1.5 0.75 0.75 0 0 1 0 -1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignalLoading"
);
var SignalLow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.162 8H0.5a0.5 0.5 0 0 0 -0.5 0.5v5a0.5 0.5 0 0 0 0.5 0.5h2.662a0.5 0.5 0 0 0 0.5 -0.5v-5a0.5 0.5 0 0 0 -0.5 -0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.813 12.5a0.75 0.75 0 0 0 0 1.5h2.374a0.75 0.75 0 0 0 0 -1.5H5.813Zm5.053 0a0.75 0.75 0 0 0 0 1.5h2.375a0.75 0.75 0 0 0 0 -1.5h-2.375Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignalLow"
);
var SignalMedium = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.669 5H8.33a0.5 0.5 0 0 1 0.5 0.5v8a0.5 0.5 0 0 1 -0.5 0.5H5.67a0.5 0.5 0 0 1 -0.5 -0.5v-8a0.5 0.5 0 0 1 0.5 -0.5ZM0.5 8h2.662a0.5 0.5 0 0 1 0.5 0.5v5a0.5 0.5 0 0 1 -0.5 0.5H0.5a0.5 0.5 0 0 1 -0.5 -0.5v-5A0.5 0.5 0 0 1 0.5 8Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.116 13.25a0.75 0.75 0 0 1 0.75 -0.75h2.375a0.75 0.75 0 0 1 0 1.5h-2.375a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignalMedium"
);
var SignalNone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 13.25a0.75 0.75 0 0 1 0.75 -0.75h2.375a0.75 0.75 0 0 1 0 1.5H0.75a0.75 0.75 0 0 1 -0.75 -0.75Zm10.116 0a0.75 0.75 0 0 1 0.75 -0.75h2.375a0.75 0.75 0 0 1 0 1.5h-2.375a0.75 0.75 0 0 1 -0.75 -0.75Zm-4.303 -0.75a0.75 0.75 0 0 0 0 1.5h2.374a0.75 0.75 0 0 0 0 -1.5H5.813Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignalNone"
);
var Stream = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.75 3.83179c0 1.62535 -1.1662 2.97832 -2.7075 3.26775L8.44387 9.8323c0.07992 0.2619 0.12291 0.5399 0.12291 0.828 0 1.5645 -1.26833 2.8329 -2.83289 2.8329S2.901 12.2248 2.901 10.6603c0 -1.54283 1.23331 -2.79759 2.76782 -2.83218l1.51366 -3.25763c-0.0539 -0.23758 -0.08235 -0.48481 -0.08235 -0.7387 0 -1.83632 1.48863 -3.324954 3.32497 -3.324954 1.8363 0 3.3249 1.488634 3.3249 3.324954Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.5403 5.03656c0.7275 -0.04187 1.2833 -0.66556 1.2414 -1.39303 -0.0419 -0.72748 -0.6656 -1.28328 -1.393 -1.24141 -0.72752 0.04187 -1.28332 0.66555 -1.24145 1.39303 0.04187 0.72748 0.66556 1.28328 1.39305 1.24141ZM0.0000280796 7.42178 0.0107706 9.69643 5.18581 11.4182c0.30368 0.101 0.63322 -0.0539 0.74915 -0.3522 0.11148 -0.2869 -0.01203 -0.6116 -0.28599 -0.7519L0.0000280796 7.42178Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Stream"
);
var WaveSignalSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0h7S14 0 14 3.5v7s0 3.5 -3.5 3.5h-7S0 14 0 10.5v-7S0 0 3.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.085 3.89a0.625 0.625 0 0 1 0.518 0.455l1.14 4.178 1.237 -1.85a0.625 0.625 0 0 1 0.52 -0.278H14v1.25H9.834L8.02 10.357a0.625 0.625 0 0 1 -1.123 -0.183L5.783 6.091l-0.747 1.25a0.625 0.625 0 0 1 -0.536 0.304H0l0 -1.25h4.145l1.319 -2.206a0.625 0.625 0 0 1 0.62 -0.298Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WaveSignalSquare"
);
var WaveSignal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m5.267 4.792 1.864 6.203a1.5 1.5 0 0 0 1.452 1.075 1.5 1.5 0 0 0 1.345 -0.949l1.244 -3.041H13a1 1 0 1 0 0 -2h-2.16l-0.006 0a1.51 1.51 0 0 0 -1.39 0.944L8.627 9.02 6.82 3.01a1.48 1.48 0 0 0 -1.304 -1.065 1.49 1.49 0 0 0 -1.471 0.82L2.387 6.08H1a1 1 0 0 0 0 2h1.69l0.011 0a1.52 1.52 0 0 0 1.333 -0.823l1.233 -2.465Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WaveSignal"
);
var Web = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.951 0.276A6.985 6.985 0 0 0 7.348 0.009a14.477 14.477 0 0 1 2.169 6.366H4.483c0.217 -2.277 0.963 -4.46 2.17 -6.366a6.985 6.985 0 0 0 -1.604 0.267 15.763 15.763 0 0 0 -1.821 6.1h-3.2a7.09 7.09 0 0 0 0 1.25h3.2a15.763 15.763 0 0 0 1.82 6.099c0.513 0.148 1.05 0.24 1.604 0.267a14.477 14.477 0 0 1 -2.17 -6.367h5.035a14.477 14.477 0 0 1 -2.17 6.367 6.985 6.985 0 0 0 1.604 -0.268 15.762 15.762 0 0 0 1.821 -6.099h3.2a7.097 7.097 0 0 0 0 -1.25h-3.2a15.762 15.762 0 0 0 -1.82 -6.1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Web"
);
var WifiAntenna = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.573 0.34A0.75 0.75 0 0 1 11.63 0.247a6.37 6.37 0 0 1 1.699 2.281 7.49 7.49 0 0 1 0.645 2.93 7.478 7.478 0 0 1 -0.648 2.897 6.354 6.354 0 0 1 -1.705 2.28 0.75 0.75 0 0 1 -0.96 -1.153 4.856 4.856 0 0 0 1.298 -1.744c0.316 -0.702 0.494 -1.49 0.515 -2.298a5.99 5.99 0 0 0 -0.513 -2.297 4.872 4.872 0 0 0 -1.294 -1.746 0.75 0.75 0 0 1 -0.094 -1.057ZM4.295 8.765a0.75 0.75 0 1 0 0.954 -1.157 2.645 2.645 0 0 1 -0.706 -0.937 3.272 3.272 0 0 1 -0.292 -1.243c0.016 -0.44 0.116 -0.867 0.29 -1.246 0.178 -0.385 0.423 -0.704 0.708 -0.94a0.75 0.75 0 0 0 -0.954 -1.157 4.14 4.14 0 0 0 -1.116 1.47 4.776 4.776 0 0 0 -0.428 1.897c0.02 0.642 0.165 1.274 0.43 1.847a4.143 4.143 0 0 0 1.114 1.466Zm5.384 -6.65a0.75 0.75 0 0 0 -0.954 1.157c0.284 0.235 0.53 0.553 0.706 0.937 0.175 0.378 0.276 0.803 0.292 1.243 -0.015 0.44 -0.116 0.867 -0.29 1.246a2.646 2.646 0 0 1 -0.708 0.94 0.75 0.75 0 1 0 0.954 1.157 4.14 4.14 0 0 0 1.116 -1.47 4.775 4.775 0 0 0 0.428 -1.897 4.773 4.773 0 0 0 -0.43 -1.847A4.142 4.142 0 0 0 9.68 2.115Zm-7.335 8.518a0.75 0.75 0 0 0 0.963 -1.15 4.871 4.871 0 0 1 -1.293 -1.746A5.99 5.99 0 0 1 1.5 5.44a5.97 5.97 0 0 1 0.516 -2.298 4.856 4.856 0 0 1 1.297 -1.744 0.75 0.75 0 0 0 -0.96 -1.152 6.355 6.355 0 0 0 -1.705 2.28A7.48 7.48 0 0 0 0 5.455a7.492 7.492 0 0 0 0.645 2.896 6.37 6.37 0 0 0 1.7 2.281Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.376 5.5a1.624 1.624 0 1 1 2.372 1.441A0.76 0.76 0 0 1 7.75 7v6.149a0.75 0.75 0 0 1 -1.5 0V7c0 -0.02 0 -0.04 0.002 -0.059A1.623 1.623 0 0 1 5.376 5.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WifiAntenna"
);
var WifiDisabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.34692 6.07302c3.0963 -3.0963 8.15116 -3.0963 11.24748 0 0.2929 0.29289 0.7677 0.29289 1.0606 0 0.2929 -0.2929 0.2929 -0.76777 0 -1.06066 -3.68205 -3.68209 -9.68665 -3.68209 -13.368741 0 -0.29289294 0.29289 -0.29289294 0.76776 0 1.06066 0.292893 0.29289 0.767771 0.29289 1.060661 0Zm1.90601 1.68294c2.0466 -2.0466 5.38881 -2.0466 7.43537 0 0.2929 0.2929 0.7678 0.2929 1.0607 0 0.2929 -0.29289 0.2929 -0.76776 0 -1.06066 -2.63239 -2.63239 -6.92434 -2.63239 -9.55673 0 -0.2929 0.2929 -0.2929 0.76777 0 1.06066 0.29289 0.2929 0.76776 0.2929 1.06066 0Zm5.43539 1.65835c-0.94515 -0.94515 -2.49024 -0.94515 -3.43539 0 -0.2929 0.29289 -0.76777 0.29289 -1.06066 0 -0.2929 -0.2929 -0.2929 -0.76777 0 -1.06066 1.53093 -1.53094 4.02577 -1.53094 5.55671 0 0.29292 0.29289 0.29292 0.76776 0 1.06066 -0.29289 0.29289 -0.76777 0.29289 -1.06066 0Zm-0.37844 2.52499c0 0.7235 -0.58651 1.31 -1.31 1.31 -0.72349 0 -1.31 -0.5865 -1.31 -1.31s0.58651 -1.31 1.31 -1.31c0.72349 0 1.31 0.5865 1.31 1.31Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.218984 0.218999c-0.2928928 0.292893 -0.2928928 0.767766 0 1.060661L12.7203 13.781c0.2929 0.2929 0.7678 0.2929 1.0607 0 0.2929 -0.2929 0.2929 -0.7678 0 -1.0606L1.27964 0.218999c-0.292889 -0.2928937 -0.767763 -0.2928937 -1.060656 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WifiDisabled"
);
var WifiHorizontal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.813 2.232a0.75 0.75 0 1 0 -0.93 -1.177A7.392 7.392 0 0 0 0.82 3.657a8.207 8.207 0 0 0 -0.8 3.364 8.182 8.182 0 0 0 0.803 3.325 7.367 7.367 0 0 0 2.072 2.601 0.75 0.75 0 0 0 0.926 -1.18 5.867 5.867 0 0 1 -1.648 -2.073A6.681 6.681 0 0 1 1.52 7c0.03 -0.945 0.254 -1.866 0.651 -2.692a5.901 5.901 0 0 1 1.642 -2.076Zm2.094 2.054a0.75 0.75 0 1 0 -0.845 -1.24 5.054 5.054 0 0 0 -1.57 1.712 4.892 4.892 0 0 0 -0.62 2.272 4.88 4.88 0 0 0 0.62 2.218c0.381 0.681 0.92 1.265 1.572 1.707a0.75 0.75 0 0 0 0.841 -1.242 3.536 3.536 0 0 1 -1.104 -1.198 3.375 3.375 0 0 1 -0.429 -1.51 3.392 3.392 0 0 1 0.43 -1.516 3.554 3.554 0 0 1 1.105 -1.203Zm1.989 -1.042a0.75 0.75 0 0 1 1.042 -0.198 5.054 5.054 0 0 1 1.57 1.712 4.892 4.892 0 0 1 0.62 2.272 4.874 4.874 0 0 1 -0.62 2.218 5.035 5.035 0 0 1 -1.572 1.707 0.75 0.75 0 0 1 -0.841 -1.242 3.536 3.536 0 0 0 1.104 -1.198 3.39 3.39 0 0 0 0.429 -1.51 3.392 3.392 0 0 0 -0.43 -1.516 3.554 3.554 0 0 0 -1.105 -1.203 0.75 0.75 0 0 1 -0.197 -1.042Zm3.22 -2.19a0.75 0.75 0 1 0 -0.93 1.178 5.894 5.894 0 0 1 1.643 2.076A6.7 6.7 0 0 1 12.479 7a6.682 6.682 0 0 1 -0.652 2.694 5.867 5.867 0 0 1 -1.648 2.073 0.75 0.75 0 0 0 0.926 1.18 7.367 7.367 0 0 0 2.072 -2.6 8.183 8.183 0 0 0 0.803 -3.368 8.206 8.206 0 0 0 -0.8 -3.322 7.392 7.392 0 0 0 -2.063 -2.602Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 5.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0 -2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WifiHorizontal"
);
var WifiRouter = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.427 12.5v0.714a0.75 0.75 0 0 0 1.5 0V12.5h-1.5Zm7.646 0v0.714a0.75 0.75 0 1 0 1.5 0V12.5h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.318 3.276a0.75 0.75 0 0 1 0.921 0.527L3.52 8.5h6.96l1.28 -4.697a0.75 0.75 0 0 1 1.448 0.394L12.034 8.5h0.466a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h0.466L0.792 4.197a0.75 0.75 0 0 1 0.526 -0.92Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.177 9.847a0.5 0.5 0 1 0 0 1h0.478a0.5 0.5 0 1 0 0 -1h-0.478Zm2.39 0a0.5 0.5 0 1 0 0 1h0.477a0.5 0.5 0 1 0 0 -1h-0.478Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.767 2.753a3.922 3.922 0 0 0 -5.534 0 0.75 0.75 0 0 1 -1.06 -1.06 5.422 5.422 0 0 1 7.655 0 0.75 0.75 0 1 1 -1.061 1.06ZM7.7 5.516a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0ZM5.958 4.218c0.528 -0.527 1.46 -0.527 1.987 0a0.75 0.75 0 1 0 1.061 -1.06c-1.113 -1.114 -2.995 -1.114 -4.109 0a0.75 0.75 0 0 0 1.061 1.06Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WifiRouter"
);
var Wifi = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 10.121a1.592 1.592 0 1 0 0 3.185 1.592 1.592 0 0 0 0 -3.185Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.916 3.381a8.056 8.056 0 0 1 8.782 1.747 0.75 0.75 0 1 0 1.06 -1.06 9.556 9.556 0 0 0 -13.517 0 0.75 0.75 0 1 0 1.061 1.06 8.056 8.056 0 0 1 2.614 -1.747ZM7 5.61a5.526 5.526 0 0 0 -3.919 1.63 0.75 0.75 0 0 1 -1.064 -1.058 7.027 7.027 0 0 1 9.966 0 0.75 0.75 0 1 1 -1.064 1.058A5.526 5.526 0 0 0 7 5.61Zm0.029 2.735a2.594 2.594 0 0 0 -1.859 0.784 0.75 0.75 0 1 1 -1.074 -1.047 4.094 4.094 0 0 1 5.866 0A0.75 0.75 0 1 1 8.887 9.13a2.594 2.594 0 0 0 -1.858 -0.784Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Wifi"
);
var BlockBellNotification = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.95 6.35a3.748 3.748 0 0 0 -5.3 -5.3 0.758 0.758 0 0 0 -0.097 0.097A3.748 3.748 0 0 0 12.95 6.35Zm-0.45 -2.602a2.248 2.248 0 0 0 -3.217 -2.03l2.998 3a2.24 2.24 0 0 0 0.219 -0.97Zm-1.28 2.03L8.223 2.78a2.248 2.248 0 0 0 2.998 2.998Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.572 8.737a4.998 4.998 0 0 1 -4.788 -7.232A4.713 4.713 0 0 0 2.78 2.747c-0.86 0.804 -1.351 1.901 -1.351 3.053v3.775c0 0.234 -0.1 0.466 -0.289 0.642 -0.219 0.204 -0.391 0.283 -0.639 0.283a0.5 0.5 0 0 0 0 1h11a0.5 0.5 0 1 0 0 -1c-0.248 0 -0.42 -0.079 -0.64 -0.283a0.879 0.879 0 0 1 -0.287 -0.642v-0.838ZM5 12.5A0.75 0.75 0 0 0 5 14h2a0.75 0.75 0 0 0 0 -1.5H5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BlockBellNotification"
);
var BrowserBlock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.748 8.748A3.748 3.748 0 0 0 7 5c-0.986 0 -1.954 0.398 -2.652 1.096a3.748 3.748 0 1 0 6.4 2.652Zm-1.5 0a2.248 2.248 0 0 0 -3.217 -2.03l2.999 3a2.24 2.24 0 0 0 0.218 -0.97Zm-1.28 2.03L4.972 7.78a2.248 2.248 0 0 0 2.998 2.998Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserBlock"
);
var BrowserLock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751v10.498c0 0.942 0.763 1.705 1.705 1.705H12.25c0.942 0 1.705 -0.763 1.705 -1.705V1.751c0 -0.942 -0.763 -1.705 -1.705 -1.705H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.125 7.267a0.875 0.875 0 1 1 1.75 0v0.5h-1.75v-0.5Zm-1.25 0.72v-0.72a2.125 2.125 0 1 1 4.25 0v0.72a0.998 0.998 0 0 1 0.375 0.78v2a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-2c0 -0.316 0.146 -0.598 0.375 -0.78Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrowserLock"
);
var BugAntivirusDebugging = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.423 3.577a0.75 0.75 0 0 1 0 1.06l-0.956 0.956c0.022 0.133 0.033 0.269 0.033 0.407v0.25h0.875a0.75 0.75 0 0 1 0 1.5H9.5V8c0 0.241 -0.034 0.474 -0.098 0.695l0.952 0.951a0.5 0.5 0 0 1 -0.708 0.708l-0.738 -0.739A2.494 2.494 0 0 1 7 10.5a2.492 2.492 0 0 1 -1.737 -0.702l-0.625 0.625a0.75 0.75 0 1 1 -1.06 -1.06l0.955 -0.956A2.517 2.517 0 0 1 4.5 8v-0.25h-0.875a0.75 0.75 0 0 1 0 -1.5H4.5V6c0 -0.241 0.034 -0.474 0.098 -0.695l-0.951 -0.951a0.5 0.5 0 1 1 0.707 -0.708l0.738 0.739A2.495 2.495 0 0 1 7 3.5a2.49 2.49 0 0 1 1.737 0.702l0.625 -0.625a0.75 0.75 0 0 1 1.061 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.744 2.684a5.406 5.406 0 0 1 7.572 7.572L3.744 2.684Zm-1.06 1.06a5.406 5.406 0 0 0 7.572 7.572L2.684 3.744Zm9.191 8.148a6.906 6.906 0 1 1 0.016 -0.016l-0.007 0.007 -0.009 0.009Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BugAntivirusDebugging"
);
var BugAntivirusShield = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0.036499C0.679191 0.036499 0 0.71569 0 1.5365v2.92041c0.00341609 4.126 2.61027 7.92169 6.46 9.40609 0.17375 0.067 0.35689 0.1005 0.54 0.1005 0.18311 0 0.36625 -0.0335 0.54 -0.1005 3.8497 -1.4844 6.4566 -5.28009 6.46 -9.40609V1.5365c0 -0.82081 -0.6792 -1.500001 -1.5 -1.500001h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.0134 2.92866c0.2441 0.24408 0.2441 0.63981 0 0.88389l-0.84118 0.84117c0.02753 0.13947 0.04196 0.28363 0.04196 0.43117v0.23214H10c0.3452 0 0.625 0.27982 0.625 0.625s-0.2798 0.625 -0.625 0.625h-0.78582v0.23215c0 0.14753 -0.01443 0.2917 -0.04195 0.43116l0.84117 0.84117c0.2441 0.24408 0.2441 0.63981 0 0.88389 -0.24408 0.24407 -0.6398 0.24407 -0.88388 0l-0.57724 -0.57725c-0.39961 0.39292 -0.94769 0.63531 -1.55239 0.63531 -0.60467 0 -1.15273 -0.24237 -1.55233 -0.63525l-0.57719 0.57719c-0.24408 0.24407 -0.63981 0.24407 -0.88388 0 -0.24408 -0.24408 -0.24408 -0.63981 0 -0.88389l0.84109 -0.84109c-0.02754 -0.13948 -0.04197 -0.28368 -0.04197 -0.43124v-0.23215h-0.78565c-0.34518 0 -0.625 -0.27982 -0.625 -0.625s0.27982 -0.625 0.625 -0.625h0.78565v-0.23214c0 -0.14757 0.01443 -0.29176 0.04197 -0.43125l-0.84109 -0.84109c-0.24408 -0.24408 -0.24408 -0.63981 0 -0.88389 0.24407 -0.24407 0.6398 -0.24407 0.88388 0l0.5772 0.5772c0.3996 -0.39289 0.94766 -0.63525 1.55232 -0.63525 0.6047 0 1.15277 0.24238 1.55238 0.6353l0.57725 -0.57725c0.24408 -0.24407 0.6398 -0.24407 0.88388 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BugAntivirusShield"
);
var BugVirusBrowser = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.046 1.75C0.046 0.81 0.81 0.047 1.751 0.047h10.498c0.942 0 1.705 0.763 1.705 1.705v3.926a2.001 2.001 0 0 0 -2.359 0 4.328 4.328 0 0 0 -4.164 0 2 2 0 0 0 -2.72 2.89 1.998 1.998 0 0 0 0 3.374 2.002 2.002 0 0 0 -0.318 2.013H1.751A1.704 1.704 0 0 1 0.046 12.25V1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.72 6.737a0.75 0.75 0 0 0 -1.008 1.11l1.023 0.93a2.828 2.828 0 0 0 -0.087 0.695l0 0.032h-0.897a0.75 0.75 0 0 0 0 1.5h0.897l0 0.032c0 0.237 0.03 0.47 0.087 0.696l-1.023 0.929a0.75 0.75 0 1 0 1.009 1.11l0.781 -0.71a2.83 2.83 0 0 0 3.95 0l0.782 0.71a0.75 0.75 0 1 0 1.008 -1.11l-1.022 -0.93c0.057 -0.225 0.086 -0.458 0.086 -0.695l0 -0.032h0.898a0.75 0.75 0 0 0 0 -1.5h-0.898l0 -0.032c0 -0.237 -0.03 -0.47 -0.086 -0.695l1.022 -0.93a0.75 0.75 0 0 0 -1.008 -1.11l-0.781 0.71a2.829 2.829 0 0 0 -3.951 0l-0.781 -0.71Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " "
  ] }) }),
  "BugVirusBrowser"
);
var BugVirusDocument = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.44 0.44A1.5 1.5 0 0 1 1.5 0h6a0.5 0.5 0 0 1 0.354 0.146l3 3A0.5 0.5 0 0 1 11 3.5v1.906a4.328 4.328 0 0 0 -3.569 0.27 2 2 0 0 0 -2.72 2.891 1.998 1.998 0 0 0 0 3.374L4.664 12H1.5A1.5 1.5 0 0 1 0 10.5v-9C0 1.102 0.158 0.72 0.44 0.44Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.72 6.737a0.75 0.75 0 0 0 -1.008 1.11l1.023 0.93a2.828 2.828 0 0 0 -0.087 0.695l0 0.032h-0.897a0.75 0.75 0 0 0 0 1.5h0.897l0 0.032c0 0.237 0.03 0.47 0.087 0.696l-1.023 0.929a0.75 0.75 0 1 0 1.009 1.11l0.781 -0.71a2.83 2.83 0 0 0 3.95 0l0.782 0.71a0.75 0.75 0 1 0 1.008 -1.11l-1.022 -0.93c0.057 -0.225 0.086 -0.458 0.086 -0.695l0 -0.032h0.898a0.75 0.75 0 0 0 0 -1.5h-0.898l0 -0.032c0 -0.237 -0.03 -0.47 -0.086 -0.695l1.022 -0.93a0.75 0.75 0 0 0 -1.008 -1.11l-0.781 0.71a2.829 2.829 0 0 0 -3.951 0l-0.781 -0.71Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BugVirusDocument"
);
var BugVirusFolder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.183 0a1.5 1.5 0 0 1 1.492 1.14l0.003 0.01 0.192 0.85h5.6a1.5 1.5 0 0 1 1.5 1.5v2.189a2.001 2.001 0 0 0 -2.375 -0.013 4.328 4.328 0 0 0 -4.164 0 2 2 0 0 0 -2.72 2.891 1.998 1.998 0 0 0 0 3.374c-0.141 0.17 -0.25 0.36 -0.326 0.559H1.5A1.5 1.5 0 0 1 0 11V1.5A1.5 1.5 0 0 1 1.5 0h3.683Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.72 6.737a0.75 0.75 0 0 0 -1.008 1.11l1.023 0.93a2.828 2.828 0 0 0 -0.087 0.695l0 0.032h-0.897a0.75 0.75 0 0 0 0 1.5h0.897l0 0.032c0 0.237 0.03 0.47 0.087 0.696l-1.023 0.929a0.75 0.75 0 1 0 1.009 1.11l0.781 -0.71a2.83 2.83 0 0 0 3.95 0l0.782 0.71a0.75 0.75 0 1 0 1.008 -1.11l-1.022 -0.93c0.057 -0.225 0.086 -0.458 0.086 -0.695l0 -0.032h0.898a0.75 0.75 0 0 0 0 -1.5h-0.898l0 -0.032c0 -0.237 -0.03 -0.47 -0.086 -0.695l1.022 -0.93a0.75 0.75 0 0 0 -1.008 -1.11l-0.781 0.71a2.829 2.829 0 0 0 -3.951 0l-0.781 -0.71Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BugVirusFolder"
);
var ChatBubbleSquareBlock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v8.919l-0.974 2.923a0.5 0.5 0 0 0 0.595 0.643L4.561 13H12.5a1.5 1.5 0 0 0 1.5 -1.5v-10A1.5 1.5 0 0 0 12.5 0h-10Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.217 4.256a2.625 2.625 0 0 1 3.606 3.606L6.217 4.256Zm-1.334 -0.54a0.635 0.635 0 0 0 -0.09 0.09 3.875 3.875 0 0 0 5.479 5.48 0.637 0.637 0 0 0 0.091 -0.09 3.875 3.875 0 0 0 -5.48 -5.479Zm4.056 5.03A2.625 2.625 0 0 1 5.333 5.14L8.94 8.746Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleSquareBlock"
);
var DatabaseLock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 2v7.882c0 1.366 2.574 2.475 5.75 2.475V10.5c0 -0.669 0.292 -1.269 0.754 -1.68A4 4 0 0 1 11.5 5.126V2c0 -1.105 -2.575 -2 -5.75 -2C2.574 0 0 0.895 0 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.006 7.05a3.973 3.973 0 0 0 -0.45 1.281c-0.265 0.013 -0.534 0.019 -0.806 0.019 -1.834 0 -3.522 -0.285 -4.775 -0.767A6.235 6.235 0 0 1 0 7.115V5.46c0.045 0.083 0.12 0.18 0.241 0.292 0.249 0.225 0.643 0.458 1.183 0.665C2.501 6.83 4.03 7.1 5.75 7.1c0.432 0 0.852 -0.017 1.256 -0.05Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 4c3.176 0 5.75 -0.895 5.75 -2S8.926 0 5.75 0 0 0.895 0 2s2.574 2 5.75 2Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.25 9a1.25 1.25 0 1 1 2.5 0v0.5h-2.5V9Zm-1.5 0.531V9a2.75 2.75 0 0 1 5.5 0v0.531a1 1 0 0 1 0.75 0.969V13a1 1 0 0 1 -1 1H8a1 1 0 0 1 -1 -1v-2.5a1 1 0 0 1 0.75 -0.969Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DatabaseLock"
);
var DeviceDatabaseEncryption1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.25 9a1.25 1.25 0 1 1 2.5 0v0.5h-2.5V9Zm-1.5 0.531V9a2.75 2.75 0 0 1 5.5 0v0.531a1 1 0 0 1 0.75 0.969V13a1 1 0 0 1 -1 1H8a1 1 0 0 1 -1 -1v-2.5a1 1 0 0 1 0.75 -0.969Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.47 0.092c-1.024 0 -1.91 0.803 -1.91 1.862v0.462c0 1.059 0.886 1.862 1.91 1.862 1.025 0 1.912 -0.803 1.912 -1.862v-0.462C6.382 0.895 5.495 0.092 4.471 0.092Zm-0.41 1.862c0 -0.17 0.152 -0.362 0.41 -0.362 0.259 0 0.412 0.192 0.412 0.362v0.462c0 0.17 -0.153 0.362 -0.411 0.362 -0.259 0 -0.412 -0.193 -0.412 -0.362v-0.462ZM0.843 0.092a0.75 0.75 0 0 1 0.75 0.75l0 2.703a0.75 0.75 0 1 1 -1.5 0V0.842a0.75 0.75 0 0 1 0.75 -0.75Zm0 4.792a0.75 0.75 0 0 1 0.75 0.75l0 2.703a0.75 0.75 0 1 1 -1.5 0V5.634a0.75 0.75 0 0 1 0.75 -0.75Zm3.215 0.75a0.75 0.75 0 1 0 -1.5 0v2.703a0.75 0.75 0 1 0 1.5 0V5.634ZM0.844 9.637a0.75 0.75 0 0 1 0.75 0.75l0 2.703a0.75 0.75 0 0 1 -1.5 0v-2.703a0.75 0.75 0 0 1 0.75 -0.75ZM8.847 0.842a0.75 0.75 0 0 0 -1.5 0v2.703a0.75 0.75 0 0 0 1.5 0V0.842Zm1.676 -0.75a0.75 0.75 0 0 1 0.75 0.75v2.703a0.75 0.75 0 1 1 -1.5 0V0.842a0.75 0.75 0 0 1 0.75 -0.75ZM2.559 11.516c0 -1.059 0.887 -1.862 1.912 -1.862 1.024 0 1.911 0.803 1.911 1.862v0.462c0 1.059 -0.887 1.862 -1.911 1.862 -1.025 0 -1.912 -0.803 -1.912 -1.862v-0.462Zm1.912 -0.362c-0.259 0 -0.412 0.193 -0.412 0.362v0.462c0 0.17 0.153 0.362 0.412 0.362 0.258 0 0.411 -0.192 0.411 -0.362v-0.462c0 -0.17 -0.153 -0.362 -0.411 -0.362Zm2.464 -6.32a1.911 1.911 0 0 0 -1.91 1.91v0.483a0.75 0.75 0 1 0 1.5 0v-0.483a0.41 0.41 0 0 1 0.41 -0.41 0.75 0.75 0 1 0 0 -1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DeviceDatabaseEncryption1"
);
var EyeOptic = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.270756 3.79297c0.292894 -0.29289 0.767764 -0.29289 1.060664 0l1.51206 1.51206c0.29289 0.2929 0.29289 0.76777 0 1.06066 -0.2929 0.2929 -0.76777 0.2929 -1.06066 0L0.270756 4.85363c-0.2928929 -0.29289 -0.2928929 -0.76776 0 -1.06066Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.35268 1.26781c0.39574 -0.12233 0.81572 0.09932 0.93804 0.49506l0.61635 1.99396c0.12232 0.39574 -0.09932 0.81572 -0.49506 0.93804 -0.39574 0.12233 -0.81572 -0.09932 -0.93804 -0.49506l-0.61635 -1.99396c-0.12232 -0.39574 0.09932 -0.81572 0.49506 -0.93804Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.7292 3.79297c-0.2929 -0.29289 -0.7678 -0.29289 -1.0607 0l-1.512 1.51206c-0.2929 0.2929 -0.2929 0.76777 0 1.06066 0.2929 0.2929 0.7677 0.2929 1.0606 0l1.5121 -1.51206c0.2929 -0.29289 0.2929 -0.76776 0 -1.06066Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.64732 1.26781c-0.39574 -0.12233 -0.81572 0.09932 -0.93804 0.49506l-0.61635 1.99396c-0.12232 0.39574 0.09932 0.81572 0.49506 0.93804 0.39574 0.12233 0.81572 -0.09932 0.93804 -0.49506l0.61637 -1.99396c0.1223 -0.39574 -0.0993 -0.81572 -0.49508 -0.93804Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.00024 2.96313c-2.27898 0 -3.90036 1.03114 -4.93433 2.05251 -0.51515 0.50886 -0.88982 1.01955 -1.137376 1.41094 -0.123986 0.19603 -0.217995 0.36514 -0.283208 0.49318 -0.032341 0.0635 -0.059417 0.12047 -0.080236 0.16821 -0.010018 0.02297 -0.021404 0.05024 -0.031771 0.0785 -0.004911 0.01339 -0.012747 0.03551 -0.020413 0.06216 -0.003807 0.01324 -0.009688 0.03486 -0.01513 0.06162 -0.00391 0.01923 -0.015354 0.07711 -0.015354 0.15188 0 0.07476 0.011444 0.13265 0.015354 0.15188 0.005442 0.02676 0.011323 0.04838 0.01513 0.06161 0.007666 0.02665 0.015502 0.04878 0.020413 0.06217 0.010367 0.02826 0.021753 0.05552 0.031771 0.0785 0.020819 0.04774 0.047895 0.1047 0.080236 0.16821 0.065213 0.12804 0.159222 0.29715 0.283208 0.49317 0.247556 0.39139 0.622226 0.90208 1.137376 1.41095C3.09988 10.89 4.72126 11.9211 7.00024 11.9211c2.27897 0 3.90036 -1.0311 4.93436 -2.05248 0.5151 -0.50887 0.8898 -1.01956 1.1373 -1.41095 0.124 -0.19602 0.218 -0.36513 0.2832 -0.49317 0.0324 -0.06351 0.0595 -0.12047 0.0803 -0.16821 0.01 -0.02298 0.0214 -0.05024 0.0318 -0.0785 0.0049 -0.01339 0.0127 -0.03552 0.0204 -0.06217 0.0038 -0.01323 0.0097 -0.03485 0.0151 -0.06161 0.0039 -0.01923 0.0153 -0.07712 0.0153 -0.15188 0 -0.07477 -0.0114 -0.13265 -0.0153 -0.15188 -0.0054 -0.02676 -0.0113 -0.04838 -0.0151 -0.06162 -0.0077 -0.02665 -0.0155 -0.04877 -0.0204 -0.06216 -0.0104 -0.02826 -0.0218 -0.05553 -0.0318 -0.0785 -0.0208 -0.04774 -0.0479 -0.10471 -0.0803 -0.16821 -0.0652 -0.12804 -0.1592 -0.29715 -0.2832 -0.49318 -0.2475 -0.39139 -0.6222 -0.90208 -1.1373 -1.41094 -1.034 -1.02137 -2.65539 -2.05251 -4.93436 -2.05251Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.06331 7.9145C8.8023 9.05437 7.66666 9.76683 6.52679 9.50581 5.38692 9.2448 4.67446 8.10916 4.93548 6.96929 5.19649 5.82942 6.33213 5.11697 7.472 5.37798c1.13987 0.26101 1.85232 1.39665 1.59131 2.53652Z" }),
    " "
  ] }) }),
  "EyeOptic"
);
var FaceScan1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.573 1.573A0.25 0.25 0 0 1 1.75 1.5h1.5a0.75 0.75 0 0 0 0 -1.5h-1.5A1.75 1.75 0 0 0 0 1.75v1.5a0.75 0.75 0 0 0 1.5 0v-1.5a0.25 0.25 0 0 1 0.073 -0.177ZM14 10.75a0.75 0.75 0 0 0 -1.5 0v1.5a0.25 0.25 0 0 1 -0.25 0.25h-1.5a0.75 0.75 0 0 0 0 1.5h1.5A1.75 1.75 0 0 0 14 12.25v-1.5ZM0.75 10a0.75 0.75 0 0 1 0.75 0.75v1.5a0.25 0.25 0 0 0 0.25 0.25h1.5a0.75 0.75 0 0 1 0 1.5h-1.5A1.75 1.75 0 0 1 0 12.25v-1.5A0.75 0.75 0 0 1 0.75 10Zm10 -10a0.75 0.75 0 0 0 0 1.5h1.5a0.25 0.25 0 0 1 0.25 0.25v1.5a0.75 0.75 0 0 0 1.5 0v-1.5A1.75 1.75 0 0 0 12.25 0h-1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 4.5a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm2.75 0a0.75 0.75 0 0 0 -1.5 0v2.75H5.5a0.75 0.75 0 0 0 0 1.5H7A0.75 0.75 0 0 0 7.75 8V4.5ZM5.017 9.456a0.75 0.75 0 1 0 -1.034 1.088 4.38 4.38 0 0 0 6.034 0 0.75 0.75 0 1 0 -1.034 -1.088 2.88 2.88 0 0 1 -3.966 0ZM10 5.5a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FaceScan1"
);
var Fingerprint1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.75 6.75C1.75 3.8505 4.10051 1.5 7 1.5c2.8995 0 5.25 2.35051 5.25 5.25v2c0 0.41421 0.3358 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-2C13.75 3.02208 10.7279 0 7 0 3.27208 0 0.25 3.02208 0.25 6.75v6.5c0 0.4142 0.335786 0.75 0.75 0.75 0.41421 0 0.75 -0.3358 0.75 -0.75v-6.5Zm3 5c0 -0.4142 -0.33579 -0.75 -0.75 -0.75s-0.75 0.3358 -0.75 0.75v1.5c0 0.4142 0.33579 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75v-1.5ZM7 5C5.75736 5 4.75 6.00736 4.75 7.25v1.5c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-1.5C3.25 5.17893 4.92893 3.5 7 3.5c2.07107 0 3.75 1.67893 3.75 3.75v6c0 0.4142 -0.3358 0.75 -0.75 0.75 -0.41421 0 -0.75 -0.3358 -0.75 -0.75v-6C9.25 6.00736 8.24264 5 7 5Zm6.75 6.75c0 -0.4142 -0.3358 -0.75 -0.75 -0.75s-0.75 0.3358 -0.75 0.75v1.5c0 0.4142 0.3358 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75v-1.5ZM7 11.5c0.41421 0 0.75 0.3358 0.75 0.75v1c0 0.4142 -0.33579 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75v-1c0 -0.4142 0.33579 -0.75 0.75 -0.75Zm0.75 -3.75C7.75 7.33579 7.41421 7 7 7s-0.75 0.33579 -0.75 0.75v1.5c0 0.41421 0.33579 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Fingerprint1"
);
var Fingerprint2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.54 0.192a5.64 5.64 0 0 1 3.767 0.301 0.75 0.75 0 1 1 -0.614 1.369A4.14 4.14 0 0 0 3.414 3.57c-0.2 0.345 -0.347 0.716 -0.438 1.102a0.75 0.75 0 0 1 -1.46 -0.344A5.64 5.64 0 0 1 5.54 0.192Zm6.073 2.203a0.75 0.75 0 1 0 -1.226 0.863 4.14 4.14 0 0 1 0.753 2.383V8.36A4.14 4.14 0 0 1 7 12.5 0.75 0.75 0 0 0 7 14a5.64 5.64 0 0 0 5.64 -5.64V5.64a5.64 5.64 0 0 0 -1.027 -3.245ZM2.86 6.726a0.75 0.75 0 1 0 -1.5 0V8.36a5.64 5.64 0 0 0 2.757 4.85 0.75 0.75 0 0 0 0.766 -1.29A4.14 4.14 0 0 1 2.86 8.36V6.727Zm3.988 -2.435a1.705 1.705 0 0 1 1.847 1.721V7a0.75 0.75 0 1 0 1.5 0v-0.974a3.205 3.205 0 0 0 -3.473 -3.23 0.75 0.75 0 0 0 0.126 1.495Zm-1.805 0.062a0.75 0.75 0 0 1 0.398 0.983 1.725 1.725 0 0 0 -0.136 0.681l0 0.005V7.99A1.695 1.695 0 0 0 8.26 9.15a0.75 0.75 0 0 1 1.116 1.001 3.195 3.195 0 0 1 -5.572 -2.179V6.023c-0.002 -0.436 0.084 -0.87 0.255 -1.272a0.75 0.75 0 0 1 0.983 -0.398ZM7.75 6.129a0.75 0.75 0 1 0 -1.5 0v1.634a0.75 0.75 0 0 0 1.5 0V6.129Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Fingerprint2"
);
var InboxBlock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.576 0h9.311c0.858 0 1.552 0.695 1.552 1.552v4.677a4.671 4.671 0 0 0 -6.507 3.082H1.576A1.552 1.552 0 0 1 0.024 7.76V1.552C0.024 0.695 0.72 0 1.576 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.44 1.63 6.231 4.732 0.024 1.629v1.398L5.952 5.99a0.625 0.625 0 0 0 0.56 0l5.927 -2.964V1.629Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.487 10.46a2.028 2.028 0 0 0 -2.83 -1.863l2.665 2.665a2.02 2.02 0 0 0 0.165 -0.802ZM13 12.907a3.528 3.528 0 1 0 -5.082 -4.894A3.528 3.528 0 0 0 13 12.906Zm-1.738 -0.585L8.597 9.657a2.028 2.028 0 0 0 2.665 2.665Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InboxBlock"
);
var InboxLock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.58 0h9.311c0.857 0 1.552 0.695 1.552 1.552v3.95A4 4 0 0 0 6.504 8.82c-0.16 0.144 -0.3 0.31 -0.415 0.492H1.58A1.552 1.552 0 0 1 0.029 7.76V1.552A1.55 1.55 0 0 1 1.58 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.443 1.63 6.235 4.732 0.028 1.629v1.398L5.956 5.99a0.625 0.625 0 0 0 0.559 0l5.928 -2.964V1.629Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.25 9a1.25 1.25 0 1 1 2.5 0v0.5h-2.5V9Zm-1.5 0.531V9a2.75 2.75 0 0 1 5.5 0v0.531a1 1 0 0 1 0.75 0.969V13a1 1 0 0 1 -1 1H8a1 1 0 0 1 -1 -1v-2.5a1 1 0 0 1 0.75 -0.969Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InboxLock"
);
var IncognitoMode = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2505 9.39893c-0.82871 0 -1.5005 0.67177 -1.5005 1.50047s0.67179 1.5005 1.5005 1.5005c0.8287 0 1.5005 -0.6718 1.5005 -1.5005s-0.6718 -1.50047 -1.5005 -1.50047Zm-2.52994 -0.11341c0.53301 -0.8338 1.46691 -1.38659 2.52994 -1.38659 1.6571 0 3.0005 1.34336 3.0005 3.00047 0 1.6571 -1.3434 3.0005 -3.0005 3.0005 -1.64269 0 -2.97705 -1.32 -3.00019 -2.9572 -0.00058 -0.0101 -0.00095 -0.0203 -0.00113 -0.0305l-0.00015 -0.0023c-0.00053 -0.0075 -0.00195 -0.023 -0.00538 -0.0435 -0.00745 -0.0447 -0.02095 -0.0928 -0.04046 -0.1319 -0.01806 -0.0361 -0.03335 -0.0494 -0.04225 -0.0553l-0.00021 -0.0001c-0.00517 -0.0035 -0.04504 -0.0303 -0.16217 -0.0303 -0.11712 0 -0.157 0.0268 -0.16217 0.0303l-0.00021 0.0001c-0.00889 0.0059 -0.02419 0.0192 -0.04224 0.0553 -0.01952 0.0391 -0.03302 0.0872 -0.04046 0.1319 -0.00208 0.0124 -0.00342 0.023 -0.00427 0.031l0 0.0021c0 1.6571 -1.34335 3.0005 -3.00046 3.0005 -1.65711 0 -3.000459 -1.3434 -3.000459 -3.0005 0 -1.65708 1.343349 -3.00044 3.000459 -3.00044 1.06267 0 1.99632 0.55245 2.5294 1.3858 0.21557 -0.08956 0.45716 -0.13602 0.72041 -0.13602 0.26391 0 0.50603 0.04669 0.722 0.13668ZM5.24883 10.9339c-0.01828 0.8128 -0.68289 1.4661 -1.50008 1.4661 -0.82868 0 -1.50046 -0.6718 -1.50046 -1.5005s0.67178 -1.50044 1.50046 -1.50044c0.81611 0 1.48004 0.65154 1.5 1.46284 -0.00001 0.0004 -0.00003 0.0009 -0.00004 0.0013l-0.00054 0.0212 -0.0001 0.0083 -0.00002 0.0036 0 0.0016 0 0.0008s0 0.0001 0.00116 0.0001l0 0.0006h-0.00116c0 0.0116 0.00026 0.0231 0.00078 0.0345Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.54449 1.21767C2.66162 0.515006 3.26957 0 3.98193 0h6.03627c0.7123 0 1.3203 0.515036 1.4374 1.21773l0.7126 4.27595h1.0541c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75H0.77771c-0.414214 0 -0.75 -0.33579 -0.75 -0.75s0.335786 -0.75 0.75 -0.75h1.05403l0.71275 -4.27601Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "IncognitoMode"
);
var Invisible1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 2.04c-1.532 0 -2.92 0.677 -4.035 1.48C1.847 4.324 0.962 5.288 0.426 5.936l-0.004 0.005C0.182 6.24 0.056 6.617 0.056 7s0.126 0.76 0.366 1.058l0.004 0.006c0.536 0.647 1.421 1.611 2.54 2.417C4.08 11.284 5.467 11.96 7 11.96s2.92 -0.676 4.035 -1.479c1.118 -0.806 2.003 -1.77 2.539 -2.417l0.004 -0.006c0.24 -0.298 0.366 -0.675 0.366 -1.058s-0.126 -0.76 -0.366 -1.058l-0.004 -0.005c-0.536 -0.648 -1.421 -1.612 -2.54 -2.418C9.92 2.717 8.533 2.04 7 2.04Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.264 1.324a0.75 0.75 0 0 1 1.06 -1.06L6.03 4.969a2.25 2.25 0 0 1 3 3l4.706 4.707a0.75 0.75 0 1 1 -1.06 1.06L0.264 1.324Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Invisible1"
);
var Invisible2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.6149 3.54054c0.48635 -0.26169 1.09276 -0.07958 1.35445 0.40677 0.19583 0.36392 0.45119 0.69984 0.75556 0.99592 0.02629 0.02247 0.05164 0.0465 0.07591 0.07208 0.80614 0.74709 1.93302 1.22235 3.19969 1.22235 1.26259 0 2.38628 -0.4722 3.19189 -1.21512 0.0287 -0.03082 0.0589 -0.05945 0.0904 -0.08586 0.3015 -0.29448 0.5545 -0.62813 0.7489 -0.98937 0.2617 -0.48635 0.8681 -0.66846 1.3544 -0.40677 0.4864 0.2617 0.6685 0.86811 0.4068 1.35446 -0.1312 0.24377 -0.279 0.47767 -0.442 0.70047l1.2914 1.08233c0.4233 0.35475 0.4789 0.98547 0.1241 1.40876 -0.3547 0.42329 -0.9854 0.47885 -1.4087 0.12411L10.918 7.00416c-0.356 0.25316 -0.7403 0.47216 -1.1471 0.65242l0.6168 1.55328c0.2038 0.5133 -0.0471 1.09464 -0.56041 1.29844 -0.5133 0.2038 -1.09464 -0.0471 -1.29845 -0.56035l-0.69873 -1.75969c-0.27202 0.03262 -0.54894 0.0494 -0.8296 0.0494 -0.28212 0 -0.56047 -0.01696 -0.83387 -0.04991l-0.69892 1.7602c-0.20382 0.51325 -0.78516 0.76415 -1.29846 0.56035 -0.5133 -0.2038 -0.76418 -0.78514 -0.56037 -1.29844l0.61744 -1.55496c-0.40561 -0.18004 -0.78879 -0.3986 -1.14391 -0.65113l-1.4401 1.2069c-0.42329 0.35474 -1.054007 0.29918 -1.408753 -0.12411 -0.354745 -0.42329 -0.2991794 -1.05401 0.12411 -1.40876L1.64977 5.59494c-0.16286 -0.22265 -0.31056 -0.45636 -0.44163 -0.69994 -0.2617 -0.48635 -0.07958 -1.09276 0.40676 -1.35446Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Invisible2"
);
var Key = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 -1.414 1.414L11 3.414 9.914 4.5l1.293 1.293a1 1 0 0 1 -1.414 1.414L8.5 5.914 7.446 6.968a4 4 0 1 1 -1.414 -1.414l1.757 -1.757 0.004 -0.004 0.004 -0.004 2.496 -2.496ZM2 9a2 2 0 1 1 4 0 2 2 0 0 1 -4 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Key"
);
var KeyholeLockCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 7.732a2 2 0 1 0 -2 0V9.5a1 1 0 1 0 2 0V7.732Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "KeyholeLockCircle"
);
var LockRotation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 7a5.5 5.5 0 0 1 9.82 -3.405l-0.966 0.965a0.5 0.5 0 0 0 0.353 0.854H13.5a0.5 0.5 0 0 0 0.5 -0.5V2.12a0.5 0.5 0 0 0 -0.854 -0.354l-0.76 0.761a7 7 0 1 0 1.427 6.086 0.75 0.75 0 0 0 -1.46 -0.344A5.5 5.5 0 0 1 1.5 7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.125 5.813a0.875 0.875 0 1 1 1.75 0v0.5h-1.75v-0.5Zm-1.25 0.719v-0.72a2.125 2.125 0 1 1 4.25 0v0.72a0.998 0.998 0 0 1 0.375 0.78v2a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-2c0 -0.315 0.146 -0.597 0.375 -0.78Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LockRotation"
);
var PadlockSquare1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2a2 2 0 0 0 -2 2v1.5a1 1 0 0 1 -2 0V4a4 4 0 1 1 8 0v1.5a1 1 0 1 1 -2 0V4a2 2 0 0 0 -2 -2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 6.5A1.5 1.5 0 0 1 3 5h8a1.5 1.5 0 0 1 1.5 1.5v6A1.5 1.5 0 0 1 11 14H3a1.5 1.5 0 0 1 -1.5 -1.5v-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.75 9.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 1 0 -2.5 0" }),
    " "
  ] }) }),
  "PadlockSquare1"
);
var Shield1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 4.927a9.399 9.399 0 0 1 -6.635 8.984 1.242 1.242 0 0 1 -0.73 0A9.399 9.399 0 0 1 0 4.927V1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v3.427Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shield1"
);
var Shield2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.41215 0.216928C7.32078 0.0838935 7.17082 0.00314212 7.00946 0.0000896752 6.8481 -0.00296277 6.69518 0.0720591 6.59885 0.201543 5.9697 1.04718 5.12412 1.70747 4.15119 2.11285c-0.97293 0.40539 -2.03718 0.54086 -3.08064 0.39215 -0.143471 -0.02044 -0.288752 0.02236 -0.398214 0.11733S0.5 2.85508 0.5 3v2.78113c0.003853 1.70548 0.52066 3.37037 1.48325 4.77827 0.96258 1.4079 2.32643 2.4936 3.91425 3.1161l0.0009 0.0004 0.59 0.23 -0.00002 0 0.00609 0.0023c0.32594 0.1222 0.68512 0.1222 1.01106 0l0.00002 0 0.00605 -0.0023 0.59 -0.23L7.92 13.21l0.1825 0.4655c1.58782 -0.6225 2.9517 -1.7082 3.9143 -3.1161 0.9625 -1.4079 1.4793 -3.07279 1.4832 -4.77827l0 -0.00113V3c0 -0.13843 -0.0574 -0.27066 -0.1585 -0.36521 -0.1011 -0.09454 -0.2369 -0.14294 -0.375 -0.13367 -2.5491 0.17121 -4.42764 -0.64371 -5.55435 -2.284192Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shield2"
);
var ShieldCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0C0.68 0 0 0.678 0 1.5v2.853c0 4.136 2.51 8.006 6.411 9.528 0.167 0.065 0.365 0.118 0.582 0.12a1.62 1.62 0 0 0 0.596 -0.12C11.49 12.359 14 8.489 14 4.353V1.5c0 -0.82 -0.68 -1.5 -1.5 -1.5h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.498 3.44a0.75 0.75 0 0 1 0.063 1.058l-4 4.5A0.75 0.75 0 0 1 5.55 9.1l-2 -1.5a0.75 0.75 0 1 1 0.9 -1.2l1.448 1.086 3.541 -3.984a0.75 0.75 0 0 1 1.06 -0.063Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShieldCheck"
);
var ShieldCross = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M14 4.927a9.399 9.399 0 0 1 -6.635 8.984 1.242 1.242 0 0 1 -0.73 0A9.399 9.399 0 0 1 0 4.927V1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v3.427Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.1 2.408a0.5 0.5 0 0 0 -0.5 0.5v1.7H3.901a0.5 0.5 0 0 0 -0.5 0.5v1.798a0.5 0.5 0 0 0 0.5 0.5h1.7v1.699a0.5 0.5 0 0 0 0.5 0.5h1.798a0.5 0.5 0 0 0 0.5 -0.5V7.406h1.7a0.5 0.5 0 0 0 0.5 -0.5V5.107a0.5 0.5 0 0 0 -0.5 -0.5h-1.7V2.908a0.5 0.5 0 0 0 -0.5 -0.5H6.1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShieldCross"
);
var ThreatBrowser1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.046 1.75C0.046 0.81 0.81 0.047 1.751 0.047h10.498c0.942 0 1.705 0.763 1.705 1.705v9.06L11.5 6.514c-0.768 -1.343 -2.706 -1.343 -3.473 0l-3.139 5.493a1.98 1.98 0 0 0 -0.021 1.946H1.75a1.704 1.704 0 0 1 -1.705 -1.705V1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.75 0.046C0.81 0.046 0.047 0.81 0.047 1.751V3.5h13.908V1.75c0 -0.94 -0.763 -1.704 -1.705 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.65 7.012a1 1 0 0 0 -1.736 0l-3.139 5.492A1 1 0 0 0 6.643 14h6.277a1 1 0 0 0 0.869 -1.496L10.65 7.012Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.407 9.5a0.625 0.625 0 0 0 -1.25 0v1a0.625 0.625 0 1 0 1.25 0v-1Zm-0.625 3.625a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 0 0 0 1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ThreatBrowser1"
);
var ThreatDocument = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.65 7.012a1 1 0 0 0 -1.736 0l-3.139 5.492A1 1 0 0 0 6.643 14h6.277a1 1 0 0 0 0.869 -1.496L10.65 7.012Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.44 0.44A1.5 1.5 0 0 1 1.5 0h6a0.5 0.5 0 0 1 0.354 0.146l3 3A0.5 0.5 0 0 1 11 3.5v2.432c-0.912 -0.719 -2.34 -0.524 -2.973 0.584L4.893 12H1.5A1.5 1.5 0 0 1 0 10.5v-9C0 1.102 0.158 0.72 0.44 0.44Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.407 9.5a0.625 0.625 0 0 0 -1.25 0v1a0.625 0.625 0 1 0 1.25 0v-1Zm-0.625 3.625a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 0 0 0 1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ThreatDocument"
);
var ThreatFolder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.65 7.012a1 1 0 0 0 -1.736 0l-3.139 5.492A1 1 0 0 0 6.643 14h6.277a1 1 0 0 0 0.869 -1.496L10.65 7.012Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.183 0a1.5 1.5 0 0 1 1.492 1.14l0.003 0.01 0.192 0.85h5.6a1.5 1.5 0 0 1 1.5 1.5v7.339L11.5 6.515c-0.768 -1.343 -2.706 -1.343 -3.473 0l-3.139 5.493a2.03 2.03 0 0 0 -0.202 0.492H1.5A1.5 1.5 0 0 1 0 11V1.5A1.5 1.5 0 0 1 1.5 0h3.683Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.407 9.5a0.625 0.625 0 0 0 -1.25 0v1a0.625 0.625 0 1 0 1.25 0v-1Zm-0.625 3.625a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 0 0 0 1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ThreatFolder"
);
var UserProtection2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.75 0A1.75 1.75 0 0 0 0 1.75v3.257a9.307 9.307 0 0 0 6.57 8.895c0.28 0.087 0.58 0.087 0.86 0A9.307 9.307 0 0 0 14 5.007V1.75A1.75 1.75 0 0 0 12.25 0H1.75Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.25 4.25a2.25 2.25 0 1 1 -4.5 0 2.25 2.25 0 0 1 4.5 0ZM7 7.5c1.657 0 3.143 0.733 4.152 1.893A7.798 7.798 0 0 1 7 12.465a7.798 7.798 0 0 1 -4.152 -3.072A5.487 5.487 0 0 1 7 7.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UserProtection2"
);
var VirusAntivirus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 2.719a0.75 0.75 0 0 0 -1.5 0v0.861a3.505 3.505 0 0 0 -2.67 2.67h-0.861a0.75 0.75 0 0 0 0 1.5h0.86c0.09 0.411 0.252 0.795 0.472 1.138l-0.609 0.609a0.75 0.75 0 0 0 1.061 1.06l0.61 -0.609c0.342 0.22 0.726 0.382 1.137 0.472v0.861a0.75 0.75 0 1 0 1.5 0v-0.862a3.505 3.505 0 0 0 2.669 -2.669h0.862a0.75 0.75 0 1 0 0 -1.5h-0.862a3.479 3.479 0 0 0 -0.471 -1.137l0.61 -0.61a0.75 0.75 0 1 0 -1.061 -1.06l-0.61 0.61A3.48 3.48 0 0 0 7.75 3.58v-0.86Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.663 2.603a5.52 5.52 0 0 1 7.734 7.734L3.664 2.603Zm-1.06 1.06a5.52 5.52 0 0 0 7.734 7.734L2.603 3.663ZM7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VirusAntivirus"
);
var Visible = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 2c-1.544 0 -2.944 0.682 -4.067 1.491 -1.128 0.812 -2.02 1.784 -2.56 2.437l-0.005 0.005C0.127 6.233 0 6.614 0 7c0 0.386 0.127 0.766 0.368 1.067l0.005 0.005c0.54 0.653 1.432 1.625 2.56 2.437C4.056 11.32 5.456 12 7 12s2.944 -0.682 4.067 -1.49c1.128 -0.813 2.02 -1.785 2.56 -2.438l0.005 -0.005c0.241 -0.3 0.368 -0.68 0.368 -1.067a1.71 1.71 0 0 0 -0.368 -1.067l-0.005 -0.005c-0.54 -0.653 -1.432 -1.625 -2.56 -2.437C9.944 2.681 8.544 2 7 2Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.75 7a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0" }),
    " "
  ] }) }),
  "Visible"
);
var VoiceScan2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.50012 4.375c0.34518 0 0.625 0.27982 0.625 0.625v4.5c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625V5c0 -0.34518 0.27982 -0.625 0.625 -0.625Zm2.24994 1c0.34518 0 0.625 0.27982 0.625 0.625v2.5c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625V6c0 -0.34518 0.27982 -0.625 0.625 -0.625ZM7.625 5c0 -0.34518 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27982 -0.625 0.625v4.5c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625V5Zm1.62494 0.375c0.34518 0 0.625 0.27982 0.625 0.625v2.5c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625V6c0 -0.34518 0.27982 -0.625 0.625 -0.625ZM12.1248 5c0 -0.34518 -0.2798 -0.625 -0.625 -0.625s-0.625 0.27982 -0.625 0.625v4.5c0 0.34518 0.2798 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625V5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.57322 1.57322C1.62011 1.52634 1.6837 1.5 1.75 1.5h1.5c0.41421 0 0.75 -0.33579 0.75 -0.75C4 0.335786 3.66421 0 3.25 0h-1.5C1.28587 0 0.840752 0.184375 0.512563 0.512563 0.184375 0.840752 0 1.28587 0 1.75v1.5c0 0.41421 0.335786 0.75 0.75 0.75 0.41421 0 0.75 -0.33579 0.75 -0.75v-1.5c0 -0.0663 0.02634 -0.12989 0.07322 -0.17678ZM14 10.75c0 -0.4142 -0.3358 -0.75 -0.75 -0.75s-0.75 0.3358 -0.75 0.75v1.5c0 0.0663 -0.0263 0.1299 -0.0732 0.1768 -0.0469 0.0469 -0.1105 0.0732 -0.1768 0.0732h-1.5c-0.4142 0 -0.75 0.3358 -0.75 0.75s0.3358 0.75 0.75 0.75h1.5c0.4641 0 0.9092 -0.1844 1.2374 -0.5126 0.3282 -0.3282 0.5126 -0.7733 0.5126 -1.2374v-1.5ZM0.75 10c0.41421 0 0.75 0.3358 0.75 0.75v1.5c0 0.0663 0.02634 0.1299 0.07322 0.1768 0.04689 0.0469 0.11048 0.0732 0.17678 0.0732h1.5c0.41421 0 0.75 0.3358 0.75 0.75s-0.33579 0.75 -0.75 0.75h-1.5c-0.46413 0 -0.909248 -0.1844 -1.237437 -0.5126C0.184375 13.1592 0 12.7141 0 12.25v-1.5c0 -0.4142 0.335786 -0.75 0.75 -0.75Zm10 -10c-0.4142 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.3358 0.75 0.75 0.75h1.5c0.0663 0 0.1299 0.02634 0.1768 0.07322 0.0469 0.04689 0.0732 0.11048 0.0732 0.17678v1.5c0 0.41421 0.3358 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-1.5c0 -0.46413 -0.1844 -0.909248 -0.5126 -1.237437C13.1592 0.184375 12.7141 0 12.25 0h-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VoiceScan2"
);
var VpnConnection = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.53623 0C0.694014 0 0 0.696591 0 1.53812v2.92559c0 4.16861 2.57482 7.94149 6.44342 9.43209l0.00942 0.0035 0.01198 0.0042c0.3474 0.116 0.76647 0.1462 1.11095 -0.0151C11.4311 12.394 14 8.72248 14 4.46371V1.53812C14 0.69659 13.306 0 12.4638 0H1.53623Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.99759 4.22144c-1.71789 0 -2.98125 0.64189 -3.34216 0.90936 -0.27732 0.20552 -0.66875 0.14731 -0.87427 -0.13002 -0.20552 -0.27732 -0.14731 -0.66875 0.13002 -0.87427 0.56765 -0.42068 2.09002 -1.15507 4.08641 -1.15507 1.99639 0 3.51871 0.73439 4.08641 1.15507 0.2773 0.20552 0.3355 0.59695 0.13 0.87427 -0.2055 0.27733 -0.5969 0.33554 -0.8743 0.13002 -0.36086 -0.26747 -1.62422 -0.90936 -3.34211 -0.90936Zm-0.00003 2.58349c-0.79563 0 -1.71243 0.38403 -2.06339 0.5791 -0.30171 0.16769 -0.68223 0.05905 -0.84993 -0.24266 -0.16769 -0.3017 -0.05905 -0.68223 0.24266 -0.84992 0.43805 -0.24347 1.57267 -0.73652 2.67066 -0.73652 1.09799 0 2.23262 0.49305 2.67066 0.73652 0.30171 0.16769 0.41038 0.54822 0.24266 0.84992 -0.16769 0.30171 -0.54822 0.41035 -0.84992 0.24266 -0.35097 -0.19507 -1.26777 -0.5791 -2.0634 -0.5791Zm-0.47154 2.82038c0.02774 -0.01542 0.10655 -0.05333 0.20832 -0.08622 0.10381 -0.03354 0.1968 -0.0505 0.26324 -0.0505 0.06644 0 0.15944 0.01696 0.26325 0.0505 0.10177 0.03289 0.18057 0.0708 0.20831 0.08622 0.30171 0.16769 0.68223 0.05905 0.84992 -0.24266s0.05905 -0.68223 -0.24265 -0.84992c-0.17274 -0.09601 -0.61757 -0.29414 -1.07883 -0.29414 -0.46125 0 -0.90608 0.19813 -1.07882 0.29414 -0.30171 0.16769 -0.41035 0.54821 -0.24266 0.84992 0.16769 0.30171 0.54822 0.41035 0.84992 0.24266Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "VpnConnection"
);
var BagDollar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.77 0 6.463 -1.336 6.463 -4.308 0 -3.232 -1.616 -4.869 -4.847 -6.485l1.397 -2.184A0.701 0.701 0 0 0 9.41 0H4.843a0.7 0.7 0 0 0 -0.603 1.077l1.144 2.13C2.154 4.845 0.537 6.482 0.537 9.713 0.537 12.664 3.23 14 7 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.262c0.345 0 0.625 0.28 0.625 0.625v0.637a1.873 1.873 0 0 1 1.56 1.239 0.625 0.625 0 1 1 -1.179 0.416 0.624 0.624 0 0 0 -0.59 -0.417H6.45a0.49 0.49 0 0 0 -0.105 0.97l1.473 0.323a1.875 1.875 0 0 1 -0.192 3.696v0.636a0.625 0.625 0 1 1 -1.25 0v-0.636a1.877 1.877 0 0 1 -1.56 -1.239 0.625 0.625 0 1 1 1.179 -0.416 0.625 0.625 0 0 0 0.59 0.416h0.833a0.625 0.625 0 0 0 0.133 -1.236l-1.473 -0.322a1.74 1.74 0 0 1 0.298 -3.44v-0.627c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BagDollar"
);
var BagPound = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.77 0 6.463 -1.336 6.463 -4.308 0 -3.232 -1.616 -4.869 -4.847 -6.485l1.397 -2.184A0.701 0.701 0 0 0 9.41 0H4.843a0.7 0.7 0 0 0 -0.603 1.077l1.144 2.13C2.154 4.845 0.537 6.482 0.537 9.713 0.537 12.664 3.23 14 7 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.926 6.12a1.477 1.477 0 0 0 -0.438 -0.224 2.794 2.794 0 0 0 -0.64 -0.14c-0.485 -0.047 -1.13 0.03 -1.639 0.538 -0.367 0.367 -0.476 0.851 -0.511 1.276 -0.017 0.198 -0.018 0.41 -0.015 0.62H5.25a0.5 0.5 0 1 0 0 1h0.446c-0.01 0.245 -0.041 0.448 -0.105 0.613 -0.078 0.201 -0.209 0.357 -0.5 0.454a0.5 0.5 0 0 0 0.159 0.974h3.5a0.5 0.5 0 1 0 0 -1H6.496l0.028 -0.067c0.12 -0.312 0.162 -0.652 0.173 -0.974h1.47a0.5 0.5 0 0 0 0 -1H6.684a5.159 5.159 0 0 1 0.01 -0.537c0.028 -0.34 0.105 -0.535 0.222 -0.652 0.22 -0.22 0.52 -0.28 0.836 -0.25 0.155 0.016 0.298 0.052 0.408 0.09 0.071 0.025 0.112 0.044 0.128 0.052l0.009 0.004 -0.007 -0.006a0.5 0.5 0 1 0 0.636 -0.772Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BagPound"
);
var BagRupee = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.77 0 6.463 -1.336 6.463 -4.308 0 -3.232 -1.616 -4.869 -4.847 -6.485l1.397 -2.184A0.701 0.701 0 0 0 9.41 0H4.843a0.7 0.7 0 0 0 -0.603 1.077l1.144 2.13C2.154 4.845 0.537 6.482 0.537 9.713 0.537 12.664 3.23 14 7 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.641 6.5H4.958a0.5 0.5 0 0 1 0 -1h1.739l0.022 0h2.323a0.5 0.5 0 0 1 0 1H8.15c0.093 0.176 0.162 0.376 0.198 0.604h0.694a0.5 0.5 0 1 1 0 1H8.28c-0.085 0.27 -0.222 0.503 -0.396 0.698 -0.29 0.327 -0.663 0.529 -1 0.656a3.389 3.389 0 0 1 -0.055 0.02c0.459 0.257 1.057 0.53 1.75 0.704a0.5 0.5 0 1 1 -0.242 0.97 8.243 8.243 0 0 1 -3.105 -1.55l-0.013 -0.012 -0.005 -0.003 -0.001 -0.002 0.328 -0.377 -0.329 0.377a0.5 0.5 0 0 1 0.328 -0.877l0.002 0 0.013 0c0.013 0 0.033 0 0.06 -0.002a3.286 3.286 0 0 0 0.917 -0.185 1.507 1.507 0 0 0 0.633 -0.417H4.958a0.5 0.5 0 0 1 0 -1h2.366a0.811 0.811 0 0 0 -0.226 -0.354 1.176 1.176 0 0 0 -0.457 -0.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BagRupee"
);
var BagYen = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.77 0 6.463 -1.336 6.463 -4.308 0 -3.232 -1.616 -4.869 -4.847 -6.485l1.397 -2.184A0.701 0.701 0 0 0 9.41 0H4.843a0.7 0.7 0 0 0 -0.603 1.077l1.144 2.13C2.154 4.845 0.537 6.482 0.537 9.713 0.537 12.664 3.23 14 7 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.65 5.7a0.5 0.5 0 0 0 -0.8 0.6L6 7.833h-0.75a0.5 0.5 0 0 0 0 1H6.5v0.459H5.25a0.5 0.5 0 1 0 0 1H6.5v0.666a0.5 0.5 0 1 0 1 0v-0.666h1.25a0.5 0.5 0 1 0 0 -1H7.5v-0.459h1.25a0.5 0.5 0 1 0 0 -1H8L9.15 6.3a0.5 0.5 0 0 0 -0.8 -0.6L7 7.5 5.65 5.7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BagYen"
);
var Bill1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 6.439c-0.801 0 -1.5 0.62 -1.5 1.445v4.67C2 13.38 2.699 14 3.5 14h7c0.802 0 1.5 -0.62 1.5 -1.445V7.884c0 -0.824 -0.698 -1.445 -1.5 -1.445h-7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.5 3.72c-0.801 0 -1.5 0.62 -1.5 1.445v4.67c0 0.825 0.699 1.446 1.5 1.446h9c0.802 0 1.5 -0.621 1.5 -1.446v-4.67c0 -0.825 -0.698 -1.446 -1.5 -1.446h-9Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0C0.699 0 0 0.62 0 1.445v5.671c0 0.824 0.699 1.445 1.5 1.445h11c0.802 0 1.5 -0.62 1.5 -1.445v-5.67C14 0.62 13.302 0 12.5 0h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.477a1.803 1.803 0 1 0 0 3.607 1.803 1.803 0 0 0 0 -3.607ZM3.529 4.502a0.752 0.752 0 1 1 -1.504 0 0.752 0.752 0 0 1 1.504 0Zm7.694 0.752a0.752 0.752 0 1 0 0 -1.504 0.752 0.752 0 0 0 0 1.504Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bill1"
);
var Bill2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 2.225c-0.804 0 -1.5 0.626 -1.5 1.45v6.65c0 0.824 0.696 1.45 1.5 1.45h11c0.804 0 1.5 -0.626 1.5 -1.45v-6.65c0 -0.824 -0.696 -1.45 -1.5 -1.45h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.899A2.101 2.101 0 1 0 7 9.1a2.101 2.101 0 0 0 0 -4.2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.5 7a0.752 0.752 0 1 0 1.504 0A0.752 0.752 0 1 0 1.5 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.996 7A0.752 0.752 0 1 0 12.5 7a0.752 0.752 0 1 0 -1.504 0" }),
    " "
  ] }) }),
  "Bill2"
);
var Bill4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.139 3.5c-0.777 0 -1.486 0.585 -1.486 1.4v5.396c0 0.815 0.71 1.4 1.486 1.4h8.376c0.776 0 1.485 -0.585 1.485 -1.4V4.899c0 -0.814 -0.709 -1.399 -1.485 -1.399H4.139Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.485 1.25C0.71 1.25 0 1.835 0 2.65v5.396c0 0.815 0.709 1.4 1.485 1.4h8.376c0.777 0 1.486 -0.585 1.486 -1.4V2.649c0 -0.814 -0.71 -1.399 -1.486 -1.399H1.485Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.673 3.846a1.501 1.501 0 1 0 0 3.003 1.501 1.501 0 0 0 0 -3.003Zm-3.398 0.752a0.75 0.75 0 1 0 0 1.5 0.75 0.75 0 0 0 0 -1.5Zm6.2 0.75a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bill4"
);
var BillCashless = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 2.225c-0.804 0 -1.5 0.626 -1.5 1.45v6.65c0 0.824 0.696 1.45 1.5 1.45h11c0.804 0 1.5 -0.626 1.5 -1.45v-6.65c0 -0.824 -0.696 -1.45 -1.5 -1.45h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.219 1.28A0.75 0.75 0 0 1 1.279 0.219l4.563 4.562a2.5 2.5 0 0 1 3.372 3.372l4.567 4.567a0.75 0.75 0 1 1 -1.06 1.061L0.218 1.28Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BillCashless"
);
var BriefcaseDollar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.763 0.587A1.75 1.75 0 0 1 5 0.074h4a1.75 1.75 0 0 1 1.75 1.75v2a0.75 0.75 0 0 1 -1.5 0v-2a0.25 0.25 0 0 0 -0.25 -0.25H5a0.25 0.25 0 0 0 -0.25 0.25v2a0.75 0.75 0 0 1 -1.5 0v-2c0 -0.464 0.184 -0.91 0.513 -1.237Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 3A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-8A1.5 1.5 0 0 0 12.5 3h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4a0.75 0.75 0 0 1 0.75 0.75v0.528a1.999 1.999 0 0 1 1.553 1.306 0.75 0.75 0 0 1 -1.415 0.5 0.5 0.5 0 0 0 -0.471 -0.334h-0.968a0.366 0.366 0 0 0 -0.078 0.723l1.473 0.322a2 2 0 0 1 -0.094 3.927v0.528a0.75 0.75 0 0 1 -1.5 0v-0.528a2.003 2.003 0 0 1 -1.553 -1.305 0.75 0.75 0 0 1 1.415 -0.5 0.5 0.5 0 0 0 0.471 0.333h0.834a0.5 0.5 0 0 0 0.107 -0.99L6.05 8.94a1.866 1.866 0 0 1 0.2 -3.678v-0.51A0.75 0.75 0 0 1 7 4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BriefcaseDollar"
);
var BusinessCard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 2A1.5 1.5 0 0 0 0 3.5v7A1.5 1.5 0 0 0 1.5 12h11a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 12.5 2h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.274 4.875a2.125 2.125 0 1 0 0 4.25 2.125 2.125 0 0 0 0 -4.25Zm3.827 0.625c0 -0.345 0.28 -0.625 0.625 -0.625h2.5a0.625 0.625 0 1 1 0 1.25h-2.5A0.625 0.625 0 0 1 8.1 5.5Zm0.625 2.375a0.625 0.625 0 1 0 0 1.25h2.5a0.625 0.625 0 1 0 0 -1.25h-2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessCard"
);
var BusinessHandshake = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m5.38502 5.24159 1.40421 -1.26893c0.65338 -0.59043 1.53318 -0.86396 2.40616 -0.74808l1.85751 0.24657 2.5782 -1.39359c0.1666 -0.09004 0.3689 0.03058 0.3689 0.21993v4.73815c0 0.32265 -0.1557 0.62548 -0.418 0.81324l-1.7363 1.24241 -3.76118 -3.15584 -1.2445 1.00715c-0.48889 0.39566 -1.20768 0.31111 -1.59141 -0.1872 -0.35648 -0.4629 -0.29708 -1.12209 0.13641 -1.51381Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m5.38502 5.24159 1.34759 -1.21776c-0.69238 -0.58807 -1.61068 -0.83912 -2.50704 -0.68392l-1.83556 0.31781L0.37647 2.57407C0.2063 2.48249 0 2.60574 0 2.79899l0.0000205134 4.23626C0.0000221072 7.37312 0.167057 7.68914 0.44623 7.87944L5.90115 11.598c0.70617 0.4814 1.63734 0.4724 2.33414 -0.0224L12 9.00006l-0.0115 -0.01097 -0.1428 0.1022 -1.87906 -1.57663c0.37746 -0.13388 0.69986 -0.35464 0.96586 -0.63051 0.2396 -0.24848 0.2324 -0.64415 -0.0161 -0.88374 -0.2484 -0.2396 -0.6441 -0.2324 -0.8837 0.01608 -0.18598 0.19288 -0.40092 0.31678 -0.65243 0.36602 -0.21916 0.0429 -0.49822 0.03524 -0.84911 -0.0723l-0.44664 -0.37476 -1.2445 1.00715c-0.48889 0.39566 -1.20768 0.31111 -1.59141 -0.1872 -0.35648 -0.4629 -0.29708 -1.12209 0.13641 -1.51381Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessHandshake"
);
var BusinessIdeaMoney = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.903 0A5 5 0 0 1 12 5.035 4.98 4.98 0 0 1 9.5 9.33v0.936a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1V9.33A5 5 0 0 1 6.903 0ZM5 12.488a0.75 0.75 0 1 0 0 1.5h4a0.75 0.75 0 0 0 0 -1.5H5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.726c0.345 0 0.625 0.28 0.625 0.625v0.384A1.607 1.607 0 0 1 8.843 3.78a0.625 0.625 0 1 1 -1.178 0.416 0.357 0.357 0 0 0 -0.337 -0.238h-0.76a0.252 0.252 0 0 0 -0.055 0.498l1.158 0.253a1.608 1.608 0 0 1 -0.046 3.15v0.386a0.625 0.625 0 1 1 -1.25 0V7.86a1.61 1.61 0 0 1 -1.218 -1.044 0.625 0.625 0 0 1 1.178 -0.417c0.05 0.14 0.183 0.238 0.338 0.238h0.655a0.358 0.358 0 0 0 0.076 -0.707l-1.158 -0.253a1.502 1.502 0 0 1 0.13 -2.957v-0.37c0 -0.345 0.279 -0.624 0.624 -0.624Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessIdeaMoney"
);
var BusinessProfessionHomeOffice = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.678 0.445a1 1 0 0 0 -1.356 0L0.481 5.832l-0.001 0.001C0.178 6.113 0 6.486 0 6.94v5.56A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5V6.94c0 -0.415 -0.172 -0.821 -0.48 -1.107L7.678 0.445Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.066 5.743a0.5 0.5 0 0 1 0.5 -0.5h0.87a0.5 0.5 0 0 1 0.5 0.5v0.405h-1.87v-0.405Zm-1 0.405v-0.405a1.5 1.5 0 0 1 1.5 -1.5h0.87a1.5 1.5 0 0 1 1.5 1.5v0.405h0.183a1 1 0 0 1 1 1v3.095a1 1 0 0 1 -1 1H4.88a1 1 0 0 1 -1 -1V7.148a1 1 0 0 1 1 -1h0.185Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessProfessionHomeOffice"
);
var BusinessProgressBar2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.864 0.562a0.75 0.75 0 0 0 -1.114 0.656v5a0.75 0.75 0 0 0 1.114 0.655l4.5 -2.5a0.75 0.75 0 0 0 0 -1.311l-4.5 -2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 1.218a0.75 0.75 0 1 0 -1.5 0v8.5a0.75 0.75 0 1 0 1.5 0v-8.5Zm5.88 7.905a0.75 0.75 0 0 0 -1.28 0.53v0.815H6.664a0.75 0.75 0 0 0 0 1.5h4.186v0.814a0.75 0.75 0 0 0 1.28 0.53l1.56 -1.56a0.743 0.743 0 0 0 0.224 -0.534 0.747 0.747 0 0 0 -0.22 -0.53L12.13 9.122ZM0.086 11.218a0.75 0.75 0 0 1 0.75 -0.75h3.5a0.75 0.75 0 0 1 0 1.5h-3.5a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.5 9.218a2 2 0 1 0 0 4 2 2 0 0 0 0 -4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessProgressBar2"
);
var BusinessUserCurriculum = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0c-0.39782 0 -0.77936 0.158035 -1.06066 0.43934C1.15804 0.720644 1 1.10218 1 1.5v11c0 0.3978 0.15804 0.7794 0.43934 1.0607S2.10217 14 2.5 14h9c0.3978 0 0.7794 -0.158 1.0607 -0.4393S13 12.8978 13 12.5v-8c0 -0.13261 -0.0527 -0.25979 -0.1464 -0.35355L8.85355 0.146447C8.75979 0.0526784 8.63261 0 8.5 0h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.98014 2.92692c0 0.56573 -0.45861 1.02434 -1.02434 1.02434 -0.56572 0 -1.02433 -0.45861 -1.02433 -1.02434 0 -0.56572 0.45861 -1.02433 1.02433 -1.02433 0.56573 0 1.02434 0.45861 1.02434 1.02433ZM3.49986 7.87496c-0.34518 0 -0.62458 0.27982 -0.62407 0.625 0.00052 0.34517 0.28076 0.62499 0.62594 0.62499h6.99997c0.3452 0 0.6246 -0.27982 0.6241 -0.62499 -0.0005 -0.34518 -0.2808 -0.625 -0.6259 -0.625H3.49986Zm0 3.00004c-0.34518 0 -0.62458 0.2798 -0.62407 0.625 0.00052 0.3451 0.28076 0.625 0.62594 0.625h4c0.34518 0 0.62459 -0.2799 0.62407 -0.625 -0.00052 -0.3452 -0.28076 -0.625 -0.62594 -0.625h-4Zm-0.36617 -5.54501c0.48332 -0.43278 1.12167 -0.69596 1.8215 -0.69596 0.69982 0 1.33818 0.26318 1.8215 0.69596 0.28688 0.25688 0.06285 0.66982 -0.32224 0.66982H3.45593c-0.38509 0 -0.60913 -0.41294 -0.32224 -0.66982Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BusinessUserCurriculum"
);
var Calculator1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.06885 1.74841c0 -0.931974 0.74803 -1.7048309 1.69202 -1.7048309h8.47823c0.944 0 1.692 0.7728569 1.692 1.7048309V12.2515c0 0.932 -0.748 1.7048 -1.692 1.7048H2.76087c-0.94399 0 -1.69202 -0.7728 -1.69202 -1.7048V1.74841Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.56885 1.74841c0 -0.12271 0.09548 -0.20483 0.19202 -0.20483h8.47823c0.0965 0 0.192 0.08212 0.192 0.20483v3.41513H2.56885V1.74841Zm5.89526 1.05326c-0.34518 0 -0.625 0.27982 -0.625 0.625 0 0.34517 0.27982 0.625 0.625 0.625l1.41846 0c0.34523 0 0.62503 -0.27983 0.62503 -0.625 0 -0.34518 -0.2798 -0.625 -0.62503 -0.625l-1.41846 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.82904 8.71918c0.41421 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.33579 -0.75 -0.75 -0.75s-0.75 0.33578 -0.75 0.75c0 0.41421 0.33579 0.75 0.75 0.75Zm3.17094 0c0.41421 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.33579 -0.75 -0.75 -0.75 -0.41422 0 -0.75 0.33578 -0.75 0.75 0 0.41421 0.33578 0.75 0.75 0.75Zm3.92092 -0.75c0 0.41421 -0.3358 0.75 -0.75 0.75s-0.74999 -0.33579 -0.74999 -0.75c0 -0.41422 0.33579 -0.75 0.74999 -0.75 0.4142 0 0.75 0.33578 0.75 0.75ZM3.82904 11.9444c0.41421 0 0.75 -0.3358 0.75 -0.75s-0.33579 -0.75 -0.75 -0.75 -0.75 0.3358 -0.75 0.75 0.33579 0.75 0.75 0.75Zm3.92094 -0.75c0 0.4142 -0.33579 0.75 -0.75 0.75 -0.41422 0 -0.75 -0.3358 -0.75 -0.75s0.33578 -0.75 0.75 -0.75c0.41421 0 0.75 0.3358 0.75 0.75Zm2.42092 0.75c0.4142 0 0.75 -0.3358 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75 -0.74999 0.3358 -0.74999 0.75 0.33579 0.75 0.74999 0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Calculator1"
);
var Calculator2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.5 0H7v7H0v4.5C0 12.8807 1.11929 14 2.5 14H7V7h7V2.5C14 1.11929 12.8807 0 11.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0C1.11929 0 0 1.11929 0 2.5V7h7v7h4.5c1.3807 0 2.5 -1.1193 2.5 -2.5V7H7V0H2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.90784 2.09955c0 -0.34518 -0.27983 -0.625 -0.625 -0.625 -0.34518 0 -0.625 0.27982 -0.625 0.625v0.625h-0.625c-0.34518 0 -0.625 0.27982 -0.625 0.625s0.27982 0.625 0.625 0.625h0.625v0.625c0 0.34518 0.27982 0.625 0.625 0.625 0.34517 0 0.625 -0.27982 0.625 -0.625v-0.625h0.625c0.34517 0 0.625 -0.27982 0.625 -0.625s-0.27983 -0.625 -0.625 -0.625h-0.625v-0.625Zm5.74255 6.93266c-0.34518 0 -0.625 0.27982 -0.625 0.625 0 0.34519 0.27982 0.62499 0.625 0.62499h2.00001c0.3452 0 0.625 -0.2798 0.625 -0.62499 0 -0.34518 -0.2798 -0.625 -0.625 -0.625H9.65039Zm-0.625 2.62499c0 -0.3452 0.27982 -0.625 0.625 -0.625h2.00001c0.3452 0 0.625 0.2798 0.625 0.625s-0.2798 0.625 -0.625 0.625H9.65039c-0.34518 0 -0.625 -0.2798 -0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.02545 3.34961c0 -0.34518 0.27982 -0.625 0.625 -0.625h2.00005c0.3451 0 0.625 0.27982 0.625 0.625s-0.2799 0.625 -0.625 0.625H9.65045c-0.34518 0 -0.625 -0.27982 -0.625 -0.625ZM1.78071 9.21518c0.24408 -0.24408 0.63981 -0.24408 0.88389 0l0.61806 0.61806 0.61805 -0.61806c0.24408 -0.24408 0.63981 -0.24408 0.88389 0 0.24408 0.24408 0.24408 0.6398 0 0.88392l-0.61806 0.618 0.61806 0.6181c0.24408 0.2441 0.24408 0.6398 0 0.8839 -0.24408 0.244 -0.63981 0.244 -0.88389 0l-0.61805 -0.6181 -0.61806 0.6181c-0.24408 0.244 -0.63981 0.244 -0.88389 0 -0.24407 -0.2441 -0.24407 -0.6398 0 -0.8839l0.61806 -0.6181 -0.61806 -0.618c-0.24407 -0.24412 -0.24407 -0.63984 0 -0.88392Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Calculator2"
);
var CoinShare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.75 8.25a4 4 0 1 0 0 -8 4 4 0 0 0 0 8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.75 2.625c0.345 0 0.625 0.28 0.625 0.625v2a0.625 0.625 0 1 1 -1.25 0v-2c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.96 6.85H0.117v4l1.828 1.828a4 4 0 0 0 2.829 1.172h5.843a1.5 1.5 0 0 0 0 -3h-3L4.788 8.022A4 4 0 0 0 1.96 6.85Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.372 9.605a0.86 0.86 0 0 1 -1.326 1.082l-1.45 -1.45a0.625 0.625 0 0 0 -0.884 0.883l1.45 1.45a2.11 2.11 0 0 0 3.456 -0.72h-0.001L6.372 9.605Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CoinShare"
);
var CoinsStack = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.123 7.286V2c0 -1.105 2.014 -2 4.5 -2 2.485 0 4.5 0.895 4.5 2v1.47c-1.236 0.041 -2.397 0.28 -3.313 0.688 -0.502 0.223 -0.986 0.522 -1.362 0.916 -0.381 0.401 -0.698 0.957 -0.698 1.64v2.534C1.673 9.068 0.123 8.254 0.123 7.286Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5 6.714V12c0 1.1 2 2 4.5 2s4.5 -0.9 4.5 -2V6.714c0 -1.104 -2.015 -2 -4.5 -2s-4.5 0.896 -4.5 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 8.539a0.825 0.825 0 0 1 -0.216 0.348c-0.185 0.195 -0.482 0.4 -0.898 0.586 -0.83 0.37 -2.025 0.616 -3.386 0.616 -1.361 0 -2.555 -0.246 -3.386 -0.616 -0.416 -0.186 -0.713 -0.39 -0.898 -0.586A0.826 0.826 0 0 1 5 8.54v1.758c0.188 0.116 0.391 0.222 0.605 0.317 1.025 0.458 2.4 0.725 3.895 0.725 1.494 0 2.87 -0.267 3.895 -0.725 0.214 -0.095 0.417 -0.2 0.605 -0.317V8.54Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.204 5.367a2.298 2.298 0 0 0 -0.45 1.227C2.598 6.512 1.55 6.267 0.726 5.9a5.147 5.147 0 0 1 -0.604 -0.317V3.825a0.826 0.826 0 0 0 0.215 0.348c0.185 0.195 0.483 0.4 0.899 0.585 0.744 0.332 1.78 0.565 2.967 0.61Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.622 2.931c1.736 0 3.143 -0.404 3.143 -0.903 0 -0.5 -1.407 -0.904 -3.143 -0.904 -1.735 0 -3.142 0.405 -3.142 0.904s1.407 0.903 3.142 0.903Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.5 7.646c1.735 0 3.142 -0.405 3.142 -0.904s-1.407 -0.904 -3.142 -0.904c-1.736 0 -3.142 0.405 -3.142 0.904 0 0.5 1.406 0.904 3.142 0.904Z" }),
    " "
  ] }) }),
  "CoinsStack"
);
var CollaborationsIdea = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.512 0.625a0.625 0.625 0 1 0 -1.25 0v0.82a0.625 0.625 0 1 0 1.25 0v-0.82ZM6.476 6.31a2.429 2.429 0 1 1 -4.857 0 2.429 2.429 0 0 1 4.857 0ZM4.048 9.548A4.048 4.048 0 0 0 0 13.595c0 0.224 0.181 0.405 0.405 0.405H7.69a0.405 0.405 0 0 0 0.405 -0.405 4.048 4.048 0 0 0 -4.047 -4.047Zm9.821 -7.926a0.625 0.625 0 0 1 -0.152 0.87l-0.672 0.472a0.625 0.625 0 0 1 -0.718 -1.023l0.671 -0.471a0.625 0.625 0 0 1 0.871 0.152Zm-7.814 0.87a0.625 0.625 0 0 1 0.718 -1.022l0.672 0.471a0.625 0.625 0 1 1 -0.718 1.023l-0.672 -0.471Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.113 5.074A2.248 2.248 0 0 0 9.841 2.84a2.248 2.248 0 0 0 -2.178 2.327 2.261 2.261 0 0 0 1.231 1.892v1.094a0.248 0.248 0 0 0 0.249 0.242h1.488a0.248 0.248 0 0 0 0.248 -0.242V7.04a2.263 2.263 0 0 0 1.234 -1.966Z" }),
    " "
  ] }) }),
  "CollaborationsIdea"
);
var CreditCard1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 5v5.75a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5 -1.5V5H0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 1.75A1.5 1.5 0 0 0 0 3.25V5h14V3.25a1.5 1.5 0 0 0 -1.5 -1.5h-11Zm8 6.875a0.625 0.625 0 1 0 0 1.25H11a0.625 0.625 0 1 0 0 -1.25H9.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CreditCard1"
);
var CreditCard2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.07212 0.083252c-0.265592 0 -0.519062 0.106844 -0.704993 0.295037C0.181398 0.566278 0.078125 0.819973 0.078125 1.08325v3c0 0.26328 0.103273 0.51698 0.289002 0.70496 0.185931 0.1882 0.439401 0.29504 0.704993 0.29504H12.9279c0.2656 0 0.519 -0.10684 0.705 -0.29504 0.1857 -0.18799 0.289 -0.44168 0.289 -0.70496v-3c0 -0.263275 -0.1033 -0.516971 -0.289 -0.704961 -0.186 -0.188193 -0.4394 -0.295037 -0.705 -0.295037H1.07212Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.25 2.5c-0.55228 0 -1 0.44772 -1 1v9.375c0 0.5523 0.44772 1 1 1h5.5c0.5523 0 1 -0.4477 1 -1V3.5c0 -0.55228 -0.4477 -1 -1 -1h-5.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.08325c-0.41421 0 -0.75 0.33579 -0.75 0.75 0 0.41422 0.33579 0.75 0.75 0.75 0.41409 0 0.75005 -0.33567 0.75005 -0.75s-0.33596 -0.75 -0.75005 -0.75ZM7 6.4375c-0.9665 0 -1.75 0.7835 -1.75 1.75s0.7835 1.75 1.75 1.75 1.75 -0.7835 1.75 -1.75 -0.7835 -1.75 -1.75 -1.75Zm-0.75005 5.1593c0 -0.4142 0.33579 -0.75 0.75 -0.75 0.4141 0 0.75005 0.3357 0.75005 0.75s-0.33595 0.75 -0.75005 0.75c-0.41421 0 -0.75 -0.3358 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CreditCard2"
);
var DecentWorkAndEconomicGrowth = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.832 0.051317c-0.1995 -0.0332465 -0.3994 0.056944 -0.5064 0.228516 -0.1071 0.171572 -0.1003 0.390738 0.0173 0.5553l0.5764 0.807017 -2.95932 1.89179L6.006 1.24912c-0.22588 -0.264127 -0.60362 -0.338474 -0.91274 -0.17965L0.838224 3.25568c-0.368429 0.18929 -0.513645 0.64142 -0.324349 1.00985 0.189296 0.36843 0.641425 0.51364 1.009855 0.32434l3.72765 -1.91524 1.99274 2.33016c0.24317 0.28434 0.65871 0.34598 0.97395 0.14446l3.57423 -2.28488 0.6935 0.97083c0.1175 0.16457 0.3226 0.24212 0.5197 0.1965 0.197 -0.04563 0.3471 -0.20544 0.3804 -0.40492l0.4285 -2.57148c0.0218 -0.130809 -0.0092 -0.264916 -0.0863 -0.372823 -0.0771 -0.107908 -0.1938 -0.180778 -0.3246 -0.202578L10.832 0.051317Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5.40118 5.1279c-0.20551 -0.35964 -0.66365 -0.48458 -1.02328 -0.27908l-3.500004 2C0.644215 6.98236 0.5 7.23086 0.5 7.50001V13.25c0 0.4142 0.335786 0.75 0.75 0.75h11.5c0.4142 0 0.75 -0.3358 0.75 -0.75V6.00001c0 -0.25994 -0.1346 -0.50134 -0.3557 -0.63799 -0.2211 -0.13666 -0.4972 -0.14908 -0.7297 -0.03283l-5.36542 2.6827 -1.648 -2.88399Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.40119 5.1279c-0.20551 -0.35964 -0.66365 -0.48458 -1.02329 -0.27908V14h4.99742V6.84882L7.04918 8.01189 5.40119 5.1279Z" }),
    " "
  ] }) }),
  "DecentWorkAndEconomicGrowth"
);
var DesktopDollar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.917 3.116c0 0.646 0.198 1.254 0.544 1.759a2 2 0 0 0 -0.359 1.958 3.26 3.26 0 0 0 1.513 1.773 2 2 0 0 0 3.937 0c0.158 -0.086 0.307 -0.185 0.448 -0.295v1.232c0 0.805 -0.652 1.457 -1.457 1.457H1.457A1.457 1.457 0 0 1 0 9.543V1.957C0 1.152 0.652 0.5 1.457 0.5h7.882a3.112 3.112 0 0 0 -1.422 2.616Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.583 0a0.75 0.75 0 0 1 0.75 0.75v0.528a1.999 1.999 0 0 1 1.553 1.305 0.75 0.75 0 0 1 -1.414 0.5A0.498 0.498 0 0 0 12 2.75h-0.967a0.366 0.366 0 0 0 -0.079 0.723l1.473 0.322a2 2 0 0 1 -0.094 3.927v0.528a0.75 0.75 0 0 1 -1.5 0v-0.528a2.003 2.003 0 0 1 -1.552 -1.305 0.75 0.75 0 0 1 1.414 -0.5 0.5 0.5 0 0 0 0.472 0.333H12a0.5 0.5 0 0 0 0.107 -0.99l-1.473 -0.322a1.866 1.866 0 0 1 0.2 -3.677V0.75a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopDollar"
);
var DollarCoin1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.79 5.509a5.196 5.196 0 1 1 -10.392 0 5.196 5.196 0 0 1 10.392 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.554 11.884a6.446 6.446 0 0 1 -7.34 -7.304 5.196 5.196 0 1 0 7.34 7.304Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.594 1.585a0.75 0.75 0 0 1 0.75 0.75v0.317a1.77 1.77 0 0 1 1.258 1.131 0.75 0.75 0 0 1 -1.415 0.5 0.268 0.268 0 0 0 -0.254 -0.179H8.6l-0.005 0 -0.005 0h-0.444a0.16 0.16 0 0 0 -0.035 0.316l1.201 0.262a1.77 1.77 0 0 1 0.033 3.45v0.317a0.75 0.75 0 0 1 -1.5 0v-0.317a1.773 1.773 0 0 1 -1.258 -1.131A0.75 0.75 0 1 1 8 6.5a0.27 0.27 0 0 0 0.254 0.18h0.68a0.27 0.27 0 0 0 0.057 -0.533L7.79 5.885a1.66 1.66 0 0 1 0.054 -3.254v-0.296a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DollarCoin1"
);
var DollarCoin = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.5a0.75 0.75 0 0 1 0.75 0.75v0.528a1.999 1.999 0 0 1 1.553 1.305 0.75 0.75 0 0 1 -1.415 0.5 0.5 0.5 0 0 0 -0.471 -0.333h-0.968a0.366 0.366 0 0 0 -0.078 0.723l1.473 0.322a2 2 0 0 1 -0.094 3.927v0.528a0.75 0.75 0 0 1 -1.5 0v-0.528a2.003 2.003 0 0 1 -1.553 -1.305 0.75 0.75 0 0 1 1.415 -0.5 0.5 0.5 0 0 0 0.471 0.333h0.834a0.5 0.5 0 0 0 0.107 -0.99L6.05 7.439a1.866 1.866 0 0 1 0.2 -3.677V3.25A0.75 0.75 0 0 1 7 2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DollarCoin"
);
var Euro = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.025 2c0.435 0 0.867 0.072 1.277 0.215a1 1 0 0 0 0.656 -1.89A5.89 5.89 0 0 0 9.954 0.001a6.77 6.77 0 0 0 -5.951 4.19H2a1 1 0 1 0 0 2h1.52a6.62 6.62 0 0 0 -0.02 0.81 6.77 6.77 0 0 0 0.02 0.808H2a1 1 0 1 0 0 2h2.003A6.768 6.768 0 0 0 9.996 14a6 6 0 0 0 2.4 -0.492 1 1 0 0 0 -0.793 -1.836 4 4 0 0 1 -1.579 0.328 4.77 4.77 0 0 1 -3.776 -2.19H8a1 1 0 1 0 0 -2H5.53a4.77 4.77 0 0 1 -0.03 -0.768 1.006 1.006 0 0 0 0 -0.082 4.57 4.57 0 0 1 0.03 -0.768H8a1 1 0 0 0 0 -2H6.248A4.768 4.768 0 0 1 10.025 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Euro"
);
var Gold = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.772 8.099h2.08a1.393 1.393 0 0 1 1.388 1.114l0 0.002 0.75 3.75a0.5 0.5 0 0 1 -0.49 0.598H8.143a0.5 0.5 0 0 1 -0.49 -0.596l0.731 -3.75 0.001 -0.004a1.393 1.393 0 0 1 1.387 -1.114Zm-7.59 0h2.081A1.393 1.393 0 0 1 5.65 9.213l0 0.002 0.75 3.75a0.5 0.5 0 0 1 -0.49 0.598H0.554a0.5 0.5 0 0 1 -0.49 -0.596l0.732 -3.75 0 -0.004a1.393 1.393 0 0 1 1.388 -1.114Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.058 1.248h-2.08A1.393 1.393 0 0 0 4.59 2.362l0 0.004 -0.733 3.75a0.5 0.5 0 0 0 0.491 0.596h5.357a0.5 0.5 0 0 0 0.49 -0.598l-0.75 -3.75 0 -0.002a1.393 1.393 0 0 0 -1.387 -1.115Z" }),
    " "
  ] }) }),
  "Gold"
);
var InvestmentSelection = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.031 5.032a5.031 5.031 0 1 1 9.951 1.06A2.5 2.5 0 0 0 6.22 8.248V9.93A5.031 5.031 0 0 1 0.03 5.032Zm9.517 2.282a5.054 5.054 0 0 1 -2.08 2.138V8.25a1.25 1.25 0 0 1 2.08 -0.935Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.061 1.794c0.346 0 0.625 0.28 0.625 0.625v0.284a1.497 1.497 0 0 1 1.077 0.96 0.625 0.625 0 0 1 -1.179 0.416 0.246 0.246 0 0 0 -0.232 -0.164h-0.288l-0.003 0 -0.002 0h-0.382a0.153 0.153 0 0 0 -0.032 0.302l1.027 0.225a1.497 1.497 0 0 1 0.014 2.92v0.284a0.625 0.625 0 1 1 -1.25 0v-0.283a1.5 1.5 0 0 1 -1.076 -0.96 0.625 0.625 0 0 1 1.179 -0.417 0.247 0.247 0 0 0 0.232 0.164h0.286l0.004 0 0.005 0h0.286a0.247 0.247 0 0 0 0.053 -0.487l-1.027 -0.225a1.403 1.403 0 0 1 0.058 -2.752v-0.267c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.469 13.999v-5.75a1.25 1.25 0 0 1 2.5 0v2.75h2a2 2 0 0 1 2 2v1" }),
    " "
  ] }) }),
  "InvestmentSelection"
);
var JusticeHammer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.331 10.63a0.5 0.5 0 0 1 0.5 -0.5h5.5a0.5 0.5 0 0 1 0.5 0.5v1.75h-6.5v-1.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m8.85 6.582 1.06 -1.06L13.7 9.31a0.75 0.75 0 1 1 -1.06 1.06L8.85 6.582Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.081 13.13a0.75 0.75 0 0 1 0.75 -0.75h7.5a0.75 0.75 0 0 1 0 1.5h-7.5a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.877 4.144a1.5 1.5 0 0 0 0 2.122l1.584 1.583a1.5 1.5 0 0 0 2.121 0l3.585 -3.585a1.5 1.5 0 0 0 0 -2.12L9.584 0.558a1.5 1.5 0 0 0 -2.122 0L3.877 4.144Z" }),
    " "
  ] }) }),
  "JusticeHammer"
);
var JusticeScale1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.74999 2.30566c0 -0.41421 -0.33579 -0.75 -0.75 -0.75 -0.41422 0 -0.75 0.33579 -0.75 0.75v1.87773c0 0.41422 0.33578 0.75 0.75 0.75 0.41421 0 0.75 -0.33578 0.75 -0.75V2.30566ZM3.24452 3.43335c0.31124 0 0.59014 0.19223 0.7009 0.4831l2.34717 6.16375c0.1474 0.3871 -0.0469 0.8204 -0.434 0.9678 -0.3871 0.1474 -0.8204 -0.0469 -0.96781 -0.434L3.24452 6.29085 1.59826 10.614c-0.14741 0.3871 -0.58071 0.5814 -0.967805 0.434 -0.387097 -0.1474 -0.5814046 -0.5807 -0.433998 -0.9678L2.54362 3.91645c0.11076 -0.29087 0.38966 -0.4831 0.7009 -0.4831Zm7.51088 0c0.3113 0 0.5902 0.19223 0.7009 0.4831l2.3472 6.16375c0.1474 0.3871 -0.0469 0.8204 -0.434 0.9678 -0.3871 0.1474 -0.8204 -0.0469 -0.9678 -0.434l-1.6463 -4.32315L9.10918 10.614c-0.1474 0.3871 -0.5807 0.5814 -0.9678 0.434 -0.3871 -0.1474 -0.5814 -0.5807 -0.434 -0.9678l2.34712 -6.16375c0.1108 -0.29087 0.3897 -0.4831 0.7009 -0.4831Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.83621 3.43335c-0.41421 0 -0.75 0.33579 -0.75 0.75s0.33579 0.75 0.75 0.75H12.1637c0.4142 0 0.75 -0.33579 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75H1.83621ZM0.897339 9.59717c-0.414214 0 -0.75 0.33578 -0.75 0.75003 0 0.8214 0.326307 1.6092 0.907141 2.19 0.58083 0.5808 1.3686 0.9071 2.19002 0.9071s1.6092 -0.3263 2.19003 -0.9071c0.58083 -0.5808 0.90713 -1.3686 0.90713 -2.19 0 -0.41425 -0.33578 -0.75003 -0.75 -0.75003H0.897339Zm7.510921 0c-0.41421 0 -0.75 0.33578 -0.75 0.75003 0 0.8214 0.32631 1.6092 0.90714 2.19s1.36861 0.9071 2.19 0.9071c0.8214 0 1.6092 -0.3263 2.1901 -0.9071 0.5808 -0.5808 0.9071 -1.3686 0.9071 -2.19 0 -0.41425 -0.3358 -0.75003 -0.75 -0.75003H8.40826Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "JusticeScale1"
);
var JusticeScale2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.877a0.75 0.75 0 1 0 -1.5 0v2.355a0.75 0.75 0 1 0 1.5 0V0.877Zm3.018 -0.11c0.3 0 0.57 0.179 0.69 0.454l2.354 5.483a0.75 0.75 0 0 1 -1.378 0.592l-1.666 -3.878 -1.666 3.878a0.75 0.75 0 1 1 -1.378 -0.592l2.355 -5.483a0.75 0.75 0 0 1 0.69 -0.454Zm-7.536 3.43a0.75 0.75 0 0 1 0.695 0.468l2.355 5.822a0.75 0.75 0 0 1 -1.39 0.563l-1.66 -4.104 -1.66 4.104a0.75 0.75 0 0 1 -1.39 -0.563l2.355 -5.822a0.75 0.75 0 0 1 0.695 -0.469Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.492 1.56A0.75 0.75 0 1 0 11.87 0.194L1.508 4.904A0.75 0.75 0 0 0 2.13 6.27l10.363 -4.71ZM8.413 6.25a0.75 0.75 0 0 0 -0.75 0.75 3.105 3.105 0 0 0 6.21 0 0.75 0.75 0 0 0 -0.75 -0.75h-4.71ZM0.877 10.018a0.75 0.75 0 0 0 -0.75 0.75 3.105 3.105 0 0 0 6.21 0 0.75 0.75 0 0 0 -0.75 -0.75H0.877Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "JusticeScale2"
);
var Lightbulb = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 13.25a0.75 0.75 0 0 1 0.75 -0.75h3.5a0.75 0.75 0 0 1 0 1.5h-3.5a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.5 9.331a5 5 0 1 0 -5 0V10.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1 -1V9.331Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Lightbulb"
);
var NoPoverty = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.164 4.462a1.715 1.715 0 1 0 0 -3.431 1.715 1.715 0 0 0 0 3.43Zm7.672 0a1.715 1.715 0 1 0 0 -3.431 1.715 1.715 0 0 0 0 3.43Zm0 0.357a3.06 3.06 0 0 0 -1.898 0.656 2.959 2.959 0 0 1 0.95 2.917h3.521a0.5 0.5 0 0 0 0.5 -0.5 3.073 3.073 0 0 0 -3.073 -3.073Zm-7.672 0a3.06 3.06 0 0 1 1.898 0.656 2.959 2.959 0 0 0 -0.95 2.917H0.59a0.5 0.5 0 0 1 -0.5 -0.5A3.073 3.073 0 0 1 3.164 4.82ZM7 9.435a1.715 1.715 0 1 0 0 -3.43 1.715 1.715 0 0 0 0 3.43Zm-3.073 3.43a3.073 3.073 0 0 1 6.146 0 0.5 0.5 0 0 1 -0.5 0.5H4.427a0.5 0.5 0 0 1 -0.5 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NoPoverty"
);
var Payment10 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v6A1.5 1.5 0 0 0 1.5 9h11A1.5 1.5 0 0 0 14 7.5v-6A1.5 1.5 0 0 0 12.5 0h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.83c0.345 0 0.625 0.279 0.625 0.624v0.415a1.64 1.64 0 0 1 1.26 1.069 0.625 0.625 0 0 1 -1.178 0.417 0.39 0.39 0 0 0 -0.369 -0.26h-0.785a0.281 0.281 0 0 0 -0.06 0.555l1.196 0.262a1.64 1.64 0 0 1 -0.064 3.219v0.415a0.625 0.625 0 1 1 -1.25 0V7.13a1.643 1.643 0 0 1 -1.26 -1.069 0.625 0.625 0 0 1 1.178 -0.417c0.054 0.153 0.2 0.26 0.369 0.26h0.676a0.39 0.39 0 0 0 0.084 -0.772l-1.197 -0.261a1.531 1.531 0 0 1 0.15 -3.017v-0.4c0 -0.346 0.28 -0.626 0.625 -0.626ZM3.5 4.5a0.75 0.75 0 1 0 -1.5 0 0.75 0.75 0 0 0 1.5 0Zm8.5 0a0.75 0.75 0 1 0 -1.5 0 0.75 0.75 0 0 0 1.5 0ZM4.5 9.875c0.345 0 0.625 0.28 0.625 0.625v2a0.625 0.625 0 1 1 -1.25 0v-2c0 -0.345 0.28 -0.625 0.625 -0.625Zm5.625 0.625a0.625 0.625 0 1 0 -1.25 0v2a0.625 0.625 0 1 0 1.25 0v-2Zm-2.5 0.75a0.625 0.625 0 1 0 -1.25 0v2a0.625 0.625 0 1 0 1.25 0v-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Payment10"
);
var PaymentCashOut3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0C0.696 0 0 0.625 0 1.45v5.6C0 7.875 0.696 8.5 1.5 8.5h11c0.804 0 1.5 -0.625 1.5 -1.45v-5.6C14 0.625 13.304 0 12.5 0h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.125 10.5a0.625 0.625 0 1 0 -1.25 0v2a0.625 0.625 0 1 0 1.25 0v-2ZM9.5 9.875c0.345 0 0.625 0.28 0.625 0.625v2a0.625 0.625 0 1 1 -1.25 0v-2c0 -0.345 0.28 -0.625 0.625 -0.625Zm-2.5 0.75c0.345 0 0.625 0.28 0.625 0.625v2a0.625 0.625 0 1 1 -1.25 0v-2c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 6.25a2 2 0 1 0 0 -4 2 2 0 0 0 0 4Zm-4.25 -2.5a0.75 0.75 0 1 1 0 1.5 0.75 0.75 0 0 1 0 -1.5ZM12 4.5a0.75 0.75 0 1 0 -1.5 0 0.75 0.75 0 0 0 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PaymentCashOut3"
);
var SafeVault = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11 12.5h1.5v0.7022c0 0.4142 -0.3358 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75V12.5Zm-9.5 0v0.7022c0 0.4142 0.33579 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75V12.5H1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0C0.671573 0 0 0.671573 0 1.5V11c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5V1.5c0 -0.828427 -0.6716 -1.5 -1.5 -1.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.375 2.93774c0 -0.34517 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27983 -0.625 0.625v0.83204c-0.24789 0.06227 -0.48141 0.16072 -0.69462 0.28942l-0.57432 -0.58696c-0.24141 -0.24673 -0.63711 -0.25103 -0.88383 -0.00963 -0.24672 0.24141 -0.25103 0.63711 -0.00962 0.88383l0.58701 0.59994c-0.12402 0.20888 -0.21914 0.43692 -0.27985 0.67862h-0.83203c-0.34517 0 -0.625 0.27983 -0.625 0.625 0 0.34518 0.27983 0.625 0.625 0.625h0.83203c0.0615 0.24482 0.15829 0.47562 0.28466 0.68669l-0.58704 0.58704c-0.24408 0.24407 -0.24408 0.6398 0 0.88388 0.24408 0.24408 0.63981 0.24408 0.88388 0l0.58704 -0.58704c0.21107 0.12637 0.44187 0.22316 0.68669 0.28466v0.83203c0 0.34518 0.27982 0.62504 0.625 0.62504s0.625 -0.27986 0.625 -0.62504v-0.83203c0.24481 -0.0615 0.47561 -0.15829 0.6867 -0.28466l0.587 0.58704c0.2441 0.24408 0.6398 0.24408 0.8839 0 0.2441 -0.24408 0.2441 -0.63981 0 -0.88388l-0.587 -0.58704c0.1263 -0.21106 0.2231 -0.44187 0.2846 -0.68669h0.8321c0.3451 0 0.625 -0.27982 0.625 -0.625 0 -0.34517 -0.2799 -0.625 -0.625 -0.625h-0.8321c-0.0615 -0.24481 -0.1583 -0.47562 -0.2846 -0.68669l0.587 -0.58703c0.2441 -0.24408 0.2441 -0.6398 0 -0.88388 -0.2441 -0.24408 -0.6398 -0.24408 -0.8839 0l-0.587 0.58703c-0.21109 -0.12636 -0.44189 -0.22315 -0.6867 -0.28465v-0.83204Zm-6.88174 0.57106c0.34517 0 0.625 0.27982 0.625 0.625l0 4.23241c0 0.34518 -0.27983 0.625 -0.625 0.625 -0.34518 0 -0.625 -0.27982 -0.625 -0.625V4.1338c0 -0.34518 0.27982 -0.625 0.625 -0.625ZM7.44284 6.25c0 -0.72192 0.58523 -1.30715 1.30715 -1.30715S10.0571 5.52808 10.0571 6.25s-0.58519 1.30716 -1.30711 1.30716S7.44284 6.97192 7.44284 6.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SafeVault"
);
var SearchDollar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.5 0a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0 -13Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 6.5a5 5 0 1 1 10 0 5 5 0 0 1 -10 0Zm5 -6.5a6.5 6.5 0 1 0 3.835 11.749l1.958 1.958a1 1 0 0 0 1.414 -1.414l-1.958 -1.958A6.5 6.5 0 0 0 6.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.153 4.303a0.316 0.316 0 0 0 -0.316 0.316v0.498h1.326v-0.498a0.316 0.316 0 0 0 -0.317 -0.316h-0.693Zm2.065 0.814v-0.498A1.37 1.37 0 0 0 6.846 3.25h-0.693a1.37 1.37 0 0 0 -1.371 1.37v0.497h-0.46a0.949 0.949 0 0 0 -0.948 0.948v2.24c0 0.525 0.425 0.949 0.949 0.949h4.354a0.95 0.95 0 0 0 0.95 -0.948V6.065a0.949 0.949 0 0 0 -0.95 -0.948h-0.46Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SearchDollar"
);
var Startup = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.74097 4.0382c-1.84662 -1.25993 -3.57985 -0.50494 -5.073107 0.86477 -0.237449 0.21781 -0.187859 0.59878 0.088141 0.76505L3.73664 7.46358" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.96176 8.25903c1.25994 1.84667 0.50494 3.57987 -0.86477 5.07307 -0.2178 0.2375 -0.59878 0.1879 -0.76505 -0.0881l-1.79556 -2.9806" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m3.73669 7.45301 2.8103 2.81029C8.79523 8.91648 11.351 7.61208 12.5175 6.40312 15.0415 3.87916 13.578 0.421966 13.578 0.421966S10.1208 -1.04151 7.59687 1.48246C6.38792 2.64899 5.07291 5.21538 3.73669 7.45301Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2693 2.14893c-0.87359 0 -1.58174 0.70815 -1.58174 1.5817 0 0.87355 0.70815 1.58171 1.58174 1.58171 0.8735 0 1.5817 -0.70816 1.5817 -1.58171 0 -0.87355 -0.7082 -1.5817 -1.5817 -1.5817Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.40645 9.48809c-0.24904 -0.10059 -0.51578 -0.14999 -0.78432 -0.14525 -0.26854 0.00474 -0.53338 0.06352 -0.77871 0.17283 -0.24407 0.10875 -0.46386 0.2653 -0.6464 0.46039 -0.211994 0.22134 -0.378065 0.56674 -0.506147 0.88734 -0.136478 0.3416 -0.258552 0.7313 -0.358782 1.0951 -0.100581 0.3651 -0.181763 0.7138 -0.2352338 0.9772 -0.0265842 0.131 -0.047337 0.246 -0.0601107 0.3338 -0.0061714 0.0425 -0.0118441 0.0878 -0.0145069 0.1289 -0.0012275 0.019 -0.002796 0.0508 -0.0007215 0.0868 0.001 0.0174 0.0035444 0.0496 0.0121888 0.0883l0.0000982 0.0004c0.0053925 0.0241 0.0277769 0.1243 0.1099979 0.2202 0.095995 0.112 0.211221 0.1471 0.240883 0.1559 0.044937 0.0134 0.082724 0.0179 0.102242 0.0198 0.040718 0.004 0.076326 0.0029 0.096026 0.002 0.043457 -0.002 0.09054 -0.0074 0.133167 -0.0132 0.0888 -0.0121 0.204654 -0.0323 0.335989 -0.0584 0.26447 -0.0524 0.61468 -0.1329 0.98135 -0.233 0.36545 -0.0998 0.75687 -0.2216 1.0999 -0.3579 0.32172 -0.1279 0.66874 -0.294 0.89051 -0.5064 0.1951 -0.1825 0.35165 -0.4023 0.4604 -0.6464 0.10931 -0.2453 0.16809 -0.5101 0.17283 -0.7787 0.00474 -0.2685 -0.04466 -0.5353 -0.14525 -0.7843 -0.10059 -0.249 -0.25031 -0.4753 -0.44023 -0.66518 -0.18991 -0.18992 -0.41614 -0.33964 -0.66517 -0.44023Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Startup"
);
var Stock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.831 0.875a0.75 0.75 0 0 0 -1.5 0v2.588a0.75 0.75 0 0 0 1.5 0V0.875Zm0 9.088a0.75 0.75 0 0 0 -1.5 0v1.5a0.75 0.75 0 0 0 1.5 0v-1.5Zm4.25 0.25a0.75 0.75 0 0 1 0.75 0.75v2.161a0.75 0.75 0 0 1 -1.5 0v-2.161a0.75 0.75 0 0 1 0.75 -0.75Zm0.75 -6.25a0.75 0.75 0 0 0 -1.5 0v3.5a0.75 0.75 0 0 0 1.5 0v-3.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.798 0.125a0.75 0.75 0 0 1 0.75 0.75v0.781c0.233 0.063 0.455 0.158 0.653 0.292 0.425 0.29 0.718 0.751 0.718 1.33a0.75 0.75 0 0 1 -1.5 0c0 -0.026 -0.005 -0.035 -0.007 -0.038a0.168 0.168 0 0 0 -0.054 -0.051c-0.086 -0.058 -0.269 -0.127 -0.56 -0.127 -0.207 0 -0.355 0 -0.48 0.012a1.004 1.004 0 0 0 -0.127 0.019 0.964 0.964 0 0 0 -0.014 0.184c0 0.078 0.02 0.157 0.171 0.289 0.178 0.154 0.434 0.293 0.798 0.484l0.035 0.018c0.317 0.166 0.728 0.381 1.053 0.665 0.363 0.317 0.685 0.777 0.685 1.418 0 0.31 -0.046 0.615 -0.18 0.89a1.358 1.358 0 0 1 -0.627 0.627c-0.191 0.094 -0.388 0.14 -0.564 0.165v0.72a0.75 0.75 0 0 1 -1.5 0v-0.762a2.041 2.041 0 0 1 -0.626 -0.248c-0.48 -0.297 -0.745 -0.788 -0.745 -1.392a0.75 0.75 0 0 1 1.5 0c0 0.04 0.004 0.067 0.007 0.081 0.003 0.014 0.006 0.02 0.007 0.02a0.106 0.106 0 0 0 0.02 0.015c0.067 0.042 0.241 0.099 0.58 0.1a0.699 0.699 0 0 1 0.014 0c0.203 0 0.348 -0.001 0.472 -0.013a0.905 0.905 0 0 0 0.127 -0.018 0.964 0.964 0 0 0 0.015 -0.185c0 -0.077 -0.021 -0.156 -0.172 -0.288 -0.177 -0.155 -0.434 -0.294 -0.797 -0.484l-0.035 -0.019c-0.318 -0.166 -0.728 -0.38 -1.053 -0.664 -0.363 -0.318 -0.685 -0.777 -0.685 -1.418 0 -0.31 0.045 -0.616 0.18 -0.89a1.36 1.36 0 0 1 0.627 -0.627c0.19 -0.095 0.388 -0.14 0.564 -0.165v-0.72a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.081 4.463a1.5 1.5 0 0 1 1.5 -1.5h1a1.5 1.5 0 0 1 1.5 1.5v4.5a1.5 1.5 0 0 1 -1.5 1.5h-1a1.5 1.5 0 0 1 -1.5 -1.5v-4.5Zm5 4a1.5 1.5 0 0 1 1.5 -1.5h1a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1 -1.5 1.5h-1a1.5 1.5 0 0 1 -1.5 -1.5v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Stock"
);
var StrategyTasks = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 2.5C1.5 1.67157 2.17157 1 3 1h8c0.8284 0 1.5 0.67157 1.5 1.5v10c0 0.8284 -0.6716 1.5 -1.5 1.5H3c-0.82843 0 -1.5 -0.6716 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 0c-0.55228 0 -1 0.447716 -1 1v0.5c0 0.55229 0.44772 1 1 1h3c0.55229 0 1 -0.44771 1 -1V1c0 -0.552285 -0.44771 -1 -1 -1h-3Zm-0.9541 5.70312c0 -0.27614 0.22386 -0.5 0.5 -0.5s0.5 0.22386 0.5 0.5c0 0.20517 -0.12371 0.38314 -0.30362 0.46017 -0.05931 0.0254 -0.12519 0.03983 -0.19638 0.03983 -0.27614 0 -0.5 -0.22385 -0.5 -0.5Zm0.5 -2c-1.10457 0 -2 0.89544 -2 2 0 1.10457 0.89543 2 2 2 0.27786 0 0.54432 -0.05709 0.78678 -0.1609 0.71203 -0.30486 1.21322 -1.01259 1.21322 -1.8391 0 -1.10456 -0.89543 -2 -2 -2Zm2.12592 4.59931c0.29289 -0.29289 0.76777 -0.29289 1.06066 0l0.72048 0.72049 0.72049 -0.72049c0.29289 -0.29289 0.76775 -0.29289 1.06065 0 0.2929 0.2929 0.2929 0.76777 0 1.06066l-0.7205 0.72051 0.7189 0.7188c0.2929 0.2929 0.2929 0.7678 0 1.0607 -0.2929 0.2929 -0.76779 0.2929 -1.06068 0l-0.71886 -0.7189 -0.71885 0.7189c-0.2929 0.2929 -0.76777 0.2929 -1.06066 0 -0.2929 -0.2929 -0.2929 -0.7678 0 -1.0607l0.71885 -0.7188 -0.72048 -0.72051c-0.29289 -0.29289 -0.29289 -0.76776 0 -1.06066Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StrategyTasks"
);
var SubscriptionCashflow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.877 2.907a0.75 0.75 0 0 1 0.75 0.75v0.362a1.82 1.82 0 0 1 1.322 1.17 0.75 0.75 0 1 1 -1.415 0.5 0.318 0.318 0 0 0 -0.3 -0.213h-0.828a0.204 0.204 0 0 0 -0.043 0.403l1.26 0.276a1.82 1.82 0 0 1 0.004 3.553v0.362a0.75 0.75 0 0 1 -1.5 0v-0.362a1.822 1.822 0 0 1 -1.321 -1.17 0.75 0.75 0 1 1 1.414 -0.5 0.32 0.32 0 0 0 0.301 0.213h0.713a0.32 0.32 0 0 0 0.068 -0.631l-1.26 -0.275a1.704 1.704 0 0 1 0.085 -3.346v-0.342a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.577 1.689a5.488 5.488 0 0 1 4.636 0.848l-0.61 0.61A0.5 0.5 0 0 0 9.957 4h2.293a0.5 0.5 0 0 0 0.5 -0.5V1.207a0.5 0.5 0 0 0 -0.854 -0.353l-0.612 0.612A6.999 6.999 0 0 0 0.12 8.287a0.75 0.75 0 1 0 1.475 -0.277 5.499 5.499 0 0 1 3.982 -6.321Zm8.303 4.024a0.75 0.75 0 0 0 -1.475 0.277 5.499 5.499 0 0 1 -8.618 5.473l0.61 -0.61A0.5 0.5 0 0 0 4.042 10H1.75a0.5 0.5 0 0 0 -0.5 0.5v2.293a0.5 0.5 0 0 0 0.854 0.353l0.612 -0.612a6.999 6.999 0 0 0 11.164 -6.82Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SubscriptionCashflow"
);
var WalletPurse = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 5c-1.85652 0 -3.63699 0.7375 -4.94975 2.05025C0.737498 8.36301 0 10.1435 0 12c0 0.5304 0.210714 1.0391 0.585786 1.4142C0.960859 13.7893 1.46957 14 2 14h10c0.5304 0 1.0391 -0.2107 1.4142 -0.5858S14 12.5304 14 12c0 -1.8565 -0.7375 -3.63699 -2.0503 -4.94975C10.637 5.7375 8.85652 5 7 5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.75 1c0 -0.414214 -0.33579 -0.75 -0.75 -0.75s-0.75 0.335786 -0.75 0.75c0 0.55718 0.16909 1.09692 0.47885 1.55062 -1.688 0.41209 -3.24699 1.27953 -4.496735 2.52773 -0.2930749 0.29271 -0.2933704 0.76758 -0.000659 1.06066 0.29271 0.29307 0.767584 0.29337 1.060664 0.00066 1.51447 -1.5126 3.56741 -2.3622 5.70787 -2.3622 2.14046 0 4.19341 0.8496 5.70791 2.3622 0.293 0.29271 0.7679 0.29241 1.0606 -0.00066 0.2927 -0.29308 0.2924 -0.76795 -0.0006 -1.06066 -1.2498 -1.2482 -2.8088 -2.11563 -4.49675 -2.52772C9.58091 2.09692 9.75 1.55718 9.75 1c0 -0.414214 -0.33579 -0.75 -0.75 -0.75s-0.75 0.335786 -0.75 0.75c0 0.33152 -0.1317 0.64946 -0.36612 0.88388C7.64946 2.1183 7.33152 2.25 7 2.25c-0.33152 0 -0.64946 -0.1317 -0.88388 -0.36612C5.8817 1.64946 5.75 1.33152 5.75 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WalletPurse"
);
var Wallet = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0.855a3.5 3.5 0 0 0 -3.5 3.5V12.5A1.5 1.5 0 0 0 1.5 14l9.712 0a1.5 1.5 0 0 0 1.5 -1.5v-7a1.5 1.5 0 0 0 -1.5 -1.5l-0.214 0a0.632 0.632 0 0 1 -0.058 0.003l-7.585 0a0.625 0.625 0 0 1 0 -1.25l7.145 0V1.355a0.5 0.5 0 0 0 -0.5 -0.5H3.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.263 7.666h-3.5c-0.276 0 -0.5 0.2 -0.5 0.445v1.778c0 0.246 0.224 0.445 0.5 0.445h3.5c0.276 0 0.5 -0.2 0.5 -0.445V8.111c0 -0.246 -0.224 -0.445 -0.5 -0.445Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.5 4.003v-1.25H3.355a0.625 0.625 0 1 0 0 1.25l7.145 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Wallet"
);
var YuanCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.997 3.874a0.625 0.625 0 1 0 -1.002 -0.748L7.08 5.689 5.154 3.124a0.625 0.625 0 0 0 -1 0.751L6.456 6.94v0.018H5.19a0.625 0.625 0 1 0 0 1.25h1.265v0.862H5.19a0.625 0.625 0 1 0 0 1.25h1.265v0.459a0.625 0.625 0 1 0 1.25 0v-0.459h1.253a0.625 0.625 0 1 0 0 -1.25H7.706v-0.862h1.253a0.625 0.625 0 1 0 0 -1.25H7.706V6.94l2.29 -3.065Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "YuanCircle"
);
var Yuan = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.8 0.4a1 1 0 1 0 -1.6 1.2l3.917 5.222v0.021H3.915a1 1 0 1 0 0 2h2.202v1.245H3.915a1 1 0 1 0 0 2h2.202v0.805a1 1 0 1 0 2 0v-0.805h2.202a1 1 0 1 0 0 -2H8.117V8.843h2.202a1 1 0 1 0 0 -2H8.117v-0.02L12.033 1.6a1 1 0 1 0 -1.6 -1.2L7.117 4.822 3.8 0.4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Yuan"
);
var Bag = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.77 0 6.462 -1.336 6.462 -4.308 0 -3.232 -1.615 -4.869 -4.847 -6.485l1.398 -2.184A0.699 0.699 0 0 0 9.41 0H4.843a0.7 0.7 0 0 0 -0.603 1.077l1.144 2.13C2.153 4.845 0.537 6.482 0.537 9.713 0.537 12.664 3.23 14 7 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.144 3.886a4.589 4.589 0 0 0 5.717 -0.004 19.828 19.828 0 0 0 -1.237 -0.67 3.344 3.344 0 0 1 -3.249 0c-0.44 0.223 -0.85 0.447 -1.23 0.674Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bag"
);
var DiscountPercentBadge = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.537 0.61a2.395 2.395 0 0 0 -3.023 0l-0.159 0.13 -0.202 -0.033A2.395 2.395 0 0 0 2.535 2.22l-0.073 0.191 -0.192 0.073A2.395 2.395 0 0 0 0.76 5.101l0.033 0.203 -0.13 0.159a2.395 2.395 0 0 0 0 3.023l0.13 0.159 -0.033 0.202a2.395 2.395 0 0 0 1.511 2.618l0.192 0.073 0.073 0.192a2.395 2.395 0 0 0 2.618 1.511l0.202 -0.032 0.16 0.129 0.315 -0.388 -0.316 0.388c0.88 0.716 2.143 0.716 3.023 0l0.16 -0.13 0.202 0.033a2.395 2.395 0 0 0 2.618 -1.511l0.073 -0.192 0.191 -0.073a2.395 2.395 0 0 0 1.512 -2.618l-0.033 -0.202 0.13 -0.16a2.395 2.395 0 0 0 0 -3.022l-0.341 0.277 0.34 -0.277 -0.129 -0.16 0.033 -0.202a2.395 2.395 0 0 0 -1.512 -2.618l-0.191 -0.073 -0.073 -0.191A2.395 2.395 0 0 0 8.899 0.707L8.696 0.74 8.537 0.61Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.026 3.974a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.026 7.974a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.968 4.032a0.625 0.625 0 0 1 0 0.884l-5 5a0.625 0.625 0 0 1 -0.884 -0.884l5 -5a0.625 0.625 0 0 1 0.884 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscountPercentBadge"
);
var DiscountPercentCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.188 3.812a0.625 0.625 0 0 1 0 0.884l-5.492 5.492a0.625 0.625 0 0 1 -0.884 -0.884l5.492 -5.492a0.625 0.625 0 0 1 0.884 0ZM4.803 3.63a1.174 1.174 0 1 0 0 2.349 1.174 1.174 0 0 0 0 -2.349Zm3.22 5.568a1.174 1.174 0 1 1 2.348 0 1.174 1.174 0 0 1 -2.349 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscountPercentCircle"
);
var DiscountPercentCoupon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.498 12.5A1.499 1.499 0 0 1 0 11V8.97a0.5 0.5 0 0 1 0.373 -0.483 1.537 1.537 0 0 0 0 -2.974A0.5 0.5 0 0 1 0 5.03V3c0 -0.828 0.67 -1.5 1.498 -1.5h11.004C13.33 1.5 14 2.172 14 3v2.034a0.5 0.5 0 0 1 -0.369 0.483 1.537 1.537 0 0 0 0 2.966 0.5 0.5 0 0 1 0.369 0.483V11c0 0.828 -0.67 1.5 -1.498 1.5H1.498Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m9.962 4.942 -5 5a0.625 0.625 0 0 1 -0.883 -0.884l5 -5a0.625 0.625 0 1 1 0.883 0.884ZM5.021 4a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Zm4 4a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscountPercentCoupon"
);
var DiscountPercentCutout = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.82532 3.64038c-0.65443 0 -1.18494 0.53051 -1.18494 1.18494 0 0.65442 0.53051 1.18493 1.18494 1.18493 0.65442 0 1.18493 -0.53051 1.18493 -1.18493 0 -0.65443 -0.53051 -1.18494 -1.18493 -1.18494Zm5.08557 0.44871c0.29291 0.29289 0.29291 0.76776 0 1.06066L5.14971 9.91092c-0.29289 0.29288 -0.76776 0.29288 -1.06066 0 -0.29289 -0.2929 -0.29289 -0.76777 0 -1.06066l4.76117 -4.76117c0.2929 -0.2929 0.76777 -0.2929 1.06067 0ZM7.98975 9.17467c0 -0.65442 0.53051 -1.18493 1.18493 -1.18493s1.18492 0.53051 1.18492 1.18493c0 0.65443 -0.5305 1.18493 -1.18492 1.18493s-1.18493 -0.5305 -1.18493 -1.18493Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.61972 1.61966c0.03793 -0.03793 0.08936 -0.05924 0.143 -0.05924 0.41421 0 0.75 -0.33578 0.75 -0.749995 0 -0.414214 -0.33579 -0.7500002 -0.75 -0.7500002 -0.45146 0 -0.884431 0.1793422 -1.203661 0.4985732C0.239828 0.878228 0.0604858 1.3112 0.0604858 1.76266c0 0.41421 0.3357862 0.75 0.7500002 0.75s0.750004 -0.33579 0.750004 -0.75c0 -0.05364 0.0213 -0.10508 0.05923 -0.143ZM12.2373 0.0604248c-0.4142 0 -0.75 0.3357862 -0.75 0.7500002 0 0.414215 0.3358 0.749995 0.75 0.749995 0.0536 0 0.1051 0.02131 0.143 0.05924 0.0379 0.03792 0.0592 0.08936 0.0592 0.143 0 0.41421 0.3358 0.75 0.75 0.75 0.4143 0 0.75 -0.33579 0.75 -0.75 0 -0.45146 -0.1793 -0.884432 -0.4985 -1.203662 -0.3193 -0.319231 -0.7522 -0.4985732 -1.2037 -0.4985732ZM0.810486 11.4872c0.414214 0 0.750004 0.3358 0.750004 0.75 0 0.0537 0.0213 0.1051 0.05923 0.143 0.03793 0.038 0.08936 0.0593 0.143 0.0593 0.41421 0 0.75 0.3358 0.75 0.75s-0.33579 0.75 -0.75 0.75c-0.45146 0 -0.884431 -0.1794 -1.203661 -0.4986 -0.319231 -0.3192 -0.4985732 -0.7522 -0.4985732 -1.2037 0 -0.4142 0.3357862 -0.75 0.7500002 -0.75Zm13.129014 0.75c0 -0.4142 -0.3357 -0.75 -0.75 -0.75 -0.4142 0 -0.75 0.3358 -0.75 0.75 0 0.0537 -0.0213 0.1051 -0.0592 0.143 -0.0379 0.038 -0.0894 0.0593 -0.143 0.0593 -0.4142 0 -0.75 0.3358 -0.75 0.75s0.3358 0.75 0.75 0.75c0.4515 0 0.8844 -0.1794 1.2037 -0.4986 0.3192 -0.3192 0.4985 -0.7522 0.4985 -1.2037ZM3.86938 0.810425c0 -0.414214 0.33579 -0.7500002 0.75 -0.7500002h0.95224c0.41421 0 0.75 0.3357862 0.75 0.7500002 0 0.414215 -0.33579 0.749995 -0.75 0.749995h-0.95224c-0.41421 0 -0.75 -0.33578 -0.75 -0.749995ZM8.42834 0.0604248c-0.41421 0 -0.75 0.3357862 -0.75 0.7500002 0 0.414215 0.33579 0.749995 0.75 0.749995h0.95224c0.41421 0 0.75002 -0.33578 0.75002 -0.749995 0 -0.414214 -0.33581 -0.7500002 -0.75002 -0.7500002h-0.95224ZM3.86938 13.1895c0 -0.4142 0.33579 -0.75 0.75 -0.75h0.95224c0.41421 0 0.75 0.3358 0.75 0.75s-0.33579 0.75 -0.75 0.75h-0.95224c-0.41421 0 -0.75 -0.3358 -0.75 -0.75Zm4.55896 -0.75c-0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75h0.95224c0.41421 0 0.75002 -0.3358 0.75002 -0.75s-0.33581 -0.75 -0.75002 -0.75h-0.95224Zm4.76116 -8.57014c0.4142 0 0.75 0.33579 0.75 0.75v0.95224c0 0.41421 -0.3358 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-0.95224c0 -0.41421 0.3358 -0.75 0.75 -0.75Zm0.75 4.55894c0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v0.95223c0 0.41422 0.3358 0.74997 0.75 0.74997s0.75 -0.33575 0.75 -0.74997V8.4283ZM0.810486 3.86936c0.414214 0 0.750004 0.33579 0.750004 0.75v0.95224c0 0.41421 -0.33579 0.75 -0.750004 0.75s-0.7500002 -0.33579 -0.7500002 -0.75v-0.95224c0 -0.41421 0.3357862 -0.75 0.7500002 -0.75ZM1.56049 8.4283c0 -0.41421 -0.33579 -0.75 -0.750004 -0.75s-0.7500002 0.33579 -0.7500002 0.75v0.95223c0 0.41422 0.3357862 0.74997 0.7500002 0.74997s0.750004 -0.33575 0.750004 -0.74997V8.4283Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscountPercentCutout"
);
var DiscountPercentFire = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.867 0.11a0.5 0.5 0 0 0 -0.59 0.67c0.372 0.933 0.534 1.707 0.5 2.44 -0.035 0.72 -0.26 1.44 -0.723 2.267L3.788 4.05a0.5 0.5 0 0 0 -0.739 -0.012C1.246 5.954 0.845 8.479 1.645 10.507c0.807 2.047 2.815 3.533 5.675 3.39l0.006 0c2.146 -0.133 3.53 -0.924 4.363 -2.014 0.821 -1.071 1.058 -2.364 1.058 -3.42 0 -2.67 -1.184 -4.627 -2.631 -5.976C8.68 1.15 6.976 0.4 5.866 0.11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.065 7.118a0.75 0.75 0 1 0 0 1.5 0.75 0.75 0 0 0 0 -1.5Zm3.24 0.169a0.5 0.5 0 0 1 0 0.707L6.02 11.277a0.5 0.5 0 1 1 -0.707 -0.707l3.283 -3.283a0.5 0.5 0 0 1 0.707 0Zm-0.58 2.66a0.75 0.75 0 1 0 0 1.5 0.75 0.75 0 0 0 0 -1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiscountPercentFire"
);
var Gift2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.846 12.855V6.274H1.154v6.581a1 1 0 0 0 1 1h9.692a1 1 0 0 0 1 -1Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.45 3.391h2.506a3.964 3.964 0 0 0 -0.342 -0.571c-0.434 -0.602 -0.945 -0.941 -1.442 -0.941 -0.545 0 -0.77 0.156 -0.861 0.257 -0.098 0.11 -0.162 0.287 -0.14 0.543 0.023 0.258 0.131 0.523 0.278 0.712Zm-1.658 0a2.844 2.844 0 0 1 -0.115 -0.58c-0.048 -0.552 0.071 -1.182 0.52 -1.68C2.652 0.628 3.337 0.38 4.172 0.38c1.2 0 2.103 0.792 2.659 1.564 0.058 0.081 0.115 0.165 0.169 0.25 0.054 -0.085 0.11 -0.169 0.17 -0.25C7.724 1.17 8.628 0.379 9.827 0.379c0.836 0 1.52 0.248 1.975 0.753 0.448 0.497 0.568 1.127 0.52 1.68a2.841 2.841 0 0 1 -0.115 0.58h0.594a1 1 0 0 1 1 1v0.881a1 1 0 0 1 -1 1H7.625v7.582h-1.25V6.273H1.198a1 1 0 0 1 -1 -1v-0.882a1 1 0 0 1 1 -1h0.594Zm8.759 0a1.4 1.4 0 0 0 0.277 -0.712c0.023 -0.256 -0.04 -0.434 -0.139 -0.543 -0.091 -0.101 -0.316 -0.257 -0.861 -0.257 -0.497 0 -1.008 0.34 -1.442 0.94 -0.137 0.19 -0.25 0.386 -0.342 0.572h2.507Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Gift2"
);
var Gift = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.306C0 3.489 0.778 3 1.5 3h11c0.722 0 1.5 0.489 1.5 1.306v1.416c0 0.628 -0.46 1.062 -1 1.23V12.5a1.5 1.5 0 0 1 -1.5 1.5h-9A1.5 1.5 0 0 1 1 12.5V6.951c-0.54 -0.167 -1 -0.601 -1 -1.229V4.306Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.621 0.858A0.75 0.75 0 0 1 4.657 0.626L7 2.112 9.344 0.626a0.75 0.75 0 0 1 0.803 1.267L7.625 3.492v3.46H13v1.25H7.625V14l-1.25 0V8.203H1v-1.25h5.375V3.492l-2.522 -1.6A0.75 0.75 0 0 1 3.621 0.859Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Gift"
);
var QrCode = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.776 0.076a1.7 1.7 0 0 0 -1.7 1.7v1.425a0.75 0.75 0 1 0 1.5 0V1.776a0.2 0.2 0 0 1 0.2 -0.2h1.425a0.75 0.75 0 1 0 0 -1.5H1.776Zm9.023 0a0.75 0.75 0 0 0 0 1.5h1.425a0.2 0.2 0 0 1 0.2 0.2v1.425a0.75 0.75 0 0 0 1.5 0V1.776a1.7 1.7 0 0 0 -1.7 -1.7h-1.425ZM0.826 10.05a0.75 0.75 0 0 1 0.75 0.75v1.425a0.2 0.2 0 0 0 0.2 0.2h1.425a0.75 0.75 0 0 1 0 1.5H1.776a1.7 1.7 0 0 1 -1.7 -1.7V10.8a0.75 0.75 0 0 1 0.75 -0.75Zm13.098 0.75a0.75 0.75 0 0 0 -1.5 0v1.425a0.2 0.2 0 0 1 -0.2 0.2h-1.425a0.75 0.75 0 0 0 0 1.5h1.425a1.7 1.7 0 0 0 1.7 -1.7V10.8Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.996 2.746c-0.69 0 -1.25 0.56 -1.25 1.25v2.073c0 0.69 0.56 1.25 1.25 1.25h2.073c0.69 0 1.25 -0.56 1.25 -1.25V3.996c0 -0.69 -0.56 -1.25 -1.25 -1.25H3.996Zm0.25 3.073V4.246h1.573v1.573H4.246Zm0 3.371a0.75 0.75 0 1 0 -1.5 0v1.314c0 0.414 0.336 0.75 0.75 0.75H4.81a0.75 0.75 0 0 0 0 -1.5h-0.564V9.19Zm1.46 0a0.75 0.75 0 0 1 0.75 -0.75H7a0.75 0.75 0 0 1 0.75 0.75v1.314a0.75 0.75 0 0 1 -1.5 0v-0.592a0.75 0.75 0 0 1 -0.544 -0.722ZM9.94 3.496a0.75 0.75 0 0 0 -1.5 0V4.81c0 0.414 0.336 0.75 0.75 0.75h1.314a0.75 0.75 0 0 0 0 -1.5l-0.564 0v-0.564ZM8.44 7a0.75 0.75 0 0 1 0.75 -0.75h1.314a0.75 0.75 0 0 1 0.75 0.75v0.639a0.75 0.75 0 0 1 -1.492 0.111H9.19A0.75 0.75 0 0 1 8.44 7Zm1.5 2.19a0.75 0.75 0 0 0 -1.5 0v1.314c0 0.414 0.336 0.75 0.75 0.75h1.314a0.75 0.75 0 0 0 0 -1.5H9.94V9.19Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "QrCode"
);
var ReceiptAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.732 0.732A2.5 2.5 0 0 1 2.5 0H12a0.5 0.5 0 0 1 0.181 0.034A1.5 1.5 0 0 0 11 1.5v12a0.5 0.5 0 0 1 -0.757 0.429L8 12.583 5.757 13.93a0.5 0.5 0 0 1 -0.514 0L3 12.583 0.757 13.93A0.5 0.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 0.732 0.732Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 4a0.75 0.75 0 0 0 -1.5 0v1.75H3a0.75 0.75 0 0 0 0 1.5h1.75V9a0.75 0.75 0 0 0 1.5 0V7.25H8a0.75 0.75 0 0 0 0 -1.5H6.25V4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 1.5V6h2a1 1 0 0 0 1 -1V1.5a1.5 1.5 0 0 0 -3 0Z" }),
    " "
  ] }) }),
  "ReceiptAdd"
);
var ReceiptCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.732 0.732A2.5 2.5 0 0 1 2.5 0H12a0.5 0.5 0 0 1 0.181 0.034A1.5 1.5 0 0 0 11 1.5v12a0.5 0.5 0 0 1 -0.757 0.429L8 12.583 5.757 13.93a0.5 0.5 0 0 1 -0.514 0L3 12.583 0.757 13.93A0.5 0.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 0.732 0.732Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 1.5V6h2a1 1 0 0 0 1 -1V1.5a1.5 1.5 0 0 0 -3 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.744 3.936a0.75 0.75 0 0 1 0.07 1.058l-3.5 4A0.75 0.75 0 0 1 4.3 9.1l-2 -1.5a0.75 0.75 0 1 1 0.9 -1.2l1.444 1.083 3.042 -3.477a0.75 0.75 0 0 1 1.058 -0.07Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ReceiptCheck"
);
var ReceiptSubtract = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.732 0.732A2.5 2.5 0 0 1 2.5 0H12a0.5 0.5 0 0 1 0.181 0.034A1.5 1.5 0 0 0 11 1.5v12a0.5 0.5 0 0 1 -0.757 0.429L8 12.583 5.757 13.93a0.5 0.5 0 0 1 -0.514 0L3 12.583 0.757 13.93A0.5 0.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 0.732 0.732Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 1.5V6h2a1 1 0 0 0 1 -1V1.5a1.5 1.5 0 0 0 -3 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.25 6.5A0.75 0.75 0 0 1 3 5.75h5a0.75 0.75 0 0 1 0 1.5H3a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ReceiptSubtract"
);
var Receipt = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.732 0.732A2.5 2.5 0 0 1 2.5 0H12a0.5 0.5 0 0 1 0.181 0.034A1.5 1.5 0 0 0 11 1.5v12a0.5 0.5 0 0 1 -0.757 0.429L8 12.583 5.757 13.93a0.5 0.5 0 0 1 -0.514 0L3 12.583 0.757 13.93A0.5 0.5 0 0 1 0 13.5v-11A2.5 2.5 0 0 1 0.732 0.732Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 2a0.75 0.75 0 0 1 0.75 0.75v0.528a1.999 1.999 0 0 1 1.553 1.305 0.75 0.75 0 0 1 -1.415 0.5 0.5 0.5 0 0 0 -0.471 -0.333h-0.968a0.366 0.366 0 0 0 -0.078 0.723l1.473 0.322a2 2 0 0 1 -0.094 3.927v0.528a0.75 0.75 0 0 1 -1.5 0v-0.528a2.003 2.003 0 0 1 -1.553 -1.305 0.75 0.75 0 0 1 1.415 -0.5 0.5 0.5 0 0 0 0.471 0.333h0.834a0.5 0.5 0 0 0 0.107 -0.99L4.55 6.939a1.866 1.866 0 0 1 0.2 -3.677V2.75A0.75 0.75 0 0 1 5.5 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 1.5V6h2a1 1 0 0 0 1 -1V1.5a1.5 1.5 0 0 0 -3 0Z" }),
    " "
  ] }) }),
  "Receipt"
);
var ScannerBarCode = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.419 0.136a1.22 1.22 0 0 0 -1.22 1.22V5.12a0.75 0.75 0 0 0 1.5 0V1.636H5.18a0.75 0.75 0 1 0 0 -1.5H1.42Zm7.525 0a0.75 0.75 0 1 0 0 1.5h3.483v3.483a0.75 0.75 0 0 0 1.5 0V1.356a1.22 1.22 0 0 0 -1.22 -1.22H8.943Zm4.233 7.995a0.75 0.75 0 0 1 0.75 0.75v3.763a1.22 1.22 0 0 1 -1.22 1.22H8.943a0.75 0.75 0 0 1 0 -1.5h3.483V8.881a0.75 0.75 0 0 1 0.75 -0.75Zm-11.479 0.75a0.75 0.75 0 1 0 -1.5 0v3.763a1.22 1.22 0 0 0 1.22 1.22h3.763a0.75 0.75 0 0 0 0 -1.5H1.698V8.881Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.709 3.908a0.625 0.625 0 0 1 1.25 0v6.184a0.625 0.625 0 0 1 -1.25 0V3.908Zm8.587 0a0.625 0.625 0 1 0 -1.25 0v6.184a0.625 0.625 0 0 0 1.25 0V3.908ZM8.43 3.283c0.345 0 0.625 0.28 0.625 0.625v3.608a0.625 0.625 0 1 1 -1.25 0V3.908c0 -0.345 0.28 -0.625 0.625 -0.625Zm-0.625 6.81a0.625 0.625 0 1 0 1.25 0V9.81a0.625 0.625 0 1 0 -1.25 0v0.281Zm-1.98 -6.81c0.344 0 0.624 0.28 0.624 0.625v3.608a0.625 0.625 0 1 1 -1.25 0V3.908c0 -0.345 0.28 -0.625 0.625 -0.625Zm-0.626 6.81a0.625 0.625 0 1 0 1.25 0V9.81a0.625 0.625 0 1 0 -1.25 0v0.281Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ScannerBarCode"
);
var ShoppingBagHandBag2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.384 1.5a1.75 1.75 0 0 0 -1.75 1.75v1.5a0.75 0.75 0 0 1 -1.5 0v-1.5a3.25 3.25 0 0 1 6.5 0v1.5a0.75 0.75 0 0 1 -1.5 0v-1.5a1.75 1.75 0 0 0 -1.75 -1.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.384 3.913a0.5 0.5 0 0 0 -0.497 0.444l-0.847 7.596 -0.01 0.07c-0.02 0.163 -0.055 0.431 -0.001 0.69 0.114 0.547 0.53 0.996 1.073 1.146 0.244 0.068 0.522 0.06 0.691 0.056l0.09 -0.002h9c0.025 0 0.056 0 0.091 0.002 0.17 0.004 0.447 0.012 0.692 -0.056 0.541 -0.15 0.958 -0.6 1.073 -1.146 0.054 -0.259 0.019 -0.527 -0.003 -0.69l-0.008 -0.07 -0.847 -7.596a0.5 0.5 0 0 0 -0.497 -0.444h-10Z" }),
    " "
  ] }) }),
  "ShoppingBagHandBag2"
);
var ShoppingBasket1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.48 1.055a0.75 0.75 0 1 0 -0.256 1.478 1.885 1.885 0 0 1 1.554 1.662l0 0.004 0.208 1.89a0.75 0.75 0 1 0 1.491 -0.165l-0.207 -1.887a3.385 3.385 0 0 0 -2.79 -2.982ZM4.793 2.552a0.75 0.75 0 0 0 -0.254 -1.478 3.385 3.385 0 0 0 -2.79 2.96l0 0.001 -0.209 1.89a0.75 0.75 0 1 0 1.491 0.163l0.208 -1.887a1.885 1.885 0 0 1 1.554 -1.649Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.537 0.556a1.74 1.74 0 0 1 1.231 -0.51H8.25a1.74 1.74 0 1 1 0 3.482H5.768A1.74 1.74 0 0 1 4.538 0.556ZM1.69 5.506A1.511 1.511 0 0 0 0.2 6.811c-0.025 0.191 -0.002 0.366 0.013 0.482l0.66 4.979c0.004 0.023 0.007 0.053 0.01 0.087 0.017 0.162 0.045 0.43 0.139 0.656 0.175 0.423 0.545 0.752 0.984 0.88 0.221 0.064 0.457 0.06 0.599 0.058l0.061 -0.001h8.733l0.044 0c0.13 0.001 0.342 0.003 0.55 -0.057 0.438 -0.128 0.808 -0.457 0.984 -0.88 0.082 -0.197 0.107 -0.414 0.122 -0.544l0.007 -0.056 0.693 -5.222a1.503 1.503 0 0 0 -1.463 -1.687H1.69Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.745 7.863c0.346 0 0.625 0.28 0.625 0.625v2.482a0.625 0.625 0 1 1 -1.25 0V8.488c0 -0.345 0.28 -0.625 0.625 -0.625Zm3.264 0c0.345 0 0.625 0.28 0.625 0.625v2.482a0.625 0.625 0 1 1 -1.25 0V8.488c0 -0.345 0.28 -0.625 0.625 -0.625Zm3.889 0.625a0.625 0.625 0 1 0 -1.25 0v2.482a0.625 0.625 0 1 0 1.25 0V8.488Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingBasket1"
);
var ShoppingBasket2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.502 2.61a0.75 0.75 0 1 0 -1.303 -0.744L2.05 5.628a0.75 0.75 0 0 0 1.303 0.744l2.15 -3.762ZM9.8 1.866a0.75 0.75 0 0 0 -1.303 0.744l2.15 3.762a0.75 0.75 0 1 0 1.302 -0.744L9.8 1.866Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.275 5.5H1.725A1.5 1.5 0 0 0 0.23 7.299l1.1 5.499 0 0.002A1.5 1.5 0 0 0 2.825 14h8.35a1.5 1.5 0 0 0 1.495 -1.2l0 -0.002 1.1 -5.498 0 -0.001a1.501 1.501 0 0 0 -1.495 -1.8Z" }),
    " "
  ] }) }),
  "ShoppingBasket2"
);
var ShoppingCart1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.844 0.753a0.75 0.75 0 0 0 -0.747 -0.675H0.77a0.75 0.75 0 0 0 0 1.5h1.649l0.252 2.506c0 0.017 0 0.035 0.002 0.052l0.482 4.795a1.431 1.431 0 0 0 1.431 1.241h5.852a1.431 1.431 0 0 0 1.416 -0.973l0 -0.002 1.24 -3.724 0 -0.001a1.431 1.431 0 0 0 -0.2 -1.286 1.431 1.431 0 0 0 -1.216 -0.6h-7.55L3.844 0.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.279 12.822a1.178 1.178 0 1 0 -2.356 0 1.178 1.178 0 0 0 2.356 0Zm5.146 0a1.178 1.178 0 1 0 -2.356 0 1.178 1.178 0 0 0 2.356 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCart1"
);
var ShoppingCart2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 1.5h1.396l0.379 1.44a0.768 0.768 0 0 0 0.01 0.034l0.968 4.845a0.757 0.757 0 0 0 0.012 0.078l0.42 2.1 0 0.003a1.25 1.25 0 0 0 1.225 1h6.09a0.75 0.75 0 0 0 0 -1.5H5.365l-0.25 -1.25H12.1l0.01 0h0.001c0.035 0 0.135 0.003 0.227 -0.012a1.01 1.01 0 0 0 0.756 -0.589c0.054 -0.124 0.081 -0.281 0.09 -0.333l0.003 -0.014 0.791 -3.862 0.002 -0.01A1.001 1.001 0 0 0 13 2.25l-0.002 0 -9.105 0L3.56 0.975A1.25 1.25 0 0 0 2.34 0H0.75a0.75 0.75 0 1 0 0 1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.63 12.8a1.149 1.149 0 1 0 -2.298 0 1.149 1.149 0 0 0 2.297 0Zm5 0a1.149 1.149 0 1 0 -2.298 0 1.149 1.149 0 0 0 2.297 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCart2"
);
var ShoppingCart3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.844 0.753a0.75 0.75 0 0 0 -0.747 -0.675H0.77a0.75 0.75 0 0 0 0 1.5h1.649l0.252 2.506c0 0.017 0 0.035 0.002 0.052l0.482 4.795a1.431 1.431 0 0 0 1.431 1.241h5.852a1.431 1.431 0 0 0 1.416 -0.973l0 -0.002 1.24 -3.724 0 -0.001a1.431 1.431 0 0 0 -0.2 -1.286 1.431 1.431 0 0 0 -1.216 -0.6h-7.55L3.844 0.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.187 5.375c0.346 0 0.625 0.28 0.625 0.625v2a0.625 0.625 0 1 1 -1.25 0V6c0 -0.345 0.28 -0.625 0.625 -0.625Zm0.092 7.447a1.178 1.178 0 1 0 -2.356 0 1.178 1.178 0 0 0 2.356 0Zm5.146 0a1.178 1.178 0 1 0 -2.356 0 1.178 1.178 0 0 0 2.356 0ZM10.312 6a0.625 0.625 0 1 0 -1.25 0v2a0.625 0.625 0 1 0 1.25 0V6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCart3"
);
var ShoppingCartAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.251 0.753a0.75 0.75 0 0 0 -0.746 -0.675H1.177a0.75 0.75 0 1 0 0 1.5h1.65l0.251 2.506c0 0.017 0 0.035 0.002 0.052l0.483 4.795a1.431 1.431 0 0 0 1.431 1.241h5.851a1.432 1.432 0 0 0 1.417 -0.973l0 -0.002 1.239 -3.724 0 -0.001a1.431 1.431 0 0 0 -0.199 -1.286 1.431 1.431 0 0 0 -1.217 -0.6h-7.55L4.252 0.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.687 5.688a0.625 0.625 0 1 1 1.25 0v0.687h0.687a0.625 0.625 0 0 1 0 1.25h-0.687v0.687a0.625 0.625 0 1 1 -1.25 0v-0.687H7a0.625 0.625 0 1 1 0 -1.25h0.687v-0.687Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.654 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.508 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCartAdd"
);
var ShoppingCartCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.251 0.753a0.75 0.75 0 0 0 -0.746 -0.675H1.177a0.75 0.75 0 1 0 0 1.5h1.65l0.251 2.506c0 0.017 0 0.035 0.002 0.052l0.483 4.795a1.431 1.431 0 0 0 1.431 1.241h5.851a1.432 1.432 0 0 0 1.417 -0.973l0 -0.002 1.239 -3.724 0 -0.001a1.431 1.431 0 0 0 -0.199 -1.286 1.431 1.431 0 0 0 -1.217 -0.6h-7.55L4.252 0.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.654 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.508 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.866 5.28a0.625 0.625 0 0 1 0.125 0.874l-1.663 2.22a0.625 0.625 0 0 1 -0.875 0.126l-1.11 -0.831a0.625 0.625 0 0 1 0.75 -1l0.61 0.456 1.288 -1.72a0.625 0.625 0 0 1 0.875 -0.126Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCartCheck"
);
var ShoppingCartSubtract = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.251 0.753a0.75 0.75 0 0 0 -0.746 -0.675H1.177a0.75 0.75 0 1 0 0 1.5h1.65l0.251 2.506c0 0.017 0 0.035 0.002 0.052l0.483 4.795a1.431 1.431 0 0 0 1.431 1.241h5.851a1.432 1.432 0 0 0 1.417 -0.973l0 -0.002 1.239 -3.724 0 -0.001a1.431 1.431 0 0 0 -0.199 -1.286 1.431 1.431 0 0 0 -1.217 -0.6h-7.55L4.252 0.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.654 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.508 11.644a1.178 1.178 0 1 1 0 2.356 1.178 1.178 0 0 1 0 -2.356Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.248 7a0.625 0.625 0 0 0 -0.624 -0.625H7a0.625 0.625 0 0 0 0 1.25h2.624c0.345 0 0.624 -0.28 0.624 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShoppingCartSubtract"
);
var Store1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 4.432a0.5 0.5 0 0 0 -0.5 0.5V13a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V4.932a0.5 0.5 0 0 0 -0.5 -0.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.547 0.288A0.5 0.5 0 0 1 2 0h10a0.5 0.5 0 0 1 0.453 0.288l1.5 3.209a0.5 0.5 0 0 1 0.045 0.253H14v0.945c0 0.524 -0.226 1.026 -0.63 1.396a2.25 2.25 0 0 1 -1.519 0.578h-0.269a2.25 2.25 0 0 1 -1.519 -0.578 1.99 1.99 0 0 1 -0.392 -0.494c-0.12 -0.19 -0.349 -0.195 -0.48 0.01 -0.1 0.177 -0.23 0.34 -0.387 0.484a2.25 2.25 0 0 1 -1.52 0.578h-0.536a2.25 2.25 0 0 1 -1.52 -0.578 1.987 1.987 0 0 1 -0.407 -0.522c-0.12 -0.155 -0.325 -0.156 -0.452 0.014a1.988 1.988 0 0 1 -0.4 0.508 2.25 2.25 0 0 1 -1.52 0.578h-0.3a2.25 2.25 0 0 1 -1.52 -0.578A1.896 1.896 0 0 1 0 4.695V3.75h0.002a0.5 0.5 0 0 1 0.045 -0.253l1.5 -3.209Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.502 10.26V9a0.5 0.5 0 0 1 0.5 -0.5h3.014a0.5 0.5 0 0 1 0.5 0.5v1.26a0.5 0.5 0 0 1 -0.5 0.5H3.002a0.5 0.5 0 0 1 -0.5 -0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m10.745 14 0 -4.041a0.21 0.21 0 0 0 -0.07 -0.156 0.25 0.25 0 0 0 -0.17 -0.064l-1.992 0a0.25 0.25 0 0 0 -0.17 0.064 0.21 0.21 0 0 0 -0.07 0.156l0 4.041" }),
    " "
  ] }) }),
  "Store1"
);
var Store2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 6a0.5 0.5 0 0 0 -0.5 0.5L1 13a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1V6.5a0.5 0.5 0 0 0 -0.5 -0.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.811 0.248c0.24 -0.162 0.52 -0.25 0.81 -0.248h8.757c0.29 -0.002 0.571 0.086 0.81 0.248 0.24 0.162 0.427 0.39 0.547 0.654l0.001 0.002 1.22 2.711A0.5 0.5 0 0 1 14 3.82v2.214c0 0.264 -0.094 0.526 -0.275 0.726a0.977 0.977 0 0 1 -0.725 0.327H1a0.977 0.977 0 0 1 -0.725 -0.327A1.085 1.085 0 0 1 0 6.034V3.82a0.5 0.5 0 0 1 0.044 -0.205L1.264 0.902c0.12 -0.264 0.308 -0.492 0.547 -0.654Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.502 10.26V9a0.5 0.5 0 0 1 0.5 -0.5h3.014a0.5 0.5 0 0 1 0.5 0.5v1.26a0.5 0.5 0 0 1 -0.5 0.5H3.002a0.5 0.5 0 0 1 -0.5 -0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m10.745 14 0 -4.041a0.21 0.21 0 0 0 -0.07 -0.156 0.25 0.25 0 0 0 -0.17 -0.064l-1.992 0a0.25 0.25 0 0 0 -0.17 0.064 0.21 0.21 0 0 0 -0.07 0.156l0 4.041" }),
    " "
  ] }) }),
  "Store2"
);
var StoreComputer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.697 10.633a0.5 0.5 0 0 1 0.465 -0.314h1.677a0.5 0.5 0 0 1 0.464 0.314l0.874 2.186H10a0.5 0.5 0 1 1 0 1H4a0.5 0.5 0 0 1 0 -1h0.823l0.874 -2.186Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.915 0.41a0.466 0.466 0 0 1 0.422 -0.27h9.32c0.18 0 0.345 0.105 0.422 0.269l1.397 2.99a0.465 0.465 0 0 1 0.043 0.236h0.002V4.78c0 0.488 -0.212 0.956 -0.587 1.3a2.096 2.096 0 0 1 -1.416 0.54h-0.25c-0.532 0 -1.04 -0.194 -1.416 -0.54a1.855 1.855 0 0 1 -0.366 -0.46c-0.11 -0.177 -0.325 -0.181 -0.447 0.009a1.856 1.856 0 0 1 -0.36 0.452 2.096 2.096 0 0 1 -1.417 0.539h-0.5c-0.531 0 -1.04 -0.194 -1.416 -0.54a1.851 1.851 0 0 1 -0.38 -0.486c-0.11 -0.145 -0.302 -0.146 -0.42 0.013 -0.096 0.173 -0.22 0.334 -0.373 0.474a2.096 2.096 0 0 1 -1.416 0.539h-0.28a2.094 2.094 0 0 1 -1.417 -0.54 1.767 1.767 0 0 1 -0.586 -1.3V3.636h0.001A0.466 0.466 0 0 1 0.517 3.4L1.915 0.41Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.636 10.39v-5.3H1.364v5.3a1 1 0 0 0 1 1h9.27a1 1 0 0 0 1 -1Z" }),
    " "
  ] }) }),
  "StoreComputer"
);
var Tag = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.394.056a.86.86 0 0 1 .411-.05l3.81.588a.87.87 0 0 1 .791.79l.587 3.81a.86.86 0 0 1-.254.723l-7.716 7.717a1.25 1.25 0 0 1-1.767 0l-3.89-3.89a1.25 1.25 0 0 1 0-1.766L8.081.26a.86.86 0 0 1 .312-.205Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", transform: "matrix(-1 0 0 1 11 3.001)", d: "M0 1a1 1 0 1 0 2 0 1 1 0 1 0-2 0" }),
    " "
  ] }) }),
  "Tag"
);
var Ticket1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.556 12.449a1.5 1.5 0 0 1 -1.5 -1.5V8.95a0.5 0.5 0 0 1 0.373 -0.484 1.517 1.517 0 0 0 0 -2.933 0.5 0.5 0 0 1 -0.373 -0.484V3.051a1.5 1.5 0 0 1 1.5 -1.5h10.888a1.5 1.5 0 0 1 1.5 1.5v2.003a0.5 0.5 0 0 1 -0.369 0.483 1.517 1.517 0 0 0 0 2.926 0.5 0.5 0 0 1 0.37 0.483v2.003a1.5 1.5 0 0 1 -1.5 1.5H1.554Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.855 12.449h-1.25v-1.715a0.625 0.625 0 1 1 1.25 0l0 1.715Zm0 -10.898 0 1.723a0.625 0.625 0 1 1 -1.25 0V1.551h1.25Zm0 4.44a0.625 0.625 0 1 0 -1.25 0v2.016a0.625 0.625 0 0 0 1.25 0l0 -2.016Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Ticket1"
);
var Tickets = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.016 3.49445c-0.2643 -0.10885 -0.5616 0.03491 -0.7469 0.25261 -0.0126 0.01484 -0.0255 0.02944 -0.0388 0.04378 -0.1325 0.14349 -0.2928 0.25857 -0.4711 0.33829 -0.1783 0.07971 -0.3709 0.1224 -0.5662 0.12547 -0.1953 0.00307 -0.3892 -0.03353 -0.57 -0.1076 -0.1807 -0.07407 -0.3445 -0.18406 -0.4815 -0.32331 -0.1369 -0.13924 -0.24421 -0.30484 -0.31529 -0.48677 -0.07108 -0.18193 -0.10449 -0.37639 -0.0982 -0.57161 0.00092 -0.0283 0.00266 -0.05653 0.00523 -0.08466 0.02506 -0.27466 -0.07261 -0.57429 -0.3223 -0.69142l-0.43362 -0.20343c-0.23644 -0.09853 -0.50221 -0.09985 -0.73961 -0.00366 -0.23741 0.09619 -0.42731 0.28213 -0.52848 0.51746L4.51729 9.67264l-0.481 1.09316c-0.09854 0.2365 -0.09985 0.5022 -0.00366 0.7396 0.09619 0.2375 0.28213 0.4273 0.51746 0.5285l4.43832 1.8912c0.23645 0.0986 0.50221 0.0999 0.73962 0.0037 0.23741 -0.0962 0.42727 -0.2821 0.52847 -0.5175l3.6729 -8.49899c0.0916 -0.22726 0.0941 -0.48072 0.007 -0.70972 -0.0872 -0.22901 -0.2575 -0.4167 -0.477 -0.52558l-0.4434 -0.18256Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.69547 1.9944c-0.18735 -0.21592 -0.48461 -0.36007 -0.748953 -0.25122l-0.419686 0.17281c-0.213914 0.10611 -0.379917 0.28902 -0.4648403 0.51219 -0.0849237 0.22317 -0.0825157 0.47017 0.0067454 0.69164L3.02499 9.96047l0.34666 -0.78785L6.56086 1.8059l0.00075 -0.00176c0.01651 -0.03831 0.03405 -0.07605 0.05259 -0.11318L6.1305 0.573666C6.03191 0.344332 5.84685 0.163132 5.61549 0.0693909c-0.23136 -0.093741 -0.49036 -0.0924594 -0.72078 0.0035667L4.48365 0.2658c-0.24968 0.117137 -0.34708 0.417005 -0.3245 0.691878 0.00191 0.023217 0.00324 0.046502 0.00399 0.069842 0.00613 0.19024 -0.02642 0.37975 -0.09569 0.55704s-0.17382 0.33868 -0.3073 0.47438c-0.13348 0.13569 -0.29312 0.24288 -0.46924 0.31506 -0.17613 0.07219 -0.36507 0.10786 -0.55539 0.10487 -0.19032 -0.00299 -0.37806 -0.04459 -0.55183 -0.12228 -0.17376 -0.07768 -0.32995 -0.18984 -0.4591 -0.32967 -0.00988 -0.01069 -0.01959 -0.02154 -0.02912 -0.03252Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Tickets"
);
var AscendingNumberOrder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.167 0a0.75 0.75 0 0 1 0.75 0.75l0 4.25h0.917a0.75 0.75 0 0 1 0 1.5H9.5a0.75 0.75 0 0 1 0 -1.5h0.917l0 -2.313c-0.16 0.041 -0.328 0.063 -0.5 0.063H9.5a0.75 0.75 0 0 1 0 -1.5h0.417a0.5 0.5 0 0 0 0.5 -0.5 0.75 0.75 0 0 1 0.75 -0.75Zm-0.745 10.094 0.656 0c0.37 0 0.67 -0.298 0.672 -0.667v-0.01a0.672 0.672 0 0 0 -0.672 -0.667l-0.656 0a0.672 0.672 0 1 0 0 1.344Zm2.813 -0.935a2.172 2.172 0 0 0 -2.157 -1.909l-0.656 0a2.172 2.172 0 0 0 0 4.344l0.656 0c0.235 0 0.46 -0.037 0.672 -0.106v0.45c0 0.31 -0.252 0.562 -0.562 0.562h-0.875a0.563 0.563 0 0 1 -0.531 -0.375 0.75 0.75 0 1 0 -1.414 0.5A2.063 2.063 0 0 0 10.313 14h0.875a2.062 2.062 0 0 0 2.062 -2.063V9.431l0 -0.01 0 -0.008v-0.1a0.754 0.754 0 0 0 -0.015 -0.154Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.75 1a1 1 0 0 0 -2 0v9h-1.5a0.75 0.75 0 0 0 -0.53 1.28l2.5 2.5a0.75 0.75 0 0 0 1.06 0l2.5 -2.5A0.75 0.75 0 0 0 6.25 10h-1.5V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AscendingNumberOrder"
);
var Dashboard3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 0a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H1Zm7 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2.01a1 1 0 0 1 -1 1H9a1 1 0 0 1 -1 -1V1Zm0 6a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1H9a1 1 0 0 1 -1 -1V7Zm-8 3.99a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1V13a1 1 0 0 1 -1 1H1a1 1 0 0 1 -1 -1v-2.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dashboard3"
);
var DashboardCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6 3c0 1.65685 -1.34315 3 -3 3S0 4.65685 0 3s1.34315 -3 3 -3 3 1.34315 3 3Zm8 0c0 1.65685 -1.3431 3 -3 3 -1.65685 0 -3 -1.34315 -3 -3s1.34315 -3 3 -3c1.6569 0 3 1.34315 3 3ZM3 14c1.65685 0 3 -1.3431 3 -3 0 -1.65685 -1.34315 -3 -3 -3s-3 1.34315 -3 3c0 1.6569 1.34315 3 3 3Zm11 -3c0 1.6569 -1.3431 3 -3 3 -1.65685 0 -3 -1.3431 -3 -3 0 -1.65685 1.34315 -3 3 -3 1.6569 0 3 1.34315 3 3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DashboardCircle"
);
var DescendingNumberOrder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m10.422 2.844 0.656 0c0.37 0 0.67 -0.298 0.672 -0.667v-0.01a0.672 0.672 0 0 0 -0.672 -0.667l-0.656 0a0.672 0.672 0 1 0 0 1.344Zm2.813 -0.935A2.172 2.172 0 0 0 11.078 0l-0.656 0a2.172 2.172 0 0 0 0 4.344l0.656 0c0.235 0 0.46 -0.037 0.672 -0.106v0.45c0 0.31 -0.252 0.562 -0.562 0.562h-0.875a0.563 0.563 0 0 1 -0.531 -0.375 0.75 0.75 0 1 0 -1.414 0.5 2.063 2.063 0 0 0 1.945 1.375h0.875a2.062 2.062 0 0 0 2.062 -2.063V2.182l0 -0.01 0 -0.008v-0.1a0.754 0.754 0 0 0 -0.015 -0.154ZM11.167 7.5a0.75 0.75 0 0 1 0.75 0.75l0 4.25h0.917a0.75 0.75 0 0 1 0 1.5H9.5a0.75 0.75 0 0 1 0 -1.5h0.917l0 -2.313c-0.16 0.041 -0.328 0.063 -0.5 0.063H9.5a0.75 0.75 0 0 1 0 -1.5h0.417a0.5 0.5 0 0 0 0.5 -0.5 0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.75 1a1 1 0 0 0 -2 0v9h-1.5a0.75 0.75 0 0 0 -0.53 1.28l2.5 2.5a0.75 0.75 0 0 0 1.06 0l2.5 -2.5A0.75 0.75 0 0 0 6.25 10h-1.5V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DescendingNumberOrder"
);
var GraphArrowDecrease = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.898 3.222A1 1 0 1 0 0.483 4.637l3.333 3.332 0.007 0.007a1.457 1.457 0 0 0 2.039 0l0.007 -0.007L7.57 6.268 9.917 8.75l-1.04 1.04a0.75 0.75 0 0 0 0.53 1.28h3.652a0.75 0.75 0 0 0 0.75 -0.75V6.67a0.75 0.75 0 0 0 -1.28 -0.53l-1.197 1.197 -2.704 -2.86a1.457 1.457 0 0 0 -2.066 -0.027l0 -0.001 -0.007 0.007 -1.713 1.712 -2.944 -2.945Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraphArrowDecrease"
);
var GraphArrowIncrease = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.81 7.332a0.75 0.75 0 0 1 -1.28 0.53l-1.198 -1.198 -2.704 2.86a1.457 1.457 0 0 1 -2.066 0.027l0 0.001 -0.007 -0.007 -1.713 -1.712 -2.944 2.945A1 1 0 1 1 0.483 9.363l3.333 -3.332 0.007 -0.007a1.457 1.457 0 0 1 2.039 0l0.007 0.007L7.57 7.732 9.917 5.25l-1.04 -1.04a0.75 0.75 0 0 1 0.53 -1.28h3.652a0.75 0.75 0 0 1 0.75 0.75v3.652Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraphArrowIncrease"
);
var GraphBarDecrease = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.315 0.606a0.75 0.75 0 0 1 0.99 -0.38l8.591 3.828 0.361 -0.795a0.75 0.75 0 0 1 1.386 0.05l0.8 2.16a0.75 0.75 0 0 1 -0.438 0.963l-2.15 0.81a0.75 0.75 0 0 1 -0.948 -1.013l0.368 -0.81 -8.58 -3.822a0.75 0.75 0 0 1 -0.38 -0.99Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.25 5.5a1 1 0 0 0 -1 1v7a0.5 0.5 0 0 0 0.5 0.5h2.5a0.5 0.5 0 0 0 0.5 -0.5v-7a1 1 0 0 0 -1 -1h-1.5Zm5 1.5a1 1 0 0 0 -1 1v5.5a0.5 0.5 0 0 0 0.5 0.5h2.5a0.5 0.5 0 0 0 0.5 -0.5V8a1 1 0 0 0 -1 -1h-1.5Zm4.293 1.793a1 1 0 0 1 0.707 -0.293h1.5a1 1 0 0 1 1 1v4a0.5 0.5 0 0 1 -0.5 0.5h-2.5a0.5 0.5 0 0 1 -0.5 -0.5v-4a1 1 0 0 1 0.293 -0.707Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraphBarDecrease"
);
var GraphBarIncrease = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.997 0.22a0.75 0.75 0 0 1 0.819 -0.163l2.127 0.882a0.75 0.75 0 0 1 0.408 0.977l-0.869 2.127a0.75 0.75 0 0 1 -1.386 0.006l-0.343 -0.82L2.115 6.92a0.75 0.75 0 1 1 -0.59 -1.38l8.649 -3.695 -0.337 -0.805a0.75 0.75 0 0 1 0.16 -0.82Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.75 5.48a1 1 0 0 1 1 1v7a0.5 0.5 0 0 1 -0.5 0.5h-2.5a0.5 0.5 0 0 1 -0.5 -0.5v-7a1 1 0 0 1 1 -1h1.5Zm-5 1.5a1 1 0 0 1 1 1v5.5a0.5 0.5 0 0 1 -0.5 0.5h-2.5a0.5 0.5 0 0 1 -0.5 -0.5v-5.5a1 1 0 0 1 1 -1h1.5ZM3.457 8.771a1 1 0 0 0 -0.707 -0.293h-1.5a1 1 0 0 0 -1 1v4a0.5 0.5 0 0 0 0.5 0.5h2.5a0.5 0.5 0 0 0 0.5 -0.5v-4a1 1 0 0 0 -0.293 -0.707Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraphBarIncrease"
);
var GraphDot = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.581 6.004a0.75 0.75 0 0 1 1.06 -0.037l1.625 1.516A0.75 0.75 0 1 1 7.243 8.58L5.618 7.064a0.75 0.75 0 0 1 -0.037 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.324 3.655a0.75 0.75 0 0 1 0.448 0.961L10.6 7.835a0.75 0.75 0 1 1 -1.41 -0.513l1.173 -3.22a0.75 0.75 0 0 1 0.961 -0.447Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0.75a0.75 0.75 0 0 0 -1.5 0v12.5c0 0.414 0.336 0.75 0.75 0.75h12.5a0.75 0.75 0 0 0 0 -1.5H1.5V9.613l2.332 -2.49a0.75 0.75 0 0 0 -1.095 -1.025L1.5 7.418V0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.584 5.63a1.998 1.998 0 1 0 3.995 0 1.998 1.998 0 0 0 -3.995 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.583 2.662a1.998 1.998 0 1 0 3.997 0 1.998 1.998 0 0 0 -3.997 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.112 9.182a2 2 0 1 0 4 0 2 2 0 0 0 -4 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraphDot"
);
var Graph = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.824 0.148a0.75 0.75 0 0 1 0.75 0.75v11.454h11.454a0.75 0.75 0 0 1 0 1.5H0.823a0.75 0.75 0 0 1 -0.75 -0.75V0.898a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.46 2.261a1 1 0 0 1 0.761 0.17l3.286 2.347a1 1 0 0 1 -1.162 1.628L9.899 4.659 6.717 9.432a1 1 0 0 1 -1.539 0.152L2.832 7.238a1 1 0 1 1 1.414 -1.415L5.73 7.308 8.808 2.69a1 1 0 0 1 0.652 -0.429Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Graph"
);
var Hierarchy10 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.25 4.5a0.75 0.75 0 0 0 -1.5 0v5a0.75 0.75 0 0 0 1.5 0V9A2.25 2.25 0 0 1 6.5 6.75h2a0.75 0.75 0 0 0 0 -1.5h-2A3.75 3.75 0 0 0 4.25 6V4.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0c-0.69 0 -1.25 0.56 -1.25 1.25v2c0 0.69 0.56 1.25 1.25 1.25h2c0.69 0 1.25 -0.56 1.25 -1.25v-2C5.75 0.56 5.19 0 4.5 0h-2Zm7.25 3.75c-0.69 0 -1.25 0.56 -1.25 1.25v2c0 0.69 0.56 1.25 1.25 1.25h2C12.44 8.25 13 7.69 13 7V5c0 -0.69 -0.56 -1.25 -1.25 -1.25h-2Zm-8.5 7c0 -0.69 0.56 -1.25 1.25 -1.25h2c0.69 0 1.25 0.56 1.25 1.25v2c0 0.69 -0.56 1.25 -1.25 1.25h-2c-0.69 0 -1.25 -0.56 -1.25 -1.25v-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy10"
);
var Hierarchy13 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.252 1.794a0.75 0.75 0 0 1 0.454 0.958l-2.5 7a0.75 0.75 0 0 1 -1.21 0.303L4.46 5.932l-1.227 5.725a0.75 0.75 0 0 1 -1.466 -0.314l1.5 -7a0.75 0.75 0 0 1 1.238 -0.398l4.667 4.243 2.122 -5.94a0.75 0.75 0 0 1 0.958 -0.454Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.5 0H13a1 1 0 0 1 1 1v2.5a1 1 0 0 1 -1 1h-2.5a1 1 0 0 1 -1 -1V1a1 1 0 0 1 1 -1ZM3 2.5h2.5a1 1 0 0 1 1 1V6a1 1 0 0 1 -1 1H3a1 1 0 0 1 -1 -1V3.5a1 1 0 0 1 1 -1Zm-2 7h2.5a1 1 0 0 1 1 1V13a1 1 0 0 1 -1 1H1a1 1 0 0 1 -1 -1v-2.5a1 1 0 0 1 1 -1ZM11 7H8.5a1 1 0 0 0 -1 1v2.5a1 1 0 0 0 1 1H11a1 1 0 0 0 1 -1V8a1 1 0 0 0 -1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy13"
);
var Hierarchy14 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 5a0.75 0.75 0 0 0 -1.5 0v1.75H3A1.75 1.75 0 0 0 1.25 8.5v2a0.75 0.75 0 0 0 1.5 0v-2A0.25 0.25 0 0 1 3 8.25h3.25v2.25a0.75 0.75 0 0 0 1.5 0V8.25H11a0.25 0.25 0 0 1 0.25 0.25v2a0.75 0.75 0 0 0 1.5 0v-2A1.75 1.75 0 0 0 11 6.75H7.75V5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.25 1v3.5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1h-3.5a1 1 0 0 0 -1 1ZM0 11a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1H1a1 1 0 0 1 -1 -1v-2Zm5 0a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1H6a1 1 0 0 1 -1 -1v-2Zm6 -1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy14"
);
var Hierarchy2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 7.75v3.75h1.5V7.75H11a0.25 0.25 0 0 1 0.25 0.25v3.5a0.75 0.75 0 0 0 1.5 0V8A1.75 1.75 0 0 0 11 6.25H7.75V2.5h-1.5v3.75H3A1.75 1.75 0 0 0 1.25 8v3.5a0.75 0.75 0 0 0 1.5 0V8A0.25 0.25 0 0 1 3 7.75h3.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5 2A1.5 1.5 0 0 1 6.5 0.5h1A1.5 1.5 0 0 1 9 2v1a1.5 1.5 0 0 1 -1.5 1.5h-1A1.5 1.5 0 0 1 5 3V2Zm0 9a1.5 1.5 0 0 1 1.5 -1.5h1A1.5 1.5 0 0 1 9 11v1a1.5 1.5 0 0 1 -1.5 1.5h-1A1.5 1.5 0 0 1 5 12v-1ZM1.5 9.5A1.5 1.5 0 0 0 0 11v1a1.5 1.5 0 0 0 1.5 1.5h1A1.5 1.5 0 0 0 4 12v-1a1.5 1.5 0 0 0 -1.5 -1.5h-1ZM10 11a1.5 1.5 0 0 1 1.5 -1.5h1A1.5 1.5 0 0 1 14 11v1a1.5 1.5 0 0 1 -1.5 1.5h-1A1.5 1.5 0 0 1 10 12v-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy2"
);
var Hierarchy4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.75 2.5a0.75 0.75 0 0 0 -1.5 0v9a0.75 0.75 0 0 0 1.5 0v-4A3.75 3.75 0 0 0 7 8.25h1a0.75 0.75 0 0 0 0 -1.5H7A2.25 2.25 0 0 1 4.75 4.5v-2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.25 0a1.5 1.5 0 0 0 -1.5 1.5V3a1.5 1.5 0 0 0 1.5 1.5h1.5A1.5 1.5 0 0 0 6.25 3V1.5A1.5 1.5 0 0 0 4.75 0h-1.5Zm0 9.5a1.5 1.5 0 0 0 -1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5 -1.5V11a1.5 1.5 0 0 0 -1.5 -1.5h-1.5ZM8 6.75a1.5 1.5 0 0 1 1.5 -1.5H11a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1 -1.5 1.5H9.5A1.5 1.5 0 0 1 8 8.25v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy4"
);
var Hierarchy7 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9 0.5a0.5 0.5 0 0 0 -0.854 -0.354l-2 2a0.5 0.5 0 0 0 0 0.708l2 2A0.5 0.5 0 0 0 9 4.5V3.25h0.75c0.69 0 1.25 0.56 1.25 1.25v6a0.75 0.75 0 0 0 1.5 0v-6a2.75 2.75 0 0 0 -2.75 -2.75H9V0.5ZM2.25 2.75A0.75 0.75 0 0 1 3 3.5v7a0.75 0.75 0 0 1 -1.5 0v-7a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5V3a1.5 1.5 0 0 0 1.5 1.5H3A1.5 1.5 0 0 0 4.5 3V1.5A1.5 1.5 0 0 0 3 0H1.5Zm0 9.5A1.5 1.5 0 0 0 0 11v1.5A1.5 1.5 0 0 0 1.5 14H3a1.5 1.5 0 0 0 1.5 -1.5V11A1.5 1.5 0 0 0 3 9.5H1.5Zm8 1.5A1.5 1.5 0 0 1 11 9.5h1.5A1.5 1.5 0 0 1 14 11v1.5a1.5 1.5 0 0 1 -1.5 1.5H11a1.5 1.5 0 0 1 -1.5 -1.5V11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hierarchy7"
);
var PieChart = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7 -3.86599 0 -7 3.13401 -7 7 0 3.866 3.13401 7 7 7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M14 7c0 -3.86599 -3.134 -7 -7 -7v6.58579c0 0.26521 0.10536 0.51957 0.29289 0.7071l4.65681 4.65681C13.2165 10.683 14 8.933 14 7Z" }),
    " "
  ] }) }),
  "PieChart"
);
var SortDescending = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 0a0.75 0.75 0 1 0 0 1.5h6.5a0.75 0.75 0 0 0 0 -1.5H0.75ZM2.5 3.75A0.75 0.75 0 0 1 3.25 3h4a0.75 0.75 0 0 1 0 1.5h-4a0.75 0.75 0 0 1 -0.75 -0.75Zm2 3A0.75 0.75 0 0 1 5.25 6h2a0.75 0.75 0 0 1 0 1.5h-2a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.75 1a1 1 0 1 0 -2 0v9h-1.5a0.75 0.75 0 0 0 -0.53 1.28l2.5 2.5a0.75 0.75 0 0 0 1.06 0l2.5 -2.5a0.75 0.75 0 0 0 -0.53 -1.28h-1.5V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SortDescending"
);
var StepsNumber = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.5951 8.33261c-0.2144 -0.2145 -0.537 -0.27867 -0.8173 -0.16258 -0.2802 0.11608 -0.463 0.38956 -0.463 0.69291v1.18516l-9.3148 0c-0.552285 0 -1 0.4477 -1 1s0.447715 1 1 1l9.3148 0v1.1852c0 0.3034 0.1828 0.5769 0.463 0.6929 0.2803 0.1161 0.6029 0.052 0.8173 -0.1625l2.1852 -2.1852c0.2929 -0.2929 0.2929 -0.7678 0 -1.0607l-2.1852 -2.18519Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m12.0943 0.760498 -0.5333 0.000005c-0.792 0.000007 -1.4577 0.532217 -1.66273 1.257037 -0.11274 0.39857 0.11903 0.81307 0.51753 0.92581 0.3986 0.11273 0.8131 -0.11899 0.9258 -0.51756 0.0272 -0.09603 0.1162 -0.16529 0.2194 -0.16529l0.5334 0c0.1258 0 0.2278 0.10201 0.2278 0.22785s-0.102 0.22785 -0.2278 0.22785l-0.0889 0c-0.4143 0 -0.75 0.33579 -0.75 0.75001 0 0.41421 0.3358 0.74999 0.75 0.74999l0.0889 0c0.0179 0 0.0357 -0.00028 0.0535 -0.00082 0.0117 0.00054 0.0235 0.00082 0.0354 0.00082 0.1749 0 0.3167 0.14181 0.3167 0.31674v0.1778c0 0.17493 -0.1418 0.31674 -0.3167 0.31674l-0.7112 0.00001c-0.1367 0 -0.2551 -0.08707 -0.2989 -0.2111 -0.1381 -0.39054 -0.5665 -0.59524 -0.9571 -0.45721 -0.39052 0.13803 -0.59522 0.56652 -0.45719 0.95706 0.24909 0.70462 0.92099 1.21125 1.71319 1.21125l0.7112 -0.00001C13.1866 6.52748 14 5.7141 14 4.71074v-0.17779c0 -0.44187 -0.1578 -0.8469 -0.42 -1.16183 0.1538 -0.25836 0.2422 -0.56025 0.2422 -0.88277 0 -0.95427 -0.7736 -1.727861 -1.7279 -1.727852ZM2.2 0.760506c0.31128 0 0.57827 0.189632 0.69174 0.459674 0.03753 0.0893 0.05826 0.18739 0.05826 0.29033l0 3.51697h0.6723c0.41422 0 0.75 0.33579 0.75 0.75 0 0.41422 -0.33578 0.75 -0.75 0.75H2.2021L2.2 6.52749l-0.00209 -0.00001H0.777649c-0.414214 0 -0.7500001 -0.33578 -0.7500001 -0.75 0 -0.41421 0.3357861 -0.75 0.7500001 -0.75H1.45l0 -1.72775c-0.10286 0.01809 -0.2087 0.02752 -0.31674 0.02752H0.777678c-0.414214 0 -0.7500003 -0.33579 -0.7500003 -0.75s0.3357863 -0.75 0.7500003 -0.75h0.355582c0.17493 0 0.31674 -0.14181 0.31674 -0.31674 0 -0.41422 0.33579 -0.750004 0.75 -0.750004ZM4.93125 1.97173c0.24904 -0.7046 0.92098 -1.211224 1.71317 -1.211224h0.73884c0.98808 0 1.78907 0.800994 1.78907 1.789074 0 0.71079 -0.42078 1.35417 -1.07198 1.63907l-1.58288 0.69251c-0.06851 0.02997 -0.12261 0.08235 -0.15524 0.14632h2.0601c0.41421 0 0.75 0.33579 0.75 0.75s-0.33579 0.75 -0.75 0.75H5.57768c-0.41421 0 -0.75 -0.33579 -0.75 -0.75v-0.60613c0 -0.72179 0.42729 -1.37512 1.08856 -1.66443l1.58289 -0.69251c0.10521 -0.04603 0.1732 -0.14999 0.1732 -0.26483 0 -0.15965 -0.12942 -0.28907 -0.28907 -0.28907h-0.73884c-0.13674 0 -0.25507 0.08706 -0.29891 0.21109 -0.13803 0.39054 -0.56653 0.59523 -0.95706 0.4572 -0.39054 -0.13804 -0.59523 -0.56653 -0.4572 -0.95707Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StepsNumber"
);
var TrendingContent = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.495 0.126A0.889 0.889 0 0 1 6.379 0.11c3.987 1.852 6.244 5.698 6.105 8.914 -0.06 1.351 -0.543 2.602 -1.48 3.515 -0.938 0.914 -2.285 1.448 -3.99 1.451a5.186 5.186 0 0 1 -5.502 -4.967l0 -0.008a4.38 4.38 0 0 1 2.251 -3.94 0.5 0.5 0 0 1 0.7 0.235A5.005 5.005 0 0 0 5.47 6.796c0.494 -0.645 0.722 -1.478 0.715 -2.394 -0.008 -1.09 -0.35 -2.259 -0.924 -3.254A0.76 0.76 0 0 1 5.495 0.126Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TrendingContent"
);
var AlarmClock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1 8a6 6 0 1 0 12 0A6 6 0 1 0 1 8" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.912 0.397a0.75 0.75 0 0 1 -0.31 1.015 7.94 7.94 0 0 0 -2.284 1.827 0.75 0.75 0 0 1 -1.136 -0.978A9.44 9.44 0 0 1 2.897 0.088a0.75 0.75 0 0 1 1.015 0.31Zm6.176 0a0.75 0.75 0 0 1 1.015 -0.309 9.44 9.44 0 0 1 2.715 2.173 0.75 0.75 0 0 1 -1.136 0.978 7.94 7.94 0 0 0 -2.285 -1.827 0.75 0.75 0 0 1 -0.309 -1.015ZM7.625 5a0.625 0.625 0 1 0 -1.25 0v3c0 0.345 0.28 0.625 0.625 0.625h2.5a0.625 0.625 0 1 0 0 -1.25H7.625V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AlarmClock"
);
var BlankCalendar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " "
  ] }) }),
  "BlankCalendar"
);
var CalendarAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 6.75a0.75 0.75 0 0 0 -1.5 0V8.5H4.5a0.75 0.75 0 0 0 0 1.5h1.75v1.75a0.75 0.75 0 0 0 1.5 0V10H9.5a0.75 0.75 0 0 0 0 -1.5H7.75V6.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CalendarAdd"
);
var CalendarEdit = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.563 5.823a0.25 0.25 0 0 0 -0.354 0L4.086 9.955a0.25 0.25 0 0 0 -0.07 0.142l-0.264 1.868a0.25 0.25 0 0 0 0.282 0.283l1.868 -0.255a0.25 0.25 0 0 0 0.143 -0.07l4.132 -4.132a0.25 0.25 0 0 0 0 -0.354L8.563 5.823Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CalendarEdit"
);
var CalendarJumpToDate = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.43 10.943a0.625 0.625 0 0 0 1.067 0.442l1.909 -1.909a0.625 0.625 0 0 0 0 -0.884l-1.91 -1.909a0.625 0.625 0 0 0 -1.066 0.442v1.16l-3.394 0a0.75 0.75 0 0 0 0 1.5l3.394 0v1.158Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CalendarJumpToDate"
);
var CalendarStar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.254 6.07a0.5 0.5 0 0 0 -0.707 0.215l-0.743 1.493 -0.001 0.002 -1.653 0.243 -0.003 0a0.5 0.5 0 0 0 -0.277 0.846l0.005 0.005 1.195 1.144a0.253 0.253 0 0 0 -0.006 0.026l-0.276 1.638a0.5 0.5 0 0 0 0.738 0.533l1.456 -0.77a0.044 0.044 0 0 1 0.028 0l1.456 0.77a0.5 0.5 0 0 0 0.74 -0.529l-0.233 -1.636a0.25 0.25 0 0 0 -0.018 -0.063l1.16 -1.103a0.501 0.501 0 0 0 -0.274 -0.861l-1.649 -0.25 -0.003 -0.001 -0.744 -1.498 -0.002 -0.003a0.5 0.5 0 0 0 -0.189 -0.2Z" }),
    " "
  ] }) }),
  "CalendarStar"
);
var CircleClock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 3.875c0.345 0 0.625 0.28 0.625 0.625v2.274L9.98 9.6a0.625 0.625 0 1 1 -0.96 0.8l-2.5 -3a0.625 0.625 0 0 1 -0.145 -0.4V4.5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CircleClock"
);
var FastforwardClock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.75a0.75 0.75 0 0 1 0.75 0.75v3.575l2.136 1.282a0.75 0.75 0 1 1 -0.772 1.286l-2.5 -1.5A0.75 0.75 0 0 1 6.25 7.5v-4A0.75 0.75 0 0 1 7 2.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 7a5.5 5.5 0 0 1 9.82 -3.405l-0.966 0.965a0.5 0.5 0 0 0 0.353 0.854H13.5a0.5 0.5 0 0 0 0.5 -0.5V2.12a0.5 0.5 0 0 0 -0.854 -0.354l-0.76 0.761a7 7 0 1 0 1.427 6.086 0.75 0.75 0 0 0 -1.46 -0.344A5.5 5.5 0 0 1 1.5 7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FastforwardClock"
);
var NotificationAlarm2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.127 0.5c0.456 0 0.905 0.068 1.334 0.197a3.75 3.75 0 0 0 3.27 5.553v2.227a0.695 0.695 0 0 0 0.696 0.695 0.75 0.75 0 1 1 0 1.5H0.827a0.75 0.75 0 0 1 0 -1.5 0.695 0.695 0 0 0 0.696 -0.695V5.104A4.604 4.604 0 0 1 6.127 0.5Zm-1 11.5a0.75 0.75 0 0 0 0 1.5h2a0.75 0.75 0 0 0 0 -1.5h-2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.75 5a2.5 2.5 0 1 0 0 -5 2.5 2.5 0 0 0 0 5Z" }),
    " "
  ] }) }),
  "NotificationAlarm2"
);
var Sleep = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.974 0.595a0.75 0.75 0 0 0 -0.666 -0.405H7.825a0.75 0.75 0 0 0 0 1.5h1.033l-1.8 2.54a0.75 0.75 0 0 0 0.612 1.184h2.793a0.75 0.75 0 0 0 0 -1.5H9.12l1.8 -2.54a0.75 0.75 0 0 0 0.054 -0.779ZM5.906 4.058a0.75 0.75 0 0 0 -0.667 -0.405H2.588a0.75 0.75 0 1 0 0 1.5h1.201L1.81 7.947a0.75 0.75 0 0 0 0.613 1.183h2.983a0.75 0.75 0 1 0 0 -1.5H3.872l1.98 -2.794a0.75 0.75 0 0 0 0.054 -0.778Zm6.108 2.904a0.75 0.75 0 0 1 0.612 1.184l-3 4.235h2.614a0.75 0.75 0 0 1 0 1.5H8.176a0.75 0.75 0 0 1 -0.612 -1.184l3 -4.235H8.402a0.75 0.75 0 1 1 0 -1.5h3.612Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Sleep"
);
var SquareClock = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.5 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0 -9 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 4.375c0.345 0 0.625 0.28 0.625 0.625v1.375H9a0.625 0.625 0 1 1 0 1.25H7A0.625 0.625 0 0 1 6.375 7V5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SquareClock"
);
var WaitingAppointmentsCalendar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1h5V1a1 1 0 0 1 2 0v1h1A1.5 1.5 0 0 1 14 3.5v1H0v-1A1.5 1.5 0 0 1 1.5 2h1V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 4.5h14v8a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.363 6.268a0.392 0.392 0 0 0 -0.393 0.392v1.56H4.41a0.392 0.392 0 0 0 -0.392 0.392v1.276c0 0.216 0.175 0.392 0.392 0.392h1.56v1.56c0 0.217 0.176 0.392 0.392 0.392h1.276a0.392 0.392 0 0 0 0.392 -0.392l0 -1.56h1.56a0.392 0.392 0 0 0 0.392 -0.392V8.612a0.392 0.392 0 0 0 -0.392 -0.392l-1.56 0V6.66a0.392 0.392 0 0 0 -0.392 -0.392H6.363Z" }),
    " "
  ] }) }),
  "WaitingAppointmentsCalendar"
);
var Watch1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Watch1"
);
var Watch2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V2H4v-0.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 12v0.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V12H4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 2A1.5 1.5 0 0 0 2 3.5v7A1.5 1.5 0 0 0 3.5 12h7a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 10.5 2h-7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Watch2"
);
var WatchCircleCharging = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.861 4.313a0.625 0.625 0 0 1 0.13 0.874L7.073 6.43H8a0.625 0.625 0 0 1 0.546 0.928l-1.182 2.13a0.625 0.625 0 1 1 -1.093 -0.606l0.667 -1.202H5.832a0.625 0.625 0 0 1 -0.503 -0.997l1.658 -2.24a0.625 0.625 0 0 1 0.874 -0.13Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WatchCircleCharging"
);
var WatchCircleHeartbeatMonitor1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.487 8.926a0.695 0.695 0 0 1 -0.972 0L4.88 7.349C3.787 6.285 5.215 3.932 7 5.672c1.782 -1.737 3.21 0.616 2.12 1.677L7.486 8.926Z" }),
    " "
  ] }) }),
  "WatchCircleHeartbeatMonitor1"
);
var WatchCircleHeartbeatMonitor2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.542 5.034a0.625 0.625 0 0 1 0.527 0.398l0.588 1.531 0.148 -0.262a0.625 0.625 0 0 1 0.544 -0.318h0.997a0.625 0.625 0 0 1 0 1.25h-0.632l-0.62 1.1a0.625 0.625 0 0 1 -1.128 -0.082l-0.61 -1.588 -0.166 0.271a0.625 0.625 0 0 1 -0.533 0.299H4.82a0.625 0.625 0 0 1 0 -1.25h0.488l0.645 -1.053a0.625 0.625 0 0 1 0.59 -0.296Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WatchCircleHeartbeatMonitor2"
);
var WatchCircleMenu = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.867 5.865a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0ZM7.24 5.24a0.625 0.625 0 0 0 0 1.25h1.75a0.625 0.625 0 1 0 0 -1.25H7.24Zm0 2.27a0.625 0.625 0 1 0 0 1.25h1.75a0.625 0.625 0 0 0 0 -1.25H7.24ZM5.117 8.885a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WatchCircleMenu"
);
var WatchCircleTime = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.44 0.44A1.5 1.5 0 0 1 5.5 0h3A1.5 1.5 0 0 1 10 1.5V3a4.978 4.978 0 0 0 -3 -1 4.978 4.978 0 0 0 -3 1V1.5c0 -0.398 0.158 -0.78 0.44 -1.06ZM4 11v1.5A1.5 1.5 0 0 0 5.5 14h3a1.5 1.5 0 0 0 1.5 -1.5V11c-0.836 0.628 -1.874 1 -3 1a4.978 4.978 0 0 1 -3 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.063 4.419c0.345 0 0.625 0.28 0.625 0.625v1.653l0.941 0.942a0.625 0.625 0 1 1 -0.883 0.884L6.62 7.398a0.625 0.625 0 0 1 -0.184 -0.442V5.044c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WatchCircleTime"
);
var AirplaneDisabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.886 4.83 -0.204 -1.393a3.185 3.185 0 0 1 0.651 -2.435 2.123 2.123 0 0 1 3.334 0c0.542 0.687 0.778 1.568 0.651 2.435L9.114 4.83l4.117 2.088a1.062 1.062 0 0 1 -0.714 1.982l-3.906 -0.88 -0.235 2.18 2.04 1.729a1.064 1.064 0 0 1 -1.111 1.788l-2.305 -1 -2.305 1a1.064 1.064 0 0 1 -1.111 -1.788l2.04 -1.729 -0.234 -2.18 -3.906 0.882A1.062 1.062 0 0 1 0.77 6.92l4.116 -2.09Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.219 0.219a0.75 0.75 0 0 0 0 1.06L12.72 13.782a0.75 0.75 0 0 0 1.061 -1.06L1.28 0.218a0.75 0.75 0 0 0 -1.061 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AirplaneDisabled"
);
var AirplaneEnabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m4.886 4.85 -0.204 -1.393a3.185 3.185 0 0 1 0.651 -2.435 2.123 2.123 0 0 1 3.334 0c0.542 0.687 0.778 1.568 0.651 2.435L9.114 4.85l4.117 2.088a1.062 1.062 0 0 1 -0.714 1.982l-3.906 -0.882 -0.235 2.181 2.04 1.729a1.064 1.064 0 0 1 -1.111 1.788l-2.305 -1 -2.305 1a1.064 1.064 0 0 1 -1.111 -1.788l2.04 -1.729L5.39 8.04l-3.906 0.882A1.062 1.062 0 0 1 0.77 6.94l4.116 -2.09Z" }),
    " "
  ] }) }),
  "AirplaneEnabled"
);
var Airplane = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.563 2.197a0.775 0.775 0 0 1 0.758 0.598l0 -0.003 -0.243 0.062 0.244 -0.056 0 -0.003 0.486 1.91L8.934 3.68a4.204 4.204 0 0 1 5.013 4.09v0.003a1.321 1.321 0 0 1 -1.321 1.321H8.048l-0.997 1.577 -0.001 0.001a2.394 2.394 0 0 1 -2.01 1.101H3.86l-0.002 0a0.786 0.786 0 0 1 -0.692 -1.146l0.223 0.114 -0.222 -0.115 0.758 -1.5h-2.55A1.322 1.322 0 0 1 0.052 7.805V2.983a0.786 0.786 0 0 1 0.786 -0.786h1.724Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Airplane"
);
var AirportPlaneTransit = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m3.246 6.912 0.71 -0.365a0.257 0.257 0 0 1 0.349 0.086l0.67 0.764 2.77 -1.94a1.882 1.882 0 0 1 2.801 0.547 0.515 0.515 0 0 1 -0.242 0.686l-1.677 0.775 -0.185 0.089 -0.38 2.07a0.272 0.272 0 0 1 -0.153 0.214l-1.229 0.612a0.278 0.278 0 0 1 -0.374 -0.12 0.28 0.28 0 0 1 -0.031 -0.14l0.249 -1.67 -0.122 0.057 -1.606 0.849a0.506 0.506 0 0 1 -0.681 -0.213l-0.98 -1.97a0.257 0.257 0 0 1 0.11 -0.33Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.577 1.689a5.488 5.488 0 0 1 4.636 0.848l-0.61 0.61A0.5 0.5 0 0 0 9.957 4h2.293a0.5 0.5 0 0 0 0.5 -0.5V1.207a0.5 0.5 0 0 0 -0.854 -0.353l-0.612 0.612A6.999 6.999 0 0 0 0.12 8.287a0.75 0.75 0 1 0 1.475 -0.277 5.499 5.499 0 0 1 3.982 -6.321Zm8.303 4.024a0.75 0.75 0 0 0 -1.475 0.277 5.499 5.499 0 0 1 -8.618 5.473l0.61 -0.61A0.5 0.5 0 0 0 4.042 10H1.75a0.5 0.5 0 0 0 -0.5 0.5v2.293a0.5 0.5 0 0 0 0.854 0.353l0.612 -0.612a6.999 6.999 0 0 0 11.164 -6.82Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AirportPlaneTransit"
);
var AirportPlane = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.98 0.3a1.72 1.72 0 0 0 -1.217 0.504l-0.001 0L8.325 3.27 3.186 0.894a1.72 1.72 0 0 0 -2.333 0.89 1.7 1.7 0 0 0 0.615 2.23l3.79 2.334L4.077 7.53H1.879l-0.02 0a1.7 1.7 0 0 0 0.02 3.39h1.2v1.2l0.001 0.02a1.7 1.7 0 0 0 3.39 -0.02V9.924l1.182 -1.183 2.335 3.79 0 0.001a1.7 1.7 0 0 0 2.229 0.615 1.712 1.712 0 0 0 0.891 -2.28L10.73 5.675l2.465 -2.437 0.001 0A1.72 1.72 0 0 0 11.98 0.3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AirportPlane"
);
var AirportSecurity = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.54 13.9a1.5 1.5 0 0 1 -1.079 0A10.065 10.065 0 0 1 0.004 4.498V1.499c0 -0.397 0.158 -0.779 0.44 -1.06", clipRule: "evenodd" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.503 0a1.5 1.5 0 0 0 -1.5 1.5v2.998A10.065 10.065 0 0 0 6.462 13.9a1.5 1.5 0 0 0 1.078 0 10.067 10.067 0 0 0 6.458 -9.402V1.499A1.5 1.5 0 0 0 12.497 0H1.503Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.974 3.685a2.308 2.308 0 0 1 2.365 1.48 0.812 0.812 0 0 1 -0.537 1.016l-1.94 0.57 -0.091 0.027 -0.7 2.051a0.547 0.547 0 0 1 -0.357 0.369l-1.189 0.437 -0.007 0.003a0.556 0.556 0 0 1 -0.715 -0.657l0.4 -1.31 -1.792 0.582a0.804 0.804 0 0 1 -1.018 -0.492l-0.746 -2.296 -0.003 -0.01a0.53 0.53 0 0 1 0.328 -0.64l0.827 -0.282a0.531 0.531 0 0 1 0.67 0.263l0.472 0.731 3.099 -1.55a2.3 2.3 0 0 1 0.934 -0.292Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AirportSecurity"
);
var Anchor = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 2.284a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0Zm3 0a2.25 2.25 0 0 1 -1.5 2.122v0.872h0.75a0.75 0.75 0 0 1 0 1.5h-0.75l0 5.612a4.75 4.75 0 0 0 3.94 -3.94H11a0.75 0.75 0 0 1 0 -1.5h1.5a0.75 0.75 0 0 1 0.75 0.75 6.25 6.25 0 0 1 -12.5 0 0.75 0.75 0 0 1 0.75 -0.75H3a0.75 0.75 0 1 1 0 1.5h-0.69a4.75 4.75 0 0 0 3.94 3.94l0 -5.612H5.5a0.75 0.75 0 1 1 0 -1.5h0.75v-0.872a2.25 2.25 0 1 1 3 -2.122Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Anchor"
);
var BagSuitcase1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 1.55347c-0.0663 0 -0.12989 0.02634 -0.17678 0.07322 -0.04688 0.04688 -0.07322 0.11047 -0.07322 0.17678v1.25h4.5v-1.25c0 -0.06631 -0.02634 -0.1299 -0.07322 -0.17678C9.12989 1.57981 9.0663 1.55347 9 1.55347H5ZM3.76256 0.56603C4.09075 0.237841 4.53587 0.0534668 5 0.0534668h4c0.46413 0 0.90925 0.1843742 1.2374 0.5125632 0.3282 0.328188 0.5126 0.77331 0.5126 1.23744v2c0 0.41421 -0.3358 0.75 -0.75 0.75H4c-0.41421 0 -0.75 -0.33579 -0.75 -0.75v-2c0 -0.46413 0.18437 -0.909252 0.51256 -1.23744Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 3C0.671573 3 0 3.67157 0 4.5v8c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5v-8c0 -0.82843 -0.6716 -1.5 -1.5 -1.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 5.95319c-0.34518 0 -0.625 0.27982 -0.625 0.625 0 0.34517 0.27982 0.625 0.625 0.625h7c0.3452 0 0.625 -0.27983 0.625 -0.625 0 -0.34518 -0.2798 -0.625 -0.625 -0.625h-7Zm0 3.84362c-0.34518 0 -0.625 0.27979 -0.625 0.62499 0 0.3452 0.27982 0.625 0.625 0.625h7c0.3452 0 0.625 -0.2798 0.625 -0.625s-0.2798 -0.62499 -0.625 -0.62499h-7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BagSuitcase1"
);
var BagSuitcase2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.763 0.532A1.75 1.75 0 0 1 5 0.02h4a1.75 1.75 0 0 1 1.75 1.75v2a0.75 0.75 0 0 1 -1.5 0v-2A0.25 0.25 0 0 0 9 1.52H5a0.25 0.25 0 0 0 -0.25 0.25v2a0.75 0.75 0 0 1 -1.5 0v-2c0 -0.464 0.184 -0.91 0.513 -1.238Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 3A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-8A1.5 1.5 0 0 0 12.5 3h-11Z" }),
    " "
  ] }) }),
  "BagSuitcase2"
);
var Baggage = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2.25c-0.46413 0 -0.90925 0.18437 -1.23744 0.51256 -0.20736 0.20737 -0.35731 0.46141 -0.43961 0.73744h3.3541c-0.0823 -0.27603 -0.23225 -0.53007 -0.43961 -0.73744C7.90925 2.43437 7.46413 2.25 7 2.25Zm-2.2981 -0.5481c-0.49037 0.49037 -0.80785 1.12131 -0.91322 1.7981H2.5C1.11929 3.5 0 4.61929 0 6v5.5C0 12.8807 1.11929 14 2.5 14h9c1.3807 0 2.5 -1.1193 2.5 -2.5V6c0 -1.38071 -1.1193 -2.5 -2.5 -2.5h-1.2887c-0.1053 -0.67679 -0.42283 -1.30773 -0.9132 -1.7981C8.6886 1.09241 7.86195 0.75 7 0.75c-0.86195 0 -1.6886 0.34241 -2.2981 0.9519Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2079 3.47876c-0.0024 0.02253 -0.0037 0.04541 -0.0037 0.06859V13.9526c0 0.016 0.0006 0.0318 0.0018 0.0474h1.2465c0.0011 -0.0156 0.0017 -0.0314 0.0017 -0.0474V3.54735c0 -0.01593 -0.0006 -0.03173 -0.0017 -0.04736h-1.2412c-0.0011 -0.00708 -0.0022 -0.01416 -0.0034 -0.02123ZM3.79401 14c0.00117 -0.0156 0.00177 -0.0314 0.00177 -0.0474V3.54735c0 -0.02318 -0.00127 -0.04606 -0.00372 -0.06859 -0.00115 0.00707 -0.00228 0.01415 -0.00338 0.02123H2.54754c-0.00117 0.01563 -0.00176 0.03143 -0.00176 0.04736V13.9526c0 0.016 0.00059 0.0318 0.00176 0.0474h1.24647Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Baggage"
);
var Beach = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.34 3.291 -0.055 0.015a2.25 2.25 0 0 0 -1.232 0.897 0.75 0.75 0 1 1 -1.24 -0.843 3.75 3.75 0 0 1 2.681 -1.62 1.83 1.83 0 0 0 -1.236 -0.193 0.75 0.75 0 0 1 -0.29 -1.471 3.33 3.33 0 0 1 3.52 1.588 3.53 3.53 0 0 1 3.825 0.908 0.75 0.75 0 1 1 -1.1 1.02 2.03 2.03 0 0 0 -1.291 -0.642 3.295 3.295 0 0 1 0.805 2.915 0.75 0.75 0 0 1 -1.468 -0.307 1.8 1.8 0 0 0 -1.069 -2.03c-0.427 0.291 -0.786 0.769 -1.059 1.43 -0.323 0.782 -0.5 1.766 -0.528 2.833a0.75 0.75 0 1 1 -1.5 -0.04c0.032 -1.192 0.23 -2.368 0.642 -3.366a5.55 5.55 0 0 1 0.595 -1.094Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.52 7.968c0.88 -0.547 1.852 -0.836 2.844 -0.836 0.991 0 1.963 0.289 2.843 0.836 0.775 0.48 1.46 1.15 2.024 1.96a1.506 1.506 0 0 0 -0.908 0.643c-0.086 0.138 -0.175 0.25 -0.262 0.339a1.012 1.012 0 0 1 -1.416 0 1.981 1.981 0 0 1 -0.224 -0.28c-0.387 -0.576 -1.056 -0.701 -1.452 -0.701 -0.396 0 -1.065 0.125 -1.452 0.701a1.98 1.98 0 0 1 -0.224 0.28 1.012 1.012 0 0 1 -1.416 0 2.056 2.056 0 0 1 -0.263 -0.339c-0.37 -0.587 -1.033 -0.71 -1.412 -0.71 -0.206 0 -0.49 0.036 -0.769 0.16 0.576 -0.853 1.284 -1.554 2.087 -2.053Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.46 11.134a0.5 0.5 0 0 0 -0.922 0.005 1.85 1.85 0 0 1 -1.18 1.063 0.5 0.5 0 0 0 -0.358 0.479v0.819a0.5 0.5 0 0 0 0.5 0.5h13a0.5 0.5 0 0 0 0.5 -0.5v-0.82a0.5 0.5 0 0 0 -0.357 -0.478 1.85 1.85 0 0 1 -1.181 -1.063 0.5 0.5 0 0 0 -0.922 -0.005 1.99 1.99 0 0 1 -0.805 0.922c-0.69 0.415 -1.78 0.415 -2.47 0a1.99 1.99 0 0 1 -0.805 -0.922 0.5 0.5 0 0 0 -0.92 0 1.99 1.99 0 0 1 -0.805 0.922c-0.69 0.415 -1.78 0.415 -2.47 0a1.99 1.99 0 0 1 -0.805 -0.922Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Beach"
);
var BicycleBike = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 8.125a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0 -5.75ZM1.851 9.851a1.625 1.625 0 1 1 2.298 2.298 1.625 1.625 0 0 1 -2.298 -2.298ZM11 8.125a2.875 2.875 0 1 0 0 5.75 2.875 2.875 0 0 0 0 -5.75ZM9.85 9.851a1.625 1.625 0 1 1 2.299 2.298 1.625 1.625 0 0 1 -2.298 -2.298Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.985 4.146a0.625 0.625 0 0 1 0.515 -0.271h3a0.625 0.625 0 1 1 0 1.25H9.41l2.173 5.65a0.625 0.625 0 0 1 -1.166 0.45L9.404 8.59l-1.913 2.296a0.622 0.622 0 0 1 -0.429 0.235l-3.984 0.498a0.625 0.625 0 0 1 -0.637 -0.9l1.8 -3.604 -0.595 -0.991H3a0.625 0.625 0 1 1 0 -1.25h0.989l0.021 0H5.5a0.625 0.625 0 1 1 0 1.25h-0.396l0.38 0.635 0.009 0.013 1.59 2.65L8.89 7.257l-0.973 -2.532a0.625 0.625 0 0 1 0.068 -0.578ZM5.003 8.387l-0.922 1.848L5.97 10l-0.968 -1.612Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BicycleBike"
);
var Bus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.701 0.04C1.76 0.04 0.996 0.805 0.996 1.747V6h12.008V1.746c0 -0.942 -0.763 -1.705 -1.705 -1.705H2.7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.295 12.478v0.513a1 1 0 1 0 2 0v-0.465H2.701a1.71 1.71 0 0 1 -0.406 -0.048Zm7.41 0.048v0.465a1 1 0 1 0 2 0v-0.513a1.71 1.71 0 0 1 -0.406 0.048H9.705Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.701 1.54a0.205 0.205 0 0 0 -0.205 0.206V5.88h9.008V1.746a0.205 0.205 0 0 0 -0.205 -0.205H2.7Zm-1.705 0.206C0.996 0.804 1.76 0.041 2.701 0.041H11.3c0.942 0 1.705 0.763 1.705 1.705v9.075c0 0.942 -0.763 1.705 -1.705 1.705H2.7a1.705 1.705 0 0 1 -1.705 -1.705V1.746Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 10a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Zm6 0a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bus"
);
var CampingTent = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.707 0.348a0.75 0.75 0 1 0 -1.255 0.82l1.652 2.528L0.13 12.83a0.75 0.75 0 0 0 0.627 1.16H13.24a0.75 0.75 0 0 0 0.628 -1.16L7.896 3.696l1.652 -2.527A0.75 0.75 0 1 0 8.293 0.348L7 2.325 5.707 0.348Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m8 13.992 0 -3.02a1 1 0 1 0 -2 0v3.02h2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CampingTent"
);
var CarBatteryCharging = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 2c0 -0.27614 0.22386 -0.5 0.5 -0.5h3c0.27614 0 0.5 0.22386 0.5 0.5v2c0 0.27614 -0.22386 0.5 -0.5 0.5H2c-0.27614 0 -0.5 -0.22386 -0.5 -0.5V2Zm7 0c0 -0.27614 0.22386 -0.5 0.5 -0.5h3c0.2761 0 0.5 0.22386 0.5 0.5v2c0 0.27614 -0.2239 0.5 -0.5 0.5H9c-0.27614 0 -0.5 -0.22386 -0.5 -0.5V2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 3.5C0.671573 3.5 0 4.17157 0 5v7.5c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5V5c0 -0.82843 -0.6716 -1.5 -1.5 -1.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.84877 5.74114c0.26954 0.21563 0.31324 0.60894 0.09761 0.87847L6.9254 7.89585h1.44961c0.23049 0 0.44228 0.12686 0.55104 0.33008 0.10876 0.20323 0.09684 0.44982 -0.03101 0.6416L7.0617 11.6175c-0.19147 0.2872 -0.57951 0.3648 -0.86672 0.1734 -0.2872 -0.1915 -0.36481 -0.5795 -0.17334 -0.8667l1.18554 -1.77835H5.62501c-0.24026 0 -0.45924 -0.13772 -0.56332 -0.35426 -0.10407 -0.21654 -0.07481 -0.47357 0.07527 -0.66118L6.9703 5.83875c0.21563 -0.26954 0.60894 -0.31324 0.87847 -0.09761Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CarBatteryCharging"
);
var CarTaxi1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.25a0.75 0.75 0 0 0 -0.75 0.75v2a0.75 0.75 0 0 0 1.5 0V2A0.75 0.75 0 0 0 7 1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.782 3.5h3.986a1.5 1.5 0 0 1 1.486 1.02l0.004 0.012 0.61 1.968H12.5A1.5 1.5 0 0 1 14 8v2a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 10V8a1.5 1.5 0 0 1 1.5 -1.5h1.14l0.655 -1.977 0.001 -0.002A1.5 1.5 0 0 1 4.782 3.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.998 11.751a1.501 1.501 0 1 0 3.002 0 1.501 1.501 0 0 0 -3.002 0Zm7 0a1.501 1.501 0 1 0 3.002 0 1.501 1.501 0 0 0 -3.002 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CarTaxi1"
);
var CompassNavigator = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.4583 1.04659c.911-.255871 1.751.58406 1.4951 1.49515l-2.0988 7.47336c-.1143.407-.4325.7252-.8395.8395l-7.47336 2.0988c-.91109.2559-1.751021-.5841-1.49515-1.4951l2.09884-7.47339c.11432-.40705.43243-.72516.83948-.83948l7.47339-2.09884Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", transform: "rotate(45 7 7)", d: "M5.029 7a1.971 1.971 0 1 0 3.942 0 1.971 1.971 0 1 0-3.942 0" }),
    " "
  ] }) }),
  "CompassNavigator"
);
var Container = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 2.5A0.5 0.5 0 0 1 0.5 2h13a0.5 0.5 0 0 1 0 1h-0.25v8h0.25a0.5 0.5 0 0 1 0 1H0.5a0.5 0.5 0 0 1 0 -1h0.25V3H0.5a0.5 0.5 0 0 1 -0.5 -0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 4.375c0.345 0 0.625 0.28 0.625 0.625v4a0.625 0.625 0 1 1 -1.25 0V5c0 -0.345 0.28 -0.625 0.625 -0.625Zm3 0c0.345 0 0.625 0.28 0.625 0.625v4a0.625 0.625 0 1 1 -1.25 0V5c0 -0.345 0.28 -0.625 0.625 -0.625ZM10.625 5a0.625 0.625 0 1 0 -1.25 0v4a0.625 0.625 0 1 0 1.25 0V5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Container"
);
var Drone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.669 8.376A0.75 0.75 0 0 1 4.5 9.624c-0.335 0.223 -0.578 0.709 -0.688 1.417 -0.064 0.412 -0.073 0.84 -0.054 1.209h0.326a0.75 0.75 0 0 1 0 1.5h-1a0.75 0.75 0 0 1 -0.74 -0.627 7.691 7.691 0 0 1 -0.014 -2.313c0.131 -0.843 0.472 -1.857 1.338 -2.434Zm6.747 0a0.75 0.75 0 1 0 -0.832 1.248c0.335 0.223 0.577 0.709 0.688 1.417 0.064 0.412 0.073 0.84 0.054 1.209H10a0.75 0.75 0 0 0 0 1.5h1a0.75 0.75 0 0 0 0.74 -0.627c0.093 -0.561 0.15 -1.444 0.014 -2.313 -0.132 -0.843 -0.473 -1.857 -1.338 -2.434Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.034 0.79a0.75 0.75 0 0 1 0.75 -0.75H4.61a0.75 0.75 0 0 1 0 1.5H3.447V3.5h-1.5V1.54H0.784a0.75 0.75 0 0 1 -0.75 -0.75Zm12.02 2.71V1.54h1.162a0.75 0.75 0 0 0 0 -1.5H9.39a0.75 0.75 0 0 0 0 1.5h1.162V3.5h1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.027 7.5h7.946c-0.037 0.376 -0.111 0.81 -0.217 1.226 -0.079 0.312 -0.18 0.627 -0.302 0.907 -0.12 0.274 -0.275 0.548 -0.48 0.752A3.5 3.5 0 0 1 7.5 11.41h-1a3.5 3.5 0 0 1 -2.475 -1.025c-0.204 -0.204 -0.36 -0.478 -0.479 -0.752a5.947 5.947 0 0 1 -0.302 -0.907A8.525 8.525 0 0 1 3.027 7.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 3.5A0.5 0.5 0 0 0 0 4v1a2.5 2.5 0 0 0 2.5 2.5h9A2.5 2.5 0 0 0 14 5V4a0.5 0.5 0 0 0 -0.5 -0.5H0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Drone"
);
var Earth1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.164 8.722H0.213A7 7 0 0 1 9.203 0.354v1.884a1.68 1.68 0 0 1 -1.68 1.68 1.68 1.68 0 0 0 -1.68 1.736v1.388a1.68 1.68 0 0 1 -1.68 1.68Zm8.31 -0.376 1.172 0.859a7.021 7.021 0 0 1 -3.537 4.068v-0.811a1.175 1.175 0 0 0 -1.189 -1.176 1.668 1.668 0 0 1 0 -3.322h2.024a3.431 3.431 0 0 1 1.53 0.382Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Earth1"
);
var EarthAirplane = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.708 3.507a5.662 5.662 0 1 0 8.218 2.74l-0.222 -0.073a1.653 1.653 0 0 1 -0.541 0.911 1.646 1.646 0 0 1 -1.577 0.314l-0.002 0 -1.258 -0.405a1.636 1.636 0 0 1 -1.08 -1.117l-0.339 -1.163 -2.413 -0.777a1.978 1.978 0 0 1 -0.786 -0.43Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.708 3.507A5.659 5.659 0 0 0 0.173 9.73h3.195a1.359 1.359 0 0 0 1.359 -1.36V7.25a1.359 1.359 0 0 1 1.359 -1.404c0.05 0 0.1 -0.003 0.149 -0.008l-0.328 -1.123 -2.413 -0.777a1.979 1.979 0 0 1 -0.786 -0.43Zm8.33 6.614 -0.947 -0.694a2.776 2.776 0 0 0 -1.239 -0.31H7.215a1.35 1.35 0 0 0 0 2.688 0.953 0.953 0 0 1 0.962 0.95v0.657a5.68 5.68 0 0 0 2.86 -3.29Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.772 1.527 12.7 1.163a0.364 0.364 0 0 0 -0.418 0.139l-0.782 1.21L7.213 0.37a2.668 2.668 0 0 0 -3.868 1.403 0.729 0.729 0 0 0 0.503 0.965l2.797 0.9 0.279 0.097 0.525 1.8a0.386 0.386 0 0 0 0.257 0.268l1.265 0.407a0.397 0.397 0 0 0 0.514 -0.44l-0.278 -1.339h0.182l2.732 0.89a0.718 0.718 0 0 0 0.911 -0.44l0.965 -2.968a0.364 0.364 0 0 0 -0.225 -0.386Z" }),
    " "
  ] }) }),
  "EarthAirplane"
);
var EmergencyExit = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.13347 0.0657959c-0.78379 0 -1.41918 0.6353891 -1.41918 1.4191841v2.64396c0.28049 0.03395 0.55349 0.10722 0.81126 0.2166 0.36615 -1.16967 1.45831 -2.01839 2.74869 -2.01839 1.59042 0 2.87976 1.28929 2.87976 2.87971 0 0.8308 -0.3519 1.57942 -0.9146 2.10502 0.8315 0.24245 1.4391 1.0104 1.4391 1.92027 0 1.10455 -0.8954 2.00005 -1.99994 2.00005l-1.37138 0c-0.17953 0 -0.35739 -0.0161 -0.53167 -0.0475 0.00677 0.082 0.0102 0.1645 0.0102 0.2474V13.25c0 0.2404 -0.0424 0.4708 -0.12014 0.6843h4.90213c0.7838 0 1.4192 -0.6354 1.4192 -1.4192V1.48498c0 -0.783795 -0.6354 -1.4191841 -1.4192 -1.4191841H6.13347Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.64453 5.20686c0 -0.90007 0.72965 -1.62971 1.62971 -1.62971s1.62971 0.72964 1.62971 1.62971c0 0.90006 -0.72965 1.62971 -1.62971 1.62971s-1.62971 -0.72965 -1.62971 -1.62971Zm0.08214 1.62083 1.4929 1.4929c0.02344 0.02344 0.05524 0.03661 0.08839 0.03661l1.37138 -0.00002c0.48326 -0.00001 0.87496 0.39174 0.87506 0.87498 0 0.48325 -0.3918 0.87504 -0.87503 0.87504l-1.37138 0c-0.49729 0 -0.97422 -0.19754 -1.32586 -0.54918l-0.87418 -0.87417 -0.70942 0.70942 0.71301 0.71303c0.35163 0.3516 0.54917 0.8285 0.54917 1.3258v1.5677c0 0.4832 -0.39175 0.875 -0.875 0.875s-0.875 -0.3918 -0.875 -0.875v-1.5677c0 -0.0331 -0.01317 -0.0649 -0.03661 -0.0884l-0.72526 -0.7252C3.8246 10.8646 3.42686 11 3.01517 11H1c-0.483249 0 -0.875 -0.3918 -0.875 -0.875 0 -0.48327 0.391751 -0.87502 0.875 -0.87502h2.01517c0.03315 0 0.06494 -0.01317 0.08839 -0.03661l1.76696 -1.76696 -0.4276 -0.4276c-0.02344 -0.02344 -0.05523 -0.03661 -0.08839 -0.03661l-1.81804 -0.00002c-0.48325 -0.00001 -0.875 -0.39176 -0.87499 -0.87501 0 -0.48325 0.39176 -0.875 0.87501 -0.87499l1.81805 0.00002c0.49727 0.00001 0.97417 0.19755 1.3258 0.54917l1.04631 1.04632Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "EmergencyExit"
);
var Fragile = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.938 4.5c0 2.588 1.735 4.1 4.062 4.431v3.045H4.165a1 1 0 1 0 0 2h2.833l0.002 0 0.002 0h2.833a1 1 0 1 0 0 -2H8V8.93c2.327 -0.33 4.063 -1.843 4.063 -4.431L11.871 1a1.136 1.136 0 0 0 -1.125 -1H3.254a1.136 1.136 0 0 0 -1.125 1.001L1.937 4.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.534 0a0.691 0.691 0 0 1 -0.008 0.014L6.318 1.89 7.91 3.282c0.224 0.196 0.28 0.523 0.131 0.781l-1 1.747a0.625 0.625 0 0 1 -1.084 -0.62l0.745 -1.303 -1.614 -1.41a0.625 0.625 0 0 1 -0.114 -0.81L6.048 0h1.486Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Fragile"
);
var GasStationFuelPetroleum = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.723 0.859a0.625 0.625 0 0 1 0 0.883l-0.793 0.793v2.17a0.625 0.625 0 0 1 -0.473 0.606l-1.479 0.37v0.987a0.35 0.35 0 0 0 0.351 0.351 2.577 2.577 0 0 1 0 5.154H8.401a0.625 0.625 0 1 1 0 -1.25h2.928a1.327 1.327 0 0 0 0 -2.654 1.601 1.601 0 0 1 -1.6 -1.6v-1.47l0 -0.015v-0.956c0 -0.165 0.065 -0.324 0.182 -0.442L12.84 0.86a0.625 0.625 0 0 1 0.884 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.594 1.288a2.5 2.5 0 0 0 -2.5 2.5V12.5a1.5 1.5 0 0 0 1.5 1.5H7.4a1.5 1.5 0 0 0 1.5 -1.5V3.788a2.5 2.5 0 0 0 -2.5 -2.5H2.594Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.094 4.88v2.264H7.9V4.881H1.094Zm5.493 5.204a0.625 0.625 0 1 0 -1.25 0v0.976a0.625 0.625 0 1 0 1.25 0v-0.976Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GasStationFuelPetroleum"
);
var HighSpeedTrainFront = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.3869 12.4777c-0.2929 -0.2929 -0.2929 -0.7678 0 -1.0607 0.2929 -0.2929 0.7677 -0.2929 1.0606 0l1.3027 1.3027c0.2929 0.2928 0.2929 0.7677 0 1.0606 -0.2929 0.2929 -0.7678 0.2929 -1.0607 0l-1.3026 -1.3026Zm-8.95526 0.1814c0.29289 -0.2929 0.2929 -0.7677 0 -1.0606 -0.29289 -0.2929 -0.76776 -0.2929 -1.06066 0L0.249801 12.7196c-0.2928949 0.2929 -0.2928977 0.7678 -0.000006 1.0607 0.292891 0.2929 0.767765 0.2929 1.060655 0l1.12119 -1.1212Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.81972 0.00756836c-1.64691 0 -3.20066 0.35175664 -4.35601 1.19323164C1.2848 2.05943 0.575684 3.3891 0.575684 5.20286c0 1.78341 0.683036 3.72938 1.778166 5.23364 1.09067 1.4981 2.65874 2.6446 4.46587 2.6446s3.37518 -1.1465 4.46588 -2.6446c1.0951 -1.50426 1.7782 -3.45023 1.7782 -5.23364 0 -1.81376 -0.7092 -3.14343 -1.8881 -4.00206C10.0204 0.359325 8.46663 0.00756836 6.81972 0.00756836Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.72644 4.24621c0 -0.97814 0.79294 -1.77108 1.77108 -1.77108h4.64817c0.97811 0 1.77111 0.79294 1.77111 1.77108 0 0.97813 -0.793 1.77107 -1.77111 1.77107H4.49752c-0.97814 0 -1.77108 -0.79294 -1.77108 -1.77107Zm4.09581 3.75048c1.89068 0 3.53795 0.76456 4.39895 2.52711 -1.0876 1.4552 -2.62964 2.5573 -4.40149 2.5573 -1.77018 0 -3.31098 -1.1001 -4.39838 -2.5532 0.86039 -1.76547 2.50877 -2.53121 4.40092 -2.53121Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HighSpeedTrainFront"
);
var HotSpring = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.852 6.92a0.75 0.75 0 0 1 1.06 -0.033 3.426 3.426 0 0 1 1.065 2.187 0.73 0.73 0 0 1 0.003 0.066c0 1.33 -0.996 2.363 -2.22 3.02 -1.257 0.672 -2.94 1.066 -4.76 1.066 -1.818 0 -3.502 -0.391 -4.758 -1.062C1.017 11.511 0.02 10.482 0.02 9.15a3.41 3.41 0 0 1 1.067 -2.262 0.75 0.75 0 1 1 1.028 1.092 1.923 1.923 0 0 0 -0.594 1.2c0.015 0.503 0.417 1.122 1.427 1.661 0.999 0.533 2.43 0.885 4.052 0.885 1.621 0 3.052 -0.354 4.05 -0.889 1.01 -0.54 1.413 -1.162 1.43 -1.666a1.91 1.91 0 0 0 -0.594 -1.19 0.75 0.75 0 0 1 -0.034 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.311 1.477a0.75 0.75 0 0 1 0.092 1.057c-0.335 0.398 -0.418 0.793 -0.374 1.247 0.05 0.501 0.249 1.038 0.5 1.695l0.017 0.045c0.23 0.602 0.504 1.318 0.575 2.04 0.077 0.786 -0.083 1.602 -0.718 2.358a0.75 0.75 0 1 1 -1.148 -0.965c0.334 -0.398 0.418 -0.794 0.373 -1.248 -0.049 -0.5 -0.249 -1.037 -0.5 -1.694l-0.017 -0.045c-0.23 -0.603 -0.504 -1.318 -0.575 -2.04 -0.077 -0.787 0.083 -1.603 0.719 -2.359a0.75 0.75 0 0 1 1.056 -0.09Zm-2.9 0.923a0.75 0.75 0 0 1 0.091 1.057c-0.378 0.45 -0.404 0.734 -0.377 0.931 0.036 0.267 0.186 0.537 0.446 0.97l0.027 0.045c0.224 0.372 0.537 0.892 0.62 1.495 0.094 0.697 -0.123 1.393 -0.716 2.098a0.75 0.75 0 0 1 -1.148 -0.965c0.378 -0.45 0.404 -0.734 0.377 -0.931 -0.036 -0.267 -0.186 -0.537 -0.446 -0.97l-0.027 -0.045c-0.224 -0.372 -0.537 -0.893 -0.62 -1.495 -0.094 -0.698 0.123 -1.394 0.716 -2.099a0.75 0.75 0 0 1 1.057 -0.09Zm6.114 0.964a0.75 0.75 0 0 0 -1.281 -0.78c-0.429 0.706 -0.562 1.357 -0.5 1.978 0.055 0.566 0.271 1.063 0.437 1.445l0.016 0.036c0.183 0.421 0.305 0.718 0.336 1.029 0.027 0.273 -0.016 0.603 -0.29 1.052a0.75 0.75 0 1 0 1.282 0.779c0.429 -0.705 0.561 -1.356 0.5 -1.977 -0.055 -0.566 -0.271 -1.064 -0.437 -1.445l-0.016 -0.036c-0.183 -0.422 -0.305 -0.719 -0.336 -1.03 -0.027 -0.273 0.016 -0.602 0.29 -1.051Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotSpring"
);
var HotelAirConditioner = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0C0.706 0 0 0.607 0 1.43v4.654c0 0.824 0.706 1.43 1.5 1.43h11c0.794 0 1.5 -0.606 1.5 -1.43V1.431C14 0.607 13.294 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.793 7.5V6a0.967 0.967 0 0 0 -0.314 -0.707 1.115 1.115 0 0 0 -0.76 -0.293H3.28c-0.284 0 -0.557 0.105 -0.759 0.293A0.967 0.967 0 0 0 2.207 6v1.5" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 8.999a0.75 0.75 0 0 1 0.75 0.75v1.1a2.15 2.15 0 0 1 -2.15 2.15h-0.1a0.75 0.75 0 0 1 0 -1.5h0.1a0.65 0.65 0 0 0 0.65 -0.65v-1.1a0.75 0.75 0 0 1 0.75 -0.75Zm6 0a0.75 0.75 0 0 0 -0.75 0.75v1.1a2.15 2.15 0 0 0 2.15 2.15h0.1a0.75 0.75 0 0 0 0 -1.5h-0.1a0.65 0.65 0 0 1 -0.65 -0.65v-1.1a0.75 0.75 0 0 0 -0.75 -0.75Zm-2.25 0.75a0.75 0.75 0 0 0 -1.5 0v3.5a0.75 0.75 0 0 0 1.5 0v-3.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelAirConditioner"
);
var HotelBed2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.54 0.046C0.714 0.046 0.045 0.715 0.045 1.54v10.922c0 0.824 0.669 1.493 1.493 1.493H12.46c0.824 0 1.493 -0.669 1.493 -1.493V1.539c0 -0.824 -0.669 -1.493 -1.493 -1.493H1.539Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.54 0.046C0.714 0.046 0.045 0.715 0.045 1.54V6h13.908V1.54c0 -0.825 -0.669 -1.494 -1.493 -1.494H1.539Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.314 2.569v0.979a1 1 0 0 1 -1 1H2.63a1 1 0 0 1 -1 -1v-0.979a1 1 0 0 1 1 -1h2.685a1 1 0 0 1 1 1Zm6.057 0v0.979a1 1 0 0 1 -1 1H8.686a1 1 0 0 1 -1 -1v-0.979a1 1 0 0 1 1 -1h2.685a1 1 0 0 1 1 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelBed2"
);
var HotelLaundry = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5V3h12V1.5A1.5 1.5 0 0 0 11.5 0h-9Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.892a3.607 3.607 0 1 0 0 7.215 3.607 3.607 0 0 0 0 -7.215Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.995 7.783a0.5 0.5 0 0 0 -0.493 0.417 2.547 2.547 0 0 0 5.024 0.848 0.5 0.5 0 0 0 -0.493 -0.582h-0.497c-0.753 0 -1.134 -0.147 -1.51 -0.304l-0.06 -0.025c-0.404 -0.167 -0.852 -0.354 -1.617 -0.354h-0.354Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelLaundry"
);
var HotelOneStar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.046A1.671 1.671 0 0 0 5.584 0.83l-1.8 2.847 -2.274 0.279a1.652 1.652 0 0 0 -1.065 2.72l0.002 0.001L2.38 8.894l-0.626 3.084 -0.001 0.003a1.661 1.661 0 0 0 0.653 1.662l0.006 0.004a1.682 1.682 0 0 0 1.78 0.1L7 12.208l2.807 1.536a1.682 1.682 0 0 0 1.78 -0.099l0.006 -0.004a1.661 1.661 0 0 0 0.653 -1.662l0 -0.003 -0.627 -3.084 1.933 -2.217 0.002 -0.002a1.65 1.65 0 0 0 -1.065 -2.719l-2.274 -0.279L8.416 0.831l0 -0.001A1.671 1.671 0 0 0 7 0.046Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.234c0.345 0 0.625 0.28 0.625 0.625l0 3.663h0.805a0.625 0.625 0 1 1 0 1.25H5.57a0.625 0.625 0 0 1 0 -1.25h0.805l0 -2.026c-0.142 0.04 -0.292 0.06 -0.447 0.06H5.57a0.625 0.625 0 1 1 0 -1.25h0.358c0.247 0 0.447 -0.2 0.447 -0.447 0 -0.346 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelOneStar"
);
var HotelShowerHead = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 8.48755c0.41421 0 0.75 0.33579 0.75 0.75v0.99995c0 0.4143 -0.33579 0.75 -0.75 0.75s-0.75 -0.3357 -0.75 -0.75v-0.99995c0 -0.41421 0.33579 -0.75 0.75 -0.75ZM3.5 11.4875c0.41421 0 0.75 0.3358 0.75 0.75v1c0 0.4143 -0.33579 0.75 -0.75 0.75s-0.75 -0.3357 -0.75 -0.75v-1c0 -0.4142 0.33579 -0.75 0.75 -0.75Zm4.25 0.75c0 -0.4142 -0.33579 -0.75 -0.75 -0.75s-0.75 0.3358 -0.75 0.75v1c0 0.4143 0.33579 0.75 0.75 0.75s0.75 -0.3357 0.75 -0.75v-1Zm2.75 -0.75c0.4142 0 0.75 0.3358 0.75 0.75v1c0 0.4143 -0.3358 0.75 -0.75 0.75s-0.75 -0.3357 -0.75 -0.75v-1c0 -0.4142 0.3358 -0.75 0.75 -0.75Zm-0.75 -2.24995c0 -0.41421 -0.33579 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v0.99995c0 0.4143 0.33579 0.75 0.75 0.75s0.75 -0.3357 0.75 -0.75v-0.99995Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 0.762451c0 -0.414213 -0.33579 -0.7499998 -0.75 -0.7499998S6.25 0.348238 6.25 0.762451V2.07671c-0.91523 0.15471 -1.76696 0.59009 -2.43198 1.2551C2.97411 4.17573 2.5 5.32032 2.5 6.51379c0 0.27615 0.22386 0.5 0.5 0.5h8c0.1326 0 0.2598 -0.05267 0.3536 -0.14644 0.0937 -0.09377 0.1464 -0.22095 0.1464 -0.35356 0 -1.19347 -0.4741 -2.33806 -1.318 -3.18198 -0.66504 -0.66501 -1.51677 -1.10039 -2.432 -1.2551V0.762451Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelShowerHead"
);
var HotelTwoStar = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.046A1.671 1.671 0 0 0 5.584 0.83l-1.8 2.847 -2.274 0.279a1.652 1.652 0 0 0 -1.065 2.72l0.002 0.001L2.38 8.894l-0.626 3.084 -0.001 0.003a1.662 1.662 0 0 0 0.653 1.662l0.006 0.004a1.681 1.681 0 0 0 1.78 0.1L7 12.208l2.807 1.536a1.682 1.682 0 0 0 1.78 -0.099l0.006 -0.004a1.662 1.662 0 0 0 0.653 -1.662l0 -0.003 -0.627 -3.084 1.933 -2.217 0.002 -0.002a1.65 1.65 0 0 0 -1.065 -2.719l-2.274 -0.279L8.416 0.831l0 -0.001A1.671 1.671 0 0 0 7 0.046Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.042 5.757a1.698 1.698 0 0 1 1.6 -1.132h0.743a1.67 1.67 0 0 1 0.67 3.199l-1.592 0.696a0.447 0.447 0 0 0 -0.267 0.394H8.43a0.625 0.625 0 1 1 0 1.25H5.57a0.625 0.625 0 0 1 -0.625 -0.625v-0.61c0 -0.674 0.4 -1.284 1.017 -1.554l1.591 -0.696a0.42 0.42 0 0 0 -0.168 -0.804h-0.742a0.448 0.448 0 0 0 -0.422 0.298 0.625 0.625 0 1 1 -1.179 -0.416Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HotelTwoStar"
);
var InformationDeskCustomer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.295 3.246a1.623 1.623 0 1 0 0 -3.246 1.623 1.623 0 0 0 0 3.246Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.59 6.493a2.705 2.705 0 1 1 5.41 0 0.27 0.27 0 0 1 -0.27 0.27H8.86a0.27 0.27 0 0 1 -0.27 -0.27Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.348 6.496a0.75 0.75 0 0 1 0.75 -0.75l6.152 0a0.75 0.75 0 0 1 0 1.5l-6.152 0a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.359 3.324a1.811 1.811 0 1 0 3.622 0 1.811 1.811 0 0 0 -3.622 0Zm-0.43 3.454A3.17 3.17 0 0 0 0 9.018v0.86a0.5 0.5 0 0 0 0.5 0.5h0.859l0.398 3.184a0.5 0.5 0 0 0 0.496 0.438h1.834a0.5 0.5 0 0 0 0.496 -0.438l0.398 -3.185h0.859a0.5 0.5 0 0 0 0.5 -0.5V9.02A3.17 3.17 0 0 0 0.928 6.778Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InformationDeskCustomer"
);
var InformationDesk = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.09 2.735a4.055 4.055 0 0 1 7.844 1.442 4.054 4.054 0 0 1 -6.528 3.211A3.686 3.686 0 0 0 6.09 2.735Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.813 2.93c-0.275 -0.03 -0.665 -0.238 -0.665 -0.71 0 -0.512 0.46 -0.712 0.733 -0.712 0.024 0 0.048 0.002 0.07 0.004 0.275 0.03 0.666 0.237 0.666 0.709 0 0.512 -0.461 0.712 -0.734 0.712a0.633 0.633 0 0 1 -0.07 -0.004Zm0.068 0.87c0.345 0 0.625 0.28 0.625 0.626l0 1.795a0.625 0.625 0 0 1 -1.25 0l0 -1.795c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.065 8.259a2.44 2.44 0 1 0 0 -4.879 2.44 2.44 0 0 0 0 4.879Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 13.137a4.065 4.065 0 1 1 8.13 0 0.407 0.407 0 0 1 -0.406 0.407H0.407A0.407 0.407 0 0 1 0 13.137Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.02 13.214a0.75 0.75 0 0 1 0.75 -0.75h12.462a0.75 0.75 0 0 1 0 1.5H0.77a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InformationDesk"
);
var LiftDisability = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.099 2.518a1.741 1.741 0 1 0 0 3.483 1.741 1.741 0 0 0 0 -3.483ZM6.1 6.486a1 1 0 0 1 1 1v1.482h0.93a1.965 1.965 0 0 1 1.965 1.965v2.013a1 1 0 1 1 -2 0v-1.978H6.1a1 1 0 0 1 -1 -1V7.486a1 1 0 0 1 1 -1ZM3.69 8.11a0.75 0.75 0 0 0 -0.001 -1.5 3.645 3.645 0 1 0 2.307 6.469 0.75 0.75 0 1 0 -0.949 -1.162A2.146 2.146 0 1 1 3.69 8.11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.146 0.146a0.5 0.5 0 0 1 0.708 0l2 2A0.5 0.5 0 0 1 13.5 3h-4a0.5 0.5 0 0 1 -0.354 -0.854l2 -2ZM9.038 5.31A0.5 0.5 0 0 1 9.5 5h4a0.5 0.5 0 0 1 0.354 0.854l-2 2a0.5 0.5 0 0 1 -0.707 0l-2 -2a0.5 0.5 0 0 1 -0.109 -0.545Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LiftDisability"
);
var Lift = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.601 3.093a0.5 0.5 0 0 0 -0.707 0L8.642 5.345a0.5 0.5 0 0 0 0.354 0.853H13.5a0.5 0.5 0 0 0 0.354 -0.853L11.6 3.093ZM8.534 9.11a0.5 0.5 0 0 1 0.462 -0.308H13.5a0.5 0.5 0 0 1 0.354 0.853L11.6 11.907a0.5 0.5 0 0 1 -0.707 0L8.642 9.655a0.5 0.5 0 0 1 -0.108 -0.545Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.584 2.03a2.03 2.03 0 1 1 -4.061 0 2.03 2.03 0 0 1 4.061 0Zm0.483 3.873a3.554 3.554 0 0 1 1.04 2.512V9.44a0.5 0.5 0 0 1 -0.5 0.5H5.585l-0.452 3.623a0.5 0.5 0 0 1 -0.497 0.438H2.472a0.5 0.5 0 0 1 -0.496 -0.438L1.523 9.94H0.5a0.5 0.5 0 0 1 -0.5 -0.5V8.415a3.554 3.554 0 0 1 6.067 -2.512Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Lift"
);
var LocationCompass1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.74 4.892a0.5 0.5 0 0 0 -0.632 -0.632L3.576 6.104a0.5 0.5 0 0 0 -0.1 0.903l2.199 1.318 1.318 2.198a0.5 0.5 0 0 0 0.903 -0.099L9.74 4.892Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LocationCompass1"
);
var LocationPin3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.007 9.506a0.5 0.5 0 0 0 -0.46 0.303L0.05 13.304A0.5 0.5 0 0 0 0.51 14h12.98a0.5 0.5 0 0 0 0.46 -0.697l-1.498 -3.495a0.5 0.5 0 0 0 -0.46 -0.303H2.007Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0C4.378 0 2.194 2.183 2.194 4.804c0 0.856 0.294 1.7 0.705 2.464 0.413 0.768 0.959 1.484 1.501 2.094a15.626 15.626 0 0 0 1.521 1.49c0.214 0.181 0.401 0.328 0.546 0.433 0.07 0.05 0.138 0.096 0.195 0.13a1.038 1.038 0 0 0 0.174 0.083 0.54 0.54 0 0 0 0.405 -0.03 1.05 1.05 0 0 0 0.098 -0.054c0.058 -0.034 0.125 -0.08 0.196 -0.132 0.144 -0.105 0.331 -0.253 0.545 -0.435 0.428 -0.366 0.977 -0.884 1.52 -1.496 0.542 -0.612 1.088 -1.33 1.5 -2.095 0.411 -0.762 0.706 -1.603 0.706 -2.452C11.806 2.184 9.621 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 6.24a1.435 1.435 0 1 0 0 -2.87 1.435 1.435 0 0 0 0 2.87Z" }),
    " "
  ] }) }),
  "LocationPin3"
);
var LocationPinDisabled = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.063 6.047C1.063 2.72 3.712 0.004 7 0.004c3.288 0 5.938 2.715 5.938 6.043 0 1.988 -0.986 3.7 -2.094 5.004 -1.112 1.307 -2.39 2.252 -3.077 2.714a1.368 1.368 0 0 1 -1.534 0c-0.686 -0.462 -1.965 -1.407 -3.077 -2.714 -1.108 -1.303 -2.094 -3.016 -2.094 -5.004ZM9 5.502a2 2 0 0 1 -2 2l-2 -2a2 2 0 1 1 4 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 1 1.06 0l12.5 12.5a0.75 0.75 0 1 1 -1.06 1.06L0.22 1.28a0.75 0.75 0 0 1 0 -1.06Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LocationPinDisabled"
);
var LocationTarget1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 5.77a1.23 1.23 0 1 0 0 2.46 1.23 1.23 0 0 0 0 -2.46Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.016a0.75 0.75 0 0 1 0.75 0.75v1.223a5.07 5.07 0 0 1 4.26 4.261h1.224a0.75 0.75 0 0 1 0 1.5h-1.223a5.07 5.07 0 0 1 -4.261 4.26v1.224a0.75 0.75 0 0 1 -1.5 0v-1.223A5.07 5.07 0 0 1 1.99 7.75H0.765a0.75 0.75 0 0 1 0 -1.5h1.223A5.07 5.07 0 0 1 6.25 1.99V0.765A0.75 0.75 0 0 1 7 0.016Zm0 3.418a3.566 3.566 0 0 1 3.566 3.56l0 0.006 0 0.006a3.566 3.566 0 0 1 -3.56 3.56l-0.006 0 -0.006 0A3.566 3.566 0 0 1 7 3.434Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LocationTarget1"
);
var LostAndFound = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 1.75A1.75 1.75 0 0 0 5.25 3.5h3.5A1.75 1.75 0 0 0 7 1.75Zm-2.298 -0.548A3.25 3.25 0 0 0 3.75 3.5H2.5A2.5 2.5 0 0 0 0 6v5.5A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5V6a2.5 2.5 0 0 0 -2.5 -2.5h-1.25a3.25 3.25 0 0 0 -5.548 -2.298Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.17 6.517a0.875 0.875 0 0 0 -1.045 0.858 0.625 0.625 0 1 1 -1.25 0 2.125 2.125 0 1 1 2.75 2.031v0.469a0.625 0.625 0 1 1 -1.25 0v-1c0 -0.345 0.28 -0.625 0.625 -0.625a0.875 0.875 0 0 0 0.17 -1.733Zm-0.918 5.608a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 0 0 -1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LostAndFound"
);
var MapFold = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.62918 12.9231 -3.40259 0.7915C0.599519 13.8605 0 13.3845 0 12.7407V1.87099C0 1.406 0.320514 1.00236 0.773413 0.896998L4.62918 0v12.9231Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.62918 12.9231 9.3708 14V1.07692L4.62918 0v12.9231Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 12.129c0 0.465 -0.3205 0.8686 -0.7734 0.974L9.3708 14V1.07692l3.4026 -0.791571C13.4005 0.13947 14 0.615527 14 1.25934V12.129Z" }),
    " "
  ] }) }),
  "MapFold"
);
var ParachuteDrop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.478 0.66C4.601 0.145 5.811 0 6.985 0c1.171 0 2.393 0.135 3.523 0.653a7.36 7.36 0 0 1 2.837 2.296 0.97 0.97 0 0 1 0.013 1.032 1 1 0 0 1 -0.81 0.517l-2.467 3.229a0.75 0.75 0 0 1 -1.192 -0.911l1.77 -2.316H7.735v2.771a0.75 0.75 0 1 1 -1.5 0V4.5H3.311l1.77 2.316a0.75 0.75 0 1 1 -1.192 0.91L1.42 4.497a1 1 0 0 1 -0.778 -0.516 0.97 0.97 0 0 1 0.034 -1.06A7.36 7.36 0 0 1 3.478 0.66Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.829 6.771c-0.806 0 -1.458 0.653 -1.458 1.459v4.312c0 0.805 0.652 1.458 1.458 1.458H9.14c0.805 0 1.458 -0.653 1.458 -1.458V8.23c0 -0.806 -0.653 -1.459 -1.458 -1.459H4.83Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.94 11.927c0 -0.345 0.28 -0.625 0.625 -0.625h1a0.625 0.625 0 0 1 0 1.25h-1a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ParachuteDrop"
);
var ParkingSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 0C1.567 0 0 1.567 0 3.5v7C0 12.433 1.567 14 3.5 14h7c1.933 0 3.5 -1.567 3.5 -3.5v-7C14 1.567 12.433 0 10.5 0h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.7671 3.30031c0.11721 -0.11721 0.27619 -0.18306 0.44195 -0.18306h3.1848c1.1736 0 2.12495 0.95139 2.12495 2.125v1.0992c0 1.17361 -0.95135 2.125 -2.12495 2.125h-2.5598v2.30305c0 0.3451 -0.27983 0.625 -0.625 0.625 -0.34518 0 -0.625 -0.2799 -0.625 -0.625V3.74225c0 -0.16576 0.06584 -0.32473 0.18305 -0.44194Zm1.06695 3.91614h2.5598c0.48325 0 0.875 -0.39175 0.875 -0.875v-1.0992c0 -0.48325 -0.39175 -0.875 -0.875 -0.875h-2.5598v2.8492Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ParkingSign"
);
var Passport = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0C1.67157 0 1 0.671573 1 1.5v11c0 0.8284 0.67157 1.5 1.5 1.5h9c0.8284 0 1.5 -0.6716 1.5 -1.5v-11c0 -0.828427 -0.6716 -1.5 -1.5 -1.5h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.49999 2.63638C5.02238 2.85413 3.85411 4.02239 3.63635 5.5h2.86364V2.63638ZM3.63635 6.5c0.21776 1.47761 1.38603 2.64587 2.86364 2.86362V6.5H3.63635Zm3.86364 2.86361C8.97758 9.14584 10.1458 7.97759 10.3636 6.5H7.49999v2.86361ZM10.3636 5.5H7.49999V2.63639C8.97758 2.85416 10.1458 4.02241 10.3636 5.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Passport"
);
var PetsAllowed = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.111 1.909c-0.821 0 -1.573 0.464 -1.94 1.199l-1.32 2.639H4.036a3.588 3.588 0 0 1 -2.242 -0.787L0.446 3.882a0.25 0.25 0 0 0 -0.406 0.196v8.155a1.69 1.69 0 1 0 3.378 0v-0.48a0.71 0.71 0 0 1 0.71 -0.709h1.919a0.71 0.71 0 0 1 0.71 0.71v0.48a1.69 1.69 0 1 0 3.378 0v-3.59h1.668a2.169 2.169 0 0 0 2.17 -2.169v-0.96a0.25 0.25 0 0 0 -0.171 -0.236l-2.708 -0.903V2.16a0.25 0.25 0 0 0 -0.25 -0.25h-0.733Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.135 8.647C9.11 8.43 8.35 7.853 7.799 7.173a5.662 5.662 0 0 1 -0.884 -1.554l-0.063 0.128H5.637a6.913 6.913 0 0 0 1.19 2.213c0.737 0.909 1.818 1.72 3.308 1.958v-1.27Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PetsAllowed"
);
var PoolLadder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.46 11.134a0.5 0.5 0 0 0 -0.922 0.005 1.85 1.85 0 0 1 -1.18 1.063 0.5 0.5 0 0 0 -0.358 0.479v0.819a0.5 0.5 0 0 0 0.5 0.5h13a0.5 0.5 0 0 0 0.5 -0.5v-0.82a0.5 0.5 0 0 0 -0.357 -0.479 1.85 1.85 0 0 1 -1.181 -1.062 0.5 0.5 0 0 0 -0.922 -0.005 1.99 1.99 0 0 1 -0.805 0.922c-0.69 0.414 -1.78 0.414 -2.47 0a1.99 1.99 0 0 1 -0.805 -0.922 0.5 0.5 0 0 0 -0.92 0 1.99 1.99 0 0 1 -0.805 0.922c-0.69 0.414 -1.78 0.414 -2.47 0a1.99 1.99 0 0 1 -0.805 -0.922Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.781 1.865a1.166 1.166 0 0 1 1.99 0.825v1.914l0 0.001 0 0.002v2.87l0 0.002 0 0.002V8.82a0.75 0.75 0 0 0 1.5 0v-0.591h3.29v0.463a0.75 0.75 0 0 0 1.5 0V2.69A2.666 2.666 0 0 0 9.394 0.024a0.75 0.75 0 0 0 0 1.5A1.166 1.166 0 0 1 10.56 2.69v1.165H7.271V2.69a2.666 2.666 0 1 0 -5.331 0 0.75 0.75 0 1 0 1.5 0c0 -0.31 0.122 -0.606 0.341 -0.825Zm6.78 4.864V5.355H7.27V6.73h3.29Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PoolLadder"
);
var ProductionBelt = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M10.6586 1.12439H3.22473c-0.37324 0 -0.67581 0.26989 -0.67581 0.60281v6.63092c0 0.33293 0.30257 0.60282 0.67581 0.60282h7.43387c0.3733 0 0.6758 -0.26989 0.6758 -0.60282V1.7272c0 -0.33292 -0.3025 -0.60281 -0.6758 -0.60281Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.29354 1.12439v3.01406c0 0.07993 -0.0356 0.1566 -0.09897 0.21312 -0.06337 0.05653 -0.14932 0.08828 -0.23894 0.08828H5.92821c-0.08962 0 -0.17557 -0.03175 -0.23894 -0.08828 -0.06337 -0.05652 -0.09897 -0.13319 -0.09897 -0.21312V1.12439" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.64563 8.96094h8.70867c1.3517 0 2.4476 1.09586 2.4476 2.44766s-1.0959 2.4476 -2.4476 2.4476H2.64563c-1.35179 0 -2.447632 -1.0958 -2.447632 -2.4476S1.29384 8.96094 2.64563 8.96094Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.40732 11.4004c0 0.4832 -0.39175 0.875 -0.875 0.875s-0.875 -0.3918 -0.875 -0.875c0 -0.4833 0.39175 -0.875 0.875 -0.875s0.875 0.3917 0.875 0.875Zm3.47226 0c0 0.4832 -0.39176 0.875 -0.875 0.875 -0.48325 0 -0.875 -0.3918 -0.875 -0.875 0 -0.4833 0.39175 -0.875 0.875 -0.875 0.48324 0 0.875 0.3917 0.875 0.875Zm2.59722 0.875c0.4833 0 0.875 -0.3918 0.875 -0.875 0 -0.4833 -0.3917 -0.875 -0.875 -0.875 -0.48322 0 -0.87497 0.3917 -0.87497 0.875 0 0.4832 0.39175 0.875 0.87497 0.875Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ProductionBelt"
);
var SailShip = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.24592 0.499995c0 -0.21051 -0.13185 -0.398473 -0.32979 -0.4701356 -0.19794 -0.071663 -0.41956 -0.0116748 -0.55432 0.1500436l-5 5.999997c-0.12421 0.14904 -0.15098 0.35648 -0.06869 0.53217 0.08229 0.1757 0.25879 0.28793 0.4528 0.28793H5.75v2.5c0 0.41421 0.33579 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75l0 -7.74826c0 -0.02659 -0.00138 -0.05286 -0.00408 -0.07873V0.499995ZM9.3814 2.19557c-0.13042 -0.16992 -0.35457 -0.23789 -0.55739 -0.16902 -0.20282 0.06886 -0.33925 0.25926 -0.33925 0.47345v4c0 0.27614 0.22386 0.5 0.5 0.5h3.07014c0.1904 0 0.3643 -0.10812 0.4485 -0.27888 0.0842 -0.17077 0.0641 -0.37452 -0.0518 -0.52555l-3.0702 -4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.500003 9c-0.16399 0 -0.317555 0.08042 -0.410963 0.2152 -0.09340765 0.13479 -0.1147824 0.30681 -0.0572017 0.46036L1.04518 12.3778C1.41109 13.3536 2.34389 14 3.386 14h7.228c1.0421 0 1.9749 -0.6464 2.3408 -1.6222l1.0134 -2.70224c0.0575 -0.15355 0.0362 -0.32557 -0.0572 -0.46036C13.8176 9.08042 13.664 9 13.5 9H0.500003Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SailShip"
);
var SchoolBusSide = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.895 1.776a1.75 1.75 0 0 0 -1.75 1.75v6.957c0 0.888 0.72 1.608 1.608 1.608h10.963c0.69 0 1.25 -0.56 1.25 -1.25V7.456c0 -0.69 -0.56 -1.25 -1.25 -1.25h-0.25v-2.68a1.75 1.75 0 0 0 -1.75 -1.75h-8.82ZM1.645 4.5a0.25 0.25 0 0 1 0.25 -0.25h1.763l0 2H1.646l0 -1.75Zm3.513 1.75v-2h2.233v2H5.158Zm3.733 0h2.075V4.5a0.25 0.25 0 0 0 -0.25 -0.25H8.89v2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.896 4.25a0.25 0.25 0 0 0 -0.25 0.25l0 1.75h2.012l0 -2H1.896Zm2.62 7.62a1.261 1.261 0 1 1 -2.521 0 1.261 1.261 0 0 1 2.521 0Zm7.11 0a1.261 1.261 0 1 1 -2.522 0 1.261 1.261 0 0 1 2.522 0ZM5.158 6.25v-2h2.233v2H5.158Zm3.733 0h2.075V4.5a0.25 0.25 0 0 0 -0.25 -0.25H8.89v2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SchoolBusSide"
);
var ShipmentAdd = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 4.308v8.615A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923V4.308l1.615 -3.113A2.189 2.189 0 0 1 3.49 0h7.022a2.19 2.19 0 0 1 1.928 1.195L14 4.308Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.615 1.195 0 4.308h14l-1.562 -3.113A2.19 2.19 0 0 0 10.511 0H3.489a2.189 2.189 0 0 0 -1.874 1.195Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 4.308V0h1.25v4.308h-1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 6.75a0.75 0.75 0 0 0 -1.5 0V8.5H4.5a0.75 0.75 0 0 0 0 1.5h1.75v1.75a0.75 0.75 0 0 0 1.5 0V10H9.5a0.75 0.75 0 0 0 0 -1.5H7.75V6.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShipmentAdd"
);
var ShipmentCheck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 4.308v8.615A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923V4.308l1.615 -3.113A2.189 2.189 0 0 1 3.49 0h7.022a2.19 2.19 0 0 1 1.928 1.195L14 4.308Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.615 1.195 0 4.308h14l-1.562 -3.113A2.19 2.19 0 0 0 10.511 0H3.489a2.189 2.189 0 0 0 -1.874 1.195Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 4.308V0h1.25v4.308h-1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.5 7.173a0.625 0.625 0 0 1 0.125 0.875l-2.549 3.403a0.625 0.625 0 0 1 -0.874 0.126L4.5 10.302a0.625 0.625 0 0 1 0.75 -1l1.2 0.9 2.175 -2.903a0.625 0.625 0 0 1 0.875 -0.126Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShipmentCheck"
);
var ShipmentDownload = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 4.308v8.615A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923V4.308l1.615 -3.113A2.189 2.189 0 0 1 3.49 0h7.022a2.19 2.19 0 0 1 1.928 1.195L14 4.308Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.615 1.195 0 4.308h14l-1.562 -3.113A2.19 2.19 0 0 0 10.511 0H3.489a2.189 2.189 0 0 0 -1.874 1.195Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 4.308V0h1.25v4.308h-1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.953 6.375A0.625 0.625 0 0 0 6.328 7l0 2.405 -0.851 0a0.527 0.527 0 0 0 -0.373 0.9L6.58 11.78c0.206 0.206 0.54 0.206 0.746 0l1.476 -1.476a0.527 0.527 0 0 0 -0.373 -0.9l-0.851 0 0 -2.405a0.625 0.625 0 0 0 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShipmentDownload"
);
var ShipmentRemove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 4.308v8.615A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923V4.308l1.615 -3.113A2.189 2.189 0 0 1 3.49 0h7.022a2.19 2.19 0 0 1 1.928 1.195L14 4.308Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.615 1.195 0 4.308h14l-1.562 -3.113A2.19 2.19 0 0 0 10.511 0H3.489a2.189 2.189 0 0 0 -1.874 1.195Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 4.308V0h1.25v4.308h-1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.75 9a0.75 0.75 0 0 1 0.75 -0.75h5a0.75 0.75 0 0 1 0 1.5h-5A0.75 0.75 0 0 1 3.75 9Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShipmentRemove"
);
var ShipmentUpload = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 4.308v8.615A1.077 1.077 0 0 1 12.923 14H1.077A1.077 1.077 0 0 1 0 12.923V4.308l1.615 -3.113A2.189 2.189 0 0 1 3.49 0h7.022a2.19 2.19 0 0 1 1.928 1.195L14 4.308Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.615 1.195 0 4.308h14l-1.562 -3.113A2.19 2.19 0 0 0 10.511 0H3.489a2.189 2.189 0 0 0 -1.874 1.195Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 4.308V0h1.25v4.308h-1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.89 12.17a0.625 0.625 0 0 1 -0.625 -0.625l0 -2.407 -0.848 0a0.526 0.526 0 0 1 -0.373 -0.898l1.474 -1.474a0.526 0.526 0 0 1 0.745 0L8.736 8.24a0.526 0.526 0 0 1 -0.372 0.898l-0.849 0 0 2.407c0 0.345 -0.28 0.625 -0.625 0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShipmentUpload"
);
var ShippingBox1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.103 4.924V0H4.897v4.924c0 0.131 0.055 0.256 0.154 0.349a0.545 0.545 0 0 0 0.371 0.144h3.155c0.14 0 0.274 -0.052 0.372 -0.144a0.477 0.477 0 0 0 0.154 -0.349Zm0.281 5.55a0.625 0.625 0 0 0 0 1.25h2.014a0.625 0.625 0 0 0 0 -1.25H9.384Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShippingBox1"
);
var ShippingTruck = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.5 3.226a1.5 1.5 0 0 1 1.5 1.5v0.5h2.5a2.5 2.5 0 0 1 2.5 2.5v4a0.5 0.5 0 0 1 -0.5 0.5H0.5a0.5 0.5 0 0 1 -0.5 -0.5v-7a1.5 1.5 0 0 1 1.5 -1.5h6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m8.997 4.632 0 3.783a0.625 0.625 0 1 0 1.25 0v-3.19H9v-0.5a1.5 1.5 0 0 0 -0.003 -0.093Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.436 12.19a1.81 1.81 0 1 0 3.62 0 1.81 1.81 0 0 0 -3.62 0Zm-7.056 0a1.81 1.81 0 1 0 3.62 0 1.81 1.81 0 0 0 -3.62 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShippingTruck"
);
var Signage3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.0498 1.84054c-0.1021 -0.40142 -0.5103 -0.64406 -0.9117 -0.54194 -0.40143 0.10212 -0.64407 0.51033 -0.54195 0.91175l2.07455 8.15475H7.5c-0.41421 0 -0.75 0.3358 -0.75 0.75s0.33579 0.75 0.75 0.75h4.5522l0.3922 1.5418c0.1022 0.4014 0.5104 0.644 0.9118 0.5419 0.4014 -0.1021 0.6441 -0.5103 0.5419 -0.9118L11.0498 1.84054Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.67698 1.27539c-0.343 0 -0.64229 0.23269 -0.72685 0.5651L0.101832 13.037c-0.0570732 0.2243 -0.0073446 0.4625 0.134743 0.6452 0.142088 0.1828 0.360611 0.2897 0.592106 0.2897H7.47471c0.343 0 0.64229 -0.2327 0.72685 -0.5651L11.0499 2.2103c0.057 -0.22435 0.0073 -0.46249 -0.1348 -0.64525 -0.1421 -0.18276 -0.3606 -0.28966 -0.5921 -0.28966H3.67698Z" }),
    " "
  ] }) }),
  "Signage3"
);
var Signage4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.854 8.669a0.75 0.75 0 0 1 0.75 0.75l0 3.815a0.75 0.75 0 0 1 -1.5 0l0 -3.815a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.146 8.71a0.75 0.75 0 0 1 0.75 0.75v3.774a0.75 0.75 0 0 1 -1.5 0V9.46a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 0.613a0.5 0.5 0 0 1 0.5 -0.5h13a0.5 0.5 0 0 1 0.5 0.5v8.931a0.5 0.5 0 0 1 -0.5 0.5H0.5a0.5 0.5 0 0 1 -0.5 -0.5V0.614Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.625 0.113h-1.25V0.99h-0.042a0.625 0.625 0 1 0 0 1.25h0.659l0.008 0 0.008 0h0.659a0.625 0.625 0 1 0 0 -1.25h-0.042V0.113Zm6.75 0h1.25V0.99h0.042a0.625 0.625 0 1 1 0 1.25h-0.663l-0.004 0 -0.004 0h-0.662a0.625 0.625 0 1 1 0 -1.25h0.041V0.114Zm-4 0h1.25V0.99h0.042a0.625 0.625 0 1 1 0 1.25h-0.659L7 2.24l-0.008 0h-0.659a0.625 0.625 0 1 1 0 -1.25h0.042V0.113Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.375 6.851c0 -0.345 0.28 -0.625 0.625 -0.625l2.667 0a0.625 0.625 0 1 1 0 1.25L9 7.476a0.625 0.625 0 0 1 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Signage4"
);
var SmokingArea = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.2159 1.04668c-0.2157 -0.269542 -0.172 -0.66285 0.0976 -0.878481 0.2695 -0.2156305 0.6628 -0.1719296 0.8784 0.097609 0.5864 0.732923 0.7823 1.429702 0.6944 2.111042 -0.0786 0.60865 -0.3823 1.13959 -0.6169 1.54953l-0.0228 0.03995c-0.2628 0.45986 -0.4414 0.78913 -0.4853 1.12927 -0.0371 0.28741 0.017 0.65313 0.4306 1.17021 0.2157 0.26954 0.172 0.66284 -0.0976 0.87848 -0.2695 0.21563 -0.6628 0.17193 -0.8784 -0.09761 -0.5864 -0.73293 -0.7823 -1.4297 -0.6944 -2.11104 0.0786 -0.60865 0.3824 -1.13959 0.6169 -1.54953l0 -0.00001 0.0229 -0.03994c0.2627 -0.45986 0.4414 -0.78914 0.4852 -1.12927 0.0371 -0.28741 -0.017 -0.65314 -0.4306 -1.17021Zm-2.66996 0c-0.21563 -0.269542 -0.17193 -0.66285 0.09761 -0.878481 0.26954 -0.2156305 0.66285 -0.1719296 0.87845 0.097609 0.5864 0.732923 0.7823 1.429702 0.6943 2.111042 -0.0785 0.60865 -0.3823 1.13959 -0.6168 1.54953l-0.0229 0.03995c-0.2627 0.45986 -0.4414 0.78913 -0.4853 1.12927 -0.037 0.28741 0.0171 0.65313 0.4307 1.17021 0.2157 0.26954 0.172 0.66284 -0.0976 0.87848 -0.2695 0.21563 -0.66283 0.17193 -0.87846 -0.09761 -0.58634 -0.73293 -0.78223 -1.4297 -0.69432 -2.11104 0.07854 -0.60865 0.38231 -1.13959 0.61686 -1.54954l0.02285 -0.03994c0.26278 -0.45986 0.4414 -0.78914 0.48529 -1.12927 0.03708 -0.28741 -0.01702 -0.65314 -0.43068 -1.17021Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 13.875c-0.828426 0 -1.5 -0.6716 -1.5 -1.5v-2c0 -0.82843 0.671573 -1.5 1.5 -1.5H11v5H1.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.5 8.875c0.2761 0 0.5 0.22386 0.5 0.5v4c0 0.2761 -0.2239 0.5 -0.5 0.5H11v-5h2.5Z" }),
    " "
  ] }) }),
  "SmokingArea"
);
var Snorkle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.188 0.062a0.75 0.75 0 0 1 0.75 0.75v9.52a3.606 3.606 0 0 1 -3.606 3.606H8.428a3.606 3.606 0 0 1 -3.606 -3.606 0.75 0.75 0 1 1 1.5 0 2.106 2.106 0 0 0 2.106 2.106h1.904a2.106 2.106 0 0 0 2.106 -2.106V0.812a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.716 2.134A2.404 2.404 0 0 0 0.312 4.538v1.904a2.404 2.404 0 0 0 2.404 2.404h0.952a0.5 0.5 0 0 0 0.416 -0.222l1.113 -1.666a0.452 0.452 0 0 1 0.75 0L7.06 8.624a0.5 0.5 0 0 0 0.416 0.222h0.952a2.404 2.404 0 0 0 2.404 -2.404V4.538a2.404 2.404 0 0 0 -2.404 -2.404H2.716Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Snorkle"
);
var SteeringWheel = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.25 6c0 -0.41421 0.33579 -0.75 0.75 -0.75h10c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75H9.84375L7.75 9.14286V12.5c0 0.4142 -0.33579 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75V9.14286L4.15625 6.75H2c-0.41421 0 -0.75 -0.33579 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2C4.23858 2 2 4.23858 2 7s2.23858 5 5 5 5 -2.23858 5 -5 -2.23858 -5 -5 -5ZM0 7c0 -3.86599 3.13401 -7 7 -7 3.866 0 7 3.13401 7 7 0 3.866 -3.134 7 -7 7 -3.86599 0 -7 -3.134 -7 -7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SteeringWheel"
);
var StreetRoad = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.5 0c-0.23282 0 -0.43484 0.160705 -0.48719 0.38757L0.0128089 13.3876c-0.0342624 0.1484 0.0010463 0.3044 0.0959061 0.4237 0.09486 0.1192 0.238917 0.1887 0.39129 0.1887H13.5c0.1524 0 0.2964 -0.0695 0.3913 -0.1887 0.0949 -0.1193 0.1302 -0.2753 0.0959 -0.4237l-3 -13.00003C10.9348 0.160705 10.7328 0 10.5 0h-7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.625 14h-1.25v-2.1539c0 -0.3451 0.27982 -0.625 0.625 -0.625s0.625 0.2799 0.625 0.625l0 2.1539Zm0 -14h-1.25v2.15385c0 0.34517 0.27982 0.625 0.625 0.625s0.625 -0.27983 0.625 -0.625L7.625 0Zm0 5.92303c0 -0.34517 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27983 -0.625 0.625v2.15385c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625l0 -2.15385Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StreetRoad"
);
var StreetSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.538 0.057a0.25 0.25 0 0 0 -0.176 0.073L0.379 2.113a0.25 0.25 0 0 0 0 0.353L2.362 4.45a0.25 0.25 0 0 0 0.176 0.074H6.75V6.5H2.538a0.25 0.25 0 0 0 -0.176 0.074L0.379 8.558a0.25 0.25 0 0 0 0 0.353l1.983 1.983a0.25 0.25 0 0 0 0.176 0.073H7a0.25 0.25 0 0 0 0.25 -0.25v-2.91h4.212a0.25 0.25 0 0 0 0.177 -0.074L13.62 5.75a0.25 0.25 0 0 0 0 -0.353l-1.98 -1.983a0.25 0.25 0 0 0 -0.177 -0.073H7.25V0.307A0.25 0.25 0 0 0 7 0.057H2.538Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.045a0.75 0.75 0 0 1 0.75 0.75l0 12.41a0.75 0.75 0 1 1 -1.5 0l0 -12.41A0.75 0.75 0 0 1 7 0.045Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StreetSign"
);
var TakeOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.094 1.75a3.49 3.49 0 0 1 3.603 2.256 1.13 1.13 0 0 1 -0.743 1.412l-3.39 1.1 -0.213 0.07 -0.602 2.059a0.7 0.7 0 0 1 -0.477 0.492l-1.527 0.496a0.73 0.73 0 0 1 -0.992 -0.826l0.234 -1.14 -3.118 1.007a1.11 1.11 0 0 1 -1.427 -0.673l-0.002 -0.006 -1.16 -3.6 -0.003 -0.008a0.69 0.69 0 0 1 0.455 -0.847l1.37 -0.44 0.001 0a0.71 0.71 0 0 1 0.796 0.275l0.82 1.298 4.95 -2.465a3.49 3.49 0 0 1 1.425 -0.46Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.99 12.988a1 1 0 0 0 -1 -1H1.006a1 1 0 1 0 0 2H12.99a1 1 0 0 0 1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TakeOff"
);
var ToiletMan = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.03 2.03a2.03 2.03 0 1 1 -4.06 0 2.03 2.03 0 0 1 4.06 0Zm0.483 3.873a3.554 3.554 0 0 1 1.04 2.512V9.44a0.5 0.5 0 0 1 -0.5 0.5H9.032l-0.453 3.623a0.5 0.5 0 0 1 -0.496 0.438H5.918a0.5 0.5 0 0 1 -0.496 -0.438L4.97 9.939H3.946a0.5 0.5 0 0 1 -0.5 -0.5V8.415a3.554 3.554 0 0 1 6.067 -2.512Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ToiletMan"
);
var ToiletSignManWoman2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.5 2.5C0.5 1.11929 1.61929 0 3 0s2.5 1.11929 2.5 2.5S4.38071 5 3 5 0.5 3.88071 0.5 2.5ZM0.5 6c-0.276142 0 -0.5 0.22386 -0.5 0.5h0.5c-0.5 0 -0.5 0.00011 -0.5 0.00025v0.00173l0.0000115335 0.00451 0.0000730455 0.01647 0.000561208 0.06161c0.000635443 0.05337 0.001896533 0.13084 0.004399623 0.22896 0.00500429 0.19617 0.01498379 0.47533 0.03490049 0.80993 0.0397303 0.66747 0.1194511 1.56345 0.2803401 2.46444 0.159409 0.8927 0.404943 1.8289 0.793664 2.5545C1.49748 13.3583 2.09776 14 3 14s1.50252 -0.6417 1.88605 -1.3576c0.38872 -0.7256 0.63426 -1.6618 0.79366 -2.5545 0.16089 -0.90099 0.24061 -1.79697 0.28034 -2.46444 0.01992 -0.3346 0.0299 -0.61376 0.0349 -0.80993 0.00251 -0.09812 0.00377 -0.17559 0.0044 -0.22896l0.00057 -0.06161 0.00007 -0.01647L6 6.50198l0 -0.00131 0 -0.00042C6 6.50011 6 6.5 5.5 6.5H6c0 -0.27614 -0.22386 -0.5 -0.5 -0.5h-5Zm8 -3.5C8.5 1.11929 9.61929 0 11 0c1.3807 0 2.5 1.11929 2.5 2.5S12.3807 5 11 5C9.61929 5 8.5 3.88071 8.5 2.5ZM11 6c-0.9022 0 -1.50252 0.64171 -1.88605 1.35764 -0.38872 0.72561 -0.63425 1.66178 -0.79366 2.55446 -0.16089 0.901 -0.24061 1.797 -0.28034 2.4644 -0.01992 0.3346 -0.0299 0.6138 -0.03491 0.81 -0.0025 0.0981 -0.00376 0.1756 -0.00439 0.2289l-0.00057 0.0616 -0.00007 0.0165L8 13.498v0.0017c0 0.0002 0 0.0003 0.5 0.0003H8c0 0.2761 0.22386 0.5 0.5 0.5h5c0.2761 0 0.5 -0.2239 0.5 -0.5h-0.5c0.5 0 0.5 -0.0001 0.5 -0.0003v-0.0004l0 -0.0013 0 -0.0045 -0.0001 -0.0165 -0.0005 -0.0616c-0.0007 -0.0533 -0.0019 -0.1308 -0.0044 -0.2289 -0.005 -0.1962 -0.015 -0.4754 -0.0349 -0.81 -0.0398 -0.6674 -0.1195 -1.5634 -0.2804 -2.4644 -0.1594 -0.89268 -0.4049 -1.82885 -0.7936 -2.55446C12.5025 6.64171 11.9022 6 11 6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ToiletSignManWoman2"
);
var ToiletWomen = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.066 2.066a2.066 2.066 0 1 1 -4.132 0 2.066 2.066 0 0 1 4.132 0ZM8.498 13.6l0.39 -1.944h1.522c0.246 0 0.448 -0.2 0.47 -0.456a0.307 0.307 0 0 0 -0.007 -0.09 35.88 35.88 0 0 1 -0.206 -1.076C10.242 7.686 9.75 4.975 7 4.975s-3.242 2.711 -3.667 5.058c-0.067 0.372 -0.133 0.735 -0.206 1.076a0.306 0.306 0 0 0 -0.007 0.09 0.484 0.484 0 0 0 0.47 0.456h1.521l0.391 1.944a0.5 0.5 0 0 0 0.49 0.401h2.016a0.5 0.5 0 0 0 0.49 -0.401Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ToiletWomen"
);
var TrafficCone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.338 0.531h1.323a1 1 0 0 1 0.966 0.74l0.87 3.229H4.5l0.873 -3.229a1 1 0 0 1 0.965 -0.74Zm5.422 12.375H2.24L3.292 9h7.416l1.052 3.906Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 4.5h4.996L10.708 9H3.292L4.5 4.5ZM0.812 12.156a0.75 0.75 0 0 0 0 1.5h12.376a0.75 0.75 0 1 0 0 -1.5H0.812Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TrafficCone"
);
var TransferMotorcycle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 3.5c-0.8284 0 -1.5 0.67157 -1.5 1.5s0.6716 1.5 1.5 1.5h1c0.2761 0 0.5 -0.22386 0.5 -0.5V4c0 -0.27614 -0.2239 -0.5 -0.5 -0.5h-1Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8 2.25c-0.41421 0 -0.75 0.33579 -0.75 0.75s0.33579 0.75 0.75 0.75h0.75v7.5h-0.5c-0.41421 0 -0.75 -0.3358 -0.75 -0.75v-1c0 -1.51878 -1.23122 -2.75 -2.75 -2.75h-2C1.23122 6.75 0 7.98122 0 9.5V12c0 0.4142 0.335786 0.75 0.75 0.75H12.5c0.9156 0 1.5 -0.75 1.5 -1.75 0 -1.92673 -1.5805 -3.62145 -3.75 -3.74303V3c0 -0.41421 -0.33579 -0.75 -0.75 -0.75H8Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.99792 12.4989c0 0.8291 0.67205 1.5011 1.50107 1.5011 0.82901 0 1.50106 -0.672 1.50106 -1.5011 0 -0.829 -0.67205 -1.501 -1.50106 -1.501 -0.82902 0 -1.50107 0.672 -1.50107 1.501Zm7.00001 0c0 0.829 0.67205 1.5011 1.50107 1.5011 0.829 0 1.501 -0.6721 1.501 -1.5011 0 -0.829 -0.672 -1.501 -1.501 -1.501 -0.82902 0 -1.50107 0.672 -1.50107 1.501Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1 6.74997h3c0.55228 0 1 -0.44772 1 -1v-3c0 -0.55229 -0.44772 -1 -1 -1H1c-0.552285 0 -1 0.44771 -1 1v3c0 0.55228 0.447715 1 1 1Z" }),
    " "
  ] }) }),
  "TransferMotorcycle"
);
var TransferVan = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.702 2.604a1.5 1.5 0 0 0 -1.5 1.5v6.626a1.5 1.5 0 0 0 1.5 1.5l10.594 0a1.5 1.5 0 0 0 1.5 -1.5V7.542a0.5 0.5 0 0 0 -0.05 -0.22l-1.393 -2.85a1.5 1.5 0 0 0 -1.348 -0.842H9.582A1.5 1.5 0 0 0 8.16 2.604H1.702Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.796 8.14h-3.622a0.595 0.595 0 0 1 -0.595 -0.595V3.62l0.003 0.01h1.423a1.5 1.5 0 0 1 1.348 0.842l1.393 2.85a0.5 0.5 0 0 1 0.05 0.22v0.599Zm-9.898 2.068a1.896 1.896 0 1 0 0 3.792 1.896 1.896 0 0 0 0 -3.792Zm4.44 1.896a1.896 1.896 0 1 1 3.793 0 1.896 1.896 0 0 1 -3.792 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TransferVan"
);
var Warehouse1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.318 6.045A1 1 0 0 0 0 6.776V12.5A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5V6.776a1 1 0 0 0 -0.318 -0.731L7.325 0.12a0.5 0.5 0 0 0 -0.65 0L0.318 6.045Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m6.75 8.75 0.02 0h0.46l0.02 0h1.253v-3h-3v3H6.75Zm-2.004 4 0.021 0h0.459l0.02 0H6.5v-3h-3v3h1.246Zm4.022 0 -0.021 0H7.5v-3h3v3H9.247l-0.02 0h-0.459Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Warehouse1"
);
var Ambulance = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.70288 2.60431c-0.828427 0 -1.499999 0.67157 -1.499999 1.5v6.62559c0 0.8285 0.671573 1.5 1.499999 1.5l10.59422 0c0.8284 0 1.5 -0.6715 1.5 -1.5V7.54242c0 -0.07605 -0.0174 -0.1511 -0.0507 -0.21943L12.354 4.47213c-0.2516 -0.51504 -0.7747 -0.8417 -1.3479 -0.8417H9.58286c-0.19836 -0.5962 -0.76078 -1.02612 -1.42361 -1.02612H1.70288Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.7971 8.14086h-3.6226c-0.3287 0 -0.59515 -0.26646 -0.59515 -0.59514V3.62006c0.00117 0.00346 0.00234 0.00692 0.0035 0.01039h1.42325c0.5732 0 1.0963 0.32666 1.3478 0.8417L13.7463 7.323c0.0334 0.06834 0.0508 0.14339 0.0508 0.21944v0.59842Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.89865 10.2081c-1.04711 0 -1.89596 0.8488 -1.89596 1.8959S2.85154 14 3.89865 14s1.89596 -0.8489 1.89596 -1.896 -0.84885 -1.8959 -1.89596 -1.8959Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2356 10.2081c-1.04715 0 -1.896 0.8488 -1.896 1.8959S9.18845 14 10.2356 14c1.0471 0 1.8959 -0.8489 1.8959 -1.896s-0.8488 -1.8959 -1.8959 -1.8959Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.56665 5.18774c0 -0.34517 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27983 -0.625 0.625v1h-1c-0.34518 0 -0.625 0.27983 -0.625 0.625 0 0.34518 0.27982 0.625 0.625 0.625h1v1c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625v-1h1c0.34518 0 0.625 -0.27982 0.625 -0.625 0 -0.34517 -0.27982 -0.625 -0.625 -0.625h-1v-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Ambulance"
);
var BacteriaVirusCellsBiology = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.52 0.434a0.75 0.75 0 0 0 -1.36 0.632l0.299 0.644c-0.23 0.183 -0.461 0.408 -0.687 0.663l-0.569 -0.53A0.75 0.75 0 0 0 3.18 2.938l0.696 0.65a9.844 9.844 0 0 0 -0.404 0.718l-0.747 -0.319a0.75 0.75 0 1 0 -0.589 1.38l0.761 0.324 -0.016 0.05c-0.092 0.29 -0.169 0.59 -0.228 0.893l-0.803 -0.1a0.75 0.75 0 0 0 -0.186 1.489l0.866 0.107c0.01 0.281 0.04 0.561 0.094 0.838l-0.672 0.3a0.75 0.75 0 1 0 0.613 1.37l0.573 -0.256c0.215 0.384 0.492 0.751 0.843 1.094l-0.48 0.576a0.75 0.75 0 0 0 1.152 0.96l0.531 -0.637c0.438 0.248 0.877 0.42 1.309 0.527l0 0.348a0.75 0.75 0 0 0 1.5 -0.002l0 -0.239a4.091 4.091 0 0 0 1.566 -0.493l0.617 0.664a0.75 0.75 0 1 0 1.099 -1.021l-0.562 -0.605c0.237 -0.288 0.431 -0.61 0.576 -0.952l0.854 0.115a0.75 0.75 0 0 0 0.2 -1.487l-0.764 -0.102a3.722 3.722 0 0 0 -0.18 -1.1l0.586 -0.25a0.75 0.75 0 0 0 -0.588 -1.38l-0.712 0.304a5.668 5.668 0 0 0 -0.121 -0.15c-0.13 -0.193 -0.174 -0.412 -0.157 -0.705 0.007 -0.107 0.02 -0.213 0.037 -0.323h0.896a0.75 0.75 0 0 0 0 -1.5h-0.668a3.006 3.006 0 0 0 -0.058 -0.718l0.723 -0.482a0.75 0.75 0 0 0 -0.832 -1.248l-0.611 0.408a2.69 2.69 0 0 0 -0.506 -0.419l0.263 -0.413A0.75 0.75 0 0 0 8.386 0.347l-0.436 0.686a3.31 3.31 0 0 0 -1.132 0.042L6.52 0.435Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.303 5.53a1.005 1.005 0 1 0 0 -2.01 1.005 1.005 0 0 0 0 2.01Zm0.221 4.974a1.229 1.229 0 1 0 0 -2.457 1.229 1.229 0 0 0 0 2.457Zm-3.109 -3.5a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BacteriaVirusCellsBiology"
);
var Bandage = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.236 1.236a4.064 4.064 0 0 1 5.747 0l0.363 0.363c0.03 0.023 0.058 0.048 0.086 0.076l4.893 4.893a0.996 0.996 0 0 1 0.076 0.085l0.363 0.364a4.064 4.064 0 1 1 -5.747 5.747l-0.363 -0.362a1.02 1.02 0 0 1 -0.086 -0.077L1.675 7.432a1.002 1.002 0 0 1 -0.076 -0.086l-0.363 -0.363a4.064 4.064 0 0 1 0 -5.747Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.814 3.875 3.875 6.814l3.311 3.31 2.939 -2.938 -3.311 -3.31Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Bandage"
);
var BloodBagDonation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.3678 7.66386V2.8992c0 -1.59313 1.29148 -2.8846126 2.88461 -2.8846126h5.49521c1.59318 0 2.88458 1.2914826 2.88458 2.8846126v4.76466c0 1.24163 -0.7945 2.34394 -1.9724 2.73654l-1.09968 0.3666v0.5745c0 0.5311 -0.43049 0.9616 -0.96154 0.9616H5.40146c-0.53105 0 -0.96154 -0.4305 -0.96154 -0.9616v-0.5745l-1.0997 -0.3666C2.16231 10.0078 1.3678 8.90549 1.3678 7.66386Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.4678 10.4429 0.97149 0.3238v0.5121c0 0.5655 0.45848 1.024 1.02404 1.024h0.81417v0.9615c0 0.3983 0.32288 0.7211 0.72116 0.7211s0.72115 -0.3228 0.72115 -0.7211v-0.9615h0.81565c0.56556 0 1.02404 -0.4585 1.02404 -1.024v-0.5121l0.9715 -0.3238c1.2545 -0.4182 2.1006 -1.59213 2.1006 -2.91447v-0.13507c-0.6827 0.56832 -2.76489 1.43212 -5.63221 0.3408 -2.86731 -1.09131 -4.94267 -0.45471 -5.62537 0 0.08258 1.23708 0.90477 2.31244 2.09378 2.70874Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.00024 2.10699c-0.16115 0 -0.31242 0.07768 -0.40633 0.20864l-0.00107 0.0015 -0.00233 0.00326 -0.00825 0.01163 -0.0298 0.04246c-0.02533 0.03634 -0.06112 0.08828 -0.10391 0.15196 -0.08527 0.12693 -0.19976 0.30265 -0.31501 0.49584 -0.11427 0.19153 -0.23455 0.40898 -0.32782 0.61784 -0.08472 0.18972 -0.18011 0.44211 -0.18011 0.67926 0 0.36785 0.14002 0.72457 0.3954 0.99072 0.25605 0.26685 0.60784 0.4208 0.97923 0.4208 0.3714 0 0.72319 -0.15395 0.97924 -0.4208 0.25538 -0.26615 0.3954 -0.62287 0.3954 -0.99072 0 -0.23715 -0.0954 -0.48954 -0.18011 -0.67926 -0.09327 -0.20886 -0.21355 -0.42631 -0.32782 -0.61784 -0.11525 -0.19319 -0.22974 -0.36891 -0.31501 -0.49584 -0.04279 -0.06368 -0.07858 -0.11562 -0.10391 -0.15196l-0.0298 -0.04246 -0.00825 -0.01163 -0.00233 -0.00326 -0.00107 -0.0015c-0.09391 -0.13096 -0.24518 -0.20864 -0.40634 -0.20864Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BloodBagDonation"
);
var BloodDonateDrop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7 0.464 0.377 -0.27a0.464 0.464 0 0 0 -0.755 0L7 0.464Zm0 0 -0.378 -0.27 -0.001 0.002 -0.005 0.006L6.6 0.226a15.07 15.07 0 0 0 -0.276 0.4 23.46 23.46 0 0 0 -0.652 1.027 12.4 12.4 0 0 0 -0.664 1.25c-0.176 0.395 -0.33 0.831 -0.33 1.198 0 0.631 0.24 1.24 0.673 1.691 0.434 0.452 1.027 0.71 1.649 0.71 0.622 0 1.215 -0.258 1.649 -0.71 0.433 -0.451 0.673 -1.06 0.673 -1.69 0 -0.368 -0.154 -0.804 -0.33 -1.2a12.408 12.408 0 0 0 -0.664 -1.25A23.088 23.088 0 0 0 7.4 0.227L7.383 0.202 7.38 0.196 7.378 0.195 7 0.465Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 9.838V5.112a1.11 1.11 0 0 1 2.222 0v3.342a1.11 1.11 0 0 1 1.801 -0.335l1.436 1.436c0.417 0.417 0.65 0.982 0.65 1.571V14H2.778v-0.556L0.586 11.252A2 2 0 0 1 0 9.838Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.222 6.922v1.524a1.472 1.472 0 0 0 -0.052 0.293c-0.025 0.34 0.078 0.612 0.23 0.764l1.008 1.009a0.5 0.5 0 1 1 -0.707 0.707L1.693 10.21c-0.405 -0.405 -0.56 -0.987 -0.52 -1.544 0.04 -0.562 0.282 -1.147 0.739 -1.6a0.498 0.498 0 0 1 0.31 -0.144Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 9.838V5.112a1.11 1.11 0 0 0 -2.222 0v3.342a1.11 1.11 0 0 0 -1.801 -0.335L8.541 9.555a2.22 2.22 0 0 0 -0.65 1.571V14h3.332v-0.556l2.191 -2.192A2 2 0 0 0 14 9.838Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.779 6.922v1.524c0.027 0.097 0.044 0.196 0.051 0.292 0.025 0.34 -0.077 0.612 -0.23 0.765l-1.008 1.008a0.5 0.5 0 1 0 0.707 0.707l1.009 -1.008c0.405 -0.405 0.56 -0.988 0.52 -1.544a2.524 2.524 0 0 0 -0.74 -1.6 0.498 0.498 0 0 0 -0.31 -0.144Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BloodDonateDrop"
);
var BloodDropDonation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.71 0.347 7 0.732C6.711 0.35 6.71 0.347 6.71 0.347Zm0 0L6.707 0.35l-0.003 0 -0.012 0.01a5.319 5.319 0 0 0 -0.205 0.164 16.99 16.99 0 0 0 -2.264 2.287C2.994 4.322 1.71 6.474 1.71 8.913c0 1.62 0.677 2.846 1.696 3.657 1.005 0.801 2.318 1.18 3.593 1.18s2.588 -0.379 3.593 -1.18c1.019 -0.81 1.696 -2.037 1.696 -3.657 0 -2.439 -1.283 -4.592 -2.512 -6.101A16.99 16.99 0 0 0 7.513 0.525 9.488 9.488 0 0 0 7.308 0.36L7.296 0.35l-0.004 0 -0.001 -0.003a0.482 0.482 0 0 0 -0.582 0Z", clipRule: "evenodd" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.386 5.068a0.378 0.378 0 0 0 -0.379 0.378V6.95H4.503a0.378 0.378 0 0 0 -0.378 0.378v1.23c0 0.208 0.17 0.378 0.378 0.378h1.504v1.504c0 0.209 0.17 0.378 0.379 0.378h1.229c0.209 0 0.378 -0.17 0.378 -0.378l0 -1.504h1.504c0.21 0 0.379 -0.17 0.379 -0.379V7.328a0.378 0.378 0 0 0 -0.379 -0.378l-1.504 0V5.446a0.378 0.378 0 0 0 -0.378 -0.378h-1.23Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "BloodDropDonation"
);
var Bone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.8462 2.15385c0 -0.57124 -0.227 -1.11908 -0.6309 -1.523003C10.8114 0.226922 10.2635 0 9.69231 0c-0.57124 0 -1.11908 0.226922 -1.523 0.630847 -0.40393 0.403923 -0.63085 0.951763 -0.63085 1.523003 0.00241 0.57031 0.23091 1.11639 0.63539 1.51846L3.67231 8.17385c-0.40207 -0.40448 -0.94815 -0.63298 -1.51846 -0.63539 -0.57124 0 -1.11908 0.22692 -1.523003 0.63085C0.226922 8.57323 0 9.12107 0 9.69231c0 0.57119 0.226922 1.11909 0.630847 1.52299 0.403923 0.4039 0.951763 0.6309 1.523003 0.6309 0 0.5712 0.22692 1.119 0.63084 1.523 0.40393 0.4039 0.95177 0.6308 1.523 0.6308 0.57124 0 1.11908 -0.2269 1.523 -0.6308 0.40393 -0.404 0.63085 -0.9518 0.63085 -1.523 -0.00241 -0.5704 -0.23091 -1.1164 -0.63539 -1.5185l4.50155 -4.50155c0.4021 0.40448 0.9481 0.63298 1.5185 0.63539 0.5712 0 1.119 -0.22692 1.523 -0.63085 0.4039 -0.40392 0.6308 -0.95176 0.6308 -1.523 0 -0.57123 -0.2269 -1.11907 -0.6308 -1.523 -0.404 -0.40392 -0.9518 -0.63084 -1.523 -0.63084Z" }),
    " "
  ] }) }),
  "Bone"
);
var BrailleBlind = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.55 5.361 0 4.968 -0.625 0a1.715 1.715 0 0 0 -1.583 2.374L2.88 14l8.005 0 0 -3.086A2.573 2.573 0 0 0 8.313 8.34l-1.194 0 0 -2.98a1.284 1.284 0 1 0 -2.569 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.468 3.91a0.947 0.947 0 1 1 0 1.893 0.947 0.947 0 0 1 0 -1.893Zm-4.62 -2.38a0.947 0.947 0 1 1 1.894 0 0.947 0.947 0 0 1 -1.894 0Zm7.307 2.38a0.947 0.947 0 1 1 0 1.893 0.947 0.947 0 0 1 0 -1.893ZM1.845 5.803a0.947 0.947 0 1 1 0 -1.893 0.947 0.947 0 0 1 0 1.893Zm0 3.31a0.947 0.947 0 1 1 0 -1.893 0.947 0.947 0 0 1 0 1.893Zm0 -8.53a0.947 0.947 0 1 1 0 1.894 0.947 0.947 0 0 1 0 -1.894Zm10.31 0a0.947 0.947 0 1 1 0 1.894 0.947 0.947 0 0 1 0 -1.894Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BrailleBlind"
);
var BrainCognitive = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.932 0.766A6 6 0 0 0 4 11.197V13.5a0.5 0.5 0 0 0 0.5 0.5h5a0.5 0.5 0 0 0 0.5 -0.5v-2h1.5A1.5 1.5 0 0 0 13 10V6A6 6 0 0 0 9.932 0.766Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.225 2.685A3.768 3.768 0 0 0 3.56 7.21c0.138 0.388 0.557 0.583 0.955 0.477C6.53 7.153 8.582 5.71 9.828 4.584c0.33 -0.299 0.399 -0.797 0.105 -1.13a3.768 3.768 0 0 0 -4.708 -0.77Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "BrainCognitive"
);
var Brain = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.375 1.744a2.618 2.618 0 0 0 -4.596 1.982C0.73 4.296 0 5.744 0 7.234c0 1.093 0.393 2.404 1.017 3.074a2.997 2.997 0 0 0 5.358 2.084V1.744Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.625 12.392a2.997 2.997 0 0 0 5.358 -2.084C13.606 9.638 14 8.328 14 7.234c0 -1.49 -0.73 -2.939 -1.779 -3.508a2.618 2.618 0 0 0 -4.596 -1.982v10.648Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.625 6.548c0.256 0.186 0.528 0.338 0.792 0.45a0.625 0.625 0 1 0 0.486 -1.153c-0.553 -0.233 -1.062 -0.685 -1.24 -1.1a0.63 0.63 0 0 0 -0.038 -0.074v1.877Zm4.189 -1.856c0.18 -0.177 0.346 -0.555 0.41 -0.965 0.393 0.215 0.742 0.553 1.024 0.972a2.55 2.55 0 0 1 -0.557 0.883 0.625 0.625 0 1 1 -0.877 -0.89Zm1.153 5.607 0.023 0.001 -0.007 0.008a3.04 3.04 0 0 1 -0.154 1.234 3.014 3.014 0 0 1 -0.778 -0.183c-0.595 -0.224 -1.242 -0.665 -1.773 -1.436a0.625 0.625 0 0 1 1.03 -0.709c0.382 0.555 0.82 0.839 1.183 0.975 0.184 0.07 0.348 0.1 0.476 0.11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.375 6.307c-0.017 0.205 -0.133 0.633 -0.4 1.023 -0.265 0.385 -0.635 0.678 -1.144 0.734a0.625 0.625 0 0 0 0.139 1.243 2.69 2.69 0 0 0 1.405 -0.585V6.307ZM1.779 3.726c-0.363 0.197 -0.688 0.5 -0.957 0.872 0.11 0.213 0.242 0.4 0.384 0.562 0.369 0.42 0.83 0.692 1.188 0.774a0.625 0.625 0 0 0 0.278 -1.219c-0.057 -0.013 -0.298 -0.119 -0.527 -0.38a1.556 1.556 0 0 1 -0.382 -0.89c0 0.095 0.006 0.188 0.016 0.28Zm-0.772 6.834c0 0.15 0.01 0.298 0.032 0.443 0.114 -0.35 0.3 -0.654 0.478 -0.794a0.625 0.625 0 1 0 -0.775 -0.982 2.082 2.082 0 0 0 -0.259 0.245c0.15 0.328 0.33 0.616 0.534 0.836 -0.007 0.083 -0.01 0.167 -0.01 0.252Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Brain"
);
var Cane = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.012 8.802a0.433 0.433 0 0 0 -0.393 0.47l0.056 0.64a0.75 0.75 0 1 1 -1.494 0.132l-0.056 -0.641a1.933 1.933 0 0 1 3.735 -0.847l1.411 3.773a0.75 0.75 0 1 1 -1.405 0.525l-1.41 -3.772a0.433 0.433 0 0 0 -0.444 -0.28Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.47 1.959a1.959 1.959 0 1 1 -3.916 0 1.959 1.959 0 0 1 3.917 0ZM4.168 4.55a1 1 0 0 1 0.936 0.252c0.684 0.661 1.443 1.16 2.658 1.032a1 1 0 1 1 0.21 1.99c-1.276 0.133 -2.269 -0.179 -3.053 -0.644l-0.166 0.509 1.52 1.094a2 2 0 0 1 0.776 1.154l0.584 2.419a1 1 0 1 1 -1.944 0.47l-0.584 -2.42L4.1 9.685l-1.05 3.217a1 1 0 1 1 -1.902 -0.62l2.31 -7.071a1 1 0 0 1 0.71 -0.66Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cane"
);
var CheckupMedicalReportClipboard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 2.5A1.5 1.5 0 0 1 2.75 1h8.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1 -1.5 1.5h-8.5a1.5 1.5 0 0 1 -1.5 -1.5v-10Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.5 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v0.5a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1V1Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.363 5.065a0.392 0.392 0 0 0 -0.393 0.393v1.56H4.41a0.392 0.392 0 0 0 -0.392 0.392v1.275c0 0.217 0.175 0.393 0.392 0.393h1.56v1.56c0 0.217 0.176 0.392 0.392 0.392h1.276a0.392 0.392 0 0 0 0.392 -0.392l0 -1.56h1.56a0.392 0.392 0 0 0 0.392 -0.393V7.41a0.392 0.392 0 0 0 -0.392 -0.392l-1.56 0v-1.56a0.392 0.392 0 0 0 -0.392 -0.393H6.363Z" }),
    " "
  ] }) }),
  "CheckupMedicalReportClipboard"
);
var Crutch = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.689 2.03a2.03 2.03 0 1 1 -4.061 0 2.03 2.03 0 0 1 4.061 0Zm1.523 6.385a3.554 3.554 0 0 0 -5.767 -2.78 1.75 1.75 0 0 1 0.198 3.142v1.288l0.438 3.497a0.5 0.5 0 0 0 0.496 0.438H9.74a0.5 0.5 0 0 0 0.496 -0.438l0.453 -3.623h1.023a0.5 0.5 0 0 0 0.5 -0.5V8.415Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.8 6.63a0.625 0.625 0 0 0 0 1.25h0.263v2.222c0 0.732 0.454 1.358 1.096 1.613v1.029H3.13a0.625 0.625 0 1 0 0 1.25h1.33a0.625 0.625 0 0 0 0 -1.25h-0.05v-1.019a1.735 1.735 0 0 0 1.122 -1.623V7.88h0.261a0.625 0.625 0 1 0 0 -1.25H1.8Zm1.513 1.25v2.222a0.484 0.484 0 0 0 0.968 0V7.88h-0.968Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Crutch"
);
var Dna = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.26473 3.75089c0.16277 -0.3809 0.60349 -0.55772 0.98437 -0.39496 0.8551 0.36541 1.8168 0.3937 2.6919 0.07918 0.3898 -0.1401 0.8194 0.06232 0.9595 0.45212 0.1401 0.38981 -0.0623 0.81937 -0.4521 0.95947 -1.2317 0.44267 -2.5852 0.40286 -3.78872 -0.11143 -0.38089 -0.16277 -0.55772 -0.60349 -0.39495 -0.98438ZM3.74588 10.6514c-0.85132 -0.3711 -1.81242 -0.4022 -2.68595 -0.0869 -0.389609 0.1407 -0.819456 -0.0612 -0.9600904 -0.4508 -0.1406342 -0.38958 0.0611994 -0.81943 0.4508084 -0.96006C1.78475 8.70817 3.14257 8.7521 4.3453 9.27641c0.3797 0.16552 0.55333 0.60751 0.38781 0.98719 -0.16553 0.3797 -0.60752 0.5534 -0.98723 0.3878Zm1.82118 -6.15451c-0.29289 -0.2929 -0.76776 -0.2929 -1.06066 0 -0.29289 0.29289 -0.29289 0.76776 0 1.06066l3.93602 3.93601c0.29289 0.29289 0.76777 0.2929 1.06066 0 0.29289 -0.29289 0.29289 -0.76777 0 -1.06066L5.56706 4.49689Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.5626 1.06514c0.1435 -0.38856 -0.0551 -0.81988 -0.4437 -0.963377 -0.38856 -0.1434978 -0.81988 0.055168 -0.96338 0.443731 -0.4533 1.227446 -0.42543 2.580946 0.078 3.788696l0.00079 0.00188c0.28785 0.68528 0.36601 1.44053 0.22459 2.17024 -0.14123 0.72875 -0.49513 1.39934 -1.01702 1.92716 -0.5381 0.53421 -1.22254 0.89689 -1.96678 1.04215 -0.40654 0.07935 -0.67178 0.47324 -0.59244 0.87978 0.07935 0.4065 0.47324 0.6718 0.87979 0.5924 1.03674 -0.2023 1.99006 -0.7079 2.73912 -1.45269l0.00001 0.00001 0.00409 -0.00413c0.73173 -0.73895 1.22793 -1.67832 1.42583 -2.6993 0.1978 -1.02064 0.0886 -2.077 -0.3138 -3.03557 -0.3574 -0.85789 -0.377 -1.81918 -0.0551 -2.69098ZM7.48627 4.52451c0.4066 -0.07908 0.6721 -0.4728 0.59301 -0.8794 -0.07908 -0.40659 -0.4728 -0.67209 -0.87939 -0.59301 -1.03204 0.20073 -1.98155 0.7025 -2.72883 1.44207l-0.00004 -0.00004 -0.00605 0.00613c-0.73028 0.73953 -1.22546 1.67857 -1.4232 2.69892 -0.19774 1.02034 -0.08921 2.07638 0.31194 3.03522l-0.00001 0 0.0018 0.0042c0.36561 0.859 0.39392 1.8244 0.07927 2.7033 -0.13959 0.39 0.06338 0.8193 0.45336 0.9589 0.38998 0.1396 0.81929 -0.0633 0.95889 -0.4533 0.44158 -1.2336 0.40215 -2.5882 -0.11035 -3.79402 -0.28625 -0.68525 -0.36359 -1.43982 -0.2223 -2.16892 0.14116 -0.72837 0.49423 -1.39881 1.01489 -1.92727 0.53629 -0.52955 1.21713 -0.88887 1.95701 -1.03278Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dna"
);
var EarHearing = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.455 0.371C2.36 0.371 1.1 1.751 0.53 3.031a1.937 1.937 0 0 0 -0.159 0.791v6.35c0 0.263 0.043 0.56 0.185 0.84 0.704 1.387 2.047 1.78 3.186 1.527 1.102 -0.244 2.146 -1.135 2.146 -2.413 0 -0.514 0.38 -0.853 0.965 -1.283 0.934 -0.686 2.237 -2.019 2.237 -4.112C9.09 2.554 7.42 0.37 4.455 0.37Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.474 3.442c-0.548 0 -0.93 0.425 -1.11 0.972a0.625 0.625 0 1 1 -1.188 -0.391c0.255 -0.77 0.959 -1.83 2.298 -1.83 1.697 0 2.591 1.395 2.591 2.669 0 0.684 -0.166 1.212 -0.455 1.632 -0.28 0.407 -0.644 0.663 -0.936 0.85l-0.21 0.132c-0.203 0.126 -0.336 0.209 -0.447 0.318a0.487 0.487 0 0 0 -0.158 0.396c0 0.458 -0.124 0.863 -0.366 1.179a1.518 1.518 0 0 1 -0.934 0.571c-0.7 0.129 -1.46 -0.23 -1.777 -0.981a0.625 0.625 0 0 1 1.15 -0.488c0.084 0.197 0.262 0.265 0.401 0.24a0.268 0.268 0 0 0 0.169 -0.104c0.046 -0.06 0.107 -0.184 0.107 -0.417 0 -0.566 0.217 -0.977 0.531 -1.287 0.22 -0.216 0.508 -0.394 0.728 -0.53L5 6.29c0.259 -0.165 0.446 -0.31 0.58 -0.505 0.124 -0.181 0.234 -0.454 0.234 -0.923 0 -0.758 -0.497 -1.42 -1.341 -1.42Zm8.405 5.256a0.75 0.75 0 0 1 0.75 0.75 4.18 4.18 0 0 1 -4.181 4.18 0.75 0.75 0 0 1 0 -1.5c1.48 0 2.68 -1.2 2.68 -2.68a0.75 0.75 0 0 1 0.75 -0.75Zm-1.694 -0.141a0.75 0.75 0 0 0 -1.5 0c0 0.605 -0.49 1.095 -1.095 1.095a0.75 0.75 0 0 0 0 1.5 2.595 2.595 0 0 0 2.595 -2.595Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "EarHearing"
);
var FluMask = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.0301514 5.83696c0 -1.36512 1.0464786 -2.55913 2.4415886 -2.55913h9.05666c1.3951 0 2.4415 1.19401 2.4415 2.55913 0 0.55272 -0.1706 1.09167 -0.4878 1.53525 -0.1557 0.21784 -0.3459 0.37414 -0.4791 0.47833l-1.8381 1.43797c-2.43783 1.90719 -5.86047 1.91189 -8.30358 0.01141L1.00237 7.85386C0.866529 7.74818 0.672592 7.5895 0.51456 7.36743 0.199552 6.92477 0.0301514 6.38771 0.0301514 5.83696ZM2.47174 4.77783c-0.47337 0 -0.94159 0.42594 -0.94159 1.05913 0 0.24521 0.07584 0.47708 0.20655 0.66077 0.0251 0.03527 0.07322 0.08391 0.18667 0.17217l1.85895 1.44606c1.9002 1.47816 4.56225 1.4745 6.45838 -0.00887l1.8381 -1.43797c0.1112 -0.08702 0.1585 -0.13482 0.1832 -0.16942 0.1316 -0.18399 0.2079 -0.41664 0.2079 -0.66274 0 -0.63319 -0.4682 -1.05913 -0.9415 -1.05913H2.47174Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.26685 3.27783c-0.55229 0 -1 0.44772 -1 1v4.90356c0 0.32713 0.15999 0.63357 0.42841 0.82051l0.57159 -0.82051c-0.57159 0.82051 -0.57064 0.82121 -0.57064 0.82121l0.00097 0.0007 0.00199 0.0013 0.00422 0.0029 0.00937 0.0064 0.02249 0.0147c0.01666 0.0107 0.03668 0.0232 0.06015 0.037 0.04695 0.0278 0.10761 0.0612 0.18271 0.0982 0.15038 0.0739 0.35763 0.1613 0.62747 0.2448 0.54076 0.1675 1.3242 0.3168 2.39443 0.3168 1.07023 0 1.85366 -0.1493 2.39442 -0.3168 0.26984 -0.0835 0.47709 -0.1709 0.62747 -0.2448 0.0751 -0.037 0.1358 -0.0704 0.1827 -0.0982 0.0235 -0.0138 0.0435 -0.0263 0.0602 -0.037l0.0224 -0.0147 0.0094 -0.0064 0.0042 -0.0028 0.002 -0.0014 0.001 -0.0007s0.0009 -0.0007 -0.57063 -0.82121l0.57153 0.82051c0.2685 -0.18694 0.4285 -0.49338 0.4285 -0.82051V4.27783c0 -0.55228 -0.4477 -1 -1.00003 -1H4.26685Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.68359 5.78143c0 -0.34517 0.27983 -0.625 0.625 -0.625H7.6916c0.34518 0 0.625 0.27983 0.625 0.625 0 0.34518 -0.27982 0.625 -0.625 0.625H6.30859c-0.34517 0 -0.625 -0.27982 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FluMask"
);
var GoodHealthAndWellBeing = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.906 7.682c0.485 0.04 0.968 0.256 1.422 0.657 0.461 -0.39 0.948 -0.599 1.433 -0.632a1.994 1.994 0 0 1 1.552 0.593c0.752 0.748 0.994 2.124 0.017 3.066l-0.01 0.01 -2.663 2.42a0.5 0.5 0 0 1 -0.673 0l-2.662 -2.42a0.449 0.449 0 0 1 -0.017 -0.016c-0.97 -0.965 -0.717 -2.348 0.042 -3.096a1.98 1.98 0 0 1 1.559 -0.582Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.87 1a0.75 0.75 0 0 1 0.64 0.374l2.025 3.5a0.75 0.75 0 1 1 -1.299 0.751l-1.394 -2.41L4.943 9.58a0.75 0.75 0 0 1 -1.265 0.022L1.875 6.875H0.76a0.75 0.75 0 1 1 0 -1.5h1.518a0.75 0.75 0 0 1 0.626 0.336l1.375 2.08 3.942 -6.433A0.75 0.75 0 0 1 8.87 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GoodHealthAndWellBeing"
);
var HealthCare2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.1921 5.51788c-0.64963 0 -1.27448 0.24932 -1.74568 0.69653l-0.0001 0.0001c-0.23399 0.2222 -0.42032 0.4897 -0.54764 0.7862 -0.12733 0.29651 -0.19299 0.61582 -0.19299 0.9385 0 0.32269 0.06566 0.642 0.19299 0.93851 0.12692 0.29556 0.31247 0.5623 0.54542 0.78409l4.20739 4.08939c0.19405 0.1886 0.50294 0.1886 0.69698 0l4.20743 -4.08938c0.2329 -0.22179 0.4185 -0.48853 0.5454 -0.7841 0.1273 -0.29651 0.193 -0.61582 0.193 -0.93851 0 -0.32268 -0.0657 -0.64199 -0.193 -0.9385 -0.1273 -0.2965 -0.3137 -0.564 -0.5477 -0.7862l-0.0001 -0.0001c-0.4712 -0.44721 -1.096 -0.69653 -1.74564 -0.69653 -0.64963 0 -1.27449 0.24932 -1.74568 0.69653l-0.00012 -0.00012 -0.00923 0.00923 -1.05285 1.05285 -1.05284 -1.05285 0.00012 -0.00012 -0.00947 -0.00899c-0.4712 -0.44721 -1.09605 -0.69653 -1.74569 -0.69653Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.00002 0.1073c-1.27862 0 -2.31514 1.03653 -2.31514 2.31515S5.7214 4.7376 7.00002 4.7376c1.27863 0 2.31515 -1.03653 2.31515 -2.31515S8.27865 0.1073 7.00002 0.1073Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HealthCare2"
);
var HearingDeaf1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.829 0.354c-2.413 0 -3.797 1.684 -4.356 3.115a2.19 2.19 0 0 0 -0.132 0.963l0.537 7.073c0.058 0.763 0.523 1.788 1.606 1.957 0.732 0.114 1.361 -0.076 1.99 -0.383 0.568 -0.277 0.957 -0.795 1.214 -1.247a7.01 7.01 0 0 0 0.568 -1.34c0.083 -0.266 0.226 -0.497 0.413 -0.67 0.445 -0.411 1.136 -1.1 1.72 -1.914 0.569 -0.792 1.12 -1.815 1.12 -2.873 0 -1.128 -0.335 -2.298 -1.117 -3.198C10.596 0.92 9.398 0.354 7.83 0.354Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.878 4.37a0.755 0.755 0 0 0 -0.364 0.082 0.75 0.75 0 0 1 -0.646 -1.354c0.645 -0.308 1.448 -0.356 2.303 0.177 0.833 0.518 1.075 1.324 1.068 1.976a0.75 0.75 0 0 1 -1.5 -0.017 0.865 0.865 0 0 0 -0.075 -0.38 0.718 0.718 0 0 0 -0.285 -0.306c-0.217 -0.135 -0.382 -0.173 -0.501 -0.178Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.22 0.22a0.75 0.75 0 0 1 1.06 0l12.5 12.5a0.75 0.75 0 1 1 -1.06 1.06L0.22 1.28a0.75 0.75 0 0 1 0 -1.06Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HearingDeaf1"
);
var HearingDeaf2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.023 0.782c-2.161 0 -3.483 1.39 -4.101 2.693 -0.192 0.404 -0.223 0.83 -0.178 1.203l0.855 7.059c0.056 0.46 0.248 0.937 0.581 1.294 0.348 0.372 0.877 0.63 1.504 0.51 0.349 -0.068 0.68 -0.198 1.004 -0.356 0.553 -0.27 0.93 -0.772 1.182 -1.209 0.26 -0.452 0.44 -0.937 0.554 -1.299 0.084 -0.266 0.228 -0.5 0.415 -0.672a12.81 12.81 0 0 0 1.67 -1.863c0.549 -0.768 1.082 -1.76 1.082 -2.79 0 -1.1 -0.327 -2.242 -1.09 -3.121C9.723 1.335 8.553 0.782 7.023 0.782Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.295 0.509a0.75 0.75 0 1 0 -0.98 1.136c0.322 0.278 0.56 0.663 0.699 1.15a0.75 0.75 0 1 0 1.442 -0.413c-0.207 -0.723 -0.585 -1.376 -1.161 -1.873Zm-8.503 7.58a0.75 0.75 0 1 0 -1.06 1.06l0.46 0.46a0.75 0.75 0 0 0 1.06 -1.06l-0.46 -0.46ZM0.577 9.152a0.75 0.75 0 0 1 1.06 0l1.494 1.494a0.75 0.75 0 1 1 -1.06 1.06L0.576 10.214a0.75 0.75 0 0 1 0 -1.06Zm4.264 -3.216a0.75 0.75 0 1 0 -1.061 1.06L5.273 8.49a0.75 0.75 0 0 0 1.06 -1.06L4.842 5.937Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.856 4.825a0.667 0.667 0 0 0 -0.32 0.072 0.75 0.75 0 1 1 -0.647 -1.353c0.62 -0.296 1.391 -0.341 2.21 0.169 0.8 0.497 1.033 1.273 1.026 1.897a0.75 0.75 0 1 1 -1.5 -0.017 0.77 0.77 0 0 0 -0.066 -0.338 0.632 0.632 0 0 0 -0.252 -0.269c-0.199 -0.124 -0.347 -0.157 -0.45 -0.161Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HearingDeaf2"
);
var HeartRatePulseGraph = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.052 1.096c0.967 0.072 1.975 0.549 2.94 1.51 0.967 -0.958 1.976 -1.433 2.946 -1.502 1.096 -0.079 2.065 0.366 2.764 1.068 1.374 1.38 1.793 3.875 0.06 5.585l-0.012 0.011 -5.42 5.012a0.5 0.5 0 0 1 -0.679 0L1.234 7.768a0.488 0.488 0 0 1 -0.015 -0.014c-1.71 -1.717 -1.292 -4.212 0.077 -5.592 0.696 -0.702 1.662 -1.146 2.756 -1.066Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.101 4.16c0.24 0.01 0.455 0.156 0.55 0.377l1.154 2.677 0.693 -0.854a0.625 0.625 0 0 1 0.486 -0.232h1.5a0.625 0.625 0 1 1 0 1.25H9.28L8.125 8.803a0.625 0.625 0 0 1 -1.06 -0.146l-1.042 -2.42 -0.423 0.806a0.625 0.625 0 0 1 -0.554 0.335H3.515a0.625 0.625 0 1 1 0 -1.25h1.153l0.856 -1.633A0.625 0.625 0 0 1 6.1 4.16Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HeartRatePulseGraph"
);
var HeartRateSearch = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.75 6.25a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0 -11 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 6.25a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1 -9.5 0ZM6.25 0a6.25 6.25 0 1 0 3.656 11.32l2.387 2.387a1 1 0 0 0 1.414 -1.414L11.32 9.906A6.25 6.25 0 0 0 6.25 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.428 4.181c0.228 0.01 0.432 0.142 0.534 0.346L6.998 6.61l0.62 -0.663a0.625 0.625 0 0 1 0.457 -0.197h1.38a0.625 0.625 0 1 1 0 1.25h-1.11L7.296 8.12a0.625 0.625 0 0 1 -1.015 -0.148l-0.931 -1.87 -0.36 0.595A0.625 0.625 0 0 1 4.454 7H3.046a0.625 0.625 0 1 1 0 -1.25H4.1l0.766 -1.267a0.625 0.625 0 0 1 0.56 -0.302Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HeartRateSearch"
);
var HospitalSignCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 3.875c0.345 0 0.625 0.28 0.625 0.625v1.875h2.75V4.5a0.625 0.625 0 1 1 1.25 0v5a0.625 0.625 0 1 1 -1.25 0V7.625h-2.75V9.5a0.625 0.625 0 1 1 -1.25 0v-5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HospitalSignCircle"
);
var HospitalSignSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1V1a1 1 0 0 0 -1 -1H1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 3.875c0.345 0 0.625 0.28 0.625 0.625v1.875h2.75V4.5a0.625 0.625 0 1 1 1.25 0v5a0.625 0.625 0 1 1 -1.25 0V7.625h-2.75V9.5a0.625 0.625 0 1 1 -1.25 0v-5c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HospitalSignSquare"
);
var MedicalBag = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.656 0.469A2.118 2.118 0 0 1 4.999 0H9c0.474 0 0.96 0.153 1.343 0.469 0.389 0.32 0.658 0.8 0.658 1.354V3.47a1 1 0 1 1 -2 0V2H4.998v1.47a1 1 0 1 1 -2 0V1.823c0 -0.553 0.268 -1.034 0.657 -1.354Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 3.366C0.69 3.366 0 4 0 4.826v7.684c0 0.825 0.69 1.46 1.5 1.46h11c0.81 0 1.5 -0.635 1.5 -1.46V4.826c0 -0.825 -0.69 -1.46 -1.5 -1.46h-11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.625 6.668a0.625 0.625 0 1 0 -1.25 0v1.375H5a0.625 0.625 0 1 0 0 1.25h1.375v1.375a0.625 0.625 0 1 0 1.25 0V9.293H9a0.625 0.625 0 1 0 0 -1.25H7.625V6.668Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MedicalBag"
);
var MedicalCrossSignHealthcare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 0a0.5 0.5 0 0 0 -0.5 0.5v4h-4A0.5 0.5 0 0 0 0 5v4a0.5 0.5 0 0 0 0.5 0.5h4v4a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.5 -0.5v-4h4A0.5 0.5 0 0 0 14 9V5a0.5 0.5 0 0 0 -0.5 -0.5h-4v-4A0.5 0.5 0 0 0 9 0H5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MedicalCrossSignHealthcare"
);
var MedicalCrossSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.04734 0.756836c0 -0.276143 0.22386 -0.5 0.5 -0.5h2.90542c0.27614 0 0.5 0.223858 0.5 0.5V3.61784l2.47774 -1.4305c0.2391 -0.13807 0.5449 -0.05613 0.683 0.18301l1.4527 2.51617c0.1381 0.23915 0.0561 0.54494 -0.183 0.68301l-2.4777 1.43051 2.4776 1.43049c0.2392 0.13807 0.3211 0.44387 0.1831 0.68302l-1.4528 2.51615c-0.138 0.2392 -0.4438 0.3211 -0.683 0.183l-2.47764 -1.4305v2.861c0 0.2762 -0.22386 0.5 -0.5 0.5H5.54734c-0.27614 0 -0.5 -0.2238 -0.5 -0.5v-2.861l-2.4777 1.4305c-0.23915 0.1381 -0.54494 0.0562 -0.68302 -0.183L0.433915 9.11355C0.295844 8.8744 0.377781 8.5686 0.616927 8.43053L3.09462 7.00004 0.616905 5.56953c-0.239147 -0.13807 -0.321084 -0.44386 -0.183013 -0.68301L1.8866 2.37035c0.13807 -0.23914 0.44387 -0.32108 0.68301 -0.18301l2.47773 1.43051V0.756836Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MedicalCrossSymbol"
);
var MedicalFilesReportHistory = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-8a0.5 0.5 0 0 0 -0.146 -0.354l-4 -4A0.5 0.5 0 0 0 8.5 0h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.363 4.997a0.392 0.392 0 0 0 -0.393 0.393v1.56H4.41a0.392 0.392 0 0 0 -0.392 0.392v1.275c0 0.217 0.175 0.392 0.392 0.392h1.56v1.56c0 0.217 0.176 0.393 0.392 0.393h1.276a0.392 0.392 0 0 0 0.392 -0.392l0 -1.56h1.56a0.392 0.392 0 0 0 0.392 -0.393V7.342a0.392 0.392 0 0 0 -0.392 -0.392l-1.56 0V5.39a0.392 0.392 0 0 0 -0.392 -0.393H6.363Z" }),
    " "
  ] }) }),
  "MedicalFilesReportHistory"
);
var MedicalRibbon1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.41609 0.362249C7.96432 0.190308 7.4825 0.112157 6.99994 0.132317c-0.48255 -0.02016 -0.96438 0.057991 -1.41614 0.229932 -0.46987 0.178832 -0.89657 0.455074 -1.25207 0.810571 -0.3555 0.3555 -0.63174 0.7822 -0.81057 1.25207 -0.17533 0.46067 -0.25314 0.95261 -0.22862 1.44469 0.00749 1.13855 0.46175 2.31781 1.03723 3.38014 0.40146 0.7411 0.88812 1.47244 1.39581 2.15673 -0.61609 0.73545 -1.21683 1.37965 -1.68387 1.85885 -0.26732 0.2742 -0.48945 0.493 -0.64372 0.6422l-0.23537 0.224c-0.4056 0.3747 -0.43074 1.0072 -0.05612 1.4129 0.37467 0.4058 1.00733 0.431 1.41309 0.0563l0.00075 -0.0007c0.32661 -0.3037 0.64228 -0.6194 0.95354 -0.9387 0.42671 -0.4378 0.96251 -1.0094 1.52607 -1.6655 0.56355 0.6561 1.09935 1.2277 1.52606 1.6655 0.55061 0.5649 1.50499 1.8171 2.36739 0.8831 0.3746 -0.4057 0.3492 -1.0385 -0.0564 -1.4132l-0.0022 -0.002 -0.001 -0.0009c-0.298 -0.2815 -0.5895 -0.5695 -0.87562 -0.863 -0.46704 -0.4792 -1.06778 -1.1234 -1.68387 -1.85885 0.50769 -0.6843 0.99435 -1.41563 1.39581 -2.15673 0.57548 -1.06233 1.02978 -2.24159 1.03728 -3.38014 0.0245 -0.49208 -0.0533 -0.98402 -0.2287 -1.44469 -0.1788 -0.46987 -0.455 -0.89657 -0.81054 -1.25207 -0.3555 -0.355497 -0.78221 -0.631739 -1.25207 -0.810571ZM6.99994 7.75481c0.33753 -0.48178 0.64883 -0.97259 0.91163 -1.45771 0.51963 -0.95924 0.79588 -1.79933 0.79588 -2.45607 0 -1.1317 -0.79588 -1.70918 -1.76553 -1.70918s-1.64948 0.78277 -1.64948 1.70918c0 0.65674 0.27625 1.49683 0.79588 2.45607 0.2628 0.48512 0.5741 0.97593 0.91162 1.45771Z", clipRule: "evenodd" }),
      " "
    ] }),
    " "
  ] }) }),
  "MedicalRibbon1"
);
var MedicalSearchDiagnosis = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 6.25a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1 -9.5 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 6.25a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1 -9.5 0ZM6.25 0a6.25 6.25 0 1 0 3.656 11.32l2.387 2.387a1 1 0 0 0 1.414 -1.414L11.32 9.906A6.25 6.25 0 0 0 6.25 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.438 3.031a0.5 0.5 0 0 0 -0.5 0.5v1.406l-1.407 0a0.5 0.5 0 0 0 -0.5 0.5v1.625a0.5 0.5 0 0 0 0.5 0.5h1.406V8.97a0.5 0.5 0 0 0 0.5 0.5h1.625a0.5 0.5 0 0 0 0.5 -0.5V7.562H8.97a0.5 0.5 0 0 0 0.5 -0.5V5.437a0.5 0.5 0 0 0 -0.5 -0.5l-1.406 0V3.531a0.5 0.5 0 0 0 -0.5 -0.5H5.438Z" }),
    " "
  ] }) }),
  "MedicalSearchDiagnosis"
);
var MicroscopeObservationSciene = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.959 0.018h1a0.5 0.5 0 0 1 0.5 0.5l0 1.72h-2l0 -1.72a0.5 0.5 0 0 1 0.5 -0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.709 2.738a0.5 0.5 0 0 1 0.5 -0.5h3v4c0 0.554 -0.446 1.006 -1 1.012l-1.459 0.017a1.03 1.03 0 0 1 -1.04 -1.029v-3.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.19 4.791h1.54a3.22 3.22 0 0 1 3.222 3.22v1.721h2.038a0.75 0.75 0 0 1 0.719 0.534V8.04a5.802 5.802 0 0 0 -5.802 -5.802H6.189v2.553Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.959 9.732a0.75 0.75 0 1 0 0 1.5h3.05c0 0.246 -0.108 0.582 -0.305 0.908 -0.23 0.222 -0.488 0.342 -0.745 0.342h-2.95a0.75 0.75 0 0 0 0 1.5h11.95a0.75 0.75 0 0 0 0.75 -0.75v-2.535a0.75 0.75 0 0 0 -0.719 -0.965H1.96Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MicroscopeObservationSciene"
);
var NurseAssistantEmergency = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2 3a3 3 0 1 0 6 0 3 3 0 1 0 -6 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.406 6.5a0.5 0.5 0 0 0 -0.5 0.5v1.906H7a0.5 0.5 0 0 0 -0.5 0.5v1.625a0.5 0.5 0 0 0 0.5 0.5h1.906V13.5a0.5 0.5 0 0 0 0.5 0.5h1.625a0.5 0.5 0 0 0 0.5 -0.5v-1.969H13.5a0.5 0.5 0 0 0 0.5 -0.5V9.406a0.5 0.5 0 0 0 -0.5 -0.5h-1.969V7a0.5 0.5 0 0 0 -0.5 -0.5H9.406Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.478 7.656A5 5 0 0 0 0 12a0.5 0.5 0 0 0 0.5 0.5h5.548a1.748 1.748 0 0 1 -0.798 -1.469V9.406c0 -0.966 0.784 -1.75 1.75 -1.75h0.478Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NurseAssistantEmergency"
);
var NurseHat = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.21 1.867H4.75a1.5 1.5 0 0 0 -1.48 1.03L2.146 5.68a0.5 0.5 0 0 0 0.464 0.687h8.78a0.5 0.5 0 0 0 0.461 -0.693l-1.162 -2.78a1.5 1.5 0 0 0 -1.48 -1.027Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M13.837 6.54a0.492 0.492 0 0 0 -0.344 -0.632 26.575 26.575 0 0 0 -12.986 0 0.492 0.492 0 0 0 -0.344 0.632l1.766 5.405a1 1 0 0 0 0.95 0.689h8.242a1 1 0 0 0 0.95 -0.69l1.766 -5.404Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.625 7.367a0.625 0.625 0 0 0 -1.25 0v0.875H5.5a0.625 0.625 0 0 0 0 1.25h0.875v0.875a0.625 0.625 0 1 0 1.25 0v-0.875H8.5a0.625 0.625 0 1 0 0 -1.25h-0.875v-0.875Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NurseHat"
);
var OnlineMedicalCallService = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.971 13.476a2.661 2.661 0 0 0 3.321 -0.355l0.375 -0.374a0.897 0.897 0 0 0 0 -1.261L9.09 9.919a0.887 0.887 0 0 0 -1.252 0 0.897 0.897 0 0 1 -1.261 0L4.064 7.406a0.897 0.897 0 0 1 0 -1.262 0.887 0.887 0 0 0 0 -1.251L2.546 3.316a0.897 0.897 0 0 0 -1.261 0L0.91 3.69a2.66 2.66 0 0 0 -0.404 3.321 23.88 23.88 0 0 0 6.465 6.465Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.371 0.1a0.493 0.493 0 0 0 -0.492 0.493V2.47H7a0.493 0.493 0 0 0 -0.493 0.493v1.602c0 0.272 0.22 0.492 0.493 0.492h1.879v1.94c0 0.273 0.22 0.493 0.492 0.493h1.602c0.272 0 0.493 -0.22 0.493 -0.492v-1.94h1.94a0.493 0.493 0 0 0 0.492 -0.493V2.964a0.493 0.493 0 0 0 -0.492 -0.493h-1.94V0.593A0.493 0.493 0 0 0 10.973 0.1H9.37Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "OnlineMedicalCallService"
);
var OnlineMedicalServiceMonitor = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.33a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.331l0.687 1.919H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.919Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.252C0.652 0.252 0 0.905 0 1.71v7.587c0 0.804 0.652 1.456 1.457 1.456h11.086c0.805 0 1.457 -0.652 1.457 -1.456V1.709c0 -0.804 -0.652 -1.457 -1.457 -1.457H1.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.38 2.272a0.392 0.392 0 0 0 -0.392 0.392v1.56h-1.56a0.392 0.392 0 0 0 -0.393 0.393v1.275c0 0.217 0.176 0.392 0.392 0.392h1.56v1.56c0 0.217 0.176 0.393 0.393 0.393h1.275a0.392 0.392 0 0 0 0.392 -0.393l0 -1.56h1.56A0.392 0.392 0 0 0 10 5.892V4.617a0.392 0.392 0 0 0 -0.392 -0.392l-1.56 0v-1.56a0.392 0.392 0 0 0 -0.393 -0.393H6.38Z" }),
    " "
  ] }) }),
  "OnlineMedicalServiceMonitor"
);
var OnlineMedicalWebService = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.751 0.046C0.81 0.046 0.047 0.809 0.047 1.75v10.5c0 0.94 0.763 1.704 1.704 1.704h10.5c0.94 0 1.704 -0.764 1.704 -1.705V1.75c0 -0.941 -0.764 -1.704 -1.705 -1.704H1.751Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.751 0.046C0.81 0.046 0.047 0.809 0.047 1.75V3.5h13.907V1.75c0 -0.941 -0.763 -1.704 -1.704 -1.704H1.751Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.363 5.53a0.392 0.392 0 0 0 -0.393 0.393v1.56H4.41a0.392 0.392 0 0 0 -0.392 0.392V9.15c0 0.217 0.175 0.393 0.392 0.393h1.56v1.56c0 0.217 0.176 0.392 0.392 0.392h1.276a0.392 0.392 0 0 0 0.392 -0.392l0 -1.56h1.56a0.392 0.392 0 0 0 0.392 -0.393V7.875a0.392 0.392 0 0 0 -0.392 -0.392l-1.56 0v-1.56a0.392 0.392 0 0 0 -0.392 -0.393H6.363Z" }),
    " "
  ] }) }),
  "OnlineMedicalWebService"
);
var PetriDishLabEquipment = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.5 4.834a1.667 1.667 0 0 1 -2.797 1.225 1.25 1.25 0 1 1 -0.385 -1.922 1.667 1.667 0 0 1 3.182 0.697ZM3.576 8.735a0.533 0.533 0 0 1 0.186 -0.04c0.083 -0.002 0.132 0.017 0.165 0.042 0.032 0.025 0.063 0.068 0.081 0.148 0.02 0.087 0.014 0.168 0.01 0.19 -0.036 0.182 -0.045 0.442 0.018 0.713 0.064 0.277 0.215 0.608 0.537 0.856 0.321 0.248 0.68 0.309 0.965 0.3 0.278 -0.008 0.526 -0.083 0.693 -0.164a0.625 0.625 0 1 0 -0.545 -1.125 0.533 0.533 0 0 1 -0.186 0.04c-0.082 0.002 -0.132 -0.016 -0.165 -0.041 -0.032 -0.025 -0.063 -0.068 -0.081 -0.149a0.533 0.533 0 0 1 -0.01 -0.19 1.765 1.765 0 0 0 -0.018 -0.712 1.49 1.49 0 0 0 -0.536 -0.856 1.49 1.49 0 0 0 -0.965 -0.3 1.765 1.765 0 0 0 -0.694 0.163 0.625 0.625 0 0 0 0.545 1.125Zm3.549 -0.37a0.875 0.875 0 1 1 1.75 0 0.875 0.875 0 0 1 -1.75 0ZM3.539 4.208a0.875 0.875 0 1 0 0 1.75 0.875 0.875 0 0 0 0 -1.75ZM9.375 9.83a0.875 0.875 0 1 1 1.75 0 0.875 0.875 0 0 1 -1.75 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PetriDishLabEquipment"
);
var Pharmacy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.103 1.515 7.512 5.576l3.07 0 1.72 -2.645a1.308 1.308 0 1 0 -2.2 -1.416Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m1.067 8.847 -0.29 -2.58a1 1 0 0 1 0.994 -1.111h10.458a1 1 0 0 1 0.994 1.112l-0.29 2.58a3.998 3.998 0 0 1 -2.055 3.062c0.156 0.307 0.266 0.643 0.32 1a0.816 0.816 0 0 1 -0.808 0.937l-6.78 0a0.816 0.816 0 0 1 -0.808 -0.937 3.26 3.26 0 0 1 0.32 -1 3.998 3.998 0 0 1 -2.055 -3.063Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.625 7.752a0.625 0.625 0 1 0 -1.25 0v1.124H5.25a0.625 0.625 0 0 0 0 1.25h1.125v1.125a0.625 0.625 0 1 0 1.25 0v-1.124H8.75a0.625 0.625 0 0 0 0 -1.25H7.625V7.751Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Pharmacy"
);
var PrescriptionPillsDrugsHealthcare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.923 0.25H7.23a3.288 3.288 0 0 1 0 6.577h-0.642l2.374 2.226 2.584 -2.583a0.75 0.75 0 0 1 1.06 1.06l-2.549 2.55 2.532 2.373a0.75 0.75 0 0 1 -1.026 1.094l-2.567 -2.406 -2.39 2.39a0.75 0.75 0 0 1 -1.06 -1.061l2.355 -2.356 -3.506 -3.287H2.673v5.25a0.75 0.75 0 0 1 -1.5 0V1a0.75 0.75 0 0 1 0.75 -0.75Zm0.75 1.5v3.577H7.23a1.788 1.788 0 0 0 0 -3.577H2.673Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PrescriptionPillsDrugsHealthcare"
);
var Stethoscope = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.801758 0.65625c-0.414214 0 -0.7500002 0.335786 -0.7500002 0.75V5c0 1.95741 1.4170522 3.58385 3.2812522 3.90942v0.54834c0 2.45684 1.99165 4.44844 4.44848 4.44844 2.45681 0 4.44851 -1.9916 4.44851 -4.44844V6.34375c0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75v3.11401c0 1.62844 -1.3201 2.94844 -2.94851 2.94844 -1.6284 0 -2.94848 -1.32 -2.94848 -2.94844v-0.57225C6.63519 8.51058 7.98926 6.91342 7.98926 5V1.40625c0 -0.414214 -0.33579 -0.75 -0.75 -0.75H6.14551c-0.41422 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.33578 0.75 0.75 0.75h0.34375V5c0 1.36345 -1.1053 2.46875 -2.46875 2.46875 -1.36346 0 -2.46875 -1.1053 -2.46875 -2.46875V2.15625h0.34375c0.41421 0 0.75 -0.33579 0.75 -0.75 0 -0.414214 -0.33579 -0.75 -0.75 -0.75H0.801758Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.0311 1.98299c-1.3394 -0.30669 -2.67378 0.53046 -2.98048 1.86983 -0.3067 1.33937 0.53045 2.67377 1.86978 2.98046 1.3394 0.3067 2.6738 -0.53045 2.9805 -1.86982 0.3067 -1.33937 -0.5304 -2.67377 -1.8698 -2.98047Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Stethoscope"
);
var Syringe = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.47 0.393a1 1 0 0 1 1.414 0l2.723 2.723a1 1 0 0 1 -1.414 1.414l-0.655 -0.654 -2.016 2.016a1 1 0 1 1 -1.414 -1.414l2.016 -2.016 -0.654 -0.655a1 1 0 0 1 0 -1.414Zm-5.348 10.9a1 1 0 0 0 -1.414 -1.415L0.393 12.193a1 1 0 1 0 1.414 1.414l2.315 -2.315Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.346 1.3A1 1 0 1 0 4.93 2.716l1.001 1.001 -3.44 3.372 -0.002 0.003a2.315 2.315 0 0 0 0 3.276l1.143 1.143a2.315 2.315 0 0 0 3.276 0l0.003 -0.003 3.372 -3.44 1 1.002A1 1 0 1 0 12.7 7.654L6.346 1.301Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Syringe"
);
var TabletCapsule = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m5.618 3.203 -0.707 -0.707 -0.708 0.707 -2.718 2.719a4.662 4.662 0 1 0 6.593 6.593l2.719 -2.718 0.707 -0.708 -0.707 -0.707 -5.18 -5.179Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.218 0.12a4.662 4.662 0 0 0 -3.296 1.365L4.204 3.203l-0.708 0.708 0.708 0.707 5.178 5.179 0.707 0.707 0.708 -0.707 1.718 -1.719A4.662 4.662 0 0 0 9.218 0.12Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TabletCapsule"
);
var Thermometer = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.75 2.25a2.25 2.25 0 0 1 4.5 0v5.569a3.5 3.5 0 1 1 -4.5 0V2.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 2.25a0.75 0.75 0 0 1 1.5 0v5.945c0 0.253 0.128 0.49 0.34 0.628a2 2 0 1 1 -2.18 0 0.75 0.75 0 0 0 0.34 -0.628V2.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Thermometer"
);
var Tooth = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.887 4.861c0.359 -3.27 3.235 -3.585 5.195 -2.45 0.615 0.357 1.22 0.357 1.836 0 1.96 -1.135 4.836 -0.82 5.195 2.45 0.36 3.28 -1.486 6.751 -2.476 8.08 -0.225 0.302 -0.588 0.447 -0.965 0.447a1.464 1.464 0 0 1 -1.378 -0.969l-0.35 -0.971a1.003 1.003 0 0 0 -1.887 0l-0.35 0.971c-0.21 0.582 -0.762 0.969 -1.38 0.969 -0.376 0 -0.74 -0.145 -0.965 -0.447 -0.989 -1.329 -2.836 -4.8 -2.475 -8.08Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { stroke: "var(--semo-icon-solid)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.25", d: "M8.666 4.697c-1.368 0.499 -2.103 0.489 -3.332 0" }),
    " "
  ] }) }),
  "Tooth"
);
var Wheelchair1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.98 2a2 2 0 1 1 4 0 2 2 0 0 1 -4 0Zm3 4a1 1 0 1 0 -2 0v3a1 1 0 0 0 1 1h2.52v3a1 1 0 1 0 2 0V9.98A1.98 1.98 0 0 0 10.52 8H8.98V6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.28 6.383a0.75 0.75 0 0 1 -0.75 0.75 2.682 2.682 0 1 0 2.071 4.39 0.75 0.75 0 1 1 1.157 0.954 4.182 4.182 0 1 1 -3.23 -6.844 0.75 0.75 0 0 1 0.751 0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Wheelchair1"
);
var Wheelchair = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.0822754 0.832275c0 -0.414213 0.3357866 -0.7499996 0.7499996 -0.7499996H3.20448c0.3576 0 0.66547 0.2524696 0.73549 0.6031486l0.63741 3.192386h4.10691c0.63075 -0.00731 1.24346 0.21081 1.72771 0.61518 0.4753 0.39684 0.7961 0.94737 0.9075 1.55555l1.1069 4.06056 0.0042 0.0149 0.2524 0.9265c0.1088 0.3996 -0.1268 0.812 -0.5264 0.9209 -0.3996 0.1089 -0.8119 -0.1268 -0.9208 -0.5264l-0.1019 -0.3739H7.43647c-0.41421 0 -0.75 -0.3358 -0.75 -0.75 0 -0.41421 0.33579 -0.74999 0.75 -0.74999H10.725l-0.2378 -0.87221 -5.40578 0c-0.41421 0 -0.75 -0.33579 -0.75 -0.75 0 -0.41422 0.33579 -0.75 0.75 -0.75l4.99688 0 -0.21514 -0.78921c-0.0066 -0.02423 -0.01199 -0.04879 -0.01613 -0.07357 -0.04523 -0.27054 -0.18586 -0.51593 -0.3964 -0.69174 -0.21055 -0.17581 -0.4771 -0.2704 -0.75137 -0.26664l-0.01026 0.00014 -3.81212 -0.00006 0.20175 1.01039c0.0811 0.4062 -0.18244 0.80123 -0.58864 0.88234 -0.40619 0.0811 -0.80123 -0.18244 -0.88233 -0.58864L2.58943 1.58228H0.832275c-0.414213 0 -0.7499996 -0.33579 -0.7499996 -0.750005Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.91615 6.25C1.79876 6.25 0.0822754 7.96648 0.0822754 10.0839c0 2.1174 1.7164846 3.8338 3.8338746 3.8338 2.11738 0 3.83387 -1.7164 3.83387 -3.8338 0 -2.11742 -1.71649 -3.8339 -3.83387 -3.8339Zm8.10345 3.8715c-1.0483 0 -1.8981 0.8498 -1.8981 1.8981 0 1.0483 0.8498 1.8981 1.8981 1.8981 1.0483 0 1.8981 -0.8498 1.8981 -1.8981 0 -1.0483 -0.8498 -1.8981 -1.8981 -1.8981Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Wheelchair"
);
var BeerMug = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.414 0.45A1.42 1.42 0 0 1 1.446 0h7.566c0.393 0 0.764 0.165 1.032 0.45 0.268 0.282 0.414 0.66 0.414 1.05v0.75h1.777A1.75 1.75 0 0 1 13.986 4v4.5a1.75 1.75 0 0 1 -1.75 1.75h-1.777v1.25a2.56 2.56 0 0 1 -0.69 1.758A2.341 2.341 0 0 1 8.066 14H2.392c-0.644 0 -1.255 -0.27 -1.701 -0.742A2.56 2.56 0 0 1 0 11.5v-10C0 1.11 0.146 0.732 0.414 0.45Zm10.044 8.3h1.777a0.25 0.25 0 0 0 0.25 -0.25V4a0.25 0.25 0 0 0 -0.25 -0.25h-1.777v5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.802 4a0.625 0.625 0 1 0 -1.25 0v5.5a0.625 0.625 0 1 0 1.25 0V4Zm4.104 0a0.625 0.625 0 1 0 -1.25 0v5.5a0.625 0.625 0 1 0 1.25 0V4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BeerMug"
);
var BeerPitch = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.77551 6.06329c0 -0.27614 0.22386 -0.5 0.5 -0.5H10.078c0.2274 0 0.4193 0.1518 0.48 0.3596 0.0025 -0.00003 0.005 -0.00004 0.0076 -0.00004h1.5906c0.9665 0 1.75 0.7835 1.75 1.75v2.38885c0 0.9665 -0.7835 1.75 -1.75 1.75h-1.5906l-0.0069 0C10.4053 13.0453 9.35315 14 8.07798 14H4.27551c-1.38071 0 -2.5 -1.1193 -2.5 -2.5V6.06329ZM10.578 10.3117h1.5782c0.1381 0 0.25 -0.1119 0.25 -0.25V7.67285c0 -0.13807 -0.1119 -0.25 -0.25 -0.25H10.578v2.88885Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.77724 6.27943C1.02165 5.9166 0.5 5.14422 0.5 4.25 0.5 3.00736 1.50736 2 2.75 2c0.27276 0 0.53418 0.04853 0.7761 0.13744C3.70172 0.928547 4.74242 0 6 0s2.29828 0.928548 2.4739 2.13744C8.71582 2.04854 8.97724 2 9.25 2c1.2426 0 2.25 1.00736 2.25 2.25S10.4926 6.5 9.25 6.5c-0.00185 0 -0.00369 0 -0.00554 -0.00001H4.50001v2.13862c0 0.75187 -0.60951 1.36138 -1.36139 1.36138 -0.75187 0 -1.36138 -0.60951 -1.36138 -1.36138V6.27943Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BeerPitch"
);
var Burger = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.0195923 7.5c0 -0.41421 0.3357867 -0.75 0.7499997 -0.75H13.2304c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75H0.769592c-0.414213 0 -0.7499997 -0.33579 -0.7499997 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 0C2.94953 0 1.93591 0.389977 1.18359 1.0936 0.430139 1.79828 0 2.76147 0 3.77346c0 0.39187 0.166747 0.76033 0.451355 1.02652 0.283477 0.26513 0.661215 0.40876 1.048645 0.40876h11c0.3874 0 0.7652 -0.14363 1.0486 -0.40876 0.2847 -0.26619 0.4514 -0.63465 0.4514 -1.02652 0 -1.01199 -0.4301 -1.97518 -1.1836 -2.67986C12.0641 0.389977 11.0505 0 10 0H4ZM0.306084 10.0174C0.495961 9.84094 0.746138 9.74757 1 9.74757h1.5c0.07278 0 0.14468 0.01588 0.21069 0.04655l2.69517 1.25228 1.25378 -1.1651c0.0925 -0.08596 0.21409 -0.13373 0.34036 -0.13373h6c0.2539 0 0.504 0.09337 0.6939 0.26983 0.1911 0.1776 0.3061 0.4266 0.3061 0.6948 0 0.8843 -0.3784 1.7243 -1.0383 2.3375C12.303 13.6619 11.4169 14 10.5 14h-7c-0.9169 0 -1.80297 -0.3381 -2.46168 -0.9503C0.378363 12.4365 0 11.5965 0 10.7122c0 -0.2682 0.114971 -0.5172 0.306084 -0.6948Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Burger"
);
var BurritoFastfood = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m0.354362 11.0127 2.666558 2.6666c0.39053 0.3905 1.02369 0.3905 1.41422 0l5.47169 -5.47169 -4.08078 -4.08078L0.354362 9.59852c-0.3905247 0.39052 -0.3905242 1.02368 0 1.41418Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.458573 9.49454 5.80868 11.4631c0.79999 0.2943 1.57787 -0.4831 1.28402 -1.2832L5.12672 4.82639 0.458573 9.49454Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.2934 1.98087c-0.2509 -0.25086 -0.5528 -0.42145 -0.8722 -0.51141 -0.0899 -0.31942 -0.2605 -0.621317 -0.5114 -0.872183 -0.3739 -0.373931 -0.8607 -0.569246 -1.3508 -0.5852209l-0.0012 -0.0000393c-0.4466 -0.01343509 -0.89877 0.1221052 -1.27319 0.4075952 -0.68509 -0.208465 -1.46048 -0.040621 -2.00156 0.50046 -0.7807 0.780708 -0.78139 2.046938 0 2.828328l2.85925 2.85924c0.7814 0.78139 2.0476 0.7807 2.8283 0 0.5411 -0.54108 0.7089 -1.31648 0.5005 -2.00156 0.2855 -0.37442 0.421 -0.82656 0.4076 -1.27315l-0.0001 -0.00125c-0.0159 -0.49012 -0.2113 -0.97688 -0.5852 -1.35081Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.8817 5.9313c-0.0109 -0.01001 -0.0217 -0.02029 -0.0322 -0.03087L7.99022 3.0412c-0.01015 -0.01015 -0.02003 -0.02046 -0.02965 -0.03093 0.09651 -0.12362 0.20882 -0.23806 0.33662 -0.34032 0.33188 -0.26557 0.72098 -0.41126 1.11501 -0.4429 0.5976 -0.04797 1.2065 0.16642 1.6442 0.62292 0.4565 0.43774 0.6518 1.03583 0.6038 1.63343 -0.0317 0.39402 -0.1774 0.78312 -0.4429 1.115 -0.101 0.12616 -0.2138 0.23723 -0.3356 0.3329Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BurritoFastfood"
);
var CakeSlice = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.224 3.42a2.031 2.031 0 1 1 -1.256 -0.063 2.85 2.85 0 0 1 0.152 -0.624c0.09 -0.24 0.24 -0.521 0.494 -0.747 0.267 -0.238 0.62 -0.385 1.045 -0.385a0.625 0.625 0 1 1 0 1.25c-0.118 0 -0.175 0.034 -0.215 0.069a0.634 0.634 0 0 0 -0.153 0.252c-0.03 0.082 -0.053 0.168 -0.067 0.248Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.5 6.973a0.5 0.5 0 0 0 -0.5 0.5V13.5a0.5 0.5 0 0 0 0.5 0.5h13a0.5 0.5 0 0 0 0.5 -0.5V7.473a0.5 0.5 0 0 0 -0.5 -0.5H0.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.5 6.973a0.5 0.5 0 0 0 -0.5 0.5V10h14V7.473a0.5 0.5 0 0 0 -0.5 -0.5H0.5Z" }),
    " "
  ] }) }),
  "CakeSlice"
);
var CandyCane = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5.3652 4.84615c0 -0.42842 0.17019 -0.8393 0.47313 -1.14225 0.30295 -0.30294 0.71383 -0.47313 1.14225 -0.47313 0.42843 0 0.83931 0.17019 1.14225 0.47313 0.30295 0.30295 0.47314 0.71383 0.47314 1.14225v7.53845c0 0.4284 0.17019 0.8393 0.47313 1.1423 0.30295 0.3029 0.71383 0.4731 1.1423 0.4731 0.4284 0 0.8393 -0.1702 1.1422 -0.4731 0.3029 -0.303 0.4731 -0.7139 0.4731 -1.1423V4.84615c0 -1.28528 -0.5105 -2.51791 -1.4194 -3.42674C9.4985 0.510575 8.26586 0 6.98058 0 5.6953 0 4.46267 0.510575 3.55384 1.41941c-0.90883 0.90883 -1.41941 2.14146 -1.41941 3.42674v1.07693c0 0.42842 0.17019 0.8393 0.47314 1.14225 0.30294 0.30294 0.71382 0.47313 1.14224 0.47313 0.42843 0 0.83931 -0.17019 1.14225 -0.47313 0.30295 -0.30295 0.47314 -0.71383 0.47314 -1.14225V4.84615Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.29025 3.62694c0.104 -0.40003 0.25874 -0.78507 0.4603 -1.14562 0.03177 0.00729 0.06339 0.01716 0.09459 0.02973L5.82918 3.7131c-0.29724 0.30203 -0.46402 0.70895 -0.46402 1.13306v0.02763L2.37808 3.67051c-0.03085 -0.01243 -0.06016 -0.02703 -0.08783 -0.04357Zm6.30568 1.45802v-0.2388c0 -0.42843 -0.17019 -0.83931 -0.47314 -1.14225 -0.02496 -0.02497 -0.05067 -0.04904 -0.07705 -0.07218L9.80309 0.906784c0.21371 0.153116 0.41591 0.324316 0.60421 0.512626 0.1139 0.1139 0.2215 0.23289 0.3227 0.35644L8.59593 5.08496Zm0 6.02974V9.34692l3.23077 -3.23077v1.76776L8.59593 11.1147Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CandyCane"
);
var ChampagnePartyAlcohol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.95 0.09a0.75 0.75 0 0 0 -0.743 0.484L1.298 5.632A3.08 3.08 0 0 0 2.64 9.386l-0.672 2.357 -0.742 -0.212a0.75 0.75 0 0 0 -0.412 1.443l1.43 0.407a0.663 0.663 0 0 0 0.07 0.02l1.426 0.407a0.75 0.75 0 1 0 0.41 -1.443l-0.74 -0.21 0.673 -2.358A3.08 3.08 0 0 0 7.2 7.315L8.246 2.01a0.75 0.75 0 0 0 -0.53 -0.867L4.115 0.118A0.752 0.752 0 0 0 3.95 0.09ZM7.858 9a3.082 3.082 0 0 0 2.144 0.868l0.596 2.376 -0.75 0.189a0.75 0.75 0 1 0 0.364 1.455l1.45 -0.364a0.799 0.799 0 0 0 0.058 -0.015l1.443 -0.362a0.75 0.75 0 0 0 -0.365 -1.454l-0.745 0.186 -0.597 -2.377a3.08 3.08 0 0 0 1.458 -3.708L11.168 0.68a0.75 0.75 0 0 0 -0.893 -0.486L8.986 0.517c0.415 0.454 0.613 1.092 0.486 1.736L8.425 7.557A4.32 4.32 0 0 1 7.858 9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.727 7.024A1.578 1.578 0 1 1 2.7 6.162l0.987 -2.615 2.574 0.766 -0.535 2.711Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.487 7.242a1.579 1.579 0 1 0 3.007 -0.962l-0.892 -2.615 -1.479 0.353 -0.636 3.224Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChampagnePartyAlcohol"
);
var Cheese = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 5.66001c-0.1569 -1.33519 -0.721 -2.58975 -1.6154 -3.59337C11.4901 1.06302 10.3084 0.358951 9.00001 0.0500078 8.8908 0.0100839 8.77412 -0.00523904 8.6583 0.00513256 8.54249 0.0155042 8.43039 0.0513146 8.33001 0.110008L0.620008 5.00001c-0.173639 0.10738 -0.320002 0.25358 -0.427583 0.4271 -0.1075801 0.17351 -0.1734453 0.36962 -0.192416691 0.5729V10.4c-0.000724964 0.153 0.046006691 0.3025 0.133759691 0.4279 0.087754 0.1253 0.212213 0.2204 0.35624 0.2721 0.141557 0.0545 0.296588 0.0636 0.443545 0.026 0.146957 -0.0376 0.278537 -0.1201 0.376457 -0.236 0.11099 -0.134 0.24874 -0.2434 0.40444 -0.3211 0.15569 -0.0778 0.32591 -0.1221 0.49974 -0.1303 0.17383 -0.0081 0.34744 0.0201 0.50973 0.0829 0.1623 0.0628 0.30968 0.1588 0.43274 0.2819 0.12305 0.123 0.21905 0.2704 0.28186 0.4327s0.09104 0.3359 0.08288 0.5097c-0.00816 0.1739 -0.05252 0.3441 -0.13025 0.4998 -0.07773 0.1557 -0.18711 0.2934 -0.32114 0.4044 -0.11587 0.0979 -0.19835 0.2295 -0.23598 0.3765 -0.03764 0.1469 -0.02856 0.302 0.02598 0.4435 0.05169 0.144 0.14677 0.2685 0.27213 0.3562 0.12536 0.0878 0.27485 0.1345 0.42787 0.1338H12.75c0.3247 0.0002 0.6367 -0.126 0.87 -0.3519 0.2333 -0.2258 0.3696 -0.5336 0.38 -0.8581V5.66001Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.3845 2.06664C13.279 3.07026 13.843 4.32482 14 5.66001c0 0.18777 -0.1522 0.34 -0.34 0.34H0.609753c-0.32718 0 -0.5897397 -0.29483 -0.417336 -0.5729 0.107581 -0.17352 0.253944 -0.31972 0.427583 -0.4271L8.33 0.110008c0.10038 -0.0586934 0.21248 -0.0945038 0.32829 -0.10487544 0.11582 -0.0103716 0.2325 0.00495134 0.34171 0.04487524C10.3084 0.358951 11.4901 1.06302 12.3845 2.06664Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 9.25a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 1 0 -3.5 0" }),
    " "
  ] }) }),
  "Cheese"
);
var Cherries = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.02777 0.0455326h2.45205c0.41421 0 0.75 0.3357864 0.75 0.7500004 0 0.414217 -0.33579 0.749997 -0.75 0.749997H6.85131c0.31371 2.10773 1.35107 4.05087 2.94719 5.4875 0.3079 0.27711 0.3328 0.75133 0.0557 1.0592 -0.2771 0.30787 -0.75132 0.33281 -1.05919 0.0557 -1.56114 -1.40514 -2.66263 -3.22694 -3.19038 -5.22885 -0.83923 1.66554 -1.2988 3.50576 -1.33419 5.38711 -0.00779 0.41414 -0.34984 0.74355 -0.76398 0.73576 -0.41414 -0.00779 -0.74355 -0.34983 -0.73576 -0.76397 0.04466 -2.37391 0.69229 -4.68935 1.87159 -6.73245H3.48212c-0.41422 0 -0.75 -0.33578 -0.75 -0.749997 0 -0.414214 0.33578 -0.7500004 0.75 -0.7500004h2.52903c0.00553 -0.0000615 0.01108 -0.0000616 0.01662 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.53247 9.84082c0 -1.70171 1.37951 -3.08122 3.08123 -3.08122 1.7017 0 3.0812 1.37951 3.0812 3.08122 0 1.70168 -1.3795 3.08118 -3.0812 3.08118 -1.70172 0 -3.08123 -1.3795 -3.08123 -3.08118ZM3.38633 7.79208c-1.70171 0 -3.081215 1.37951 -3.081215 3.08122 0 1.7017 1.379505 3.0812 3.081215 3.0812 1.70171 0 3.08122 -1.3795 3.08122 -3.0812 0 -1.70171 -1.37951 -3.08122 -3.08122 -3.08122Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cherries"
);
var ChickenGrilledStream = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.52405 0.519897c0.34518 0 0.625 0.279822 0.625 0.625003v1.5625c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625V1.1449c0 -0.345181 0.27982 -0.625003 0.625 -0.625003ZM2.8678 2.30798c0 -0.34517 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27983 -0.625 0.625v1.5625c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625v-1.5625Zm4.5625 0c0 -0.34517 -0.27982 -0.625 -0.625 -0.625s-0.625 0.27983 -0.625 0.625v1.5625c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625v-1.5625Zm3.5781 2.35684c0 -0.80383 0.6517 -1.45547 1.4555 -1.45547 0.8038 0 1.4555 0.65164 1.4555 1.45547s-0.6517 1.45547 -1.4555 1.45547c-0.1615 0 -0.3168 -0.0263 -0.462 -0.07485 -0.0108 0.01166 -0.0222 0.02299 -0.034 0.03397l-1.7071 1.57813c-0.2534 0.23432 -0.64886 0.2188 -0.88318 -0.03466 -0.23432 -0.25346 -0.21881 -0.64888 0.03465 -0.8832l1.68923 -1.56165c-0.0602 -0.15961 -0.0931 -0.33256 -0.0931 -0.51321Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.60048 6.57163c0.91567 -0.79126 2.11132 -0.81447 2.79052 -0.19603 0.503 0.45794 0.6821 1.23072 0.4561 2.00116 0.1292 -0.0584 0.2822 -0.06177 0.4203 0.0037 0.7982 0.37834 1.3587 0.83617 1.7113 1.41238 0.3522 0.57556 0.4631 1.21456 0.4631 1.89046v0.2968c0 0.8284 -0.6715 1.5 -1.5 1.5H1.63979c-0.47786 0 -1.00102 -0.2393 -1.22134 -0.7707 -0.317609 -0.766 -0.665525 -2.2669 0.252736 -4.10091C2.02497 5.90467 5.32868 5.33326 7.44392 6.44335c0.06237 0.03273 0.11495 0.07677 0.15656 0.12828Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m7.63638 6.54115 -0.19328 -0.09792c-0.25427 -0.13344 -0.52571 -0.24259 -0.80888 -0.32665 -0.00924 0.00993 -0.01843 0.01992 -0.02758 0.02997 -1.09766 1.20553 -1.31231 2.96922 -0.40007 4.15015 0.09203 0.1191 0.19509 0.2312 0.30908 0.335 0.20418 0.1859 0.52042 0.1711 0.70633 -0.0331 0.18591 -0.2042 0.1711 -0.5204 -0.03308 -0.7063 -0.07064 -0.06432 -0.13423 -0.13354 -0.19096 -0.20697 -0.55293 -0.71578 -0.49696 -1.93741 0.34812 -2.86553 0.09291 -0.10205 0.19002 -0.19487 0.29032 -0.27865Zm4.16282 2.12502c-0.1558 0.52286 -0.4353 1.02604 -0.8265 1.45573 -0.1859 0.2042 -0.5022 0.219 -0.7064 0.0331 -0.2041 -0.18595 -0.219 -0.50219 -0.033 -0.70637 0.3544 -0.38931 0.5697 -0.82702 0.66 -1.25744l0.3733 0.18915c0.191 0.09054 0.3684 0.18564 0.5326 0.28583Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChickenGrilledStream"
);
var Cocktail = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.536 0.026a1.447 1.447 0 0 0 -1.138 2.342L6.25 8.543v3.946H4a0.75 0.75 0 0 0 0 1.5h6a0.75 0.75 0 0 0 0 -1.5H7.75V8.543l4.852 -6.175A1.447 1.447 0 0 0 11.464 0.026H2.536Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.197 3H3.803l2.214 2.82a1.25 1.25 0 0 0 1.966 0L10.197 3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cocktail"
);
var CoffeeBean = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M10.9248 10.9248c-2.81785 2.8178 -6.85937 3.345 -9.02696 1.1774C-0.269748 9.93462 0.257406 5.89311 3.07527 3.07524 5.89314 0.257376 9.93465 -0.269778 12.1022 1.89781c2.1676 2.16759 1.6405 6.2091 -1.1774 9.02699Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.8222 2.84977c-0.0487 0.17331 -0.1051 0.35907 -0.1698 0.55328 -0.3287 0.98616 -0.8941 2.25227 -1.8375 3.19564 -0.54 0.54002 -1.20028 0.79114 -1.8585 0.91082 -0.63551 0.11555 -1.31542 0.11551 -1.92792 0.11549h-0.00001L7 7.625c-0.64501 0 -1.2187 0.00185 -1.73279 0.09532 -0.50124 0.09113 -0.89501 0.26163 -1.19824 0.56486 -0.74311 0.74311 -1.23179 1.79592 -1.5355 2.70702 -0.14957 0.4487 -0.24939 0.8481 -0.31158 1.1341 -0.01922 0.0884 -0.03477 0.1657 -0.04705 0.2299 -0.09536 -0.0801 -0.18777 -0.1648 -0.277 -0.254 -0.28692 -0.2869 -0.52662 -0.6067 -0.72004 -0.9521 0.04876 -0.1733 0.10509 -0.359 0.16981 -0.5532 0.32873 -0.98612 0.8941 -2.25223 1.83748 -3.1956 0.54001 -0.54001 1.20029 -0.79114 1.85851 -0.91082 0.63551 -0.11554 1.31542 -0.11551 1.92792 -0.11548L7 6.375c0.645 0 1.2187 -0.00186 1.73279 -0.09533 0.50124 -0.09113 0.89501 -0.26163 1.19824 -0.56486 0.74307 -0.74311 1.23177 -1.79592 1.53547 -2.70705 0.1496 -0.4487 0.2494 -0.84803 0.3116 -1.13411 0.0192 -0.08839 0.0348 -0.16568 0.0471 -0.22993 0.0954 0.08015 0.1878 0.16483 0.277 0.25409 0.2869 0.28689 0.5266 0.6066 0.72 0.95196Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CoffeeBean"
);
var CoffeeMug = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.94 5.44A1.5 1.5 0 0 1 3 5h5a1.5 1.5 0 0 1 1.429 1.044H9.5a3.25 3.25 0 1 1 0 6.5h-0.228A2.5 2.5 0 0 1 7 14H4a2.5 2.5 0 0 1 -2.5 -2.5v-5c0 -0.398 0.158 -0.78 0.44 -1.06Zm7.56 5.604a1.75 1.75 0 1 0 0 -3.5v3.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.75 0.773a0.75 0.75 0 0 0 -1.5 0v2a0.75 0.75 0 1 0 1.5 0v-2Zm3 0a0.75 0.75 0 0 0 -1.5 0v2a0.75 0.75 0 1 0 1.5 0v-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CoffeeMug"
);
var CoffeeTakeawayCup = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 0c-0.21522 0 -0.40628 0.137715 -0.47434 0.341886l-1 3.000004C2.00866 3.39287 2 3.44626 2 3.5V7c0 0.02545 0.00194 0.05087 0.00581 0.07603l1 6.49997c0.03753 0.2439 0.2474 0.424 0.49419 0.424h7c0.2468 0 0.4567 -0.1801 0.4942 -0.424l1 -6.49997C11.9981 7.05087 12 7.02545 12 7V3.5c0 -0.05374 -0.0087 -0.10713 -0.0257 -0.15811l-1 -3.000004C10.9063 0.137715 10.7152 0 10.5 0h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.8848 3.16347H2.11525c-0.5995 0 -1.0855 0.42133 -1.0855 0.94108v2.38216c0 0.51975 0.486 0.94109 1.0855 0.94109h9.76955c0.5995 0 1.0855 -0.42134 1.0855 -0.94109V4.10455c0 -0.51975 -0.486 -0.94108 -1.0855 -0.94108Z" }),
    " "
  ] }) }),
  "CoffeeTakeawayCup"
);
var Donut = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 13.5c3.5899 0 6.5 -2.9101 6.5 -6.5C13.5 3.41015 10.5899 0.5 7 0.5 3.41015 0.5 0.5 3.41015 0.5 7c0 3.5899 2.91015 6.5 6.5 6.5ZM7 9c1.10457 0 2 -0.89543 2 -2s-0.89543 -2 -2 -2 -2 0.89543 -2 2 0.89543 2 2 2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.44194 2.05806c-0.24408 -0.24408 -0.6398 -0.24408 -0.88388 0 -0.24408 0.24408 -0.24408 0.6398 0 0.88388l1 1c0.24408 0.24408 0.6398 0.24408 0.88388 0 0.24408 -0.24408 0.24408 -0.6398 0 -0.88388l-1 -1Zm3.33756 3.88292c0.3087 0.15437 0.4339 0.52979 0.2795 0.83853l-0.5 1c-0.1544 0.30873 -0.5298 0.43388 -0.8385 0.27951s-0.4339 -0.52979 -0.2795 -0.83853l0.5 -1c0.1544 -0.30873 0.5298 -0.43388 0.8385 -0.27951ZM2.55806 8.55806c0.24408 -0.24408 0.6398 -0.24408 0.88388 0l1 1c0.24408 0.24408 0.24408 0.63984 0 0.88384 -0.24408 0.2441 -0.6398 0.2441 -0.88388 0l-1 -0.99996c-0.24408 -0.24408 -0.24408 -0.6398 0 -0.88388ZM3.5 5.5c0.55228 0 1 -0.44772 1 -1s-0.44772 -1 -1 -1 -1 0.44772 -1 1 0.44772 1 1 1Zm6 5.5c0 0.5523 -0.44772 1 -1 1s-1 -0.4477 -1 -1 0.44772 -1 1 -1 1 0.4477 1 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Donut"
);
var ForkKnife = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.974 0.15a1 1 0 0 1 0.973 -0.044c2.333 1.166 3.467 3.203 4.014 5.12 0.54 1.884 0.539 3.748 0.539 4.75l0 0.024a1 1 0 0 1 -1 1h-3v2a1 1 0 1 1 -2 0V1a1 1 0 0 1 0.474 -0.85ZM1 0.25a0.75 0.75 0 0 1 0.75 0.75v2.5a1.75 1.75 0 0 0 1 1.581V1a0.75 0.75 0 0 1 1.5 0v4.081a1.75 1.75 0 0 0 1 -1.581V1a0.75 0.75 0 0 1 1.5 0v2.5A3.25 3.25 0 0 1 4.5 6.592V13a1 1 0 1 1 -2 0V6.592A3.25 3.25 0 0 1 0.25 3.5V1A0.75 0.75 0 0 1 1 0.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ForkKnife"
);
var ForkSpoon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.784668 0.0240479c0.414212 0 0.750002 0.3357861 0.750002 0.7500001V3.27405c0 0.46413 0.18437 0.90925 0.51256 1.23743 0.14298 0.14299 0.30816 0.25867 0.48744 0.34371V0.774048c0 -0.414214 0.33578 -0.7500001 0.75 -0.7500001 0.41421 0 0.75 0.3357861 0.75 0.7500001V4.85519c0.18075 -0.08574 0.34567 -0.20194 0.48743 -0.34371 0.16251 -0.1625 0.29141 -0.35542 0.37936 -0.56774 0.08794 -0.21232 0.13321 -0.43988 0.13321 -0.66969V0.774048c0 -0.414214 0.33578 -0.7500001 0.75 -0.7500001 0.41421 0 0.75 0.3357861 0.75 0.7500001V3.27405c0 0.42679 -0.08407 0.84941 -0.24739 1.24372 -0.16333 0.39431 -0.40272 0.75258 -0.70451 1.05437 -0.3018 0.3018 -0.66007 0.54119 -1.05438 0.70452 -0.07998 0.03313 -0.16113 0.06299 -0.24323 0.08956v6.63388c0 0.5522 -0.44772 1 -1 1 -0.55229 0 -1 -0.4478 -1 -1V6.36654c-0.48519 -0.15683 -0.93132 -0.42712 -1.298589 -0.7944C0.377078 4.96265 0.034668 4.136 0.034668 3.27405V0.774048c0 -0.414214 0.335786 -0.7500001 0.75 -0.7500001Zm10.050232 0c-1.77182 0 -2.94107 1.7268421 -2.94107 3.4888621 0 1.40426 0.74263 2.78616 1.94107 3.28945v6.19774c0 0.5523 0.4477 1 1 1s1 -0.4477 1 -1V6.80238c1.1985 -0.50327 1.9411 -1.88519 1.9411 -3.28947 0 -1.76202 -1.1692 -3.4888621 -2.9411 -3.4888621Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ForkSpoon"
);
var IceCream2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.142 9.858v3a1.141 1.141 0 1 1 -2.284 0v-3" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.154 0c-0.8 0 -1.449 0.649 -1.449 1.449V9.09c0 0.8 0.649 1.449 1.449 1.449h5.692c0.8 0 1.449 -0.649 1.449 -1.449V1.449c0 -0.8 -0.649 -1.449 -1.449 -1.449H4.154Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.97 3a0.625 0.625 0 0 0 -1.25 0v4.5a0.625 0.625 0 1 0 1.25 0V3Zm3.31 0a0.625 0.625 0 1 0 -1.25 0v4.5a0.625 0.625 0 0 0 1.25 0V3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "IceCream2"
);
var IceCream3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.64384 5.9723c-0.16784 0 -0.32447 0.0842 -0.41705 0.22419 -0.09258 0.13998 -0.10875 0.31708 -0.04306 0.47152l2.84553 6.68949c0.07822 0.1895 0.21076 0.3517 0.38097 0.4661 0.17141 0.1152 0.37325 0.1767 0.57977 0.1767 0.20652 0 0.40837 -0.0615 0.57978 -0.1767 0.17001 -0.1143 0.30243 -0.2762 0.38069 -0.4654l2.86533 -6.68903c0.0661 -0.15448 0.0503 -0.33186 -0.0423 -0.47216 -0.0925 -0.14029 -0.2493 -0.22471 -0.4174 -0.22471H3.64384Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.00001 -0.000289917c1.34385 0 2.43761 1.070809917 2.47457 2.405739917 1.16742 0.19921 2.05612 1.21591 2.05612 2.44016 0 1.36721 -1.1083 2.47554 -2.4755 2.47554 -0.85606 0 -1.61064 -0.43453 -2.0552 -1.09507 -0.44455 0.66054 -1.19912 1.09507 -2.05519 1.09507 -1.36721 0 -2.47554 -1.10833 -2.47554 -2.47554 0 -1.22425 0.88869 -2.24095 2.05616 -2.44016 0.03696 -1.33493 1.13072 -2.405739917 2.47458 -2.405739917Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "IceCream3"
);
var LemonFruitSeasoning = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.754 1.24747c-0.4118 -0.411832 -0.9041 -0.62562 -1.4281 -0.656407 -0.514 -0.030206 -1.0267 0.116917 -1.49864 0.369082 -0.20559 0.109835 -0.43015 0.135315 -0.62192 0.077655C7.22459 0.442158 4.67002 0.679393 2.67474 2.67468 0.680281 4.66914 0.442411 7.22242 1.03712 9.20282c0.05758 0.19176 0.03203 0.41625 -0.077837 0.62173 -0.252439 0.47215 -0.399798 0.98495 -0.369721 1.49915 0.030657 0.5242 0.244444 1.0168 0.656438 1.4288 0.41142 0.4114 0.90321 0.6252 1.42662 0.6563 0.51355 0.0305 1.02575 -0.116 1.49741 -0.3675 0.20585 -0.1098 0.43059 -0.1351 0.6224 -0.0772 1.9816 0.5979 4.5393 0.3622 6.53657 -1.6351 1.9965 -1.9965 2.2328 -4.55292 1.6359 -6.53417 -0.0578 -0.1918 -0.0325 -0.41646 0.0773 -0.62221 0.2518 -0.47179 0.3986 -0.98418 0.3682 -1.49793 -0.031 -0.52362 -0.2448 -1.01564 -0.6564 -1.42722Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.25971 4.09135c-0.9889 -0.29737 -2.22837 -0.17542 -3.20622 0.80243 -0.54393 0.54393 -0.81654 1.15821 -0.90827 1.75973 -0.06244 0.40948 -0.44501 0.69081 -0.85449 0.62836 -0.40948 -0.06244 -0.69081 -0.44501 -0.62837 -0.85449 0.13773 -0.90318 0.55038 -1.81417 1.33047 -2.59426 1.43631 -1.43631 3.28011 -1.60486 4.69884 -1.17823 0.39667 0.11929 0.62153 0.53755 0.50225 0.93421 -0.11928 0.39667 -0.53754 0.62153 -0.93421 0.50225Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LemonFruitSeasoning"
);
var Milkshake = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.722 0.067a0.75 0.75 0 0 1 0.487 0.942l-0.632 1.986a0.75 0.75 0 0 1 -1.43 -0.455L8.78 0.554a0.75 0.75 0 0 1 0.942 -0.487Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.11 1.712a4.173 4.173 0 0 0 -4.172 4.173v0.489c0 0.017 0 0.035 0.002 0.053l0.422 5.916a1.75 1.75 0 0 0 1.746 1.626h4.005c0.918 0 1.68 -0.71 1.746 -1.626l0.422 -5.916a0.733 0.733 0 0 0 0.002 -0.053v-0.49a4.173 4.173 0 0 0 -4.172 -4.172Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.221 5.624a0.75 0.75 0 1 0 0 1.5h9.78a0.75 0.75 0 0 0 0 -1.5H2.22Zm2.393 3.194h4.993l-0.245 3.418a0.25 0.25 0 0 1 -0.249 0.233H5.108a0.25 0.25 0 0 1 -0.25 -0.232l-0.244 -3.419Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Milkshake"
);
var Popcorn = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 5.5h-0.571l0.075 0.566 0.885 6.632A1.5 1.5 0 0 0 4.375 14h5.25a1.5 1.5 0 0 0 1.486 -1.302l0.885 -6.632 0.075 -0.566H2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.402 2.773c-0.134 0.003 -0.266 0.02 -0.395 0.054 0.1 -0.236 0.152 -0.488 0.154 -0.744a2.145 2.145 0 0 0 -0.676 -1.485A2.207 2.207 0 0 0 8.949 0a2.214 2.214 0 0 0 -1.124 0.31c-0.34 0.201 -0.617 0.49 -0.803 0.834A2.172 2.172 0 0 0 6.219 0.31a2.207 2.207 0 0 0 -2.646 0.296 2.144 2.144 0 0 0 -0.668 1.477c0.001 0.256 0.053 0.508 0.153 0.744a1.654 1.654 0 0 0 -1.577 0.42A1.607 1.607 0 0 0 1 4.393c0 0.43 0.173 0.841 0.481 1.145 0.308 0.303 0.726 0.463 1.161 0.463H6.25v8h1.5V6h3.608c0.435 0 0.853 -0.17 1.161 -0.474a1.607 1.607 0 0 0 0 -2.29 1.655 1.655 0 0 0 -1.161 -0.473l0.043 0.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Popcorn"
);
var PorkMeat = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.24786 0.548575c-0.15491 -0.073772 -0.33683 -0.062959 -0.48192 0.028644C1.62086 0.668822 1.53288 0.82842 1.53288 1v3.01935c0 0.15957 -0.07946 0.35087 -0.2401 0.54744C0.807653 5.16042 0.125 6.36153 0.125 8.38267c0 1.84193 0.865169 3.15033 2.17911 3.97483C3.59159 13.1654 5.28935 13.5 7 13.5c1.71065 0 3.4084 -0.3346 4.6959 -1.1425 1.3139 -0.8245 2.1791 -2.1329 2.1791 -3.97483 0 -2.02114 -0.6827 -3.22225 -1.1678 -3.81588 -0.1606 -0.19657 -0.2401 -0.38787 -0.2401 -0.54744V1c0 -0.17158 -0.088 -0.331178 -0.233 -0.422781 -0.1451 -0.091603 -0.327 -0.102416 -0.482 -0.028644L8.75856 1.97417l-0.02997 -0.00654c-0.12435 -0.02702 -0.29708 -0.06308 -0.49062 -0.09921C7.86293 1.7984 7.36784 1.71986 7 1.71986c-0.36784 0 -0.86293 0.07854 -1.23797 0.14856 -0.19354 0.03613 -0.36627 0.07219 -0.49062 0.09921l-0.02997 0.00654L2.24786 0.548575Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5625 5.625c0 0.34518 0.27982 0.625 0.625 0.625s0.625 -0.27982 0.625 -0.625S4.53268 5 4.1875 5s-0.625 0.27982 -0.625 0.625Zm6.375 3.34375C9.9375 10.3125 8.62234 11.125 7 11.125s-2.9375 -0.75 -2.9375 -2.15625S5.37766 6.8125 7 6.8125s2.9375 0.8125 2.9375 2.15625Zm0.5 -3.34375c0 0.34518 -0.2798 0.625 -0.625 0.625 -0.34518 0 -0.625 -0.27982 -0.625 -0.625S9.46732 5 9.8125 5c0.3452 0 0.625 0.27982 0.625 0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6 8.46875c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625 -0.625 -0.27982 -0.625 -0.625 0.27982 -0.625 0.625 -0.625Zm2.625 0.625c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625 0.27982 -0.625 0.625 -0.625 0.625 0.27982 0.625 0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PorkMeat"
);
var ServingDome = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.853a0.75 0.75 0 0 0 -1.5 0v1.5a0.75 0.75 0 1 0 1.5 0v-1.5ZM0.78 11.75a0.75 0.75 0 0 0 0 1.5h12.44a0.75 0.75 0 0 0 0 -1.5H0.78Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.95 3.904A7 7 0 0 1 14 8.854a1.5 1.5 0 0 1 -1.5 1.5h-11a1.5 1.5 0 0 1 -1.5 -1.5 7 7 0 0 1 11.95 -4.95Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ServingDome"
);
var Shrimp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.34743 1.78125c-0.41625 0 -0.75368 0.33743 -0.75368 0.75368 0 0.41624 0.33743 0.75367 0.75368 0.75367h1.00245c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41422 -0.33579 0.75 -0.75 0.75H2.34743c-1.24467 0 -2.25368 -1.009 -2.25368 -2.25367 0 -1.24468 1.00901 -2.25368 2.25368 -2.25368h4.51103c0.41421 0 0.75 0.335786 0.75 0.75 0 0.41421 -0.33579 0.75 -0.75 0.75H2.34743Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.34985 4.799V3.28674h5.51348c2.76817 0 5.01227 2.24407 5.01227 5.01226 0 2.7682 -2.2441 5.5123 -5.01227 5.5123v-1.0025c1.10728 0 2.00487 -0.8976 2.00487 -2.0049 0 -1.10728 -0.89759 -2.0049 -2.00487 -2.0049H7.34985c-2.20914 0 -4 -1.79086 -4 -4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.19011 13.8125h2.67321v-0.7518c0 -0.9689 -0.78543 -1.7543 -1.75429 -1.7543h-0.08354c-0.92273 0 -1.67075 0.748 -1.67075 1.6707 0 0.4614 0.37401 0.8354 0.83537 0.8354Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.86333 3.28674c0.3576 0 0.70646 0.03745 1.04286 0.10864 0.06465 0.13066 0.12711 0.27326 0.18551 0.42512 0.2268 0.58988 0.4083 1.3591 0.4083 2.17949 0 0.82038 -0.1815 1.58961 -0.4083 2.17949 -0.11355 0.29515 -0.24225 0.55536 -0.373 0.76082 -0.00819 0.01287 -0.01646 0.02564 -0.0248 0.03829 -0.25307 -0.11534 -0.53431 -0.17959 -0.83057 -0.17959h-0.32117c0.04181 -0.09538 0.11348 -0.17827 0.20986 -0.2332 0.00364 -0.0035 0.00902 -0.00892 0.01609 -0.01673 0.02619 -0.02891 0.06282 -0.07632 0.10693 -0.14565 0.088 -0.13828 0.18847 -0.33641 0.28329 -0.58292C9.34811 7.32705 9.5 6.6796 9.5 5.99999c0 -0.67962 -0.15189 -1.32706 -0.34167 -1.82051 -0.09482 -0.24652 -0.19529 -0.44464 -0.28329 -0.58293 -0.04411 -0.06932 -0.08074 -0.11673 -0.10693 -0.14564 -0.00707 -0.00781 -0.01245 -0.01323 -0.01609 -0.01673 -0.06608 -0.03767 -0.12055 -0.08847 -0.16174 -0.14744h0.27305Zm2.00487 7.51716c0 0.0313 -0.0007 0.0624 -0.0021 0.0934 0.8652 -0.3508 2.1962 -1.24704 3.0042 -2.83086 -0.0292 -0.6383 -0.1777 -1.24546 -0.4238 -1.79969 -0.4251 2.0753 -1.8877 3.21085 -2.7932 3.63314 0.1375 0.27161 0.2149 0.57881 0.2149 0.90401ZM7.35963 5.5423c0 0.41523 -0.33661 0.75184 -0.75183 0.75184 -0.41523 0 -0.75184 -0.33661 -0.75184 -0.75184 0 -0.41522 0.33661 -0.75183 0.75184 -0.75183 0.41522 0 0.75183 0.33661 0.75183 0.75183Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shrimp"
);
var Strawberry = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.25 0.795A0.75 0.75 0 0 1 5 0.045c0.714 0 1.398 0.454 1.858 0.94 0.048 0.052 0.095 0.105 0.142 0.16a5.57 5.57 0 0 1 0.142 -0.16C7.602 0.5 8.286 0.046 9 0.046a0.75 0.75 0 0 1 0 1.5c-0.12 0 -0.435 0.12 -0.767 0.47 -0.318 0.337 -0.483 0.713 -0.483 0.985a0.75 0.75 0 0 1 -1.5 0c0 -0.272 -0.165 -0.648 -0.483 -0.984 -0.332 -0.351 -0.648 -0.47 -0.767 -0.47a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 2.5c-1.321 0 -2.57 0.316 -3.5 1.06C2.554 4.317 2 5.469 2 7c0 1.866 0.665 3.593 1.597 4.86C4.513 13.101 5.768 14 7 14c1.232 0 2.487 -0.898 3.402 -2.14A8.313 8.313 0 0 0 12 7c0 -1.531 -0.554 -2.683 -1.5 -3.44C9.57 2.816 8.32 2.5 7 2.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.5 6.75a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Zm1 3.058a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Zm1.75 0.75a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Zm-0.5 -3.808a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Zm1.5 0.75a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Strawberry"
);
var TeaCup = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.723 4.73v2.5h0.5a1.25 1.25 0 0 0 0 -2.5h-0.5Zm0 4a2.5 2.5 0 0 1 -2.5 2.5h-5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1H9.22l0.004 0h2a2.75 2.75 0 1 1 0 5.5h-0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.262 0.77a0.75 0.75 0 1 0 -1.5 0v0.73a0.75 0.75 0 1 0 1.5 0V0.77ZM0.777 12.48a0.75 0.75 0 0 0 0 1.5h12.446a0.75 0.75 0 0 0 0 -1.5H0.777ZM8.487 0.02a0.75 0.75 0 0 1 0.75 0.75v0.73a0.75 0.75 0 1 1 -1.5 0V0.77a0.75 0.75 0 0 1 0.75 -0.75ZM6.25 0.77a0.75 0.75 0 0 0 -1.5 0v0.73a0.75 0.75 0 1 0 1.5 0V0.77Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TeaCup"
);
var Toast = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.8097 3.54329C13.9353 3.84661 14 4.1717 14 4.5c0.0008 0.38825 -0.0892 0.7713 -0.2629 1.11856 -0.1736 0.34727 -0.426 0.64911 -0.7371 0.88144v5c0 0.2652 -0.1054 0.5196 -0.2929 0.7071S12.2652 12.5 12 12.5H5.5V2h6c0.3283 0 0.6534 0.06466 0.9567 0.1903s0.5789 0.30979 0.8111 0.54193c0.2321 0.23215 0.4163 0.50775 0.5419 0.81106Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M9.5 4.5c0 -0.3283 -0.06466 -0.65339 -0.1903 -0.95671 -0.12564 -0.30331 -0.30979 -0.57891 -0.54193 -0.81106 -0.23215 -0.23214 -0.50775 -0.41629 -0.81106 -0.54193C7.65339 2.06466 7.3283 2 7 2H2.5c-0.52471 0 -1.03611 0.16509 -1.46178 0.47189 -0.425659 0.30681 -0.744002 0.73976 -0.909928 1.23754 -0.1659269 0.49778 -0.1710262 1.03515 -0.014576 1.53599C0.270167 5.74626 0.580235 6.18518 1 6.5v5c0 0.2652 0.10536 0.5196 0.29289 0.7071 0.18754 0.1875 0.44189 0.2929 0.70711 0.2929h5.5c0.26522 0 0.51957 -0.1054 0.70711 -0.2929 0.18753 -0.1875 0.29289 -0.4419 0.29289 -0.7071v-5c0.31107 -0.23233 0.5635 -0.53417 0.73713 -0.88144C9.41076 5.2713 9.50078 4.88825 9.5 4.5Z" }),
    " "
  ] }) }),
  "Toast"
);
var WaterGlass = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.7342 0.0268097c-0.21371 0 -0.41726 0.0911633 -0.55956 0.2506013 -0.1423 0.159437 -0.209821 0.372006 -0.185619 0.584334L2.21466 11.6148c0.07551 0.6524 0.38927 1.2539 0.88108 1.6892 0.49114 0.4346 1.12531 0.6729 1.7811 0.6692h4.22711c0.65579 0.0037 1.28995 -0.2346 1.78115 -0.6692 0.4918 -0.4353 0.8055 -1.0368 0.881 -1.6892L13.0108 0.863055c0.0246 -0.212514 -0.0428 -0.425418 -0.1851 -0.585152 -0.1423 -0.159734 -0.346 -0.2510933 -0.56 -0.2510933H1.7342Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m2.9408 4.74014 0.76391 6.70216c0.03313 0.285 0.17031 0.5483 0.38513 0.7384 0.21498 0.1902 0.49264 0.2944 0.7797 0.2925l0.00498 0 4.23674 0c0.28706 0.0019 0.56472 -0.1023 0.77969 -0.2925 0.21495 -0.1903 0.35215 -0.4532 0.38515 -0.7384l0.7758 -6.70216H2.9408Z" }),
    " "
  ] }) }),
  "WaterGlass"
);
var Wine = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m2.224 1.533 0.004 -0.033c0.063 -0.504 0.34 -0.852 0.557 -1.044A1.68 1.68 0 0 1 3.899 0.028l6.195 0a1.68 1.68 0 0 1 1.12 0.426 1.686 1.686 0 0 1 0.562 1.085c0.105 1.057 0.162 2.518 0.162 2.961 0 1.429 -0.555 2.576 -1.494 3.353 -0.74 0.613 -1.68 0.964 -2.694 1.078v3.475H9a0.75 0.75 0 0 1 0 1.5H5a0.75 0.75 0 1 1 0 -1.5h1.25V8.931c-1.013 -0.114 -1.954 -0.465 -2.694 -1.078C2.617 7.076 2.062 5.93 2.062 4.5c0 -0.441 0.057 -1.953 0.162 -2.967Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.49 3.57H3.51c-0.015 0.348 -0.022 0.638 -0.022 0.78 0 2.045 1.56 3.122 3.512 3.122 1.951 0 3.512 -1.077 3.512 -3.122 0 -0.144 -0.007 -0.431 -0.023 -0.78Z" }),
    " "
  ] }) }),
  "Wine"
);
var ZeroHunger = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.996277 7.03979c-0.276143 0 -0.5 0.22386 -0.5 0.5 0 2.29541 1.406143 4.26341 3.430683 5.26111v0.662c0 0.2762 0.22386 0.5 0.5 0.5h5.14599l0.00004 -0.5v0.5c0.27614 0 0.50001 -0.2238 0.50001 -0.5v-0.662c2.0245 -0.9977 3.4307 -2.9657 3.4307 -5.26111 0 -0.27614 -0.2239 -0.5 -0.5 -0.5H0.996277Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.53365 1.28706c0.23681 -0.339848 0.15328 -0.807318 -0.18657 -1.044125 -0.33984 -0.23680657 -0.80731 -0.1532768 -1.04412 0.186569 -0.35479 0.509176 -0.3946 1.038886 -0.29169 1.511486 0.08883 0.40796 0.29053 0.79333 0.43858 1.0762l0.01817 0.03473c0.17236 0.32981 0.27901 0.54483 0.32049 0.73533 0.0311 0.14282 0.01731 0.22853 -0.05673 0.33478 -0.23681 0.33984 -0.15328 0.80731 0.18656 1.04412 0.33985 0.23681 0.80732 0.15328 1.04413 -0.18656 0.3548 -0.50918 0.39461 -1.03889 0.2917 -1.51148 -0.08883 -0.40798 -0.29053 -0.79335 -0.43858 -1.07622l-0.01817 -0.03472c-0.17236 -0.32981 -0.27902 -0.54483 -0.3205 -0.73533 -0.0311 -0.14283 -0.0173 -0.22854 0.05673 -0.33478ZM7.19987 0.242935c0.33984 0.236807 0.42337 0.704277 0.18657 1.044125 -0.07404 0.10624 -0.08783 0.19195 -0.05673 0.33478 0.04148 0.1905 0.14814 0.40552 0.3205 0.73533l0.01816 0.03472c0.14805 0.28287 0.34975 0.66824 0.43858 1.07622 0.10291 0.47259 0.0631 1.0023 -0.2917 1.51148 -0.23681 0.33984 -0.70428 0.42337 -1.04412 0.18656 -0.33985 -0.23681 -0.42338 -0.70428 -0.18657 -1.04412 0.07404 -0.10625 0.08784 -0.19196 0.05674 -0.33478 -0.04148 -0.1905 -0.14814 -0.40552 -0.3205 -0.73533l-0.01817 -0.03473c-0.14805 -0.28287 -0.34974 -0.66824 -0.43858 -1.0762 -0.10291 -0.4726 -0.0631 -1.00231 0.2917 -1.511486 0.2368 -0.3398458 0.70427 -0.42337557 1.04412 -0.186569Zm3.86623 0c0.3398 0.236807 0.4234 0.704277 0.1865 1.044125 -0.074 0.10624 -0.0878 0.19195 -0.0567 0.33478 0.0415 0.1905 0.1482 0.40552 0.3205 0.73533l0.0182 0.03472 0 0.00001c0.148 0.28287 0.3497 0.66824 0.4386 1.07621 0.1029 0.47259 0.0631 1.0023 -0.2917 1.51148 -0.2368 0.33984 -0.7043 0.42337 -1.0442 0.18656 -0.3398 -0.23681 -0.4233 -0.70428 -0.1865 -1.04412 0.074 -0.10625 0.0878 -0.19196 0.0567 -0.33478 -0.0415 -0.1905 -0.1481 -0.40552 -0.3205 -0.73533l-0.0182 -0.03473c-0.148 -0.28287 -0.3497 -0.66824 -0.43854 -1.0762 -0.10291 -0.4726 -0.0631 -1.00231 0.29174 -1.511486 0.2368 -0.3398458 0.7042 -0.42337557 1.0441 -0.186569Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ZeroHunger"
);
var AffordableAndCleanEnergy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.86243 0.0144043c0.41421 0 0.75 0.3357867 0.75 0.7499997v0.652326c0 0.41422 -0.33579 0.75 -0.75 0.75 -0.41422 0 -0.75 -0.33578 -0.75 -0.75V0.764404c0 -0.414213 0.33578 -0.7499997 0.75 -0.7499997ZM11.1498 6.86193c0 2.36861 -1.92011 4.28877 -4.28872 4.28877 -2.36861 0 -4.28875 -1.92016 -4.28875 -4.28877 0 -2.36861 1.92014 -4.28875 4.28875 -4.28875 2.36861 0 4.28872 1.92014 4.28872 4.28875ZM7.61243 12.3063c0 -0.4142 -0.33579 -0.75 -0.75 -0.75 -0.41422 0 -0.75 0.3358 -0.75 0.75v0.6523c0 0.4142 0.33578 0.75 0.75 0.75 0.41421 0 0.75 -0.3358 0.75 -0.75v-0.6523ZM0.0148315 6.862c0 -0.41421 0.3357865 -0.75 0.7500005 -0.75h0.652328c0.41422 0 0.75 0.33579 0.75 0.75s-0.33578 0.75 -0.75 0.75H0.764832c-0.414214 0 -0.7500005 -0.33579 -0.7500005 -0.75ZM12.3067 6.112c-0.4142 0 -0.75 0.33579 -0.75 0.75s0.3358 0.75 0.75 0.75h0.6523c0.4142 0 0.75 -0.33579 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75h-0.6523Zm-0.5601 -4.13574c0.2929 0.2929 0.2929 0.76777 0 1.06066l-0.434 0.43395c-0.2929 0.29289 -0.7677 0.29289 -1.0606 0 -0.29294 -0.29289 -0.29294 -0.76777 0 -1.06066l0.4339 -0.43395c0.2929 -0.29289 0.7678 -0.29289 1.0607 0ZM3.4713 11.3122c0.29289 -0.2929 0.29289 -0.7677 0 -1.0606 -0.29289 -0.29293 -0.76777 -0.29293 -1.06066 0l-0.43395 0.4339c-0.29289 0.2929 -0.29289 0.7678 0 1.0607 0.29289 0.2929 0.76777 0.2929 1.06066 0l0.43395 -0.434ZM1.97669 1.97626c0.29289 -0.29289 0.76777 -0.29289 1.06066 0l0.43395 0.43395c0.29289 0.29289 0.29289 0.76777 0 1.06066s-0.76777 0.29289 -1.06066 0l-0.43395 -0.43395c-0.29289 -0.29289 -0.29289 -0.76776 0 -1.06066Zm9.33591 8.27534c-0.2929 -0.29293 -0.7677 -0.29293 -1.0606 0 -0.29294 0.2929 -0.29294 0.7677 0 1.0606l0.4339 0.434c0.2929 0.2929 0.7678 0.2929 1.0607 0 0.2929 -0.2929 0.2929 -0.7678 0 -1.0607l-0.434 -0.4339Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.48779 4.17114c0 -0.34518 -0.27982 -0.625 -0.625 -0.625 -0.34517 0 -0.625 0.27982 -0.625 0.625v1.76635c0 0.34518 0.27983 0.625 0.625 0.625 0.34518 0 0.625 -0.27982 0.625 -0.625V4.17114ZM5.36866 5.73557c0.20728 -0.27602 0.15156 -0.6678 -0.12446 -0.87508 -0.27601 -0.20728 -0.6678 -0.15155 -0.87508 0.12446 -0.39094 0.5206 -0.62284 1.16861 -0.62284 1.86898 0 1.72026 1.39454 3.1148 3.1148 3.1148s3.11481 -1.39454 3.11481 -3.1148c0 -0.70037 -0.2319 -1.34838 -0.62285 -1.86898 -0.20728 -0.27601 -0.59906 -0.33174 -0.87508 -0.12446 -0.27601 0.20728 -0.33174 0.59906 -0.12446 0.87508 0.23399 0.31158 0.37239 0.6979 0.37239 1.11836 0 1.0299 -0.8349 1.8648 -1.86481 1.8648 -1.0299 0 -1.8648 -0.8349 -1.8648 -1.8648 0 -0.42046 0.1384 -0.80678 0.37238 -1.11836Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AffordableAndCleanEnergy"
);
var Alien = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0C5.152 0 3.413 0.361 2.122 1.24 0.803 2.14 0 3.548 0 5.5c0 1.92 0.783 4.023 2.021 5.65C3.256 12.77 5.011 14 7 14c1.988 0 3.744 -1.23 4.979 -2.85C13.217 9.522 14 7.42 14 5.5c0 -1.953 -0.803 -3.361 -2.122 -4.26C10.587 0.362 8.848 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.52 4.169a3.262 3.262 0 0 1 2.552 0.512 0.25 0.25 0 0 1 0.062 0.062 3.262 3.262 0 0 1 0.512 2.551 0.25 0.25 0 0 1 -0.192 0.192 3.262 3.262 0 0 1 -2.55 -0.512 0.25 0.25 0 0 1 -0.063 -0.063 3.261 3.261 0 0 1 -0.512 -2.55 0.25 0.25 0 0 1 0.192 -0.192Zm7.63 -0.01a3.262 3.262 0 0 1 1.33 0.01 0.25 0.25 0 0 1 0.191 0.192 3.262 3.262 0 0 1 -0.512 2.55 0.25 0.25 0 0 1 -0.063 0.063 3.262 3.262 0 0 1 -2.55 0.512 0.25 0.25 0 0 1 -0.192 -0.192 3.261 3.261 0 0 1 0.512 -2.55 0.25 0.25 0 0 1 0.062 -0.063 3.262 3.262 0 0 1 1.222 -0.521Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Alien"
);
var Cat1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.30055 0.10042C2.1491 -0.0134972 1.94627 -0.032 1.7767 0.0526343 1.60714 0.137269 1.5 0.310492 1.5 0.500003V9.5C1.5 11.9853 3.51472 14 6 14h2c2.4853 0 4.5 -2.0147 4.5 -4.5V6.1822l0 -0.00569V0.500003c0 -0.189511 -0.1072 -0.362734 -0.2767 -0.4473687 -0.1696 -0.0846343 -0.3724 -0.0661315 -0.5239 0.0477857L7.78243 3.04666C7.52574 3.01584 7.26462 3 7 3c-0.26463 0 -0.52576 0.01584 -0.78246 0.04666L2.30055 0.10042Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.874 7c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75 0.33579 -0.75 0.75 -0.75 0.75 0.33579 0.75 0.75Zm-4.25 0.00031c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75c0 -0.41422 0.33579 -0.75 0.75 -0.75s0.75 0.33578 0.75 0.75ZM6.25001 9c-0.22033 0 -0.41469 0.14423 -0.47854 0.35511 -0.06385 0.21088 0.01786 0.4387 0.20119 0.56092l0.75 0.49997c0.16795 0.112 0.38675 0.112 0.5547 0l0.75 -0.49997c0.18333 -0.12222 0.26505 -0.35004 0.2012 -0.56092C8.16471 9.14423 7.97035 9 7.75001 9h-1.5Zm-6.24836205 0.5c0 -0.41421 0.33578605 -0.75 0.75000005 -0.75l2.998362 0c0.41422 0 0.75 0.33579 0.75 0.75s-0.33578 0.75 -0.75 0.75l-2.998362 0c-0.414214 0 -0.75000005 -0.33579 -0.75000005 -0.75ZM4.33542 12.1708c0.37049 -0.1852 0.52066 -0.6357 0.33541 -1.0062 -0.18524 -0.3705 -0.63574 -0.5207 -1.00623 -0.3354l-2.999997 1.5c-0.370484 0.1852 -0.520652 0.6357 -0.33541 1.0062 0.185242 0.3705 0.635747 0.5207 1.006227 0.3354l3 -1.5ZM9.50001 9.5c0 -0.41421 0.33579 -0.75 0.74999 -0.75l2.9984 0c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75l-2.9984 0c-0.4142 0 -0.74999 -0.33579 -0.74999 -0.75Zm0.83539 1.3292c-0.37046 -0.1853 -0.82097 -0.0351 -1.00621 0.3354 -0.18524 0.3705 -0.03507 0.821 0.33541 1.0062l3 1.5c0.3705 0.1853 0.821 0.0351 1.0062 -0.3354 0.1853 -0.3705 0.0351 -0.821 -0.3354 -1.0062l-3 -1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Cat1"
);
var Celsius = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 2.25a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0ZM2.25 0a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0 -4.5ZM8 4a2 2 0 0 1 2 -2c0.934 0 1.803 0.614 2.057 1.333a1 1 0 0 0 1.886 -0.666C13.373 1.056 11.679 0 10 0a4 4 0 0 0 -4 4v6a4 4 0 0 0 4 4c1.678 0 3.373 -1.056 3.943 -2.667a1 1 0 1 0 -1.886 -0.666C11.803 11.387 10.934 12 10 12a2 2 0 0 1 -2 -2V4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Celsius"
);
var CleanWaterAndSanitation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.94998 0.0375977c-1.06188 0 -1.88347 0.9306833 -1.75176 1.9843623l0.76155 6.09238c0.11043 0.88346 0.86143 1.54642 1.75176 1.54642h4.29963c0.89033 0 1.64134 -0.66296 1.75174 -1.54642l0.7616 -6.09238C11.6562 0.968282 10.8346 0.0375977 9.77271 0.0375977H3.94998Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.74717 4.1468c-0.59526 -0.03412 -1.09535 0.0068 -1.54032 0.0958 -0.60647 0.12129 -1.09102 0.32897 -1.52932 0.51683l-0.01334 0.00571c-0.43733 0.18743 -0.82956 0.35416 -1.31314 0.45464 -0.34181 0.07103 -0.73882 0.11046 -1.23032 0.08896l0.32744 2.61952c0.0166 0.13281 0.1295 0.23247 0.26334 0.23247h4.29963c0.13385 0 0.24675 -0.09966 0.26335 -0.23247l0.47268 -3.78146Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.99782 9.66071h1.5v1.30439h0.71316c0.30334 0 0.57682 0.1827 0.69291 0.4629 0.11608 0.2803 0.05191 0.6029 -0.16258 0.8174l-1.461 1.461c-0.00741 0.0075 -0.01497 0.0148 -0.02269 0.0219 -0.06286 0.0584 -0.1333 0.1039 -0.20799 0.1367 -0.09235 0.0407 -0.19444 0.0632 -0.30181 0.0632 -0.1106 0 -0.21562 -0.0239 -0.31014 -0.0669 -0.065 -0.0295 -0.12666 -0.0688 -0.18276 -0.1178 -0.01418 -0.0124 -0.02789 -0.0253 -0.0411 -0.0387l-1.45946 -1.4594c-0.2145 -0.2145 -0.27867 -0.5371 -0.16258 -0.8174 0.11609 -0.2802 0.38956 -0.4629 0.69291 -0.4629h0.71313V9.66071Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CleanWaterAndSanitation"
);
var Comet = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.78238 1.27828c0.29175 -0.294027 0.28992 -0.768897 -0.0041 -1.060656 -0.29403 -0.2917588 -0.7689 -0.2899234 -1.06066 0.0041L4.48019 3.4843 1.2448 6.74479l-0.00105 0.00106 -0.00003 0.00002C-0.000269134 7.99073 -0.311064 9.81515 0.311334 11.3496c0.12969 0.3197 0.299898 0.6269 0.510624 0.9136 0.126375 0.1719 0.267322 0.3365 0.422842 0.492 1.65935 1.6594 4.34947 1.6597 6.00929 0.0011l0.00111 -0.0011 3.2605 -3.23538 0.0029 -0.0029 3.2597 -3.23454c0.294 -0.29176 0.2958 -0.76663 0.0041 -1.06066 -0.2918 -0.29402 -0.7667 -0.29586 -1.0607 -0.0041l-2.7075 2.68669c-0.0756 0.08807 -0.18773 0.14386 -0.31289 0.14386 -0.22761 0 -0.41213 -0.18451 -0.41213 -0.41212 0 -0.11263 0.04519 -0.21471 0.11842 -0.2891l-0.00033 -0.00033L12.743 4.01089c0.2929 -0.29289 0.2929 -0.76777 0 -1.06066s-0.7678 -0.29289 -1.0607 0L8.34661 6.28596l-0.00145 -0.00145c-0.08957 0.1113 -0.22692 0.18252 -0.3809 0.18252 -0.26989 0 -0.48867 -0.21879 -0.48867 -0.48867 0 -0.17169 0.08853 -0.32269 0.22243 -0.40985l4.28818 -4.28818c0.2929 -0.292893 0.2929 -0.767767 0 -1.06066 -0.2929 -0.2928933 -0.7678 -0.2928933 -1.0607 0L6.60293 4.54228l-0.00113 -0.00113c-0.06841 0.06947 -0.16354 0.11254 -0.26874 0.11254 -0.20828 0 -0.37713 -0.16885 -0.37713 -0.37713 0 -0.12304 0.05892 -0.23232 0.15009 -0.30115l2.67636 -2.69713Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.136 9.75a2.114 2.114 0 1 0 4.228 0 2.114 2.114 0 1 0 -4.228 0" }),
    " "
  ] }) }),
  "Comet"
);
var Fahrenheit = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 2.25a0.75 0.75 0 1 1 1.5 0 0.75 0.75 0 0 1 -1.5 0ZM2.25 0a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0 -4.5ZM6 1a1 1 0 0 1 1 -1h6a1 1 0 1 1 0 2H8v3.5h4a1 1 0 1 1 0 2H8V13a1 1 0 1 1 -2 0V1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Fahrenheit"
);
var Flower = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h11a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 12.5 0h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10 5.098a3 3 0 0 1 -2.375 2.934v2.052l1.433 -1.433a0.625 0.625 0 1 1 0.884 0.884l-2.5 2.5a0.623 0.623 0 0 1 -0.436 0.183l-0.006 0 -0.006 0a0.623 0.623 0 0 1 -0.436 -0.183l-2.5 -2.5a0.625 0.625 0 1 1 0.884 -0.884l1.433 1.433V8.032A3 3 0 0 1 4 5.098v-2.19a0.5 0.5 0 0 1 0.72 -0.45L7 3.598l2.28 -1.14a0.5 0.5 0 0 1 0.72 0.45v2.19Z" }),
    " "
  ] }) }),
  "Flower"
);
var Galaxy1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.107 7a1.893 1.893 0 1 0 3.786 0 1.893 1.893 0 1 0 -3.786 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.55762 0.198018C7.1989 -0.00908852 6.7402 0.113818 6.5331 0.472537c-0.20711 0.35872 -0.0842 0.817413 0.27452 1.024523 1.24923 0.72124 1.88874 1.97763 1.91771 3.3468 -1.71411 -2.18069 -4.66831 -3.26859 -7.33715 -1.72774 -0.35872 0.2071 -0.481622 0.6658 -0.27452 1.02452 0.20711 0.35872 0.6658 0.48162 1.02452 0.27451 1.25104 -0.72228 2.66112 -0.64666 3.86248 0.01548 -2.73907 0.40041 -5.170094 2.4098 -5.170094 5.4875 0 0.41417 0.335784 0.74997 0.750004 0.74997 0.41421 0 0.75 -0.3358 0.75 -0.74997 0 -1.43411 0.76925 -2.61278 1.93914 -3.32418 -1.01575 2.56975 -0.48832 5.67175 2.1725 7.20795 0.35872 0.2071 0.81741 0.0842 1.02451 -0.2745 0.20711 -0.3587 0.08421 -0.8174 -0.27451 -1.0245 -1.24217 -0.7172 -1.8783 -1.973 -1.90927 -3.34206 1.71754 2.16486 4.66791 3.25936 7.32886 1.72296 0.3588 -0.2071 0.4817 -0.6658 0.2746 -1.02447 -0.2071 -0.35872 -0.6658 -0.48163 -1.0246 -0.27452 -1.2403 0.71609 -2.64363 0.64039 -3.84362 -0.01467 2.74002 -0.39882 5.15122 -2.41171 5.15122 -5.48832 0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75c0 1.44244 -0.7683 2.62443 -1.93944 3.33412 1.03144 -2.57479 0.49644 -5.67709 -2.17234 -7.217922ZM6.9899 5.85695c-0.62665 0.00542 -1.13297 0.51509 -1.13297 1.14301 0 0.20279 0.05281 0.39325 0.14542 0.55837 0.00048 0.00081 0.00095 0.00162 0.00142 0.00243 0.00527 0.00913 0.01055 0.01823 0.01586 0.02732 0.1999 0.33249 0.56415 0.55494 0.98036 0.55494 0.42333 0 0.79291 -0.23013 0.99047 -0.5721 0.0019 -0.00342 0.00384 -0.00682 0.0058 -0.01022l0.00147 -0.00255c0.09255 -0.16508 0.14532 -0.35547 0.14532 -0.55819 0 -0.20884 -0.05601 -0.4046 -0.15382 -0.57308 -0.00182 -0.00306 -0.00363 -0.00613 -0.00541 -0.00922 -0.19852 -0.33468 -0.56295 -0.55937 -0.97997 -0.56075 -0.00465 0.00001 -0.0093 0.00002 -0.01395 0.00004Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Galaxy1"
);
var Galaxy2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.121 7a1.88 1.88 0 1 0 3.76 0 1.88 1.88 0 1 0 -3.76 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.556 2.35c0.749 0.514 1.317 1.278 1.317 2.3 0 1.498 -0.899 2.76 -2.148 3.615 -1.253 0.858 -2.932 1.365 -4.712 1.365l-0.001 0 -0.011 0a2.63 2.63 0 0 1 -2.538 -3.323 5.91 5.91 0 0 0 -1.315 0.666c-0.984 0.673 -1.495 1.525 -1.495 2.377 0 0.389 0.195 0.74 0.666 1.064 0.486 0.333 1.204 0.585 2.052 0.722 0.84 0.135 1.753 0.15 2.588 0.047 0.846 -0.103 1.554 -0.317 2.018 -0.596a0.75 0.75 0 0 1 0.772 1.286c-0.71 0.427 -1.647 0.682 -2.608 0.8a11 11 0 0 1 -3.009 -0.056c-0.972 -0.157 -1.929 -0.463 -2.662 -0.967 -0.75 -0.514 -1.317 -1.279 -1.317 -2.3 0 -1.498 0.899 -2.76 2.148 -3.615 1.247 -0.854 2.916 -1.36 4.686 -1.365l0.014 0 0.005 0 0.007 0 0.014 0a2.63 2.63 0 0 1 2.509 3.333c0.5 -0.18 0.953 -0.409 1.342 -0.676 0.984 -0.673 1.495 -1.525 1.495 -2.377 0 -0.389 -0.195 -0.74 -0.666 -1.064 -0.485 -0.333 -1.204 -0.585 -2.052 -0.722a9.462 9.462 0 0 0 -2.588 -0.047c-0.845 0.103 -1.554 0.317 -2.018 0.596a0.75 0.75 0 0 1 -0.772 -1.286c0.71 -0.427 1.647 -0.682 2.609 -0.8a10.96 10.96 0 0 1 3.008 0.056c0.973 0.157 1.929 0.463 2.662 0.967ZM6.993 5.87l0.011 0a1.13 1.13 0 1 1 -0.011 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Galaxy2"
);
var HumidityNone = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m7 0.5 0.40024 -0.29968C7.30583 0.0742289 7.15752 0 7 0s-0.30583 0.0742289 -0.40024 0.20032L7 0.5Zm0 0c0.40024 -0.29968 0.40029 -0.299618 0.40035 -0.299534l0.00021 0.000284 0.00073 0.000979 0.00268 0.003587 0.01013 0.0136 0.03864 0.052142c0.03364 0.045555 0.08271 0.112323 0.145 0.197973 0.12455 0.171276 0.30208 0.418197 0.51493 0.722099 0.42537 0.60735 0.99339 1.44448 1.56223 2.36157 0.5678 0.91539 1.142 1.91942 1.5759 2.85909C11.6759 7.33231 12 8.26038 12 9c0 1.3261 -0.5268 2.5979 -1.4645 3.5355C9.59785 13.4732 8.32608 14 7 14c-1.32608 0 -2.59785 -0.5268 -3.53553 -1.4645C2.52678 11.5979 2 10.3261 2 9c0 -0.73962 0.32411 -1.66769 0.74919 -2.58821 0.43391 -0.93967 1.00812 -1.9437 1.57591 -2.85909 0.56884 -0.91709 1.13686 -1.75422 1.56223 -2.36157 0.21285 -0.303902 0.39038 -0.550823 0.51493 -0.722099 0.06229 -0.08565 0.11136 -0.152418 0.145 -0.197973L6.5859 0.218916l0.01013 -0.0136 0.00268 -0.003587 0.00073 -0.000979 0.00021 -0.000284C6.59971 0.200382 6.59976 0.20032 7 0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.21967 0.21967c-0.2928931 0.292893 -0.2928931 0.767767 0 1.06066L12.7197 13.7803c0.2929 0.2929 0.7677 0.2929 1.0606 0 0.2929 -0.2929 0.2929 -0.7677 0 -1.0606L1.28033 0.21967c-0.292893 -0.2928933 -0.767767 -0.2928933 -1.06066 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HumidityNone"
);
var Leaf = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.45711 0.00909638c0.23657 -0.02654708 0.47599 0.00171752 0.69971 0.08248852C4.24693 0.406269 5.92602 0.956058 7.57742 1.76619 9.22613 2.575 10.9063 3.6714 11.9189 5.10222c1.0963 1.54423 1.2183 3.19937 0.9774 4.60844 -0.2394 1.40014 -0.8394 2.58094 -1.2243 3.23554l-0.0053 0.009 -0.0001 0c-0.1468 0.2381 -0.3439 0.4412 -0.5774 0.5952 -0.2319 0.1528 -0.4942 0.2536 -0.7687 0.2953 -0.75639 0.1298 -2.08421 0.2696 -3.48875 0.0039 -1.41394 -0.2676 -2.93457 -0.9534 -3.99972 -2.4971 -1.02768 -1.43202 -1.49732 -3.36513 -1.69802 -5.17309C0.932286 4.36219 0.995809 2.6069 1.08179 1.47596c0.0113 -0.24175 0.07913 -0.47751 0.1981 -0.688366 0.12057 -0.213693 0.29019 -0.395673 0.49486 -0.530998 0.20466 -0.135324 0.43854 -0.2201376 0.68236 -0.24749962Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.8582 12.6164c-0.0656 0.1212 -0.1283 0.2314 -0.1862 0.3298l-0.0053 0.009c-0.1468 0.2381 -0.3439 0.4412 -0.5775 0.5951 -0.0546 0.0361 -0.111 0.0692 -0.1687 0.0993 -1.12922 -3.0219 -3.2484 -6.34522 -6.38221 -9.23272 -0.25385 -0.23389 -0.27003 -0.62929 -0.03613 -0.88314s0.62929 -0.27003 0.88314 -0.03613c3.07165 2.83022 5.2272 6.07527 6.4729 9.11879Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Leaf"
);
var Log = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.96967 1.96967c0.29289 -0.29289 0.76777 -0.29289 1.06066 0l2 2c0.29289 0.29289 0.29289 0.76777 0 1.06066s-0.76777 0.29289 -1.06066 0l-2 -2c-0.29289 -0.29289 -0.29289 -0.76777 0 -1.06066Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.5 4H2v8h9.5c0.8091 0 1.444 -0.5694 1.8483 -1.2771C13.7608 10.0012 14 9.03739 14 8s-0.2392 -2.00116 -0.6517 -2.72294C12.944 4.56941 12.3091 4 11.5 4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.95123 8.875C3.98315 8.59348 4 8.30065 4 8c0 -2.19188 -0.89543 -3.96875 -2 -3.96875C0.895431 4.03125 0 5.80812 0 8c0 2.1919 0.895431 3.9688 2 3.9688 0.71064 0 1.33471 -0.7355 1.68946 -1.8438H6.9999c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H3.95123ZM8.5 6.375h5.2917c0.1054 0.39015 0.1731 0.81132 0.1978 1.25H8.5c-0.34518 0 -0.625 -0.27982 -0.625 -0.625s0.27982 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Log"
);
var MoonCloud = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.91342 4.3806c-0.91363 -0.37843 -1.91896 -0.47745 -2.88887 -0.28452 -0.9699 0.19292 -1.86082 0.66913 -2.56008 1.36839C0.765206 6.16373 0.289002 7.05465 0.0960758 8.02455c-0.192926 0.9699 -0.09390942 1.97524 0.2845292 2.88885 0.378438 0.9136 1.019305 1.6945 1.841545 2.244C3.0444 13.7068 4.0111 14 5 14h6c0.7957 0 1.5587 -0.3161 2.1213 -0.8787C13.6839 12.5587 14 11.7957 14 11c0 -0.7956 -0.3161 -1.55871 -0.8787 -2.12132C12.5587 8.31607 11.7957 8 11 8l-0.0007 0c-0.366 0.00049 -0.7264 0.0677 -1.06436 0.196 -0.11453 -0.70294 -0.37846 -1.37651 -0.77759 -1.97385 -0.54941 -0.82225 -1.3303 -1.46311 -2.24393 -1.84155Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.035 0.527976c0.0606 0.229067 0.0141 0.515124 -0.1918 0.721084 -0.5073 0.5073 -0.5073 1.32979 0 1.83709 0.5073 0.5073 1.3297 0.5073 1.837 0 0.206 -0.20596 0.4921 -0.25244 0.7211 -0.19186 0.2431 0.06428 0.5237 0.29061 0.5093 0.67443 -0.0312 0.83204 -0.3649 1.65627 -1.0003 2.29169l-0.0103 0.00998c-0.469 0.44295 -0.9685 0.7353 -1.4714 0.90126C11.2868 6.75729 11.1438 6.75 11 6.75l-0.0018 0c-0.0552 0.00008 -0.1109 0.00123 -0.1659 0.00344 -0.1651 -0.42864 -0.3778 -0.83992 -0.6356 -1.22575 -0.68676 -1.02781 -1.66288 -1.82889 -2.80492 -2.30193 -0.155 -0.06421 -0.31211 -0.12198 -0.47094 -0.17328 0.11864 -0.70738 0.48974 -1.41083 1.15326 -2.03868 0.63472 -0.632052 1.45671 -0.9639503 2.2865 -0.9950794 0.3838 -0.01439952 0.6101 0.2661924 0.6744 0.5092554Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MoonCloud"
);
var Octopus = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7.00001 0C4.51474 0 2.5 2.01472 2.5 4.5c0 1.3441 0.58991 2.55104 1.52331 3.37487 0.33658 0.29707 0.52739 0.65923 0.54944 1.0239 0.02146 0.35498 -0.11235 0.7879 -0.57213 1.24763 -0.55761 0.5577 -1.34897 0.7563 -1.97713 0.6224 -0.309 -0.0659 -0.5614 -0.2079 -0.73472 -0.4068C1.11931 10.1675 1 9.88996 1 9.5 1 9.22386 0.776142 9 0.5 9s-0.5 0.22386 -0.5 0.5v0.8281c0 1.933 1.567 3.5 3.5 3.5h7c1.933 0 3.5 -1.567 3.5 -3.5V9.5c0 -0.27614 -0.2238 -0.5 -0.5 -0.5 -0.2761 0 -0.5 0.22386 -0.5 0.5 0 0.38996 -0.1193 0.6675 -0.2888 0.862 -0.1733 0.1989 -0.4257 0.3409 -0.7347 0.4068 -0.6281 0.1339 -1.4195 -0.0647 -1.97711 -0.6224 -0.45978 -0.45973 -0.59358 -0.89265 -0.57212 -1.24763 0.02204 -0.36467 0.21286 -0.72683 0.54944 -1.0239C10.9101 7.05104 11.5 5.8441 11.5 4.5 11.5 2.01472 9.4853 0 7.00001 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.03604 5.25001c0 0.43415 -0.35194 0.78609 -0.78609 0.78609 -0.43414 0 -0.78608 -0.35194 -0.78608 -0.78609 0 -0.43414 0.35194 -0.78608 0.78608 -0.78608 0.43415 0 0.78609 0.35194 0.78609 0.78608Zm7.16766 7.30079c-0.102 0.0261 -0.1987 0.0783 -0.2795 0.1567l-0.0036 0.0032c-0.007 0.0061 -0.0219 0.0187 -0.0447 0.0359 -0.0457 0.0343 -0.1224 0.086 -0.2297 0.1397 -0.2126 0.1063 -0.5511 0.2231 -1.0213 0.2231 -1.5054 0 -2.52498 -1.2402 -2.96296 -2.3406 -0.12766 -0.3207 -0.49113 -0.4772 -0.81183 -0.3495 -0.32071 0.1276 -0.4772 0.4911 -0.34955 0.8118 0.34095 0.8566 1.04807 1.9557 2.14943 2.597h0.84991c1.089 0 2.0619 -0.4973 2.7038 -1.2773Zm-8.85385 1.2773c1.10135 -0.6413 1.80847 -1.7404 2.14942 -2.597 0.12766 -0.3207 -0.02884 -0.6842 -0.34954 -0.8118 -0.32071 -0.1277 -0.68418 0.0288 -0.81183 0.3495 -0.43799 1.1004 -1.45755 2.3406 -2.96298 2.3406 -0.47015 0 -0.80864 -0.1168 -1.02127 -0.2231 -0.10734 -0.0537 -0.18398 -0.1054 -0.22971 -0.1397 -0.02282 -0.0172 -0.03774 -0.0298 -0.04473 -0.0359l-0.00361 -0.0032c-0.080766 -0.0784 -0.177458 -0.1306 -0.279457 -0.1567 0.641927 0.78 1.614767 1.2773 2.703777 1.2773h0.84993Zm4.4001 -7.792c0.43415 0 0.78609 -0.35194 0.78609 -0.78609 0 -0.43414 -0.35194 -0.78608 -0.78609 -0.78608 -0.43414 0 -0.78608 0.35194 -0.78608 0.78608 0 0.43415 0.35194 0.78609 0.78608 0.78609Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Octopus"
);
var OpenUmbrella = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 7.5h1.5v4.25a0.75 0.75 0 0 0 1.5 0 0.75 0.75 0 0 1 1.5 0 2.25 2.25 0 0 1 -4.5 0V7.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 0.75a0.75 0.75 0 0 0 -1.5 0v0.801A5.5 5.5 0 0 0 1.5 7a0.5 0.5 0 0 0 0.5 0.5h10a0.5 0.5 0 0 0 0.5 -0.5 5.5 5.5 0 0 0 -4.75 -5.449V0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OpenUmbrella"
);
var PetPaw = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 1.5c-0.495 0 -0.883 0.301 -1.123 0.662C3.134 2.526 3 3.001 3 3.5c0 0.5 0.134 0.974 0.377 1.338 0.24 0.36 0.628 0.662 1.123 0.662s0.883 -0.301 1.123 -0.662C5.866 4.474 6 3.999 6 3.5c0 -0.5 -0.134 -0.974 -0.377 -1.338 -0.24 -0.36 -0.628 -0.662 -1.123 -0.662Zm5 0c-0.495 0 -0.883 0.301 -1.123 0.662C8.134 2.526 8 3.001 8 3.5c0 0.5 0.134 0.974 0.377 1.338 0.24 0.36 0.628 0.662 1.123 0.662s0.883 -0.301 1.123 -0.662c0.243 -0.364 0.377 -0.839 0.377 -1.338 0 -0.5 -0.134 -0.974 -0.377 -1.338 -0.24 -0.36 -0.628 -0.662 -1.123 -0.662ZM1.5 6c-0.495 0 -0.883 0.301 -1.123 0.662C0.134 7.026 0 7.501 0 8c0 0.5 0.134 0.974 0.377 1.338 0.24 0.36 0.628 0.662 1.123 0.662s0.883 -0.301 1.123 -0.662C2.866 8.974 3 8.499 3 8c0 -0.5 -0.134 -0.974 -0.377 -1.338C2.383 6.302 1.995 6 1.5 6ZM7 6c-1.2 0 -2.089 0.644 -2.657 1.443C3.782 8.23 3.5 9.207 3.5 10c0 0.924 0.555 1.566 1.236 1.952 0.67 0.38 1.51 0.548 2.264 0.548 0.753 0 1.594 -0.167 2.264 -0.548 0.68 -0.386 1.236 -1.028 1.236 -1.952 0 -0.793 -0.282 -1.77 -0.843 -2.557C9.09 6.643 8.201 6 7 6Zm5.5 0c-0.495 0 -0.883 0.301 -1.123 0.662C11.134 7.026 11 7.501 11 8c0 0.5 0.134 0.974 0.377 1.338 0.24 0.36 0.628 0.662 1.123 0.662s0.883 -0.301 1.123 -0.662C13.866 8.974 14 8.499 14 8c0 -0.5 -0.134 -0.974 -0.377 -1.338 -0.24 -0.36 -0.628 -0.662 -1.123 -0.662Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PetPaw"
);
var Planet = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 7a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0 -11 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.028 2.408c0.126 -0.076 0.25 -0.147 0.37 -0.214 0.666 -0.37 1.212 -0.584 1.612 -0.662 0.312 -0.06 0.434 -0.021 0.466 -0.008 0.013 0.032 0.052 0.154 -0.008 0.466 -0.078 0.4 -0.292 0.946 -0.662 1.611 -0.734 1.322 -1.996 2.961 -3.62 4.585s-3.263 2.886 -4.585 3.62c-0.665 0.37 -1.211 0.584 -1.611 0.662 -0.312 0.06 -0.434 0.021 -0.466 0.008 -0.013 -0.032 -0.052 -0.154 0.008 -0.466 0.078 -0.4 0.292 -0.946 0.662 -1.611 0.067 -0.121 0.138 -0.245 0.214 -0.37a5.472 5.472 0 0 1 -0.73 -1.634c-0.303 0.441 -0.57 0.869 -0.796 1.275 -0.407 0.733 -0.702 1.436 -0.822 2.055 -0.114 0.588 -0.104 1.307 0.402 1.813s1.225 0.516 1.813 0.402c0.619 -0.12 1.322 -0.415 2.055 -0.822 1.474 -0.82 3.223 -2.177 4.917 -3.871s3.052 -3.443 3.87 -4.917c0.408 -0.733 0.703 -1.436 0.823 -2.055 0.114 -0.588 0.104 -1.307 -0.402 -1.813S12.313 -0.054 11.725 0.06c-0.619 0.12 -1.322 0.415 -2.055 0.822 -0.406 0.226 -0.834 0.493 -1.275 0.796a5.472 5.472 0 0 1 1.633 0.73Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Planet"
);
var PottedFlowerTulip = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.34718 0.067545c0.15416 -0.089461 0.34428 -0.090096 0.49903 -0.0016666L7.22682 1.99765 10.6074 0.0658784c0.1548 -0.0884294 0.3449 -0.0877944 0.4991 0.0016666 0.1541 0.089461 0.249 0.25422 0.249 0.432455v3.62868c0 2.02409 -1.45656 3.70799 -3.37869 4.06072v4.6856c0 0.4142 -0.33579 0.75 -0.75 0.75 -0.41422 0 -0.75 -0.3358 -0.75 -0.75l0 -4.6856c-1.92213 -0.35275 -3.37867 -2.03664 -3.37867 -4.06072V0.5c0 -0.178235 0.09488 -0.342994 0.24904 -0.432455Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.57812 10.7188v-0.6471c0 -0.27613 0.22386 -0.49998 0.5 -0.49998h2.20221c1.46326 0 2.68183 1.04758 2.94663 2.43368 0.26479 -1.3861 1.48337 -2.43368 2.94664 -2.43368h2.2022c0.2761 0 0.5 0.22385 0.5 0.49998v0.6471c0 1.6568 -1.3432 3 -3.00001 3H4.57812c-1.65685 0 -3 -1.3432 -3 -3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PottedFlowerTulip"
);
var RainCloud = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.054 0.134A4.25 4.25 0 1 0 5 8.5h5.25a3 3 0 0 0 0 -6l-0.002 0a3.04 3.04 0 0 0 -1.264 0.28A4.25 4.25 0 0 0 6.054 0.134Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.885 9.58a0.75 0.75 0 0 1 0.336 1.005l-0.5 1a0.75 0.75 0 1 1 -1.342 -0.67l0.5 -1a0.75 0.75 0 0 1 1.006 -0.336Zm4.9 0a0.75 0.75 0 0 1 0.336 1.005l-0.5 1a0.75 0.75 0 1 1 -1.342 -0.67l0.5 -1a0.75 0.75 0 0 1 1.006 -0.336Zm-2.614 3.005a0.75 0.75 0 1 0 -1.342 -0.67l-0.5 1a0.75 0.75 0 1 0 1.342 0.67l0.5 -1ZM1.935 11.58a0.75 0.75 0 0 1 0.336 1.006l-0.5 1a0.75 0.75 0 1 1 -1.342 -0.67l0.5 -1a0.75 0.75 0 0 1 1.006 -0.336Zm10.136 1.006a0.75 0.75 0 1 0 -1.342 -0.67l-0.5 1a0.75 0.75 0 1 0 1.342 0.67l0.5 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RainCloud"
);
var Rainbow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 3.132a6.986 6.986 0 0 0 -6.986 6.986 0.75 0.75 0 0 0 0.75 0.75h12.472a0.75 0.75 0 0 0 0.75 -0.75A6.986 6.986 0 0 0 7 3.132Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 4.632a5.486 5.486 0 0 0 -5.486 5.486 0.75 0.75 0 0 1 -1.5 0 6.986 6.986 0 0 1 13.972 0 0.75 0.75 0 0 1 -1.5 0A5.486 5.486 0 0 0 7 4.632ZM7 7.09a3.028 3.028 0 0 0 -3.028 3.028 0.75 0.75 0 0 1 -1.5 0 4.528 4.528 0 1 1 9.056 0 0.75 0.75 0 0 1 -1.5 0A3.028 3.028 0 0 0 7 7.09Zm-0.403 2.625a0.57 0.57 0 0 1 0.973 0.403 0.75 0.75 0 0 0 1.5 0 2.07 2.07 0 1 0 -4.14 0 0.75 0.75 0 0 0 1.5 0 0.57 0.57 0 0 1 0.167 -0.403Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Rainbow"
);
var Recycle1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.62564 1.3093c0.98107 -1.645262 3.33698 -1.719642 4.41986 -0.13955l0.5939 0.86648 0.8193 -0.40484c0.2315 -0.11434 0.5094 -0.07464 0.6996 0.09993 0.1901 0.17457 0.2534 0.44809 0.1592 0.68843l-1.1506 2.93644c-0.1165 0.29744 -0.4386 0.45912 -0.7468 0.37484l-3.08498 -0.84375c-0.25038 -0.06848 -0.43237 -0.28459 -0.45724 -0.54297 -0.02487 -0.25838 0.11255 -0.50524 0.34527 -0.62023l0.68605 -0.33895 -0.56125 -0.88097c-0.13389 -0.21016 -0.43171 -0.2337 -0.59695 -0.0472L5.62839 3.72398c-0.21389 0.24141 -0.57634 0.28041 -0.8367 0.09004 -0.26035 -0.19037 -0.33309 -0.54759 -0.1679 -0.82461L5.62564 1.3093ZM3.77518 4.66759c0.31587 -0.04778 0.61693 0.15033 0.69802 0.45933l0.81179 3.09355c0.06588 0.25108 -0.03028 0.51674 -0.24161 0.66747 -0.21133 0.15073 -0.49383 0.15515 -0.70977 0.0111l-0.63658 -0.42467 -0.48232 0.92653c-0.11506 0.22103 0.01346 0.49072 0.2576 0.54058l1.65858 0.33872c0.31601 0.0645 0.53101 0.3589 0.49632 0.6796 -0.03469 0.3206 -0.30768 0.5622 -0.63018 0.5577l-1.95595 -0.0276C1.12571 11.4629 -0.116658 9.45981 0.710289 7.73194l0.453471 -0.94751 -0.760266 -0.50718C0.188753 6.134 0.0841754 5.87346 0.140276 5.62149c0.056102 -0.25197 0.261337 -0.44352 0.516572 -0.48213l3.118332 -0.47177Zm3.38714 6.55251c-0.19932 -0.2496 -0.17828 -0.6094 0.04879 -0.8341L9.4843 8.13617c0.1845 -0.1826 0.46265 -0.23215 0.6989 -0.1245 0.2362 0.10765 0.3812 0.3501 0.3644 0.60913l-0.0494 0.76365 1.0436 -0.04557c0.2489 -0.01087 0.4182 -0.25702 0.3393 -0.49338l-0.536 -1.60571c-0.1021 -0.30594 0.0454 -0.63934 0.3404 -0.76963 0.295 -0.13028 0.6408 -0.01466 0.7981 0.2669l0.9541 1.70769c0.9343 1.67225 -0.1793 3.74975 -2.0891 3.89745l-1.0473 0.0811 -0.0591 0.912c-0.0167 0.2576 -0.1901 0.4784 -0.43632 0.5558 -0.24626 0.0774 -0.51477 -0.0046 -0.67583 -0.2063l-1.96773 -2.4647Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Recycle1"
);
var RockSlide = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.853553 0.146447C0.710554 0.00344762 0.495495 -0.0393302 0.308658 0.0380602 0.121821 0.115451 0 0.297769 0 0.5v13c0 0.2761 0.223858 0.5 0.5 0.5H9c0.1498 0 0.2917 -0.0672 0.38667 -0.183s0.133 -0.2682 0.10362 -0.4151l-0.5 -2.5c-0.02095 -0.1047 -0.0749 -0.2 -0.15395 -0.2719L3.46952 5.75111l-0.47455 -3.32182c-0.01529 -0.1071 -0.06492 -0.20635 -0.14142 -0.28284L0.853553 0.146447Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 1c0 -0.552285 0.44772 -1 1 -1s1 0.447715 1 1c0 0.55228 -0.44772 1 -1 1s-1 -0.44772 -1 -1Zm5 2c-1.10457 0 -2 0.89543 -2 2s0.89543 2 2 2c1.1046 0 2 -0.89543 2 -2s-0.8954 -2 -2 -2Zm2 8c0 -0.5523 0.4477 -1 1 -1s1 0.4477 1 1 -0.4477 1 -1 1 -1 -0.4477 -1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RockSlide"
);
var Rose = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 9.54672c0.41421 0 0.75 0.33579 0.75 0.74998l0 2.8766c0 0.4143 -0.33579 0.75 -0.75 0.75s-0.75 -0.3357 -0.75 -0.75l0 -2.8766c0 -0.41419 0.33579 -0.74998 0.75 -0.74998Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.12677 2.99708C3.57183 1.27333 5.13721 0 7 0c1.86399 0 3.4302 1.27497 3.8741 3.00041 0.3554 -0.05881 0.7148 -0.09694 1.0765 -0.11387 0.5301 -0.02481 0.9455 0.41938 0.9455 0.95008v2.30616c0 1.56374 -0.6212 3.06343 -1.7269 4.16912 -1.1057 1.1058 -2.60544 1.727 -4.16917 1.727 -1.56374 0 -3.06343 -0.6212 -4.16916 -1.727 -1.10573 -1.10569 -1.72693 -2.60538 -1.72693 -4.16912V3.77752c0 -0.50604 0.37986 -0.92462 0.88536 -0.90136 0.31657 0.01456 0.70202 0.04773 1.13747 0.12092Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.65338 1.80823c-0.23629 0.36006 -0.41604 0.76054 -0.52662 1.18884 1.0798 0.18148 2.46698 0.609 3.87326 1.60887l0.00412 -0.00296c1.42437 1.03157 3.04856 3.00829 4.12606 5.74762M2.19467 2.88778c0.02969 0.00576 0.06016 0.00945 0.09127 0.01088 0.04883 0.00224 0.09948 0.00509 0.15187 0.00861m8.69229 7.44333c0.0131 -0.0128 0.0261 -0.0257 0.0391 -0.0387 0.327 -0.32698 0.6116 -0.68845 0.8503 -1.07585 -1.0438 -2.36762 -2.47861 -4.19315 -3.8738 -5.33106 0.85786 -0.44259 1.77871 -0.74744 2.7284 -0.90459 -0.1089 -0.42335 -0.2854 -0.81958 -0.5173 -1.17651 -1.17751 0.23177 -2.31097 0.66473 -3.34888 1.28394 -1.21866 -0.73719 -2.39208 -1.11403 -3.35454 -1.2996", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Rose"
);
var Shell = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.77766 3.85142C4.40349 3.62823 3.96611 3.5 3.49878 3.5 2.11806 3.5 0.998776 4.61929 0.998776 6c0 0.35482 0.073914 0.69238 0.207194 0.99811 -0.14607 0.18677 -0.278067 0.36966 -0.396425 0.5443 -0.543029 0.80122 -0.213574 1.83084 0.607205 2.34382L3.99878 11.5h6l2.58202 -1.61377c0.8208 -0.51298 1.1502 -1.5426 0.6072 -2.34382 -0.1184 -0.17464 -0.2503 -0.35753 -0.3964 -0.5443 0.1333 -0.30573 0.2072 -0.64329 0.2072 -0.99811 0 -1.38071 -1.1193 -2.5 -2.5 -2.5 -0.4674 0 -0.90474 0.12823 -1.2789 0.35142C8.8039 3.0486 7.9654 2.5 6.99878 2.5c-0.96663 0 -1.80512 0.5486 -2.22112 1.35142Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.99878 12.5v-1h-6v1c0 0.5523 0.44771 1 1 1h4c0.55228 0 1 -0.4477 1 -1Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.1602 3.58841c0.35216 0.09637 0.75541 -0.01817 1.00341 -0.28612 0.04637 -0.0501 0.09476 -0.09829 0.14505 -0.14445 0.03507 0.05676 0.06159 0.12016 0.07735 0.18882l0.72416 3.15414c0.07724 0.33642 -0.13287 0.67176 -0.46929 0.749 -0.33643 0.07724 -0.67177 -0.13287 -0.74901 -0.46929l-0.72416 -3.15414c-0.00291 -0.01266 -0.00541 -0.02531 -0.00751 -0.03796Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.639557 7.86909c0.042119 -0.11172 0.098497 -0.22119 0.170004 -0.3267 0.052839 -0.07796 0.108397 -0.15757 0.166711 -0.23843 0.137858 -0.19117 0.164318 -0.43895 0.104418 -0.66689l3.04226 2.28541c0.27598 0.20732 0.33164 0.59911 0.12432 0.87509 -0.20732 0.27603 -0.59912 0.33163 -0.8751 0.12432L0.639557 7.86909Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.9162 6.63964c-0.0597 0.2263 -0.0334 0.47236 0.1036 0.66216 0.0588 0.0816 0.1149 0.16194 0.1682 0.24059 0.0719 0.10602 0.1284 0.21603 0.1706 0.32831l-2.7304 2.05119c-0.276 0.20731 -0.66781 0.15171 -0.87514 -0.12432 -0.20732 -0.27598 -0.15166 -0.66777 0.12432 -0.87509l3.03882 -2.28284Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.69175 3.16043c0.0481 0.04429 0.09446 0.09044 0.13896 0.13834 0.25028 0.26939 0.65644 0.38475 1.0113 0.28838 -0.00215 0.01306 -0.00471 0.02614 -0.00772 0.03922l-0.72416 3.15414c-0.07724 0.33642 -0.41258 0.54653 -0.749 0.46929 -0.33643 -0.07724 -0.54654 -0.41258 -0.4693 -0.749l0.72416 -3.15414c0.01552 -0.06762 0.04147 -0.13013 0.07576 -0.18623Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Shell"
);
var ShovelRake = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.02417 0.0625c-0.41421 0 -0.75 0.335786 -0.75 0.75 0 0.41421 0.33579 0.75 0.75 0.75h0.67041v6.16773C8.335 8.06603 7.3269 9.29389 7.3269 10.7572v2.3678c0 0.4142 0.33579 0.75 0.75 0.75 0.41422 0 0.75 -0.3358 0.75 -0.75v-2.3678c0 -0.6228 0.35189 -1.16335 0.86768 -1.43376V13.125c0 0.4142 0.33582 0.75 0.75002 0.75s0.75 -0.3358 0.75 -0.75V9.32333c0.5159 0.27036 0.8679 0.81097 0.8679 1.43387v2.3678c0 0.4142 0.3358 0.75 0.75 0.75s0.75 -0.3358 0.75 -0.75v-2.3678c0 -1.4634 -1.0082 -2.69131 -2.3679 -3.02702V1.5625h0.6709c0.4142 0 0.75 -0.33579 0.75 -0.75 0 -0.414214 -0.3358 -0.75 -0.75 -0.75H9.02417ZM1.52314 2.04115C1.81549 1.01794 2.75071 0.3125 3.81487 0.3125c1.06415 0 1.99938 0.70544 2.29172 1.72865l0.77553 2.71436c0.44835 1.56921 -0.70158 3.1314 -2.31742 3.18536V12.375h0.67093c0.41422 0 0.75 0.3358 0.75 0.75s-0.33578 0.75 -0.75 0.75H3.8201l-0.0054 0 -0.00541 0h-1.415c-0.41422 0 -0.75 -0.3358 -0.75 -0.75s0.33578 -0.75 0.75 -0.75h0.67041V7.94086C1.44903 7.88669 0.299297 6.32461 0.747614 4.75551l0.775526 -2.71436Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ShovelRake"
);
var SnowFlake = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.53 0.22a0.75 0.75 0 1 0 -1.06 1.06l1.78 1.78v3.19H3.06L1.28 4.47A0.75 0.75 0 0 0 0.22 5.53L1.69 7 0.22 8.47a0.75 0.75 0 1 0 1.06 1.06l1.78 -1.78h3.19v3.19l-1.78 1.78a0.75 0.75 0 1 0 1.06 1.06L7 12.31l1.47 1.47a0.75 0.75 0 0 0 1.06 -1.06l-1.78 -1.78V7.75h3.19l1.78 1.78a0.75 0.75 0 1 0 1.06 -1.06L12.31 7l1.47 -1.47a0.75 0.75 0 0 0 -1.06 -1.06l-1.78 1.78H7.75V3.06l1.78 -1.78A0.75 0.75 0 0 0 8.47 0.22L7 1.69 5.53 0.22ZM2.97 2.97a0.75 0.75 0 0 1 1.06 0l1 1a0.75 0.75 0 0 1 -1.06 1.06l-1 -1a0.75 0.75 0 0 1 0 -1.06Zm2.06 7.06a0.75 0.75 0 1 0 -1.06 -1.06l-1 1a0.75 0.75 0 1 0 1.06 1.06l1 -1Zm6 -7.06a0.75 0.75 0 0 1 0 1.06l-1 1a0.75 0.75 0 1 1 -1.06 -1.06l1 -1a0.75 0.75 0 0 1 1.06 0Zm-1 6a0.75 0.75 0 1 0 -1.06 1.06l1 1a0.75 0.75 0 1 0 1.06 -1.06l-1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SnowFlake"
);
var Sprout = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.75789 5.61058c0.81101 0.4324 1.85571 0.35681 2.58551 -0.2785 0.7526 -0.58821 1.0983 -2.52828 1.2213 -3.43052 0.0359 -0.26312 -0.149 -0.49798 -0.4132 -0.5249 -0.9076 -0.09246 -2.8802 -0.21336 -3.62442 0.37512 -0.8913 0.63204 -1.18352 1.82226 -0.76307 2.7856 -0.0557 0.03214 -0.10816 0.07203 -0.1558 0.11967 -0.63955 0.63955 -1.19379 1.6328 -1.59637 2.60454 -0.25898 -0.36357 -0.58523 -0.68744 -0.97436 -1.0083 0.25096 -0.87826 -0.05878 -1.88127 -0.83214 -2.42968 -0.71577 -0.56596 -2.60579 -0.45374 -3.49072 -0.36451 -0.26422 0.02664 -0.44958 0.26204 -0.41342 0.52513 0.12088 0.8795 0.45567 2.73751 1.17942 3.30319 0.75579 0.65787 1.86049 0.69539 2.66341 0.17391 0.46003 0.38806 0.70662 0.70031 0.85613 1.03679 0.16886 0.38005 0.24983 0.87102 0.24983 1.68588 0 0.4037 0.31962 0.735 0.7231 0.7495 0.40349 0.0145 0.74603 -0.2931 0.77497 -0.6958 0.04398 -0.6118 0.28006 -1.50981 0.64907 -2.4008 0.37156 -0.89716 0.83467 -1.68212 1.27174 -2.11919 0.03351 -0.03351 0.06318 -0.0694 0.08902 -0.10713Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 10.1839c-4.84615 0 -7 2.1538 -7 2.1538v1.5818h14v-1.5818s-2.1538 -2.1538 -7 -2.1538Z" }),
    " "
  ] }) }),
  "Sprout"
);
var SunCloud = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.004 2.998a2.998 2.998 0 1 0 5.996 0 2.998 2.998 0 1 0 -5.996 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.5 5a4.5 4.5 0 0 0 0 9h6a2.5 2.5 0 0 0 0 -5 2.45 2.45 0 0 0 -1.17 0.3 0.24 0.24 0 0 1 -0.23 0 0.25 0.25 0 0 1 -0.14 -0.19A4.45 4.45 0 0 0 4.5 5Z" }),
    " "
  ] }) }),
  "SunCloud"
);
var TidalWave = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.5 0C5.39 0 4.202 2.248 4.007 3.418a0.5 0.5 0 0 0 0.679 0.546c0.562 -0.225 0.998 -0.264 1.33 -0.206 0.325 0.057 0.586 0.214 0.8 0.451 0.445 0.495 0.684 1.35 0.684 2.291 0 1.176 -1.225 2.5 -3 2.5 -0.857 0 -1.721 -0.453 -2.04 -1.197a0.5 0.5 0 0 0 -0.922 0.005c-0.21 0.506 -0.655 0.907 -1.18 1.063A0.5 0.5 0 0 0 0 9.35v3.681a0.5 0.5 0 0 0 0.5 0.5h13a0.5 0.5 0 0 0 0.5 -0.5V3.5a0.5 0.5 0 0 0 -0.053 -0.224C13.395 2.173 11.553 0 8.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.224 10.982a0.75 0.75 0 0 1 0.694 0.454c0.134 0.315 0.365 0.578 0.658 0.754 0.572 0.344 1.504 0.344 2.077 0a1.63 1.63 0 0 0 0.658 -0.754 0.75 0.75 0 0 1 1.378 0c0.135 0.315 0.365 0.578 0.658 0.754 0.573 0.344 1.505 0.344 2.077 0 0.293 -0.176 0.524 -0.44 0.658 -0.754a0.75 0.75 0 0 1 1.382 0.008 1.493 1.493 0 0 0 0.953 0.857 0.75 0.75 0 1 1 -0.428 1.438 2.992 2.992 0 0 1 -1.217 -0.707 3.123 3.123 0 0 1 -0.576 0.444c-1.047 0.629 -2.573 0.629 -3.62 0A3.13 3.13 0 0 1 7 13.032a3.13 3.13 0 0 1 -0.576 0.444c-1.047 0.629 -2.573 0.629 -3.62 0a3.125 3.125 0 0 1 -0.576 -0.444 2.992 2.992 0 0 1 -1.217 0.707 0.75 0.75 0 1 1 -0.428 -1.438 1.493 1.493 0 0 0 0.953 -0.857 0.75 0.75 0 0 1 0.688 -0.462Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TidalWave"
);
var Tree2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 9.5191c0.55228 0 1 0.44772 1 1v2.4818c0 0.5523 -0.44772 1 -1 1s-1 -0.4477 -1 -1l0 -2.4818c0 -0.55228 0.44772 -1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.99999 0C3.96312 0 1.50125 2.46187 1.50125 5.49874s2.46187 5.49876 5.49874 5.49876c3.03691 0 5.49871 -2.46189 5.49871 -5.49876S10.0369 0 6.99999 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Tree2"
);
var Tree3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.92 8.494a1 1 0 0 1 1 1v3.486a1 1 0 1 1 -2 0l0 -3.486a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.353 0.985a4 4 0 0 1 6.477 2.023 3.5 3.5 0 0 1 -0.328 6.984H3.498a3.5 3.5 0 0 1 -0.41 -6.976A4 4 0 0 1 4.353 0.986Z" }),
    " "
  ] }) }),
  "Tree3"
);
var Volcano = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.719 1.198A2.828 2.828 0 0 1 6.999 0.046a2.83 2.83 0 0 1 2.28 1.152 2.364 2.364 0 1 1 0.986 4.513H8.487v3.15H5.509v-3.15H3.733a2.364 2.364 0 1 1 0.986 -4.513Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.69 8.486a0.5 0.5 0 0 0 -0.5 0.5c0 0.917 -0.611 1.786 -1.472 2.528a9.78 9.78 0 0 1 -2.368 1.48 0.5 0.5 0 0 0 0.195 0.96h12.91a0.5 0.5 0 0 0 0.195 -0.96 9.779 9.779 0 0 1 -2.368 -1.48c-0.86 -0.742 -1.473 -1.61 -1.473 -2.528a0.5 0.5 0 0 0 -0.5 -0.5H4.691Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Volcano"
);
var WaningCresentMoon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9 0a7 7 0 0 0 0 14l0.004 0a7.079 7.079 0 0 0 2.657 -0.538 0.5 0.5 0 0 0 0.061 -0.894A6.5 6.5 0 0 1 8.5 7a6.5 6.5 0 0 1 3.194 -5.568 0.5 0.5 0 0 0 -0.063 -0.893A7.08 7.08 0 0 0 9.006 0H9Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WaningCresentMoon"
);
var WindFlow1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.75 0.75A0.75 0.75 0 0 1 7.5 0a2.5 2.5 0 1 1 0 5H0.75a0.75 0.75 0 0 1 0 -1.5H7.5a1 1 0 0 0 0 -2 0.75 0.75 0 0 1 -0.75 -0.75ZM2 7a0.75 0.75 0 0 1 0.75 -0.75h8.75a2.5 2.5 0 0 1 0 5 0.75 0.75 0 0 1 0 -1.5 1 1 0 1 0 0 -2H2.75A0.75 0.75 0 0 1 2 7Zm-0.25 2a0.75 0.75 0 0 0 0 1.5h5.5a1 1 0 0 1 0 2 0.75 0.75 0 0 0 0 1.5 2.5 2.5 0 0 0 0 -5h-5.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WindFlow1"
);
var WindFlow2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.673 0.834a0.75 0.75 0 0 0 -1.085 0.796l0.168 0.946a8.85 8.85 0 0 1 -1.369 0.173c-0.747 -0.004 -1.315 -0.287 -2.041 -0.665l-0.04 -0.02c-0.703 -0.366 -1.564 -0.814 -2.71 -0.814a10.386 10.386 0 0 0 -4.18 1.078 0.75 0.75 0 1 0 0.668 1.343 8.886 8.886 0 0 1 3.529 -0.921c0.747 0.004 1.315 0.287 2.041 0.665l0.04 0.02c0.703 0.366 1.564 0.815 2.71 0.815a10.34 10.34 0 0 0 4.18 -1.078 0.748 0.748 0 0 0 0.338 -1.006 0.747 0.747 0 0 0 -0.334 -0.336L11.673 0.834ZM4.562 5.751a0.75 0.75 0 0 1 0.034 -0.001c1.146 0 2.007 0.448 2.71 0.814l0.04 0.02c0.726 0.378 1.294 0.662 2.041 0.666a8.868 8.868 0 0 0 1.398 -0.18l-0.192 -0.916a0.75 0.75 0 0 1 1.08 -0.82l1.915 0.996a0.747 0.747 0 0 1 0.36 0.943 0.747 0.747 0 0 1 -0.364 0.399 10.488 10.488 0 0 1 -1.705 0.668 10.343 10.343 0 0 1 -2.475 0.41c-1.146 0 -2.007 -0.448 -2.71 -0.814l-0.04 -0.02c-0.726 -0.378 -1.294 -0.662 -2.041 -0.666a8.886 8.886 0 0 0 -3.53 0.922 0.75 0.75 0 1 1 -0.667 -1.344 10.386 10.386 0 0 1 4.146 -1.077Zm0 4.5 0.034 0c1.146 0 2.007 0.448 2.71 0.814l0.04 0.02c0.726 0.378 1.294 0.661 2.041 0.665a8.83 8.83 0 0 0 1.402 -0.18l-0.195 -0.912a0.75 0.75 0 0 1 1.079 -0.823l1.915 0.996a0.747 0.747 0 0 1 0.36 0.942 0.747 0.747 0 0 1 -0.364 0.4 10.394 10.394 0 0 1 -4.18 1.078c-1.146 0 -2.007 -0.449 -2.71 -0.815l-0.04 -0.02c-0.726 -0.378 -1.294 -0.661 -2.041 -0.665a8.887 8.887 0 0 0 -3.53 0.921 0.75 0.75 0 1 1 -0.667 -1.343 10.386 10.386 0 0 1 4.146 -1.078Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WindFlow2"
);
var Windmill = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.02 7.795C3.519 9.492 3 11.675 3 13.5a0.5 0.5 0 0 0 0.5 0.5h7a0.5 0.5 0 0 0 0.5 -0.5c0 -1.825 -0.518 -4.008 -1.02 -5.705 -0.14 -0.47 -0.53 -0.908 -0.659 -1.295H4.68c-0.13 0.387 -0.519 0.824 -0.658 1.295Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0v4.86a2 2 0 0 0 -2 -2H3.281a2 2 0 0 0 -2 2v0.859h4.86a2 2 0 0 0 -2 2v1.718a2 2 0 0 0 2 2H7V6.579a2 2 0 0 0 2 2h1.719a2 2 0 0 0 2 -2v-0.86h-4.86a2 2 0 0 0 2 -2V2a2 2 0 0 0 -2 -2H7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Windmill"
);
var AiScienceSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.148 6.804a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.223 7.22a1.89 1.89 0 0 0 1.397 0.584c0.687 0.982 1.196 1.952 1.46 2.817 0.288 0.939 0.365 2.038 -0.356 2.76 -0.467 0.466 -1.103 0.594 -1.708 0.557 -0.606 -0.036 -1.273 -0.238 -1.948 -0.545 -0.61 -0.278 -1.26 -0.655 -1.92 -1.118 -0.66 0.463 -1.309 0.84 -1.92 1.118 -0.675 0.307 -1.342 0.509 -1.947 0.545 -0.605 0.037 -1.241 -0.09 -1.709 -0.558 -0.467 -0.467 -0.594 -1.104 -0.558 -1.708 0.036 -0.606 0.239 -1.273 0.546 -1.948 0.277 -0.611 0.655 -1.26 1.117 -1.92A12.2 12.2 0 0 1 0.56 5.884C0.253 5.21 0.05 4.543 0.014 3.937c-0.036 -0.604 0.09 -1.24 0.558 -1.708 0.721 -0.72 1.82 -0.643 2.759 -0.357 0.866 0.265 1.836 0.775 2.818 1.462 -0.014 0.52 0.174 1.047 0.565 1.42a0.75 0.75 0 0 1 -0.128 0.116 17.35 17.35 0 0 0 -1.8 1.573c-0.451 0.452 -0.863 0.91 -1.23 1.362a17.82 17.82 0 0 0 2.592 2.592c0.453 -0.367 0.91 -0.779 1.362 -1.23a17.347 17.347 0 0 0 1.573 -1.8 0.746 0.746 0 0 1 0.14 -0.147Zm-6.33 -3.914c0.575 0.176 1.262 0.51 2.006 0.993a19.52 19.52 0 0 0 -2.256 2.256 10.016 10.016 0 0 1 -0.718 -1.291c-0.263 -0.58 -0.392 -1.06 -0.414 -1.418 -0.021 -0.358 0.067 -0.502 0.122 -0.557 0.09 -0.09 0.423 -0.239 1.26 0.017Zm-0.968 7.038c0.184 -0.404 0.425 -0.839 0.718 -1.291A19.516 19.516 0 0 0 4.9 11.309c-0.452 0.293 -0.887 0.534 -1.291 0.718 -0.58 0.264 -1.06 0.393 -1.417 0.414 -0.36 0.022 -0.503 -0.067 -0.558 -0.122 -0.055 -0.055 -0.143 -0.199 -0.122 -0.557 0.022 -0.358 0.15 -0.838 0.414 -1.418Zm6.763 1.683a10.028 10.028 0 0 1 -1.29 -0.718 19.521 19.521 0 0 0 2.255 -2.256c0.483 0.744 0.817 1.432 0.993 2.007 0.256 0.836 0.108 1.17 0.018 1.26 -0.056 0.054 -0.2 0.143 -0.558 0.121 -0.358 -0.021 -0.838 -0.15 -1.418 -0.414Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.39 0.679c-0.19 -0.835 -1.382 -0.83 -1.565 0.007l-0.007 0.033 -0.014 0.064A2.38 2.38 0 0 1 7.888 2.61c-0.87 0.152 -0.87 1.401 0 1.553a2.38 2.38 0 0 1 1.918 1.836l0.02 0.088c0.182 0.836 1.373 0.842 1.563 0.007l0.024 -0.102a2.396 2.396 0 0 1 1.925 -1.828c0.872 -0.151 0.872 -1.404 0 -1.555A2.396 2.396 0 0 1 11.416 0.796l-0.018 -0.078L11.39 0.68Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiScienceSpark"
);
var BookReading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.998 0.055A1.38 1.38 0 0 1 1.58 0.014l0.012 0.001a8.738 8.738 0 0 1 4.666 2.361 8.738 8.738 0 0 1 4.666 -2.36l0.011 -0.002a1.385 1.385 0 0 1 1.58 1.372v7.129a1.385 1.385 0 0 1 -0.521 1.09 3.267 3.267 0 0 0 -0.6 -0.056h-0.75v-1.5a2.5 2.5 0 0 0 -5 0v3.614c-1.466 -1.022 -2.79 -1.493 -4.426 -1.766A1.386 1.386 0 0 1 0 8.515v-7.13A1.386 1.386 0 0 1 0.998 0.056Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.644 8.049c0 -0.921 0.497 -1.726 1.239 -2.16l0 -4.066c-0.362 0.29 -0.888 0.29 -1.25 0v9.476c0 0.04 0.003 0.078 0.01 0.116V8.049Zm1.25 5.25v-5.25a1.25 1.25 0 0 1 2.5 0v2.75h2a2 2 0 0 1 2 2v0.5a0.5 0.5 0 0 1 -0.5 0.5h-5.5a0.5 0.5 0 0 1 -0.5 -0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BookReading"
);
var CircleFlask = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.456 0.005a0.75 0.75 0 0 0 0 1.5H5v2.907a5 5 0 1 0 4 0V1.505h0.544a0.75 0.75 0 0 0 0 -1.5H4.456Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CircleFlask"
);
var ClassLesson = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.746 2.583a1.848 1.848 0 1 1 -3.695 0 1.848 1.848 0 0 1 3.695 0Zm2.32 3.096a1.027 1.027 0 0 1 0 2.055h-2.16l-0.752 5.404a1 1 0 0 1 -0.99 0.862H2.66a1 1 0 0 1 -0.994 -0.893l-0.282 -2.61h-0.172a0.964 0.964 0 0 1 -0.963 -0.963V8.328a2.649 2.649 0 0 1 2.65 -2.648h4.167Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.259 8.976h5.143c0.745 0 1.348 -0.604 1.348 -1.349V1.35c0 -0.746 -0.604 -1.35 -1.348 -1.35H4.608a3.095 3.095 0 0 1 0.778 4.43h1.68a2.277 2.277 0 0 1 0.193 4.546Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ClassLesson"
);
var DefinitionSearchBook = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 0.125a0.5 0.5 0 0 0 -0.5 0.5v10a0.5 0.5 0 0 0 0.5 0.5h4.756A4.492 4.492 0 0 1 5 9.625c0 -1.271 0.527 -2.42 1.375 -3.238v-4.96A2 2 0 0 0 4.5 0.126h-4Zm7.125 1.303v4.105a4.5 4.5 0 0 1 6.347 3.584H14V0.625a0.5 0.5 0 0 0 -0.5 -0.5h-4a2 2 0 0 0 -1.875 1.303Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 9.625a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1 -3.5 0Zm1.75 -3.25a3.25 3.25 0 1 0 1.706 6.017l1.263 1.263a0.75 0.75 0 0 0 1.06 -1.06l-1.262 -1.264A3.25 3.25 0 0 0 9.5 6.375Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DefinitionSearchBook"
);
var DictionaryLanguageBook = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.75 10.75v1.75H3.625c-0.48325 0 -0.875 -0.3918 -0.875 -0.875s0.39175 -0.875 0.875 -0.875h8.125Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.25 2.25v9.375C1.25 12.9367 2.31332 14 3.625 14H12c0.4142 0 0.75 -0.3358 0.75 -0.75s-0.3358 -0.75 -0.75 -0.75H3.625c-0.48325 0 -0.875 -0.3918 -0.875 -0.875s0.39175 -0.875 0.875 -0.875H12c0.4142 0 0.75 -0.3358 0.75 -0.75V2.25C12.75 1.00736 11.7426 0 10.5 0h-7C2.25736 0 1.25 1.00736 1.25 2.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.81376 2.62936c-0.12271 -0.36812 -0.46721 -0.61642 -0.85524 -0.61642s-0.73253 0.2483 -0.85523 0.61642L3.4268 4.65881c-0.00261 0.00726 -0.00505 0.0146 -0.00733 0.02201l-0.3822 1.1466c-0.08733 0.26197 0.05425 0.54513 0.31623 0.63245 0.26197 0.08732 0.54513 -0.05426 0.63245 -0.31623l0.27188 -0.81564h1.40138l0.27188 0.81564c0.08733 0.26197 0.37049 0.40355 0.63246 0.31623 0.26197 -0.08732 0.40355 -0.37048 0.31623 -0.63245l-0.3822 -1.14659c-0.00228 -0.00742 -0.00473 -0.01476 -0.00734 -0.02202l-0.67648 -2.02945ZM4.59117 4.328l0.36735 -1.10207 0.36736 1.10207h-0.73471Zm5.77523 0.17395c0.187 0 0.3583 0.10428 0.4442 0.27033 0.0858 0.16605 0.0719 0.36614 -0.0362 0.51868L8.87357 7.97454h1.63753c0.2762 0 0.5 0.22386 0.5 0.5 0 0.27615 -0.2238 0.5 -0.5 0.5H7.90668c-0.18694 0 -0.35826 -0.10428 -0.44413 -0.27033 -0.08587 -0.16605 -0.07194 -0.36613 0.03612 -0.51868l1.90087 -2.68358H8.05137c-0.27614 0 -0.5 -0.22385 -0.5 -0.5 0 -0.27614 0.22386 -0.5 0.5 -0.5h2.31503Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DictionaryLanguageBook"
);
var ErlenmeyerFlask = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.02 0.75A0.75 0.75 0 0 1 3.77 0h6.46a0.75 0.75 0 0 1 0 1.5H9.5v4.827l3.486 4.437c1.031 1.313 0.097 3.236 -1.572 3.236H2.586c-1.669 0 -2.604 -1.923 -1.572 -3.236L4.5 6.327V1.5h-0.73a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ErlenmeyerFlask"
);
var GlobalLearning = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.264 6.717a0.546 0.546 0 0 1 0.434 0L13.67 8.44a0.546 0.546 0 0 1 0 1.002l-3.973 1.722a0.546 0.546 0 0 1 -0.434 0L6.189 9.83v2.3a0.683 0.683 0 0 1 -1.365 0V9.104a0.68 0.68 0 0 1 0.35 -0.595 0.545 0.545 0 0 1 0.116 -0.069l3.974 -1.722Zm-0.475 5.387 -2.024 -0.877 0.003 1.36c0 0.118 0.039 0.233 0.11 0.328l0.435 -0.33 -0.435 0.33 0 0.001 0.002 0.001 0.001 0.002 0.005 0.006 0.012 0.015 0.037 0.044c0.03 0.034 0.073 0.08 0.127 0.132 0.11 0.104 0.269 0.238 0.482 0.369 0.43 0.265 1.07 0.515 1.936 0.515 0.866 0 1.506 -0.25 1.937 -0.515 0.214 -0.13 0.374 -0.264 0.483 -0.368a2.124 2.124 0 0 0 0.165 -0.176l0.012 -0.015 0.005 -0.005 0.001 -0.003 0.001 0 0 -0.001 -0.433 -0.33 0.434 0.33a0.546 0.546 0 0 0 0.111 -0.331l0 -1.359 -2.024 0.877a1.74 1.74 0 0 1 -1.383 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.006 0a6.006 6.006 0 0 0 -2.317 11.548V9.052a1.75 1.75 0 0 1 1.05 -1.737l4.025 -1.743a1.75 1.75 0 0 1 1.391 0l1.846 0.8A6.006 6.006 0 0 0 6.006 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.395 0.012a0.625 0.625 0 0 1 0.094 0.094A10.129 10.129 0 0 1 8.697 5.38h3.282a6.087 6.087 0 0 1 0.022 0.99l-1.846 -0.8a1.75 1.75 0 0 0 -1.391 0L6.319 6.63H4.57c0.03 0.238 0.07 0.474 0.119 0.708a1.75 1.75 0 0 0 -0.968 1.23 10.127 10.127 0 0 1 -0.41 -1.938H0.032a6.076 6.076 0 0 1 0 -1.25H3.31A10.13 10.13 0 0 1 5.52 0.106a0.625 0.625 0 0 1 0.093 -0.093 6.096 6.096 0 0 1 0.783 0ZM6.004 1.55a8.879 8.879 0 0 1 1.435 3.83h-2.87a8.879 8.879 0 0 1 1.435 -3.83Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GlobalLearning"
);
var GraduationCap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m2.95 7 0.006 2.517a0.5 0.5 0 0 0 0.1 0.3l0.4 -0.301 -0.4 0.301 0.001 0.001 0.001 0.001 0.002 0.003 0.005 0.006 0.016 0.02 0.05 0.06c0.043 0.048 0.105 0.114 0.185 0.191 0.162 0.154 0.4 0.354 0.723 0.553 0.648 0.399 1.624 0.784 2.96 0.784 1.337 0 2.314 -0.386 2.964 -0.784 0.323 -0.198 0.562 -0.398 0.724 -0.552a3.168 3.168 0 0 0 0.237 -0.252l0.015 -0.019 0.005 -0.006 0.002 -0.003s0.002 -0.002 -0.396 -0.304l0.398 0.302a0.5 0.5 0 0 0 0.101 -0.302l0 -2.516 -3.354 1.453a1.75 1.75 0 0 1 -1.391 0L2.95 7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.695 4.069c0.276 0 0.5 0.28 0.5 0.625v6.89c0 0.346 -0.224 0.626 -0.5 0.626s-0.5 -0.28 -0.5 -0.626v-6.89c0 -0.345 0.224 -0.625 0.5 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.696 10.998a1.24 1.24 0 1 0 0 2.478 1.24 1.24 0 0 0 0 -2.478Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.199 0.892a0.5 0.5 0 0 0 -0.398 0l-6.5 2.816a0.5 0.5 0 0 0 0 0.918l6.5 2.816a0.5 0.5 0 0 0 0.398 0l6.5 -2.816a0.5 0.5 0 0 0 0 -0.918L7.199 0.892Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m2.95 5.774 3.851 1.668a0.5 0.5 0 0 0 0.398 0l3.85 -1.668V9.22l0 -2.22 -3.354 1.453a1.75 1.75 0 0 1 -1.391 0L2.95 7V5.774ZM2.95 7l0.005 2.22h-0.004V7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GraduationCap"
);
var ManualBook = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m3.5 13.25 8.233 0v-3l-8.233 0a1.5 1.5 0 1 0 0 3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.25 2.25v9.375A2.375 2.375 0 0 0 3.625 14H12a0.75 0.75 0 0 0 0 -1.5H3.625a0.875 0.875 0 0 1 0 -1.75H12a0.75 0.75 0 0 0 0.75 -0.75V2.25A2.25 2.25 0 0 0 10.5 0h-7a2.25 2.25 0 0 0 -2.25 2.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.17 2.829a0.875 0.875 0 0 0 -1.045 0.858 0.625 0.625 0 1 1 -1.25 0 2.125 2.125 0 1 1 2.75 2.031 0.625 0.625 0 0 1 -1.25 -0.031v-0.5c0 -0.345 0.28 -0.625 0.625 -0.625a0.875 0.875 0 0 0 0.17 -1.733Zm-1.045 5.18a0.875 0.875 0 1 0 1.75 0 0.875 0.875 0 0 0 -1.75 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ManualBook"
);
var NewsPaper = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.293 1.543A1 1 0 0 1 1 1.25h9.27a1 1 0 0 1 1 1v1.76a0.503 0.503 0 0 1 0.096 -0.01H13.5a0.5 0.5 0 0 1 0.5 0.5V11a1.75 1.75 0 0 1 -1.75 1.75H1.5a1.5 1.5 0 0 1 -1.5 -1.5v-9a1 1 0 0 1 0.293 -0.707Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.787 4.037a0.5 0.5 0 0 1 0.5 -0.5h4.5a0.5 0.5 0 0 1 0.5 0.5v2.5a0.5 0.5 0 0 1 -0.5 0.5h-4.5a0.5 0.5 0 0 1 -0.5 -0.5v-2.5Zm0.5 5.088a0.625 0.625 0 1 0 0 1.25h4.5a0.625 0.625 0 0 0 0 -1.25h-4.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.27 3.713v0.296A0.503 0.503 0 0 1 11.366 4h1.153l0 6.459a0.625 0.625 0 1 1 -1.25 0V3.743l0 -0.03Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NewsPaper"
);
var OpenBook = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.49642 0.179297C4.12508 0.491169 6.43824 1.52628 7 2.08803 7.56176 1.52628 9.87492 0.491312 12.5036 0.179439 13.3262 0.0818366 14 0.759749 14 1.58818v7.99999c0 0.82843 -0.677 1.48863 -1.4921 1.63663 -1.8409 0.3342 -3.37196 1.217 -4.34871 1.9148 -0.67407 0.4815 -1.64499 0.4809 -2.31909 -0.0006 -0.97678 -0.6977 -2.50755 -1.5802 -4.34797 -1.9144C0.677027 11.0766 0 10.4165 0 9.58803v-8C0 0.759606 0.673762 0.0816941 1.49642 0.179297Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.375 13.4046V1.65274c0.368 0.20612 0.88199 0.20613 1.25 0.00002V13.4048c-0.40314 0.1276 -0.84681 0.1275 -1.25 -0.0002Z" }),
    " "
  ] }) }),
  "OpenBook"
);
var Podium = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.189 3c-0.0405 -0.28535 -0.1094 -0.63285 -0.2275 -0.98717C11.6789 1.16484 10.9982 0 9.5 0c-0.41421 0 -0.75 0.335786 -0.75 0.75 0 0.31203 0.19055 0.57955 0.46163 0.69256l0.00001 0L10.2498 3 9.21164 1.44256C9.30041 1.47957 9.39782 1.5 9.5 1.5c0.5018 0 0.8212 0.33516 1.0385 0.98717 0.0574 0.17231 0.0997 0.34793 0.1307 0.51283h1.5198ZM7.75 3V0.75C7.75 0.335786 7.41422 0 7 0c-0.41421 0 -0.75 0.335786 -0.75 0.75V3h1.5ZM3.3308 3c0.03098 -0.1649 0.07328 -0.34052 0.13072 -0.51283C3.67885 1.83516 3.9982 1.5 4.5 1.5c0.41422 0 0.75 -0.33579 0.75 -0.75C5.25 0.335786 4.91422 0 4.5 0 3.00181 0 2.32115 1.16484 2.03849 2.01283c-0.11811 0.35432 -0.18696 0.70182 -0.22753 0.98717H3.3308Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.613333 3.18301C0.708303 3.06716 0.850208 3 1 3h12c0.1498 0 0.2917 0.06716 0.3867 0.18301 0.0949 0.11584 0.133 0.26816 0.1036 0.41505l-1 5C12.4436 8.83177 12.2383 9 12 9H9.5v3.5h0.5c0.4142 0 0.75 0.3358 0.75 0.75s-0.3358 0.75 -0.75 0.75H4c-0.41421 0 -0.75 -0.3358 -0.75 -0.75s0.33579 -0.75 0.75 -0.75h0.5V9H2c-0.23834 0 -0.44354 -0.16823 -0.49029 -0.40194l-0.999996 -5c-0.029378 -0.14689 0.00865 -0.29921 0.103619 -0.41505Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Podium"
);
var ProjectorBoard = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 13.25v-3a0.75 0.75 0 0 0 -1.5 0v3a0.75 0.75 0 0 0 1.5 0ZM6.03 9.72a0.75 0.75 0 0 1 0 1.06l-3 3a0.75 0.75 0 0 1 -1.06 -1.06l3 -3a0.75 0.75 0 0 1 1.06 0Zm1.94 0a0.75 0.75 0 0 1 1.06 0l3 3a0.75 0.75 0 1 1 -1.06 1.06l-3 -3a0.75 0.75 0 0 1 0 -1.06Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0h11S14 0 14 1.5v8s0 1.5 -1.5 1.5h-11S0 11 0 9.5v-8S0 0 1.5 0" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v2H0l0 -2Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "ProjectorBoard"
);
var QualityEducation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.561 1.267c0 -0.577 -0.484 -1.142 -1.118 -1.152l-0.004 0 -8.343 0.006a1.25 1.25 0 0 0 -0.741 0.243l-0.96 0.707a0.25 0.25 0 0 0 0 0.403l0.96 0.706c0.214 0.159 0.474 0.244 0.742 0.244l8.342 -0.005 0.004 0c0.634 -0.01 1.118 -0.575 1.118 -1.152Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.723 4.118a0.5 0.5 0 0 0 -0.5 0.5v7.188a0.5 0.5 0 0 0 0.5 0.5c1.617 0 2.678 0.243 3.413 0.538 0.66 0.265 1.078 0.577 1.444 0.851l0.122 0.091a0.5 0.5 0 0 0 0.596 0l0.121 -0.09c0.367 -0.274 0.785 -0.587 1.445 -0.852 0.736 -0.295 1.796 -0.538 3.413 -0.538a0.5 0.5 0 0 0 0.5 -0.5V4.618a0.5 0.5 0 0 0 -0.5 -0.5c-1.72 0 -2.91 0.259 -3.785 0.61A6.559 6.559 0 0 0 7 5.573a6.559 6.559 0 0 0 -1.492 -0.845c-0.875 -0.351 -2.065 -0.61 -3.785 -0.61Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.375 13.543V5.155l0.015 0.01a1.192 1.192 0 0 0 1.235 -0.01l0 8.388a20.096 20.096 0 0 0 -0.327 0.244 0.5 0.5 0 0 1 -0.596 0l-0.122 -0.092 -0.205 -0.152Z" }),
    " "
  ] }) }),
  "QualityEducation"
);
var Script2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M10.5 1.75A1.75 1.75 0 0 1 12.25 0h-8A1.75 1.75 0 0 0 2.5 1.75V11c0 0.818 -0.393 1.544 -1 2h-1a0.5 0.5 0 0 0 0 1H8a2.5 2.5 0 0 0 2.5 -2.5V1.75Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.25 0A1.75 1.75 0 0 1 14 1.75V3.5a0.5 0.5 0 0 1 -0.5 0.5h-3V1.75A1.75 1.75 0 0 1 12.25 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.177 3.5c0 -0.345 0.28 -0.625 0.625 -0.625H7.74a0.625 0.625 0 1 1 0 1.25H5.802a0.625 0.625 0 0 1 -0.625 -0.625Zm-1.291 3c0 -0.345 0.28 -0.625 0.625 -0.625H7.74a0.625 0.625 0 1 1 0 1.25H4.51a0.625 0.625 0 0 1 -0.624 -0.625Zm0.625 2.375a0.625 0.625 0 1 0 0 1.25H7.74a0.625 0.625 0 1 0 0 -1.25H4.51Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Script2"
);
var Telescope = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.86 5.1 -2.337 0.852 0.936 2.569 2.337 -0.852 -0.936 -2.568Zm2.942 2.883L4.884 12.69a0.75 0.75 0 0 0 1.389 0.566l1.682 -4.129 1.682 4.129a0.75 0.75 0 0 0 1.39 -0.566L8.871 7.404l-2.07 0.579Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.893 0.315a0.5 0.5 0 0 1 0.276 0.29l1.758 4.826a0.5 0.5 0 0 1 -0.335 0.652L5.531 8.338a0.5 0.5 0 0 1 -0.605 -0.31l-1.319 -3.62a0.5 0.5 0 0 1 0.263 -0.626L11.492 0.321a0.5 0.5 0 0 1 0.4 -0.006ZM1.497 5.881a0.75 0.75 0 1 0 -1.41 0.514l0.995 2.727a0.75 0.75 0 0 0 1.409 -0.514l-0.994 -2.727Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Telescope"
);
var TestTube = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.017 0.749a0.75 0.75 0 0 1 0.75 -0.75h8.466a0.75 0.75 0 1 1 0 1.5H10.5V10.5a3.5 3.5 0 1 1 -7 0V1.499h-0.733a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 3.923v-1.25H6a0.625 0.625 0 1 1 0 1.25H3.5Zm0 3.202v-1.25H6a0.625 0.625 0 1 1 0 1.25H3.5Zm0 3.202v-1.25H6a0.625 0.625 0 1 1 0 1.25H3.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TestTube"
);
var AddLayer2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.25 2.25a1.5 1.5 0 0 0 -1.5 -1.5h-8a1.5 1.5 0 0 0 -1.5 1.5v8a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5 -1.5v-8Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11 4.5A1.5 1.5 0 0 0 9.5 3h-8A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5 -1.5v-8Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.25 6a0.75 0.75 0 0 0 -1.5 0v1.75H3a0.75 0.75 0 0 0 0 1.5h1.75V11a0.75 0.75 0 0 0 1.5 0V9.25H8a0.75 0.75 0 0 0 0 -1.5H6.25V6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AddLayer2"
);
var AlignBack1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3 4.5A1.5 1.5 0 0 1 4.5 3h8A1.5 1.5 0 0 1 14 4.5v8a1.5 1.5 0 0 1 -1.5 1.5h-8A1.5 1.5 0 0 1 3 12.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h8A1.5 1.5 0 0 1 11 1.5v8A1.5 1.5 0 0 1 9.5 11h-8A1.5 1.5 0 0 1 0 9.5v-8Z" }),
    " "
  ] }) }),
  "AlignBack1"
);
var AlignFront1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5C0 0.671573 0.671573 0 1.5 0h8c0.8284 0 1.5 0.671573 1.5 1.5v8c0 0.8284 -0.6716 1.5 -1.5 1.5h-8C0.671573 11 0 10.3284 0 9.5v-8Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3 4.5C3 3.67157 3.67157 3 4.5 3h8c0.8284 0 1.5 0.67157 1.5 1.5v8c0 0.8284 -0.6716 1.5 -1.5 1.5h-8c-0.82843 0 -1.5 -0.6716 -1.5 -1.5v-8Z" }),
    " "
  ] }) }),
  "AlignFront1"
);
var AutoFlash = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.615 0.59a0.5 0.5 0 0 0 -0.912 -0.283L1.176 6.89a0.5 0.5 0 0 0 0.413 0.783h2.38v3.615a0.5 0.5 0 0 0 0.912 0.283l4.526 -6.583a0.5 0.5 0 0 0 -0.412 -0.783h-2.38V0.59Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.896 7.484a1.444 1.444 0 0 0 -2.74 0L7.987 10.99a0.77 0.77 0 0 0 -0.012 0.036l-0.66 1.982a0.75 0.75 0 1 0 1.423 0.474l0.495 -1.487h2.586l0.495 1.487a0.75 0.75 0 1 0 1.424 -0.474l-0.662 -1.985a0.743 0.743 0 0 0 -0.01 -0.03l-1.17 -3.51Zm-0.577 3.012 -0.793 -2.378 -0.793 2.378h1.586Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AutoFlash"
);
var Brightness1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.75 7a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 0.75a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1Zm0 11.5a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1ZM11.5 7a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1A0.75 0.75 0 0 1 11.5 7ZM0.75 6.25a0.75 0.75 0 0 0 0 1.5h1a0.75 0.75 0 0 0 0 -1.5h-1Zm1.3 -4.2a0.75 0.75 0 0 1 1.06 0l0.862 0.86A0.75 0.75 0 0 1 2.91 3.973l-0.86 -0.861a0.75 0.75 0 0 1 0 -1.06Zm9.04 7.978a0.75 0.75 0 1 0 -1.062 1.06l0.861 0.862a0.75 0.75 0 0 0 1.06 -1.061l-0.86 -0.86Zm0.86 -7.978a0.75 0.75 0 0 1 0 1.06l-0.86 0.862a0.75 0.75 0 0 1 -1.062 -1.061l0.861 -0.86a0.75 0.75 0 0 1 1.06 0Zm-7.978 9.04a0.75 0.75 0 1 0 -1.061 -1.06l-0.86 0.86a0.75 0.75 0 0 0 1.06 1.06l0.86 -0.86Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Brightness1"
);
var Brightness2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 0.75a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1Zm0 11.5a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1ZM11.5 7a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1A0.75 0.75 0 0 1 11.5 7ZM0.75 6.25a0.75 0.75 0 0 0 0 1.5h1a0.75 0.75 0 0 0 0 -1.5h-1Zm1.3 -4.2a0.75 0.75 0 0 1 1.06 0l0.862 0.86A0.75 0.75 0 0 1 2.91 3.973l-0.86 -0.861a0.75 0.75 0 0 1 0 -1.06Zm9.04 7.978a0.75 0.75 0 1 0 -1.062 1.06l0.861 0.862a0.75 0.75 0 0 0 1.06 -1.061l-0.86 -0.86Zm0.86 -7.978a0.75 0.75 0 0 1 0 1.06l-0.86 0.862a0.75 0.75 0 0 1 -1.062 -1.061l0.861 -0.86a0.75 0.75 0 0 1 1.06 0Zm-7.978 9.04a0.75 0.75 0 1 0 -1.061 -1.06l-0.86 0.86a0.75 0.75 0 0 0 1.06 1.06l0.86 -0.86Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.75 7a3.25 3.25 0 0 0 2.752 3.212c0.273 0.042 0.498 -0.186 0.498 -0.462v-5.5c0 -0.276 -0.225 -0.504 -0.498 -0.462A3.25 3.25 0 0 0 3.75 7Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Brightness2"
);
var Brightness3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6 7a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.75 0.75a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1Zm0 11.5a0.75 0.75 0 0 0 -1.5 0v1a0.75 0.75 0 0 0 1.5 0v-1ZM11.5 7a0.75 0.75 0 0 1 0.75 -0.75h1a0.75 0.75 0 0 1 0 1.5h-1A0.75 0.75 0 0 1 11.5 7ZM0.75 6.25a0.75 0.75 0 0 0 0 1.5h1a0.75 0.75 0 0 0 0 -1.5h-1Zm1.3 -4.2a0.75 0.75 0 0 1 1.06 0l0.862 0.86A0.75 0.75 0 0 1 2.91 3.973l-0.86 -0.861a0.75 0.75 0 0 1 0 -1.06Zm9.04 7.978a0.75 0.75 0 1 0 -1.062 1.06l0.861 0.862a0.75 0.75 0 0 0 1.06 -1.061l-0.86 -0.86Zm0.86 -7.978a0.75 0.75 0 0 1 0 1.06l-0.86 0.862a0.75 0.75 0 0 1 -1.062 -1.061l0.861 -0.86a0.75 0.75 0 0 1 1.06 0Zm-7.978 9.04a0.75 0.75 0 1 0 -1.061 -1.06l-0.86 0.86a0.75 0.75 0 0 0 1.06 1.06l0.86 -0.86Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Brightness3"
);
var ColorPalette = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.97352 4.06315C4.44759 2.85522 5.62392 2 7 2c1.37608 0 2.55241 0.85522 3.0265 2.06315C9.77381 4.02161 9.51443 4 9.25 4c-0.81407 0 -1.5803 0.20479 -2.25 0.56565C6.3303 4.20479 5.56407 4 4.75 4c-0.26443 0 -0.52381 0.02161 -0.77648 0.06315Zm-1.69089 0.62715C2.5596 2.33072 4.566 0.5 7 0.5c2.43399 0 4.4404 1.83072 4.7174 4.1903C13.0861 5.52393 14 7.03024 14 8.75c0 2.6234 -2.1266 4.75 -4.75 4.75 -0.81407 0 -1.5803 -0.2048 -2.25 -0.5657 -0.6697 0.3609 -1.43593 0.5657 -2.25 0.5657C2.12665 13.5 0 11.3734 0 8.75c0 -1.71976 0.913945 -3.22607 2.28263 -4.0597Zm7.94307 0.95872C9.91774 5.5522 9.58997 5.5 9.25 5.5c-0.31851 0 -0.62633 0.04582 -0.9172 0.13123 0.46551 0.53432 0.81345 1.17377 1.00351 1.87801 0.4786 -0.49482 0.80139 -1.14123 0.88939 -1.86022ZM9.46737 9.3097c1.02703 -0.62555 1.79803 -1.62987 2.11893 -2.81893 0.5656 0.58481 0.9137 1.38137 0.9137 2.25923 0 1.7949 -1.4551 3.25 -3.25 3.25 -0.31851 0 -0.62633 -0.0458 -0.9172 -0.1312 0.61163 -0.7021 1.0203 -1.5856 1.13457 -2.5591Zm-1.49162 -0.95872C7.88253 7.58958 7.526 6.90956 7 6.40479c-0.526 0.50477 -0.88253 1.18479 -0.97575 1.94619C6.33226 8.4478 6.66003 8.5 7 8.5s0.66774 -0.0522 0.97575 -0.14902ZM6.22353 9.93685C6.47619 9.97839 6.73557 10 7 10c0.26443 0 0.52381 -0.02161 0.77648 -0.06315 -0.17323 0.44135 -0.44023 0.83565 -0.77648 1.15835 -0.33625 -0.3227 -0.60325 -0.717 -0.77647 -1.15835Zm-1.6909 -0.62715c0.11427 0.9735 0.52294 1.857 1.13458 2.5591 -0.29088 0.0854 -0.5987 0.1312 -0.91721 0.1312 -1.79493 0 -3.25 -1.4551 -3.25 -3.25 0 -0.87786 0.34805 -1.67443 0.91369 -2.25924 0.3209 1.18906 1.09189 2.19339 2.11894 2.81894Zm0.13106 -1.80046c-0.4786 -0.49482 -0.80142 -1.14123 -0.88944 -1.86022C4.08226 5.5522 4.41003 5.5 4.75 5.5c0.31851 0 0.62633 0.04582 0.91721 0.13123 -0.46552 0.53432 -0.81346 1.17376 -1.00352 1.87801Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ColorPalette"
);
var ColorPicker = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m0.329 11.409 1.253 -1.253a3.425 3.425 0 0 1 0.6 -3.993l2.96 -2.96 5.655 5.656 -2.96 2.96a3.425 3.425 0 0 1 -3.993 0.599L2.591 13.67a1.131 1.131 0 0 1 -1.595 0l-0.667 -0.667a1.131 1.131 0 0 1 0 -1.595Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.91 1.223C8.51 -0.39 11.18 -0.39 12.78 1.22c1.61 1.6 1.61 4.27 -0.002 5.869l-0.813 0.813L13.03 8.97a0.75 0.75 0 1 1 -1.06 1.06l-8 -8A0.75 0.75 0 0 1 5.03 0.97l1.067 1.066 0.813 -0.813Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ColorPicker"
);
var ColorSwatches = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M14 12.5v-3c0 -0.39782 -0.158 -0.77936 -0.4393 -1.06066C13.2794 8.15804 12.8978 8 12.5 8L3 8c-0.79565 0 -1.55871 0.31607 -2.121321 0.87868 -0.278575 0.27858 -0.499553 0.60929 -0.650318 0.97327C0.0775967 10.2159 1.72e-8 10.606 0 11c-3.48e-8 0.7956 0.31607 1.5587 0.878679 2.1213C1.44129 13.6839 2.20435 14 3 14l9.5 0c0.3978 0 0.7794 -0.158 1.0607 -0.4393S14 12.8978 14 12.5Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m12.3388 3.78258 -2.1213 -2.12132c-0.28129 -0.2813 -0.66282 -0.43934 -1.06064 -0.43934 -0.39783 0 -0.77936 0.15804 -1.06067 0.43934L0.87868 8.87878C0.316071 9.44139 3.793e-7 10.2045 0 11.0001c4.215e-7 0.394 0.0775974 0.7841 0.228361 1.1481 0.150764 0.3639 0.371743 0.6946 0.650319 0.9732 0.56261 0.5626 1.32567 0.8787 2.12132 0.8787s1.55871 -0.3161 2.12132 -0.8787l7.21748 -7.2175c0.2813 -0.2813 0.4394 -0.66283 0.4394 -1.06066 0 -0.39782 -0.1581 -0.77935 -0.4394 -1.06066Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.5 0h-3C1.10218 0 0.720644 0.158035 0.43934 0.43934 0.158035 0.720644 0 1.10218 0 1.5V11c0 0.7956 0.31607 1.5587 0.87868 2.1213 0.27858 0.2786 0.60929 0.4996 0.97327 0.6503C2.21593 13.9224 2.60603 14 3 14c0.79565 0 1.55871 -0.3161 2.12132 -0.8787C5.68393 12.5587 6 11.7956 6 11V1.5c0 -0.39783 -0.15804 -0.779356 -0.43934 -1.06066C5.27936 0.158035 4.89782 0 4.5 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.39548 3.37451c-0.34518 0 -0.625003 0.27982 -0.625003 0.625s0.279823 0.625 0.625003 0.625h3.20904c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H1.39548Zm0 4.50049c-0.34518 0 -0.625003 0.27982 -0.625003 0.625s0.279823 0.625 0.625003 0.625h3.20904c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H1.39548Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ColorSwatches"
);
var CompositionOval = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.32 2.391A13.77 13.77 0 0 0 7 1.5a13.77 13.77 0 0 0 -5.32 0.891 1.415 1.415 0 0 0 -0.798 0.76A10.84 10.84 0 0 0 0 7.022a10.84 10.84 0 0 0 0.882 3.827c0.153 0.353 0.442 0.625 0.797 0.76A13.77 13.77 0 0 0 7 12.5a13.77 13.77 0 0 0 5.32 -0.891c0.356 -0.135 0.645 -0.407 0.798 -0.76a10.84 10.84 0 0 0 0.881 -3.871 10.84 10.84 0 0 0 -0.881 -3.827 1.415 1.415 0 0 0 -0.797 -0.76Z" }),
    " "
  ] }) }),
  "CompositionOval"
);
var CompositionVertical = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.827 0.051c-0.044 -0.002 -0.084 0 -0.108 0l-0.02 0 -0.031 0.002h-7.29l-0.016 0a1.399 1.399 0 0 0 -0.342 0.026 1.004 1.004 0 0 0 -0.657 1.427l0.006 0.013a13.975 13.975 0 0 1 -0.014 10.995l-0.004 0.009c-0.014 0.033 -0.047 0.108 -0.067 0.19 -0.134 0.55 0.23 1.155 0.846 1.229 0.071 0.008 0.149 0.007 0.178 0.007l0.01 0h7.293l0.016 0c0.05 0.001 0.183 0.004 0.302 -0.02a0.955 0.955 0 0 0 0.727 -1.207 1.91 1.91 0 0 0 -0.091 -0.23l-0.003 -0.007A13.974 13.974 0 0 1 11.618 1.5c0.001 -0.002 0.046 -0.098 0.066 -0.154a0.96 0.96 0 0 0 -0.857 -1.295Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "CompositionVertical"
);
var CompsitionHorizontal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.949 10.799c0.002 -0.044 0 -0.083 0 -0.108l0 -0.02 -0.002 -0.03V3.406l0 -0.017a1.382 1.382 0 0 0 -0.026 -0.34 1.004 1.004 0 0 0 -1.166 -0.74c-0.11 0.022 -0.218 0.07 -0.26 0.088l-0.014 0.006a14.065 14.065 0 0 1 -10.996 -0.014l-0.008 -0.003c-0.033 -0.014 -0.108 -0.047 -0.19 -0.067 -0.55 -0.133 -1.155 0.228 -1.229 0.84 -0.008 0.07 -0.007 0.147 -0.007 0.176l0 0.01 0 7.24 0 0.015c-0.001 0.05 -0.004 0.182 0.02 0.3 0.115 0.57 0.69 0.87 1.207 0.722 0.086 -0.025 0.202 -0.078 0.23 -0.09l0.007 -0.004a14.066 14.066 0 0 1 10.984 0.056c0.002 0 0.098 0.045 0.154 0.066 0.588 0.214 1.265 -0.176 1.296 -0.851Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "CompsitionHorizontal"
);
var CropSelection = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 1c0 -0.552285 -0.44772 -1 -1 -1s-1 0.447715 -1 1v1.5H1c-0.552285 0 -1 0.44772 -1 1s0.447715 1 1 1h1.5V9c0 1.3807 1.11929 2.5 2.5 2.5h4.5V13c0 0.5523 0.44771 1 1 1 0.5523 0 1 -0.4477 1 -1v-1.5H13c0.5523 0 1 -0.4477 1 -1 0 -0.55229 -0.4477 -1 -1 -1H5c-0.27614 0 -0.5 -0.22386 -0.5 -0.5V1ZM6 3.5c0 -0.55228 0.44772 -1 1 -1h2c1.3807 0 2.5 1.11929 2.5 2.5v2c0 0.55228 -0.4477 1 -1 1 -0.55228 0 -1 -0.44772 -1 -1V5c0 -0.27614 -0.22386 -0.5 -0.5 -0.5H7c-0.55228 0 -1 -0.44772 -1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CropSelection"
);
var DarkDislayMode = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.46 4.522a2.46 2.46 0 1 0 0 4.919c0.25 0 0.441 0.3 0.258 0.47a3.996 3.996 0 1 1 0 -5.86c0.183 0.17 -0.008 0.471 -0.258 0.471Z" }),
    " "
  ] }) }),
  "DarkDislayMode"
);
var FitToHeightSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 14A3.5 3.5 0 0 1 0 10.5v-7A3.5 3.5 0 0 1 3.5 0h7A3.5 3.5 0 0 1 14 3.5l0 7a3.5 3.5 0 0 1 -3.5 3.5l-7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.462 5.691A0.5 0.5 0 0 1 9 6H7.75l0 2H9a0.5 0.5 0 0 1 0.354 0.854l-2 2a0.5 0.5 0 0 1 -0.708 0l-2 -2A0.5 0.5 0 0 1 5 8h1.25l0 -2H5a0.5 0.5 0 0 1 -0.354 -0.854l2 -2a0.5 0.5 0 0 1 0.708 0l2 2a0.5 0.5 0 0 1 0.108 0.545Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FitToHeightSquare"
);
var Flash1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.27225 0c-0.20076 0 -0.38205 0.120076 -0.46038 0.304925l-2.25 5.310005 -0.00211 0.00506c-0.06224 0.1515 -0.08632 0.31597 -0.07011 0.47895 0.0162 0.16298 0.07219 0.31949 0.16304 0.45577 0.09085 0.13627 0.21379 0.24815 0.358 0.32579 0.14421 0.07765 0.30529 0.11868 0.46907 0.11949L2.48225 7h2.12714l-1.8179 6.3626c-0.06191 0.2167 0.02877 0.448 0.22143 0.5649 0.19265 0.1169 0.43969 0.0904 0.60325 -0.0646l8.59003 -8.13997 0.003 -0.00288c0.1427 -0.13751 0.2413 -0.31433 0.2834 -0.508 0.042 -0.19367 0.0255 -0.39546 -0.0473 -0.57976 -0.0729 -0.18429 -0.1989 -0.34279 -0.362 -0.45536s-0.356 -0.17413 -0.5541 -0.17688L11.5223 4H8.58127L10.2195 0.723607c0.0775 -0.154994 0.0692 -0.339064 -0.0219 -0.486473C10.1065 0.0897262 9.94554 0 9.77225 0h-5.5Z" }),
    " "
  ] }) }),
  "Flash1"
);
var Flash2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 0.5a0.5 0.5 0 0 0 -0.912 -0.283l-5.5 8A0.5 0.5 0 0 0 2.5 9h3v4.5a0.5 0.5 0 0 0 0.912 0.283l5.5 -8A0.5 0.5 0 0 0 11.5 5h-3V0.5Z" }),
    " "
  ] }) }),
  "Flash2"
);
var Flash3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.08031 5.2808 4.2864 0.873933c0.11895 -0.434637 0.5139 -0.736024 0.96452 -0.736024h1.94039c0.65937 0 1.13825 0.626978 0.96476 1.263121l-0.66712 2.44612h1.83301c0.68734 0 1.16974 0.6774 0.94504 1.32696L8.77032 9.50003h1.33688c0.469 0 0.6799 0.58757 0.318 0.88587l-3.81947 3.148c-0.21784 0.1796 -0.54104 0.1433 -0.71365 -0.0801L3.3907 10.2167c-0.25396 -0.32863 -0.0197 -0.80569 0.39564 -0.80569h1.51078l0.84301 -2.86623h-2.0953c-0.65974 0 -1.13868 -0.62764 -0.96452 -1.26398Z" }),
    " "
  ] }) }),
  "Flash3"
);
var FlashOff = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.5 0.500007c0 -0.219014 -0.14253 -0.4125369 -0.35169 -0.4774992 -0.20916 -0.0649623 -0.43625 0.0137578 -0.56033 0.1942342l-5.5 7.999998c-0.10519 0.15301 -0.11693 0.35171 -0.03049 0.51604 0.08644 0.16433 0.25683 0.26723 0.44251 0.26723h3V13.5c0 0.219 0.14254 0.4125 0.35169 0.4775 0.20916 0.065 0.43625 -0.0138 0.56033 -0.1942L11.912 5.78327c0.1052 -0.15301 0.117 -0.35171 0.0305 -0.51604 -0.0864 -0.16433 -0.2568 -0.26722 -0.4425 -0.26722h-3V0.500007Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.21967 0.21967c-0.2928931 0.292893 -0.2928931 0.767767 0 1.06066L12.7197 13.7803c0.2929 0.2929 0.7677 0.2929 1.0606 0 0.2929 -0.2929 0.2929 -0.7677 0 -1.0606L1.28033 0.21967c-0.292893 -0.2928933 -0.767767 -0.2928933 -1.06066 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FlashOff"
);
var FlipVerticalArrow2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.1464 13.1463 7.35348 9.35342c-0.19526 -0.19527 -0.51184 -0.19526 -0.70711 0L2.85348 13.1463c-0.31498 0.315 -0.0919 0.8536 0.35355 0.8536l7.58577 0c0.4455 0 0.6686 -0.5386 0.3536 -0.8536Zm0 -12.292869L7.35348 4.64632c-0.19526 0.19527 -0.51184 0.19527 -0.70711 0L2.85348 0.85343c-0.31498 -0.314982 -0.0919 -0.853552443 0.35355 -0.853552424l7.58577 3.32e-7c0.4455 1.9e-8 0.6686 0.538571092 0.3536 0.853553092Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.2499 7.74988c0.4142 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.3358 -0.75 -0.75 -0.75l-1 0c-0.4142 0 -0.75 0.33578 -0.75 0.75 0 0.41421 0.3358 0.75 0.75 0.75l1 0Zm-3.83327 0c0.41421 0 0.74997 -0.33579 0.74997 -0.75 0 -0.41422 -0.33576 -0.75 -0.74997 -0.75l-1 0c-0.41422 0 -0.75 0.33578 -0.75 0.75 0 0.41421 0.33578 0.75 0.75 0.75l1 0Zm-3.08326 -0.75c0 0.41421 -0.33578 0.75 -0.75 0.75l-1 0c-0.41421 0 -0.75 -0.33579 -0.75 -0.75 0 -0.41422 0.33579 -0.75 0.75 -0.75l1 0c0.41422 0 0.75 0.33578 0.75 0.75Zm-4.58325 0.75c0.41422 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.33578 -0.75 -0.75 -0.75l-0.999998 0c-0.414213 0 -0.749999944 0.33578 -0.749999962 0.75 -1.9e-8 0.41421 0.335786962 0.75 0.749999962 0.75l0.999998 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FlipVerticalArrow2"
);
var FlipVerticalCircle1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 6.25A0.75 0.75 0 0 0 0 7a7 7 0 1 0 14 0 0.75 0.75 0 0 0 -0.75 -0.75H0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.61 0.183a7.192 7.192 0 0 0 -3.22 0 0.75 0.75 0 0 0 0.336 1.461 5.692 5.692 0 0 1 2.548 0A0.75 0.75 0 1 0 8.61 0.183ZM3.588 1.715a0.75 0.75 0 0 1 -0.101 1.056c-0.328 0.27 -0.622 0.579 -0.877 0.919l-0.004 0.005a5.142 5.142 0 0 0 -0.638 1.091 0.75 0.75 0 0 1 -1.378 -0.592c0.215 -0.5 0.49 -0.973 0.821 -1.406a6.846 6.846 0 0 1 1.121 -1.174 0.75 0.75 0 0 1 1.056 0.1Zm6.92 -0.013a0.75 0.75 0 0 1 1.059 -0.078c0.402 0.347 0.762 0.74 1.074 1.169 0.328 0.432 0.603 0.902 0.817 1.401a0.75 0.75 0 0 1 -1.378 0.592 5.143 5.143 0 0 0 -0.638 -1.09l-0.012 -0.017a5.347 5.347 0 0 0 -0.843 -0.919 0.75 0.75 0 0 1 -0.078 -1.058Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FlipVerticalCircle1"
);
var FlipVerticalSquare2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.25 8.75c-0.4142 0 -0.75 -0.33579 -0.75 -0.75l0 -2.4999c0 -0.41421 0.3358 -0.75 0.75 -0.75s0.75 0.33579 0.75 0.75L14 8c0 0.41421 -0.3358 0.75 -0.75 0.75ZM13.2499 3c-0.4142 0 -0.75 -0.33579 -0.75 -0.75l0 -0.5c0 -0.13807 -0.112 -0.25 -0.25 -0.25l-0.5 0c-0.4142 0 -0.75 -0.33579 -0.75 -0.75 0 -0.414213 0.3358 -0.750000233 0.75 -0.7500001967l0.5 4.37e-8C13.2164 -6.85e-8 13.9999 0.783502 13.9999 1.75l0 0.5c0 0.41421 -0.3358 0.75 -0.75 0.75ZM0.750001 3C0.335787 3 5.32e-7 2.66421 5.682e-7 2.25l4.38e-8 -0.5C6.965e-7 0.7835 0.783502 -0.0000011554 1.75 -0.000001071l0.5 4.38e-8C2.66421 -9.91e-7 3 0.335786 3 0.749999 3 1.16421 2.66421 1.5 2.25 1.5l-0.5 0c-0.13807 0 -0.25 0.11193 -0.25 0.25l0 0.5c0 0.41421 -0.33579 0.75 -0.749999 0.75ZM8 1.5c0.41421 0 0.75 -0.33579 0.75 -0.75C8.75 0.335786 8.41421 -4.883e-7 8 -5.245e-7L6 -6.994e-7C5.58579 -7.356e-7 5.25 0.335786 5.25 0.749999 5.25 1.16421 5.58579 1.5 6 1.5l2 0ZM6.56e-8 8C2.94e-8 8.41421 0.335787 8.75 0.75 8.75c0.41421 0 0.75 -0.33579 0.75 -0.75l0 -2.50012c0 -0.41422 -0.33579 -0.75 -0.75 -0.75 -0.414213 0 -0.7499996797 0.33578 -0.7499997159 0.75L6.56e-8 8Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.25 14c0.9665 0 1.75 -0.7835 1.75 -1.75L14 7c0 -0.41421 -0.3358 -0.75 -0.75 -0.75l-12.499999 0C0.335787 6.25 6.482e-7 6.58579 6.12e-7 7l-4.59e-7 5.25C6.85e-8 13.2165 0.783502 14 1.75 14l10.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FlipVerticalSquare2"
);
var FocusPoints = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.747 0.997A1.705 1.705 0 0 0 0.042 2.702v0.955a0.75 0.75 0 1 0 1.5 0v-0.955a0.205 0.205 0 0 1 0.205 -0.205h0.955a0.75 0.75 0 1 0 0 -1.5h-0.955Zm9.55 0a0.75 0.75 0 0 0 0 1.5h0.956a0.205 0.205 0 0 1 0.205 0.205v0.955a0.75 0.75 0 1 0 1.5 0v-0.955A1.705 1.705 0 0 0 12.253 0.997h-0.955Zm1.91 8.596a0.75 0.75 0 0 1 0.75 0.75v0.955a1.705 1.705 0 0 1 -1.704 1.705h-0.955a0.75 0.75 0 0 1 0 -1.5h0.955a0.205 0.205 0 0 0 0.205 -0.205v-0.955a0.75 0.75 0 0 1 0.75 -0.75Zm-11.665 0.75a0.75 0.75 0 0 0 -1.5 0v0.955a1.705 1.705 0 0 0 1.705 1.705h0.955a0.75 0.75 0 0 0 0 -1.5h-0.955a0.205 0.205 0 0 1 -0.205 -0.205v-0.955Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2a1 1 0 1 0 0 2 1 1 0 0 0 0 -2ZM2 7a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Zm4 0a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Zm5 -1a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Zm-5 5a1 1 0 1 1 2 0 1 1 0 0 1 -2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FocusPoints"
);
var InsertSide = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 0.5a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1H1Zm0 7a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1H1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.5 1a0.75 0.75 0 0 1 0.75 -0.75h5a0.75 0.75 0 0 1 0 1.5h-5A0.75 0.75 0 0 1 7.5 1Zm0 3a0.75 0.75 0 0 1 0.75 -0.75h5a0.75 0.75 0 0 1 0 1.5h-5A0.75 0.75 0 0 1 7.5 4Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h5a0.75 0.75 0 0 0 0 -1.5h-5ZM7.5 10a0.75 0.75 0 0 1 0.75 -0.75h5a0.75 0.75 0 0 1 0 1.5h-5A0.75 0.75 0 0 1 7.5 10Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h5a0.75 0.75 0 0 0 0 -1.5h-5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InsertSide"
);
var InsertTopLeft = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 1.5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1H1a1 1 0 0 1 -1 -1v-5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.5 1a0.75 0.75 0 0 1 0.75 -0.75h4a0.75 0.75 0 0 1 0 1.5h-4A0.75 0.75 0 0 1 8.5 1Zm0 3a0.75 0.75 0 0 1 0.75 -0.75h4a0.75 0.75 0 0 1 0 1.5h-4A0.75 0.75 0 0 1 8.5 4Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h4a0.75 0.75 0 0 0 0 -1.5h-4ZM0 10a0.75 0.75 0 0 1 0.75 -0.75h12.5a0.75 0.75 0 0 1 0 1.5H0.75A0.75 0.75 0 0 1 0 10Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h12.5a0.75 0.75 0 0 0 0 -1.5H0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InsertTopLeft"
);
var InsertTopRight = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 1.5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1H8a1 1 0 0 1 -1 -1v-5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0 1A0.75 0.75 0 0 1 0.75 0.25h4a0.75 0.75 0 0 1 0 1.5h-4A0.75 0.75 0 0 1 0 1Zm0 3a0.75 0.75 0 0 1 0.75 -0.75h4a0.75 0.75 0 0 1 0 1.5h-4A0.75 0.75 0 0 1 0 4Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h4a0.75 0.75 0 0 0 0 -1.5h-4ZM0 10a0.75 0.75 0 0 1 0.75 -0.75h12.5a0.75 0.75 0 0 1 0 1.5H0.75A0.75 0.75 0 0 1 0 10Zm0.75 2.25a0.75 0.75 0 0 0 0 1.5h12.5a0.75 0.75 0 0 0 0 -1.5H0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InsertTopRight"
);
var LassoTool = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.475 1.87C2.58 0.786 4.347 0 7 0c2.653 0 4.42 0.785 5.525 1.87C13.616 2.943 14 4.244 14 5.167s-0.383 2.224 -1.475 3.295c-1.106 1.085 -2.872 1.87 -5.525 1.87l-0.063 0c0.626 0.801 1.081 1.654 1.078 2.916a0.75 0.75 0 1 1 -1.5 -0.004c0.001 -0.564 -0.118 -0.988 -0.369 -1.42a2.354 2.354 0 0 1 -0.433 0.768c-0.442 0.52 -1.135 0.868 -2.09 0.868 -0.955 0 -1.648 -0.348 -2.09 -0.868A2.362 2.362 0 0 1 0.976 11.1c0 -0.416 0.14 -1 0.557 -1.491 0.183 -0.215 0.408 -0.4 0.676 -0.543a5.51 5.51 0 0 1 -0.734 -0.605C0.383 7.391 0 6.09 0 5.166S0.383 2.942 1.475 1.87Zm1.05 1.071C1.742 3.711 1.5 4.617 1.5 5.166c0 0.549 0.242 1.455 1.025 2.225 0.77 0.754 2.128 1.44 4.475 1.44 2.347 0 3.706 -0.686 4.475 -1.44 0.784 -0.77 1.025 -1.676 1.025 -2.225 0 -0.55 -0.242 -1.456 -1.025 -2.225C10.705 2.187 9.347 1.5 7 1.5c-2.347 0 -3.706 0.687 -4.475 1.441Zm0.152 7.639a0.866 0.866 0 0 0 -0.201 0.52c0 0.12 0.05 0.341 0.2 0.52 0.128 0.15 0.385 0.339 0.947 0.339 0.563 0 0.819 -0.189 0.946 -0.34a0.866 0.866 0 0 0 0.201 -0.52c0 -0.12 -0.05 -0.34 -0.2 -0.519 -0.128 -0.15 -0.384 -0.339 -0.947 -0.339 -0.562 0 -0.819 0.189 -0.946 0.339Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LassoTool"
);
var Layers1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 6.505c-0.23 0 -0.458 0.047 -0.67 0.139L0.62 9.309l-0.014 0.007a1.06 1.06 0 0 0 0 1.893l0.015 0.007 5.7 2.64 0.01 0.005a1.68 1.68 0 0 0 1.34 0l5.711 -2.666 0.014 -0.006a1.06 1.06 0 0 0 0 -1.893l-0.015 -0.007 -5.7 -2.64 -0.01 -0.005a1.68 1.68 0 0 0 -0.67 -0.14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 3.252c-0.23 0 -0.458 0.048 -0.67 0.14L0.62 6.056l-0.014 0.007a1.06 1.06 0 0 0 0 1.892l0.015 0.008 5.7 2.64 0.01 0.005a1.68 1.68 0 0 0 1.34 0l5.711 -2.666 0.014 -0.007a1.06 1.06 0 0 0 0 -1.892l-0.015 -0.008 -5.7 -2.64 -0.01 -0.005A1.68 1.68 0 0 0 7 3.252Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 0c-0.23 0 -0.458 0.047 -0.67 0.139L0.62 2.805l-0.014 0.006a1.06 1.06 0 0 0 0 1.893l0.015 0.007 5.7 2.64 0.01 0.005a1.68 1.68 0 0 0 1.34 0l5.711 -2.665 0.014 -0.007a1.06 1.06 0 0 0 0 -1.893l-0.015 -0.007 -5.7 -2.64 -0.01 -0.005A1.68 1.68 0 0 0 7 0Z" }),
    " "
  ] }) }),
  "Layers1"
);
var Layers2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7.5A1.5 1.5 0 0 1 1.5 6h6A1.5 1.5 0 0 1 9 7.5v4A1.5 1.5 0 0 1 7.5 13h-6A1.5 1.5 0 0 1 0 11.5v-4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M2.5 5A1.5 1.5 0 0 1 4 3.5h6A1.5 1.5 0 0 1 11.5 5v4a1.5 1.5 0 0 1 -1.5 1.5H4A1.5 1.5 0 0 1 2.5 9V5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 2.5A1.5 1.5 0 0 1 6.5 1h6A1.5 1.5 0 0 1 14 2.5v4A1.5 1.5 0 0 1 12.5 8h-6A1.5 1.5 0 0 1 5 6.5v-4Z" }),
    " "
  ] }) }),
  "Layers2"
);
var LayoutWindow1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.194 6.25H14v1.5H6.194V14H1.5A1.5 1.5 0 0 1 0 12.5v-11A1.5 1.5 0 0 1 1.5 0h4.694v6.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LayoutWindow1"
);
var LayoutWindow11 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.806 0H12.5A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5H7.806V7.75H0v-1.5h7.806V0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LayoutWindow11"
);
var LayoutWindow2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0h11A1.5 1.5 0 0 1 14 1.5V4H5.157v3.806H14v1.5H5.157V14h-1.5V4H0V1.5A1.5 1.5 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LayoutWindow2"
);
var LayoutWindow8 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0h11A1.5 1.5 0 0 1 14 1.5V4H7.75v3.806l6.25 0v1.5l-6.25 0V14h-1.5V9.306H0v-1.5l6.25 0V4H0V1.5A1.5 1.5 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "LayoutWindow8"
);
var MagicWand2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.707 5.293a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1 -1.414 -1.414l7 -7a1 1 0 0 1 1.414 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m13.19 1.344 -0.84 2.48a0.41 0.41 0 0 0 0 0.37l1.57 2.1a0.4 0.4 0 0 1 -0.33 0.64h-2.62a0.43 0.43 0 0 0 -0.33 0.17l-1.46 2.1a0.4 0.4 0 0 1 -0.71 -0.11l-0.78 -2.5a0.38 0.38 0 0 0 -0.26 -0.26l-2.5 -0.78a0.4 0.4 0 0 1 -0.11 -0.71l2.14 -1.51a0.43 0.43 0 0 0 0.17 -0.33V0.384a0.4 0.4 0 0 1 0.6 -0.33l2.1 1.57a0.41 0.41 0 0 0 0.37 0.05l2.48 -0.84a0.4 0.4 0 0 1 0.51 0.51Z" }),
    " "
  ] }) }),
  "MagicWand2"
);
var OrientationLandscape = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.5 12.5A1.5 1.5 0 0 0 14 11V3a1.5 1.5 0 0 0 -1.5 -1.5h-11A1.5 1.5 0 0 0 0 3v8a1.5 1.5 0 0 0 1.5 1.5h11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.502 6.434a1.467 1.467 0 1 0 0 -2.934 1.467 1.467 0 0 0 0 2.934Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m1.5 12.5 7.083 0a7.097 7.097 0 0 0 -7.136 -5.786A7.599 7.599 0 0 0 0 6.849V11a1.5 1.5 0 0 0 1.5 1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.61 9.266a8.336 8.336 0 0 1 1.201 3.003c0.015 0.077 0.022 0.154 0.022 0.231H12.5a1.5 1.5 0 0 0 1.5 -1.494V9.289a8.474 8.474 0 0 0 -2.716 -0.445 8.57 8.57 0 0 0 -2.675 0.422Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OrientationLandscape"
);
var OrientationPortrait = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.5 1.5A1.5 1.5 0 0 0 11 0H3a1.5 1.5 0 0 0 -1.5 1.5v11A1.5 1.5 0 0 0 3 14h8a1.5 1.5 0 0 0 1.5 -1.5l0 -11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.819 6.031a1.5 1.5 0 1 0 0 -3 1.5 1.5 0 0 0 0 3Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.547 14c0 -1.866 -0.633 -3.96 -2.307 -5.167 -1.034 -0.745 -2.332 -1.14 -3.662 -1.113 -0.362 0 -0.722 0.027 -1.078 0.084V12.5A1.5 1.5 0 0 0 3 14h5.547Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m9.9 14 1.157 0c0.797 0 1.443 -0.646 1.443 -1.443l0 -2.978a7.822 7.822 0 0 0 -2.251 -0.329 7.946 7.946 0 0 0 -1.702 0.181C9.538 10.821 9.9 12.531 9.9 14Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OrientationPortrait"
);
var PaintBucket = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11 12.5153c0 -0.6217 0.4872 -1.5208 0.9515 -2.2175 0.2646 -0.39708 0.8324 -0.39708 1.097 0 0.4643 0.6967 0.9515 1.5958 0.9515 2.2175C14 13.6288 13.25 14 12.5 14s-1.5 -0.3712 -1.5 -1.4847Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M11.7952 6.63231c0.2491 -0.18664 0.2751 -0.55076 0.0551 -0.77092L6.14057 0.149793c-0.21998 -0.2200544 -0.58379 -0.1941901 -0.77045 0.054773L0.202658 7.09683c-0.1460671 0.19604 -0.2170963 0.43793 -0.2002153 0.68185 0.016881 0.24392 0.1205553 0.47372 0.2922343 0.64775L3.57668 11.7095c0.17335 0.1691 0.40106 0.2712 0.64259 0.288 0.24153 0.0169 0.4812 -0.0526 0.67634 -0.1959l6.89959 -5.16929Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "PaintBucket"
);
var PaintPalette = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.093 0.066A7 7 0 0 0 4.35 0.577a7.055 7.055 0 0 0 -4.2 5.94 7.055 7.055 0 0 0 3.343 6.462A7 7 0 0 0 7.129 14a6.8 6.8 0 0 0 1.877 -0.259 1.43 1.43 0 0 0 1.01 -1.524 1.477 1.477 0 0 0 -0.99 -1.292A1.5 1.5 0 0 1 9.5 8h1.87c0.803 0.002 1.582 -0.4 2.046 -1.056a2.526 2.526 0 0 0 0.315 -2.282A7 7 0 0 0 8.093 0.066Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.5 4a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0 -3 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M3.5 9.5a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" }),
    " "
  ] }) }),
  "PaintPalette"
);
var Paintbrush1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12 5a1 1 0 0 1 1 1v2a0.5 0.5 0 0 1 -0.5 0.5h-11A0.5 0.5 0 0 1 1 8V6a1 1 0 0 1 1 -1h2a1 1 0 0 0 1 -1V2a2 2 0 1 1 4 0v2a1 1 0 0 0 1 1h2Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m1.75 8.5 -0.74 4.363a0.942 0.942 0 0 0 -0.01 0.14c0 0.551 0.418 0.997 0.934 0.997H7.75v-2.134c0 -0.442 0.336 -0.8 0.75 -0.8s0.75 0.358 0.75 0.8V14h2.816c0.516 0 0.934 -0.446 0.934 -0.996a0.946 0.946 0 0 0 -0.01 -0.141L12.25 8.5H1.75Z" }),
    " "
  ] }) }),
  "Paintbrush1"
);
var Paintbrush2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.41 0.594A2.025 2.025 0 0 0 11.112 0.19a2.05 2.05 0 0 0 -0.66 0.495L4.77 7.044a2.886 2.886 0 0 1 1.53 0.848c0.37 0.371 0.638 0.832 0.78 1.338l6.24 -5.654a2.041 2.041 0 0 0 0.678 -1.46 2.059 2.059 0 0 0 -0.587 -1.522Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.119 12.377c-1.591 1.6 -4.209 2.214 -5.931 0.934 -0.245 -0.181 -0.239 -0.532 -0.05 -0.77 1.634 -2.06 -0.259 -3.15 1.329 -4.738a3.267 3.267 0 1 1 4.607 4.619l0.045 -0.045Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Paintbrush2"
);
var PathfinderDivide = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0h7A1.5 1.5 0 0 1 10 1.5v1.245H5.377A2.625 2.625 0 0 0 2.752 5.37V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0Zm11 4h-1.236l0 4.632a2.625 2.625 0 0 1 -2.626 2.625H4V12.5A1.5 1.5 0 0 0 5.5 14h7a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 12.5 4Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10 3.995V4h0.014l0 4.632c0 0.76 -0.616 1.375 -1.376 1.375H4.002V5.37c0 -0.76 0.616 -1.375 1.375 -1.375H10Z" }),
    " "
  ] }) }),
  "PathfinderDivide"
);
var PathfinderExclude = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0h7A1.5 1.5 0 0 1 10 1.5V4h2.5A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1 -1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10 4H5.5A1.5 1.5 0 0 0 4 5.5V10h4.5A1.5 1.5 0 0 0 10 8.5V4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PathfinderExclude"
);
var PathfinderIntersect = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 2.5c0.198107 -0.00259 0.38737 -0.08244 0.52747 -0.22253 0.14009 -0.1401 0.21994 -0.32936 0.22253 -0.52747 0 -0.0663 0.02634 -0.12989 0.07322 -0.17678C1.62011 1.52634 1.6837 1.5 1.75 1.5c0.19891 0 0.38968 -0.07902 0.53033 -0.21967C2.42098 1.13968 2.5 0.948912 2.5 0.75c0 -0.198912 -0.07902 -0.389677 -0.21967 -0.53033C2.13968 0.079018 1.94891 0 1.75 0 1.28668 0.0026251 0.843085 0.187842 0.515464 0.515464 0.187842 0.843085 0.0026251 1.28668 0 1.75c0.00258996 0.19811 0.0824394 0.38737 0.222534 0.52747C0.362629 2.41756 0.551893 2.49741 0.75 2.5Zm11.6768 2.57322C12.3799 5.02634 12.3163 5 12.25 5c-0.1989 0 -0.3897 -0.07902 -0.5303 -0.21967C11.579 4.63968 11.5 4.44891 11.5 4.25c0 -0.19891 0.079 -0.38968 0.2197 -0.53033 0.1406 -0.14065 0.3314 -0.21967 0.5303 -0.21967 0.4633 0.00262 0.9069 0.18784 1.2345 0.51546 0.3277 0.32763 0.5129 0.77122 0.5155 1.23454 0 0.19891 -0.079 0.38968 -0.2197 0.53033C13.6397 5.92098 13.4489 6 13.25 6c-0.1989 0 -0.3897 -0.07902 -0.5303 -0.21967C12.579 5.63968 12.5 5.44891 12.5 5.25c0 -0.0663 -0.0263 -0.12989 -0.0732 -0.17678Zm0.2957 6.64928c0.1401 -0.1401 0.3294 -0.2199 0.5275 -0.2225 0.1981 0.0026 0.3874 0.0824 0.5275 0.2225 0.1401 0.1401 0.2199 0.3294 0.2225 0.5275 -0.0026 0.4633 -0.1878 0.9069 -0.5155 1.2345 -0.3276 0.3277 -0.7712 0.5129 -1.2345 0.5155 -0.1989 0 -0.3897 -0.079 -0.5303 -0.2197 -0.1407 -0.1406 -0.2197 -0.3314 -0.2197 -0.5303 0 -0.1989 0.079 -0.3897 0.2197 -0.5303 0.1406 -0.1407 0.3314 -0.2197 0.5303 -0.2197 0.0663 0 0.1299 -0.0263 0.1768 -0.0732 0.0469 -0.0469 0.0732 -0.1105 0.0732 -0.1768 0.0026 -0.1981 0.0824 -0.3874 0.2225 -0.5275ZM5.25 12.5c-0.0663 0 -0.12989 -0.0263 -0.17678 -0.0732C5.02634 12.3799 5 12.3163 5 12.25c0 -0.1989 -0.07902 -0.3897 -0.21967 -0.5303C4.63968 11.579 4.44891 11.5 4.25 11.5c-0.19891 0 -0.38968 0.079 -0.53033 0.2197 -0.14065 0.1406 -0.21967 0.3314 -0.21967 0.5303 0.00262 0.4633 0.18784 0.9069 0.51546 1.2345 0.32763 0.3277 0.77122 0.5129 1.23454 0.5155 0.19891 0 0.38968 -0.079 0.53033 -0.2197C5.92098 13.6397 6 13.4489 6 13.25c0 -0.1989 -0.07902 -0.3897 -0.21967 -0.5303C5.63968 12.579 5.44891 12.5 5.25 12.5Zm2.21967 0.2197C7.61032 12.579 7.80109 12.5 8 12.5h1.5c0.19891 0 0.38968 0.079 0.5303 0.2197 0.1407 0.1406 0.2197 0.3314 0.2197 0.5303 0 0.1989 -0.079 0.3897 -0.2197 0.5303C9.88968 13.921 9.69891 14 9.5 14H8c-0.19891 0 -0.38968 -0.079 -0.53033 -0.2197 -0.14065 -0.1406 -0.21967 -0.3314 -0.21967 -0.5303 0 -0.1989 0.07902 -0.3897 0.21967 -0.5303ZM13.25 7.25c-0.1981 0.00259 -0.3874 0.08244 -0.5275 0.22253 -0.1401 0.1401 -0.2199 0.32936 -0.2225 0.52747v1.5c0 0.19891 0.079 0.38968 0.2197 0.5303 0.1406 0.1407 0.3314 0.2197 0.5303 0.2197 0.1989 0 0.3897 -0.079 0.5303 -0.2197C13.921 9.88968 14 9.69891 14 9.5V8c-0.0026 -0.19811 -0.0824 -0.38737 -0.2225 -0.52747 -0.1401 -0.14009 -0.3294 -0.21994 -0.5275 -0.22253ZM1.57322 8.92678C1.62011 8.97366 1.6837 9 1.75 9c0.19891 0 0.38968 0.07902 0.53033 0.21967 0.14065 0.14065 0.21967 0.33142 0.21967 0.53033 0 0.19891 -0.07902 0.3897 -0.21967 0.5303 -0.14065 0.1407 -0.33142 0.2197 -0.53033 0.2197 -0.46332 -0.0026 -0.906915 -0.1878 -1.234536 -0.51546C0.187842 9.65691 0.0026251 9.21332 0 8.75c0 -0.19891 0.079018 -0.38968 0.21967 -0.53033C0.360323 8.07902 0.551088 8 0.75 8c0.198912 0 0.38968 0.07902 0.53033 0.21967 0.14065 0.14065 0.21967 0.33142 0.21967 0.53033 0 0.0663 0.02634 0.12989 0.07322 0.17678Zm7.35356 -7.35356C8.87989 1.52634 8.8163 1.5 8.75 1.5c-0.19891 0 -0.38968 -0.07902 -0.53033 -0.21967C8.07902 1.13968 8 0.948912 8 0.75c0 -0.198912 0.07902 -0.389677 0.21967 -0.53033C8.36032 0.079018 8.55109 0 8.75 0c0.46332 0.0026251 0.90691 0.187842 1.23454 0.515464 0.32766 0.327621 0.51286 0.771216 0.51546 1.234536 0 0.19891 -0.079 0.38968 -0.2197 0.53033 -0.1406 0.14065 -0.33139 0.21967 -0.5303 0.21967 -0.19891 0 -0.38968 -0.07902 -0.53033 -0.21967C9.07902 2.13968 9 1.94891 9 1.75c0 -0.0663 -0.02634 -0.12989 -0.07322 -0.17678ZM4.5 1.5H6c0.19891 0 0.38968 -0.07902 0.53033 -0.21967C6.67098 1.13968 6.75 0.948912 6.75 0.75c0 -0.198912 -0.07902 -0.389677 -0.21967 -0.53033C6.38968 0.079018 6.19891 0 6 0H4.5c-0.19891 0 -0.38968 0.079018 -0.53033 0.21967C3.82902 0.360323 3.75 0.551088 3.75 0.75c0 0.198912 0.07902 0.38968 0.21967 0.53033 0.14065 0.14065 0.33142 0.21967 0.53033 0.21967ZM1.27747 6.52747C1.13737 6.66756 0.948107 6.74741 0.75 6.75c-0.198107 -0.00259 -0.387371 -0.08244 -0.527466 -0.22253C0.0824394 6.38737 0.00258996 6.19811 0 6V4.5c0 -0.19891 0.079018 -0.38968 0.21967 -0.53033C0.360323 3.82902 0.551088 3.75 0.75 3.75c0.198912 0 0.38968 0.07902 0.53033 0.21967 0.14065 0.14065 0.21967 0.33142 0.21967 0.53033V6c-0.00259 0.19811 -0.08244 0.38737 -0.22253 0.52747Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.25 5.25c0 -0.55228 0.44772 -1 1 -1h4c0.27614 0 0.5 0.22386 0.5 0.5v4c0 0.55228 -0.44772 1 -1 1h-4c-0.27614 0 -0.5 -0.22386 -0.5 -0.5v-4Z" }),
    " "
  ] }) }),
  "PathfinderIntersect"
);
var PathfinderMerge = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.5 0h7A1.5 1.5 0 0 1 10 1.5V4h2.5A1.5 1.5 0 0 1 14 5.5v7a1.5 1.5 0 0 1 -1.5 1.5h-7A1.5 1.5 0 0 1 4 12.5V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.004 10V6.5a0.625 0.625 0 0 0 -1.25 0V10h1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PathfinderMerge"
);
var PathfinderMinusFront1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.5 0h-7A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h2a1 1 0 0 0 1 -1V5a0.5 0.5 0 0 1 0.5 -0.5h4a1 1 0 0 0 1 -1v-2A1.5 1.5 0 0 0 8.5 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.073 5.073A0.25 0.25 0 0 0 5 5.25a0.75 0.75 0 0 1 -1.5 0A1.76 1.76 0 0 1 5.25 3.5a0.75 0.75 0 0 1 0 1.5 0.25 0.25 0 0 0 -0.177 0.073Zm7.354 0A0.25 0.25 0 0 0 12.25 5a0.75 0.75 0 1 1 0 -1.5A1.76 1.76 0 0 1 14 5.25a0.75 0.75 0 1 1 -1.5 0 0.25 0.25 0 0 0 -0.073 -0.177Zm0.823 6.427a0.76 0.76 0 0 0 -0.75 0.75 0.25 0.25 0 0 1 -0.25 0.25 0.75 0.75 0 1 0 0 1.5A1.76 1.76 0 0 0 14 12.25a0.76 0.76 0 0 0 -0.75 -0.75Zm-8.177 0.927a0.25 0.25 0 0 0 0.177 0.073 0.75 0.75 0 1 1 0 1.5 1.76 1.76 0 0 1 -1.75 -1.75 0.75 0.75 0 1 1 1.5 0c0 0.066 0.026 0.13 0.073 0.177ZM9.5 12.5H8A0.75 0.75 0 1 0 8 14h1.5a0.75 0.75 0 1 0 0 -1.5ZM8 3.5h1.5a0.75 0.75 0 1 1 0 1.5H8a0.75 0.75 0 0 1 0 -1.5Zm5.25 3.75a0.76 0.76 0 0 0 -0.75 0.75v1.5a0.75 0.75 0 1 0 1.5 0V8a0.76 0.76 0 0 0 -0.75 -0.75Zm-9.527 0.223a0.76 0.76 0 0 1 0.527 -0.223A0.76 0.76 0 0 1 5 8v1.5a0.75 0.75 0 1 1 -1.5 0V8a0.76 0.76 0 0 1 0.223 -0.527Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PathfinderMinusFront1"
);
var PathfinderTrim = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.5 4h-7A1.5 1.5 0 0 0 4 5.5v7A1.5 1.5 0 0 0 5.5 14h7a1.5 1.5 0 0 0 1.5 -1.5v-7A1.5 1.5 0 0 0 12.5 4Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0h7A1.5 1.5 0 0 1 10 1.5v1.25H5.5A2.75 2.75 0 0 0 2.75 5.5V10H1.5A1.5 1.5 0 0 1 0 8.5v-7A1.5 1.5 0 0 1 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PathfinderTrim"
);
var PathfinderUnion = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 0h7c0.82843 0 1.5 0.671573 1.5 1.5V4h2.5c0.8284 0 1.5 0.67157 1.5 1.5v7c0 0.8284 -0.6716 1.5 -1.5 1.5h-7c-0.82843 0 -1.5 -0.6716 -1.5 -1.5V10H1.5C0.671573 10 0 9.32843 0 8.5v-7C0 0.671573 0.671573 0 1.5 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PathfinderUnion"
);
var Pen3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5.5 4.438h-5V11.1a0.5 0.5 0 0 0 0.116 0.32l2 2.4a0.5 0.5 0 0 0 0.768 0l2 -2.4a0.5 0.5 0 0 0 0.116 -0.32V4.438Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.5 2.5a2.5 2.5 0 1 0 -5 0v1.938h5V2.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.5 4.438h4V11a1 1 0 0 1 -1 1h-0.25v1.25a0.75 0.75 0 0 1 -1.5 0V12H8.5a1 1 0 0 1 -1 -1V4.437Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.5 2a2 2 0 1 1 4 0v0.938h0.75A1.747 1.747 0 0 1 14 4.682v3.98a0.75 0.75 0 0 1 -1.5 0v-3.98a0.242 0.242 0 0 0 -0.072 -0.171 0.253 0.253 0 0 0 -0.178 -0.074H7.5V2Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Pen3"
);
var PenDraw = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.61078 2.6597c-0.22737 -0.1972 -0.81784 -0.36518 -1.60254 0.12904 -2.50795 1.57955 -4.693 4.43023 -5.43253 5.46367 -0.24105 0.33685 -0.709531 0.41451 -1.04638 0.17346 -0.33685 -0.24105 -0.41451 -0.70953 -0.17346 -1.04638 0.74992 -1.04796 3.07804 -4.11229 5.85298 -5.86C7.41009 0.762931 8.75033 0.795145 9.5936 1.52654c0.4218 0.3658 0.6849 0.88993 0.6887 1.48627 0.0038 0.59124 -0.2463 1.17704 -0.70218 1.69827C8.15314 6.34257 6.26776 8.55593 5.476 9.63643c-0.10368 0.14149 -0.11141 0.24898 -0.10229 0.312 0.01008 0.06967 0.04768 0.13507 0.11116 0.18257 0.0605 0.0452 0.15744 0.083 0.29764 0.0667 0.14122 -0.0164 0.36086 -0.0935 0.62826 -0.33866 0.22661 -0.20778 0.46172 -0.42924 0.70325 -0.65674 0.74461 -0.70134 1.55023 -1.46016 2.35586 -2.05296 0.83812 -0.61668 1.81772 -0.78777 2.56132 -0.33319 0.3709 0.22671 0.6316 0.58938 0.7223 1.02421 0.0897 0.42991 0.0041 0.87798 -0.2124 1.28921 -0.2326 0.44194 -0.4339 0.76135 -0.6151 1.04683l-0.0143 0.0226c-0.1744 0.2748 -0.3241 0.5109 -0.4851 0.819 -0.0728 0.1394 -0.071 0.2943 -0.0236 0.415 0.0235 0.0599 0.0466 0.0887 0.0595 0.1012 0.0922 0.0065 0.1725 -0.0161 0.2994 -0.1146 0.178 -0.1382 0.3772 -0.3736 0.6765 -0.7652 0.2515 -0.329 0.7222 -0.3919 1.0513 -0.1403 0.3291 0.2515 0.3919 0.7222 0.1404 1.0513 -0.2846 0.3723 -0.5936 0.7637 -0.9485 1.0391 -0.3919 0.3043 -0.8663 0.489 -1.4435 0.414 -0.6333 -0.0823 -1.0481 -0.5707 -1.2313 -1.0372 -0.1921 -0.4891 -0.20092 -1.1004 0.0903 -1.6578 0.1906 -0.36498 0.37 -0.64756 0.5409 -0.91679 0.0071 -0.01131 0.0143 -0.02259 0.0215 -0.03386 0.1767 -0.27854 0.3511 -0.55596 0.5542 -0.94188 0.0851 -0.16163 0.0775 -0.2554 0.0715 -0.28425 -0.005 -0.02392 -0.0137 -0.03693 -0.0364 -0.05077 -0.0433 -0.0265 -0.3467 -0.13814 -0.8899 0.26157 -0.72558 0.53388 -1.43291 1.19985 -2.16005 1.88448 -0.25513 0.2402 -0.51271 0.4827 -0.77436 0.7226 -0.92323 0.8465 -2.04722 0.9591 -2.83811 0.3675 -0.77065 -0.5765 -0.98178 -1.67957 -0.32031 -2.58227 0.83695 -1.14219 2.76709 -3.40518 4.185 -5.02628l0.51324 0.44891 -0.51324 -0.44891c0.27129 -0.31018 0.33221 -0.55432 0.33128 -0.70125 -0.0009 -0.14184 -0.05802 -0.26411 -0.17157 -0.3626Zm2.86232 8.8828c0 0.0001 -0.001 -0.0004 -0.0027 -0.0016 0.0019 0.0009 0.0028 0.0015 0.0027 0.0016Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PenDraw"
);
var PenTool = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.381 5.25366 0.107224 13.3209c-0.0529464 0.3353 0.236533 0.6248 0.571862 0.5719L8.74634 12.619c0.44506 -0.0703 0.78816 -0.4295 0.83792 -0.8773L10 8 6 4l-3.74167 0.41574c-0.44782 0.04976 -0.80706 0.39286 -0.87733 0.83792Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m1.04961 13.8342 2.95041 -2.9504 0.30804 0.3081c0.24408 0.2441 0.63981 0.2441 0.88388 0 0.24408 -0.2441 0.24408 -0.6398 0 -0.8839l-1.5 -1.5c-0.24407 -0.24408 -0.6398 -0.24408 -0.88388 0 -0.24408 0.24407 -0.24408 0.6398 0 0.88388l0.30808 0.30808L0.165729 12.9504l-0.058504 0.3705c-0.0529465 0.3353 0.236533 0.6248 0.571862 0.5719l0.370523 -0.0586Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.30819 0.922483 5.99999 4.00008l4 4 3.07761 -2.3082c0.4868 -0.36513 0.5374 -1.0768 0.1071 -1.5071L9.81529 0.815376C9.38498 0.385067 8.67332 0.435644 8.30819 0.922483Z" }),
    " "
  ] }) }),
  "PenTool"
);
var Pencil = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.715 -0.001a1.5 1.5 0 0 0 -1.07 0.449L1.407 8.645a0.5 0.5 0 0 0 -0.128 0.22l-1.26 4.5a0.5 0.5 0 0 0 0.616 0.616l4.5 -1.26a0.5 0.5 0 0 0 0.22 -0.128l8.197 -8.238 0.002 -0.001a1.5 1.5 0 0 0 0 -2.128l-0.002 -0.001L11.786 0.449a1.499 1.499 0 0 0 -1.071 -0.45Z" }),
    " "
  ] }) }),
  "Pencil"
);
var RotateAngle45 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { stroke: "var(--semo-icon-solid)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "M7.7502 13.2496c0 -1.8566 -0.73749 -3.63704 -2.05025 -4.9498" }),
    " ",
    /* @__PURE__ */ jsx("path", { stroke: "var(--semo-icon-soft)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "m10.25 3.75 -9.5 9.5h12.5" }),
    " "
  ] }) }),
  "RotateAngle45"
);
var RoundCap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7c0 2.76142 2.23858 5 5 5h9V2H5C2.23858 2 0 4.23858 0 7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 6.25H6.85462C6.55793 5.51704 5.83934 5 5 5c-1.10457 0 -2 0.89543 -2 2s0.89543 2 2 2c0.83934 0 1.55793 -0.51704 1.85462 -1.25H14v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RoundCap"
);
var SelectCircleArea1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.73844 0.113512C6.14819 0.0388823 6.56988 0 7 0c0.43012 0 0.85181 0.0388823 1.26156 0.113512 0.40751 0.074221 0.67769 0.464741 0.60347 0.872251 -0.07422 0.407507 -0.46474 0.677697 -0.87225 0.603467C7.6713 1.53068 7.33956 1.5 7 1.5s-0.6713 0.03068 -0.99278 0.08923c-0.40751 0.07423 -0.79803 -0.19596 -0.87225 -0.603467 -0.07422 -0.40751 0.19596 -0.79803 0.60347 -0.872251ZM4.0662 1.42925c0.2356 0.34069 0.15041 0.80786 -0.19028 1.04345 -0.5481 0.37904 -1.02418 0.85512 -1.40322 1.40322 -0.23559 0.34069 -0.70276 0.42588 -1.04345 0.19028 -0.34068 -0.2356 -0.42587 -0.70277 -0.19028 -1.04346 0.48191 -0.69685 1.08692 -1.30186 1.78378 -1.78377 0.34068 -0.23559 0.80785 -0.1504 1.04345 0.19028Zm5.8676 0c0.2356 -0.34068 0.7028 -0.42587 1.0435 -0.19028 0.6968 0.48191 1.3018 1.08692 1.7837 1.78378 0.2356 0.34068 0.1504 0.80785 -0.1903 1.04345 -0.3406 0.2356 -0.8078 0.15041 -1.0434 -0.19028 -0.379 -0.5481 -0.8551 -1.02418 -1.4032 -1.40322 -0.34071 -0.23559 -0.4259 -0.70276 -0.1903 -1.04345ZM0.985763 5.13497c0.407507 0.07422 0.677697 0.46474 0.603467 0.87225C1.53068 6.3287 1.5 6.66044 1.5 7s0.03068 0.6713 0.08923 0.99278c0.07423 0.40751 -0.19596 0.79803 -0.603467 0.87225 -0.40751 0.07422 -0.79803 -0.19596 -0.872251 -0.60347C0.0388823 7.85181 0 7.43012 0 7c0 -0.43012 0.0388823 -0.85181 0.113512 -1.26156 0.074221 -0.40751 0.464741 -0.6777 0.872251 -0.60347Zm12.028437 0c0.4075 -0.07422 0.7981 0.19596 0.8723 0.60347C13.9611 6.14819 14 6.56988 14 7c0 0.43012 -0.0389 0.85181 -0.1135 1.26156 -0.0742 0.40751 -0.4648 0.67769 -0.8723 0.60347 -0.4075 -0.07422 -0.6777 -0.46474 -0.6034 -0.87225C12.4693 7.6713 12.5 7.33956 12.5 7s-0.0307 -0.6713 -0.0892 -0.99278c-0.0743 -0.40751 0.1959 -0.79803 0.6034 -0.87225ZM1.42925 9.9338c0.34069 -0.2356 0.80786 -0.15041 1.04345 0.1903 0.37904 0.5481 0.85512 1.0242 1.40322 1.4032 0.34069 0.2356 0.42588 0.7028 0.19028 1.0434 -0.2356 0.3407 -0.70277 0.4259 -1.04346 0.1903 -0.69685 -0.4819 -1.30186 -1.0869 -1.78377 -1.7837 -0.23559 -0.3407 -0.1504 -0.8079 0.19028 -1.0435Zm11.14145 0c0.3407 0.2356 0.4259 0.7028 0.1903 1.0435 -0.4819 0.6968 -1.0869 1.3018 -1.7837 1.7837 -0.3407 0.2356 -0.8079 0.1504 -1.0435 -0.1903 -0.2356 -0.3406 -0.15041 -0.8078 0.1903 -1.0434 0.5481 -0.379 1.0242 -0.8551 1.4032 -1.4032 0.2356 -0.34071 0.7028 -0.4259 1.0434 -0.1903Zm-7.43573 3.0804c0.07422 -0.4075 0.46474 -0.6777 0.87225 -0.6034 0.32148 0.0585 0.65322 0.0892 0.99278 0.0892s0.6713 -0.0307 0.99278 -0.0892c0.40751 -0.0743 0.79803 0.1959 0.87225 0.6034 0.07422 0.4075 -0.19596 0.7981 -0.60347 0.8723C7.85181 13.9611 7.43012 14 7 14c-0.43012 0 -0.85181 -0.0389 -1.26156 -0.1135 -0.40751 -0.0742 -0.6777 -0.4648 -0.60347 -0.8723Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SelectCircleArea1"
);
var SprayPaint = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.5 1.75049c-0.41421 0 -0.75 0.33578 -0.75 0.75 0 0.41421 0.33579 0.75 0.75 0.75h0.25v1.75c0 0.41421 0.33579 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-1.75h0.25c0.41421 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.33579 -0.75 -0.75 -0.75h-2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.3971 1.48546c0.4062 -0.08124 0.6696 -0.47635 0.5883 -0.882525 -0.0812 -0.406169 -0.4763 -0.6695819 -0.8825 -0.588348L8.10292 1.01459c-0.40617 0.08123 -0.66958 0.47635 -0.58835 0.88252 0.08124 0.40617 0.47635 0.66958 0.88252 0.58835l5.00001 -1ZM8.39709 3.01459c-0.40617 -0.08124 -0.80128 0.18218 -0.88252 0.58835 -0.08123 0.40617 0.18218 0.80128 0.58835 0.88252l4.99998 1c0.4062 0.08123 0.8013 -0.18218 0.8825 -0.58835 0.0813 -0.40617 -0.1821 -0.80129 -0.5883 -0.88252l-5.00001 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 6c0 -0.82843 0.671573 -1.5 1.5 -1.5h4C6.32843 4.5 7 5.17157 7 6v6.5c0 0.8284 -0.67157 1.5 -1.5 1.5h-4C0.671573 14 0 13.3284 0 12.5V6Z" }),
    " "
  ] }) }),
  "SprayPaint"
);
var SquareCap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 3c0 -0.55228 0.447715 -1 1 -1h13v10H1c-0.552284 0 -1 -0.4477 -1 -1V3Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 6.25H6.85462C6.55793 5.51704 5.83934 5 5 5c-1.10457 0 -2 0.89543 -2 2s0.89543 2 2 2c0.83934 0 1.55793 -0.51704 1.85462 -1.25H14v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SquareCap"
);
var StraightCap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 3.5C2.5 2.67157 3.17157 2 4 2h10v10H4c-0.82843 0 -1.5 -0.6716 -1.5 -1.5v-7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M14 6.24992H4.34819C4.05148 5.517 3.33292 5 2.49361 5 1.38904 5 0.493607 5.89543 0.493607 7S1.38904 9 2.49361 9c0.83937 0 1.55798 -0.51708 1.85465 -1.25008H14v-1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StraightCap"
);
var AiGamingSpark = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.778 5.027c0.162 0.08 0.343 0.14 0.544 0.175 0.51 0.088 0.917 0.478 1.028 0.984l0.019 0.086c0.41 1.87 2.987 1.953 3.576 0.228 0.21 0.356 0.35 0.76 0.398 1.195l0.41 3.686a2.274 2.274 0 0 1 -4.295 1.268l-0.358 -0.716H5.14l-0.358 0.716a2.274 2.274 0 0 1 -4.294 -1.268l0.41 -3.686a3 3 0 0 1 2.98 -2.668h2.9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.03 6.868c0.346 0 0.625 0.28 0.625 0.625v0.526h0.527a0.625 0.625 0 1 1 0 1.25h-0.527v0.526a0.625 0.625 0 0 1 -1.25 0V9.27H2.88a0.625 0.625 0 0 1 0 -1.25h0.526v-0.526c0 -0.345 0.28 -0.625 0.625 -0.625Zm5.442 2.393a0.617 0.617 0 1 1 -1.233 0 0.617 0.617 0 0 1 1.233 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.966 0.707c-0.19 -0.83 -1.374 -0.825 -1.556 0.007l-0.007 0.032 -0.014 0.064a2.342 2.342 0 0 1 -1.884 1.797c-0.867 0.15 -0.867 1.394 0 1.545A2.342 2.342 0 0 1 9.39 5.958l0.019 0.087c0.182 0.832 1.367 0.837 1.556 0.006l0.023 -0.1a2.356 2.356 0 0 1 1.893 -1.798c0.868 -0.15 0.868 -1.397 0 -1.548a2.356 2.356 0 0 1 -1.89 -1.782l-0.017 -0.077 -0.01 -0.039Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AiGamingSpark"
);
var Ball = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7 -3.86599 0 -7 3.13401 -7 7 0 3.866 3.13401 7 7 7Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.33308 2.88989c0.24692 -0.33987 0.52367 -0.65666 0.82641 -0.94654 0.76369 0.53861 1.38923 1.27454 1.82555 2.13737 0.45252 0.89488 0.68839 1.89993 0.68839 2.91921 0 1.01928 -0.23587 2.02433 -0.68839 2.9192 -0.43634 0.86287 -1.0619 1.59887 -1.82564 2.13747 -0.30273 -0.2899 -0.57947 -0.6067 -0.82639 -0.9466 0.01276 -0.0102 0.02603 -0.0199 0.03977 -0.0292 0.61738 -0.4178 1.13491 -1.0102 1.49677 -1.72575 0.36195 -0.71577 0.55388 -1.52703 0.55388 -2.35512 0 -0.82809 -0.19193 -1.63935 -0.55388 -2.35513 -0.36186 -0.71559 -0.87939 -1.30792 -1.49676 -1.72573 -0.01373 -0.00929 -0.02697 -0.01902 -0.03971 -0.02918Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.375 13.9725V0.0275215C6.5809 0.00930333 6.78936 0 7 0c0.21063 0 0.4191 0.00930348 0.625 0.0275219V13.9725C7.4191 13.9907 7.21063 14 7 14c-0.21064 0 -0.4191 -0.0093 -0.625 -0.0275Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.667 11.11c-0.2469 0.3399 -0.5237 0.6567 -0.8264 0.9466 -0.7638 -0.5386 -1.3893 -1.2746 -1.8256 -2.13745 -0.45256 -0.89487 -0.68843 -1.89992 -0.68843 -2.9192s0.23587 -2.02433 0.68843 -2.9192c0.4363 -0.86284 1.0618 -1.59877 1.8255 -2.13738 0.3028 0.28988 0.5795 0.60667 0.8264 0.94654 -0.0127 0.01016 -0.026 0.0199 -0.0397 0.02919 -0.6174 0.41781 -1.1349 1.01014 -1.4968 1.72573 -0.3619 0.71577 -0.5538 1.52703 -0.5538 2.35512 0 0.82809 0.1919 1.63935 0.5538 2.35512 0.3619 0.71563 0.8794 1.30793 1.4968 1.72573 0.0138 0.0093 0.027 0.0191 0.0398 0.0292Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Ball"
);
var Balloon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.97395 10.6473c0.34418 -0.0262 0.64447 0.2315 0.67072 0.5757 0.04204 0.5512 0.18846 0.8843 0.34559 1.0849 0.15328 0.1956 0.35024 0.3084 0.58158 0.3626 0.50035 0.1172 1.12808 -0.0536 1.50585 -0.2965 0.84941 -0.546 1.59332 -0.9141 2.39941 -1.1169 0.8061 -0.2029 1.6331 -0.2302 2.6344 -0.1515 0.3441 0.027 0.6011 0.3279 0.5741 0.672 -0.0271 0.3442 -0.328 0.6012 -0.6721 0.5741 -0.926 -0.0727 -1.6047 -0.0401 -2.2313 0.1176 -0.6267 0.1577 -1.24262 0.4509 -2.02856 0.9562 -0.58907 0.3787 -1.56073 0.6743 -2.4669 0.462 -0.47193 -0.1105 -0.93002 -0.3615 -1.2804 -0.8087 -0.34652 -0.4422 -0.55238 -1.0309 -0.60805 -1.7607 -0.02625 -0.3442 0.23148 -0.6445 0.57566 -0.6708Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.22583 8.97468c-0.94956 -0.19649 -1.78384 -0.73039 -2.4138 -1.41608C1.01407 6.69005 0.503418 5.53512 0.503418 4.40357 0.503418 2.13402 2.54567 0.125 5.02138 0.125c2.47569 0 4.51817 2.00899 4.51817 4.27857 0 1.13157 -0.51071 2.2865 -1.30873 3.15505 -0.62409 0.67925 -1.44869 1.20955 -2.38721 1.41045l1.1168 1.39033c0.12048 0.15 0.14423 0.3558 0.06106 0.5292 -0.08316 0.1735 -0.25848 0.2839 -0.45087 0.2839H3.47169c-0.19363 0 -0.36985 -0.1118 -0.45235 -0.287 -0.0825 -0.1751 -0.05644 -0.3822 0.06688 -0.5315l1.13961 -1.37932Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Balloon"
);
var Bomb = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.99129 2.08371C9.62436 0.807359 10.926 0 12.3507 0h0.8993c0.4142 0 0.75 0.335786 0.75 0.75 0 0.41421 -0.3358 0.75 -0.75 0.75h-0.8993c-0.8548 0 -1.6358 0.48442 -2.0156 1.25023l-0.41321 0.83303c-0.18405 0.37107 -0.63407 0.52269 -1.00515 0.33863 -0.37108 -0.18405 -0.52269 -0.63407 -0.33863 -1.00515l0.41318 -0.83303Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 1 0 -13 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.49998 5.125c-0.62989 0 -1.23396 0.25021 -1.67936 0.6956 -0.4454 0.4454 -0.69562 1.04949 -0.69562 1.67938 0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625c0 -0.96141 0.38192 -1.88344 1.06174 -2.56326C4.61656 4.2569 5.53858 3.875 6.49998 3.875c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bomb"
);
var Bow = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.57715 1.75c-0.41421 0 -0.75 0.33579 -0.75 0.75v9c0 0.4142 0.33579 0.75 0.75 0.75h8.99995c0.4143 0 0.75 -0.3358 0.75 -0.75s-0.3357 -0.75 -0.75 -0.75H3.32715V2.5c0 -0.41421 -0.33579 -0.75 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.57715 1.75c-0.41421 0 -0.75 0.33579 -0.75 0.75v9c0 0.4142 0.33579 0.75 0.75 0.75h8.99995c0.4143 0 0.75 -0.3358 0.75 -0.75s-0.3357 -0.75 -0.75 -0.75H3.32715V2.5c0 -0.41421 -0.33579 -0.75 -0.75 -0.75Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.4643 0.026123c-0.3034 0 -0.57684 0.182732 -0.69293 0.462987 -0.11608 0.280256 -0.05191 0.60284 0.16258 0.81734l0.86255 0.86253 -8.44726 8.44722H0.827322c-0.303347 0 -0.576824 0.1827 -0.692909 0.463l-0.000827 0.002c-0.01926 0.0467 -0.0339318 0.0959 -0.0434552 0.1468 -0.0102892 0.0549 -0.0143337 0.1103 -0.0123348 0.1653 0.0071277 0.2046 0.096191 0.3883 0.235388 0.5194l1.823976 1.824c0.13684 0.146 0.33142 0.2372 0.54729 0.2372 0.41421 0 0.75 -0.3358 0.75 -0.75v-1.5716l8.42265 -8.42266 0.8626 0.86253c0.2145 0.2145 0.5371 0.27867 0.8173 0.16258 0.2803 -0.11609 0.463 -0.38956 0.463 -0.69291V0.776123c0 -0.106551 -0.0222 -0.207912 -0.0623 -0.299703 -0.0323 -0.074227 -0.0772 -0.144292 -0.1347 -0.206952 -0.0144 -0.015718 -0.0295 -0.03082 -0.0452 -0.045262 -0.065 -0.059927 -0.1381 -0.106257 -0.2155 -0.1389887C13.4525 0.0471671 13.3537 0.026123 13.25 0.026123h-2.7857Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.82715 3c4.55635 0 8.25005 3.69365 8.25005 8.25 0 0.6312 -0.0708 1.2449 -0.2045 1.834 -0.0916 0.404 0.1615 0.8057 0.5655 0.8974 0.4039 0.0917 0.8057 -0.1615 0.8973 -0.5654 0.1583 -0.6973 0.2417 -1.4224 0.2417 -2.166 0 -5.38478 -4.36527 -9.75 -9.75005 -9.75 -0.74361 0 -1.46865 0.08338 -2.165963 0.24161 -0.403945 0.09166 -0.65710192 0.49343 -0.5654414 0.89737 0.0916594 0.40395 0.4934264 0.6571 0.8973714 0.56544C1.58225 3.07074 2.19598 3 2.82715 3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bow"
);
var Cards = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.02662 3.05918c-0.06858 -0.25582 -0.33153 -0.40764 -0.58737 -0.33912L0.35575 4.3493c-0.2559288 0.06854 -0.4078092 0.33161 -0.3392033 0.58752L2.35089 13.6443c0.06858 0.2558 0.33153 0.4076 0.58737 0.3391l6.0835 -1.6292c0.25593 -0.0686 0.40781 -0.3316 0.3392 -0.5875L7.02662 3.05918Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.97338 0.669039c0.06858 -0.255819 0.33153 -0.407632 0.58737 -0.339116L13.6443 1.95917c0.2559 0.06854 0.4078 0.3316 0.3392 0.58751l-2.3344 8.70752c-0.0686 0.2558 -0.3315 0.4076 -0.5874 0.3391L4.97824 9.96403c-0.25593 -0.06854 -0.40781 -0.3316 -0.3392 -0.58751L6.97338 0.669039Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Cards"
);
var ChessBishop = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.267 2c-0.2 0.126 -0.442 0.294 -0.684 0.502 -0.587 0.505 -1.265 1.32 -1.265 2.413 0 0.561 0.158 1.042 0.471 1.417 0.165 0.197 0.363 0.353 0.582 0.474 -0.01 0.03 -0.018 0.06 -0.025 0.09 -0.158 0.65 -0.405 1.677 -0.616 2.578a95.406 95.406 0 0 0 -0.296 1.301h5.132l-0.023 -0.107a95.368 95.368 0 0 0 -0.273 -1.194c-0.21 -0.9 -0.458 -1.929 -0.615 -2.578a1.365 1.365 0 0 0 -0.026 -0.09 2.03 2.03 0 0 0 0.582 -0.475c0.313 -0.374 0.471 -0.855 0.471 -1.416 0 -0.475 -0.128 -0.898 -0.32 -1.265L8.38 4.66a0.625 0.625 0 0 1 -0.897 -0.871l1.102 -1.135A5.766 5.766 0 0 0 7.734 2a1.085 1.085 0 0 1 -1.467 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.911 1.194a1.09 1.09 0 1 1 2.18 0 1.09 1.09 0 0 1 -2.18 0ZM2.794 11.549c0.197 -0.5 0.712 -0.774 1.216 -0.774h5.982c0.504 0 1.019 0.273 1.216 0.774l0.611 1.548a0.5 0.5 0 0 1 -0.465 0.683H2.648a0.5 0.5 0 0 1 -0.465 -0.683l0.61 -1.548Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChessBishop"
);
var ChessKing = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.3 0.542a0.5 0.5 0 0 0 -1 0V0.78h-0.237a0.5 0.5 0 0 0 0 1h0.238v0.567c-0.946 0.204 -1.704 0.974 -1.704 1.971a0.5 0.5 0 0 0 0.5 0.5h3.407a0.5 0.5 0 0 0 0.5 -0.5c0 -0.997 -0.758 -1.767 -1.703 -1.971V1.78h0.237a0.5 0.5 0 0 0 0 -1h-0.237V0.542Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.573 4.23c0.214 -0.258 0.545 -0.412 0.906 -0.412h4.644c0.361 0 0.692 0.154 0.906 0.411a0.992 0.992 0 0 1 0.17 1.001L9.197 7.835a0.5 0.5 0 0 1 -0.166 0.22l0.36 2.583a0.5 0.5 0 0 1 0 0.137H4.11a0.5 0.5 0 0 1 0 -0.137l0.372 -2.67a0.5 0.5 0 0 1 -0.076 -0.133L3.402 5.23a0.992 0.992 0 0 1 0.17 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.81 10.775c-0.504 0 -1.019 0.273 -1.216 0.774l-0.612 1.548a0.5 0.5 0 0 0 0.466 0.683h8.706a0.5 0.5 0 0 0 0.465 -0.683l-0.611 -1.548c-0.198 -0.5 -0.712 -0.774 -1.216 -0.774H3.809Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChessKing"
);
var ChessKnight = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.088 4.16A1.733 1.733 0 0 0 5.44 6.543l1.39 -0.794a1.436 1.436 0 0 1 -0.05 0.263c-0.122 0.43 -0.485 1.053 -1.4 1.77 -1.111 0.869 -1.873 1.832 -2.649 2.928a0.5 0.5 0 0 0 0.418 0.789l7.281 -0.14a0.5 0.5 0 0 0 0.482 -0.404l0.256 -1.306 0.003 -0.015c0.497 -3.003 0.373 -4.927 -0.072 -6.244 -0.454 -1.345 -1.226 -2.002 -1.856 -2.492C8.622 0.415 7.608 0.162 6.702 0.059c-0.91 -0.104 -1.877 -0.076 -2.45 0.128a0.5 0.5 0 0 0 -0.29 0.674l0.46 1.035L3.088 4.16Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.81 7.418c0.974 -0.717 1.987 -1.802 2.442 -3.301a0.5 0.5 0 0 0 -0.957 -0.29C6.905 5.11 6.003 6.058 5.11 6.69c0.113 -0.037 0.224 -0.085 0.33 -0.146l1.39 -0.794a1.436 1.436 0 0 1 -0.05 0.263c-0.1 0.356 -0.365 0.843 -0.97 1.405Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.107 10.642c-0.7 0 -1.22 0.541 -1.398 1.18l-0.51 1.519a0.5 0.5 0 0 0 0.473 0.659h10.656a0.5 0.5 0 0 0 0.48 -0.642l-0.452 -1.526c-0.174 -0.643 -0.697 -1.19 -1.4 -1.19h-7.85Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChessKnight"
);
var ChessPawn = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.496a2.644 2.644 0 0 0 -2.247 4.039h4.494A2.644 2.644 0 0 0 7 0.497Zm1.886 5.539H5.114a30.801 30.801 0 0 1 -0.47 2.541 15.44 15.44 0 0 1 -0.486 1.705 7.092 7.092 0 0 1 -0.198 0.495l0.049 0H9.99l0.05 0a7.084 7.084 0 0 1 -0.2 -0.495c-0.18 -0.5 -0.343 -1.09 -0.486 -1.705a30.793 30.793 0 0 1 -0.469 -2.541Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.677 5.285a0.75 0.75 0 0 1 0.75 -0.75h5.146a0.75 0.75 0 0 1 0 1.5H4.427a0.75 0.75 0 0 1 -0.75 -0.75Zm0.332 5.49c-0.504 0 -1.019 0.273 -1.216 0.774l-0.611 1.548a0.5 0.5 0 0 0 0.465 0.683h8.706a0.5 0.5 0 0 0 0.465 -0.683l-0.61 -1.548c-0.198 -0.5 -0.713 -0.774 -1.217 -0.774H4.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChessPawn"
);
var CloudGaming1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.14286 1.85718C2.30254 1.85718 0 4.15971 0 7.00003c0 2.84033 2.30254 5.14287 5.14286 5.14287h4.64285C12.1132 12.1429 14 10.2561 14 7.92861s-1.8868 -4.21429 -4.21429 -4.21429c-0.21937 0 -0.43509 0.0168 -0.64588 0.04926 -0.94221 -1.16222 -2.38268 -1.9064 -3.99697 -1.9064Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.0184 7.15747c-0.41424 0 -0.75003 -0.33579 -0.75003 -0.75s0.33579 -0.75 0.75003 -0.75c0.4142 0 0.75 0.33579 0.75 0.75s-0.3358 0.75 -0.75 0.75ZM4.17806 5.76526c0.34518 0 0.625 0.27982 0.625 0.625v0.84053h0.84053c0.34518 0 0.625 0.27982 0.625 0.625s-0.27982 0.625 -0.625 0.625h-0.84053v0.84054c0 0.34517 -0.27982 0.625 -0.625 0.625s-0.625 -0.27983 -0.625 -0.625v-0.84054h-0.84054c-0.34517 0 -0.625 -0.27982 -0.625 -0.625s0.27983 -0.625 0.625 -0.625h0.84054v-0.84053c0 -0.34518 0.27982 -0.625 0.625 -0.625Zm5.17326 2.0592c0 0.41422 -0.33579 0.75 -0.75 0.75 -0.41422 0 -0.75 -0.33578 -0.75 -0.75 0 -0.41421 0.33578 -0.75 0.75 -0.75 0.41421 0 0.75 0.33579 0.75 0.75Zm2.08408 0.75c0.4142 0 0.75 -0.33578 0.75 -0.75 0 -0.41421 -0.3358 -0.75 -0.75 -0.75s-0.75 0.33579 -0.75 0.75c0 0.41422 0.3358 0.75 0.75 0.75Zm-2.16703 0.667c0 0.41421 0.33579 0.75 0.75003 0.75 0.4142 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.3358 -0.75 -0.75 -0.75 -0.41424 0 -0.75003 0.33578 -0.75003 0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CloudGaming1"
);
var ClubsSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.25a3.036 3.036 0 0 0 -3.036 3.036c0 0.56 0.152 1.186 0.412 1.771a4.029 4.029 0 0 0 -1.09 -0.164 3.036 3.036 0 0 0 0 6.071c0.622 0 1.328 -0.187 1.967 -0.504l-0.606 2.99a0.25 0.25 0 0 0 0.245 0.3h4.216a0.25 0.25 0 0 0 0.245 -0.3l-0.606 -2.99c0.639 0.317 1.345 0.504 1.967 0.504a3.036 3.036 0 0 0 0 -6.071c-0.347 0 -0.72 0.058 -1.09 0.164 0.26 -0.585 0.412 -1.212 0.412 -1.771A3.036 3.036 0 0 0 7 0.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ClubsSymbol"
);
var Controller1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.203 5.169 0.784 8.94a2.305 2.305 0 0 0 4.353 1.286L5.5 9.5h3l0.363 0.726a2.305 2.305 0 0 0 4.353 -1.286l-0.42 -3.771A3 3 0 0 0 9.816 2.5h-5.63a3 3 0 0 0 -2.982 2.669Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 5a0.625 0.625 0 1 0 -1.25 0v0.542h-0.542a0.625 0.625 0 0 0 0 1.25h0.542v0.541a0.625 0.625 0 1 0 1.25 0v-0.541h0.542a0.625 0.625 0 0 0 0 -1.25H5V5Zm4.266 2.417a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 0 0 0 1.25Zm1.875 -2.175a0.625 0.625 0 1 1 -1.25 0 0.625 0.625 0 0 1 1.25 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Controller1"
);
var ControllerWireless = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.612 2.45c0.353 -0.235 1.634 -0.825 3.388 -0.825 1.753 0 3.035 0.59 3.387 0.825a0.75 0.75 0 0 0 0.833 -1.248C10.62 0.802 9.05 0.125 7 0.125S3.379 0.803 2.78 1.202a0.75 0.75 0 1 0 0.832 1.248Zm1.822 2.424c0.264 -0.132 0.968 -0.396 1.566 -0.396 0.597 0 1.302 0.264 1.566 0.396a0.75 0.75 0 0 0 0.671 -1.342C8.868 3.348 7.924 2.978 7 2.978c-0.924 0 -1.868 0.37 -2.237 0.554a0.75 0.75 0 0 0 0.67 1.342Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.618 6a3.61 3.61 0 1 0 2.205 6.469h2.316A3.61 3.61 0 1 0 10.344 6l-0.016 0 -0.008 0H3.79c-0.017 0 -0.032 0 -0.047 0.002A3.674 3.674 0 0 0 3.618 6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.328 9.285a0.765 0.765 0 1 0 0 -1.53 0.765 0.765 0 0 0 0 1.53Zm-1.76 1.88a0.765 0.765 0 1 0 0 -1.53 0.765 0.765 0 0 0 0 1.53Zm-6.15 -3.27c0.345 0 0.625 0.28 0.625 0.625v0.448h0.448a0.625 0.625 0 0 1 0 1.25h-0.448v0.448a0.625 0.625 0 1 1 -1.25 0v-0.448h-0.449a0.625 0.625 0 1 1 0 -1.25h0.449V8.52c0 -0.345 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ControllerWireless"
);
var Controller = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.047 0.991a0.75 0.75 0 0 0 -1.5 0v0.884a0.25 0.25 0 0 1 -0.25 0.25H8a1.75 1.75 0 0 0 -1.75 1.75v0.884h1.5v-0.884a0.25 0.25 0 0 1 0.25 -0.25h1.297a1.75 1.75 0 0 0 1.75 -1.75V0.991Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m1.203 7.428 -0.419 3.771a2.305 2.305 0 0 0 4.353 1.286l0.363 -0.726h3l0.363 0.726a2.305 2.305 0 0 0 4.353 -1.286l-0.42 -3.771a3 3 0 0 0 -2.981 -2.67h-5.63a3 3 0 0 0 -2.982 2.67Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 7.259a0.625 0.625 0 1 0 -1.25 0V7.8h-0.542a0.625 0.625 0 0 0 0 1.25h0.542v0.541a0.625 0.625 0 0 0 1.25 0V9.05h0.542a0.625 0.625 0 1 0 0 -1.25H5v-0.542Zm4.266 2.417a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 0 0 0 1.25ZM11.14 7.5a0.625 0.625 0 1 1 -1.25 0 0.625 0.625 0 0 1 1.25 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Controller"
);
var DesktopGame = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.518 0.884C0.714 0.884 0.062 1.536 0.062 2.34v7.31c0 0.804 0.652 1.456 1.456 1.456H12.5a1.5 1.5 0 0 0 1.5 -1.5V2.384a1.5 1.5 0 0 0 -1.5 -1.5H1.518Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.814 4.53a0.625 0.625 0 0 0 -1.25 0v0.875h-0.875a0.625 0.625 0 0 0 0 1.25h0.875v0.875a0.625 0.625 0 0 0 1.25 0v-0.875h0.875a0.625 0.625 0 1 0 0 -1.25h-0.875V4.53Zm5.292 0.525a0.875 0.875 0 1 0 1.75 0 0.875 0.875 0 0 0 -1.75 0Zm-1.942 1.95a0.875 0.875 0 1 0 1.75 0 0.875 0.875 0 0 0 -1.75 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopGame"
);
var DiamondsSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.0721 0.784927c-0.52684 -0.7132358 -1.61743 -0.7132363 -2.14427 0L1.89112 6.24982c-0.33106 0.44819 -0.33106 1.05217 0 1.50036l4.03671 5.46492c0.52684 0.7132 1.61743 0.7132 2.14427 0l4.0367 -5.46492c0.3311 -0.44819 0.3311 -1.05217 0 -1.50036L8.0721 0.784927Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DiamondsSymbol"
);
var Dice1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.8 7a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 1 0 -2.4 0" }),
    " "
  ] }) }),
  "Dice1"
);
var Dice2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.788 5.412a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm-5.576 5.576a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dice2"
);
var Dice3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.788 5.412a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4ZM8.198 7a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0ZM5.412 9.788a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dice3"
);
var Dice4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.414 4.212a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Zm4.372 1.2a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm0 5.576a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm-5.572 0a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dice4"
);
var Dice5 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.414 4.212a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Zm5.572 0a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Zm0 5.576a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0ZM7 8.202a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm-2.786 2.786a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dice5"
);
var Dice6 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v9A2.5 2.5 0 0 0 2.5 14h9a2.5 2.5 0 0 0 2.5 -2.5v-9A2.5 2.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.035 4.77a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm0 6.86a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4ZM5.235 7a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Zm4.73 -2.23a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Zm1.2 5.66a1.2 1.2 0 1 1 -2.4 0 1.2 1.2 0 0 1 2.4 0Zm-1.2 -2.23a1.2 1.2 0 1 0 0 -2.4 1.2 1.2 0 0 0 0 2.4Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dice6"
);
var DicesEntertainmentGamingDices = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.25 0.25h6.437s1 0 1 1v6.437s0 1 -1 1H1.25s-1 0 -1 -1V1.25s0 -1 1 -1" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.752 2.723a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.313 5.313h6.437s1 0 1 1v6.437s0 1 -1 1H6.313s-1 0 -1 -1V6.313s0 -1 1 -1" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.8815 8.97168c0.5523 0 1 -0.44772 1 -1 0 -0.55229 -0.4477 -1 -1 -1s-0.99997 0.44771 -0.99997 1c0 0.55228 0.44767 1 0.99997 1ZM8.18188 12.0919c0.55229 0 1 -0.4477 1 -1s-0.44771 -1 -1 -1c-0.55228 0 -1 0.4477 -1 1s0.44772 1 1 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DicesEntertainmentGamingDices"
);
var Esports = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.43207 4.03003c-0.51489 0 -1.01775 0.29608 -1.21779 0.81646 -0.348468 0.90652 -0.655294 2.12669 -0.872293 3.26858 -0.215976 1.1365 -0.3522598 2.24423 -0.341380314 2.92313C0.0128946 11.805 0.130229 12.5158 0.510743 13.0398c0.408133 0.5621 1.042057 0.8119 1.846267 0.8119 0.07768 0 0.15429 -0.0181 0.22375 -0.0529 0.60472 -0.3026 1.11798 -0.8834 1.54694 -1.4149 0.12944 -0.1604 0.25167 -0.3167 0.36898 -0.4668l0.00001 0c0.24975 -0.3193 0.47721 -0.6102 0.70437 -0.8512H8.7906c0.20517 0.2313 0.41233 0.511 0.64088 0.8196l0.00001 0 0.00007 0.0001c0.11652 0.1574 0.23861 0.3222 0.36883 0.492 0.40901 0.5333 0.90731 1.125 1.49921 1.4212 0.0694 0.0348 0.146 0.0529 0.2237 0.0529 0.8024 0 1.4544 -0.2476 1.8916 -0.7929 0.4182 -0.5215 0.5719 -1.2341 0.5845 -2.0206 0.0108 -0.6737 -0.1233 -1.76946 -0.3363 -2.89613 -0.214 -1.13227 -0.5167 -2.34375 -0.8609 -3.25227 -0.208 -0.54911 -0.7375 -0.85977 -1.2789 -0.85977H9.78578c-0.07762 0 -0.15418 0.01807 -0.22361 0.05279l-0.82302 0.41151H5.26084l-0.82303 -0.41151c-0.06942 -0.03472 -0.14598 -0.05279 -0.2236 -0.05279H2.43207Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.46863 4.03087V1.2872c0 -0.18585 0.19558 -0.306719 0.3618 -0.22361l1.40363 0.70183L6.82273 0.176739c0.09764 -0.0976309 0.25593 -0.0976314 0.35356 0L8.76497 1.76542l1.40363 -0.70183c0.1663 -0.083113 0.3618 0.03776 0.3618 0.22361v2.74367c0 0.48752 -0.3952 0.88273 -0.88268 0.88273H4.35136c-0.48752 0 -0.88273 -0.39521 -0.88273 -0.88273Zm2.13973 4.58126c0 0.72169 -0.58505 1.30674 -1.30674 1.30674 -0.7217 0 -1.30675 -0.58505 -1.30675 -1.30674 0 -0.7217 0.58505 -1.30675 1.30675 -1.30675 0.72169 0 1.30674 0.58505 1.30674 1.30675Zm5.39684 0c0 0.72169 -0.5851 1.30674 -1.30679 1.30674 -0.7217 0 -1.30675 -0.58505 -1.30675 -1.30674 0 -0.7217 0.58505 -1.30675 1.30675 -1.30675 0.72169 0 1.30679 0.58505 1.30679 1.30675Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Esports"
);
var FireworksRocket = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.92027 7.44293c-0.02915 -0.09329 -0.08067 -0.18109 -0.15457 -0.25499 -0.24408 -0.24408 -0.63981 -0.24408 -0.88388 0L0.409926 12.6598c-0.244078 0.2441 -0.244078 0.6398 0 0.8839 0.244078 0.2441 0.639804 0.2441 0.883884 0l4.19125 -4.19124c-0.11219 0.78454 0.13092 1.61014 0.7298 2.21714l0.42875 0.4346c0.24242 0.2457 0.63814 0.2484 0.88386 0.006 0.24572 -0.2425 0.24839 -0.6382 0.00596 -0.8839l-0.42875 -0.4346c-0.52958 -0.5367 -0.52806 -1.39989 0.00341 -1.9348l0.24692 -0.24851c0.24329 -0.24487 0.24202 -0.64059 -0.00285 -0.88388 -0.11971 -0.11895 -0.27549 -0.17944 -0.43189 -0.18158Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.15415 1.19495c0.03679 0.10133 0.09884 0.19724 0.1795 0.27742l0.44152 0.44153 -4.18343 3.18162c-0.24111 0.18338 -0.26507 0.53734 -0.05087 0.75154l3.56462 3.56462c0.2142 0.2142 0.56816 0.19024 0.75153 -0.05088l3.18158 -4.18343 0.4547 0.45465c0.0798 0.07674 0.1739 0.13532 0.2727 0.16977 0.0988 0.03446 0.1988 0.04355 0.2898 0.02635 0.0964 -0.01281 0.1809 -0.0532 0.2445 -0.11685 0.0637 -0.06365 0.1041 -0.14818 0.1169 -0.24456l0.4162 -4.613807c0.0091 -0.089066 -0.0057 -0.184588 -0.0429 -0.277749 -0.0372 -0.093161 -0.0957 -0.180959 -0.17 -0.255291 -0.0743 -0.074331 -0.1621 -0.132802 -0.2553 -0.170014 -0.0932 -0.037212 -0.1887 -0.0519666 -0.2777 -0.042902l-4.6012 0.42887c-0.09638 0.012814 -0.18091 0.053201 -0.24456 0.116853 -0.06365 0.063652 -0.10404 0.148178 -0.11686 0.244557 -0.01763 0.093454 -0.00751 0.196373 0.02927 0.297703Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.4659 10.1357c-0.2441 -0.24408 -0.63984 -0.24408 -0.88392 0 -0.24407 0.2441 -0.24407 0.6398 0 0.8839l0.45132 0.4513c0.244 0.244 0.6398 0.244 0.8838 0 0.2441 -0.2441 0.2441 -0.6399 0 -0.8839l-0.4512 -0.4513Zm1.9169 0c0.2441 -0.24408 0.6398 -0.24408 0.8839 0 0.2441 0.2441 0.2441 0.6398 0 0.8839l-0.4513 0.4513c-0.244 0.244 -0.6398 0.244 -0.8839 0 -0.244 -0.2441 -0.244 -0.6399 0 -0.8839l0.4513 -0.4513Zm-2.80082 3.408c0.24408 0.2441 0.63982 0.2441 0.88392 0l0.4512 -0.4512c0.2441 -0.2441 0.2441 -0.6398 0 -0.8839 -0.244 -0.2441 -0.6398 -0.2441 -0.8838 0l-0.45132 0.4513c-0.24407 0.244 -0.24407 0.6398 0 0.8838Zm2.80082 0c0.2441 0.2441 0.6398 0.2441 0.8839 0 0.2441 -0.244 0.2441 -0.6398 0 -0.8838l-0.4513 -0.4513c-0.244 -0.2441 -0.6398 -0.2441 -0.8839 0 -0.244 0.2441 -0.244 0.6398 0 0.8839l0.4513 0.4512Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "FireworksRocket"
);
var HeartsSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.788 1.314c0.988 0.02 2.085 0.49 3.214 1.56 1.127 -1.067 2.223 -1.536 3.21 -1.555 1.04 -0.02 1.918 0.46 2.536 1.18 1.218 1.42 1.47 3.85 -0.058 5.377l-0.001 0.001 -4.247 4.208c-0.81 0.802 -2.07 0.802 -2.88 0L1.316 7.877C-0.217 6.343 0.032 3.913 1.25 2.491c0.617 -0.72 1.495 -1.2 2.537 -1.178Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HeartsSymbol"
);
var JumpObject = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5 3.5h4s1.5 0 1.5 1.5v4s0 1.5 -1.5 1.5H5s-1.5 0 -1.5 -1.5V5s0 -1.5 1.5 -1.5" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 0.25a0.75 0.75 0 1 0 0 1.5h12.5a0.75 0.75 0 0 0 0 -1.5H0.75Zm0 12a0.75 0.75 0 0 0 0 1.5h12.5a0.75 0.75 0 0 0 0 -1.5H0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "JumpObject"
);
var ModulePuzzle1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.02 0.25a1.142 1.142 0 0 0 -0.842 0.37L5.045 1.745a2.416 2.416 0 0 0 -0.481 -0.668 2.464 2.464 0 0 0 -3.486 3.486c0.193 0.197 0.416 0.357 0.66 0.477L0.62 6.138a1.142 1.142 0 0 0 0 1.684l1.466 1.467a0.5 0.5 0 0 0 0.804 -0.136 1.478 1.478 0 1 1 2.388 1.668 1.59 1.59 0 0 1 -0.412 0.29 0.5 0.5 0 0 0 -0.143 0.795l1.413 1.47a1.143 1.143 0 0 0 1.686 0.005l1.136 -1.13a2.462 2.462 0 0 0 3.957 0.665 2.463 2.463 0 0 0 -0.655 -3.954l1.119 -1.1a1.143 1.143 0 0 0 0 -1.685l-1.487 -1.468a0.5 0.5 0 0 0 -0.801 0.138 1.586 1.586 0 0 1 -0.28 0.404 1.473 1.473 0 0 1 -2.081 -2.08c0.12 -0.114 0.256 -0.21 0.404 -0.281a0.5 0.5 0 0 0 0.143 -0.797L7.864 0.623A1.142 1.142 0 0 0 7.02 0.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ModulePuzzle1"
);
var ModulePuzzle3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.5 0C0.671573 0 0 0.671573 0 1.5v11c0 0.8284 0.671573 1.5 1.5 1.5h11c0.8284 0 1.5 -0.6716 1.5 -1.5v-11c0 -0.828427 -0.6716 -1.5 -1.5 -1.5h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 12.5V7h2.13195c-0.23752 0.26538 -0.38195 0.61582 -0.38195 1 0 0.82843 0.67157 1.5 1.5 1.5s1.5 -0.67157 1.5 -1.5c0 -0.38418 -0.14443 -0.73462 -0.38195 -1H7V4.36805c-0.26538 0.23752 -0.61582 0.38195 -1 0.38195 -0.82843 0 -1.5 -0.67157 -1.5 -1.5s0.67157 -1.5 1.5 -1.5c0.38418 0 0.73462 0.14443 1 0.38195V0h5.5c0.8284 0 1.5 0.671573 1.5 1.5V7h-2.1319c0.2375 -0.26538 0.3819 -0.61582 0.3819 -1 0 -0.82843 -0.6716 -1.5 -1.5 -1.5 -0.82843 0 -1.5 0.67157 -1.5 1.5 0 0.38418 0.14443 0.73462 0.38195 1H7v2.63195c0.26538 -0.23752 0.61582 -0.38195 1 -0.38195 0.82843 0 1.5 0.67157 1.5 1.5 0 0.8284 -0.67157 1.5 -1.5 1.5 -0.38418 0 -0.73462 -0.1444 -1 -0.3819V14H1.5C0.671573 14 0 13.3284 0 12.5Z" }),
    " "
  ] }) }),
  "ModulePuzzle3"
);
var OneVesusOne = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m10.852 12.095 0.103 0.307a1.306 1.306 0 0 0 2.537 -0.557l-0.202 -1.817a2.4 2.4 0 0 0 -2.386 -2.136H7.991c-1.223 0 -2.25 0.92 -2.386 2.136l-0.202 1.816a1.306 1.306 0 0 0 2.538 0.558l0.102 -0.307c0.12 -0.359 0.455 -0.6 0.833 -0.6h1.143c0.378 0 0.714 0.241 0.833 0.6Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8 3a3 3 0 1 1 -6 0 3 3 0 0 1 6 0ZM4.363 9.89a3.65 3.65 0 0 1 1.796 -2.755A5 5 0 0 0 0 12a0.5 0.5 0 0 0 0.5 0.5h3.696a2.557 2.557 0 0 1 -0.035 -0.793l0.202 -1.817Zm3.54 2.61c0.014 -0.032 0.027 -0.065 0.038 -0.098l0.102 -0.307 -0.102 0.307a1.312 1.312 0 0 1 -0.037 0.098Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OneVesusOne"
);
var PartyPopper = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.408 4.29a1.676 1.676 0 0 0 -1.564 0.4l-0.012 0.012 -3.911 3.911 -0.005 0.005a1.667 1.667 0 0 0 0.636 2.732l6.232 2.323 0.007 0.003a1.639 1.639 0 0 0 2.102 -2.064L11.58 5.385a1.677 1.677 0 0 0 -1.173 -1.095Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.876 0.201a0.75 0.75 0 0 1 0.463 0.955 3.456 3.456 0 0 0 0.107 2.54 0.75 0.75 0 0 1 -1.372 0.607A4.956 4.956 0 0 1 5.921 0.665 0.75 0.75 0 0 1 6.876 0.2ZM4.523 2.883a0.75 0.75 0 0 0 -1.486 -0.206 2.85 2.85 0 0 0 0.448 1.968 0.75 0.75 0 1 0 1.25 -0.83 1.35 1.35 0 0 1 -0.212 -0.932Zm-2.172 5.16a1.31 1.31 0 0 1 0.928 -0.133 0.75 0.75 0 0 0 0.332 -1.463 2.81 2.81 0 0 0 -1.991 0.287 0.75 0.75 0 0 0 0.73 1.31ZM1.065 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0 -2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PartyPopper"
);
var SpadesSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.43617 0.814097c-0.80812 -0.7521293 -2.05975 -0.7521293 -2.86787 0L1.32107 4.76704l-0.00085 0.00079C-0.0561896 6.06085 -0.000548035 8.03805 0.896475 9.39564c0.451315 0.68306 1.123015 1.22416 1.951715 1.45206 0.70628 0.1942 1.51027 0.1564 2.36585 -0.1938l-0.56683 2.7964c-0.0149 0.0736 0.004 0.1499 0.05148 0.2079 0.04748 0.0581 0.11853 0.0918 0.19354 0.0918h4.2155c0.07501 0 0.14606 -0.0337 0.19354 -0.0918 0.04748 -0.058 0.06638 -0.1343 0.05148 -0.2079l-0.56758 -2.8001c0.85469 0.3498 1.65813 0.3872 2.36403 0.1928 0.8284 -0.2281 1.5002 -0.7692 1.952 -1.45198 0.8978 -1.35686 0.9565 -3.33299 -0.417 -4.62319l-0.0008 -0.00079L8.43617 0.814097Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SpadesSymbol"
);
var Trophy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.75 0A0.75 0.75 0 0 0 0 0.75v2.77a3.75 3.75 0 0 0 3.75 3.75h0.385a0.75 0.75 0 0 0 0.75 -0.75V0.75a0.75 0.75 0 0 0 -0.75 -0.75H0.75Zm0.75 3.52V1.5h1.885v4.24A2.25 2.25 0 0 1 1.5 3.52ZM13.25 0a0.75 0.75 0 0 1 0.75 0.75v2.77a3.75 3.75 0 0 1 -3.75 3.75h-0.385a0.75 0.75 0 0 1 -0.75 -0.75V0.75a0.75 0.75 0 0 1 0.75 -0.75h3.385Zm-0.75 3.52V1.5h-1.885v4.24A2.25 2.25 0 0 0 12.5 3.52ZM7 8.654a0.75 0.75 0 0 1 0.75 0.75V12.5h2.615a0.75 0.75 0 0 1 0 1.5H7.026a0.762 0.762 0 0 1 -0.052 0h-3.34a0.75 0.75 0 0 1 0 -1.5H6.25V9.404a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 0.002a0.5 0.5 0 0 0 -0.5 0.5V6a4 4 0 1 0 8 0V0.502a0.5 0.5 0 0 0 -0.5 -0.5h-7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Trophy"
);
var Zodiac1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.846 3.385A0.846 0.846 0 0 0 2 4.23v5.538a1 1 0 0 1 -2 0V4.231a2.846 2.846 0 0 1 4.692 -2.166A2.846 2.846 0 0 1 9.385 4.23v5.538a0.846 0.846 0 0 0 1.689 0.074 1 1 0 0 1 -0.627 -1.704l0.918 -0.918a0.992 0.992 0 0 1 0.712 -0.298 0.997 0.997 0 0 1 0.707 0.293l0.923 0.923a1 1 0 0 1 -0.631 1.704 2.847 2.847 0 0 1 -5.691 -0.074V4.231a0.846 0.846 0 0 0 -1.693 -0.004l0 0.004v5.538a1 1 0 0 1 -2 0V4.236l0 -0.005a0.846 0.846 0 0 0 -0.846 -0.846Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac1"
);
var Zodiac10 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.138 0.38A1 1 0 0 1 2.543 0.215 8.292 8.292 0 0 1 5.666 6h2.668A8.292 8.292 0 0 1 11.457 0.215a1 1 0 1 1 1.24 1.57A6.293 6.293 0 0 0 10.344 6H13a1 1 0 1 1 0 2h-2.656a6.29 6.29 0 0 0 2.353 4.215 1 1 0 1 1 -1.24 1.57A8.293 8.293 0 0 1 8.334 8H5.666a8.293 8.293 0 0 1 -3.123 5.785 1 1 0 1 1 -1.24 -1.57A6.293 6.293 0 0 0 3.657 8H1a1 1 0 0 1 0 -2h2.656a6.292 6.292 0 0 0 -2.352 -4.215A1 1 0 0 1 1.138 0.38Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac10"
);
var Zodiac11 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.743 0.331A0.998 0.998 0 0 0 13 0H8.385a1 1 0 0 0 0 2h2.2L4.232 8.355l-1.6 -1.6a1 1 0 0 0 -1.415 1.414l1.6 1.6 -2.523 2.524a1 1 0 1 0 1.414 1.414l2.524 -2.524 1.6 1.601a1 1 0 1 0 1.415 -1.414l-1.601 -1.6L12 3.413v2.201a1 1 0 1 0 2 0V1a0.996 0.996 0 0 0 -0.257 -0.669Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac11"
);
var Zodiac12 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.30769 2.53088C2.58547 2.53088 2 3.11636 2 3.83857c0 0.72222 0.58547 1.30769 1.30769 1.30769s1.30769 -0.58547 1.30769 -1.30769c0 -0.72221 -0.58547 -1.30769 -1.30769 -1.30769ZM0 3.83857C0 2.01179 1.4809 0.530884 3.30769 0.530884H13c0.5523 0 1 0.447715 1 0.999996 0 0.55229 -0.4477 1 -1 1H6.34683c0.17281 0.4011 0.26855 0.84322 0.26855 1.30769 0 1.82679 -1.4809 3.30769 -3.30769 3.30769S0 5.66536 0 3.83857Zm10.6923 5.01522c-0.72218 0 -1.30766 0.58547 -1.30766 1.30771 0 0.7195 0.58117 1.3034 1.29976 1.3076h0.0079l0.0053 0.0001C11.4174 11.4663 12 10.882 12 10.1615c0 -0.72224 -0.5854 -1.30771 -1.3077 -1.30771ZM7.38464 10.1615c0 0.4644 0.09574 0.9066 0.26855 1.3076H1c-0.552285 0 -1 0.4478 -1 1 0 0.5523 0.447715 1 1 1h9.6796l0.0127 0.0001c1.8268 0 3.3077 -1.4809 3.3077 -3.3077 0 -1.82681 -1.4809 -3.30771 -3.3077 -3.30771 -1.82675 0 -3.30766 1.4809 -3.30766 3.30771Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac12"
);
var Zodiac2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.07692 2c-0.28562 0 -0.55954 0.11346 -0.7615 0.31542C2.11346 2.51738 2 2.7913 2 3.07692v6.23075c0 0.55229 -0.44772 1.00003 -1 1.00003 -0.552285 0 -1 -0.44774 -1 -1.00003V3.07692C0 2.26087 0.324174 1.47824 0.901209 0.901209 1.47824 0.324174 2.26087 0 3.07692 0c0.77037 0 1.51096 0.288902 2.07692 0.806708C5.71979 0.288902 6.46038 0 7.23076 0c0.81605 0 1.59867 0.324174 2.17571 0.901209 0.44849 0.448491 0.74423 1.021191 0.85373 1.637241h0.3078c2.8955 0 4.3455 3.50071 2.2981 5.5481l-2.4862 2.48625c0.0418 0.0946 0.101 0.1817 0.1756 0.2563 0.1587 0.1587 0.3739 0.2478 0.5983 0.2478 0.2244 0 0.4397 -0.0891 0.5983 -0.2478 0.1587 -0.1587 0.2479 -0.3739 0.2479 -0.5984v-0.42303c0 -0.55228 0.4477 -1 1 -1s1 0.44772 1 1v0.42303c0 0.7549 -0.2999 1.4788 -0.8336 2.0126 -0.5338 0.5337 -1.2577 0.8336 -2.0126 0.8336 -0.7548 0 -1.47875 -0.2999 -2.01251 -0.8336 -0.07248 -0.0725 -0.14065 -0.1485 -0.20434 -0.2276l-0.72984 0.7299c-0.39053 0.3905 -1.02369 0.3905 -1.41422 0 -0.39052 -0.3906 -0.39052 -1.0237 0 -1.4143l1.51478 -1.51474V3.07692c0 -0.28562 -0.11346 -0.55954 -0.31542 -0.7615C7.79029 2.11346 7.51637 2 7.23076 2c-0.28562 0 -0.55954 0.11346 -0.7615 0.31542 -0.20059 0.20059 -0.31387 0.47216 -0.31541 0.75567l0.00002 0.00584v6.23076c0 0.55229 -0.44772 1.00001 -1 1.00001 -0.55229 0 -1 -0.44772 -1 -1.00001V3.08506l-0.00003 -0.00814c0 -0.28562 -0.11346 -0.55954 -0.31543 -0.7615C3.63645 2.11346 3.36254 2 3.07692 2Zm7.23078 5.81656 1.1442 -1.14422c0.7875 -0.78746 0.2298 -2.13389 -0.8839 -2.13389h-0.2603v3.27811Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac2"
);
var Zodiac3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.461 0a3.77 3.77 0 0 0 -3.769 3.77v4.666a2.846 2.846 0 1 0 2 2.702v-7.37a1.77 1.77 0 1 1 3.539 0v7.846a2.385 2.385 0 0 0 4.769 0 1 1 0 0 0 -2 0 0.385 0.385 0 0 1 -0.77 0V3.77A3.77 3.77 0 0 0 7.462 0ZM3.692 11.145v0.009l0 0.007a0.846 0.846 0 1 1 0 -0.016Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac3"
);
var Zodiac4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.759 2.357A1 1 0 1 0 0.24 3.659l2.123 2.474 0.001 0.001a1.923 1.923 0 0 0 2.808 0.116l0.005 -0.005L6.972 4.45l1.795 1.795 0.005 0.005a1.923 1.923 0 0 0 2.803 -0.11l2.176 -2.47a1 1 0 1 0 -1.502 -1.323l-2.13 2.42 -1.781 -1.78 -0.002 -0.002a1.923 1.923 0 0 0 -2.727 0L3.827 4.767 1.76 2.357Zm0 5.189A1 1 0 1 0 0.24 8.848l2.123 2.474 0.001 0a1.921 1.921 0 0 0 2.808 0.116l0.005 -0.005L6.972 9.64l1.795 1.794 0.005 0.005a1.922 1.922 0 0 0 2.803 -0.11l2.176 -2.47a1 1 0 1 0 -1.502 -1.322l-2.13 2.42 -1.781 -1.78 -0.002 -0.002a1.923 1.923 0 0 0 -2.727 0L3.827 9.956 1.76 7.546Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac4"
);
var Zodiac5 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.02001 1.10698C3.95634 0.558382 3.46 0.165263 2.91139 0.228929c-0.5486 0.063666 -0.94172 0.560008 -0.87805 1.108611 0.14136 1.2181 0.72543 2.34177 1.64115 3.15737 0.10849 0.09663 0.22075 0.18814 0.33638 0.27438C2.79024 5.68098 2 7.1371 2 8.7778c0 2.7614 2.23857 5 4.99999 5S12 11.5392 12 8.7778c0 -1.64069 -0.7903 -3.09682 -2.01088 -4.00851 0.11568 -0.08624 0.22788 -0.17775 0.33638 -0.27438 0.9157 -0.8156 1.4998 -1.93927 1.6412 -3.15737 0.0636 -0.548603 -0.3295 -1.044945 -0.8781 -1.108611s-1.0449 0.329453 -1.10861 0.878051c-0.08482 0.73086 -0.43526 1.40507 -0.98469 1.89442 -0.54943 0.48936 -1.25954 0.75975 -1.9953 0.75975s-1.44587 -0.27039 -1.9953 -0.75975c-0.54944 -0.48935 -0.89988 -1.16356 -0.98469 -1.89442ZM4 8.7778c0 -1.65685 1.34314 -3 2.99999 -3s3 1.34315 3 3c0 1.6568 -1.34315 3 -3 3S4 10.4346 4 8.7778Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac5"
);
var Zodiac6 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.217 0.024a1 1 0 0 0 -0.435 1.952l-0.001 0 -0.001 0 0.002 0 0.02 0.005 0.102 0.027a5.967 5.967 0 0 1 1.618 0.747c0.868 0.579 1.632 1.46 1.632 2.86a1 1 0 1 0 2 0c0 -1.4 0.763 -2.281 1.631 -2.86a5.52 5.52 0 0 1 0.523 -0.307v5.86H1a1 1 0 1 0 0 2h7.308v0.832l0 0.014a2.846 2.846 0 1 0 2.85 -2.846l-0.004 0h-0.846V1A1 1 0 0 0 9.09 0.024L9.308 1 9.09 0.024l-0.001 0 -0.002 0 -0.006 0.002 -0.015 0.004a3.498 3.498 0 0 0 -0.211 0.055 7.964 7.964 0 0 0 -2.178 1.006 6.088 6.088 0 0 0 -1.523 1.427A6.088 6.088 0 0 0 3.632 1.09 7.964 7.964 0 0 0 1.242 0.03L1.226 0.026 1.221 0.025l-0.002 0 -0.001 -0.001L1 1l0.217 -0.976Zm9.09 11.136 0 -0.006v-0.008a0.846 0.846 0 1 1 0 0.014Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac6"
);
var Zodiac7 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.106 0.553A1 1 0 0 1 1.447 0.106C3.065 0.914 5.605 3.164 7 7.019 8.395 3.164 10.935 0.914 12.553 0.106a1 1 0 1 1 0.894 1.788C11.771 2.733 8 6.195 8 13a1 1 0 1 1 -2 0C6 6.195 2.23 2.733 0.553 1.894A1 1 0 0 1 0.106 0.553Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac7"
);
var Zodiac8 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.886a4.692 4.692 0 0 0 -4.618 5.538H1a1 1 0 1 0 0 2h2.806a1 1 0 0 0 0.861 -1.508 2.59 2.59 0 0 1 -0.36 -1.332v-0.006a2.692 2.692 0 1 1 5.385 0l0 0.023a2.59 2.59 0 0 1 -0.332 1.333 1 1 0 0 0 0.87 1.49H13a1 1 0 1 0 0 -2h-1.37c0.047 -0.282 0.068 -0.569 0.062 -0.857A4.692 4.692 0 0 0 7 0.886Zm-6 9.72a1 1 0 1 0 0 2h12a1 1 0 0 0 0 -2H1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac8"
);
var Zodiac9 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.746 0.334A1 1 0 1 0 0.254 1.666 8.226 8.226 0 0 0 3.29 3.787c0.133 0.054 0.267 0.105 0.402 0.153v6.12a9.24 9.24 0 0 0 -0.402 0.153 8.226 8.226 0 0 0 -3.036 2.121 1 1 0 0 0 1.492 1.332 6.227 6.227 0 0 1 2.3 -1.602 7.105 7.105 0 0 1 2.92 -0.515l0.067 0a7.113 7.113 0 0 1 2.92 0.515c0.91 0.372 1.696 0.924 2.3 1.602a1 1 0 1 0 1.493 -1.332 8.226 8.226 0 0 0 -3.036 -2.121 8.698 8.698 0 0 0 -0.402 -0.153V3.94a9.24 9.24 0 0 0 0.402 -0.153 8.226 8.226 0 0 0 3.036 -2.121A1 1 0 0 0 12.254 0.334a6.228 6.228 0 0 1 -2.3 1.602c-0.91 0.371 -1.911 0.55 -2.92 0.515l-0.067 0a7.115 7.115 0 0 1 -2.92 -0.515 6.227 6.227 0 0 1 -2.3 -1.602Zm6.562 4.064A9.23 9.23 0 0 1 7 4.45a9.23 9.23 0 0 1 -1.308 -0.053v5.204c0.433 -0.048 0.87 -0.066 1.308 -0.053a9.23 9.23 0 0 1 1.308 0.053V4.398Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Zodiac9"
);
var ChatBubbleOvalSmiley1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.014 0.748a6.94 6.94 0 0 0 -8.932 9.876l-0.991 2.64a0.5 0.5 0 0 0 0.557 0.668l3.458 -0.626A6.94 6.94 0 0 0 10.014 0.748Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.438 4.969a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0ZM3.533 7.398a0.625 0.625 0 0 1 0.77 0.435c0.402 1.451 2.037 2.365 3.506 1.971 0.922 -0.343 1.65 -1.094 1.888 -1.968a0.625 0.625 0 0 1 1.206 0.328c-0.36 1.32 -1.422 2.363 -2.69 2.823a0.625 0.625 0 0 1 -0.046 0.015c-2.124 0.59 -4.475 -0.694 -5.07 -2.835a0.625 0.625 0 0 1 0.436 -0.77Zm5.78 -1.68a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChatBubbleOvalSmiley1"
);
var ChatBubbleOvalSmiley2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.014 0.748a6.94 6.94 0 0 0 -8.932 9.876l-0.991 2.64a0.5 0.5 0 0 0 0.557 0.668l3.458 -0.626A6.94 6.94 0 0 0 10.014 0.748Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4 4.563a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.469 4.563a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 11a3.5 3.5 0 0 0 3.5 -3.5h-7A3.5 3.5 0 0 0 7 11Z" }),
    " "
  ] }) }),
  "ChatBubbleOvalSmiley2"
);
var DesktopEmoji = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.635 10.577a0.5 0.5 0 0 1 0.47 -0.332h1.79a0.5 0.5 0 0 1 0.47 0.332l0.687 1.918H10a0.75 0.75 0 1 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.948l0.686 -1.918Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.457 0.5C0.652 0.5 0 1.152 0 1.957v7.586C0 10.348 0.652 11 1.457 11h11.086C13.348 11 14 10.348 14 9.543V1.957C14 1.152 13.348 0.5 12.543 0.5H1.457Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.016 4.003a0.766 0.766 0 1 1 -1.531 0 0.766 0.766 0 0 1 1.53 0ZM4.119 6.378a0.625 0.625 0 0 1 0.884 0.008c0.358 0.364 1.038 0.741 1.997 0.741 0.959 0 1.64 -0.377 1.998 -0.741a0.625 0.625 0 0 1 0.89 0.876C9.295 7.867 8.293 8.377 7 8.377c-1.292 0 -2.294 -0.51 -2.889 -1.115a0.625 0.625 0 0 1 0.008 -0.884Zm4.631 -1.61a0.766 0.766 0 1 0 0 -1.531 0.766 0.766 0 0 0 0 1.531Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DesktopEmoji"
);
var HappyFace = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.584 3.927a1.025 1.025 0 1 0 0 2.049l0.003 0a1.025 1.025 0 0 0 -0.003 -2.049Zm3.807 1.025a1.024 1.024 0 1 1 1.027 1.024l-0.002 0A1.025 1.025 0 0 1 8.39 4.952ZM4.19 7.76a0.625 0.625 0 0 0 -1.207 0.325 4.163 4.163 0 0 0 8.038 0 0.625 0.625 0 0 0 -1.207 -0.325 2.913 2.913 0 0 1 -5.624 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HappyFace"
);
var SadFace = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0C3.13401 0 0 3.13401 0 7c0 3.866 3.13401 7 7 7 3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.58559 3.927c0.56526 0.00066 1.02328 0.45909 1.02328 1.0245 0 0.56582 -0.45868 1.02451 -1.0245 1.02451L4.58195 5.976c-0.5647 -0.00131 -1.02207 -0.45949 -1.02207 -1.0245 0 -0.56581 0.45868 -1.0245 1.0245 -1.0245h0.00121Zm-1.16157 7.2146c0.33332 0.0897 0.67624 -0.1078 0.76594 -0.4411 0.3338 -1.24044 1.46707 -2.15263 2.81179 -2.15263 1.34472 0 2.47798 0.91219 2.81179 2.15263 0.08969 0.3333 0.43266 0.5308 0.76596 0.4411 0.3333 -0.0897 0.5308 -0.4326 0.4411 -0.766 -0.477 -1.77237 -2.09467 -3.07773 -4.01885 -3.07773 -1.92418 0 -3.54189 1.30536 -4.01885 3.07773 -0.0897 0.3334 0.1078 0.6763 0.44112 0.766ZM9.41563 3.927l-0.00001 0c-0.56582 0 -1.0245 0.45869 -1.0245 1.0245 0 0.56501 0.45737 1.0232 1.02208 1.0245 0.00081 0.00001 0.00162 0.00001 0.00243 0.00001 0.56582 0 1.02447 -0.45869 1.02447 -1.02451 0 -0.56581 -0.45865 -1.0245 -1.02447 -1.0245Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SadFace"
);
var SmileyAngry = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.809 2.58c0.255 -0.063 0.399 -0.14 0.45 -0.18a0.625 0.625 0 0 1 0.792 0.966c-0.26 0.213 -0.612 0.345 -0.941 0.427a4.698 4.698 0 0 1 -2.22 0c-0.329 -0.082 -0.68 -0.214 -0.94 -0.427a0.625 0.625 0 0 1 0.792 -0.967c0.05 0.042 0.195 0.118 0.45 0.18a3.45 3.45 0 0 0 1.617 0Zm1.206 6.697c0 -1.143 -0.865 -2.14 -2.013 -2.14 -1.15 0 -2.014 0.997 -2.014 2.14 0 1.143 0.865 2.14 2.014 2.14 1.148 0 2.013 -0.997 2.013 -2.14Zm0.399 -4.96a1.024 1.024 0 0 0 0.002 2.05l0.002 0a1.024 1.024 0 0 0 -0.002 -2.05l-0.002 0Zm-4.832 0a1.025 1.025 0 0 0 0.003 2.05l0.002 0a1.024 1.024 0 0 0 -0.002 -2.05l-0.003 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyAngry"
);
var SmileyCool = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.84 3.795h12.32c0.515 0 0.932 0.42 0.822 0.924 -0.288 1.318 -1.203 3.098 -3.436 3.098C7.737 7.817 7.014 5.001 7 3.83c-0.014 1.171 -0.737 3.987 -3.546 3.987C1.22 7.817 0.306 6.037 0.018 4.72c-0.11 -0.503 0.307 -0.924 0.822 -0.924Zm8.553 6.271a0.5 0.5 0 0 0 -0.759 -0.651 1.728 1.728 0 0 1 -0.69 0.481 1.403 1.403 0 0 1 -0.26 0.042 0.5 0.5 0 0 0 0.07 0.998 2.402 2.402 0 0 0 0.513 -0.094 2.73 2.73 0 0 0 1.126 -0.776Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyCool"
);
var SmileyCrying1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.377 3.907c0.204 -0.054 0.428 -0.09 0.617 -0.08a0.625 0.625 0 1 1 -0.061 1.248c-0.002 0 -0.025 0 -0.07 0.006a1.578 1.578 0 0 0 -0.54 0.184 1.578 1.578 0 0 0 -0.43 0.376 0.378 0.378 0 0 0 -0.04 0.058 0.625 0.625 0 1 1 -1.112 -0.571c0.086 -0.17 0.23 -0.345 0.378 -0.495 0.156 -0.156 0.354 -0.321 0.578 -0.45 0.225 -0.13 0.467 -0.22 0.68 -0.276Zm-0.474 6.228a0.625 0.625 0 0 0 0.766 -0.44 2.415 2.415 0 0 1 4.662 0 0.625 0.625 0 0 0 1.208 -0.326 3.665 3.665 0 0 0 -7.077 0 0.625 0.625 0 0 0 0.44 0.766Zm5.164 -5.06a1.433 1.433 0 0 1 0.237 0.04 1.6 1.6 0 0 1 0.373 0.15 1.579 1.579 0 0 1 0.47 0.434 0.625 0.625 0 0 0 1.112 -0.571 2.138 2.138 0 0 0 -0.378 -0.495 2.825 2.825 0 0 0 -0.579 -0.45 2.824 2.824 0 0 0 -0.679 -0.276 2.137 2.137 0 0 0 -0.617 -0.08 0.625 0.625 0 1 0 0.061 1.248Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyCrying1"
);
var SmileyCute = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.999 0a7 7 0 1 0 0 14 7 7 0 0 0 0 -14Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.936 5.408c0.063 -0.102 0.278 -0.24 0.543 -0.24s0.48 0.138 0.543 0.24a0.625 0.625 0 1 0 1.065 -0.655c-0.34 -0.553 -1.013 -0.835 -1.608 -0.835 -0.595 0 -1.267 0.282 -1.608 0.835a0.625 0.625 0 1 0 1.065 0.655Zm5.583 -0.24c0.265 0 0.48 0.138 0.543 0.24a0.625 0.625 0 1 0 1.065 -0.655c-0.34 -0.553 -1.013 -0.835 -1.608 -0.835 -0.595 0 -1.268 0.282 -1.608 0.835a0.625 0.625 0 1 0 1.065 0.655c0.063 -0.102 0.278 -0.24 0.543 -0.24ZM4.179 8.01c0.345 0 0.625 0.28 0.625 0.625a0.785 0.785 0 0 0 1.57 0 0.625 0.625 0 1 1 1.25 0 0.785 0.785 0 0 0 1.57 0 0.625 0.625 0 1 1 1.25 0 2.035 2.035 0 0 1 -3.445 1.468 2.035 2.035 0 0 1 -3.445 -1.467c0 -0.346 0.28 -0.626 0.625 -0.626Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyCute"
);
var SmileyDrool = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m8.869 4.733 0.02 0.001 0.06 0.006a1.698 1.698 0 0 1 0.582 0.198 1.698 1.698 0 0 1 0.509 0.472 0.625 0.625 0 1 0 1.112 -0.572 2.216 2.216 0 0 0 -0.393 -0.513 2.94 2.94 0 0 0 -0.603 -0.47 2.943 2.943 0 0 0 -0.708 -0.286 2.22 2.22 0 0 0 -0.64 -0.084 0.625 0.625 0 1 0 0.06 1.248ZM3.96 5.41l0.011 -0.018a1.545 1.545 0 0 1 0.157 -0.185c0.102 -0.103 0.223 -0.2 0.34 -0.269a1.698 1.698 0 0 1 0.642 -0.204l0.021 0a0.625 0.625 0 0 0 0.062 -1.25 2.22 2.22 0 0 0 -0.641 0.085 2.944 2.944 0 0 0 -0.708 0.287c-0.234 0.134 -0.44 0.306 -0.603 0.47a2.22 2.22 0 0 0 -0.393 0.512 0.625 0.625 0 1 0 1.112 0.572Zm5.82 4.289v1.77a1.231 1.231 0 0 1 -2.462 0v-0.602c-0.109 0.008 -0.22 0.012 -0.334 0.012 -1.285 0 -2.2 -0.517 -2.79 -1.173 -0.581 -0.646 -0.85 -1.43 -0.85 -1.983a0.25 0.25 0 0 1 0.25 -0.25h6.78a0.25 0.25 0 0 1 0.25 0.25c0 0.55 -0.267 1.33 -0.844 1.976Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyDrool"
);
var SmileyEmojiKissNervous = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.875 3.5a0.625 0.625 0 1 0 -0.75 1l1.191 0.893 -1.095 0.548a0.625 0.625 0 1 0 0.559 1.118l2 -1A0.625 0.625 0 0 0 5.875 5l-2 -1.5ZM11 3.625a0.625 0.625 0 0 1 -0.125 0.875l-1.191 0.893 1.096 0.548a0.625 0.625 0 1 1 -0.56 1.118l-2 -1A0.625 0.625 0 0 1 8.126 5l2 -1.5a0.625 0.625 0 0 1 0.875 0.125ZM6.702 7.181a0.625 0.625 0 0 1 0.743 -0.478l0.447 0.097c1.125 0.244 1.526 1.593 0.812 2.414 0.714 0.821 0.313 2.17 -0.812 2.414l-0.447 0.097a0.625 0.625 0 1 1 -0.265 -1.221l0.446 -0.097a0.233 0.233 0 0 0 0.098 -0.408l-0.369 -0.3a0.625 0.625 0 0 1 0 -0.97l0.369 -0.3a0.233 0.233 0 0 0 -0.098 -0.407l-0.446 -0.097a0.625 0.625 0 0 1 -0.478 -0.744Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyEmojiKissNervous"
);
var SmileyEmojiTerrified = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 3.625a0.625 0.625 0 0 1 0.875 -0.125l2 1.5a0.625 0.625 0 0 1 -0.095 1.059l-2 1a0.625 0.625 0 1 1 -0.56 -1.118l1.096 -0.548L3.125 4.5A0.625 0.625 0 0 1 3 3.625Zm8 0a0.625 0.625 0 0 1 -0.125 0.875l-1.191 0.893 1.096 0.548a0.625 0.625 0 0 1 -0.56 1.118l-2 -1A0.625 0.625 0 0 1 8.125 5l2 -1.5a0.625 0.625 0 0 1 0.875 0.125Zm-5.963 6.694a0.625 0.625 0 0 1 -1.074 -0.638L4.5 10l-0.537 -0.32 0 -0.001 0.002 -0.002 0.004 -0.007 0.014 -0.024a9.41 9.41 0 0 1 0.246 -0.386c0.162 -0.246 0.392 -0.577 0.656 -0.91 0.262 -0.33 0.573 -0.682 0.9 -0.957 0.302 -0.254 0.73 -0.541 1.215 -0.541 0.484 0 0.913 0.287 1.215 0.54 0.327 0.276 0.638 0.627 0.9 0.958a13.253 13.253 0 0 1 0.902 1.296l0.014 0.024 0.004 0.007 0.002 0.002L9.5 10l0.537 -0.32a0.625 0.625 0 0 1 -1.074 0.64l0 -0.001 -0.003 -0.004 -0.011 -0.019a12.268 12.268 0 0 0 -0.814 -1.17 5.57 5.57 0 0 0 -0.725 -0.776 1.614 1.614 0 0 0 -0.297 -0.206A0.352 0.352 0 0 0 7 8.103a0.352 0.352 0 0 0 -0.113 0.041c-0.08 0.04 -0.18 0.108 -0.297 0.206a5.543 5.543 0 0 0 -0.725 0.777 12.005 12.005 0 0 0 -0.814 1.17l-0.011 0.018 -0.002 0.004Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyEmojiTerrified"
);
var SmileyGrumpy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.94 4.408c0 -0.345 0.28 -0.625 0.626 -0.625h1.303c0.346 0 0.625 0.28 0.625 0.625v0.595a0.625 0.625 0 0 1 -1.249 0.03h-0.68a0.625 0.625 0 0 1 -0.624 -0.625Zm7.157 5.615a0.625 0.625 0 0 1 -0.766 -0.442 2.415 2.415 0 0 0 -4.662 0 0.625 0.625 0 1 1 -1.207 -0.324 3.665 3.665 0 0 1 7.077 0 0.625 0.625 0 0 1 -0.442 0.766Zm-0.967 -6.24a0.625 0.625 0 0 0 0 1.25h0.68a0.625 0.625 0 0 0 1.249 -0.03v-0.595a0.625 0.625 0 0 0 -0.625 -0.625H9.13Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyGrumpy"
);
var SmileyHappy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.58 5.976a1.025 1.025 0 0 1 0.004 -2.049l0.005 0a1.025 1.025 0 0 1 -0.005 2.049l-0.003 0Zm-0.987 1.997a0.25 0.25 0 0 0 -0.25 0.25c0 0.552 0.27 1.337 0.851 1.983 0.59 0.656 1.505 1.173 2.79 1.173 1.285 0 2.2 -0.517 2.79 -1.173 0.581 -0.646 0.85 -1.43 0.85 -1.983a0.25 0.25 0 0 0 -0.25 -0.25h-6.78Zm5.82 -1.997a1.025 1.025 0 1 1 0.003 0l-0.003 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyHappy"
);
var SmileyInLove = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.893 4.473c0.014 -0.933 1.061 -1.798 2.053 -0.58 0.993 -1.218 2.04 -0.353 2.054 0.58C6 5.86 4.34 7 3.946 7c-0.392 0 -2.053 -1.14 -2.053 -2.527Zm8.16 -0.58c0.993 -1.218 2.04 -0.353 2.054 0.58C12.107 5.86 10.447 7 10.054 7S8 5.86 8 4.473c0.014 -0.933 1.061 -1.798 2.053 -0.58Zm0.222 4.503a0.625 0.625 0 0 0 -0.766 0.441 2.6 2.6 0 0 1 -5.017 0 0.625 0.625 0 0 0 -1.207 0.325 3.85 3.85 0 0 0 7.431 0 0.625 0.625 0 0 0 -0.441 -0.766Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyInLove"
);
var SmileyKiss = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.56 4.676a1.024 1.024 0 1 1 1.024 1.025l-0.002 0A1.025 1.025 0 0 1 3.56 4.676Zm5.856 -1.024a1.024 1.024 0 0 1 0 2.049l-0.003 0a1.025 1.025 0 0 1 0.003 -2.049ZM7.364 6.39a0.625 0.625 0 1 0 -0.266 1.222l0.447 0.097c0.19 0.041 0.249 0.285 0.098 0.408l-0.37 0.3a0.625 0.625 0 0 0 0 0.97l0.37 0.3a0.233 0.233 0 0 1 -0.098 0.407l-0.447 0.097a0.625 0.625 0 0 0 0.266 1.222l0.446 -0.097c1.125 -0.245 1.526 -1.594 0.813 -2.414 0.713 -0.821 0.312 -2.17 -0.813 -2.415l-0.446 -0.097Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyKiss"
);
var SmileyLaughing3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.526 0.982a6.949 6.949 0 1 0 6.948 12.036A6.949 6.949 0 0 0 3.526 0.982Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.714 2.936a0.625 0.625 0 0 0 -1.226 -0.246l-0.4 1.995a0.625 0.625 0 0 0 0.925 0.664l1.441 -0.832a0.625 0.625 0 0 0 -0.625 -1.082l-0.244 0.14 0.129 -0.639Zm-5.69 2.332a0.625 0.625 0 1 0 -0.4 1.184l0.617 0.209 -0.243 0.14a0.625 0.625 0 0 0 0.625 1.083l1.44 -0.832a0.625 0.625 0 0 0 -0.112 -1.133l-1.928 -0.651Zm1.184 4.628a0.5 0.5 0 0 1 0.183 -0.683l5.83 -3.366a0.5 0.5 0 0 1 0.683 0.183c0.309 0.534 0.472 1.407 0.281 2.306 -0.196 0.923 -0.767 1.883 -1.936 2.558 -1.17 0.675 -2.287 0.69 -3.184 0.398 -0.874 -0.284 -1.548 -0.862 -1.857 -1.396Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyLaughing3"
);
var SmileyMask = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 0C3.13401 0 0 3.13401 0 7c0 3.866 3.13401 7 7 7 3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.9448 6.11635c-0.389 0.22833 -1.2138 0.61755 -2.3245 0.97637 -1.3127 0.42411 -2.95418 0.78224 -4.62032 0.78224 -1.66615 0 -3.30764 -0.35813 -4.62036 -0.78224 -1.1106 -0.35881 -1.9354 -0.74801 -2.3243891 -0.97633C0.0187817 6.40578 0 6.70067 0 6.99995c0 0.17024 0.00607668 0.33905 0.018025 0.50624 0.521274 0.24935 1.202195 0.52558 1.977305 0.776 0.46359 0.14977 0.96906 0.29303 1.50465 0.41759v4.36372c0.95284 0.5512 2.04767 0.8842 3.21619 0.9308 0.08262 0.0032 0.16344 0.005 0.24207 0.0055C6.97215 13.9999 6.98607 14 7 14c0.01203 0 0.02406 -0.0001 0.03608 -0.0001 0.08089 -0.0005 0.16412 -0.0024 0.24926 -0.0057 1.16793 -0.0468 2.26221 -0.3798 3.21466 -0.9307V8.69978c0.5356 -0.12456 1.041 -0.26782 1.5046 -0.41759 0.7752 -0.25043 1.4561 -0.52667 1.9774 -0.77602 0.0119 -0.16719 0.018 -0.33599 0.018 -0.50622 0 -0.29929 -0.0188 -0.59419 -0.0552 -0.8836ZM9.13739 4.54356c-0.04509 -0.00624 -0.06793 -0.00624 -0.07043 -0.00624l-0.00021 0c-0.34476 0.01691 -0.63796 -0.24887 -0.65487 -0.59363 -0.01691 -0.34477 0.24887 -0.63796 0.59363 -0.65487 0.18937 -0.00929 0.41357 0.02659 0.61768 0.08056 0.21311 0.05634 0.45501 0.14578 0.67931 0.27528 0.2243 0.1295 0.4227 0.29427 0.5781 0.45066 0.1487 0.14977 0.2919 0.326 0.3786 0.49464 0.1577 0.30703 0.0367 0.6838 -0.2704 0.84153 -0.307 0.15774 -0.6838 0.03671 -0.8415 -0.27032l0 -0.00008 -0.0001 -0.00009c-0.0012 -0.00217 -0.0127 -0.02195 -0.0406 -0.05788 -0.0283 -0.0364 -0.0664 -0.08013 -0.11285 -0.12685 -0.09492 -0.09555 -0.20714 -0.18608 -0.31625 -0.24907 -0.10912 -0.063 -0.24363 -0.11493 -0.37383 -0.14935 -0.06367 -0.01684 -0.1206 -0.02796 -0.16628 -0.03429ZM4.3768 3.37075c0.2041 -0.05397 0.42831 -0.08985 0.61767 -0.08056 0.34477 0.01691 0.61054 0.31011 0.59363 0.65487 -0.01691 0.34476 -0.31011 0.61054 -0.65487 0.59363l-0.0002 0c-0.0025 0 -0.02535 0 -0.07044 0.00625 -0.04568 0.00632 -0.1026 0.01745 -0.16627 0.03428 -0.1302 0.03443 -0.26471 0.08635 -0.37383 0.14935 -0.10912 0.063 -0.22134 0.15352 -0.31625 0.24907 -0.04642 0.04672 -0.08451 0.09046 -0.11283 0.12686 -0.02795 0.03592 -0.03938 0.05571 -0.04063 0.05787l-0.00007 0.00014c-0.00005 0.00007 -0.00005 0.00008 -0.00003 0.00004 -0.15774 0.30703 -0.5345 0.42805 -0.84153 0.27032 -0.30703 -0.15774 -0.42806 -0.53451 -0.27032 -0.84154 0.08664 -0.16864 0.22981 -0.34486 0.3786 -0.49464 0.15535 -0.15639 0.35376 -0.32115 0.57806 -0.45065s0.46619 -0.21894 0.67931 -0.27529Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyMask"
);
var SmileyNauseas = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.586 3.952a1.024 1.024 0 0 1 -0.002 2.05l-0.002 0a1.024 1.024 0 0 1 0.002 -2.05h0.002ZM3.26 7.936a0.625 0.625 0 0 1 0.822 -0.324c0.346 0.15 0.61 0.37 0.803 0.631a3.625 3.625 0 0 1 2.127 -0.683c0.896 0 1.613 0.316 2.11 0.67 0.192 -0.256 0.454 -0.47 0.794 -0.618a0.625 0.625 0 1 1 0.498 1.146c-0.37 0.16 -0.6 0.65 -0.364 1.297a0.625 0.625 0 1 1 -1.174 0.429 2.725 2.725 0 0 1 -0.166 -0.964c-0.226 -0.251 -0.824 -0.71 -1.698 -0.71 -0.91 0 -1.522 0.499 -1.724 0.741 0 0.317 -0.058 0.637 -0.166 0.933a0.625 0.625 0 0 1 -1.174 -0.43c0.236 -0.646 0.006 -1.135 -0.364 -1.296a0.625 0.625 0 0 1 -0.324 -0.822Zm6.155 -3.984a1.025 1.025 0 0 0 -0.003 2.05l0.003 0a1.024 1.024 0 0 0 0 -2.05Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyNauseas"
);
var SmileySmirk = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.56 4.676a1.024 1.024 0 1 1 1.024 1.025l-0.002 0A1.025 1.025 0 0 1 3.56 4.676Zm5.856 -1.024a1.024 1.024 0 0 1 0 2.049l-0.003 0a1.025 1.025 0 0 1 0.003 -2.049ZM8.05 9.832a0.8 0.8 0 0 0 0.32 -0.067 2.056 2.056 0 0 0 0.928 -0.71c0.112 -0.156 0.144 -0.26 0.148 -0.291a0.625 0.625 0 0 1 1.24 0.16c-0.041 0.318 -0.2 0.618 -0.372 0.859a3.308 3.308 0 0 1 -1.507 1.153c-0.278 0.104 -0.609 0.178 -0.926 0.134a0.625 0.625 0 0 1 0.17 -1.238Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileySmirk"
);
var SmileySparks = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.515 3.078c0.345 0 0.625 0.28 0.625 0.625v0.492h0.49a0.625 0.625 0 0 1 0 1.25h-0.49v0.49a0.625 0.625 0 1 1 -1.25 0v-0.49h-0.492a0.625 0.625 0 1 1 0 -1.25h0.492v-0.492c0 -0.345 0.28 -0.625 0.625 -0.625Zm4.97 0a0.625 0.625 0 0 0 -0.625 0.626v0.491h-0.49a0.625 0.625 0 0 0 0 1.25h0.49v0.49a0.625 0.625 0 0 0 1.25 0v-0.49h0.492a0.625 0.625 0 1 0 0 -1.25h-0.492v-0.491a0.625 0.625 0 0 0 -0.625 -0.625Zm0.906 4.69a0.5 0.5 0 0 1 0.5 0.5c0 0.62 -0.297 1.463 -0.916 2.15 -0.635 0.707 -1.616 1.256 -2.975 1.256 -1.36 0 -2.34 -0.55 -2.975 -1.255 -0.619 -0.688 -0.916 -1.53 -0.916 -2.151a0.5 0.5 0 0 1 0.5 -0.5h6.782Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileySparks"
);
var SmileySurprised = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.999 0a7 7 0 1 0 0 14 7 7 0 0 0 0 -14Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.58 5.976a1.025 1.025 0 0 1 0.003 -2.049l0.005 0a1.025 1.025 0 0 1 -0.005 2.049l-0.003 0Zm2.419 0.747c-1.19 0 -2.013 1.115 -2.013 2.3 0 1.185 0.823 2.3 2.013 2.3s2.013 -1.115 2.013 -2.3c0 -1.185 -0.824 -2.3 -2.013 -2.3Zm2.413 -0.747a1.025 1.025 0 0 1 0.003 -2.049l0.002 0a1.024 1.024 0 0 1 -0.002 2.049l-0.003 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileySurprised"
);
var SmileyThrowUp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.394 3.535a0.625 0.625 0 1 0 -1.04 0.694l0.46 0.69H2.766a0.625 0.625 0 1 0 0 1.25h2.216a0.625 0.625 0 0 0 0.52 -0.972L4.394 3.535Zm6.079 -0.173a0.625 0.625 0 0 0 -0.867 0.173L8.498 5.197a0.625 0.625 0 0 0 0.52 0.972h2.216a0.625 0.625 0 1 0 0 -1.25h-1.048l0.46 -0.69a0.625 0.625 0 0 0 -0.174 -0.867Zm-0.511 7.482C10.15 8.867 7.99 8.524 7 8.524c-0.986 0 -3.13 0.34 -2.964 2.293 0.018 0.217 0.222 0.37 0.453 0.37h0.664c-0.003 0.688 -0.654 1.1 -1.218 1.458 -0.432 0.273 -0.813 0.514 -0.813 0.822 0 0 0.167 0.533 3.878 0.533 3.71 0 3.878 -0.533 3.878 -0.533 0 -0.308 -0.381 -0.549 -0.813 -0.822 -0.564 -0.358 -1.215 -0.77 -1.218 -1.457h0.714a0.393 0.393 0 0 0 0.4 -0.345Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyThrowUp"
);
var SmileyVeryShocked = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.15 1.522C3.421 0.53 5.144 0.048 7 0.048c1.854 0 3.578 0.483 4.85 1.474 1.287 1.002 2.075 2.498 2.075 4.423 0 0.578 -0.05 1.055 -0.147 1.46a1.771 1.771 0 0 0 -1.262 -0.286c-0.843 0.122 -1.545 0.785 -2.141 1.778 -0.974 1.623 -1.17 3.344 -1.12 4.468 -0.568 0.344 -1.292 0.534 -2.255 0.534 -0.963 0 -1.687 -0.19 -2.256 -0.534 0.052 -1.123 -0.145 -2.844 -1.119 -4.468 -0.596 -0.993 -1.298 -1.656 -2.14 -1.778a1.771 1.771 0 0 0 -1.263 0.285C0.125 7 0.075 6.524 0.075 5.945c0 -1.925 0.788 -3.421 2.074 -4.423ZM0.047 13.952c0.302 -0.455 0.817 -1.727 0.454 -3.18C0.138 9.316 0.35 8.65 0.502 8.498c0.303 -0.454 1.181 -0.908 2.272 0.91 1.09 1.816 1.06 3.785 0.908 4.543l-3.634 0Zm13.45 -3.18c-0.363 1.453 0.152 2.725 0.454 3.18l-3.634 0c-0.152 -0.758 -0.182 -2.726 0.908 -4.544 1.09 -1.817 1.97 -1.363 2.272 -0.909 0.152 0.152 0.364 0.818 0 2.272Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6 4.5C6 5.88 5.105 7 4 7S2 5.88 2 4.5 2.895 2 4 2s2 1.12 2 2.5Zm1 2.843a0.75 0.75 0 0 1 0.75 0.75v1.751a0.75 0.75 0 1 1 -1.5 0V8.093a0.75 0.75 0 0 1 0.75 -0.75ZM10 7C8.895 7 8 5.88 8 4.5S8.895 2 10 2s2 1.12 2 2.5S11.105 7 10 7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SmileyVeryShocked"
);
var StraightFace = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.56 4.952c0 -0.565 0.456 -1.023 1.02 -1.025l0.004 0a1.025 1.025 0 0 1 0.004 2.049l-0.004 0A1.025 1.025 0 0 1 3.56 4.952Zm5.856 1.024 0.002 0a1.024 1.024 0 0 0 -0.002 -2.049l-0.003 0a1.025 1.025 0 0 0 0.003 2.049ZM9.452 8.7a0.625 0.625 0 1 1 0 1.25H4.548a0.625 0.625 0 0 1 0 -1.25h4.904Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "StraightFace"
);
var CursorClick = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.471 5.72a1 1 0 0 1 1.265 -1.265l7.12 2.375c0.92 0.307 0.908 1.612 -0.018 1.902l-2.026 0.637 2.7 2.7a1 1 0 0 1 -1.415 1.414l-2.706 -2.707 -0.642 2.046c-0.29 0.925 -1.596 0.937 -1.903 0.017l-2.375 -7.12Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.658 0.162a0.75 0.75 0 0 1 0.918 0.53l0.449 1.673a0.75 0.75 0 1 1 -1.45 0.389L3.129 1.08a0.75 0.75 0 0 1 0.53 -0.919ZM0.602 4.673A0.75 0.75 0 0 1 0.99 3.224l1.673 0.449a0.75 0.75 0 1 1 -0.388 1.448L0.602 4.673Zm1.465 4.082a0.75 0.75 0 1 1 -1.061 -1.06L2.231 6.47a0.75 0.75 0 0 1 1.06 1.06L2.067 8.755Zm6.46 -6.591a0.75 0.75 0 0 0 -1.06 -1.061L6.24 2.328a0.75 0.75 0 0 0 1.061 1.06l1.225 -1.224Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CursorClick"
);
var Fist = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.25006 0C6.34605 0 5.6132 0.73285 5.6132 1.63687v0.63917C5.52659 1.31833 4.6718 0.566406 3.63009 0.566406c-1.09922 0 -1.99032 0.837254 -1.99032 1.870054v2.105c0 0.22044 0.04059 0.43196 0.11514 0.62834 -0.64703 0.3722 -0.798876 1.28042 -0.798916 2.15826C0.955932 8.64808 1.89558 10.5845 3.29473 11.07v2.43c0 0.2762 0.22385 0.5 0.49998 0.5l6.40659 0.0003c0.2762 0 0.5 -0.2239 0.5 -0.5V10.826S13.04 9.8905 13.04 7.08407V6.04983c0 -0.26444 -0.1133 -0.75369 -0.2514 -1.00975 0.0467 -0.15874 0.0716 -0.32595 0.0716 -0.49862v-2.105c0 -1.0328 -0.8925 -1.870054 -1.9935 -1.870054 -1.02145 0 -1.86349 0.720704 -1.97977 1.649624v-0.57916C8.88693 0.73285 8.15408 0 7.25006 0Zm-1.5486 4.44864c-0.04116 -0.11993 -0.06879 -0.24615 -0.08104 -0.37684v0.39058l0.08104 -0.01374Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.87899 2.29178c0.05138 -0.63504 0.44087 -1.18147 1 -1.481233V4.64512c0 0.9317 0.45301 1.54681 1.38471 1.54681 0.7406 0 1.3244 -0.50526 1.5327 -1.1805l-0.008 0.02814c0.1382 0.25597 0.2516 0.74552 0.2516 1.01006v0.42209c-0.4606 0.44528 -1.0796 0.72021 -1.7763 0.72021 -0.9081 0 -1.40871 -0.3103 -1.8951 -1 -0.81763 1.14985 -1.80216 1.61286 -2.60185 1.73427l-0.05816 0.01764c0.05169 0.0418 0.10205 0.08505 0.15095 0.12965 0.56209 0.51262 0.99393 1.26248 0.975 2.14561 -0.0074 0.3451 -0.29315 0.6189 -0.63825 0.6115 -0.3451 -0.0074 -0.61886 -0.2931 -0.61146 -0.6382 0.00946 -0.44156 -0.20585 -0.86541 -0.5676 -1.19532 -0.36807 -0.33568 -0.82343 -0.51375 -1.1802 -0.51375 -0.30976 0 -0.57279 -0.2269 -0.61824 -0.53331 -0.04544 -0.30642 0.14042 -0.59989 0.43685 -0.68979L6.76336 6.621c0.31363 -0.09511 0.52807 -0.38424 0.52807 -0.71197 0 -0.41106 -0.33298 -0.74399 -0.74371 -0.74399H1.74626c-0.06896 -0.19504 -0.10649 -0.40493 -0.10649 -0.62358v-0.62642h2.99316V0.82303c0.58736 0.32493 0.98161 0.92576 0.98161 1.61324v1.47877h0.93318c0.97922 0 1.79313 0.70576 1.96169 1.6361 0.22151 -0.32625 0.36958 -0.65014 0.36958 -0.90602V2.29178Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Fist"
);
var GiveGift = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.843 7H0v4l1.828 1.828A4 4 0 0 0 4.657 14H10.5a1.5 1.5 0 0 0 0 -3h-3L4.672 8.172A4 4 0 0 0 1.843 7Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.255 9.754a0.86 0.86 0 0 1 -1.326 1.082l-1.45 -1.45a0.625 0.625 0 1 0 -0.884 0.884l1.45 1.45A2.11 2.11 0 0 0 7.502 11H7.5L6.255 9.753Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.03 0.22a0.75 0.75 0 1 0 -1.06 1.06l0.72 0.72H6.5a0.5 0.5 0 0 0 -0.5 0.5v5a0.5 0.5 0 0 0 0.5 0.5h7a0.5 0.5 0 0 0 0.5 -0.5v-5a0.5 0.5 0 0 0 -0.5 -0.5h-2.19l0.72 -0.72A0.75 0.75 0 0 0 10.97 0.22l-0.97 0.97 -0.97 -0.97Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.375 8V2h1.25v6h-1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GiveGift"
);
var HandCursor = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.784 6.063a2.154 2.154 0 0 1 1.712 2.412l-0.657 4.599a1.077 1.077 0 0 1 -1.077 0.926H3.784a1.076 1.076 0 0 1 -1.002 -0.678L1.63 10.457a2.154 2.154 0 0 1 1.077 -2.725L4.16 7V1.615a1.615 1.615 0 1 1 3.23 0v3.77l3.393 0.678Z" }),
    " "
  ] }) }),
  "HandCursor"
);
var HandGrab = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.80893 0.0696891C5.25506 -0.257441 3.79391 0.928133 3.79391 2.51606v0.92225l-1.5333 0.4488 -0.023 0.00673 -0.02224 0.0089C1.09642 4.35032 0.456046 5.53248 0.692394 6.71422l0.530856 2.6543c0.11536 0.57678 0.4304 1.09438 0.88971 1.46188l1.74346 1.3948v1.2597c0 0.2761 0.22386 0.5 0.5 0.5h6.99998c0.2762 0 0.5 -0.2239 0.5 -0.5v-1.382l0.3915 -0.783c0.729 -1.45797 1.1085 -3.06567 1.1085 -4.69574V3.60762c0 -1.17981 -0.8247 -2.19867 -1.9779 -2.44487L6.82227 0.0726872l0.00004 -0.0001817 -0.01338 -0.0028164Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.54395 3.80419v2.27438c0 0.34518 0.27982 0.625 0.625 0.625 0.34517 0 0.625 -0.27982 0.625 -0.625l0 -3.5815c-0.00005 0.00633 -0.00007 0.01267 -0.00007 0.01901v0.92225l-1.24993 0.36586Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HandGrab"
);
var HandHeldTabletDrawing = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.887 0.094c-0.944 0 -1.663 0.785 -1.663 1.697v10.418c0 0.912 0.72 1.697 1.663 1.697h8.225c0.944 0 1.664 -0.785 1.664 -1.697V1.844a1.75 1.75 0 0 0 -1.75 -1.75H2.887Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.974 10.25h-0.75l0 0.75 0 1.21c0 0.911 0.72 1.696 1.663 1.696h8.226c0.944 0 1.663 -0.785 1.663 -1.697l0 -1.209 0 -0.75H1.974Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.482 3.515c-0.292 0.158 -0.61 0.478 -0.84 0.805a0.625 0.625 0 0 1 -1.021 -0.722c0.294 -0.415 0.744 -0.9 1.266 -1.182 0.264 -0.143 0.585 -0.255 0.934 -0.243 0.368 0.013 0.712 0.162 0.997 0.446 0.493 0.494 0.38 1.141 0.235 1.56 -0.144 0.42 -0.406 0.87 -0.626 1.249l-0.029 0.05c-0.248 0.427 -0.434 0.758 -0.512 1.014a0.939 0.939 0 0 0 -0.02 0.073 0.946 0.946 0 0 0 0.237 -0.123c0.282 -0.19 0.598 -0.51 0.973 -0.896L7.12 5.5c0.336 -0.347 0.726 -0.749 1.11 -1.014 0.382 -0.264 1.015 -0.562 1.635 -0.149 0.228 0.152 0.408 0.355 0.504 0.616 0.093 0.254 0.083 0.502 0.04 0.707 -0.067 0.33 -0.25 0.672 -0.382 0.917l-0.045 0.085c-0.163 0.308 -0.241 0.493 -0.253 0.625 -0.004 0.046 0.004 0.064 0.008 0.072 0.006 0.011 0.03 0.056 0.128 0.121a0.625 0.625 0 1 1 -0.693 1.04 1.576 1.576 0 0 1 -0.554 -0.604 1.37 1.37 0 0 1 -0.134 -0.734c0.036 -0.427 0.25 -0.833 0.393 -1.105l0.026 -0.047c0.16 -0.305 0.253 -0.48 0.282 -0.621a0.353 0.353 0 0 0 0.004 -0.02l-0.003 -0.002a0.79 0.79 0 0 0 -0.246 0.127c-0.276 0.191 -0.588 0.512 -0.966 0.902l-0.011 0.011c-0.346 0.357 -0.754 0.778 -1.163 1.052 -0.401 0.27 -1.03 0.544 -1.655 0.152a1.117 1.117 0 0 1 -0.515 -0.74 1.579 1.579 0 0 1 0.06 -0.763c0.127 -0.416 0.393 -0.875 0.615 -1.256l0.012 -0.022c0.247 -0.425 0.452 -0.78 0.554 -1.077a0.768 0.768 0 0 0 0.055 -0.277c-0.066 -0.064 -0.112 -0.072 -0.148 -0.074a0.614 0.614 0 0 0 -0.296 0.093Zm0.331 3.06 -0.002 -0.001 0.002 0.001Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HandHeldTabletDrawing"
);
var HandHeldTabletWriting = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.867 0.094C0.923 0.094 0.203 0.879 0.203 1.79v10.418c0 0.912 0.72 1.697 1.664 1.697h8.225c0.944 0 1.664 -0.785 1.664 -1.697V1.844a1.75 1.75 0 0 0 -1.75 -1.75H1.867Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.953 10.25h-0.75l0 0.75 0 1.21c0 0.911 0.72 1.696 1.664 1.696h8.225c0.944 0 1.664 -0.785 1.664 -1.697l0 -1.209 0 -0.75H0.953Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.828 3.007a0.625 0.625 0 0 0 0 1.25h2.495a0.625 0.625 0 1 0 0 -1.25H2.828Zm0 2.868a0.625 0.625 0 0 0 0 1.25h1.248a0.625 0.625 0 1 0 0 -1.25H2.828Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.402 7.394a0.5 0.5 0 0 1 -0.266 0.14l-2.148 0.386a0.5 0.5 0 0 1 -0.582 -0.573l0.359 -2.182a0.5 0.5 0 0 1 0.14 -0.273L11.021 0.796a1 1 0 0 1 1.42 0l1.06 1.06a1 1 0 0 1 0 1.42L9.402 7.394Z" }),
    " "
  ] }) }),
  "HandHeldTabletWriting"
);
var HandHeld = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.702 0.042C1.761 0.042 0.997 0.806 0.997 1.747v10.505c0 0.942 0.764 1.706 1.705 1.706h8.596c0.941 0 1.704 -0.764 1.704 -1.706V1.747c0 -0.941 -0.763 -1.705 -1.705 -1.705H2.702Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0.997 12.252c0 0.942 0.764 1.706 1.705 1.706h8.596c0.941 0 1.704 -0.764 1.704 -1.706V10.5H0.997v1.752Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.862 2.886a0.75 0.75 0 0 1 0.75 -0.75h4.776a0.75 0.75 0 0 1 0 1.5H4.612a0.75 0.75 0 0 1 -0.75 -0.75Zm0 2.624a0.75 0.75 0 0 1 0.75 -0.75h4.776a0.75 0.75 0 0 1 0 1.5H4.612a0.75 0.75 0 0 1 -0.75 -0.75Zm0.75 1.874a0.75 0.75 0 1 0 0 1.5h2.866a0.75 0.75 0 1 0 0 -1.5H4.612Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HandHeld"
);
var InsuranceHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.315 1.031a0.5 0.5 0 0 0 -0.5 0.5v1.407l-1.406 0a0.5 0.5 0 0 0 -0.5 0.5v1.625a0.5 0.5 0 0 0 0.5 0.5h1.406v1.406a0.5 0.5 0 0 0 0.5 0.5H9.94a0.5 0.5 0 0 0 0.5 -0.5V5.563h1.406a0.5 0.5 0 0 0 0.5 -0.5V3.438a0.5 0.5 0 0 0 -0.5 -0.5l-1.406 0V1.53a0.5 0.5 0 0 0 -0.5 -0.5H8.315Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.843 6.906H0v4l1.828 1.829a4 4 0 0 0 2.829 1.171H10.5a1.5 1.5 0 1 0 0 -3h-3L4.672 8.078a4 4 0 0 0 -2.829 -1.172Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.402 9.812a0.86 0.86 0 0 1 -1.44 0.827l-1.45 -1.45a0.625 0.625 0 1 0 -0.884 0.884l1.45 1.45a2.11 2.11 0 0 0 3.414 -0.62l-1.09 -1.09Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InsuranceHand"
);
var Like1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 12.5a1 1 0 0 1 -1 -1l0 -5a1 1 0 0 1 1 -1l4.5 0A0.5 0.5 0 0 1 6 6l0 6a0.5 0.5 0 0 1 -0.5 0.5l-4.5 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.486 13.204a2.5 2.5 0 0 1 -1.075 -0.243l-0.2 -0.095a1.5 1.5 0 0 1 -0.854 -1.354l0 -5.442a1.5 1.5 0 0 1 0.19 -0.733l2.078 -3.71a1.625 1.625 0 0 1 3.044 0.794l0 2.357 3.283 0a2 2 0 0 1 1.976 2.31l-0.626 4.003a2.5 2.5 0 0 1 -2.47 2.113l-5.346 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Like1"
);
var OkHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.3375 0.0138496C2.69547 0.103741 2.19816 0.617204 2.1622 1.2645c-0.17932 3.22798 0.04754 8.11244 2.70248 10.526l1.47226 -2.42414C4.83929 6.73914 4.93778 4.96227 4.93778 2.04042l0 -0.79853C4.8411 0.457358 4.12033 -0.0957546 3.3375 0.0138496Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.93768 2.21051c-0.00013 0.11455 -0.00036 0.22735 -0.00059 0.33853 -0.00538 2.62716 -0.0089 4.34603 1.39985 6.81731L4.86468 11.7905c-1.22011 -1.1092 -1.92741 -2.74021 -2.31816 -4.49248 0.25963 -1.03309 0.7302 -2.09092 1.20501 -3.01161 0.38518 -0.74688 0.8038 -1.46024 1.18615 -2.0759Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.1146 9.98204c0.1833 -0.04231 0.36 -0.12616 0.5157 -0.25301 0.544 -0.44318 0.5856 -1.45212 0.1424 -1.99611 -0.80145 -0.98378 -1.99219 -1.46362 -3.16913 -1.39834L9.18816 3.0435c0.31602 -0.72455 -0.02296 -1.56748 -0.75262 -1.8715 -0.59843 -0.24935 -1.28783 -0.06042 -1.64818 0.4785 -0.99108 1.48214 -3.07804 4.75225 -3.19155 6.96517 -0.11478 2.23773 -0.06107 4.09083 -0.02436 4.91863 0.01166 0.2629 0.22885 0.4656 0.49202 0.4656l4.7453 0c0.0974 0 0.19457 -0.0133 0.2867 -0.0449 0.4141 -0.1421 0.81057 -0.3585 1.16983 -0.6511 0.5392 -0.4393 0.929 -0.9987 1.1589 -1.609 0.2474 -0.6566 -0.0844 -1.3894 -0.741 -1.6368 -0.1877 -0.07065 -0.3816 -0.09404 -0.5686 -0.07606ZM6.97817 11.1188c-0.44318 -0.544 -0.36146 -1.34428 0.18253 -1.78746 0.544 -0.44318 1.34426 -0.36145 1.78744 0.18254 0.27887 0.3423 0.69912 0.50152 1.10796 0.4622 -0.40051 0.09242 -0.74873 0.37702 -0.90448 0.79052 -0.07594 0.2016 -0.20411 0.3865 -0.38602 0.5347 -0.54399 0.4432 -1.34425 0.3615 -1.78743 -0.1825Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OkHand"
);
var OneFingerDragHorizontal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.907 3.799 0.947 5.86 -0.52 0.188a1.715 1.715 0 0 0 -0.658 2.8l1 1.044a1 1 0 0 0 0.722 0.31h6.482a1 1 0 0 0 0.994 -1.113l-0.367 -3.237a2.573 2.573 0 0 0 -2.951 -2.13l-2.432 0.394 -0.73 -4.518a1.26 1.26 0 0 0 -2.487 0.402Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.191 0.038A0.5 0.5 0 0 1 2.5 0.5v1h1a0.5 0.5 0 0 1 0 1h-1v1a0.5 0.5 0 0 1 -0.854 0.354l-1.5 -1.5a0.5 0.5 0 0 1 0 -0.708l1.5 -1.5a0.5 0.5 0 0 1 0.545 -0.108Zm8.118 0a0.5 0.5 0 0 1 0.545 0.108l1.5 1.5a0.5 0.5 0 0 1 0 0.708l-1.5 1.5A0.5 0.5 0 0 1 10 3.5v-1H9a0.5 0.5 0 1 1 0 -1h1v-1a0.5 0.5 0 0 1 0.309 -0.462Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OneFingerDragHorizontal"
);
var OneFingerDragVertical = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m5.944 3.76 0 5.936 -0.543 0.102a1.715 1.715 0 0 0 -1.096 2.659l0.764 1.11a1 1 0 0 0 0.824 0.433l6.607 0a1 1 0 0 0 1 -1l0 -2.09a2.573 2.573 0 0 0 -2.573 -2.574l-2.464 0 0 -4.577a1.26 1.26 0 0 0 -2.519 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 0a0.5 0.5 0 0 1 0.354 0.146l1.5 1.5A0.5 0.5 0 0 1 3.5 2.5h-0.75v2h0.75a0.5 0.5 0 0 1 0.354 0.854l-1.5 1.5a0.5 0.5 0 0 1 -0.708 0l-1.5 -1.5A0.5 0.5 0 0 1 0.5 4.5h0.75v-2H0.5a0.5 0.5 0 0 1 -0.354 -0.854l1.5 -1.5A0.5 0.5 0 0 1 2 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OneFingerDragVertical"
);
var OneFingerHold = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.5 4.196a2.696 2.696 0 0 1 3.95 -2.387 0.75 0.75 0 1 0 0.7 -1.327A4.196 4.196 0 0 0 0.11 5.15a0.75 0.75 0 1 0 1.46 -0.34 2.706 2.706 0 0 1 -0.07 -0.614ZM10.5 7a3.5 3.5 0 1 0 0 -7 3.5 3.5 0 0 0 0 7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m3.133 4.26 0 5.436 -0.543 0.102a1.715 1.715 0 0 0 -1.096 2.659l0.764 1.11A1 1 0 0 0 3.08 14l6.608 0a1 1 0 0 0 1 -1l0 -2.09a2.573 2.573 0 0 0 -2.573 -2.574l-2.464 0 0 -4.077a1.26 1.26 0 0 0 -2.519 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.942 2.058a0.625 0.625 0 0 1 0 0.884l-1 1a0.625 0.625 0 1 1 -0.884 -0.884l1 -1a0.625 0.625 0 0 1 0.884 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OneFingerHold"
);
var OneFingerTap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.883 4.26 0 5.436 -0.543 0.102a1.715 1.715 0 0 0 -1.096 2.659l0.764 1.11A1 1 0 0 0 4.83 14l6.608 0a1 1 0 0 0 1 -1l0 -2.09a2.573 2.573 0 0 0 -2.573 -2.574l-2.464 0 0 -4.077a1.26 1.26 0 0 0 -2.519 0Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.115 1.5a2.861 2.861 0 0 0 -2.787 3.512 0.75 0.75 0 0 1 -1.461 0.34 4.361 4.361 0 1 1 8.495 0 0.75 0.75 0 1 1 -1.46 -0.34A2.861 2.861 0 0 0 6.114 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OneFingerTap"
);
var PeaceHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.203 5.903c2.464 0.478 4.691 1.32 4.355 3.37 -0.183 1.116 -0.289 2.932 -1.61 4.432a0.909 0.909 0 0 1 -0.688 0.295H4.184c-0.244 0 -0.48 -0.09 -0.663 -0.251 -0.22 -0.193 -0.543 -0.478 -0.89 -0.78 -1.098 -0.956 -1.284 -2.332 -1.208 -3.512 0.062 -0.953 0.953 -1.62 1.909 -1.62L1.758 1.933A1.31 1.31 0 0 1 2.728 0.31a1.419 1.419 0 0 1 1.684 0.997l1.132 4.11 0.514 -4.323a1.236 1.236 0 0 1 2.461 0.229l-0.316 4.581Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.296 7.837 0.036 0 -0.333 -1.25 3.78 0a1.723 1.723 0 0 1 0.402 3.399l-0.112 0.026c0.384 0.39 0.681 0.932 0.707 1.624a0.625 0.625 0 1 1 -1.249 0.048c-0.016 -0.425 -0.238 -0.742 -0.543 -0.961 -0.335 -0.24 -0.662 -0.287 -0.75 -0.272a0.625 0.625 0 0 1 -0.246 -1.225L6.89 8.77a0.473 0.473 0 0 0 -0.11 -0.933l-3.484 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PeaceHand"
);
var PrayingHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 14.0004h2.31947c2.08035 0 3.81342 -1.5947 3.98618 -3.6678l0.1113 -1.33566c0.04471 -0.53646 -0.37864 -0.99655 -0.91695 -0.99655V5.24455c0 -0.74236 -0.6018 -1.34416 -1.34416 -1.34416 -0.6646 0 -1.22943 0.4857 -1.32899 1.1428L2.62882 9.6502c-0.07407 0.4889 -0.49428 0.8502 -0.98872 0.8502H0.5c-0.276142 0 -0.5 0.2238 -0.5 0.5v2.5c0 0.2761 0.223858 0.5 0.5 0.5Zm13 0h-2.3194c-2.08039 0 -3.81346 -1.5947 -3.98622 -3.6678l-0.1113 -1.33566c-0.04471 -0.53646 0.37864 -0.99655 0.91695 -0.99655V5.24455c0 -0.74236 0.6018 -1.34416 1.34416 -1.34416 0.66461 0 1.22941 0.4857 1.32901 1.1428l0.698 4.60701c0.0741 0.4889 0.4943 0.8502 0.9887 0.8502H13.5c0.2762 0 0.5 0.2238 0.5 0.5v2.5c0 0.2761 -0.2238 0.5 -0.5 0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 0.75C7.75 0.335786 7.41421 0 7 0s-0.75 0.335786 -0.75 0.75v1c0 0.41421 0.33579 0.75 0.75 0.75s0.75 -0.33579 0.75 -0.75v-1ZM6.00001 6.74609v1.25016c-0.46171 0.00669 -0.85986 0.34787 -0.92777 0.81561l-0.16051 1.10561c-0.04959 0.34163 -0.36671 0.57833 -0.70831 0.52873 -0.34159 -0.0496 -0.57831 -0.3667 -0.52872 -0.70832l0.16051 -1.10561c0.15798 -1.08816 1.0889 -1.88008 2.1648 -1.88618Zm2.00002 1.25016c0.4617 0.0067 0.85984 0.34787 0.92775 0.81561l0.16051 1.10561c0.04959 0.34163 0.36671 0.57833 0.70831 0.52873 0.3416 -0.0496 0.5783 -0.3667 0.5287 -0.70832l-0.1605 -1.10561c-0.158 -1.08815 -1.08888 -1.88008 -2.16477 -1.88618v1.25016ZM11.5303 0.71967c0.2929 0.29289 0.2929 0.76777 0 1.06066l-1 1c-0.2929 0.29289 -0.76774 0.29289 -1.06063 0s-0.29289 -0.76777 0 -1.06066l1.00003 -1c0.2929 -0.292893 0.7677 -0.292893 1.0606 0Zm-7.99997 0c-0.29289 -0.292893 -0.76777 -0.292893 -1.06066 0 -0.29289 0.29289 -0.29289 0.76777 0 1.06066l1 1c0.29289 0.29289 0.76777 0.29289 1.06066 0s0.29289 -0.76777 0 -1.06066l-1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PrayingHand"
);
var RockAndRollHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.568 13.925c-1.913 -0.864 -2.058 -2.688 -1.873 -4.17 0.07 -0.568 0.414 -1.031 0.883 -1.308V1.458a1.458 1.458 0 0 1 2.917 0v4c1.913 -0.276 2.343 -0.198 4.083 0.584v-2.25a1.458 1.458 0 0 1 2.917 0v6.525a4.666 4.666 0 0 1 -1.367 3.3l-0.09 0.09a1 1 0 0 1 -0.708 0.293l-6.393 0a0.894 0.894 0 0 1 -0.37 -0.075Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m2.553 8.462 0.025 -0.015V7.212H6.15a1.748 1.748 0 0 1 0.809 3.299c0.256 0.335 0.43 0.772 0.45 1.303a0.625 0.625 0 1 1 -1.248 0.047c-0.015 -0.375 -0.171 -0.604 -0.34 -0.74 -0.195 -0.155 -0.385 -0.175 -0.435 -0.167a0.625 0.625 0 0 1 -0.254 -1.223l1.14 -0.288a0.498 0.498 0 0 0 -0.122 -0.98H2.553Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "RockAndRollHand"
);
var TwoFingerDragHotizontal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3 0.5a0.5 0.5 0 0 0 -0.854 -0.354l-1.5 1.5a0.5 0.5 0 0 0 0 0.708l1.5 1.5A0.5 0.5 0 0 0 3 3.5v-1h1a0.5 0.5 0 1 0 0 -1H3v-1Zm8.808 -0.462a0.5 0.5 0 0 1 0.545 0.108l1.5 1.5a0.5 0.5 0 0 1 0 0.708l-1.5 1.5A0.5 0.5 0 0 1 11.5 3.5v-1h-1a0.5 0.5 0 1 1 0 -1h1v-1a0.5 0.5 0 0 1 0.308 -0.462Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m3.524 6.11 1.896 3.952 -0.574 0.317a1.707 1.707 0 0 0 -0.209 2.853l0.74 0.564a1 1 0 0 0 0.606 0.204h6.834a1 1 0 0 0 0.986 -1.167l-0.698 -4.14c-0.042 -0.247 -0.092 -0.497 -0.211 -0.718a2.134 2.134 0 0 0 -2.545 -1.014l-0.447 0.147 -0.814 -4.294a1.283 1.283 0 0 0 -2.521 0.478l0.877 4.625 0 0.008 -1.588 -2.992A1.307 1.307 0 0 0 3.524 6.11Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "TwoFingerDragHotizontal"
);
var TwoFingerTap = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.031 1.5c-0.846 0 -1.602 0.382 -2.108 0.985a0.75 0.75 0 0 1 -0.72 0.254 2.748 2.748 0 0 0 -3.21 3.323 0.75 0.75 0 0 1 -1.46 0.34 4.249 4.249 0 0 1 4.534 -5.196 4.248 4.248 0 0 1 7.103 4.009 0.75 0.75 0 1 1 -1.462 -0.34A2.748 2.748 0 0 0 9.031 1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m4.182 5.842 0.566 4.347 -0.644 0.121a1.707 1.707 0 0 0 -1.09 2.646l0.42 0.61a1 1 0 0 0 0.826 0.433l7.275 -0.015a1 1 0 0 0 0.998 -1l0 -2.067a2.134 2.134 0 0 0 -2.134 -2.134h-0.47l0.568 -4.333a1.283 1.283 0 0 0 -2.544 -0.334l-0.612 4.667 -0.003 0.008 -0.573 -3.338a1.307 1.307 0 0 0 -2.583 0.39Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "TwoFingerTap"
);
var WavingHand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m2.096 11.96 0.447 0.509c0.296 0.344 0.699 0.58 1.144 0.668l3.64 0.728a1.94 1.94 0 0 0 1.28 -0.184 1.92 1.92 0 0 0 0.897 -1.168l1.962 -7.32a0.928 0.928 0 0 0 -1.793 -0.48L8.99 7.258a0.447 0.447 0 1 1 -0.863 -0.23L9.4 2.28a0.894 0.894 0 1 0 -1.726 -0.462L6.402 6.565a0.447 0.447 0 1 1 -0.863 -0.232l0.925 -3.452a0.894 0.894 0 1 0 -1.727 -0.462L3.074 8.627l-0.62 -1.416a1.19 1.19 0 0 0 -2.203 0.894l0.775 2.07a5.79 5.79 0 0 0 1.07 1.786Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.741 0.064a0.75 0.75 0 0 1 0.606 1.372 2.11 2.11 0 0 0 -0.906 0.763 0.75 0.75 0 0 1 -1.248 -0.832A3.61 3.61 0 0 1 3.741 0.064Zm8.415 1.76a0.75 0.75 0 0 1 1.048 0.163 3.61 3.61 0 0 1 0.689 1.902 0.75 0.75 0 1 1 -1.497 0.097 2.11 2.11 0 0 0 -0.403 -1.114 0.75 0.75 0 0 1 0.163 -1.048ZM3.074 8.626l-0.016 0.06c0.347 0.093 1.157 0.474 1.547 1.15a0.625 0.625 0 1 0 1.082 -0.625c-0.62 -1.075 -1.789 -1.594 -2.305 -1.732l-0.308 1.148Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WavingHand"
);
var Amazon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.44434 2.96142c0 -0.46975 0.54462 -1.11767 1.58459 -1.11767 1.03997 0 1.58459 0.64792 1.58459 1.11767v1.11902H6.02893c-1.53875 0 -3.08459 1.02445 -3.08459 2.61768 0 1.59322 1.54584 2.61767 3.08459 2.61767 0.84721 0 1.69657 -0.31056 2.28889 -0.85561 0.23221 0.25487 0.54816 0.48903 0.9645 0.58895 0.40277 0.09667 0.80768 -0.15148 0.90428 -0.55426 0.0967 -0.40278 -0.1514 -0.80765 -0.55422 -0.90432 -0.07693 -0.01846 -0.19071 -0.09051 -0.31491 -0.28471 -0.10235 -0.16004 -0.17023 -0.341 -0.20395 -0.46732l0 -0.1404V4.83044l0 -1.86902c0 -1.59322 -1.54584 -2.61767 -3.08459 -2.61767 -1.53875 0 -3.08459 1.02445 -3.08459 2.61767 0 0.41422 0.33578 0.75 0.75 0.75 0.41421 0 0.75 -0.33578 0.75 -0.75Zm3.16918 2.61902H6.02893c-1.03997 0 -1.58459 0.64793 -1.58459 1.11768s0.54462 1.11767 1.58459 1.11767c1.03996 0 1.58459 -0.64792 1.58459 -1.11767l0 -0.00086V5.58044Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.8733 12.0857c-1.1237 0.4964 -2.65798 0.95 -4.48791 1.0393 -3.13997 0.1533 -5.75065 -0.8379 -7.049509 -2.0159 -0.3068235 -0.2782 -0.32997308 -0.7525 -0.051706 -1.0594 0.278266 -0.3068 0.752575 -0.32995 1.059395 -0.05168 0.94031 0.85278 3.13076 1.76728 5.9687 1.62878 1.7574 -0.0857 3.18073 -0.5483 4.14083 -0.9977 -0.2912 -0.0257 -0.5648 -0.008 -0.7878 0.0723 -0.3897 0.1402 -0.81938 -0.0621 -0.95962 -0.4518 -0.14025 -0.38976 0.06202 -0.8194 0.45172 -0.95965 0.7928 -0.28526 1.6563 -0.16067 2.2399 -0.01626 0.306 0.07573 0.5691 0.16572 0.7561 0.23682 0.094 0.03573 0.1701 0.06717 0.2242 0.0904 0.0271 0.01162 0.0487 0.02123 0.0645 0.02834l0.0192 0.00874 0.0061 0.00286 0.0023 0.00103 0.0008 0.00041 0.0004 0.00019c0.0001 0.00005 0.0002 0.00009 -0.0669 0.14286 0 0.00001 0.0001 0.00002 0.0001 0.00003l0.0672 -0.14273c0.2739 0.12896 0.4434 0.40996 0.4298 0.71246l-0.0212 -0.001 0 0.0003c0.0212 0.001 0.0212 0.001 0.0211 0.0011l0 0.0004 0 0.001 -0.0001 0.0024 -0.0004 0.0068 -0.0012 0.0211c-0.0011 0.0172 -0.0027 0.0409 -0.005 0.0702 -0.0008 0.0093 -0.0016 0.019 -0.0024 0.0294 0 0.0507 -0.005 0.1013 -0.0151 0.1511 -0.0022 0.0192 -0.0046 0.0392 -0.0071 0.06 -0.0243 0.1986 -0.0674 0.4733 -0.1432 0.7793 -0.1444 0.5836 -0.4369 1.4055 -1.0589 1.9738 -0.3059 0.2793 -0.7803 0.2579 -1.0596 -0.048 -0.2794 -0.3058 -0.2579 -0.7802 0.0479 -1.0596 0.0789 -0.072 0.1513 -0.1591 0.2174 -0.2577Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Amazon"
);
var Android = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.53033 0.241276c-0.29289 -0.2928928 -0.76777 -0.2928928 -1.06066 0 -0.29289 0.292894 -0.29289 0.767764 0 1.060664l1.29124 1.29124c-0.6984 0.78877 -1.08708 1.80823 -1.08708 2.86778v0.87193c-0.68497 0.01286 -1.33914 0.29054 -1.824482 0.77588 -0.497089 0.49709 -0.77635 1.17129 -0.77635 1.87428v0.90062c0 0.41423 0.335786 0.75003 0.75 0.75003 0.414212 0 0.750002 -0.3358 0.750002 -0.75003v-0.90062c0 -0.30517 0.12122 -0.59783 0.33701 -0.81362 0.20402 -0.20401 0.47676 -0.32351 0.76382 -0.33593v5.3262c0 0.4142 0.33578 0.75 0.75 0.75 0.41421 0 0.75 -0.3358 0.75 -0.75v-1.7513h5.65234v1.7513c0 0.4142 0.33583 0.75 0.75003 0.75 0.4142 0 0.75 -0.3358 0.75 -0.75V10.666l0 -0.0076V7.8335c0.2871 0.01242 0.5598 0.13191 0.7638 0.33593 0.2158 0.21579 0.3371 0.50845 0.3371 0.81362v0.90062c0 0.41423 0.3357 0.75003 0.75 0.75003 0.4142 0 0.75 -0.3358 0.75 -0.75003v-0.90062c0 -0.70299 -0.2793 -1.37719 -0.7764 -1.87428 -0.4853 -0.48534 -1.1395 -0.76303 -1.8245 -0.77588v-0.87193c0 -1.05955 -0.3887 -2.07902 -1.0871 -2.86779l1.2913 -1.29123c0.2929 -0.2929 0.2929 -0.76777 0 -1.060664 -0.2929 -0.2928928 -0.7678 -0.2928928 -1.0607 0L9.05629 1.65468c-0.62606 -0.33819 -1.3318 -0.51991 -2.05627 -0.51991 -0.72448 0 -1.43022 0.18172 -2.05628 0.51991L3.53033 0.241276Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.3098 5.08447H2.69023c-0.01089 0.12471 -0.0164 0.25032 -0.0164 0.37649v0.87351h8.65237v-0.87351c0 -0.12617 -0.0055 -0.25178 -0.0164 -0.37649Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Android"
);
var AppStore = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.85324 1.29785c-0.50373 -0.29213 -1.1489 -0.1206 -1.44103 0.38313l-0.26731 0.46094 -0.26732 -0.46094c-0.29213 -0.50373 -0.9373 -0.67526 -1.44102 -0.38313 -0.50373 0.29213 -0.67527 0.9373 -0.38314 1.44103l0.87264 1.50471 -2.77787 4.78996H1.30747c-0.582304 0 -1.054357 0.47206 -1.054357 1.05435 0 0.5823 0.472053 1.0544 1.054357 1.0544h7.32091L7.40826 9.03355h-1.8224L7.1449 6.34526l2.09147 -3.60638c0.29213 -0.50373 0.1206 -1.1489 -0.38313 -1.44103ZM1.7383 13.6468c0.51657 0.2975 1.17645 0.1198 1.4739 -0.3967l0.5936 -1.0309 -2.48942 0c-0.26147 0.5091 -0.07936 1.139 0.42192 1.4276Zm9.3508 -0.3968L7.75055 7.45203l1.24364 -2.13807 2.15851 3.72062h1.6691c0.5823 0 1.0544 0.47205 1.0544 1.05432 0 0.5823 -0.4721 1.0544 -1.0544 1.0544h-0.4549l0.5928 1.0296c0.2975 0.5165 0.1198 1.1764 -0.3967 1.4739 -0.5166 0.2974 -1.1765 0.1198 -1.4739 -0.3968Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "AppStore"
);
var Apple = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.94901 3.79068c-0.43974 -0.1042 -0.89652 -0.11447 -1.3405 -0.03013 -0.43545 0.08271 -0.849 0.25461 -1.21467 0.50479 -0.06215 0.03283 -0.13146 0.05005 -0.20191 0.05005 -0.07321 0 -0.14518 -0.01859 -0.20918 -0.05397 -0.39509 -0.2485 -0.83739 -0.41253 -1.29908 -0.48171 -0.4659 -0.0698 -0.94124 -0.04147 -1.39555 0.08318 -0.45431 0.12465 -0.87755 0.34287 -1.24259 0.64067 -0.36324 0.29632 -0.66086 0.66493 -0.874 1.0824 -0.56829 1.0498 -0.76423 2.26103 -0.55608 3.43626 0.17196 1.57318 0.85333 3.04728 1.9406 4.19758 0.00624 0.0066 0.01266 0.0131 0.01926 0.0193 0.42095 0.3994 0.97003 0.6362 1.54937 0.6684 0.57823 0.0321 1.14909 -0.1417 1.61122 -0.4906 0.12542 -0.0922 0.27702 -0.1419 0.43272 -0.1419 0.15355 0 0.30312 0.0483 0.42752 0.1381 0.4436 0.3546 0.99788 0.5419 1.56589 0.5291 0.57222 -0.0129 1.12137 -0.2281 1.54987 -0.6075 0.0082 -0.0073 0.0162 -0.0148 0.0238 -0.0225 0.8302 -0.838 1.4219 -1.8822 1.7142 -3.025 0.0353 -0.138 0.0101 -0.2845 -0.0694 -0.40271 -0.0794 -0.11823 -0.2055 -0.19698 -0.3465 -0.21649 -0.439 -0.06067 -0.8404 -0.28005 -1.1286 -0.61666 -0.2881 -0.33661 -0.4429 -0.76712 -0.4352 -1.21014l0.0001 0 0 -0.00787c0.0007 -0.38668 0.1244 -0.7631 0.3532 -1.07479 0.2289 -0.31169 0.5509 -0.54248 0.9197 -0.65894 0.1423 -0.04497 0.2571 -0.15117 0.313 -0.28958 0.0559 -0.13842 0.047 -0.29456 -0.0242 -0.42575 -0.2156 -0.39717 -0.5126 -0.74439 -0.8715 -1.01899 -0.3589 -0.2746 -0.7717 -0.47039 -1.21149 -0.5746Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.1468 0.276799c0.2929 0.292893 0.2929 0.767771 0 1.060661l-1.50001 1.5c-0.2929 0.29289 -0.76777 0.29289 -1.06066 0 -0.2929 -0.29289 -0.2929 -0.76777 0 -1.06066l1.5 -1.500001c0.29289 -0.2928934 0.76776 -0.2928934 1.06067 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Apple"
);
var BinanceCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.61 1.963a0.625 0.625 0 0 1 0.78 0l2.5 2a0.625 0.625 0 1 1 -0.78 0.976L7 3.252 4.89 4.939a0.625 0.625 0 1 1 -0.78 -0.976l2.5 -2ZM4.012 9.158a0.625 0.625 0 0 1 0.878 -0.098L7 10.748 9.11 9.06a0.625 0.625 0 1 1 0.78 0.976l-2.5 2a0.625 0.625 0 0 1 -0.78 0l-2.5 -2a0.625 0.625 0 0 1 -0.098 -0.878ZM7 7.75a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5ZM4.55 7a0.75 0.75 0 1 1 -1.5 0 0.75 0.75 0 0 1 1.5 0Zm5.65 0.75a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BinanceCircle"
);
var Bitcoin = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.744 1.029a1 1 0 1 0 -2 0v0.604a1.744 1.744 0 0 0 -0.886 1.518v7.432a1.744 1.744 0 0 0 0.886 1.518v0.87a1 1 0 1 0 2 0v-0.644h1.019v0.644a1 1 0 1 0 2 0v-0.805A3.416 3.416 0 0 0 9.99 6.353a3.05 3.05 0 0 0 -1.227 -4.725v-0.6a1 1 0 1 0 -2 0v0.379h-1.02v-0.378Zm-0.886 6.466v2.832h2.868a1.416 1.416 0 0 0 0.02 -2.832H4.859Zm2.832 -2H4.858V3.407h2.86a1.049 1.049 0 0 1 -0.028 2.088Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bitcoin"
);
var Chrome = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.25 7a6.75 6.75 0 1 0 13.5 0A6.75 6.75 0 1 0 0.25 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M13.5015 5.17729c-0.0983 0.04173 -0.2063 0.06483 -0.3198 0.06483H9.91287c0.31003 0.5129 0.48843 1.11426 0.48843 1.7573 0 0.68589 -0.203 1.32437 -0.55214 1.85865L7.02458 13.7504l-0.02454 0c-0.53389 0 -1.05331 -0.062 -1.55144 -0.1791 0.01469 -0.0845 0.04422 -0.1678 0.08958 -0.2464l1.69237 -2.9313c-0.0764 0.0052 -0.15349 0.0078 -0.23118 0.0078 -1.21358 0 -2.27874 -0.63549 -2.8809 -1.59182 -0.02723 -0.03265 -0.05205 -0.06807 -0.07403 -0.10614L1.13257 3.65993c0.26437 -0.46341 0.58206 -0.89247 0.94471 -1.27883 0.06281 0.05382 0.11772 0.11902 0.16143 0.19472l1.69795 2.94094c0.55097 -1.13602 1.71537 -1.91928 3.06271 -1.91928 0.07962 0 0.15861 0.00274 0.23686 0.00812h5.59997c0.2846 0.48826 0.5096 1.01547 0.6653 1.57169ZM8.68277 7.88541c-0.01412 0.01977 -0.02742 0.04039 -0.03982 0.06187l-0.0681 0.11795c-0.342 0.50456 -0.92002 0.83613 -1.57548 0.83613 -1.05042 0 -1.90194 -0.85152 -1.90194 -1.90194 0 -1.05041 0.85152 -1.90194 1.90194 -1.90194 1.05041 0 1.90194 0.85153 1.90194 1.90194 0 0.31993 -0.07899 0.62141 -0.21854 0.88599Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Chrome"
);
var CssThree = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.5 0C0.35377 0 0.21487 0.064014 0.119875 0.175185 0.0248795 0.286356 -0.0166878 0.433541 0.00611851 0.577981L1.50612 10.078c0.02117 0.1341 0.09594 0.2538 0.20715 0.3316l5 3.5c0.17216 0.1205 0.4013 0.1205 0.57346 0l4.99997 -3.5c0.1112 -0.0778 0.186 -0.1975 0.2072 -0.3316l1.5 -9.500019c0.0228 -0.14444 -0.0188 -0.291625 -0.1138 -0.402796C13.7851 0.064014 13.6462 0 13.5 0H0.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.57538 3.08789c0 -0.34518 0.27982 -0.625 0.625 -0.625h5.59921c0.27881 0 0.52391 0.18469 0.60081 0.4527 0.0768 0.26801 -0.0331 0.55453 -0.2696 0.7023L7.49947 5.2625h1.7402c0.34518 0 0.625 0.27982 0.625 0.625v2.7996c0 0.19673 -0.09262 0.38197 -0.25 0.5l-2.23968 1.6798c-0.22223 0.1666 -0.52778 0.1666 -0.75 0L4.3853 9.1871c-0.27614 -0.2071 -0.33211 -0.59885 -0.125 -0.875 0.20711 -0.27614 0.59886 -0.3321 0.875 -0.125l1.86469 1.39852L8.61467 8.3746V6.5125H5.32022c-0.27882 0 -0.52391 -0.18469 -0.60078 -0.4527 -0.07686 -0.26801 0.03309 -0.55453 0.26953 -0.7023l2.63137 -1.64461H4.20038c-0.34518 0 -0.625 -0.27982 -0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CssThree"
);
var Discord = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.0458984 10.3057c0 -2.7817 0.9934516 -6.45747 1.9869016 -7.94765 0 0 0.99345 -0.49672 4.96726 -0.49672 3.97384 0 4.96724 0.49672 4.96724 0.49672 0.9935 1.49018 1.9869 5.16595 1.9869 7.94765 -0.3311 0.4967 -1.4902 1.5895 -3.4771 1.9869l-1.74755 -2.1845c-0.51862 0.1218 -1.10891 0.1976 -1.72949 0.1976 -0.62058 0 -1.21087 -0.0758 -1.72949 -0.1976l-1.74759 2.1845c-1.9869 -0.3974 -3.145931 -1.4902 -3.4770816 -1.9869Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.40668 6.0769c0 0.55229 -0.44772 1 -1 1 -0.55229 0 -1 -0.44771 -1 -1 0 -0.55228 0.44771 -1 1 -1 0.55228 0 1 0.44772 1 1Zm3.99966 4.877c0.60366 -0.1967 1.11566 -0.4636 1.42436 -0.7722 0.1952 -0.19528 0.1952 -0.51187 0 -0.70713 -0.1953 -0.19526 -0.5119 -0.19526 -0.7071 0 -0.19451 0.19447 -0.67907 0.45254 -1.39319 0.63443l0.67593 0.8449Zm-4.13665 -0.8449 -0.67593 0.845c-0.60371 -0.1968 -1.1157 -0.4637 -1.42436 -0.7723 -0.19527 -0.19528 -0.19527 -0.51187 0 -0.70713 0.19526 -0.19526 0.51184 -0.19526 0.7071 0 0.19447 0.19447 0.67905 0.45255 1.39319 0.63443ZM9.3172 7.0769c0.55228 0 1 -0.44771 1 -1 0 -0.55228 -0.44772 -1 -1 -1 -0.55229 0 -1 0.44772 -1 1 0 0.55229 0.44771 1 1 1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Discord"
);
var Dropbox = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.3125 3.13164 3.65582 0.840454 6.99913 3.13164 3.65582 5.42283 0.3125 3.13164ZM10.3442 0.840454 7.00085 3.13164l3.34335 2.29119 3.3433 -2.29119L10.3442 0.840454Zm-0.0005 9.168346 -0.0004 0.0003L7 7.71795l3.3433 -2.29119 0.0004 0.00029 0.0005 -0.00029 3.3433 2.29119 -3.3433 2.29115 -0.0005 -0.0003Zm-6.68507 1.2823 3.34332 -2.29116 3.34335 2.29116 -3.34335 2.2912 -3.34332 -2.2912Zm-0.00281 -5.86434L0.3125 7.71795l3.34332 2.29115 3.34331 -2.29115 -3.34331 -2.29119Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dropbox"
);
var EpicGames1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.0484 0C1.26267 0 0.723145 0.696666 0.723145 1.42857v8.24754c0 0.51109 0.256348 1.01049 0.711035 1.26629l5.32062 2.9934c0.15222 0.0856 0.3381 0.0856 0.49032 0l5.32058 -2.9934c0.4547 -0.2558 0.7111 -0.7552 0.7111 -1.26629V1.42857C13.2768 0.696666 12.7372 0 11.9515 0H2.0484Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.60864 2.08252c-0.34518 0 -0.625 0.27982 -0.625 0.625v4.64286c0 0.34517 0.27982 0.625 0.625 0.625h2.78571c0.34518 0 0.625 -0.27983 0.625 -0.625 0 -0.34518 -0.27982 -0.625 -0.625 -0.625H6.23364V5.65395h2.16071c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H6.23364V3.33252h2.16071c0.34518 0 0.625 -0.27982 0.625 -0.625s-0.27982 -0.625 -0.625 -0.625H5.60864Zm-0.1628 7.60538c-0.30208 -0.16702 -0.68236 -0.05753 -0.84938 0.24455 -0.16702 0.30205 -0.05753 0.68235 0.24455 0.84935l1.85715 1.0268c0.18818 0.1041 0.41664 0.1041 0.60482 0l1.85714 -1.0268c0.30208 -0.167 0.41157 -0.5473 0.24456 -0.84935 -0.16702 -0.30208 -0.5473 -0.41157 -0.84938 -0.24455l-1.55473 0.8596 -1.55473 -0.8596Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "EpicGames1"
);
var EthereumCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.5a0.5 0.5 0 0 1 0.384 0.18l2.5 3a0.5 0.5 0 0 1 -0.072 0.71l-2.5 2a0.5 0.5 0 0 1 -0.624 0l-2.5 -2a0.5 0.5 0 0 1 -0.072 -0.71l2.5 -3A0.5 0.5 0 0 1 7 2.5ZM4.89 8.512a0.625 0.625 0 0 0 -0.78 0.976l2.5 2a0.625 0.625 0 0 0 0.78 0l2.5 -2a0.625 0.625 0 1 0 -0.78 -0.976L7 10.2 4.89 8.512Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "EthereumCircle"
);
var Ethereum = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.403 0.26a0.5 0.5 0 0 0 -0.805 0L1.86 6.694a0.5 0.5 0 0 0 0 0.593l4.738 6.433a0.5 0.5 0 0 0 0.805 0l4.737 -6.433a0.5 0.5 0 0 0 0 -0.593L7.403 0.261Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.236 6.95 7.089 8.64a0.5 0.5 0 0 1 -0.315 -0.001l-5.01 -1.684a0.5 0.5 0 0 0 0.096 0.332l4.738 6.433a0.5 0.5 0 0 0 0.805 0l4.737 -6.433a0.5 0.5 0 0 0 0.096 -0.336Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Ethereum"
);
var Facebook1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.07692V12.9231c0 0.2856 0.113461 0.5595 0.315423 0.7615 0.201963 0.2019 0.475882 0.3154 0.761497 0.3154H12.9231c0.2856 0 0.5595 -0.1135 0.7615 -0.3154 0.2019 -0.202 0.3154 -0.4759 0.3154 -0.7615V1.07692c0 -0.285615 -0.1135 -0.559534 -0.3154 -0.761497C13.4826 0.113461 13.2087 0 12.9231 0H1.07692C0.791305 0 0.517386 0.113461 0.315423 0.315423 0.113461 0.517386 0 0.791305 0 1.07692Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.69233 8.89539V14H7.28002V8.89539h-0.68923c-0.08717 0.00143 -0.17375 -0.0145 -0.2547 -0.04688 -0.08095 -0.03237 -0.15465 -0.08053 -0.21679 -0.14168 -0.06215 -0.06114 -0.1115 -0.13404 -0.14519 -0.21445 -0.03368 -0.08042 -0.05103 -0.16673 -0.05101 -0.25391v-0.82923c-0.00002 -0.08718 0.01733 -0.1735 0.05101 -0.25391 0.03369 -0.08041 0.08304 -0.15331 0.14519 -0.21446 0.06214 -0.06114 0.13584 -0.1093 0.21679 -0.14167 0.08095 -0.03238 0.16753 -0.04831 0.2547 -0.04688h0.68923v-1.26c-0.0439 -0.35895 -0.00936 -0.72315 0.10124 -1.06744s0.29462 -0.66047 0.53934 -0.9267c0.24473 -0.26623 0.54433 -0.47616 0.87811 -0.6153 0.33378 -0.13913 0.69379 -0.20415 1.05516 -0.19056h1.23843c0.0877 0.00278 0.174 0.02282 0.254 0.05897 0.0799 0.03615 0.1519 0.08771 0.212 0.15172 0.06 0.06401 0.1068 0.13922 0.1377 0.22133 0.0309 0.08211 0.0454 0.16951 0.0425 0.25721v0.79692c0.0015 0.0864 -0.015 0.17216 -0.0484 0.25187 -0.0333 0.07971 -0.0829 0.15163 -0.1455 0.21121 -0.0582 0.06425 -0.1299 0.11491 -0.21 0.14841 -0.08 0.03349 -0.1664 0.049 -0.253 0.04543h-0.5277c-0.4093 0 -0.8185 0 -0.8185 0.90462v1.01231h0.7215c0.0863 0 0.1717 0.01699 0.2514 0.05 0.0797 0.03301 0.1522 0.0814 0.2132 0.1424s0.1093 0.13342 0.1424 0.21313c0.033 0.0797 0.05 0.16512 0.05 0.25139v0.82923c0 0.17423 -0.0692 0.34132 -0.1924 0.46451 -0.1232 0.1232 -0.2903 0.19241 -0.4646 0.19241h-0.76457Z" }),
    " "
  ] }) }),
  "Facebook1"
);
var Figma = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.99976 2.24991C1.99976 1.00732 3.00707 0 4.24966 0h2.74989v4.49982H4.24966c-1.24259 0 -2.2499 -1.00732 -2.2499 -2.24991Zm9.99984 4.74925c0 -1.38065 -1.1193 -2.4999 -2.49993 -2.4999 -1.38065 0 -2.4999 1.11925 -2.4999 2.4999 0 1.38066 1.11925 2.4999 2.4999 2.4999 1.38063 0 2.49993 -1.11924 2.49993 -2.4999ZM4.24966 9.50018c-1.24259 0 -2.2499 1.00732 -2.2499 2.24992S3.00707 14 4.24966 14h0.24999c1.38066 0 2.4999 -1.1192 2.4999 -2.4999V9.50018H4.24966Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.75034 0c1.24256 0 2.24986 1.00732 2.24986 2.24991 0 1.24259 -1.0073 2.24991 -2.24986 2.24991H7.00045V0h2.74989ZM4.49965 4.4996c-1.38065 0 -2.49989 1.11924 -2.49989 2.4999 0 1.38066 1.11924 2.4999 2.49989 2.4999h2.4999V4.4996h-2.4999Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Figma"
);
var Gameboy = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.558 13a1 1 0 0 1 -1 1H2.442a1 1 0 0 1 -1 -1V1a1 1 0 0 1 1 -1h9.116a1 1 0 0 1 1 1v12Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.412 6.608a1 1 0 0 1 -1 1H4.588a1 1 0 0 1 -1 -1V2.926a1 1 0 0 1 1 -1h4.824a1 1 0 0 1 1 1v3.682Zm-6.138 4.936a0.625 0.625 0 1 0 1.25 0v-0.334h0.335a0.625 0.625 0 1 0 0 -1.25h-0.335v-0.335a0.625 0.625 0 1 0 -1.25 0v0.335H3.94a0.625 0.625 0 1 0 0 1.25h0.334v0.334Zm5.226 -0.073a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Gameboy"
);
var Gmail = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.00772 12.0542h2.76535V7.68637l3.26988 2.11682 3.26995 -2.11683v4.36784h2.7653c0.5091 0 0.9218 -0.4112 0.9218 -0.9185V3.75445c0 -1.45329 -1.6136 -2.33103 -2.8405 -1.54516l-0.8466 0.54231v0.00119L7.04295 4.85187 3.77307 2.75279V2.7516l-0.84665 -0.54231C1.69951 1.42342 0.0859375 2.30116 0.0859375 3.75445v7.38125c0 0.5073 0.4126965 0.9185 0.9217825 0.9185Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.77307 7.68637 0.0859375 5.29944V3.75445c0 -1.45329 1.6135725 -2.33103 2.8404825 -1.54516l0.84665 0.5435v4.93358ZM14 5.29944V3.75445c0 -1.45329 -1.6136 -2.33103 -2.8405 -1.54516l-0.8466 0.5435v4.93357L14 5.29944Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Gmail"
);
var GoogleDrive = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.110107 9.10972 2.5903 13.078h8.9287l2.4802 -3.96828L9.53485 1.1731H4.57446L0.110107 9.10972Zm5.481143 -0.45423 1.31333 -2.33481 1.45926 2.33481H5.59125Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.95459 12.061 3.6334 9.0764c0.01264 -0.02585 0.02673 -0.05087 0.04216 -0.07495L5.99871 4.8714 4.15419 1.92017l0.42023 -0.74707h0.88172l2.01422 3.22275c0.02678 0.03543 0.0502 0.07299 0.07011 0.11217L10.1326 8.6555h3.6111l0.2555 0.45422 -0.6537 1.04578H4.74743L3.10351 13.078h-0.51325l-0.63567 -1.017Zm3.63659 -3.4055 1.31333 -2.33482L8.36377 8.6555H5.59118Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "GoogleDrive"
);
var Google = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.7009 5.73497H7.54982c-0.07313 -0.00002 -0.14553 0.01455 -0.21295 0.04284 -0.06743 0.02829 -0.12853 0.06973 -0.17974 0.12191 -0.0512 0.05218 -0.09148 0.11404 -0.11847 0.18197 -0.02699 0.06792 -0.04015 0.14055 -0.03872 0.21362v1.51938c0 0.14576 0.05793 0.28554 0.16106 0.38861 0.10312 0.10306 0.24298 0.16096 0.38882 0.16096h2.85728c0.0078 0.4165 -0.0724 0.82997 -0.2352 1.21342 -0.1629 0.38346 -0.40486 0.72832 -0.71008 1.01202 -0.30522 0.2836 -0.66686 0.4998 -1.06132 0.6344 -0.39447 0.1346 -0.81289 0.1846 -1.22797 0.1466 -2.41515 0 -3.5796 -2.04739 -3.5796 -4.37497 0 -2.32757 1.25071 -4.37497 3.5796 -4.37497 1.02816 -0.03409 2.03563 0.29391 2.84647 0.92672 0.0648 0.04239 0.1381 0.07002 0.2148 0.08094 0.0766 0.01091 0.1548 0.00484 0.2289 -0.01777 0.074 -0.02262 0.1422 -0.06124 0.1997 -0.11313 0.0575 -0.05188 0.1028 -0.11576 0.1329 -0.18711l0.6792 -1.55171c0.0559 -0.11437 0.0703 -0.24458 0.0408 -0.36839s-0.1011 -0.23355 -0.2025 -0.31049C10.0764 0.340925 8.65581 -0.0327003 7.21566 0.00224508 3.29104 -0.00853072 0.617126 3.04102 0.617126 6.99573 0.617126 10.9505 3.30182 14 7.17253 14c3.87067 0 6.21037 -2.7586 6.21037 -6.46548 0 -1.18533 -0.4744 -1.79955 -1.682 -1.79955Z" }),
    " "
  ] }) }),
  "Google"
);
var Instagram = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.786499 3.3904c0 -1.43803 1.165751 -2.603779 2.603771 -2.603779h6.94343c1.438 0 2.6037 1.165749 2.6037 2.603779v6.9434c0 1.438 -1.1657 2.6038 -2.6037 2.6038H3.39027c-1.43802 0 -2.603771 -1.1658 -2.603771 -2.6038V3.3904Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.9673 3.35269c0 0.3493 -0.2831 0.63247 -0.6324 0.63247 -0.34934 0 -0.63251 -0.28317 -0.63251 -0.63247 0 -0.34931 0.28317 -0.63248 0.63251 -0.63248 0.3493 0 0.6324 0.28317 0.6324 0.63248Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.3331 4.14417c0.4142 0 0.75 -0.33579 0.75 -0.75 0 -0.41422 -0.3358 -0.75 -0.75 -0.75 -0.41418 0 -0.74997 0.33578 -0.74997 0.75 0 0.41421 0.33579 0.75 0.74997 0.75ZM3.78198 6.86204c0 -1.70107 1.37899 -3.08006 3.08006 -3.08006S9.9421 5.16097 9.9421 6.86204 8.56311 9.9421 6.86204 9.9421 3.78198 8.56311 3.78198 6.86204Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Instagram"
);
var Linkedin = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.913 2.362c0.26 -0.268 0.403 -0.626 0.4 -0.998A1.417 1.417 0 0 0 1.928 0 1.428 1.428 0 0 0 0.532 1.364a1.45 1.45 0 0 0 1.396 1.428 1.42 1.42 0 0 0 0.985 -0.43ZM1.67 4.63c-0.587 -0.013 -0.987 -0.022 -0.987 0.696v7.992c0 0.703 0.382 0.689 0.932 0.668 0.1 -0.004 0.205 -0.008 0.314 -0.008 0.11 0 0.215 0.004 0.314 0.008 0.548 0.02 0.922 0.035 0.922 -0.668V5.327c0 -0.718 -0.392 -0.71 -0.977 -0.696a11.32 11.32 0 0 1 -0.519 0Zm4.084 0.015c-0.266 0.053 -0.437 0.223 -0.437 0.681v7.992c0 0.703 0.367 0.689 0.918 0.668 0.1 -0.004 0.207 -0.008 0.318 -0.008 0.112 0 0.218 0.004 0.319 0.008 0.554 0.02 0.928 0.035 0.928 -0.668V9.056a1.545 1.545 0 0 1 1.577 -1.695 1.534 1.534 0 0 1 1.62 1.663v4.261c0 0.704 0.366 0.69 0.917 0.669 0.1 -0.004 0.207 -0.008 0.318 -0.008 0.112 0 0.218 0.004 0.319 0.008 0.551 0.02 0.917 0.035 0.917 -0.668V7.83a3.195 3.195 0 0 0 -3.388 -3.335 2.674 2.674 0 0 0 -2.387 1.066c0.011 -0.394 -0.117 -0.916 -0.436 -0.916 -0.092 0 -0.233 -0.005 -0.393 -0.01 -0.4 -0.012 -0.92 -0.028 -1.11 0.01Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Linkedin"
);
var Meta = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.40436 3.9087c-0.67994 0.72297 -1.33135 1.66334 -1.91934 2.52984l-0.19687 0.29061 -0.00002 0.00003c-0.53131 0.78492 -1.01018 1.49239 -1.46592 2.03158 -0.25331 0.29968 -0.46477 0.50453 -0.63579 0.62821 -0.12019 0.08693 -0.18321 0.10696 -0.19749 0.1109 -0.18584 -0.00557 -0.49846 -0.15008 -0.72248 -0.49242 0.14965 0.47444 0.57591 1.42335 1.46451 1.42335 1.06089 0 2.70318 -1.83108 3.21138 -2.57734l0.00019 -0.00028c0.06626 -0.09798 0.1321 -0.19535 0.19744 -0.29164 0.59952 -0.8835 1.16686 -1.69313 1.7213 -2.28266 0.59341 -0.63097 0.96223 -0.77884 1.13873 -0.77884 0.4421 0 0.9 0.18303 1.2724 0.663 0.0314 -0.36388 -0.0915 -1.21139 -0.8339 -1.69037 -0.74247 -0.47899 -2.35421 -0.28701 -3.03414 0.43603Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.14741 3.937C1.90002 2.96697 2.94211 2.5 4 2.5c1.0735 0 1.95468 0.72713 2.59564 1.40866 0.13602 0.14463 0.2709 0.29796 0.40436 0.45765 0.13346 -0.15969 0.26834 -0.31302 0.40436 -0.45765C8.04532 3.22713 8.9265 2.5 10 2.5c1.0579 0 2.1 0.46697 2.8526 1.437C13.5916 4.88948 14 6.25449 14 8c0 1.90211 -1.3086 3.5 -3 3.5 -0.5432 0 -1.00558 -0.2352 -1.3585 -0.4905 -0.35828 -0.2591 -0.68979 -0.6012 -0.99117 -0.9577 -0.53018 -0.62727 -1.07431 -1.43188 -1.59267 -2.19838 -0.06633 -0.09808 -0.13224 -0.19554 -0.19764 -0.29192 -0.37529 -0.55306 -0.73797 -1.07718 -1.09277 -1.53648 -0.09556 0.13892 -0.18968 0.27713 -0.28223 0.41352l-0.19687 0.29061 -0.00002 0.00003c-0.53131 0.78492 -1.01018 1.49239 -1.46592 2.03158 -0.25331 0.29968 -0.46477 0.50453 -0.63579 0.62821 -0.12019 0.08693 -0.18321 0.10696 -0.19749 0.1109 -0.18584 -0.00557 -0.49846 -0.15008 -0.72248 -0.49242 0.14965 0.47444 0.57591 1.42335 1.46451 1.42335 1.0588 0 2.69672 -1.82388 3.20837 -2.57292 -0.51746 0.76516 -1.06051 1.56787 -1.58966 2.19392 -0.30138 0.3565 -0.63289 0.6986 -0.99117 0.9577 -0.35292 0.2553 -0.81529 0.4905 -1.3585 0.4905 -1.69135 0 -3 -1.59789 -3 -3.5 0 -1.74551 0.408426 -3.11052 1.14741 -4.063Zm4.61982 2.08801c-0.21198 -0.27441 -0.42114 -0.52568 -0.6285 -0.74617C4.54532 4.64787 4.1765 4.5 4 4.5c-0.44211 0 -0.90002 0.18303 -1.27241 0.663C2.34157 5.66052 2 6.54551 2 8c0 1.08496 0.67516 1.49043 0.98893 1.49983 0.01428 -0.00394 0.0773 -0.02397 0.19749 -0.1109 0.17102 -0.12368 0.38248 -0.32853 0.63579 -0.62821 0.45574 -0.5392 0.93462 -1.24667 1.46593 -2.03159l0.00001 -0.00002 0.19687 -0.29061c0.09255 -0.13638 0.18666 -0.27459 0.28221 -0.41349Zm1.23279 -1.65868c0.53366 0.6386 1.0446 1.37902 1.51496 2.07217l0.19687 0.29061 0.00003 0.00004c0.5313 0.78492 1.01017 1.49238 1.46592 2.03157 0.2533 0.29968 0.4648 0.50453 0.6358 0.62821 0.1202 0.08693 0.1832 0.10696 0.1975 0.1109C11.3248 9.49043 12 9.08496 12 8c0 -1.45449 -0.3416 -2.33948 -0.7276 -2.837 0.0314 -0.3639 -0.0915 -1.21136 -0.8339 -1.69033 -0.74247 -0.47899 -2.35421 -0.28701 -3.03414 0.43603 -0.13602 0.14462 -0.27089 0.29794 -0.40434 0.45763Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Meta"
);
var Netflix = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.47223 -0.000488281c-0.27614 0 -0.5 0.223857281 -0.5 0.500000281V6.46784l3.46847 6.80556c0.0077 0.0152 0.0147 0.0307 0.0208 0.0464 0.0218 -0.0564 0.0337 -0.1174 0.0337 -0.1806V0.499512c0 -0.276143 -0.2239 -0.500000281 -0.5 -0.500000281H9.47223ZM1.55628 0.733919c-0.00657 -0.013325 -0.0125 -0.026861 -0.01781 -0.040565 -0.02186 0.056411 -0.03371 0.11742 -0.03371 0.180572V13.2262c0 0.1637 0.08013 0.317 0.21452 0.4105 0.13439 0.0934 0.30602 0.1152 0.45948 0.0582l2.5221 -0.9362c0.19597 -0.0728 0.326 -0.2597 0.326 -0.4688V7.77499L1.55628 0.733919Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.00476 0.0128784c-0.17278 0 -0.33332 0.0892066 -0.42457 0.2359246 -0.09126 0.146719 -0.1003 0.330154 -0.02391 0.485133L7.36279 12.5141c0.06219 0.1262 0.17467 0.2203 0.30984 0.2593l4.18397 1.2075c0.1914 0.0552 0.3973 -0.0085 0.5242 -0.1621 0.1268 -0.1536 0.1504 -0.3679 0.0599 -0.5454L5.82156 0.285839C5.73619 0.118337 5.56408 0.0128784 5.37607 0.0128784H2.00476Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Netflix"
);
var NintendoSwitch = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.4146 14c1.933 0 3.5 -1.567 3.5 -3.5V3.50049c0 -1.933 -1.567 -3.500001719 -3.5 -3.500001719H8.24213c-0.27615 0 -0.5 0.223857719 -0.5 0.499999719V13.5c0 0.2762 0.22385 0.5 0.5 0.5h2.17247Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.6869 10.0881c0.8414 0 1.5235 -0.68206 1.5235 -1.52342s-0.6821 -1.52342 -1.5235 -1.52342c-0.84133 0 -1.52339 0.68206 -1.52339 1.52342s0.68206 1.52342 1.52339 1.52342Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.52802 0.000488281C1.59502 0.000488281 0.0280151 1.56749 0.0280151 3.50049V10.5c0 1.933 1.5670049 3.5 3.5000049 3.5h2.17252c0.27614 0 0.5 -0.2238 0.5 -0.5l0 -12.999511c0 -0.276143 -0.22386 -0.500000719 -0.5 -0.500000719H3.52802Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M3.25572 3.14697c-0.84136 0 -1.52342 0.68206 -1.52342 1.52342 0 0.84137 0.68206 1.52343 1.52342 1.52343s1.52342 -0.68206 1.52342 -1.52343c0 -0.84136 -0.68206 -1.52342 -1.52342 -1.52342Z" }),
    " "
  ] }) }),
  "NintendoSwitch"
);
var Pacman = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.375a6.625 6.625 0 1 0 5.64 10.102 0.5 0.5 0 0 0 -0.163 -0.689L7.953 7l4.524 -2.788a0.5 0.5 0 0 0 0.163 -0.689A6.621 6.621 0 0 0 7 0.375Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5 4a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" }),
    " "
  ] }) }),
  "Pacman"
);
var Paypal = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.0008 1.09486 2.9808 0.0152523c-0.06373 -0.01628191 -0.13009 -0.01956882 -0.19512 -0.00966473 -0.06503 0.00990413 -0.1274 0.03279643 -0.1834 0.06731213 -0.05599 0.0345153 -0.10445 0.0799483 -0.14251 0.1335883 -0.03805 0.053641 -0.0649 0.114391 -0.07897 0.178629l-1.36 6.407663L0.0108044 11.5011c-0.0268829 0.1258 -0.00313979 0.2572 0.0660968 0.3657 0.0692368 0.1085 0.1784038 0.1854 0.3039028 0.214l1.199996 0.26c0.06304 0.0131 0.12806 0.0137 0.19133 0.0018 0.06328 -0.012 0.12358 -0.0363 0.17744 -0.0716 0.05387 -0.0353 0.10025 -0.0808 0.1365 -0.134 0.03624 -0.0532 0.06164 -0.1131 0.07473 -0.1761l1 -4.6783 3.44 0.73973c0.51241 0.11015 1.04295 0.10452 1.5529 -0.01647 0.50995 -0.12099 0.98643 -0.35429 1.39467 -0.68287 0.40824 -0.32858 0.73793 -0.74414 0.96493 -1.21634 0.2271 -0.47221 0.3458 -0.98915 0.3475 -1.51307 -0.0034 -0.8225 -0.2894 -1.61886 -0.81 -2.25577 -0.52068 -0.6369 -1.24438 -1.07571 -2.05 -1.24295Zm-1.36 4.6583 -3 -0.64976 0.55 -2.59906 3 0.64977c0.34213 0.07423 0.64075 0.28128 0.83016 0.57561 0.18941 0.29432 0.2541 0.65181 0.17984 0.99381 -0.07426 0.34201 -0.28139 0.64052 -0.57582 0.82986 -0.29443 0.18934 -0.65205 0.25401 -0.99418 0.17978l0.01 0.01999Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m4.60147 7.59238 1.99933 0.42993c0.51241 0.11015 1.04295 0.10452 1.5529 -0.01647 0.50995 -0.12099 0.98643 -0.35429 1.39467 -0.68287 0.40824 -0.32857 0.73793 -0.74413 0.96493 -1.21634 0.2271 -0.47221 0.3458 -0.98914 0.3475 -1.51307 -0.0009 -0.20584 -0.0194 -0.41005 -0.0549 -0.61053l0.8216 0.20732c0.3149 0.07948 0.6254 0.18815 0.8885 0.37865 0.2495 0.18065 0.4764 0.39384 0.674 0.63558 0.5206 0.63691 0.8066 1.43326 0.81 2.25576 -0.0017 0.52392 -0.1204 1.04085 -0.3474 1.51306 -0.2271 0.47221 -0.5568 0.88777 -0.965 1.2163 -0.4083 0.3286 -0.8847 0.5619 -1.3947 0.6829 -0.5099 0.121 -1.0405 0.1266 -1.55289 0.0165l-3.43999 -0.7397 -0.82562 3.4604c-0.01309 0.063 -0.03849 0.1228 -0.07473 0.176 -0.03625 0.0533 -0.08263 0.0988 -0.1365 0.1341 -0.05386 0.0353 -0.11416 0.0596 -0.17744 0.0716 -0.06327 0.0119 -0.12829 0.0113 -0.19133 -0.0019l-1.2 -0.2599c-0.1255 -0.0287 -0.23466 -0.1055 -0.3039 -0.214s-0.09298 -0.2399 -0.0661 -0.3658l1.27707 -5.55752Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Paypal"
);
var PlayStation = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M6.45903 0.0890586c-0.22807 -0.072878 -0.47724 -0.0324799 -0.6706 0.1087274 -0.19336 0.141208 -0.30768 0.366252 -0.30768 0.605687V5.70961c0 0.02518 0.00125 0.05013 0.00371 0.07479 -0.00246 0.02472 -0.00372 0.0498 -0.00372 0.07518v7.35502c0 0.4142 0.33579 0.75 0.75 0.75 0.41422 0 0.75 -0.3358 0.75 -0.75V5.85958c0 -0.02037 -0.00081 -0.04055 -0.0024 -0.0605l0 -2.94386c0 -0.34517 0.27982 -0.625 0.625 -0.625s0.625 0.27983 0.625 0.625l0 4.26755 1.37586 0.43191c0.00885 0.00278 0.01775 0.00539 0.02669 0.00784 0.93451 0.2557 1.77491 0.08847 2.37451 -0.47298 0.5669 -0.53088 0.8006 -1.30534 0.8065 -2.04656 0.0119 -1.47165 -0.8763 -3.23735 -2.7609 -3.80614L6.45903 0.0890586Z" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M4.23317 7.8457 1.69426 8.99598C0.942749 9.28783 0.367862 9.74546 0.14237 10.3841c-0.2357904 0.6678 -0.013548 1.3118 0.37104 1.7745 0.74283 0.8937 2.22916 1.3513 3.71976 0.8788v-1.6152l-0.46323 0.1884c-0.9811 0.3071 -1.80027 -0.0466 -2.10296 -0.4108 -0.14135 -0.1701 -0.12595 -0.2717 -0.11019 -0.3163 0.02385 -0.0676 0.14985 -0.2864 0.69516 -0.4949 0.01406 -0.0054 0.02797 -0.0112 0.04168 -0.0174l1.93954 -0.87873 0 -1.64677Z" }),
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m12.2503 12.5861 -4.02197 1.2811V12.293l3.55457 -1.1323c0.5477 -0.1964 0.6491 -0.4058 0.6635 -0.4502 0.01 -0.0305 0.0297 -0.1411 -0.1366 -0.3335 -0.3487 -0.4037 -1.2075 -0.74615 -2.1116 -0.42796l-1.96987 0.71946V9.07158l1.46636 -0.53555c1.47281 -0.52093 2.98711 -0.02309 3.75031 0.86041 0.3899 0.45137 0.6501 1.09636 0.4276 1.77896 -0.2179 0.6683 -0.8207 1.127 -1.5993 1.403 -0.0076 0.0027 -0.0153 0.0052 -0.023 0.0077Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "PlayStation"
);
var PlayStore = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.352234 12.4175V1.30515c0 -0.730373 0.857956 -1.192043 1.556106 -0.837343L12.8444 6.024c0.7183 0.36496 0.7183 1.30973 0 1.67469L1.90834 13.2549c-0.69815 0.3547 -1.556106 -0.107 -1.556106 -0.8374Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.61059 0.365789C1.01277 0.251444 0.40243 0.64332 0.355169 1.23168L5.98444 6.86096 0.355103 12.4903c0.046721 0.5885 0.656627 0.9806 1.254377 0.8669L7.0451 7.92161 8.85109 9.7276l1.40661 -0.71467 -2.15194 -2.15197 2.15134 -2.15138 -1.40661 -0.71467L7.0451 5.8003 1.61059 0.365789Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PlayStore"
);
var Slack = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M9.62995 1.02493C9.62995 0.59695 9.283 0.25 8.85501 0.25c-0.42798 0 -0.77493 0.34695 -0.77493 0.77493v5.10085c0 0.42798 0.34695 0.77493 0.77493 0.77493 0.42799 0 0.77494 -0.34695 0.77494 -0.77493V1.02493ZM5.92072 7.87418c0 -0.42799 -0.34695 -0.77494 -0.77494 -0.77494 -0.42798 0 -0.77493 0.34695 -0.77493 0.77494V12.975c0 0.428 0.34695 0.775 0.77493 0.775 0.42799 0 0.77494 -0.347 0.77494 -0.775V7.87418ZM0.25 5.14578c0 -0.42798 0.34695 -0.77493 0.77493 -0.77493h5.10073c0.42799 0 0.77494 0.34695 0.77494 0.77493 0 0.42799 -0.34695 0.77494 -0.77494 0.77494H1.02493C0.59695 5.92072 0.25 5.57377 0.25 5.14578Zm7.62424 2.9343c-0.42799 0 -0.77494 0.34695 -0.77494 0.77493 0 0.42799 0.34695 0.77494 0.77494 0.77494h5.10096c0.428 0 0.7749 -0.34695 0.7749 -0.77494 0 -0.42798 -0.3469 -0.77493 -0.7749 -0.77493H7.87424Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6 1c-0.55228 0 -1 0.44772 -1 1s0.44772 1 1 1 1 -0.44772 1 -1 -0.44772 -1 -1 -1Zm6 4c-0.5523 0 -1 0.44772 -1 1s0.4477 1 1 1 1 -0.44772 1 -1 -0.4477 -1 -1 -1Zm-5 7c0 -0.5523 0.44772 -1 1 -1s1 0.4477 1 1 -0.44772 1 -1 1 -1 -0.4477 -1 -1ZM2 7c-0.55228 0 -1 0.44772 -1 1s0.44772 1 1 1 1 -0.44772 1 -1 -0.44772 -1 -1 -1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Slack"
);
var Spotify = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 0.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0 -13Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.22 5.705a8.4 8.4 0 0 1 1.94 -0.226c1.416 0 2.748 0.35 3.916 0.97a0.625 0.625 0 1 0 0.585 -1.105 9.586 9.586 0 0 0 -4.5 -1.115 9.65 9.65 0 0 0 -2.23 0.26 0.625 0.625 0 1 0 0.289 1.216Zm1.94 1.774c-0.505 0 -0.997 0.059 -1.467 0.17a0.625 0.625 0 1 1 -0.287 -1.217 7.644 7.644 0 0 1 5.2 0.618 0.625 0.625 0 1 1 -0.565 1.115 6.346 6.346 0 0 0 -2.88 -0.686Zm0 2c-0.345 0 -0.68 0.04 -1.001 0.115a0.625 0.625 0 0 1 -0.285 -1.217 5.64 5.64 0 0 1 3.69 0.39 0.625 0.625 0 1 1 -0.535 1.13 4.356 4.356 0 0 0 -1.868 -0.418Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Spotify"
);
var Telegram = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.25C3.27208 0.25 0.25 3.27208 0.25 7c0 3.7279 3.02208 6.75 6.75 6.75 3.7279 0 6.75 -3.0221 6.75 -6.75C13.75 3.27208 10.7279 0.25 7 0.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2969 3.13171 9.25183 11.0643 7.30336 9.50304 5.61828 11.1069l-0.00004 -2.72603 2.22797 -1.72226c0.21848 -0.16888 0.25868 -0.4829 0.08979 -0.70138 -0.16888 -0.21848 -0.4829 -0.25868 -0.70138 -0.08979L4.54938 7.94317l-2.41773 -0.87612 8.16525 -3.93534Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Telegram"
);
var Tiktok = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9.422 1.14a1 1 0 0 0 -2 0v8.58a1.893 1.893 0 1 1 -1.893 -1.892 1 1 0 1 0 0 -2 3.893 3.893 0 1 0 3.893 3.893V5.283a5.266 5.266 0 0 0 3.288 1.146 1 1 0 1 0 0 -2 3.288 3.288 0 0 1 -3.288 -3.288Z" }),
    " "
  ] }) }),
  "Tiktok"
);
var Tinder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.17695 0.476102C8.02544 0.36247 7.82273 0.344192 7.65334 0.428888c-0.16939 0.084696 -0.27639 0.257827 -0.27639 0.447213 0 1.644869 -0.39587 3.797309 -2.4061 4.656469 -0.2718 -0.39446 -0.5314 -1.06215 -0.5314 -2.03147 0 -0.17329 -0.08973 -0.33422 -0.23714 -0.42532 -0.14741 -0.09111 -0.33148 -0.09939 -0.48647 -0.02189 -1.04573 0.52287 -2.46389 2.00933 -2.46389 4.82221 0 1.88568 0.7121 3.3367 1.80844 4.3112 1.08714 0.9664 2.52252 1.4388 3.94156 1.4388 1.41903 0 2.85442 -0.4724 3.94155 -1.4388 1.0963 -0.9745 1.8084 -2.42552 1.8084 -4.3112 0 -3.77015 -2.83104 -6.09207 -4.57495 -7.399998Z" }),
    " "
  ] }) }),
  "Tinder"
);
var Twitter = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.475 1.163c1.302 -0.335 2.873 0.127 3.83 1.146h1.073a0.5 0.5 0 0 1 0.45 0.717l-1.055 2.187c0.3 2.547 -0.697 4.983 -2.702 6.423 -2.05 1.473 -5.067 1.844 -8.645 0.379a1 1 0 0 1 0.051 -1.889 6.271 6.271 0 0 0 1.564 -0.662A6.02 6.02 0 0 1 0.284 2.915a1 1 0 0 1 1.695 -0.593C3.392 3.711 4.627 4.285 5.483 4.52c0.332 0.091 0.61 0.132 0.822 0.149 -0.066 -0.88 0.084 -1.614 0.416 -2.194 0.404 -0.707 1.047 -1.13 1.754 -1.312Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Twitter"
);
var Whatsapp = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.627 7.003C13.627 3.396 10.614 0.377 7 0.379 3.39 0.381 0.38 3.394 0.38 7.003c0 1.213 0.336 2.412 0.968 3.449L0.41 12.95a0.5 0.5 0 0 0 0.557 0.668l3.28 -0.593A6.64 6.64 0 0 0 7 13.62c3.614 0.002 6.627 -3.008 6.627 -6.618Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.356 10.314c1.091 0.7 2.232 0.098 2.969 -0.498 0.403 -0.326 0.39 -0.92 0.036 -1.298l-0.644 -0.685c-0.193 -0.206 -0.524 -0.207 -0.785 -0.1 -0.312 0.125 -0.68 0.163 -0.965 0.076 -0.946 -0.288 -1.343 -0.78 -1.664 -1.281 -0.256 -0.399 -0.134 -0.934 0.073 -1.333 0.131 -0.253 0.124 -0.587 -0.087 -0.78l-0.692 -0.631c-0.329 -0.3 -0.827 -0.352 -1.13 -0.025 -0.757 0.817 -1.264 2.16 -0.726 2.998 0.919 1.43 2.185 2.638 3.615 3.557Z" }),
      " "
    ] }),
    " "
  ] }) }),
  "Whatsapp"
);
var Windows = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M12.877 0.124 0.883 1.504l-0.002 0A1 1 0 0 0 0 2.46v8.62l0 0.002a1.01 1.01 0 0 0 0.832 0.99l12.01 1.842a1 1 0 0 0 1.158 -0.98V1.112a0.99 0.99 0 0 0 -1.123 -0.988Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m6.625 0.843 -1.25 0.144v5.148H0v1.25h5.375v5.384l1.25 0.192V7.385H14v-1.25H6.625V0.843Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Windows"
);
var Xbox = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.5119 2.68444c-1.4075 0.14757 -3.00292 0.84863 -4.50643 1.91966 0.26126 0.22887 0.51576 0.46616 0.76212 0.71053C10.5014 7.03452 11.918 9.19066 12.4503 11.3929c-0.3177 0.3937 -0.6773 0.7524 -1.0719 1.0691 -0.2688 -2.1326 -1.62593 -4.40975 -3.49111 -6.25992 -0.28714 -0.28482 -0.58367 -0.55691 -0.88704 -0.81457 -0.30336 0.25766 -0.5999 0.52975 -0.88704 0.81457 -1.86528 1.85026 -3.22244 4.12752 -3.49113 6.26022 -0.39464 -0.3167 -0.75423 -0.6753 -1.07202 -1.069 0.53229 -2.20236 1.94889 -4.35867 3.68285 -6.07867 0.24636 -0.24437 0.50086 -0.48166 0.76212 -0.71053 -1.50366 -1.07114 -3.09928 -1.77223 -4.50681 -1.9197 0.31277 -0.39891 0.6679 -0.763 1.05863 -1.08552 1.49288 0.34662 3.03929 1.13682 4.4534 2.1916 1.414 -1.05469 2.96028 -1.84486 4.45305 -2.19152 0.3907 0.32251 0.7458 0.6866 1.0586 1.08548Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Xbox"
);
var XrpCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14c3.866 0 7 -3.134 7 -7 0 -3.86599 -3.134 -7 -7 -7 -3.86599 0 -7 3.13401 -7 7 0 3.866 3.13401 7 7 7Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.58635 3.1313c-0.24408 -0.24408 -0.6398 -0.24408 -0.88388 0 -0.24408 0.24408 -0.24408 0.63981 0 0.88388l2.04382 2.04383c0.16408 0.16516 0.35918 0.29628 0.57409 0.38581 0.21536 0.08972 0.44635 0.13592 0.67964 0.13592 0.2333 0 0.46429 -0.0462 0.67964 -0.13592 0.21491 -0.08953 0.41 -0.22064 0.57408 -0.38579l0.00103 -0.00104 2.04283 -2.04281c0.2441 -0.24407 0.2441 -0.6398 0 -0.88388 -0.2441 -0.24408 -0.63983 -0.24408 -0.88391 0L7.36907 5.17592l-0.0018 0.00181c-0.04809 0.04849 -0.1053 0.08697 -0.16833 0.11323 -0.06303 0.02626 -0.13063 0.03978 -0.19892 0.03978 -0.06828 0 -0.13589 -0.01352 -0.19892 -0.03978 -0.06303 -0.02626 -0.12024 -0.06474 -0.16832 -0.11323l-0.00181 -0.00181L4.58635 3.1313ZM6.8011 8.70903c0.06303 -0.02626 0.13064 -0.03978 0.19892 -0.03978 0.06829 0 0.13589 0.01352 0.19892 0.03978 0.06303 0.02626 0.12024 0.06474 0.16833 0.11322l-0.00001 0 0.00181 0.00182 2.04462 2.04463c0.24408 0.2441 0.63981 0.2441 0.88391 0 0.2441 -0.2441 0.2441 -0.6398 0 -0.8839L8.25477 7.942l-0.00102 -0.00102c-0.16407 -0.16516 -0.35917 -0.29628 -0.57409 -0.38582 -0.21535 -0.08972 -0.44634 -0.13591 -0.67964 -0.13591 -0.23329 0 -0.46428 0.04619 -0.67964 0.13591 -0.21492 0.08954 -0.41003 0.22067 -0.57411 0.38584l-2.0438 2.0438c-0.24408 0.2441 -0.24408 0.6398 0 0.8839 0.24408 0.2441 0.6398 0.2441 0.88388 0l2.04462 -2.04463 0.00181 -0.00182c0.04808 -0.04848 0.10529 -0.08696 0.16832 -0.11322Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "XrpCircle"
);
var Attribution = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 5a1.5 1.5 0 1 0 0 -3 1.5 1.5 0 0 0 0 3Zm1.138 6.66 0.307 -2.451h0.722c0.2 0 0.36 -0.162 0.36 -0.361v-0.723a2.528 2.528 0 0 0 -5.055 0v0.723c0 0.2 0.162 0.36 0.361 0.36h0.722l0.307 2.452a0.5 0.5 0 0 0 0.496 0.438h1.284a0.5 0.5 0 0 0 0.496 -0.438Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Attribution"
);
var ChristianCross1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5 0a0.5 0.5 0 0 0 -0.5 0.5V3H2a0.5 0.5 0 0 0 -0.5 0.5v4A0.5 0.5 0 0 0 2 8h2.5v5.5a0.5 0.5 0 0 0 0.5 0.5h4a0.5 0.5 0 0 0 0.5 -0.5V8H12a0.5 0.5 0 0 0 0.5 -0.5v-4A0.5 0.5 0 0 0 12 3H9.5V0.5A0.5 0.5 0 0 0 9 0H5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChristianCross1"
);
var ChristianCross2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 1.12439c0 -0.552284 -0.44771 -1 -1 -1 -0.55228 0 -1 0.447714 -1 1l0 2.61576H3.38422c-0.55229 0 -1 0.44772 -1 1 0 0.55229 0.44771 1 1 1h2.61577l-0.00001 7.18795c0 0.5523 0.44772 1 1 1 0.55229 0 1 -0.4477 1 -1l0.00001 -7.18795h2.61571c0.5523 0 1 -0.44771 1 -1 0 -0.55228 -0.4477 -1 -1 -1H8l0 -2.61576Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ChristianCross2"
);
var Christianity = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.391 3.326a1 1 0 0 1 0.353 1.37l-0.002 0.002a18.103 18.103 0 0 1 -0.623 0.945c-0.27 0.383 -0.624 0.855 -1.049 1.357a19.931 19.931 0 0 1 1.504 2.032c0.058 0.09 0.115 0.18 0.169 0.271l0 0.001a1 1 0 0 1 -1.721 1.018l-0.03 -0.05a14.644 14.644 0 0 0 -0.506 -0.761 17.983 17.983 0 0 0 -0.804 -1.053c-1.308 1.206 -3.056 2.353 -5.036 2.355a5.935 5.935 0 0 1 -3.175 -0.9A6.178 6.178 0 0 1 0.225 7.452a1 1 0 0 1 0 -0.902 6.178 6.178 0 0 1 2.246 -2.463 5.935 5.935 0 0 1 3.175 -0.899c1.98 0.002 3.728 1.149 5.036 2.355A17.99 17.99 0 0 0 11.89 3.89c0.043 -0.067 0.085 -0.134 0.126 -0.202l0.005 -0.009a1 1 0 0 1 1.37 -0.353Z" }),
    " "
  ] }) }),
  "Christianity"
);
var Circle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " "
  ] }) }),
  "Circle"
);
var ConeShape = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.66 0.643C7.504 0.339 7.21 0.12 6.852 0.12c-0.357 0 -0.651 0.219 -0.808 0.523l-5.037 9.78a1 1 0 0 0 -0.095 0.279l-0.06 0.333a0.5 0.5 0 0 0 -0.008 0.09c0 0.488 0.244 0.906 0.585 1.236 0.34 0.33 0.804 0.602 1.338 0.821 1.07 0.439 2.515 0.698 4.085 0.698 1.57 0 3.013 -0.26 4.084 -0.698 0.534 -0.219 0.999 -0.492 1.338 -0.82 0.341 -0.33 0.585 -0.75 0.585 -1.238 0 -0.03 -0.002 -0.06 -0.008 -0.09l-0.074 -0.402a0.498 0.498 0 0 0 -0.047 -0.139L7.66 0.643Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.852 8.368c-1.57 0 -3.014 0.26 -4.085 0.698 -0.534 0.219 -0.999 0.492 -1.338 0.82 -0.341 0.331 -0.585 0.75 -0.585 1.238 0 0.489 0.244 0.907 0.585 1.237 0.34 0.33 0.804 0.602 1.338 0.821 1.07 0.439 2.515 0.698 4.085 0.698 1.57 0 3.013 -0.26 4.084 -0.698 0.534 -0.219 0.999 -0.492 1.338 -0.82 0.341 -0.33 0.585 -0.75 0.585 -1.238 0 -0.489 -0.244 -0.907 -0.585 -1.237 -0.34 -0.33 -0.804 -0.602 -1.338 -0.821 -1.07 -0.439 -2.515 -0.698 -4.084 -0.698Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "ConeShape"
);
var CreativeCommons = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.86887 6c0 -0.20711 0.16789 -0.375 0.375 -0.375h0.66666c0.1623 0 0.30205 0.10345 0.35383 0.24995 0.11502 0.32545 0.4721 0.49603 0.79755 0.381 0.32545 -0.11503 0.49603 -0.47211 0.381 -0.79755 -0.22278 -0.63031 -0.82386 -1.0834 -1.53238 -1.0834h-0.66666c-0.89747 0 -1.625 0.72754 -1.625 1.625v2c0 0.89746 0.72753 1.625 1.625 1.625h0.66666c0.70851 0 1.30959 -0.45308 1.53237 -1.08338 0.11503 -0.32545 -0.05554 -0.68252 -0.38099 -0.79755 -0.32545 -0.11504 -0.68252 0.05554 -0.79755 0.38099 -0.05178 0.14649 -0.19153 0.24994 -0.35383 0.24994h-0.66666c-0.20711 0 -0.375 -0.16789 -0.375 -0.375V6Zm4.9024 0c0 -0.20711 0.16789 -0.375 0.375 -0.375h0.66667c0.1623 0 0.30206 0.10345 0.35386 0.24995 0.115 0.32545 0.4721 0.49603 0.7975 0.381 0.3255 -0.11503 0.496 -0.47211 0.381 -0.79755 -0.2228 -0.63031 -0.8238 -1.0834 -1.53236 -1.0834h-0.66667c-0.89746 0 -1.625 0.72754 -1.625 1.625v2c0 0.89746 0.72754 1.625 1.625 1.625h0.66667c0.70846 0 1.30956 -0.45308 1.53236 -1.08338 0.115 -0.32545 -0.0555 -0.68252 -0.381 -0.79755 -0.3254 -0.11504 -0.6825 0.05554 -0.7975 0.38099 -0.0518 0.14649 -0.19156 0.24994 -0.35386 0.24994h-0.66667c-0.20711 0 -0.375 -0.16789 -0.375 -0.375V6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CreativeCommons"
);
var DangerousZoneSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.00088 0.00585938c-0.27607 0 -0.54678 0.07618792 -0.78233 0.22017362 -0.23555 0.143986 -0.42681 0.350172 -0.55269 0.595875L0.163964 11.8257c-0.1147897 0.2281 -0.1694323 0.4818 -0.15874325 0.737 0.01070155 0.2555 0.08653225 0.504 0.22029125 0.7219 0.133758 0.2179 0.321004 0.398 0.543955 0.5232 0.22295 0.1252 0.474203 0.1913 0.729903 0.1921l0.00151 0H12.5009l0.0015 0c0.2557 -0.0008 0.5069 -0.0669 0.7299 -0.1921 0.2229 -0.1252 0.4102 -0.3053 0.5439 -0.5232 0.1338 -0.2179 0.2096 -0.4664 0.2203 -0.7219 0.0107 -0.2552 -0.0443 -0.5096 -0.1591 -0.7378L8.33812 0.826281 8.33588 0.821919C8.21 0.576216 8.01876 0.370019 7.78321 0.226033 7.54767 0.0820473 7.27695 0.00585938 7.00088 0.00585938Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.746 4.83005c0.33441 0.24443 0.40736 0.71367 0.16293 1.04808l-1.1505 1.57402h1.96005c0.28241 0 0.54088 0.15865 0.66874 0.41047 0.12785 0.25182 0.10341 0.5541 -0.06325 0.78211L7.3018 11.4113c-0.24443 0.3344 -0.71367 0.4074 -1.04807 0.163 -0.33441 -0.2445 -0.40736 -0.7137 -0.16293 -1.0481l1.1505 -1.57405H5.28125c-0.28241 0 -0.54088 -0.15864 -0.66874 -0.41046 -0.12785 -0.25182 -0.10341 -0.55411 0.06324 -0.78211l2.02218 -2.7666c0.24443 -0.33441 0.71367 -0.40735 1.04807 -0.16293Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DangerousZoneSign"
);
var Dhammajak = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 13.934A6.936 6.936 0 1 0 7 0.062a6.936 6.936 0 0 0 0 13.872Zm0 -5.04a1.898 1.898 0 1 0 0 -3.796 1.898 1.898 0 0 0 0 3.797Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.062c0.21 0 0.419 0.009 0.625 0.027v4.462c0.238 0.061 0.463 0.156 0.67 0.279l3.153 -3.154c0.32 0.268 0.616 0.564 0.883 0.885L9.175 5.717c0.12 0.205 0.214 0.429 0.273 0.666h4.461a7.02 7.02 0 0 1 -0.002 1.25H9.442c-0.06 0.234 -0.154 0.455 -0.276 0.657l3.156 3.156c-0.268 0.32 -0.564 0.616 -0.885 0.883L8.28 9.17c-0.202 0.12 -0.422 0.211 -0.655 0.27v4.465a7.019 7.019 0 0 1 -1.25 0l0 -4.464a2.508 2.508 0 0 1 -0.655 -0.27l-3.157 3.157a6.98 6.98 0 0 1 -0.885 -0.883L4.833 8.29a2.508 2.508 0 0 1 -0.276 -0.658H0.093a7.024 7.024 0 0 1 -0.002 -1.25h4.46c0.06 -0.237 0.153 -0.461 0.274 -0.667L1.669 2.56a7.03 7.03 0 0 1 0.883 -0.885L5.706 4.83c0.206 -0.123 0.43 -0.218 0.669 -0.279l0 -4.462C6.58 0.071 6.789 0.062 7 0.062ZM5.727 6.996a1.273 1.273 0 1 1 2.546 0 1.273 1.273 0 0 1 -2.546 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Dhammajak"
);
var Diamond2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "m3.361 0.779 -0.013 0a1.57 1.57 0 0 0 -1.244 0.67L0.287 3.966l-0.003 0.004a1.55 1.55 0 0 0 0.083 1.897l5.451 6.779a1.499 1.499 0 0 0 2.364 0l5.45 -6.779a1.55 1.55 0 0 0 0.084 -1.897l-0.003 -0.004 -1.817 -2.515a1.57 1.57 0 0 0 -1.244 -0.67l0 -0.001h-7.29Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.054 4.468h3.253L5.029 0.78h1.379L4.685 4.47h4.65L7.62 0.778h1.377l1.716 3.69h3.233a1.55 1.55 0 0 1 -0.205 1.249H10.74L8.844 11.82l-0.663 0.825a1.498 1.498 0 0 1 -1.078 0.573l2.328 -7.5H4.59l2.339 7.502a1.5 1.5 0 0 1 -1.11 -0.575l-0.617 -0.77 -1.92 -6.157H0.259a1.55 1.55 0 0 1 -0.205 -1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Diamond2"
);
var HalfStar1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.518 0.5a0.5 0.5 0 0 0 -0.503 -0.5 1.04 1.04 0 0 0 -0.941 0.61L4.486 3.966a0.48 0.48 0 0 0 -0.007 0.016 0.02 0.02 0 0 1 -0.016 0.012l-0.006 0.001 -3.54 0.51 -0.009 0.001a1.08 1.08 0 0 0 -0.57 1.851L2.89 8.98l0.002 0.002a0.08 0.08 0 0 1 0.022 0.068l-0.638 3.693 0 0.002a1.06 1.06 0 0 0 1.53 1.125l3.199 -1.739a0.09 0.09 0 0 1 0.04 -0.01 0.5 0.5 0 0 0 0.483 -0.5L7.518 0.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "HalfStar1"
);
var Heart = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.024 1.085c0.98 0.071 2.002 0.55 2.98 1.517 0.978 -0.968 1.999 -1.445 2.978 -1.514 1.106 -0.079 2.083 0.368 2.79 1.073 1.39 1.386 1.827 3.895 0.102 5.62a0.488 0.488 0 0 1 -0.018 0.017L7.34 12.795a0.5 0.5 0 0 1 -0.672 0L1.152 7.798a0.504 0.504 0 0 1 -0.018 -0.017c-1.734 -1.734 -1.3 -4.243 0.095 -5.628 0.709 -0.704 1.688 -1.148 2.795 -1.068Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Heart"
);
var Hexagram = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.857 0.564a1 1 0 0 0 -1.714 0L4.67 3.017H1.655a1 1 0 0 0 -0.857 1.515L2.279 7 0.798 9.468a1 1 0 0 0 0.857 1.515H4.67l1.473 2.452a1 1 0 0 0 1.714 0l1.473 -2.452h3.015a1 1 0 0 0 0.857 -1.515L11.721 7l1.481 -2.468a1 1 0 0 0 -0.857 -1.515H9.33L7.857 0.564Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hexagram"
);
var Hinduism = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.112 2.541a1 1 0 1 0 0 -2 1 1 0 0 0 0 2ZM4.42 2.057c-0.48 0 -0.92 0.16 -1.273 0.43a0.75 0.75 0 0 1 -0.911 -1.192 3.599 3.599 0 0 1 5.413 4.451c0.094 0.072 0.185 0.146 0.273 0.225a3.39 3.39 0 0 1 0.553 -0.17 3.934 3.934 0 0 1 3.947 6.32 0.75 0.75 0 0 1 -1.163 -0.95 2.434 2.434 0 0 0 -2.34 -3.93A4.496 4.496 0 1 1 0.443 9.334a0.75 0.75 0 1 1 1.5 0A2.996 2.996 0 1 0 4.94 6.338a0.75 0.75 0 1 1 0 -1.5c0.48 0 0.944 0.076 1.378 0.216A2.099 2.099 0 0 0 4.42 2.057Zm8.917 2.108a0.75 0.75 0 0 0 -1.06 -1.06 1.646 1.646 0 0 1 -2.329 0 0.75 0.75 0 0 0 -1.06 1.06 3.146 3.146 0 0 0 4.449 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Hinduism"
);
var Islam = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.325 0.003a7 7 0 1 0 3.529 12.92 0.5 0.5 0 0 0 -0.264 -0.923 5 5 0 0 1 0 -10 0.5 0.5 0 0 0 0.264 -0.923A7 7 0 0 0 7.325 0.003Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.195 4.944a0.5 0.5 0 0 0 -0.894 0.002l-0.4 0.806h-0.774a0.5 0.5 0 0 0 -0.359 0.848l0.635 0.654 -0.17 0.944a0.5 0.5 0 0 0 0.745 0.52l0.776 -0.454 0.822 0.46a0.5 0.5 0 0 0 0.733 -0.542l-0.201 -0.936 0.627 -0.646a0.5 0.5 0 0 0 -0.358 -0.848h-0.775l-0.407 -0.808Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Islam"
);
var PeaceSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2 7a4.983 4.983 0 0 1 3.981 -4.88v2.75L2.298 8.7A4.972 4.972 0 0 1 2 7Zm1.39 3.451a4.973 4.973 0 0 0 2.591 1.43V7.756L3.39 10.451Zm4.59 -2.695v4.125a4.972 4.972 0 0 0 2.592 -1.43L7.98 7.756Zm3.683 0.945A4.983 4.983 0 0 0 7.98 2.119v2.752l3.683 3.83ZM0 7a6.981 6.981 0 1 1 13.962 0A6.981 6.981 0 0 1 0 7Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PeaceSymbol"
);
var Pentagon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.969 0.665a1.5 1.5 0 0 0 -1.938 0L0.727 5.153a1.5 1.5 0 0 0 -0.424 1.702l2.481 6.202A1.5 1.5 0 0 0 4.177 14h5.646a1.5 1.5 0 0 0 1.393 -0.943l2.48 -6.202a1.5 1.5 0 0 0 -0.423 -1.702L7.969 0.665Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Pentagon"
);
var PolkaDotCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 2.93c-1.51 0 -2.716 1.26 -2.716 2.82a0.625 0.625 0 1 1 -1.25 0c0 -2.2 1.717 -4.07 3.966 -4.07 2.237 0 3.966 1.858 3.966 3.965 0 2.082 -1.705 4.07 -3.966 4.07 -0.536 0 -1.082 0.31 -1.337 0.894l-0.138 0.691a0.625 0.625 0 0 1 -1.226 -0.245l0.093 -0.466a0.624 0.624 0 0 1 0.032 -0.235c0.011 -0.035 0.023 -0.07 0.036 -0.104l0.883 -4.414a0.625 0.625 0 0 1 1.226 0.245l-0.511 2.557c0.301 -0.114 0.621 -0.173 0.942 -0.173 1.497 0 2.716 -1.353 2.716 -2.82C9.716 4.203 8.52 2.929 7 2.929Zm0.943 8.998a0.75 0.75 0 1 0 0 -1.5 0.75 0.75 0 0 0 0 1.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PolkaDotCircle"
);
var Polygon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.914 0a1.5 1.5 0 0 0 -1.06 0.44L0.439 3.853A1.5 1.5 0 0 0 0 4.914v4.172c0 0.398 0.158 0.78 0.44 1.06l3.414 3.415a1.5 1.5 0 0 0 1.06 0.439h4.172a1.5 1.5 0 0 0 1.06 -0.44l3.415 -3.414A1.5 1.5 0 0 0 14 9.086V4.914a1.5 1.5 0 0 0 -0.44 -1.06L10.147 0.439A1.5 1.5 0 0 0 9.086 0H4.914Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Polygon"
);
var PyramidShape = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M13.195 10.9a1 1 0 0 0 0.42 -1.467L7.816 0.75a1 1 0 0 0 -1.663 0l-5.8 8.68a1 1 0 0 0 0.42 1.466l5.594 2.532a1.5 1.5 0 0 0 1.236 0l5.592 -2.529Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M13.195 10.9a1 1 0 0 0 0.42 -1.467L7.816 0.75A0.992 0.992 0 0 0 7 0.306v13.255a1.5 1.5 0 0 0 0.603 -0.133l5.592 -2.529Z" }),
    " "
  ] }) }),
  "PyramidShape"
);
var Radioactive2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.271 2.062a0.75 0.75 0 0 0 -1.061 -1.06 3.942 3.942 0 0 0 -0.826 4.357A3.942 3.942 0 0 0 0.025 8.252a0.75 0.75 0 0 0 1.45 0.389A2.442 2.442 0 0 1 2.91 7.014a4.116 4.116 0 0 0 2.393 4.211 2.442 2.442 0 0 1 -2.1 0.41 0.75 0.75 0 0 0 -0.387 1.45A3.942 3.942 0 0 0 7 11.622l0.038 0.05a3.942 3.942 0 0 0 4.146 1.411 0.75 0.75 0 1 0 -0.387 -1.449 2.442 2.442 0 0 1 -2.1 -0.41 4.116 4.116 0 0 0 2.393 -4.211 2.442 2.442 0 0 1 1.436 1.627 0.75 0.75 0 0 0 1.448 -0.39 3.942 3.942 0 0 0 -3.358 -2.892l0.025 -0.061a3.941 3.941 0 0 0 -0.85 -4.296 0.75 0.75 0 0 0 -1.062 1.06 2.442 2.442 0 0 1 0.687 2.081A4.097 4.097 0 0 0 7 3.359c-0.903 0 -1.738 0.291 -2.416 0.784a2.442 2.442 0 0 1 0.687 -2.081Zm3.264 3.625c0.068 -0.055 0.133 -0.113 0.194 -0.175A2.605 2.605 0 0 0 7 4.86c-0.663 0 -1.268 0.247 -1.729 0.653 0.061 0.062 0.126 0.12 0.194 0.175a3.954 3.954 0 0 1 0.658 0.38 2.442 2.442 0 0 0 1.754 0 3.943 3.943 0 0 1 0.658 -0.38Zm-2.29 3.2a2.442 2.442 0 0 0 -0.877 -1.511 3.942 3.942 0 0 1 -0.659 -0.38 2.444 2.444 0 0 0 -0.263 -0.085 2.617 2.617 0 0 0 1.732 3.047c0.028 -0.096 0.05 -0.195 0.066 -0.295a3.92 3.92 0 0 1 0 -0.776ZM9.29 6.996a2.44 2.44 0 0 1 0.264 -0.085 2.617 2.617 0 0 1 -1.732 3.047 2.442 2.442 0 0 1 -0.067 -0.295 3.922 3.922 0 0 0 0 -0.776 2.442 2.442 0 0 1 0.876 -1.511 3.941 3.941 0 0 0 0.659 -0.38Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Radioactive2"
);
var SignCrossSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.688 0.094a1.5 1.5 0 0 0 -1.5 1.5v10.594a1.5 1.5 0 0 0 1.5 1.5H12.28a1.5 1.5 0 0 0 1.5 -1.5V1.594a1.5 1.5 0 0 0 -1.5 -1.5H1.687Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.188 3.563a0.5 0.5 0 0 0 -0.5 0.5v1.406l-1.407 0a0.5 0.5 0 0 0 -0.5 0.5v1.625a0.5 0.5 0 0 0 0.5 0.5h1.407V9.5a0.5 0.5 0 0 0 0.5 0.5h1.625a0.5 0.5 0 0 0 0.5 -0.5V8.094h1.406a0.5 0.5 0 0 0 0.5 -0.5V5.969a0.5 0.5 0 0 0 -0.5 -0.5l-1.406 0V4.062a0.5 0.5 0 0 0 -0.5 -0.5H6.188Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignCrossSquare"
);
var Skull1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M11.25 10.235a6 6 0 1 0 -8.5 0V13a1 1 0 1 0 2 0v-0.916H6V13a1 1 0 1 0 2 0v-0.916h1.25V13a1 1 0 1 0 2 0v-2.765Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.5 7.334a1.25 1.25 0 1 1 -2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6 7.334a1.25 1.25 0 1 1 -2.5 0 1.25 1.25 0 0 1 2.5 0Z" }),
    " "
  ] }) }),
  "Skull1"
);
var SosHelpEmergencySign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 5.77847c0 -0.95795 0.776572 -1.73452 1.73452 -1.73452h0.85372c0.54885 0 1.04273 0.23957 1.38094 0.61746 0.15906 0.1777 0.28474 0.38695 0.36637 0.61789 0.13803 0.39054 -0.06666 0.81903 -0.4572 0.95707 -0.39054 0.13803 -0.81903 -0.06666 -0.95706 -0.4572 -0.01522 -0.04304 -0.03896 -0.08293 -0.06981 -0.11739 -0.0657 -0.07341 -0.15879 -0.11783 -0.26324 -0.11783h-0.85372c-0.12952 0 -0.23452 0.10499 -0.23452 0.23452 0 0.11021 0.07674 0.20555 0.1844 0.2291l1.2998 0.28433c0.85092 0.18614 1.45698 0.93996 1.45698 1.81046 0 1.023 -0.82924 1.85335 -1.85294 1.85335h-0.7353c-0.80795 0 -1.493298 -0.51669 -1.74731 -1.23536 -0.1380354 -0.39054 0.066658 -0.81903 0.457195 -0.95706 0.390537 -0.13804 0.819025 0.06665 0.957065 0.45719 0.04881 0.13809 0.18055 0.23523 0.33305 0.23523h0.7353c0.19456 0 0.35294 -0.15806 0.35294 -0.35335 0 -0.16612 -0.11575 -0.30972 -0.27752 -0.34511l-1.2998 -0.28433C0.567569 7.29873 0 6.59359 0 5.77847Zm9.55859 0c0 -0.95795 0.77661 -1.73452 1.73451 -1.73452h0.8537c0.5489 0 1.0428 0.23957 1.381 0.61746 0.159 0.1777 0.2847 0.38695 0.3663 0.61789 0.1381 0.39054 -0.0666 0.81903 -0.4572 0.95707 -0.3905 0.13803 -0.819 -0.06666 -0.957 -0.4572 -0.0152 -0.04304 -0.039 -0.08293 -0.0698 -0.11739 -0.0657 -0.07341 -0.1588 -0.11783 -0.2633 -0.11783h-0.8537c-0.1295 0 -0.2345 0.10499 -0.2345 0.23452 0 0.11021 0.0767 0.20555 0.1844 0.2291l1.2998 0.28433c0.8509 0.18614 1.457 0.93996 1.457 1.81046 0 1.023 -0.8293 1.85335 -1.853 1.85335h-0.7353c-0.8079 0 -1.49326 -0.51669 -1.74728 -1.23536 -0.13803 -0.39054 0.06666 -0.81903 0.45718 -0.95706 0.3906 -0.13804 0.819 0.06665 0.9571 0.45719 0.0488 0.13809 0.1805 0.23523 0.333 0.23523h0.7353c0.1946 0 0.353 -0.15806 0.353 -0.35335 0 -0.16612 -0.1158 -0.30972 -0.2775 -0.34511l-1.2998 -0.28433c-0.7963 -0.17419 -1.36391 -0.87933 -1.36391 -1.69445Zm-3.27929 0.11842c0 -0.19493 0.15801 -0.35294 0.35294 -0.35294h0.73529c0.19493 0 0.35294 0.15801 0.35294 0.35294v2.20588c0 0.19492 -0.15801 0.35294 -0.35294 0.35294h-0.73529c-0.19493 0 -0.35294 -0.15802 -0.35294 -0.35294V5.89689Zm0.35294 -1.85294c-1.02335 0 -1.85294 0.82959 -1.85294 1.85294v2.20588c0 1.02335 0.82959 1.85294 1.85294 1.85294h0.73529c1.02335 0 1.85294 -0.82959 1.85294 -1.85294V5.89689c0 -1.02335 -0.82959 -1.85294 -1.85294 -1.85294h-0.73529Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SosHelpEmergencySign"
);
var SpiralShape = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.91917 1.94646C3.47853 1.94646 1.5 3.92499 1.5 6.36563v0.6344c0 2.79101 2.26256 5.05357 5.05358 5.05357H7c3.0376 0 5.5 -2.46243 5.5 -5.49999v-0.44643c0 -0.41421 0.3358 -0.75 0.75 -0.75s0.75 0.33579 0.75 0.75v0.44643c0 3.86599 -3.134 6.99999 -7 6.99999h-0.44642C2.93414 13.5536 0 10.6195 0 7.00003v-0.6344C0 3.09657 2.6501 0.446465 5.91917 0.446465c2.98359 0 5.40223 2.418675 5.40223 5.402255v0.43016c0 2.53839 -2.05774 4.59612 -4.59613 4.59612h-0.1717c-2.1401 0 -3.875 -1.73486 -3.875 -3.87496v-0.44643c0 -1.89355 1.53503 -3.42857 3.42857 -3.42857 1.40044 0 2.53572 1.13527 2.53572 2.53571v0.2551c0 1.25955 -1.02107 2.28061 -2.28061 2.28061h-0.25511c-0.41421 0 -0.75 -0.33578 -0.75 -0.75 0 -0.41421 0.33579 -0.75 0.75 -0.75h0.25511c0.43112 0 0.78061 -0.34949 0.78061 -0.78061v-0.2551c0 -0.57201 -0.46371 -1.03571 -1.03572 -1.03571 -1.06512 0 -1.92857 0.86345 -1.92857 1.92857v0.44643c0 1.31167 1.06333 2.375 2.375 2.375h0.1717c1.70996 0 3.09616 -1.3862 3.09616 -3.09616v-0.43016c0 -2.15516 -1.7471 -3.90226 -3.90226 -3.90226Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SpiralShape"
);
var Star1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.277a1.04 1.04 0 0 0 -0.94 0.596L4.472 4.078a0.495 0.495 0 0 0 -0.012 0.023 0.486 0.486 0 0 0 -0.023 0.004L0.94 4.623a1.04 1.04 0 0 0 -0.617 1.788l2.56 2.469 0.006 0.005a0.03 0.03 0 0 1 0.009 0.027l0 0.004 -0.61 3.568 0 0.001a1.05 1.05 0 0 0 1.526 1.107l3.15 -1.665a0.09 0.09 0 0 1 0.072 0l3.15 1.664a1.049 1.049 0 0 0 1.527 -1.106l-0.61 -3.57 0 -0.003c-0.002 -0.004 -0.001 -0.01 0 -0.014a0.03 0.03 0 0 1 0.008 -0.013l0.006 -0.005 2.559 -2.47a1.04 1.04 0 0 0 -0.617 -1.787l-3.496 -0.518a0.486 0.486 0 0 0 -0.023 -0.004 0.495 0.495 0 0 0 -0.012 -0.023L7.94 0.873A1.04 1.04 0 0 0 7 0.277Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Star1"
);
var Star2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.94 0.66c-0.32 -0.877 -1.56 -0.877 -1.88 0L4.62 4.62 0.66 6.06c-0.877 0.32 -0.877 1.56 0 1.88l3.96 1.44 1.44 3.96c0.32 0.877 1.56 0.877 1.88 0l1.44 -3.96 3.96 -1.44c0.877 -0.32 0.877 -1.56 0 -1.88L9.38 4.62 7.94 0.66Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Star2"
);
var StarBadge = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.022 7.544 -0.456 -0.376 -0.295 0.512 -2.204 3.818a0.5 0.5 0 0 0 0.562 0.732l1.899 -0.508 0.508 1.898a0.5 0.5 0 0 0 0.916 0.12l1.913 -3.311 0.211 -0.367 -0.326 -0.27 -2.728 -2.248Zm7.956 0 0.456 -0.376 0.295 0.512 2.204 3.818a0.5 0.5 0 0 1 -0.563 0.732l-1.898 -0.508 -0.509 1.898a0.5 0.5 0 0 1 -0.916 0.12l-1.912 -3.31 -0.212 -0.367 0.327 -0.27 2.728 -2.248Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.997 0.009a5.125 5.125 0 1 0 0 10.25 5.125 5.125 0 0 0 0 -10.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m7.2 2.433 0.683 1.373a0.214 0.214 0 0 0 0.174 0.127l1.516 0.23a0.23 0.23 0 0 1 0.127 0.397L8.581 5.624a0.222 0.222 0 0 0 0 0.206l0.214 1.509a0.23 0.23 0 0 1 -0.34 0.246l-1.35 -0.715a0.27 0.27 0 0 0 -0.223 0l-1.35 0.715a0.23 0.23 0 0 1 -0.34 -0.246l0.253 -1.509a0.222 0.222 0 0 0 -0.04 -0.206L4.287 4.552a0.23 0.23 0 0 1 0.127 -0.389l1.517 -0.222a0.214 0.214 0 0 0 0.174 -0.127l0.683 -1.374a0.23 0.23 0 0 1 0.413 -0.007Z" }),
    " "
  ] }) }),
  "StarBadge"
);
var TriangleFlag = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.89 0.112a0.5 0.5 0 0 0 -0.448 0.894l0.224 0.112v7.8l-0.224 0.112a0.5 0.5 0 1 0 0.447 0.895l8.919 -4.46a0.5 0.5 0 0 0 0 -0.894L2.889 0.11Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.666 0.044a0.75 0.75 0 0 1 0.75 0.75l0 12.412a0.75 0.75 0 0 1 -1.5 0l0 -12.412a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TriangleFlag"
);
var WarningOctagon = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4.914 0a1.5 1.5 0 0 0 -1.06 0.44L0.439 3.853A1.5 1.5 0 0 0 0 4.914v4.172c0 0.398 0.158 0.78 0.44 1.06l3.414 3.415a1.5 1.5 0 0 0 1.06 0.439h4.172a1.5 1.5 0 0 0 1.06 -0.44l3.415 -3.414A1.5 1.5 0 0 0 14 9.086V4.914a1.5 1.5 0 0 0 -0.44 -1.06L10.147 0.439A1.5 1.5 0 0 0 9.086 0H4.914Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 3.875a0.75 0.75 0 0 0 -1.5 0v3.25a0.75 0.75 0 0 0 1.5 0v-3.25Zm-0.75 7a1 1 0 1 0 0 -2 1 1 0 0 0 0 2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WarningOctagon"
);
var YinYangSymbol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.473 0.016c-0.316 0.263 -3.69 3.216 -0.476 6.98 3.239 3.796 -0.215 6.766 -0.484 6.987 0.089 0.006 0.178 0.01 0.267 0.014h0.44A7 7 0 0 0 7.473 0.016Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M9.092 5.25a1.236 1.236 0 1 0 0 -2.473 1.236 1.236 0 0 0 0 2.473Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M5.26 11.226a1.236 1.236 0 1 0 0 -2.472 1.236 1.236 0 0 0 0 2.472Z" }),
    " "
  ] }) }),
  "YinYangSymbol"
);
var Ampersand = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.19237 1.75841c-0.23294 0.1577 -0.49859 0.46922 -0.49859 1.2356 0 0.20446 0.10699 0.55556 0.4221 1.06886 0.20935 0.34103 0.4863 0.71512 0.81902 1.1142 0.05349 -0.04735 0.12431 -0.11095 0.20724 -0.18756 0.19463 -0.1798 0.45165 -0.42733 0.70635 -0.70203 0.25762 -0.27786 0.4973 -0.56689 0.66802 -0.83027 0.08497 -0.13109 0.14414 -0.24257 0.18042 -0.33223 0.03478 -0.08596 0.03828 -0.12676 0.03862 -0.13068 0.00003 -0.00034 0.00004 -0.0004 0.00004 -0.0002 0 -0.57975 -0.18781 -0.92699 -0.41653 -1.13538C6.07892 1.63993 5.71113 1.5 5.23452 1.5c-0.36229 0 -0.75691 0.0653 -1.04215 0.25841Zm1.74864 4.5313c0.05883 -0.05221 0.13331 -0.11924 0.21898 -0.19839 0.21304 -0.19681 0.49959 -0.47244 0.78845 -0.78399 0.28594 -0.30839 0.58982 -0.66869 0.82677 -1.03424 0.21865 -0.33732 0.46038 -0.79749 0.46038 -1.27899 0 -0.93418 -0.31891 -1.709 -0.9063 -2.244176C6.75331 0.225151 5.99556 0 5.23452 0c-0.48368 0 -1.23443 0.077164 -1.88307 0.51629 -0.70094 0.474536 -1.15767 1.28502 -1.15767 2.47772 0 0.6254 0.28419 1.26789 0.64375 1.85361 0.25952 0.42275 0.58818 0.86308 0.96149 1.30946l-1.84615 1.5912C0.517435 8.98549 0.303932 11.1308 1.46737 12.6267c1.28716 1.6549 3.71913 1.8433 5.24584 0.4064l2.15376 -2.0271c0.56218 0.4766 1.10259 0.9253 1.59173 1.3299 0.1042 0.0862 0.206 0.1703 0.305 0.2522 0.5086 0.4203 0.9451 0.781 1.2802 1.0683 0.3145 0.2696 0.788 0.2332 1.0576 -0.0813 0.2695 -0.3145 0.2331 -0.788 -0.0814 -1.0575 -0.3464 -0.297 -0.7959 -0.6684 -1.304 -1.0884 -0.0984 -0.0813 -0.1989 -0.1644 -0.3013 -0.2491 -0.45 -0.3723 -0.94 -0.779 -1.44848 -1.20875l1.01598 -0.95618c0.3016 -0.28389 0.316 -0.75854 0.0321 -1.06017 -0.2839 -0.30163 -0.7586 -0.31602 -1.06019 -0.03213L8.8214 8.98904c-1.00962 -0.8812 -2.02024 -1.80861 -2.88039 -2.69933Zm-1.13715 0.98157L2.93217 8.88449c-0.83014 0.7155 -0.95361 1.95621 -0.28077 2.82121 0.74439 0.9571 2.15084 1.0661 3.03376 0.2351l2.03876 -1.9188c-1.0102 -0.88503 -2.0362 -1.83017 -2.92006 -2.75072Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Ampersand"
);
var Asterisk1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0.0905762c0.55229 0 1 0.4477148 1 1.0000038v4.08776l3.4634 -2.204c0.466 -0.29651 1.0841 -0.15916 1.3806 0.30679 0.2965 0.46594 0.1591 1.08402 -0.3068 1.38053L8.86266 6.99999l3.67454 2.33833c0.4659 0.29651 0.6033 0.91458 0.3068 1.38058 -0.2965 0.4659 -0.9146 0.6033 -1.3806 0.3067L8 8.82165v4.08775c0 0.5523 -0.44771 1 -1 1 -0.55228 0 -1 -0.4477 -1 -1V8.82169L2.53664 11.0256c-0.46595 0.2966 -1.08403 0.1592 -1.38054 -0.3067 -0.29651 -0.466 -0.159157 -1.08407 0.30678 -1.38058L5.1374 6.99999 1.46288 4.66166c-0.465937 -0.29651 -0.60329 -0.91459 -0.30678 -1.38053 0.29651 -0.46595 0.91459 -0.6033 1.38054 -0.30679L6 5.1783V1.09058C6 0.538291 6.44772 0.0905762 7 0.0905762Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Asterisk1"
);
var BulletList = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 3.5a1 1 0 1 0 0 -2 1 1 0 0 0 0 2ZM2 7a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Zm0 4.5a1 1 0 1 1 -2 0 1 1 0 0 1 2 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 2.5a0.75 0.75 0 0 1 0.75 -0.75h8.5a0.75 0.75 0 0 1 0 1.5h-8.5A0.75 0.75 0 0 1 4 2.5ZM4 7a0.75 0.75 0 0 1 0.75 -0.75h8.5a0.75 0.75 0 0 1 0 1.5h-8.5A0.75 0.75 0 0 1 4 7Zm0.75 3.75a0.75 0.75 0 0 0 0 1.5h8.5a0.75 0.75 0 0 0 0 -1.5h-8.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "BulletList"
);
var DivisionCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 0.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.125 4.136a0.875 0.875 0 1 0 1.75 0 0.875 0.875 0 0 0 -1.75 0Zm-2.706 2.87c0 -0.346 0.28 -0.625 0.625 -0.625h5.977a0.625 0.625 0 0 1 0 1.25H4.044a0.625 0.625 0 0 1 -0.625 -0.625Zm2.706 2.87a0.875 0.875 0 1 0 1.75 0 0.875 0.875 0 0 0 -1.75 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DivisionCircle"
);
var EqualSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 3.5c-0.552285 0 -1 0.44772 -1 1s0.447715 1 1 1h12c0.5523 0 1 -0.44772 1 -1s-0.4477 -1 -1 -1H1Zm0 5c-0.552285 0 -1 0.44772 -1 1 0 0.5523 0.447715 1 1 1h12c0.5523 0 1 -0.4477 1 -1 0 -0.55228 -0.4477 -1 -1 -1H1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "EqualSign"
);
var Factorial = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.46033 6.0652c0 -1.4783 1.20288 -2.6819 2.69313 -2.6819s2.69313 1.2036 2.69313 2.6819v6.9036c0 0.5522 0.44771 1 1 1 0.55228 0 1 -0.4478 1 -1V6.0652c0 -2.58861 -2.10406 -4.6819 -4.69313 -4.6819 -1.00613 0 -1.93901 0.31611 -2.70363 0.85457 -0.07043 -0.48336 -0.48661 -0.85457 -0.9895 -0.85457 -0.552288 0 -1.000003 0.44772 -1.000003 1v10.5855c0 0.5522 0.447715 1 1.000003 1 0.55228 0 1 -0.4478 1 -1V6.0652Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12.0781 0.078125c0.5522 0 1 0.447715 1 0.999995l0 7.85926c0 0.55228 -0.4478 1 -1 1 -0.5523 0 -1 -0.44772 -1 -1l0 -7.85926c0 -0.55228 0.4477 -0.999995 1 -0.999995ZM10.6164 12.4612c0 -0.8073 0.6544 -1.4617 1.4616 -1.4617 0.8073 0 1.4617 0.6544 1.4617 1.4617 0 0.8072 -0.6544 1.4616 -1.4617 1.4616 -0.8072 0 -1.4616 -0.6544 -1.4616 -1.4616Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Factorial"
);
var Heading1ParagraphStylesHeading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.75 1.25a0.75 0.75 0 0 0 -1.5 0v11.5a0.75 0.75 0 0 0 1.5 0V7.27H6v5.48a0.75 0.75 0 0 0 1.5 0V1.25a0.75 0.75 0 0 0 -1.5 0v4.52H1.75V1.25Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.145 7.445a0.75 0.75 0 0 0 -1.5 0c0 0.29 -0.235 0.524 -0.524 0.524h-0.425a0.75 0.75 0 1 0 0 1.5h0.425c0.18 0 0.356 -0.024 0.523 -0.069V12h-0.948a0.75 0.75 0 0 0 0 1.5h3.397a0.75 0.75 0 0 0 0 -1.5h-0.949V7.655a0.766 0.766 0 0 0 -0.004 -0.078 1.94 1.94 0 0 0 0.005 -0.132Z" }),
    " "
  ] }) }),
  "Heading1ParagraphStylesHeading"
);
var Heading2ParagraphStylesHeading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.75 1.25a0.75 0.75 0 0 0 -1.5 0v11.5a0.75 0.75 0 0 0 1.5 0V7.27H6v5.48a0.75 0.75 0 0 0 1.5 0V1.25a0.75 0.75 0 0 0 -1.5 0v4.52H1.75V1.25Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.854 6.695c-0.9 0 -1.624 0.611 -1.885 1.398a0.75 0.75 0 0 0 1.424 0.472c0.08 -0.243 0.278 -0.37 0.46 -0.37h0.862c0.21 0 0.461 0.196 0.461 0.542a0.55 0.55 0 0 1 -0.293 0.504l-1.845 0.86c-0.735 0.344 -1.178 1.098 -1.178 1.895v0.754c0 0.414 0.336 0.75 0.75 0.75h3.316a0.75 0.75 0 0 0 0 -1.5H10.36v-0.004c0 -0.256 0.142 -0.456 0.313 -0.535l1.845 -0.861c0.722 -0.337 1.158 -1.079 1.158 -1.863 0 -1.081 -0.833 -2.042 -1.961 -2.042h-0.861Z" }),
    " "
  ] }) }),
  "Heading2ParagraphStylesHeading"
);
var Heading3ParagraphStylesHeading = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.75 1.25a0.75 0.75 0 0 0 -1.5 0v11.5a0.75 0.75 0 0 0 1.5 0V7.27H6v5.48a0.75 0.75 0 0 0 1.5 0V1.25a0.75 0.75 0 0 0 -1.5 0v4.52H1.75V1.25Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m11.562 6.695 -0.663 0c-0.901 0 -1.659 0.605 -1.892 1.43a0.75 0.75 0 1 0 1.444 0.408 0.466 0.466 0 0 1 0.448 -0.338l0.663 0a0.466 0.466 0 0 1 0 0.931h-0.332a0.75 0.75 0 0 0 0 1.5l0.442 0c0.319 0 0.577 0.258 0.577 0.577l0 0.22a0.576 0.576 0 0 1 -0.577 0.577l-0.884 0a0.577 0.577 0 0 1 -0.543 -0.384 0.75 0.75 0 0 0 -1.415 0.5 2.077 2.077 0 0 0 1.958 1.384l0.884 0c1.147 0 2.077 -0.93 2.077 -2.076v-0.221a2.07 2.07 0 0 0 -0.568 -1.427 1.966 1.966 0 0 0 -1.619 -3.081Z" }),
    " "
  ] }) }),
  "Heading3ParagraphStylesHeading"
);
var InputBox = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1 4.5h12s1 0 1 1v3s0 1 -1 1H1s-1 0 -1 -1v-3s0 -1 1 -1" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.25 2.5A0.75 0.75 0 0 1 4 1.75h2a0.75 0.75 0 0 1 0 1.5h-0.25v7.5H6a0.75 0.75 0 0 1 0 1.5H4a0.75 0.75 0 0 1 0 -1.5h0.25v-7.5H4a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "InputBox"
);
var NotEqualSign = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1 3.5c-0.552285 0 -1 0.44772 -1 1s0.447715 1 1 1h12c0.5523 0 1 -0.44772 1 -1s-0.4477 -1 -1 -1H1Zm0 5c-0.552285 0 -1 0.44772 -1 1 0 0.5523 0.447715 1 1 1h12c0.5523 0 1 -0.4477 1 -1 0 -0.55228 -0.4477 -1 -1 -1H1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.7049 0.11954c0.4862 0.261838 0.6682 0.8683 0.4063 1.35457L4.6497 13.4741c-0.26184 0.4863 -0.8683 0.6682 -1.35457 0.4064 -0.48628 -0.2619 -0.66821 -0.8683 -0.40638 -1.3546L9.35029 0.525911c0.26184 -0.4862708 0.86831 -0.668209 1.35461 -0.406371Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "NotEqualSign"
);
var Paragraph = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.786 0a4.786 4.786 0 1 0 0 9.573h0.943v3.677a0.75 0.75 0 0 0 1.5 0V8.827l0 -0.004V1.5h2.146v11.75a0.75 0.75 0 0 0 1.5 0V1.5h2.375a0.75 0.75 0 0 0 0 -1.5H4.786Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Paragraph"
);
var PiSymbolCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.25a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 7 0.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.912 3.381a0.625 0.625 0 1 1 0.175 1.238L10 4l-0.088 -0.619Zm-0.787 1.375a530.534 530.534 0 0 1 0.782 -0.112l0.134 -0.019 0.035 -0.004 0.008 -0.002 0.003 0L10 4l-0.088 -0.619 -0.003 0 -0.009 0.002 -0.035 0.005 -0.134 0.019a443.255 443.255 0 0 0 -2.003 0.29c-1.13 0.165 -2.39 0.356 -2.801 0.44 -0.924 0.191 -1.403 0.967 -1.531 1.454a0.625 0.625 0 1 0 1.208 0.318 0.838 0.838 0 0 1 0.185 -0.316 0.718 0.718 0 0 1 0.39 -0.23c0.049 -0.011 0.113 -0.023 0.19 -0.037 -0.01 0.557 -0.04 1.224 -0.121 1.89 -0.127 1.028 -0.364 1.914 -0.742 2.4a0.625 0.625 0 0 0 0.988 0.767c0.603 -0.777 0.866 -1.968 0.994 -3.015 0.1 -0.815 0.127 -1.625 0.135 -2.243 0.394 -0.06 0.827 -0.124 1.252 -0.187v4.536c0 0.205 0.065 0.485 0.262 0.725 0.218 0.266 0.552 0.426 0.963 0.426 0.79 0 1.282 -0.56 1.443 -0.842a0.625 0.625 0 0 0 -1.086 -0.619s-0.003 0.006 -0.01 0.014a0.576 0.576 0 0 1 -0.12 0.117 0.394 0.394 0 0 1 -0.202 0.079V4.756Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "PiSymbolCircle"
);
var Quotation2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.49 3.877a0.75 0.75 0 1 0 -1.48 0.246l0.5 3a0.75 0.75 0 0 0 1.48 -0.246l-0.5 -3Zm2.5 0a0.75 0.75 0 1 0 -1.48 0.246l0.5 3a0.75 0.75 0 0 0 1.48 -0.246l-0.5 -3Zm7.133 2.383a0.75 0.75 0 0 1 0.617 0.863l-0.5 3a0.75 0.75 0 1 1 -1.48 -0.246l0.5 -3a0.75 0.75 0 0 1 0.863 -0.617Zm2.867 0.863a0.75 0.75 0 1 0 -1.48 -0.246l-0.5 3a0.75 0.75 0 1 0 1.48 0.246l0.5 -3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Quotation2"
);
var Sigma = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.418 2.268C-0.366 1.48 0.184 0.126 1.305 0.126h11.9a0.744 0.744 0 1 1 0 1.489H1.87l4.843 4.86c0.29 0.29 0.29 0.76 0 1.05l-4.843 4.86h11.337a0.744 0.744 0 1 1 0 1.49h-11.9c-1.122 0 -1.672 -1.355 -0.888 -2.142L5.134 7 0.418 2.268Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Sigma"
);
var SignAt = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.00427 0.0299354V0.0299072l-0.00651 0.0000201C5.96744 0.0331094 4.95064 0.264674 4.02054 0.707954 3.09044 1.15123 2.27019 1.7952 1.61881 2.59351 0.967442 3.39181 0.501154 4.3246 0.253514 5.32473 0.00587445 6.32485 -0.0169584 7.36744 0.186659 8.37745 0.390277 9.38746 0.815281 10.3398 1.43108 11.1658c0.6158 0.8261 1.40707 1.5053 2.31687 1.9889 0.9098 0.4836 1.91549 0.7594 2.94469 0.8077 1.0292 0.0483 2.0563 -0.1322 3.00738 -0.5284 0.38238 -0.1593 0.56318 -0.5985 0.40388 -0.9808 -0.15933 -0.3824 -0.59844 -0.5632 -0.98079 -0.4039 -0.7464 0.311 -1.55246 0.4527 -2.36017 0.4148 -0.80771 -0.0379 -1.59697 -0.2544 -2.31098 -0.6339 -0.714 -0.3795 -1.33499 -0.9126 -1.81827 -1.5609 -0.48328 -0.64827 -0.81682 -1.39564 -0.97661 -2.18829 -0.1598 -0.79265 -0.14188 -1.61087 0.05246 -2.39576 0.19435 -0.78489 0.56029 -1.51694 1.07148 -2.14345 0.5112 -0.6265 1.15493 -1.13188 1.88486 -1.47977 0.72896 -0.34742 1.52578 -0.52912 2.33326 -0.5321 0.96315 0.00595 1.90824 0.26216 2.74252 0.74354 0.83524 0.48192 1.53064 1.17291 2.01794 2.00504l-0.0001 0.00004 0.0057 0.00945c1.1988 1.97988 0.6106 3.51442 -0.0948 4.19887 -0.3904 0.37881 -0.71 0.41704 -0.8076 0.39445 -0.0248 -0.00574 -0.0506 -0.01486 -0.0851 -0.0711 -0.044 -0.07166 -0.109 -0.23925 -0.109 -0.56618V7.00002l0 -0.00657c-0.0008 -0.47835 -0.0964 -0.95181 -0.2813 -1.39304 -0.1857 -0.44328 -0.45779 -0.84514 -0.80044 -1.18217 -0.34264 -0.33702 -0.74895 -0.60246 -1.19523 -0.78083 -0.44629 -0.17838 -0.92362 -0.26612 -1.40417 -0.25811 -0.71344 0.0119 -1.40746 0.23432 -1.99491 0.63934 -0.58745 0.40502 -1.04213 0.97458 -1.30695 1.63716 -0.26482 0.66257 -0.32797 1.38862 -0.18152 2.08697s0.49597 1.33786 1.00467 1.83822c0.5087 0.50031 1.1539 0.83931 1.85457 0.97411 0.70068 0.1349 1.42558 0.0598 2.08369 -0.2159 0.40097 -0.168 0.76625 -0.40594 1.07988 -0.70056 0.24062 0.36816 0.59071 0.60996 0.99761 0.70406 0.798 0.1846 1.6154 -0.2215 2.1903 -0.77929 1.2245 -1.18802 1.8803 -3.49349 0.3363 -6.04762 -0.6187 -1.05464 -1.5008 -1.93046 -2.5599 -2.541561C9.4306 0.362208 8.22887 0.0367771 7.00427 0.0299354ZM7.01256 4.8791c0.28147 -0.0047 0.56106 0.0467 0.82246 0.15117 0.2614 0.10448 0.49939 0.25996 0.70008 0.45736 0.2007 0.19741 0.36009 0.43279 0.46887 0.69243 0.10878 0.25964 0.16479 0.53834 0.16475 0.81985 -0.00006 0.41794 -0.1236 0.82655 -0.35511 1.1745 -0.23151 0.34796 -0.56068 0.61976 -0.94615 0.78127 -0.38547 0.1615 -0.81007 0.20552 -1.22047 0.12651 -0.41041 -0.07901 -0.78832 -0.27752 -1.08628 -0.57059 -0.29796 -0.29308 -0.50268 -0.66766 -0.58846 -1.0767 -0.08578 -0.40904 -0.0488 -0.83431 0.10632 -1.2224 0.15511 -0.38809 0.42143 -0.7217 0.76552 -0.95893 0.34408 -0.23723 0.75059 -0.36751 1.16847 -0.37447Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignAt"
);
var SignHashtag = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11.178 0.09a0.75 0.75 0 0 1 0.594 0.879l-0.513 2.67h1.913a0.75 0.75 0 1 1 0 1.5h-2.201l-0.716 3.722h2.917a0.75 0.75 0 1 1 0 1.5H9.966l-0.568 2.953a0.75 0.75 0 1 1 -1.473 -0.283l0.514 -2.67H4.743l-0.568 2.953a0.75 0.75 0 1 1 -1.473 -0.283l0.514 -2.67H0.827a0.75 0.75 0 0 1 0 -1.5h2.677l0.716 -3.723H0.827a0.75 0.75 0 1 1 0 -1.5H4.51L5.076 0.686A0.75 0.75 0 1 1 6.55 0.969l-0.513 2.67h3.696L10.3 0.686a0.75 0.75 0 0 1 0.879 -0.595Zm-5.43 5.048 -0.716 3.723h3.695l0.716 -3.723H5.748Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SignHashtag"
);
var SquareRootXCircle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.75 0a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0 -13.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.39 3.471a0.625 0.625 0 0 0 -0.616 0.518l-0.667 3.836 -0.286 -0.4a0.625 0.625 0 1 0 -1.017 0.727l1.154 1.615a0.625 0.625 0 0 0 1.124 -0.256l0.833 -4.79h3.397a0.625 0.625 0 1 0 0 -1.25H5.39Zm4.259 2.776a0.625 0.625 0 0 0 -0.882 0.057l-0.642 0.73 -0.642 -0.73a0.625 0.625 0 1 0 -0.939 0.825l0.75 0.852 -0.889 1.01a0.625 0.625 0 1 0 0.94 0.825l0.78 -0.888 0.78 0.888a0.625 0.625 0 1 0 0.94 -0.825l-0.888 -1.01 0.749 -0.852a0.625 0.625 0 0 0 -0.057 -0.882Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "SquareRootXCircle"
);
var TaskList = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.719 0a1.5 1.5 0 0 0 -1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5 -1.5V4.914a1.5 1.5 0 0 0 -0.44 -1.06L8.365 0.439A1.5 1.5 0 0 0 7.305 0H1.719Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.28 6.375a0.75 0.75 0 0 1 0.75 -0.75l2.5 0a0.75 0.75 0 0 1 0 1.5l-2.5 0a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.28 10.344a0.75 0.75 0 0 1 0.75 -0.75l2.5 0a0.75 0.75 0 0 1 0 1.5l-2.5 0a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.33 8.56a0.75 0.75 0 0 1 0.175 1.046L4.108 11.56a0.75 0.75 0 0 1 -1.14 0.094l-0.838 -0.837a0.75 0.75 0 0 1 1.06 -1.061l0.212 0.212 0.882 -1.235A0.75 0.75 0 0 1 5.33 8.56Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.33 4.528a0.75 0.75 0 0 1 0.175 1.047L4.108 7.53a0.75 0.75 0 0 1 -1.14 0.094l-0.838 -0.838a0.75 0.75 0 0 1 1.06 -1.06l0.212 0.211 0.882 -1.234a0.75 0.75 0 0 1 1.046 -0.175Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TaskList"
);
var TextFlowRows = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.50001 2.75c-0.41422 0 -0.75 -0.33579 -0.75 -0.75s0.33578 -0.75 0.75 -0.75H12c0.3034 0 0.5768 0.18273 0.6929 0.46299 0.1161 0.28025 0.0519 0.60284 -0.1626 0.81734L4.31067 10.75H10.5V9.5c0 -0.20223 0.1218 -0.38455 0.3087 -0.46194 0.1868 -0.07739 0.4019 -0.03461 0.5449 0.10839l2 1.99995c0.1952 0.1953 0.1952 0.5119 0 0.7072l-2 2c-0.143 0.143 -0.3581 0.1857 -0.5449 0.1083 -0.1869 -0.0774 -0.3087 -0.2597 -0.3087 -0.4619v-1.25H2.50001c-0.30335 0 -0.57683 -0.1827 -0.69291 -0.463 -0.11609 -0.2802 -0.05192 -0.6028 0.16258 -0.8173L10.1893 2.75H2.50001Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.499924 0.500015C0.499915 0.223867 0.723775 0 0.999924 0H4.00005c0.27613 0 0.49999 0.223848 0.5 0.499985l0.00009 2.999995c0.00001 0.27615 -0.22385 0.50002 -0.5 0.50002H1.00002c-0.276141 0 -0.499996 -0.22385 -0.500005 -0.49998L0.499924 0.500015ZM9.5 0.5c0 -0.276142 0.22386 -0.5 0.5 -0.5h3c0.2761 0 0.5 0.223858 0.5 0.5v3c0 0.27614 -0.2239 0.5 -0.5 0.5h-3c-0.27614 0 -0.5 -0.22386 -0.5 -0.5v-3ZM1 9.5c-0.276142 0 -0.5 0.22386 -0.5 0.5v3c0 0.2761 0.223858 0.5 0.5 0.5h3c0.27614 0 0.5 -0.2239 0.5 -0.5v-3c0 -0.27614 -0.22386 -0.5 -0.5 -0.5H1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TextFlowRows"
);
var TextSquare = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5v-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 3.875a0.242 0.242 0 0 0 -0.23 0.166L5.575 7.625h2.85L7.23 4.041A0.242 0.242 0 0 0 7 3.875Zm2.88 4.164L8.416 3.645a1.492 1.492 0 0 0 -2.832 0L4.12 8.04a0.624 0.624 0 0 0 -0.01 0.027l-0.828 2.486a0.625 0.625 0 1 0 1.186 0.396l0.69 -2.073h3.683l0.691 2.073a0.625 0.625 0 1 0 1.186 -0.396l-0.829 -2.486a0.626 0.626 0 0 0 -0.009 -0.027Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TextSquare"
);
var TextStyle = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.5 1.5c-0.11 0 -0.25 0.102 -0.25 0.292v1.042a0.75 0.75 0 0 1 -1.5 0V1.792C0.75 0.832 1.505 0 2.5 0h9c0.995 0 1.75 0.832 1.75 1.792v1.042a0.75 0.75 0 0 1 -1.5 0V1.792c0 -0.19 -0.14 -0.292 -0.25 -0.292H7.75v11H9.5a0.75 0.75 0 0 1 0 1.5H7.027a0.784 0.784 0 0 1 -0.054 0H4.5a0.75 0.75 0 0 1 0 -1.5h1.75v-11H2.5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TextStyle"
);
var UnderlineText1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M4 0a0.75 0.75 0 0 1 0.75 0.75V7.5a2.25 2.25 0 0 0 4.5 0V0.75a0.75 0.75 0 0 1 1.5 0V7.5a3.75 3.75 0 1 1 -7.5 0V0.75A0.75 0.75 0 0 1 4 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 13.25a0.75 0.75 0 0 1 0.75 -0.75h12.5a0.75 0.75 0 0 1 0 1.5H0.75a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "UnderlineText1"
);
var Bank = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.284 5.934v5.054h2.664V5.933l-0.038 0.001h-2.626Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.668 5.934v5.054h2.664V5.934H5.668Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.052 5.933v5.055h2.664V5.934H1.09l-0.038 0Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.386 0.233a1.21 1.21 0 0 1 1.248 0.013l5.911 3.87c0.42 0.277 0.547 0.754 0.385 1.161 -0.156 0.392 -0.55 0.657 -1.02 0.657H1.09c-0.47 0 -0.864 -0.265 -1.02 -0.657 -0.162 -0.407 -0.034 -0.884 0.385 -1.16l0.001 -0.001 5.91 -3.87a0.496 0.496 0 0 1 0.02 -0.013ZM0 11.877c0 -0.6 0.572 -0.889 1 -0.889h12c0.428 0 1 0.289 1 0.89v1.167c0 0.6 -0.572 0.889 -1 0.889H1c-0.428 0 -1 -0.289 -1 -0.89v-1.167Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Bank"
);
var Building2 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.5 6a0.5 0.5 0 0 0 -0.5 0.5v7a0.5 0.5 0 0 0 0.5 0.5h6a0.5 0.5 0 0 0 0.5 -0.5v-7a0.5 0.5 0 0 0 -0.5 -0.5h-6Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M4.521 0.138a0.5 0.5 0 0 0 -0.69 0l-3.676 3.5A0.5 0.5 0 0 0 0 4v9.5a0.5 0.5 0 0 0 0.5 0.5h7.353a0.5 0.5 0 0 0 0.5 -0.5V4a0.5 0.5 0 0 0 -0.156 -0.362L4.521 0.138Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M5.176 14v-2a1 1 0 1 0 -2 0v2h2Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M2.798 4.53a0.625 0.625 0 1 0 0 1.25h2.757a0.625 0.625 0 1 0 0 -1.25H2.798Zm0 2.608a0.625 0.625 0 1 0 0 1.25h2.757a0.625 0.625 0 0 0 0 -1.25H2.798Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Building2"
);
var Capitol = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.06 0.016a0.75 0.75 0 0 1 0.75 0.75v0.702a4.252 4.252 0 0 1 3.5 4.185v1.406a0.505 0.505 0 0 1 -0.007 0.077L7.307 4.853a0.5 0.5 0 0 0 -0.496 0L2.815 7.136a0.504 0.504 0 0 1 -0.006 -0.077V5.653c0 -2.092 1.51 -3.83 3.5 -4.185V0.766a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.811 4.853a0.5 0.5 0 0 1 0.496 0l6.203 3.544a0.5 0.5 0 0 1 -0.248 0.934h-0.347v3.148h0.101a0.75 0.75 0 0 1 0 1.5H1.102a0.75 0.75 0 0 1 0 -1.5h0.1V9.33H0.858a0.5 0.5 0 0 1 -0.249 -0.934l6.203 -3.544Zm3.551 4.478h1.053v3.148h-1.053V9.33Zm-7.66 0h1.054v3.148H2.703V9.33Zm2.554 3.148V9.33h1.053v3.148H5.256Zm2.553 0V9.33h1.053v3.148H7.81Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Capitol"
);
var CityHall = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 0.05a0.75 0.75 0 0 0 -0.75 0.75l0 2.406 0.509 -0.431a0.5 0.5 0 0 1 0.646 0l0.345 0.292 0 -1.516 0.621 0a0.75 0.75 0 0 0 0 -1.5H7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.759 2.775a0.5 0.5 0 0 1 0.646 0l5.053 4.284H1.706L6.76 2.775Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.922 7.06a0.75 0.75 0 0 0 0 1.5h0.196v3.934H0.922a0.75 0.75 0 0 0 0 1.5h12.32a0.75 0.75 0 0 0 0 -1.5h-0.196V8.559h0.196a0.75 0.75 0 0 0 0 -1.5H0.922Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.886 8.56h1.25v3.934h-1.25l0 -3.935Zm-7.022 0h1.25l0 3.934h-1.25V8.559Zm5.093 3.934H6.095v-2.11a0.93 0.93 0 1 1 1.862 0v2.11Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "CityHall"
);
var Home3 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0 6.776a1 1 0 0 1 0.318 -0.731L6.675 0.12a0.5 0.5 0 0 1 0.65 0l6.357 5.925a1 1 0 0 1 0.318 0.731V12.5a1.5 1.5 0 0 1 -1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5V6.776Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8 14H6v-3a1 1 0 1 1 2 0v3Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Home3"
);
var Home4 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsxs("g", { children: [
      " ",
      /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2 13V7l5 -5 5 5v6a1 1 0 0 1 -1 1H3a1 1 0 0 1 -1 -1Z" }),
      " "
    ] }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.293 1.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 -1.414 1.414L7 3.414 1.707 8.707A1 1 0 0 1 0.293 7.293l6 -6Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Home4"
);
var IndustryInnovationAndInfrastructure = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7.207 0.478a0.5 0.5 0 0 0 -0.414 0L3.992 1.754a0.5 0.5 0 0 0 -0.293 0.455v3.4a0.5 0.5 0 0 0 0.293 0.456l2.8 1.275a0.5 0.5 0 0 0 0.415 0l2.801 -1.275a0.5 0.5 0 0 0 0.293 -0.455V2.209a0.5 0.5 0 0 0 -0.293 -0.455L7.208 0.478Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.827 1.671 6.998 2.96 4.171 1.672l-0.179 0.082a0.5 0.5 0 0 0 -0.293 0.455v0.347l2.8 1.275V7a0.5 0.5 0 0 0 0.056 0.232l0.238 0.108a0.5 0.5 0 0 0 0.414 0l0.233 -0.106A0.498 0.498 0 0 0 7.498 7V3.83l2.803 -1.275v-0.346a0.5 0.5 0 0 0 -0.293 -0.455l-0.18 -0.083Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.86 6.837a0.5 0.5 0 0 0 -0.414 0L7.645 8.113a0.5 0.5 0 0 0 -0.293 0.455v3.4a0.5 0.5 0 0 0 0.293 0.456l2.8 1.275a0.5 0.5 0 0 0 0.415 0l2.8 -1.275a0.5 0.5 0 0 0 0.294 -0.455V8.568a0.5 0.5 0 0 0 -0.293 -0.455l-2.8 -1.276Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m13.48 8.03 -2.83 1.29 -2.825 -1.29 -0.18 0.082a0.5 0.5 0 0 0 -0.292 0.455v0.347l2.799 1.275v3.375l0.295 0.134a0.5 0.5 0 0 0 0.414 0l0.29 -0.132V10.19l2.804 -1.277v-0.345a0.5 0.5 0 0 0 -0.293 -0.455l-0.18 -0.083Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.554 6.837a0.5 0.5 0 0 0 -0.414 0L0.34 8.113a0.5 0.5 0 0 0 -0.294 0.455v3.4a0.5 0.5 0 0 0 0.293 0.456l2.801 1.275a0.5 0.5 0 0 0 0.414 0l2.801 -1.275a0.5 0.5 0 0 0 0.293 -0.455V8.568a0.5 0.5 0 0 0 -0.293 -0.455l-2.8 -1.276Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.174 8.03 3.345 9.32 0.518 8.03l-0.179 0.082a0.5 0.5 0 0 0 -0.293 0.455v0.347l2.8 1.275v3.375l0.294 0.134a0.5 0.5 0 0 0 0.414 0l0.291 -0.132V10.19l2.803 -1.276v-0.346a0.5 0.5 0 0 0 -0.293 -0.455l-0.18 -0.083Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "IndustryInnovationAndInfrastructure"
);
var OfficeBuilding1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.655 0.003C1.818 0.003 1.14 0.682 1.14 1.52l0 10.981H0.766a0.75 0.75 0 0 0 0 1.5h2.875l0.007 0h2.536a1.586 1.586 0 0 1 -0.035 -0.33c0 -1.611 0.838 -3.027 2.1 -3.835a3.228 3.228 0 0 1 0.711 -4.828l0.001 -3.488c0 -0.837 -0.678 -1.516 -1.515 -1.516h-4.79Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m1.14 5.622 0.006 0h4.341a0.625 0.625 0 1 0 0 -1.25h-4.34l-0.007 0 0 1.25Zm0 -2.6 0.006 0h2.72a0.625 0.625 0 0 0 0 -1.25h-2.72l-0.006 0 0 1.25Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.7 9.71a1.98 1.98 0 1 0 0 -3.96 1.98 1.98 0 0 0 0 3.96Zm-3.3 3.96a3.3 3.3 0 1 1 6.6 0 0.33 0.33 0 0 1 -0.33 0.33H7.73a0.33 0.33 0 0 1 -0.33 -0.33Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "OfficeBuilding1"
);
var Parliament = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M6.46969 0.270275c0.14066 -0.140661 0.33143 -0.2196832 0.53035 -0.2196833l1.37117 0c0.41422 0 0.75 0.3357863 0.75 0.7500003 0 0.414218 -0.33578 0.749998 -0.75 0.749998l-0.62114 0 0.0001 1.98227c0.00002 0.41421 -0.33575 0.75002 -0.74996 0.75004 -0.41422 0.00002 -0.75002 -0.33575 -0.75004 -0.74997L6.25004 0.800629c-0.00001 -0.198919 0.079 -0.389694 0.21965 -0.530354Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.41923 2.43353c-0.08644 -0.16434 -0.25683 -0.26724 -0.44252 -0.26724 -0.18568 0 -0.35608 0.1029 -0.44252 0.26724L5.13963 5.08484c-0.03775 0.07178 -0.05748 0.15166 -0.05748 0.23277l0.00002 3.4273c0 0.27614 0.22386 0.5 0.5 0.5h2.78912c0.1326 0 0.25978 -0.05268 0.35355 -0.14645 0.09377 -0.09377 0.14645 -0.22095 0.14645 -0.35356l-0.00002 -3.4273c0 -0.0811 -0.01973 -0.16098 -0.05748 -0.23276L7.41923 2.43353Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.22925 8.17926c-0.27614 0 -0.5 0.22386 -0.5 0.5v4.70994c0 0.2762 0.22386 0.5 0.5 0.5h9.54165c0.2761 0 0.5 -0.2238 0.5 -0.5V8.67926c0 -0.27614 -0.2239 -0.5 -0.5 -0.5H2.22925Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.54103 4.01227c0.19611 0 0.37412 0.11464 0.45523 0.29319l0.99874 2.1984c0.0295 0.06496 0.04477 0.13547 0.04477 0.20681v6.67863c0 0.2762 -0.22386 0.5 -0.5 0.5H0.542297c-0.276142 0 -0.4999996 -0.2238 -0.4999996 -0.5V6.71067c0 -0.07134 0.0152667 -0.14185 0.0447747 -0.20681l0.9987379 -2.1984c0.08111 -0.17855 0.25912 -0.29319 0.45522 -0.29319Zm11.32527 0.29319c-0.0812 -0.17855 -0.2592 -0.29319 -0.4553 -0.29319s-0.3741 0.11464 -0.4552 0.29319l-0.9987 2.1984c-0.0295 0.06496 -0.0448 0.13547 -0.0448 0.20681v6.67863c0 0.2762 0.2239 0.5 0.5 0.5h1.9975c0.2761 0 0.5 -0.2238 0.5 -0.5V6.71067c0 -0.07134 -0.0153 -0.14185 -0.0448 -0.20681l-0.9987 -2.1984Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M6.09821 12.3874c0 -0.498 0.40374 -0.9018 0.90179 -0.9018s0.9018 0.4038 0.9018 0.9018v1.502H6.09821v-1.502Z" }),
    " "
  ] }) }),
  "Parliament"
);
var PiggyBank = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.575 2.055a0.625 0.625 0 0 0 -0.367 0.804c0.284 0.763 0.816 1.319 1.326 1.696a0.625 0.625 0 0 0 0.744 -1.005c-0.382 -0.282 -0.724 -0.659 -0.9 -1.128a0.625 0.625 0 0 0 -0.803 -0.367Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M10.302 0.386C9.53 0.351 8.058 0.704 7.349 2.081c-1.705 -0.058 -3.018 0.189 -4.015 0.667 -1.074 0.514 -1.753 1.284 -2.148 2.159 -0.913 2.025 -0.276 4.148 0.067 5.291l0.005 0.015c0.05 0.17 0.097 0.314 0.132 0.425l0.02 0.063 0.038 0.12 0 1.718a1 1 0 0 0 1 1h1.765a1 1 0 0 0 1 -1v-0.407h2.141v0.484a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1 -1v-0.637c1.153 -0.451 2.124 -1.088 2.672 -2.267a0.5 0.5 0 0 0 0.047 -0.21V7.283a0.5 0.5 0 0 0 -0.183 -0.386l-0.695 -0.571c-0.015 -0.664 -0.101 -1.312 -0.385 -1.89 -0.287 -0.584 -0.756 -1.054 -1.456 -1.406V1.277c0 -0.375 -0.25 -0.866 -0.802 -0.89Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.375 4.902c0 0.345 -0.28 0.625 -0.625 0.625l-1.854 0a0.625 0.625 0 1 1 0 -1.25l1.854 0c0.346 0 0.625 0.28 0.625 0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M10.6 6.154a0.766 0.766 0 1 1 -1.532 0 0.766 0.766 0 0 1 1.531 0Z" }),
    " "
  ] }) }),
  "PiggyBank"
);
var Backpack = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 1.5c-0.33152 0 -0.64946 0.1317 -0.88388 0.36612C5.8817 2.10054 5.75 2.41848 5.75 2.75v1.20215c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75V2.75c0 -0.72935 0.28973 -1.42882 0.80546 -1.944544C5.57118 0.289731 6.27065 0 7 0c0.72935 0 1.42882 0.289732 1.94454 0.805456C9.46027 1.32118 9.75 2.02065 9.75 2.75v1.20215c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75V2.75c0 -0.33152 -0.1317 -0.64946 -0.36612 -0.88388C7.64946 1.6317 7.33152 1.5 7 1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.5 7.95215c-0.39783 0 -0.779356 0.15803 -1.06066 0.43934C0.158035 8.67279 0 9.05432 0 9.45215v3.99995c0 0.2762 0.223858 0.5 0.5 0.5h13c0.2761 0 0.5 -0.2238 0.5 -0.5V9.45215c0 -0.39783 -0.158 -0.77936 -0.4393 -1.06066 -0.2813 -0.28131 -0.6629 -0.43934 -1.0607 -0.43934h-11Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M5 2.95215h4c0.53043 0 1.0391 0.21477 1.4142 0.59706 0.3751 0.3823 0.5858 0.9008 0.5858 1.44144v8.96145H3l0 -8.96145c0 -0.54064 0.21071 -1.05914 0.58579 -1.44144 0.37507 -0.38229 0.88378 -0.59706 1.41421 -0.59706Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M11 7.92969H7.625v0.42871c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625v-0.42871H3v-1.25h3.375V6.3584c0 -0.34518 0.27982 -0.625 0.625 -0.625s0.625 0.27982 0.625 0.625v0.32129H11v1.25Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Backpack"
);
var Beanie = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7 0a1 1 0 0 1 1 1v1.5a1 1 0 0 1 -2 0V1a1 1 0 0 1 1 -1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M7 1.482a6 6 0 0 0 -6 6v3.5a0.5 0.5 0 0 0 0.5 0.5h11a0.5 0.5 0 0 0 0.5 -0.5v-3.5a6 6 0 0 0 -6 -6Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M12.923 10.751H1.077c-0.595 0 -1.077 0.482 -1.077 1.077v1.077c0 0.595 0.482 1.077 1.077 1.077h11.846c0.595 0 1.077 -0.482 1.077 -1.077v-1.077c0 -0.595 -0.482 -1.077 -1.077 -1.077Z" }),
    " "
  ] }) }),
  "Beanie"
);
var BowTie = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M12.653 10.17 7.538 8.94V5.06l5.115 -1.27c0.162 -0.039 0.332 -0.042 0.495 -0.01 0.164 0.033 0.317 0.1 0.448 0.197 0.13 0.097 0.235 0.221 0.305 0.362a0.94 0.94 0 0 1 0.098 0.45v4.38a0.94 0.94 0 0 1 -0.098 0.452c-0.07 0.14 -0.175 0.265 -0.305 0.362a1.12 1.12 0 0 1 -0.447 0.197 1.168 1.168 0 0 1 -0.496 -0.01Zm-11.306 0.02 5.115 -1.23V5.08L1.347 3.81a1.157 1.157 0 0 0 -0.495 -0.01c-0.164 0.033 -0.317 0.1 -0.448 0.197a1.02 1.02 0 0 0 -0.305 0.362A0.94 0.94 0 0 0 0 4.81v4.38a0.94 0.94 0 0 0 0.098 0.45c0.07 0.142 0.174 0.266 0.305 0.363 0.13 0.097 0.284 0.164 0.448 0.197 0.163 0.032 0.333 0.029 0.495 -0.01Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 9.5a2.5 2.5 0 1 0 0 -5 2.5 2.5 0 0 0 0 5Z" }),
    " "
  ] }) }),
  "BowTie"
);
var Crown = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.41 1.713a0.5 0.5 0 0 0 -0.82 0L3.432 6.225 0.854 3.646A0.5 0.5 0 0 0 0 4v6.5a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2V4a0.5 0.5 0 0 0 -0.854 -0.354l-2.578 2.579L7.41 1.713Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Crown"
);
var Glasses = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M0.75 9h4.808v2.885a0.961 0.961 0 0 1 -0.962 0.961H1.712a0.962 0.962 0 0 1 -0.962 -0.961V9Zm7.692 0h4.808v2.885a0.962 0.962 0 0 1 -0.961 0.961H9.404a0.962 0.962 0 0 1 -0.962 -0.961V9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.615 1a0.75 0.75 0 0 1 0.75 -0.75h0.962A2.673 2.673 0 0 1 14 2.923v6.069L14 9v2.885a1.712 1.712 0 0 1 -1.711 1.711H9.404a1.712 1.712 0 0 1 -1.712 -1.711V9.75H6.308v2.135a1.712 1.712 0 0 1 -1.712 1.711H1.712A1.712 1.712 0 0 1 0 11.885V2.923A2.673 2.673 0 0 1 2.673 0.25h0.962a0.75 0.75 0 0 1 0 1.5h-0.962A1.173 1.173 0 0 0 1.5 2.923V8.25h11V2.923a1.173 1.173 0 0 0 -1.173 -1.173h-0.962a0.75 0.75 0 0 1 -0.75 -0.75ZM1.5 9.75v2.135a0.212 0.212 0 0 0 0.212 0.211h2.884a0.211 0.211 0 0 0 0.212 -0.211V9.75H1.5Zm7.692 0v2.135a0.212 0.212 0 0 0 0.212 0.211h2.885a0.212 0.212 0 0 0 0.211 -0.211V9.75H9.192Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Glasses"
);
var Lipstick = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M8.872 3.216 11.634 0.455a0.981 0.981 0 0 1 1.07 -0.207 0.982 0.982 0 0 1 0.608 0.903v2.13a0.98 0.98 0 0 1 -0.285 0.696l-1.74 1.653" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.834 2.995a0.75 0.75 0 0 0 -1.06 0l-2.56 2.56 -0.001 0a1.51 1.51 0 0 0 0 2.13l0.001 0.002 1.59 1.59 0.001 0.001a1.51 1.51 0 0 0 2.13 0l0.002 -0.001 2.559 -2.56a0.75 0.75 0 0 0 0 -1.06L8.834 2.994Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M5.648 4.986a0.53 0.53 0 0 0 -0.749 0L1.166 8.719l-0.001 0.001a1.639 1.639 0 0 0 0 2.311l2.32 2.32a1.639 1.639 0 0 0 2.311 0l0.001 0 3.734 -3.734a0.53 0.53 0 0 0 0 -0.749L5.648 4.986Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Lipstick"
);
var MakeUpBrush = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m5.45593 4.94412 3.77056 3.77055L13.1269 6.8945c0.6288 -0.29347 0.7749 -1.12258 0.2842 -1.61329L8.88939 0.759527C8.39869 0.26882 7.56957 0.41489 7.27611 1.04375L5.45593 4.94412Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.47648 1.34644 8.13497 3.12386c-0.20795 0.27551 -0.15317 0.66743 0.12234 0.87538 0.27551 0.20794 0.66743 0.15316 0.87537 -0.12235L10.369 2.23891l-0.89252 -0.89247ZM11.9882 3.8582l-1.6206 1.02533c-0.2917 0.18454 -0.37861 0.57062 -0.1941 0.86232 0.1846 0.2917 0.5707 0.37857 0.8624 0.19402l1.8583 -1.17569 -0.906 -0.90598Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "m5.45699 4.94038 3.77055 3.77056L4.8912 13.0274c-1.0419 1.0372 -2.72669 1.0352 -3.76621 -0.0043 -1.0428943 -1.0429 -1.0409545 -2.7344 0.00433 -3.77486l4.32767 -4.30786Z" }),
    " "
  ] }) }),
  "MakeUpBrush"
);
var Moustache = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7 8.39a3.77 3.77 0 0 0 6.919 -1.163c0.076 -0.36 -0.304 -0.606 -0.655 -0.497a5.568 5.568 0 0 1 -1.418 0.25c-1.077 0 -0.624 -2.607 -2.154 -3.113A2.52 2.52 0 0 0 7 4.826a2.52 2.52 0 0 0 -2.692 -0.959C2.778 4.373 3.23 6.98 2.154 6.98a5.568 5.568 0 0 1 -1.418 -0.25c-0.35 -0.11 -0.73 0.137 -0.655 0.497A3.77 3.77 0 0 0 7 8.39Z" }),
    " "
  ] }) }),
  "Moustache"
);
var MouthLip = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M0.278965 8.02054c0.065305 0.11414 0.161271 0.27181 0.290037 0.45843 0.256941 0.37238 0.648138 0.86535 1.191668 1.35836 1.09374 0.99207 2.80472 1.98177 5.23908 1.98177 2.43436 0 4.14535 -0.9897 5.23905 -1.98177 0.5436 -0.49301 0.9348 -0.98599 1.1917 -1.35837 0.1288 -0.18662 0.2247 -0.34429 0.29 -0.45843 0.0369 -0.06441 0.0728 -0.12951 0.1055 -0.19614 0.081 -0.16736 0.0983 -0.3629 0.0461 -0.54134 -0.0878 -0.29694 -0.212 -0.58238 -0.3486 -0.85979 -0.2332 -0.474 -0.6084 -1.09802 -1.1672 -1.63881 -0.5646 -0.54642 -1.3308 -1.02004 -2.3241 -1.14365 -0.89598 -0.1115 -1.90538 0.07066 -3.03245 0.63368 -1.12707 -0.56302 -2.13647 -0.74518 -3.03244 -0.63368 -0.99328 0.12361 -1.75953 0.59724 -2.32413 1.14365 -0.55879 0.54079 -0.933946 1.16482 -1.167216 1.63882 -0.136523 0.27741 -0.260811 0.56284 -0.348539 0.85979 -0.0522211 0.17843 -0.034923 0.37397 0.046038 0.54134 0.032729 0.06662 0.068647 0.13172 0.105502 0.19614Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0.334389 8.11523C0.31392 8.08104 0.295447 8.0494 0.278934 8.02054 0.24208 7.95612 0.206162 7.89102 0.173433 7.8244c-0.0809615 -0.16737 -0.0982597 -0.36291 -0.046038 -0.54134 0.041884 -0.14177 0.092102 -0.28092 0.148006 -0.41783H13.724c0.0559 0.13691 0.1062 0.27605 0.148 0.41782 0.0523 0.17844 0.035 0.37398 -0.046 0.54134 -0.0327 0.06663 -0.0686 0.13173 -0.1055 0.19614 -0.0165 0.02886 -0.035 0.06051 -0.0555 0.0947l-13.330611 0Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "MouthLip"
);
var Necklace = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.24847 1.57982C4.30881 0.717935 5.63357 0.247437 7.00002 0.247437c1.36644 0 2.6912 0.470498 3.75158 1.332383 1.0603 0.86188 1.7915 2.06258 2.0707 3.40019 0.2792 1.33762 0.0893 2.73057 -0.5378 3.94464 -0.627 1.21405 -1.653 2.17515 -2.90538 2.72175 -0.23187 0.1012 -0.49913 0.0787 -0.71079 -0.0599 -0.21167 -0.1385 -0.33921 -0.3745 -0.33921 -0.6275v-0.0831c0 -0.4143 0.33579 -0.75 0.75 -0.75l0.00235 0c0.79914 -0.42319 1.45293 -1.08147 1.87033 -1.88961 0.4689 -0.90788 0.6109 -1.94954 0.4022 -2.94981 -0.2088 -1.00028 -0.7556 -1.89817 -1.54856 -2.54268 -0.79293 -0.64452 -1.7836 -0.99636 -2.80542 -0.99636 -1.02183 0 -2.0125 0.35184 -2.80543 0.99636 -0.79292 0.64451 -1.33975 1.5424 -1.54852 2.54268 -0.20877 1.00027 -0.06675 2.04193 0.40217 2.94981 0.41741 0.80814 1.07118 1.46642 1.87032 1.88961l0.00235 0c0.41421 0 0.75 0.3357 0.75 0.75v0.0831c0 0.253 -0.12754 0.489 -0.33921 0.6275 -0.21166 0.1386 -0.47892 0.1611 -0.71079 0.0599 -1.25236 -0.5466 -2.27833 -1.5077 -2.9054 -2.72175 -0.62706 -1.21407 -0.816972 -2.60702 -0.5378 -3.94464 0.27918 -1.33761 1.01042 -2.53831 2.07076 -3.40019Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M9 10.75c0 -0.1574 -0.0741 -0.3056 -0.2 -0.4L7.3 9.225c-0.17778 -0.13333 -0.42222 -0.13333 -0.6 0L5.2 10.35c-0.1259 0.0944 -0.2 0.2426 -0.2 0.4v1.5c0 0.1574 0.0741 0.3056 0.2 0.4l1.5 1.125c0.17778 0.1333 0.42222 0.1333 0.6 0l1.5 -1.125c0.1259 -0.0944 0.2 -0.2426 0.2 -0.4v-1.5Z" }),
    " "
  ] }) }),
  "Necklace"
);
var Necktie = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m8.5 3 0.972 8.363a0.5 0.5 0 0 1 -0.143 0.412L7.354 13.75a0.5 0.5 0 0 1 -0.708 0l-1.975 -1.976a0.5 0.5 0 0 1 -0.143 -0.41L5.5 3" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M8.5 3.104h-3L4.939 1.42A1 1 0 0 1 5.887 0.104h2.226A1 1 0 0 1 9.06 1.42L8.5 3.104Z" }),
    " "
  ] }) }),
  "Necktie"
);
var TallHat = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0a0.5 0.5 0 0 0 -0.497 0.557l1.5 12.997a0.5 0.5 0 0 0 0.497 0.443h6a0.5 0.5 0 0 0 0.497 -0.443l1.5 -12.997A0.5 0.5 0 0 0 11.5 0h-9Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m10.618 12.5 0.347 -3h-7.93l0.347 3H0.774a0.75 0.75 0 0 0 0 1.5h12.452a0.75 0.75 0 1 0 0 -1.5h-2.608Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TallHat"
);
var Chair = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M11.218 0.907H2.782v4.237h8.436V0.907Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.532 0.907a0.75 0.75 0 1 0 -1.5 0v7.03a0.75 0.75 0 0 0 1.5 0V0.907Zm8.436 0a0.75 0.75 0 0 0 -1.5 0v7.03a0.75 0.75 0 0 0 1.5 0V0.907Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.207 7.32a0.75 0.75 0 0 0 -0.85 1.235l3.32 2.282 -2.383 1.638a0.75 0.75 0 1 0 0.85 1.236L7 11.747l2.856 1.964a0.75 0.75 0 0 0 0.85 -1.236l-2.382 -1.638 3.319 -2.282a0.75 0.75 0 0 0 -0.85 -1.236L7 9.927 3.207 7.319Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1.095 7.937a0.75 0.75 0 0 1 0.75 -0.75h10.31a0.75 0.75 0 0 1 0 1.5H1.845a0.75 0.75 0 0 1 -0.75 -0.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Chair"
);
var Closet = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 11.5 0h-9Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M7.625 14h-1.25V0h1.25v14Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.5 5.837c0.345 0 0.625 0.28 0.625 0.625v1.076a0.625 0.625 0 1 1 -1.25 0V6.462c0 -0.346 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.5 5.837c0.345 0 0.625 0.28 0.625 0.625v1.076a0.625 0.625 0 1 1 -1.25 0V6.462c0 -0.346 0.28 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Closet"
);
var DressingTable = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", d: "M1.25 5.75a5.75 5.75 0 1 1 11.5 0V7H1.25l0 -1.25Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M1.25 8.5h11.5v3.75A1.75 1.75 0 0 1 11 14H3a1.75 1.75 0 0 1 -1.75 -1.75V8.5Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.25 10.25A0.75 0.75 0 0 1 5 11v0.5a0.75 0.75 0 0 1 -1.5 0V11a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M9.75 10.25a0.75 0.75 0 0 1 0.75 0.75v0.5a0.75 0.75 0 0 1 -1.5 0V11a0.75 0.75 0 0 1 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M7.75 8.5V14h-1.5V8.5h1.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M0 8.75A0.75 0.75 0 0 1 0.75 8h12.5a0.75 0.75 0 0 1 0 1.5H0.75A0.75 0.75 0 0 1 0 8.75Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "DressingTable"
);
var Iron = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10.2241 1.31363c0.6759 -0.00876 1.3172 0.25662 1.8106 0.72256 0.4927 0.46519 0.8073 1.09921 0.9078 1.77909l0.0002 0.00114 0.2168 1.48239c0.06 0.40985 -0.2237 0.7907 -0.6335 0.85065 -0.4099 0.05994 -0.7907 -0.22371 -0.8507 -0.63356l-0.2167 -1.48124 0 -0.00056c-0.055 -0.37075 -0.2233 -0.68972 -0.4537 -0.90731 -0.2282 -0.2155 -0.5 -0.31734 -0.7639 -0.31325l-0.0116 0.00018v-0.00009H4.53284c-0.41422 0 -0.75 -0.33579 -0.75 -0.75 0 -0.41422 0.33578 -0.75 0.75 -0.75h5.69126Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M8.85107 4.65738h-0.0007c-1.94113 0.00183 -3.8326 0.61369 -5.40703 1.7491C1.86891 7.54189 0.691144 9.14341 0.0765266 10.9847c-0.076351303 0.2287 -0.0380668 0.4802 0.1028884 0.6758 0.140954 0.1957 0.367385 0.3116 0.608524 0.3116H12.243c0.2483 0 0.4937 -0.0537 0.7192 -0.1576 0.2251 -0.1037 0.4251 -0.2547 0.5863 -0.4429 0.1628 -0.1892 0.2825 -0.4116 0.3506 -0.6517 0.0683 -0.2405 0.0833 -0.493 0.044 -0.73987l0 -0.00001 -0.0009 -0.00586 -0.785 -4.69058c-0.0605 -0.36141 -0.3733 -0.6262 -0.7397 -0.6262H8.85107Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Iron"
);
var Ladder = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M3.5 0a1 1 0 0 1 1 1v1.216h5V1a1 1 0 0 1 2 0v12a1 1 0 1 1 -2 0v-1.216h-5V13a1 1 0 1 1 -2 0V1a1 1 0 0 1 1 -1Zm1 9.784h5V8h-5v1.784Zm5 -5.568V6h-5V4.216h5Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Ladder"
);
var Microwave = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1 2c-0.552285 0 -1 0.44772 -1 1v8c0 0.5523 0.447715 1 1 1h12c0.5523 0 1 -0.4477 1 -1V3c0 -0.55228 -0.4477 -1 -1 -1H1Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M8.95366 4.08752H2.54624c-0.3217 0 -0.58249 0.2608 -0.58249 0.5825v4.65994c0 0.3217 0.26079 0.58249 0.58249 0.58249h6.40742c0.3217 0 0.58249 -0.26079 0.58249 -0.58249V4.67002c0 -0.3217 -0.26079 -0.5825 -0.58249 -0.5825Zm1.73844 0.74872c0 -0.34518 0.2798 -0.625 0.625 -0.625h1.0464c0.3452 0 0.625 0.27982 0.625 0.625s-0.2798 0.625 -0.625 0.625h-1.0464c-0.3452 0 -0.625 -0.27982 -0.625 -0.625Zm0.625 1.53876c-0.3452 0 -0.625 0.27982 -0.625 0.625s0.2798 0.625 0.625 0.625h1.0464c0.3452 0 0.625 -0.27982 0.625 -0.625s-0.2798 -0.625 -0.625 -0.625h-1.0464Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Microwave"
);
var Refrigerator = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4 11.4935c0.41421 0 0.75 0.3358 0.75 0.75v1c0 0.4142 -0.33579 0.75 -0.75 0.75s-0.75 -0.3358 -0.75 -0.75v-1c0 -0.4142 0.33579 -0.75 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M10 11.4935c0.4142 0 0.75 0.3358 0.75 0.75v1c0 0.4142 -0.3358 0.75 -0.75 0.75 -0.41421 0 -0.75 -0.3358 -0.75 -0.75v-1c0 -0.4142 0.33579 -0.75 0.75 -0.75Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 0C2.68181 0 2 0.651871 2 1.47862v9.78618c0 0.8268 0.68181 1.4787 1.5 1.4787h7c0.8182 0 1.5 -0.6519 1.5 -1.4787V1.47862C12 0.651871 11.3182 0 10.5 0h-7Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M4.41626 1.98425c0.34518 0 0.625 0.27982 0.625 0.625v0.5c0 0.34518 -0.27982 0.625 -0.625 0.625s-0.625 -0.27982 -0.625 -0.625v-0.5c0 -0.34518 0.27982 -0.625 0.625 -0.625Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M12 5.37564c-0.0095 -0.00042 -0.019 -0.00064 -0.0286 -0.00064H2.02859c-0.00958 0 -0.01911 0.00022 -0.02859 0.00064v1.24872c0.00948 0.00042 0.01901 0.00064 0.02859 0.00064h9.94281c0.0096 0 0.0191 -0.00022 0.0286 -0.00064V5.37564Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Refrigerator"
);
var Shelf = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "M2.5 0A1.5 1.5 0 0 0 1 1.5v11A1.5 1.5 0 0 0 2.5 14h9a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 11.5 0h-9Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M1 3.002h12v1.25H1v-1.25Zm0 3.873h12v1.25H7.625V14h-1.25V8.125H1v-1.25Zm4.125 3.631a0.625 0.625 0 1 0 -1.25 0v1a0.625 0.625 0 1 0 1.25 0v-1Zm5 0a0.625 0.625 0 1 0 -1.25 0v1a0.625 0.625 0 1 0 1.25 0v-1Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "Shelf"
);
var TableLamp1 = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "M6.5 0.75a0.75 0.75 0 0 0 0 1.5H8a3.25 3.25 0 0 1 3.25 3.25v7h-4a0.75 0.75 0 0 0 0 1.5h6a0.75 0.75 0 0 0 0 -1.5h-0.5v-7A4.75 4.75 0 0 0 8 0.75H6.5Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M3.5 0A1.5 1.5 0 0 0 2 1.5v1.222a4.5 4.5 0 0 0 -2 3.782A0.5 0.5 0 0 0 0.5 7h8a0.5 0.5 0 0 0 0.5 -0.496 4.5 4.5 0 0 0 -2 -3.782V1.5A1.5 1.5 0 0 0 5.5 0h-2Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "TableLamp1"
);
var WorkspaceDesk = /* @__PURE__ */ createIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("g", { children: [
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", d: "m10.216 0.755 -6.432 0A0.784 0.784 0 0 0 3 1.539V5.47c0 0.433 0.351 0.784 0.784 0.784l6.432 0A0.784 0.784 0 0 0 11 5.47V1.539a0.784 0.784 0 0 0 -0.784 -0.784Z" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-solid)", fillRule: "evenodd", d: "m3.784 1.505 6.432 0c0.019 0 0.034 0.015 0.034 0.034V5.47a0.034 0.034 0 0 1 -0.034 0.034l-6.432 0a0.034 0.034 0 0 1 -0.034 -0.034V1.539c0 -0.02 0.015 -0.034 0.034 -0.034Zm6.432 -1.5 -6.432 0C2.937 0.005 2.25 0.69 2.25 1.539V5.47c0 0.847 0.687 1.534 1.534 1.534l2.465 0 0 1.036a0.75 0.75 0 0 0 1.5 0l0 -1.036 2.467 0c0.847 0 1.534 -0.687 1.534 -1.534V1.539c0 -0.848 -0.687 -1.534 -1.534 -1.534Z", clipRule: "evenodd" }),
    " ",
    /* @__PURE__ */ jsx("path", { fill: "var(--semo-icon-soft)", fillRule: "evenodd", d: "M1.844 11.228v2.017a0.75 0.75 0 1 1 -1.5 0V9.88c0 -0.644 0.328 -1.213 0.827 -1.546 0.254 -0.199 0.575 -0.318 0.923 -0.318h9.813c0.35 0 0.672 0.12 0.927 0.321 0.496 0.334 0.822 0.9 0.822 1.543v3.366a0.75 0.75 0 1 1 -1.5 0v-2.017H1.844Z", clipRule: "evenodd" }),
    " "
  ] }) }),
  "WorkspaceDesk"
);
var AlignCenter = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M21 5H3" }),
    /* @__PURE__ */ jsx("path", { d: "M17 12H7" }),
    /* @__PURE__ */ jsx("path", { d: "M19 19H5" })
  ] }),
  "AlignCenter"
);
var AlignJustify = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M3 5h18" }),
    /* @__PURE__ */ jsx("path", { d: "M3 12h18" }),
    /* @__PURE__ */ jsx("path", { d: "M3 19h18" })
  ] }),
  "AlignJustify"
);
var AlignLeft = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M21 5H3" }),
    /* @__PURE__ */ jsx("path", { d: "M15 12H3" }),
    /* @__PURE__ */ jsx("path", { d: "M17 19H3" })
  ] }),
  "AlignLeft"
);
var AlignRight = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M21 5H3" }),
    /* @__PURE__ */ jsx("path", { d: "M21 12H9" }),
    /* @__PURE__ */ jsx("path", { d: "M21 19H7" })
  ] }),
  "AlignRight"
);
var ArrowDownRight = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m7 7 10 10" }),
    /* @__PURE__ */ jsx("path", { d: "M17 7v10H7" })
  ] }),
  "ArrowDownRight"
);
var ArrowLeft = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m12 19-7-7 7-7" }),
    /* @__PURE__ */ jsx("path", { d: "M19 12H5" })
  ] }),
  "ArrowLeft"
);
var ArrowRight = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M5 12h14" }),
    /* @__PURE__ */ jsx("path", { d: "m12 5 7 7-7 7" })
  ] }),
  "ArrowRight"
);
var ArrowUpRight = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M7 7h10v10" }),
    /* @__PURE__ */ jsx("path", { d: "M7 17 17 7" })
  ] }),
  "ArrowUpRight"
);
var Bold = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" }) }),
  "Bold"
);
var ChevronDown = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "m6 9 6 6 6-6" }) }),
  "ChevronDown"
);
var ChevronLeft = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "m15 18-6-6 6-6" }) }),
  "ChevronLeft"
);
var ChevronRight = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "m9 18 6-6-6-6" }) }),
  "ChevronRight"
);
var ChevronUp = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "m18 15-6-6-6 6" }) }),
  "ChevronUp"
);
var ChevronsUpDown = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m7 15 5 5 5-5" }),
    /* @__PURE__ */ jsx("path", { d: "m7 9 5-5 5 5" })
  ] }),
  "ChevronsUpDown"
);
var Highlighter = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m9 11-6 6v3h9l3-3" }),
    /* @__PURE__ */ jsx("path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4" })
  ] }),
  "Highlighter"
);
var Italic = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("line", { x1: "19", x2: "10", y1: "4", y2: "4" }),
    /* @__PURE__ */ jsx("line", { x1: "14", x2: "5", y1: "20", y2: "20" }),
    /* @__PURE__ */ jsx("line", { x1: "15", x2: "9", y1: "4", y2: "20" })
  ] }),
  "Italic"
);
var Link = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
    /* @__PURE__ */ jsx("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
  ] }),
  "Link"
);
var List = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M3 5h.01" }),
    /* @__PURE__ */ jsx("path", { d: "M3 12h.01" }),
    /* @__PURE__ */ jsx("path", { d: "M3 19h.01" }),
    /* @__PURE__ */ jsx("path", { d: "M8 5h13" }),
    /* @__PURE__ */ jsx("path", { d: "M8 12h13" }),
    /* @__PURE__ */ jsx("path", { d: "M8 19h13" })
  ] }),
  "List"
);
var ListOrdered = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M11 5h10" }),
    /* @__PURE__ */ jsx("path", { d: "M11 12h10" }),
    /* @__PURE__ */ jsx("path", { d: "M11 19h10" }),
    /* @__PURE__ */ jsx("path", { d: "M4 4h1v5" }),
    /* @__PURE__ */ jsx("path", { d: "M4 9h2" }),
    /* @__PURE__ */ jsx("path", { d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02" })
  ] }),
  "ListOrdered"
);
var Menu = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M4 5h16" }),
    /* @__PURE__ */ jsx("path", { d: "M4 12h16" }),
    /* @__PURE__ */ jsx("path", { d: "M4 19h16" })
  ] }),
  "Menu"
);
var Palette = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" }),
    /* @__PURE__ */ jsx("circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor" }),
    /* @__PURE__ */ jsx("circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor" }),
    /* @__PURE__ */ jsx("circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor" }),
    /* @__PURE__ */ jsx("circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor" })
  ] }),
  "Palette"
);
var RemoveFormatting = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M4 7V4h16v3" }),
    /* @__PURE__ */ jsx("path", { d: "M5 20h6" }),
    /* @__PURE__ */ jsx("path", { d: "M13 4 8 20" }),
    /* @__PURE__ */ jsx("path", { d: "m15 15 5 5" }),
    /* @__PURE__ */ jsx("path", { d: "m20 15-5 5" })
  ] }),
  "RemoveFormatting"
);
var Ruler = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z" }),
    /* @__PURE__ */ jsx("path", { d: "m14.5 12.5 2-2" }),
    /* @__PURE__ */ jsx("path", { d: "m11.5 9.5 2-2" }),
    /* @__PURE__ */ jsx("path", { d: "m8.5 6.5 2-2" }),
    /* @__PURE__ */ jsx("path", { d: "m17.5 15.5 2-2" })
  ] }),
  "Ruler"
);
var Search = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m21 21-4.34-4.34" }),
    /* @__PURE__ */ jsx("circle", { cx: "11", cy: "11", r: "8" })
  ] }),
  "Search"
);
var Strikethrough = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }),
    /* @__PURE__ */ jsx("path", { d: "M14 12a4 4 0 0 1 0 8H6" }),
    /* @__PURE__ */ jsx("line", { x1: "4", x2: "20", y1: "12", y2: "12" })
  ] }),
  "Strikethrough"
);
var Type = createStrokeIcon(
  /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("path", { d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z" }) }),
  "Type"
);
var Underline = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }),
    /* @__PURE__ */ jsx("line", { x1: "4", x2: "20", y1: "20", y2: "20" })
  ] }),
  "Underline"
);
var Unlink = createStrokeIcon(
  /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" }),
    /* @__PURE__ */ jsx("path", { d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" }),
    /* @__PURE__ */ jsx("line", { x1: "8", x2: "8", y1: "2", y2: "5" }),
    /* @__PURE__ */ jsx("line", { x1: "2", x2: "5", y1: "8", y2: "8" }),
    /* @__PURE__ */ jsx("line", { x1: "16", x2: "16", y1: "19", y2: "22" }),
    /* @__PURE__ */ jsx("line", { x1: "19", x2: "22", y1: "16", y2: "16" })
  ] }),
  "Unlink"
);

// src/generated/catalog.ts
var ICON_CATALOG = [
  {
    "component": "Alt",
    "name": "Alt",
    "category": "01-arrows-navigation",
    "keywords": "alt--windows-key-alt-pc-keyboard",
    "duotone": true
  },
  {
    "component": "ArrowBendLeftDown2",
    "name": "Arrow-Bend-Left-Down-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-bend-left-down-2--arrow-bend-curve-change-direction-left-to-down",
    "duotone": false
  },
  {
    "component": "ArrowBendRightDown2",
    "name": "Arrow-Bend-Right-Down-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-bend-right-down-2--arrow-bend-curve-change-direction-right-to-down",
    "duotone": false
  },
  {
    "component": "ArrowCrossoverDown",
    "name": "Arrow-Crossover-Down",
    "category": "01-arrows-navigation",
    "keywords": "arrow-crossover-down--cross-move-over-arrow-arrows-down",
    "duotone": true
  },
  {
    "component": "ArrowCrossoverLeft",
    "name": "Arrow-Crossover-Left",
    "category": "01-arrows-navigation",
    "keywords": "arrow-crossover-left--cross-move-over-arrow-arrows-left",
    "duotone": true
  },
  {
    "component": "ArrowCrossoverRight",
    "name": "Arrow-Crossover-Right",
    "category": "01-arrows-navigation",
    "keywords": "arrow-crossover-right--cross-move-over-arrow-arrows-ight",
    "duotone": true
  },
  {
    "component": "ArrowCrossoverUp",
    "name": "Arrow-Crossover-Up",
    "category": "01-arrows-navigation",
    "keywords": "arrow-crossover-up--cross-move-over-arrow-arrows-right",
    "duotone": true
  },
  {
    "component": "ArrowCursor1",
    "name": "Arrow-Cursor-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-cursor-1--mouse-select-cursor",
    "duotone": false
  },
  {
    "component": "ArrowCursor2",
    "name": "Arrow-Cursor-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-cursor-2--mouse-select-cursor",
    "duotone": false
  },
  {
    "component": "ArrowCurvyUpDown1",
    "name": "Arrow-Curvy-Up-Down-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-curvy-up-down-1--both-direction-arrow-curvy-diagram-zigzag-vertical",
    "duotone": false
  },
  {
    "component": "ArrowCurvyUpDown2",
    "name": "Arrow-Curvy-Up-Down-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-curvy-up-down-2",
    "duotone": false
  },
  {
    "component": "ArrowDown2",
    "name": "Arrow-Down-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-down-2--down-move-arrow-arrows",
    "duotone": true
  },
  {
    "component": "ArrowDownDashedSquare",
    "name": "Arrow-Down-Dashed-Square",
    "category": "01-arrows-navigation",
    "keywords": "arrow-down-dashed-square--arrow-keyboard-button-down-square-dashes",
    "duotone": true
  },
  {
    "component": "ArrowExpand",
    "name": "Arrow-Expand",
    "category": "01-arrows-navigation",
    "keywords": "arrow-expand--expand-small-bigger-retract-smaller-big",
    "duotone": false
  },
  {
    "component": "ArrowInfiniteLoop",
    "name": "Arrow-Infinite-Loop",
    "category": "01-arrows-navigation",
    "keywords": "arrow-infinite-loop--arrow-diagram-loop-infinity-repeat",
    "duotone": false
  },
  {
    "component": "ArrowMove",
    "name": "Arrow-Move",
    "category": "01-arrows-navigation",
    "keywords": "arrow-move--move-button-arrows-direction",
    "duotone": false
  },
  {
    "component": "ArrowReloadHorizontal1",
    "name": "Arrow-Reload-Horizontal-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-reload-horizontal-1--arrows-load-arrow-sync-square-loading-reload-synchronize",
    "duotone": false
  },
  {
    "component": "ArrowReloadHorizontal2",
    "name": "Arrow-Reload-Horizontal-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-reload-horizontal-2",
    "duotone": false
  },
  {
    "component": "ArrowReloadVertical1",
    "name": "Arrow-Reload-Vertical-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-reload-vertical-1--arrows-load-arrow-sync-square-loading-reload-synchronize",
    "duotone": false
  },
  {
    "component": "ArrowReloadVertical2",
    "name": "Arrow-Reload-Vertical-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-reload-vertical-2",
    "duotone": false
  },
  {
    "component": "ArrowRoadmap",
    "name": "Arrow-Roadmap",
    "category": "01-arrows-navigation",
    "keywords": "arrow-roadmap",
    "duotone": true
  },
  {
    "component": "ArrowRoundLeft",
    "name": "Arrow-Round-Left",
    "category": "01-arrows-navigation",
    "keywords": "arrow-round-left--diagram-round-arrow-left",
    "duotone": false
  },
  {
    "component": "ArrowRoundRight",
    "name": "Arrow-Round-Right",
    "category": "01-arrows-navigation",
    "keywords": "arrow-round-right--diagram-round-arrow-right",
    "duotone": false
  },
  {
    "component": "ArrowShrinkDiagonal1",
    "name": "Arrow-Shrink-Diagonal-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-shrink-diagonal-1--expand-retract-shrink-bigger-big-small-smaller",
    "duotone": false
  },
  {
    "component": "ArrowShrinkDiagonal2",
    "name": "Arrow-Shrink-Diagonal-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-shrink-diagonal-2--expand-retract-shrink-bigger-big-small-smaller",
    "duotone": false
  },
  {
    "component": "ArrowShrink",
    "name": "Arrow-Shrink",
    "category": "01-arrows-navigation",
    "keywords": "arrow-shrink--expand-retract-shrink-bigger-big-small-smaller",
    "duotone": false
  },
  {
    "component": "ArrowTransferDiagonal1",
    "name": "Arrow-Transfer-Diagonal-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-transfer-diagonal-1--arrows-arrow-server-data-diagonal-internet-transfer-network",
    "duotone": false
  },
  {
    "component": "ArrowTransferDiagonal2",
    "name": "Arrow-Transfer-Diagonal-2",
    "category": "01-arrows-navigation",
    "keywords": "arrow-transfer-diagonal-2--arrows-arrow-server-data-diagonal-internet-transfer-network",
    "duotone": false
  },
  {
    "component": "ArrowTransferDiagonal3",
    "name": "Arrow-Transfer-Diagonal-3",
    "category": "01-arrows-navigation",
    "keywords": "arrow-transfer-diagonal-3--arrows-arrow-server-data-diagonal-internet-transfer-network",
    "duotone": false
  },
  {
    "component": "ArrowUp1",
    "name": "Arrow-Up-1",
    "category": "01-arrows-navigation",
    "keywords": "arrow-up-1--arrow-up-keyboard",
    "duotone": false
  },
  {
    "component": "ArrowUpDashedSquare",
    "name": "Arrow-Up-Dashed-Square",
    "category": "01-arrows-navigation",
    "keywords": "arrow-up-dashed-square--arrow-keyboard-button-up-square-dashes",
    "duotone": true
  },
  {
    "component": "ExpandHorizontal1",
    "name": "Expand-Horizontal-1",
    "category": "01-arrows-navigation",
    "keywords": "expand-horizontal-1--expand-resize-bigger-horizontal-smaller-size-arrow-arrows-big",
    "duotone": true
  },
  {
    "component": "ExpandWindow2",
    "name": "Expand-Window-2",
    "category": "01-arrows-navigation",
    "keywords": "expand-window-2--expand-small-bigger-retract-smaller-big",
    "duotone": true
  },
  {
    "component": "Expand",
    "name": "Expand",
    "category": "01-arrows-navigation",
    "keywords": "expand--big-bigger-design-expand-larger-resize-size-square",
    "duotone": true
  },
  {
    "component": "Login1",
    "name": "Login-1",
    "category": "01-arrows-navigation",
    "keywords": "login-1--arrow-enter-frame-left-login-point-rectangle",
    "duotone": true
  },
  {
    "component": "Logout1",
    "name": "Logout-1",
    "category": "01-arrows-navigation",
    "keywords": "logout-1--arrow-exit-frame-leave-logout-rectangle-right",
    "duotone": true
  },
  {
    "component": "MinimizeWindow2",
    "name": "Minimize-Window-2",
    "category": "01-arrows-navigation",
    "keywords": "minimize-window-2--expand-retract-shrink-bigger-big-small-smaller",
    "duotone": true
  },
  {
    "component": "MoveLeft",
    "name": "Move-Left",
    "category": "01-arrows-navigation",
    "keywords": "move-left--move-left-arrows",
    "duotone": true
  },
  {
    "component": "MoveRight",
    "name": "Move-Right",
    "category": "01-arrows-navigation",
    "keywords": "move-right--move-right-arrows",
    "duotone": true
  },
  {
    "component": "NavigationArrowOff",
    "name": "Navigation-Arrow-Off",
    "category": "01-arrows-navigation",
    "keywords": "navigation-arrow-off--compass-arrow-map-bearing-navigation-maps-heading-gps-off-disable",
    "duotone": true
  },
  {
    "component": "NavigationArrowOn",
    "name": "Navigation-Arrow-On",
    "category": "01-arrows-navigation",
    "keywords": "navigation-arrow-on--compass-arrow-map-bearing-navigation-maps-heading-gps-off-disable",
    "duotone": false
  },
  {
    "component": "Next",
    "name": "Next",
    "category": "01-arrows-navigation",
    "keywords": "next--next-arrow-right-keyboard",
    "duotone": false
  },
  {
    "component": "Return2",
    "name": "Return-2",
    "category": "01-arrows-navigation",
    "keywords": "return-2--arrow-return-enter-keyboard",
    "duotone": false
  },
  {
    "component": "Shift",
    "name": "Shift",
    "category": "01-arrows-navigation",
    "keywords": "shift--key-shift-up-arrow-keyboard",
    "duotone": false
  },
  {
    "component": "ShrinkHorizontal1",
    "name": "Shrink-Horizontal-1",
    "category": "01-arrows-navigation",
    "keywords": "shrink-horizontal-1--resize-shrink-bigger-horizontal-smaller-size-arrow-arrows-big",
    "duotone": true
  },
  {
    "component": "SplitVertical",
    "name": "Split-Vertical",
    "category": "01-arrows-navigation",
    "keywords": "split-vertical",
    "duotone": false
  },
  {
    "component": "SynchronizeDisable",
    "name": "Synchronize-Disable",
    "category": "01-arrows-navigation",
    "keywords": "synchronize-disable--arrows-loading-load-sync-synchronize-arrow-reload",
    "duotone": true
  },
  {
    "component": "SynchronizeWarning",
    "name": "Synchronize-Warning",
    "category": "01-arrows-navigation",
    "keywords": "synchronize-warning--arrow-fail-notification-sync-warning-failure-synchronize-error",
    "duotone": true
  },
  {
    "component": "Add1",
    "name": "Add-1",
    "category": "02-interface-actions",
    "keywords": "add-1--expand-cross-buttons-button-more-remove-plus-add-+-mathematics-math",
    "duotone": false
  },
  {
    "component": "AddCircle",
    "name": "Add-Circle",
    "category": "02-interface-actions",
    "keywords": "add-circle--button-remove-cross-add-buttons-plus-circle-+-mathematics-math",
    "duotone": true
  },
  {
    "component": "AddSquare",
    "name": "Add-Square",
    "category": "02-interface-actions",
    "keywords": "add-square--square-remove-cross-buttons-add-plus-button-+-mathematics-math",
    "duotone": true
  },
  {
    "component": "Bookmark",
    "name": "Bookmark",
    "category": "02-interface-actions",
    "keywords": "bookmark--bookmarks-tags-favorite",
    "duotone": false
  },
  {
    "component": "ButtonPower1",
    "name": "Button-Power-1",
    "category": "02-interface-actions",
    "keywords": "button-power-1--power-button-on-off",
    "duotone": false
  },
  {
    "component": "CheckSquare",
    "name": "Check-Square",
    "category": "02-interface-actions",
    "keywords": "check-square--check-form-validation-checkmark-success-add-addition-box-square-tick",
    "duotone": true
  },
  {
    "component": "Check",
    "name": "Check",
    "category": "02-interface-actions",
    "keywords": "check--check-form-validation-checkmark-success-add-addition-tick",
    "duotone": false
  },
  {
    "component": "Cog",
    "name": "Cog",
    "category": "02-interface-actions",
    "keywords": "cog--work-loading-cog-gear-settings-machine",
    "duotone": false
  },
  {
    "component": "Cut",
    "name": "Cut",
    "category": "02-interface-actions",
    "keywords": "cut--coupon-cut-discount-price-prices-scissors",
    "duotone": true
  },
  {
    "component": "Delete1",
    "name": "Delete-1",
    "category": "02-interface-actions",
    "keywords": "delete-1--remove-add-button-buttons-delete-cross-x-mathematics-multiply-math",
    "duotone": false
  },
  {
    "component": "DeleteKeyboard",
    "name": "Delete-Keyboard",
    "category": "02-interface-actions",
    "keywords": "delete-keyboard",
    "duotone": true
  },
  {
    "component": "DisableHeart",
    "name": "Disable-Heart",
    "category": "02-interface-actions",
    "keywords": "disable-heart",
    "duotone": true
  },
  {
    "component": "Filter2",
    "name": "Filter-2",
    "category": "02-interface-actions",
    "keywords": "filter-2--funnel-filter-angle-oil",
    "duotone": false
  },
  {
    "component": "HelpQuestion1",
    "name": "Help-Question-1",
    "category": "02-interface-actions",
    "keywords": "help-question-1--circle-faq-frame-help-info-mark-more-query-question",
    "duotone": true
  },
  {
    "component": "HorizontalMenuCircle",
    "name": "Horizontal-Menu-Circle",
    "category": "02-interface-actions",
    "keywords": "horizontal-menu-circle--navigation-dots-three-circle-button-horizontal-menu",
    "duotone": true
  },
  {
    "component": "InformationCircle",
    "name": "Information-Circle",
    "category": "02-interface-actions",
    "keywords": "information-circle--information-frame-info-more-help-point-circle",
    "duotone": true
  },
  {
    "component": "MagnifyingGlassCircle",
    "name": "Magnifying-Glass-Circle",
    "category": "02-interface-actions",
    "keywords": "magnifying-glass-circle--circle-glass-search-magnifying",
    "duotone": true
  },
  {
    "component": "MagnifyingGlass",
    "name": "Magnifying-Glass",
    "category": "02-interface-actions",
    "keywords": "magnifying-glass--glass-search-magnifying",
    "duotone": true
  },
  {
    "component": "SearchVisual",
    "name": "Search-Visual",
    "category": "02-interface-actions",
    "keywords": "search-visual",
    "duotone": true
  },
  {
    "component": "Subtract1",
    "name": "Subtract-1",
    "category": "02-interface-actions",
    "keywords": "subtract-1--button-delete-buttons-subtract-horizontal-remove-line-add-mathematics-math-minus",
    "duotone": false
  },
  {
    "component": "SubtractCircle",
    "name": "Subtract-Circle",
    "category": "02-interface-actions",
    "keywords": "subtract-circle--delete-add-circle-subtract-button-buttons-remove-mathematics-math-minus",
    "duotone": true
  },
  {
    "component": "SubtractSquare",
    "name": "Subtract-Square",
    "category": "02-interface-actions",
    "keywords": "subtract-square--subtract-buttons-remove-add-button-square-delete-mathematics-math-minus",
    "duotone": true
  },
  {
    "component": "Target3",
    "name": "Target-3",
    "category": "02-interface-actions",
    "keywords": "target-3--shop-bullseye-shooting-target",
    "duotone": true
  },
  {
    "component": "Target",
    "name": "Target",
    "category": "02-interface-actions",
    "keywords": "target--shop-bullseye-arrow-target",
    "duotone": true
  },
  {
    "component": "VerticalSliderSquare",
    "name": "Vertical-Slider-Square",
    "category": "02-interface-actions",
    "keywords": "vertical-slider-square--adjustment-adjust-controls-fader-vertical-settings-slider-square",
    "duotone": true
  },
  {
    "component": "WarningTriangle",
    "name": "Warning-Triangle",
    "category": "02-interface-actions",
    "keywords": "warning-triangle--frame-alert-warning-triangle-exclamation-caution",
    "duotone": true
  },
  {
    "component": "Wrench",
    "name": "Wrench",
    "category": "02-interface-actions",
    "keywords": "wrench--crescent-tool-construction-tools-wrench-setting-edit-adjust",
    "duotone": false
  },
  {
    "component": "ArchiveBox",
    "name": "Archive-Box",
    "category": "03-files-folders",
    "keywords": "archive-box--box-content-banker-archive-file",
    "duotone": true
  },
  {
    "component": "BlankNotepad",
    "name": "Blank-Notepad",
    "category": "03-files-folders",
    "keywords": "blank-notepad--content-notes-book-notepad-notebook",
    "duotone": true
  },
  {
    "component": "BoxSign",
    "name": "Box-Sign",
    "category": "03-files-folders",
    "keywords": "box-sign--box-package-label-delivery-shipment-shipping-this-way-up-arrow-sign-sticker",
    "duotone": true
  },
  {
    "component": "ClipboardAdd",
    "name": "Clipboard-Add",
    "category": "03-files-folders",
    "keywords": "clipboard-add--edit-task-edition-add-clipboard-form",
    "duotone": true
  },
  {
    "component": "ClipboardCheck",
    "name": "Clipboard-Check",
    "category": "03-files-folders",
    "keywords": "clipboard-check--checkmark-edit-task-edition-checklist-check-success-clipboard-form",
    "duotone": true
  },
  {
    "component": "ClipboardRemove",
    "name": "Clipboard-Remove",
    "category": "03-files-folders",
    "keywords": "clipboard-remove--edit-task-edition-remove-delete-clipboard-form",
    "duotone": true
  },
  {
    "component": "CopyPaste",
    "name": "Copy-Paste",
    "category": "03-files-folders",
    "keywords": "copy-paste--clipboard-copy-cut-paste",
    "duotone": true
  },
  {
    "component": "DownloadBox1",
    "name": "Download-Box-1",
    "category": "03-files-folders",
    "keywords": "download-box-1--arrow-box-down-download-internet-network-server-upload",
    "duotone": true
  },
  {
    "component": "DownloadCircle",
    "name": "Download-Circle",
    "category": "03-files-folders",
    "keywords": "download-circle--arrow-circle-down-download-internet-network-server-upload",
    "duotone": true
  },
  {
    "component": "DownloadComputer",
    "name": "Download-Computer",
    "category": "03-files-folders",
    "keywords": "download-computer--action-actions-computer-desktop-device-display-download-monitor-screen",
    "duotone": true
  },
  {
    "component": "DownloadFile",
    "name": "Download-File",
    "category": "03-files-folders",
    "keywords": "download-file",
    "duotone": true
  },
  {
    "component": "EmptyClipboard",
    "name": "Empty-Clipboard",
    "category": "03-files-folders",
    "keywords": "empty-clipboard--work-plain-clipboard-task-list-company-office",
    "duotone": true
  },
  {
    "component": "FileAddAlternate",
    "name": "File-Add-Alternate",
    "category": "03-files-folders",
    "keywords": "file-add-alternate--file-common-add",
    "duotone": true
  },
  {
    "component": "FileDeleteAlternate",
    "name": "File-Delete-Alternate",
    "category": "03-files-folders",
    "keywords": "file-delete-alternate--file-common-delete-cross",
    "duotone": true
  },
  {
    "component": "FileRemoveAlternate",
    "name": "File-Remove-Alternate",
    "category": "03-files-folders",
    "keywords": "file-remove-alternate--file-common-remove-minus-subtract",
    "duotone": true
  },
  {
    "component": "FolderAdd",
    "name": "Folder-Add",
    "category": "03-files-folders",
    "keywords": "folder-add--add-folder-plus",
    "duotone": true
  },
  {
    "component": "FolderCheck",
    "name": "Folder-Check",
    "category": "03-files-folders",
    "keywords": "folder-check--remove-check-folder",
    "duotone": true
  },
  {
    "component": "FolderDelete",
    "name": "Folder-Delete",
    "category": "03-files-folders",
    "keywords": "folder-delete--remove-minus-folder-subtract-delete",
    "duotone": true
  },
  {
    "component": "LocalStorageFolder",
    "name": "Local-Storage-Folder",
    "category": "03-files-folders",
    "keywords": "local-storage-folder",
    "duotone": true
  },
  {
    "component": "MultipleFile2",
    "name": "Multiple-File-2",
    "category": "03-files-folders",
    "keywords": "multiple-file-2--double-common-file",
    "duotone": true
  },
  {
    "component": "NewFile",
    "name": "New-File",
    "category": "03-files-folders",
    "keywords": "new-file--empty-common-file-content",
    "duotone": true
  },
  {
    "component": "NewFolder",
    "name": "New-Folder",
    "category": "03-files-folders",
    "keywords": "new-folder--empty-folder",
    "duotone": false
  },
  {
    "component": "NewStickyNote",
    "name": "New-Sticky-Note",
    "category": "03-files-folders",
    "keywords": "new-sticky-note--empty-common-file",
    "duotone": true
  },
  {
    "component": "PageSetting",
    "name": "Page-Setting",
    "category": "03-files-folders",
    "keywords": "page-setting--page-setting-square-triangle-circle-line-combination-variation",
    "duotone": true
  },
  {
    "component": "Paperclip1",
    "name": "Paperclip-1",
    "category": "03-files-folders",
    "keywords": "paperclip-1--attachment-link-paperclip-unlink",
    "duotone": false
  },
  {
    "component": "RecycleBin2",
    "name": "Recycle-Bin-2",
    "category": "03-files-folders",
    "keywords": "recycle-bin-2--remove-delete-empty-bin-trash-garbage",
    "duotone": true
  },
  {
    "component": "Shredder",
    "name": "Shredder",
    "category": "03-files-folders",
    "keywords": "shredder--device-electronics-shred-paper-cut-destroy-remove-delete",
    "duotone": true
  },
  {
    "component": "UploadBox1",
    "name": "Upload-Box-1",
    "category": "03-files-folders",
    "keywords": "upload-box-1--arrow-box-download-internet-network-server-up-upload",
    "duotone": true
  },
  {
    "component": "UploadCircle",
    "name": "Upload-Circle",
    "category": "03-files-folders",
    "keywords": "upload-circle--arrow-circle-download-internet-network-server-up-upload",
    "duotone": true
  },
  {
    "component": "UploadComputer",
    "name": "Upload-Computer",
    "category": "03-files-folders",
    "keywords": "upload-computer--action-actions-computer-desktop-device-display-monitor-screen-upload",
    "duotone": true
  },
  {
    "component": "UploadFile",
    "name": "Upload-File",
    "category": "03-files-folders",
    "keywords": "upload-file",
    "duotone": true
  },
  {
    "component": "AddBellNotification",
    "name": "Add-Bell-Notification",
    "category": "04-communication",
    "keywords": "add-bell-notification--notification-alarm-alert-bell-add",
    "duotone": true
  },
  {
    "component": "AnnouncementMegaphone",
    "name": "Announcement-Megaphone",
    "category": "04-communication",
    "keywords": "annoncement-megaphone",
    "duotone": true
  },
  {
    "component": "CallCenterSupportService",
    "name": "Call-Center-Support-Service",
    "category": "04-communication",
    "keywords": "call-center-support-service",
    "duotone": true
  },
  {
    "component": "CallHangUp",
    "name": "Call-Hang-Up",
    "category": "04-communication",
    "keywords": "call-hang-up--phone-telephone-mobile-device-smartphone-call-hang-up",
    "duotone": true
  },
  {
    "component": "ChatBubbleOvalNotification",
    "name": "Chat-Bubble-Oval-Notification",
    "category": "04-communication",
    "keywords": "chat-bubble-oval-notification--messages-message-bubble-chat-oval-notify-ping",
    "duotone": true
  },
  {
    "component": "ChatBubbleOval",
    "name": "Chat-Bubble-Oval",
    "category": "04-communication",
    "keywords": "chat-bubble-oval--messages-message-bubble-chat-oval",
    "duotone": false
  },
  {
    "component": "ChatBubbleSquareQuestion",
    "name": "Chat-Bubble-Square-Question",
    "category": "04-communication",
    "keywords": "chat-bubble-square-question--bubble-square-messages-notification-chat-message-question-help",
    "duotone": true
  },
  {
    "component": "ChatBubbleSquareWarning",
    "name": "Chat-Bubble-Square-Warning",
    "category": "04-communication",
    "keywords": "chat-bubble-square-warning--bubble-square-messages-notification-chat-message-warning-alert",
    "duotone": true
  },
  {
    "component": "ChatBubbleSquareWrite",
    "name": "Chat-Bubble-Square-Write",
    "category": "04-communication",
    "keywords": "chat-bubble-square-write--messages-message-bubble-chat-square-write-review-pen-pencil-compose",
    "duotone": true
  },
  {
    "component": "ChatBubbleTextSquare",
    "name": "Chat-Bubble-Text-Square",
    "category": "04-communication",
    "keywords": "chat-bubble-text-square--messages-message-bubble-text-square-chat",
    "duotone": true
  },
  {
    "component": "ChatBubbleTypingOval",
    "name": "Chat-Bubble-Typing-Oval",
    "category": "04-communication",
    "keywords": "chat-bubble-typing-oval--messages-message-bubble-typing-chat",
    "duotone": true
  },
  {
    "component": "ChatTwoBubblesOval",
    "name": "Chat-Two-Bubbles-Oval",
    "category": "04-communication",
    "keywords": "chat-two-bubbles-oval--messages-message-bubble-chat-oval-conversation",
    "duotone": true
  },
  {
    "component": "ContactPhonebook2",
    "name": "Contact-Phonebook-2",
    "category": "04-communication",
    "keywords": "contact-phonebook-2",
    "duotone": true
  },
  {
    "component": "CustomerSupport1",
    "name": "Customer-Support-1",
    "category": "04-communication",
    "keywords": "customer-support-1--customer-headset-help-microphone-phone-support",
    "duotone": true
  },
  {
    "component": "DisableBellNotification",
    "name": "Disable-Bell-Notification",
    "category": "04-communication",
    "keywords": "disable-bell-notification--disable-silent-notification-off-silence-alarm-bell-alert",
    "duotone": true
  },
  {
    "component": "DiscussionConverstionReply",
    "name": "Discussion-Converstion-Reply",
    "category": "04-communication",
    "keywords": "discussion-converstion-reply",
    "duotone": false
  },
  {
    "component": "GroupMeetingCall",
    "name": "Group-Meeting-Call",
    "category": "04-communication",
    "keywords": "group-meeting-call--group-meeting-call-work",
    "duotone": true
  },
  {
    "component": "HangUp1",
    "name": "Hang-Up-1",
    "category": "04-communication",
    "keywords": "hang-up-1--android-phone-mobile-device-smartphone-iphone-telephone-hang-up",
    "duotone": false
  },
  {
    "component": "HangUp2",
    "name": "Hang-Up-2",
    "category": "04-communication",
    "keywords": "hang-up-2--android-phone-mobile-device-smartphone-iphone-telephone-hang-up",
    "duotone": true
  },
  {
    "component": "HelpChat2",
    "name": "Help-Chat-2",
    "category": "04-communication",
    "keywords": "help-chat-2--bubble-help-mark-message-query-question-speech-circle",
    "duotone": true
  },
  {
    "component": "InboxFavoriteHeart",
    "name": "Inbox-Favorite-Heart",
    "category": "04-communication",
    "keywords": "inbox-favorite-heart--mail-envelope-email-message-heart-favorite-like-love-important-bookmark",
    "duotone": true
  },
  {
    "component": "InboxFavorite",
    "name": "Inbox-Favorite",
    "category": "04-communication",
    "keywords": "inbox-favorite--mail-envelope-email-message-star-favorite-important-bookmark",
    "duotone": true
  },
  {
    "component": "InboxTray1",
    "name": "Inbox-Tray-1",
    "category": "04-communication",
    "keywords": "inbox-tray-1--mail-email-outbox-drawer-empty-open-inbox-arrow-down",
    "duotone": true
  },
  {
    "component": "InboxTray2",
    "name": "Inbox-Tray-2",
    "category": "04-communication",
    "keywords": "inbox-tray-2--mail-email-outbox-drawer-empty-open-inbox-arrow-up",
    "duotone": true
  },
  {
    "component": "IncomingCall",
    "name": "Incoming-Call",
    "category": "04-communication",
    "keywords": "incoming-call--android-phone-mobile-device-smartphone-iphone-ringing-incoming-call",
    "duotone": true
  },
  {
    "component": "MailIncoming",
    "name": "Mail-Incoming",
    "category": "04-communication",
    "keywords": "mail-incoming--inbox-envelope-email-message-down-arrow-inbox",
    "duotone": true
  },
  {
    "component": "MailSearch",
    "name": "Mail-Search",
    "category": "04-communication",
    "keywords": "mail-search--inbox-envelope-email-message-search",
    "duotone": true
  },
  {
    "component": "MailSendEmailMessage",
    "name": "Mail-Send-Email-Message",
    "category": "04-communication",
    "keywords": "mail-send-email-message--send-email-paper-airplane-deliver",
    "duotone": true
  },
  {
    "component": "MailSendEnvelope",
    "name": "Mail-Send-Envelope",
    "category": "04-communication",
    "keywords": "mail-send-envelope--envelope-email-message-unopened-sealed-close",
    "duotone": true
  },
  {
    "component": "MailSendReplyAll",
    "name": "Mail-Send-Reply-All",
    "category": "04-communication",
    "keywords": "mail-send-reply-all--email-message-reply-all-actions-action-arrow",
    "duotone": false
  },
  {
    "component": "Megaphone2",
    "name": "Megaphone-2",
    "category": "04-communication",
    "keywords": "megaphone-2--bullhorn-loud-megaphone-share-speaker-transmit",
    "duotone": true
  },
  {
    "component": "MissedCall",
    "name": "Missed-Call",
    "category": "04-communication",
    "keywords": "missed-call--android-phone-mobile-device-smartphone-iphone-missed-call",
    "duotone": true
  },
  {
    "component": "NotificationApplication1",
    "name": "Notification-Application-1",
    "category": "04-communication",
    "keywords": "notification-application-1--android-phone-mobile-device-smartphone-iphone-alert-box",
    "duotone": true
  },
  {
    "component": "NotificationApplication2",
    "name": "Notification-Application-2",
    "category": "04-communication",
    "keywords": "notification-application-2--android-phone-mobile-device-smartphone-iphone-alert-box",
    "duotone": true
  },
  {
    "component": "NotificationMessageAlert",
    "name": "Notification-Message-Alert",
    "category": "04-communication",
    "keywords": "notification-message-alert--android-phone-mobile-device-smartphone-iphone-alert-message-text",
    "duotone": true
  },
  {
    "component": "OutgoingCall",
    "name": "Outgoing-Call",
    "category": "04-communication",
    "keywords": "outgoing-call--android-phone-mobile-device-smartphone-iphone-ringing-outgoing-call",
    "duotone": true
  },
  {
    "component": "RingingBellNotification",
    "name": "Ringing-Bell-Notification",
    "category": "04-communication",
    "keywords": "ringing-bell-notification--notification-vibrate-ring-sound-alarm-alert-bell-noise",
    "duotone": true
  },
  {
    "component": "SendEmail",
    "name": "Send-Email",
    "category": "04-communication",
    "keywords": "send-email--mail-send-email-paper-airplane",
    "duotone": true
  },
  {
    "component": "GenderEquality",
    "name": "Gender-Equality",
    "category": "05-users-people",
    "keywords": "gender-equality",
    "duotone": true
  },
  {
    "component": "ManSymbol",
    "name": "Man-Symbol",
    "category": "05-users-people",
    "keywords": "man-symbol--geometric-gender-boy-person-male-human-user",
    "duotone": false
  },
  {
    "component": "OfficeWorker",
    "name": "Office-Worker",
    "category": "05-users-people",
    "keywords": "office-worker--office-worker-human-resources",
    "duotone": true
  },
  {
    "component": "PoliticsCompaign",
    "name": "Politics-Compaign",
    "category": "05-users-people",
    "keywords": "politics-compaign",
    "duotone": true
  },
  {
    "component": "PoliticsSpeech",
    "name": "Politics-Speech",
    "category": "05-users-people",
    "keywords": "politics-speech",
    "duotone": true
  },
  {
    "component": "PoliticsVote2",
    "name": "Politics-Vote-2",
    "category": "05-users-people",
    "keywords": "politics-vote-2",
    "duotone": true
  },
  {
    "component": "ReducedInequalities",
    "name": "Reduced-Inequalities",
    "category": "05-users-people",
    "keywords": "reduced-inequalities",
    "duotone": true
  },
  {
    "component": "UserAddPlus",
    "name": "User-Add-Plus",
    "category": "05-users-people",
    "keywords": "user-add-plus--actions-add-close-geometric-human-person-plus-single-up-user",
    "duotone": true
  },
  {
    "component": "UserCheckValidate",
    "name": "User-Check-Validate",
    "category": "05-users-people",
    "keywords": "user-check-validate--actions-close-checkmark-check-geometric-human-person-single-success-up-user",
    "duotone": true
  },
  {
    "component": "UserCircleSingle",
    "name": "User-Circle-Single",
    "category": "05-users-people",
    "keywords": "user-circle-single--circle-geometric-human-person-single-user",
    "duotone": true
  },
  {
    "component": "UserIdentifierCard",
    "name": "User-Identifier-Card",
    "category": "05-users-people",
    "keywords": "user-identifier-card",
    "duotone": true
  },
  {
    "component": "UserMultipleCircle",
    "name": "User-Multiple-Circle",
    "category": "05-users-people",
    "keywords": "user-multiple-circle--close-geometric-human-multiple-person-up-user-circle",
    "duotone": true
  },
  {
    "component": "UserMultipleGroup",
    "name": "User-Multiple-Group",
    "category": "05-users-people",
    "keywords": "user-multiple-group--close-geometric-human-multiple-person-up-user",
    "duotone": true
  },
  {
    "component": "UserProfileFocus",
    "name": "User-Profile-Focus",
    "category": "05-users-people",
    "keywords": "user-profile-focus--close-geometric-human-person-profile-focus-user",
    "duotone": true
  },
  {
    "component": "UserRemoveSubtract",
    "name": "User-Remove-Subtract",
    "category": "05-users-people",
    "keywords": "user-remove-subtract--actions-remove-close-geometric-human-person-minus-single-up-user",
    "duotone": true
  },
  {
    "component": "UserSingleNeutralMale",
    "name": "User-Single-Neutral-Male",
    "category": "05-users-people",
    "keywords": "user-single-neutral-male--close-geometric-human-person-single-up-user-male",
    "duotone": true
  },
  {
    "component": "UserSyncOnlineInPerson",
    "name": "User-Sync-Online-In-Person",
    "category": "05-users-people",
    "keywords": "user-sync-online-in-person",
    "duotone": true
  },
  {
    "component": "WomanSymbol",
    "name": "Woman-Symbol",
    "category": "05-users-people",
    "keywords": "woman-symbol--geometric-gender-female-person-human-user",
    "duotone": false
  },
  {
    "component": "ButtonFastForward1",
    "name": "Button-Fast-Forward-1",
    "category": "06-media-audio-video",
    "keywords": "button-fast-forward-1--button-controls-fast-forward-movies-television-video-tv",
    "duotone": false
  },
  {
    "component": "ButtonFastForward2",
    "name": "Button-Fast-Forward-2",
    "category": "06-media-audio-video",
    "keywords": "button-fast-forward-2--button-controls-fast-forward-movies-television-video-tv",
    "duotone": false
  },
  {
    "component": "ButtonNext",
    "name": "Button-Next",
    "category": "06-media-audio-video",
    "keywords": "button-next--button-television-buttons-movies-skip-next-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonPause2",
    "name": "Button-Pause-2",
    "category": "06-media-audio-video",
    "keywords": "button-pause-2--button-television-buttons-movies-tv-pause-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonPlay",
    "name": "Button-Play",
    "category": "06-media-audio-video",
    "keywords": "button-play--button-television-buttons-movies-play-tv-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonPrevious",
    "name": "Button-Previous",
    "category": "06-media-audio-video",
    "keywords": "button-previous--button-television-buttons-movies-skip-previous-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonRecord3",
    "name": "Button-Record-3",
    "category": "06-media-audio-video",
    "keywords": "button-record-3--button-television-buttons-movies-record-tv-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonRewind1",
    "name": "Button-Rewind-1",
    "category": "06-media-audio-video",
    "keywords": "button-rewind-1--rewind-television-button-movies-buttons-tv-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonRewind2",
    "name": "Button-Rewind-2",
    "category": "06-media-audio-video",
    "keywords": "button-rewind-2--rewind-television-button-movies-buttons-tv-video-controls",
    "duotone": false
  },
  {
    "component": "ButtonStop",
    "name": "Button-Stop",
    "category": "06-media-audio-video",
    "keywords": "button-stop--button-television-buttons-movies-stop-tv-video-controls",
    "duotone": false
  },
  {
    "component": "EditImagePhoto",
    "name": "Edit-Image-Photo",
    "category": "06-media-audio-video",
    "keywords": "edit-image-photo",
    "duotone": true
  },
  {
    "component": "Eject",
    "name": "Eject",
    "category": "06-media-audio-video",
    "keywords": "eject--eject-unmount-dismount-remove-keyboard",
    "duotone": false
  },
  {
    "component": "FilmRoll1",
    "name": "Film-Roll-1",
    "category": "06-media-audio-video",
    "keywords": "film-roll-1--photos-camera-shutter-picture-photography-pictures-photo-film-roll",
    "duotone": true
  },
  {
    "component": "FilmSlate",
    "name": "Film-Slate",
    "category": "06-media-audio-video",
    "keywords": "film-slate--pictures-photo-film-slate",
    "duotone": true
  },
  {
    "component": "GifFormat",
    "name": "Gif-Format",
    "category": "06-media-audio-video",
    "keywords": "gif-format",
    "duotone": true
  },
  {
    "component": "ImageBlur",
    "name": "Image-Blur",
    "category": "06-media-audio-video",
    "keywords": "image-blur",
    "duotone": true
  },
  {
    "component": "ImageSaturation",
    "name": "Image-Saturation",
    "category": "06-media-audio-video",
    "keywords": "image-saturation",
    "duotone": true
  },
  {
    "component": "InsertCloudVideo",
    "name": "Insert-Cloud-Video",
    "category": "06-media-audio-video",
    "keywords": "insert-cloud-video",
    "duotone": true
  },
  {
    "component": "Landscape2",
    "name": "Landscape-2",
    "category": "06-media-audio-video",
    "keywords": "landscape-2--photos-photo-landscape-picture-photography-camera-pictures-image",
    "duotone": true
  },
  {
    "component": "LandscapeSetting",
    "name": "Landscape-Setting",
    "category": "06-media-audio-video",
    "keywords": "landscape-setting--design-composition-horizontal-lanscape",
    "duotone": true
  },
  {
    "component": "LiveVideo",
    "name": "Live-Video",
    "category": "06-media-audio-video",
    "keywords": "live-video",
    "duotone": true
  },
  {
    "component": "Loop1",
    "name": "Loop-1",
    "category": "06-media-audio-video",
    "keywords": "loop-1--multimedia-multi-button-repeat-media-loop-infinity-controls",
    "duotone": false
  },
  {
    "component": "MusicEqualizer",
    "name": "Music-Equalizer",
    "category": "06-media-audio-video",
    "keywords": "music-equalizer--music-audio-note-wave-sound-equalizer-entertainment",
    "duotone": false
  },
  {
    "component": "MusicFolderSong",
    "name": "Music-Folder-Song",
    "category": "06-media-audio-video",
    "keywords": "music-folder-song",
    "duotone": true
  },
  {
    "component": "MusicNote1",
    "name": "Music-Note-1",
    "category": "06-media-audio-video",
    "keywords": "music-note-1--music-audio-note-entertainment",
    "duotone": false
  },
  {
    "component": "MusicNote2",
    "name": "Music-Note-2",
    "category": "06-media-audio-video",
    "keywords": "music-note-2--music-audio-note-entertainment",
    "duotone": false
  },
  {
    "component": "MusicNoteOff1",
    "name": "Music-Note-Off-1",
    "category": "06-media-audio-video",
    "keywords": "music-note-off-1--music-audio-note-off-mute-entertainment",
    "duotone": true
  },
  {
    "component": "MusicNoteOff2",
    "name": "Music-Note-Off-2",
    "category": "06-media-audio-video",
    "keywords": "music-note-off-2--music-audio-note-off-mute-entertainment",
    "duotone": true
  },
  {
    "component": "PicturesFolderMemories",
    "name": "Pictures-Folder-Memories",
    "category": "06-media-audio-video",
    "keywords": "pictures-folder-memories",
    "duotone": true
  },
  {
    "component": "PlayList4",
    "name": "Play-List-4",
    "category": "06-media-audio-video",
    "keywords": "play-list-4--screen-television-display-player-movies-players-tv-media-video-entertainment",
    "duotone": true
  },
  {
    "component": "PlayList5",
    "name": "Play-List-5",
    "category": "06-media-audio-video",
    "keywords": "play-list-5--player-television-movies-slider-media-tv-players-video-stack-entertainment",
    "duotone": true
  },
  {
    "component": "PlayList8",
    "name": "Play-List-8",
    "category": "06-media-audio-video",
    "keywords": "play-list-8--player-television-movies-slider-media-tv-players-video-stack-entertainment",
    "duotone": true
  },
  {
    "component": "PlayList9",
    "name": "Play-List-9",
    "category": "06-media-audio-video",
    "keywords": "play-list-9--player-television-movies-slider-media-tv-players-video-stack-entertainment",
    "duotone": true
  },
  {
    "component": "PlayListFolder",
    "name": "Play-List-Folder",
    "category": "06-media-audio-video",
    "keywords": "play-list-folder--player-television-movies-slider-media-tv-players-video",
    "duotone": true
  },
  {
    "component": "PolaroidFour",
    "name": "Polaroid-Four",
    "category": "06-media-audio-video",
    "keywords": "polaroid-four--photos-camera-polaroid-picture-photography-pictures-four-photo-image",
    "duotone": true
  },
  {
    "component": "RecordingTapeBubbleCircle",
    "name": "Recording-Tape-Bubble-Circle",
    "category": "06-media-audio-video",
    "keywords": "recording-tape-bubble-circle--phone-device-mail-mobile-voice-machine-answering-chat-entertainment",
    "duotone": true
  },
  {
    "component": "RecordingTapeBubbleSquare",
    "name": "Recording-Tape-Bubble-Square",
    "category": "06-media-audio-video",
    "keywords": "recording-tape-bubble-square--phone-device-mail-mobile-voice-machine-answering-chat-entertainment",
    "duotone": true
  },
  {
    "component": "Shuffle",
    "name": "Shuffle",
    "category": "06-media-audio-video",
    "keywords": "shuffle--multimedia-shuffle-multi-button-controls-media",
    "duotone": true
  },
  {
    "component": "SongRecommendation",
    "name": "Song-Recommendation",
    "category": "06-media-audio-video",
    "keywords": "song-recommendation--song-recommendation-entertainment",
    "duotone": true
  },
  {
    "component": "TapeCassetteRecord",
    "name": "Tape-Cassette-Record",
    "category": "06-media-audio-video",
    "keywords": "tape-cassette-record--music-entertainment-tape-cassette-record",
    "duotone": true
  },
  {
    "component": "VoiceMailOff",
    "name": "Voice-Mail-Off",
    "category": "06-media-audio-video",
    "keywords": "voice-mail-off--mic-audio-mike-music-microphone-mute-off",
    "duotone": true
  },
  {
    "component": "VoiceMail",
    "name": "Voice-Mail",
    "category": "06-media-audio-video",
    "keywords": "voice-mail--mic-audio-mike-music-microphone",
    "duotone": true
  },
  {
    "component": "VolumeDown",
    "name": "Volume-Down",
    "category": "06-media-audio-video",
    "keywords": "volume-down--speaker-down-volume-control-audio-music-decrease-entertainment",
    "duotone": true
  },
  {
    "component": "VolumeLevelHigh",
    "name": "Volume-Level-High",
    "category": "06-media-audio-video",
    "keywords": "volume-level-high--speaker-high-volume-control-audio-music-entertainment",
    "duotone": true
  },
  {
    "component": "VolumeLevelLow",
    "name": "Volume-Level-Low",
    "category": "06-media-audio-video",
    "keywords": "volume-level-low--volume-speaker-lower-down-control-music-low-audio-entertainment",
    "duotone": true
  },
  {
    "component": "VolumeLevelOff",
    "name": "Volume-Level-Off",
    "category": "06-media-audio-video",
    "keywords": "volume-level-off--volume-speaker-control-music-audio-entertainment",
    "duotone": false
  },
  {
    "component": "VolumeMute",
    "name": "Volume-Mute",
    "category": "06-media-audio-video",
    "keywords": "volume-mute--speaker-remove-volume-control-audio-music-mute-off-cross-entertainment",
    "duotone": true
  },
  {
    "component": "VolumeOff",
    "name": "Volume-Off",
    "category": "06-media-audio-video",
    "keywords": "volume-off--speaker-music-mute-volume-control-audio-off-mute-entertainment",
    "duotone": true
  },
  {
    "component": "BackCamera1",
    "name": "Back-Camera-1",
    "category": "07-devices-hardware",
    "keywords": "back-camera-1--android-phone-mobile-device-smartphone-iphone-camera-lenses",
    "duotone": true
  },
  {
    "component": "BatteryAlert1",
    "name": "Battery-Alert-1",
    "category": "07-devices-hardware",
    "keywords": "battery-alert-1--phone-mobile-charge-device-electricity-power-battery-alert-warning",
    "duotone": true
  },
  {
    "component": "BatteryCharging",
    "name": "Battery-Charging",
    "category": "07-devices-hardware",
    "keywords": "battery-charging--phone-mobile-charge-device-electricity-power-battery-charging",
    "duotone": true
  },
  {
    "component": "BatteryEmpty1",
    "name": "Battery-Empty-1",
    "category": "07-devices-hardware",
    "keywords": "battery-empty-1--phone-mobile-charge-device-electricity-empty-power-battery",
    "duotone": false
  },
  {
    "component": "BatteryEmpty2",
    "name": "Battery-Empty-2",
    "category": "07-devices-hardware",
    "keywords": "battery-empty-2--phone-mobile-charge-device-electricity-empty-power-battery",
    "duotone": true
  },
  {
    "component": "BatteryFull1",
    "name": "Battery-Full-1",
    "category": "07-devices-hardware",
    "keywords": "battery-full-1--phone-mobile-charge-device-electricity-power-battery-full",
    "duotone": true
  },
  {
    "component": "BatteryLow1",
    "name": "Battery-Low-1",
    "category": "07-devices-hardware",
    "keywords": "battery-low-1--phone-mobile-charge-device-electricity-power-battery-low",
    "duotone": true
  },
  {
    "component": "BatteryMedium1",
    "name": "Battery-Medium-1",
    "category": "07-devices-hardware",
    "keywords": "battery-medium-1--phone-mobile-charge-medium-device-electricity-power-battery",
    "duotone": true
  },
  {
    "component": "Camera1",
    "name": "Camera-1",
    "category": "07-devices-hardware",
    "keywords": "camera-1--photos-picture-camera-photography-photo-pictures",
    "duotone": true
  },
  {
    "component": "CameraDisabled",
    "name": "Camera-Disabled",
    "category": "07-devices-hardware",
    "keywords": "camera-disabled--photos-picture-camera-photography-photo-pictures-disabled-off",
    "duotone": true
  },
  {
    "component": "CameraLoading",
    "name": "Camera-Loading",
    "category": "07-devices-hardware",
    "keywords": "camera-loading--photos-picture-camera-photography-photo-pictures-loading-option-setting",
    "duotone": true
  },
  {
    "component": "CameraSquare",
    "name": "Camera-Square",
    "category": "07-devices-hardware",
    "keywords": "camera-square--photos-picture-camera-photography-photo-pictures-frame-square",
    "duotone": true
  },
  {
    "component": "CameraVideo",
    "name": "Camera-Video",
    "category": "07-devices-hardware",
    "keywords": "camera-video--film-television-tv-camera-movies-video-recorder",
    "duotone": true
  },
  {
    "component": "ComputerPcDesktop",
    "name": "Computer-Pc-Desktop",
    "category": "07-devices-hardware",
    "keywords": "computer-pc-desktop--screen-desktop-monitor-device-electronics-display-pc-computer",
    "duotone": true
  },
  {
    "component": "DesktopChat",
    "name": "Desktop-Chat",
    "category": "07-devices-hardware",
    "keywords": "desktop-chat--bubble-chat-customer-service-conversation-display-device",
    "duotone": true
  },
  {
    "component": "DesktopCheck",
    "name": "Desktop-Check",
    "category": "07-devices-hardware",
    "keywords": "desktop-check--success-approve-device-display-desktop-computer",
    "duotone": true
  },
  {
    "component": "DesktopDelete",
    "name": "Desktop-Delete",
    "category": "07-devices-hardware",
    "keywords": "desktop-delete--device-remove-display-computer-deny-desktop-fail-failure-cross",
    "duotone": true
  },
  {
    "component": "DesktopFavoriteStar",
    "name": "Desktop-Favorite-Star",
    "category": "07-devices-hardware",
    "keywords": "desktop-favorite-star--desktop-device-display-like-favorite-star",
    "duotone": true
  },
  {
    "component": "DesktopHelp",
    "name": "Desktop-Help",
    "category": "07-devices-hardware",
    "keywords": "desktop-help--device-help-information-display-desktop-question-info",
    "duotone": true
  },
  {
    "component": "Earpods",
    "name": "Earpods",
    "category": "07-devices-hardware",
    "keywords": "earpods--airpods-audio-earpods-music-earbuds-true-wireless-entertainment",
    "duotone": false
  },
  {
    "component": "ElectricCord1",
    "name": "Electric-Cord-1",
    "category": "07-devices-hardware",
    "keywords": "electric-cord-1--electricity-electronic-appliances-device-cord-cable-plug-connection",
    "duotone": true
  },
  {
    "component": "ElectricCord3",
    "name": "Electric-Cord-3",
    "category": "07-devices-hardware",
    "keywords": "electric-cord-3--electricity-electronic-appliances-device-cord-cable-plug-connection",
    "duotone": true
  },
  {
    "component": "FireAlarm2",
    "name": "Fire-Alarm-2",
    "category": "07-devices-hardware",
    "keywords": "fire-alarm-2",
    "duotone": true
  },
  {
    "component": "FireExtinguisherSign",
    "name": "Fire-Extinguisher-Sign",
    "category": "07-devices-hardware",
    "keywords": "fire-extinguisher-sign",
    "duotone": true
  },
  {
    "component": "FloppyDisk",
    "name": "Floppy-Disk",
    "category": "07-devices-hardware",
    "keywords": "floppy-disk--disk-floppy-electronics-device-disc-computer-storage",
    "duotone": true
  },
  {
    "component": "FrontCamera",
    "name": "Front-Camera",
    "category": "07-devices-hardware",
    "keywords": "front-camera",
    "duotone": true
  },
  {
    "component": "Gramophone",
    "name": "Gramophone",
    "category": "07-devices-hardware",
    "keywords": "gramophone--music-audio-note-gramophone-player-vintage-entertainment",
    "duotone": true
  },
  {
    "component": "HardDisk",
    "name": "Hard-Disk",
    "category": "07-devices-hardware",
    "keywords": "hard-disk--device-disc-drive-disk-electronics-platter-turntable-raid-storage",
    "duotone": true
  },
  {
    "component": "HardDrive1",
    "name": "Hard-Drive-1",
    "category": "07-devices-hardware",
    "keywords": "hard-drive-1--disk-device-electronics-disc-drive-raid-storage",
    "duotone": true
  },
  {
    "component": "KeyboardVirtual",
    "name": "Keyboard-Virtual",
    "category": "07-devices-hardware",
    "keywords": "keyboard-virtual--remote-device-electronics-qwerty-keyboard-virtual-interface",
    "duotone": true
  },
  {
    "component": "KeyboardWireless2",
    "name": "Keyboard-Wireless-2",
    "category": "07-devices-hardware",
    "keywords": "keyboard-wireless-2--remote-device-wireless-electronics-qwerty-keyboard-bluetooth",
    "duotone": true
  },
  {
    "component": "Keyboard",
    "name": "Keyboard",
    "category": "07-devices-hardware",
    "keywords": "keyboard--keyboard-device-electronics-dvorak-qwerty",
    "duotone": true
  },
  {
    "component": "LaptopCamera",
    "name": "Laptop-Camera",
    "category": "07-devices-hardware",
    "keywords": "laptop-camera--photos-photo-picture-photography-camera-pictures-laptop-computer",
    "duotone": true
  },
  {
    "component": "LaptopCharging",
    "name": "Laptop-Charging",
    "category": "07-devices-hardware",
    "keywords": "laptop-charging--device-laptop-electronics-computer-notebook-charging",
    "duotone": true
  },
  {
    "component": "MobilePhoneCamera",
    "name": "Mobile-Phone-Camera",
    "category": "07-devices-hardware",
    "keywords": "mobile-phone-camera--photos-photo-picture-photography-camera-pictures-phone",
    "duotone": true
  },
  {
    "component": "MouseWireless1",
    "name": "Mouse-Wireless-1",
    "category": "07-devices-hardware",
    "keywords": "mouse-wireless-1--remote-wireless-device-electronics-mouse-computer",
    "duotone": true
  },
  {
    "component": "MouseWireless",
    "name": "Mouse-Wireless",
    "category": "07-devices-hardware",
    "keywords": "mouse-wireless--remote-wireless-device-electronics-mouse-computer",
    "duotone": true
  },
  {
    "component": "Mouse",
    "name": "Mouse",
    "category": "07-devices-hardware",
    "keywords": "mouse--device-electronics-mouse",
    "duotone": true
  },
  {
    "component": "PhoneMobilePhone",
    "name": "Phone-Mobile-Phone",
    "category": "07-devices-hardware",
    "keywords": "phone-mobile-phone--android-phone-mobile-device-smartphone-iphone",
    "duotone": true
  },
  {
    "component": "PhoneQr",
    "name": "Phone-Qr",
    "category": "07-devices-hardware",
    "keywords": "phone-qr--android-phone-mobile-device-smartphone-iphone-qr-code-scan",
    "duotone": true
  },
  {
    "component": "PhoneRinging1",
    "name": "Phone-Ringing-1",
    "category": "07-devices-hardware",
    "keywords": "phone-ringing-1--android-phone-mobile-device-smartphone-iphone-ringing-incoming-call",
    "duotone": true
  },
  {
    "component": "PhoneRinging2",
    "name": "Phone-Ringing-2",
    "category": "07-devices-hardware",
    "keywords": "phone-ringing-2--android-phone-mobile-device-smartphone-iphone-ringing",
    "duotone": true
  },
  {
    "component": "Phone",
    "name": "Phone",
    "category": "07-devices-hardware",
    "keywords": "phone--android-phone-mobile-device-smartphone-iphone",
    "duotone": false
  },
  {
    "component": "Printer",
    "name": "Printer",
    "category": "07-devices-hardware",
    "keywords": "printer--scan-device-electronics-printer-print-computer",
    "duotone": true
  },
  {
    "component": "Radio",
    "name": "Radio",
    "category": "07-devices-hardware",
    "keywords": "radio--antenna-audio-music-radio-entertainment",
    "duotone": true
  },
  {
    "component": "Scanner3",
    "name": "Scanner-3",
    "category": "07-devices-hardware",
    "keywords": "scanner-3--payment-electronic-cash-dollar-codes-tags-upc-barcode-qr",
    "duotone": true
  },
  {
    "component": "Scanner",
    "name": "Scanner",
    "category": "07-devices-hardware",
    "keywords": "scanner",
    "duotone": true
  },
  {
    "component": "Screen1",
    "name": "Screen-1",
    "category": "07-devices-hardware",
    "keywords": "screen-1--screen-device-electronics-monitor-diplay-computer",
    "duotone": true
  },
  {
    "component": "Screen2",
    "name": "Screen-2",
    "category": "07-devices-hardware",
    "keywords": "screen-2--screen-device-electronics-monitor-diplay-computer",
    "duotone": true
  },
  {
    "component": "ScreenCurve",
    "name": "Screen-Curve",
    "category": "07-devices-hardware",
    "keywords": "screen-curve--screen-curved-device-electronics-monitor-diplay-computer",
    "duotone": true
  },
  {
    "component": "ScreensaverMonitorWallpaper",
    "name": "Screensaver-Monitor-Wallpaper",
    "category": "07-devices-hardware",
    "keywords": "screensaver-monitor-wallpaper",
    "duotone": true
  },
  {
    "component": "SmokeDetector",
    "name": "Smoke-Detector",
    "category": "07-devices-hardware",
    "keywords": "smoke-detector--smoke-alert-fire-signal",
    "duotone": true
  },
  {
    "component": "Speaker1",
    "name": "Speaker-1",
    "category": "07-devices-hardware",
    "keywords": "speaker-1--speaker-music-audio-subwoofer-entertainment",
    "duotone": true
  },
  {
    "component": "Speaker2",
    "name": "Speaker-2",
    "category": "07-devices-hardware",
    "keywords": "speaker-2--speakers-music-audio-entertainment",
    "duotone": true
  },
  {
    "component": "UsbDrive",
    "name": "Usb-Drive",
    "category": "07-devices-hardware",
    "keywords": "usb-drive--usb-drive-stick-memory-storage-data-connection",
    "duotone": true
  },
  {
    "component": "VideoSwapCamera",
    "name": "Video-Swap-Camera",
    "category": "07-devices-hardware",
    "keywords": "video-swap-camera",
    "duotone": true
  },
  {
    "component": "VirtualReality",
    "name": "Virtual-Reality",
    "category": "07-devices-hardware",
    "keywords": "virtual-reality--gaming-virtual-gear-controller-reality-games-headset-technology-vr-eyewear",
    "duotone": true
  },
  {
    "component": "VrHeadset1",
    "name": "Vr-Headset-1",
    "category": "07-devices-hardware",
    "keywords": "vr-headset-1--entertainment-gaming-vr-headset",
    "duotone": true
  },
  {
    "component": "VrHeadset2",
    "name": "Vr-Headset-2",
    "category": "07-devices-hardware",
    "keywords": "vr-headset-2--entertainment-gaming-vr-headset",
    "duotone": true
  },
  {
    "component": "WebcamVideoCircle",
    "name": "Webcam-Video-Circle",
    "category": "07-devices-hardware",
    "keywords": "webcam-video-circle--work-video-meeting-camera-company-conference-office",
    "duotone": true
  },
  {
    "component": "WebcamVideoOff",
    "name": "Webcam-Video-Off",
    "category": "07-devices-hardware",
    "keywords": "webcam-video-off--work-video-meeting-camera-company-conference-office-off",
    "duotone": true
  },
  {
    "component": "WebcamVideo",
    "name": "Webcam-Video",
    "category": "07-devices-hardware",
    "keywords": "webcam-video--work-video-meeting-camera-company-conference-office",
    "duotone": false
  },
  {
    "component": "Webcam",
    "name": "Webcam",
    "category": "07-devices-hardware",
    "keywords": "webcam--webcam-camera-future-tech-chat-skype-technology-video",
    "duotone": true
  },
  {
    "component": "AiChipSpark",
    "name": "Ai-Chip-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-chip-spark--chip-processor-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiCloudSpark",
    "name": "Ai-Cloud-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-cloud-spark--cloud-internet-server-network-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiEditSpark",
    "name": "Ai-Edit-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-edit-spark--change-edit-modify-pencil-write-writing-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiEmailGeneratorSpark",
    "name": "Ai-Email-Generator-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-email-generator-spark--mail-envelope-inbox-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiGenerateLandscapeImageSpark",
    "name": "Ai-Generate-Landscape-Image-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-generate-landscape-image-spark--picture-photography-photo-image-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiGenerateMusicSpark",
    "name": "Ai-Generate-Music-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-generate-music-spark--music-audio-note-entertainment-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiGeneratePortraitImageSpark",
    "name": "Ai-Generate-Portrait-Image-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-generate-portrait-image-spark--picture-photography-photo-image-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiGenerateVariationSpark",
    "name": "Ai-Generate-Variation-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-generate-variation-spark--module-application-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiNavigationSpark",
    "name": "Ai-Navigation-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-navigation-spark--map-location-direction-travel-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiPromptSpark",
    "name": "Ai-Prompt-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-prompt-spark--app-code-apps-window-website-web-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiRedoSpark",
    "name": "Ai-Redo-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-redo-spark--arrow-refresh-sync-synchronize-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiSettingsSpark",
    "name": "Ai-Settings-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-settings-spark--cog-gear-settings-machine-artificial-intelligence",
    "duotone": true
  },
  {
    "component": "AiTechnologySpark",
    "name": "Ai-Technology-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-technology-spark--lightbulb-idea-bright-lighting-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "AiUpscaleSpark",
    "name": "Ai-Upscale-Spark",
    "category": "08-tech-ai-code",
    "keywords": "ai-upscale-spark--magnifier-zoom-view-find-search-ai",
    "duotone": true
  },
  {
    "component": "AiVehicleSpark1",
    "name": "Ai-Vehicle-Spark-1",
    "category": "08-tech-ai-code",
    "keywords": "ai-vehicle-spark-1--car-automated-transportation-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "ApplicationAdd",
    "name": "Application-Add",
    "category": "08-tech-ai-code",
    "keywords": "application-add--application-new-add-square",
    "duotone": true
  },
  {
    "component": "ArtificialIntelligenceSpark",
    "name": "Artificial-Intelligence-Spark",
    "category": "08-tech-ai-code",
    "keywords": "artificial-intelligence-spark--brain-thought-ai-automated-ai",
    "duotone": true
  },
  {
    "component": "BracesCircle",
    "name": "Braces-Circle",
    "category": "08-tech-ai-code",
    "keywords": "braces-circle--interface-math-braces-sign-mathematics",
    "duotone": true
  },
  {
    "component": "Bracket",
    "name": "Bracket",
    "category": "08-tech-ai-code",
    "keywords": "bracket--code-angle-programming-file-bracket",
    "duotone": false
  },
  {
    "component": "BrowserAdd",
    "name": "Browser-Add",
    "category": "08-tech-ai-code",
    "keywords": "browser-add--app-code-apps-add-window-plus",
    "duotone": true
  },
  {
    "component": "BrowserBuild",
    "name": "Browser-Build",
    "category": "08-tech-ai-code",
    "keywords": "browser-build--build-website-development-window-code-web-backend-browser-dev",
    "duotone": true
  },
  {
    "component": "BrowserCheck",
    "name": "Browser-Check",
    "category": "08-tech-ai-code",
    "keywords": "browser-check--checkmark-pass-window-app-code-success-check-apps",
    "duotone": true
  },
  {
    "component": "BrowserDelete",
    "name": "Browser-Delete",
    "category": "08-tech-ai-code",
    "keywords": "browser-delete--app-code-apps-fail-delete-window-remove-cross",
    "duotone": true
  },
  {
    "component": "BrowserHash",
    "name": "Browser-Hash",
    "category": "08-tech-ai-code",
    "keywords": "browser-hash--window-hash-code-internet-language-browser-web-tag",
    "duotone": true
  },
  {
    "component": "BrowserMultipleWindow",
    "name": "Browser-Multiple-Window",
    "category": "08-tech-ai-code",
    "keywords": "browser-multiple-window--app-code-apps-two-window-cascade",
    "duotone": true
  },
  {
    "component": "BrowserRemove",
    "name": "Browser-Remove",
    "category": "08-tech-ai-code",
    "keywords": "browser-remove--app-code-apps-subtract-window-minus",
    "duotone": true
  },
  {
    "component": "Bug",
    "name": "Bug",
    "category": "08-tech-ai-code",
    "keywords": "bug--code-bug-security-programming-secure-computer",
    "duotone": true
  },
  {
    "component": "CloudAdd",
    "name": "Cloud-Add",
    "category": "08-tech-ai-code",
    "keywords": "cloud-add--cloud-network-internet-add-server-plus",
    "duotone": true
  },
  {
    "component": "CloudBlock",
    "name": "Cloud-Block",
    "category": "08-tech-ai-code",
    "keywords": "cloud-block--cloud-network-internet-block-server-deny",
    "duotone": true
  },
  {
    "component": "CloudCheck",
    "name": "Cloud-Check",
    "category": "08-tech-ai-code",
    "keywords": "cloud-check--cloud-network-internet-check-server-approve",
    "duotone": true
  },
  {
    "component": "CloudDataTransfer",
    "name": "Cloud-Data-Transfer",
    "category": "08-tech-ai-code",
    "keywords": "cloud-data-transfer--cloud-data-transfer-internet-server-network",
    "duotone": true
  },
  {
    "component": "CloudRefresh",
    "name": "Cloud-Refresh",
    "category": "08-tech-ai-code",
    "keywords": "cloud-refresh--cloud-network-internet-server-refresh",
    "duotone": true
  },
  {
    "component": "CloudShare",
    "name": "Cloud-Share",
    "category": "08-tech-ai-code",
    "keywords": "cloud-share--cloud-network-internet-server-share",
    "duotone": true
  },
  {
    "component": "CloudWarning",
    "name": "Cloud-Warning",
    "category": "08-tech-ai-code",
    "keywords": "cloud-warning--cloud-network-internet-server-warning-alert",
    "duotone": true
  },
  {
    "component": "CloudWifi",
    "name": "Cloud-Wifi",
    "category": "08-tech-ai-code",
    "keywords": "cloud-wifi--cloud-wifi-internet-server-network",
    "duotone": true
  },
  {
    "component": "Cloud",
    "name": "Cloud",
    "category": "08-tech-ai-code",
    "keywords": "cloud--cloud-meteorology-cloudy-overcast-cover-weather",
    "duotone": false
  },
  {
    "component": "CodeAnalysis",
    "name": "Code-Analysis",
    "category": "08-tech-ai-code",
    "keywords": "code-analysis",
    "duotone": true
  },
  {
    "component": "CodeMonitor1",
    "name": "Code-Monitor-1",
    "category": "08-tech-ai-code",
    "keywords": "code-monitor-1--code-tags-angle-bracket-monitor",
    "duotone": true
  },
  {
    "component": "CodeMonitor2",
    "name": "Code-Monitor-2",
    "category": "08-tech-ai-code",
    "keywords": "code-monitor-2--code-tags-angle-image-ui-ux-design",
    "duotone": true
  },
  {
    "component": "Command",
    "name": "Command",
    "category": "08-tech-ai-code",
    "keywords": "command--mac-command-apple-keyboard",
    "duotone": false
  },
  {
    "component": "ComputerChip1",
    "name": "Computer-Chip-1",
    "category": "08-tech-ai-code",
    "keywords": "computer-chip-1--computer-device-chip-electronics-cpu-microprocessor",
    "duotone": true
  },
  {
    "component": "ComputerChip2",
    "name": "Computer-Chip-2",
    "category": "08-tech-ai-code",
    "keywords": "computer-chip-2--core-microprocessor-device-electronics-chip-computer",
    "duotone": true
  },
  {
    "component": "CurlyBrackets",
    "name": "Curly-Brackets",
    "category": "08-tech-ai-code",
    "keywords": "curly-brackets",
    "duotone": false
  },
  {
    "component": "Cyborg2",
    "name": "Cyborg-2",
    "category": "08-tech-ai-code",
    "keywords": "cyborg-2--artificial-robotics-intelligence-machine-technology-android",
    "duotone": true
  },
  {
    "component": "Cyborg",
    "name": "Cyborg",
    "category": "08-tech-ai-code",
    "keywords": "cyborg--artificial-robotics-intelligence-machine-technology-android",
    "duotone": true
  },
  {
    "component": "DatabaseCheck",
    "name": "Database-Check",
    "category": "08-tech-ai-code",
    "keywords": "database-check--raid-storage-code-disk-programming-database-array-hard-disc-check-approve",
    "duotone": true
  },
  {
    "component": "DatabaseRefresh",
    "name": "Database-Refresh",
    "category": "08-tech-ai-code",
    "keywords": "database-refresh--raid-storage-code-disk-programming-database-array-hard-disc-refresh",
    "duotone": true
  },
  {
    "component": "DatabaseRemove",
    "name": "Database-Remove",
    "category": "08-tech-ai-code",
    "keywords": "database-remove--raid-storage-code-disk-programming-database-array-hard-disc-remove-delete-cross",
    "duotone": true
  },
  {
    "component": "DatabaseServer1",
    "name": "Database-Server-1",
    "category": "08-tech-ai-code",
    "keywords": "database-server-1--server-network-internet",
    "duotone": true
  },
  {
    "component": "DatabaseServer2",
    "name": "Database-Server-2",
    "category": "08-tech-ai-code",
    "keywords": "database-server-2--server-network-internet",
    "duotone": true
  },
  {
    "component": "DatabaseSetting",
    "name": "Database-Setting",
    "category": "08-tech-ai-code",
    "keywords": "database-setting--raid-storage-code-disk-programming-database-array-hard-disc-setting",
    "duotone": true
  },
  {
    "component": "DatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinus",
    "name": "Database-Subtract-2-Raid-Storage-Code-Disk-Programming-Database-Array-Hard-Disc-Minus",
    "category": "08-tech-ai-code",
    "keywords": "database-subtract-2-raid-storage-code-disk-programming-database-array-hard-disc-minus",
    "duotone": true
  },
  {
    "component": "Database",
    "name": "Database",
    "category": "08-tech-ai-code",
    "keywords": "database--raid-storage-code-disk-programming-database-array-hard-disc",
    "duotone": true
  },
  {
    "component": "DesktopCode",
    "name": "Desktop-Code",
    "category": "08-tech-ai-code",
    "keywords": "desktop-code--desktop-device-display-computer-code-terminal-html-css-programming-system",
    "duotone": true
  },
  {
    "component": "FileCode1",
    "name": "File-Code-1",
    "category": "08-tech-ai-code",
    "keywords": "file-code-1--code-files-angle-programming-file-bracket",
    "duotone": true
  },
  {
    "component": "MarkdownCircleProgramming",
    "name": "Markdown-Circle-Programming",
    "category": "08-tech-ai-code",
    "keywords": "markdown-circle-programming",
    "duotone": true
  },
  {
    "component": "MarkdownDocumentProgramming",
    "name": "Markdown-Document-Programming",
    "category": "08-tech-ai-code",
    "keywords": "markdown-document-programming",
    "duotone": true
  },
  {
    "component": "ModuleThree",
    "name": "Module-Three",
    "category": "08-tech-ai-code",
    "keywords": "module-three--code-three-module-programming-plugin",
    "duotone": false
  },
  {
    "component": "SquareBracketsCircle",
    "name": "Square-Brackets-Circle",
    "category": "08-tech-ai-code",
    "keywords": "square-brackets-circle--interface-math-brackets-sign-mathematics",
    "duotone": true
  },
  {
    "component": "Widget",
    "name": "Widget",
    "category": "08-tech-ai-code",
    "keywords": "widget",
    "duotone": true
  },
  {
    "component": "AiNetworkSpark",
    "name": "Ai-Network-Spark",
    "category": "09-network-connectivity",
    "keywords": "ai-network-spark--globe-internet-world-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "BluetoothDisabled",
    "name": "Bluetooth-Disabled",
    "category": "09-network-connectivity",
    "keywords": "bluetooth-disabled--bluetooth-internet-server-network-wireless-disabled-off-connection",
    "duotone": true
  },
  {
    "component": "BluetoothSearching",
    "name": "Bluetooth-Searching",
    "category": "09-network-connectivity",
    "keywords": "bluetooth-searching--bluetooth-internet-server-network-wireless-searching-connecting-connection",
    "duotone": true
  },
  {
    "component": "Bluetooth",
    "name": "Bluetooth",
    "category": "09-network-connectivity",
    "keywords": "bluetooth--bluetooth-internet-server-network-wireless-connection",
    "duotone": false
  },
  {
    "component": "BrokenLink2",
    "name": "Broken-Link-2",
    "category": "09-network-connectivity",
    "keywords": "broken-link-2--break-broken-hyperlink-link-remove-unlink-chain",
    "duotone": true
  },
  {
    "component": "BrowserWebsite1",
    "name": "Browser-Website-1",
    "category": "09-network-connectivity",
    "keywords": "browser-website-1--app-code-apps-window-website-web",
    "duotone": true
  },
  {
    "component": "BrowserWifi",
    "name": "Browser-Wifi",
    "category": "09-network-connectivity",
    "keywords": "browser-wifi--wireless-wifi-internet-server-network-browser-connection",
    "duotone": true
  },
  {
    "component": "CellularNetwork4g",
    "name": "Cellular-Network-4g",
    "category": "09-network-connectivity",
    "keywords": "cellular-network-4g",
    "duotone": true
  },
  {
    "component": "CellularNetwork5g",
    "name": "Cellular-Network-5g",
    "category": "09-network-connectivity",
    "keywords": "cellular-network-5g",
    "duotone": true
  },
  {
    "component": "CellularNetworkLte",
    "name": "Cellular-Network-Lte",
    "category": "09-network-connectivity",
    "keywords": "cellular-network-lte",
    "duotone": true
  },
  {
    "component": "LinkChain",
    "name": "Link-Chain",
    "category": "09-network-connectivity",
    "keywords": "link-chain--create-hyperlink-link-make-unlink-connection-chain",
    "duotone": false
  },
  {
    "component": "Network",
    "name": "Network",
    "category": "09-network-connectivity",
    "keywords": "network--network-server-internet-ethernet-connection",
    "duotone": true
  },
  {
    "component": "RssSquare",
    "name": "Rss-Square",
    "category": "09-network-connectivity",
    "keywords": "rss-square--wireless-rss-feed-square-transmit-broadcast",
    "duotone": true
  },
  {
    "component": "RssSymbol",
    "name": "Rss-Symbol",
    "category": "09-network-connectivity",
    "keywords": "rss-symbol--wireless-feed-rss-transmit-broadcast",
    "duotone": true
  },
  {
    "component": "SatelliteDish",
    "name": "Satellite-Dish",
    "category": "09-network-connectivity",
    "keywords": "satellite-dish--broadcast-satellite-share-transmit-satellite",
    "duotone": true
  },
  {
    "component": "ScreenBroadcast",
    "name": "Screen-Broadcast",
    "category": "09-network-connectivity",
    "keywords": "screen-broadcast--wireless-feed-rss-transmit-broadcast-monitor-screen",
    "duotone": true
  },
  {
    "component": "ShareLink",
    "name": "Share-Link",
    "category": "09-network-connectivity",
    "keywords": "share-link--share-transmit",
    "duotone": true
  },
  {
    "component": "SignalFull",
    "name": "Signal-Full",
    "category": "09-network-connectivity",
    "keywords": "signal-full--phone-mobile-device-signal-wireless-smartphone-iphone-bar-bars-full-android",
    "duotone": false
  },
  {
    "component": "SignalLoading",
    "name": "Signal-Loading",
    "category": "09-network-connectivity",
    "keywords": "signal-loading--bracket-loading-internet-angle-signal-server-network-connecting-connection",
    "duotone": true
  },
  {
    "component": "SignalLow",
    "name": "Signal-Low",
    "category": "09-network-connectivity",
    "keywords": "signal-low--phone-mobile-device-signal-wireless-smartphone-iphone-bar-low-bars-android",
    "duotone": true
  },
  {
    "component": "SignalMedium",
    "name": "Signal-Medium",
    "category": "09-network-connectivity",
    "keywords": "signal-medium--smartphone-phone-mobile-device-iphone-signal-medium-wireless-bar-bars-android",
    "duotone": true
  },
  {
    "component": "SignalNone",
    "name": "Signal-None",
    "category": "09-network-connectivity",
    "keywords": "signal-none--phone-mobile-device-signal-wireless-smartphone-iphone-bar-bars-no-zero-android",
    "duotone": false
  },
  {
    "component": "Stream",
    "name": "Stream",
    "category": "09-network-connectivity",
    "keywords": "stream--stream-entertainment-gaming",
    "duotone": true
  },
  {
    "component": "WaveSignalSquare",
    "name": "Wave-Signal-Square",
    "category": "09-network-connectivity",
    "keywords": "wave-signal-square--heart-line-stats-beat-square-graph",
    "duotone": true
  },
  {
    "component": "WaveSignal",
    "name": "Wave-Signal",
    "category": "09-network-connectivity",
    "keywords": "wave-signal--heart-line-beat-square-graph-stats",
    "duotone": false
  },
  {
    "component": "Web",
    "name": "Web",
    "category": "09-network-connectivity",
    "keywords": "web--server-world-internet-earth-www-globe-worldwide-web-network",
    "duotone": true
  },
  {
    "component": "WifiAntenna",
    "name": "Wifi-Antenna",
    "category": "09-network-connectivity",
    "keywords": "wifi-antenna--wireless-wifi-internet-server-network-antenna-connection",
    "duotone": true
  },
  {
    "component": "WifiDisabled",
    "name": "Wifi-Disabled",
    "category": "09-network-connectivity",
    "keywords": "wifi-disabled--wireless-wifi-internet-server-network-disabled-off-offline-connection",
    "duotone": true
  },
  {
    "component": "WifiHorizontal",
    "name": "Wifi-Horizontal",
    "category": "09-network-connectivity",
    "keywords": "wifi-horizontal--wireless-wifi-internet-server-network-horizontal-connection",
    "duotone": true
  },
  {
    "component": "WifiRouter",
    "name": "Wifi-Router",
    "category": "09-network-connectivity",
    "keywords": "wifi-router--wireless-wifi-internet-server-network-connection",
    "duotone": true
  },
  {
    "component": "Wifi",
    "name": "Wifi",
    "category": "09-network-connectivity",
    "keywords": "wifi--wireless-wifi-internet-server-network-connection",
    "duotone": true
  },
  {
    "component": "BlockBellNotification",
    "name": "Block-Bell-Notification",
    "category": "10-security-privacy",
    "keywords": "block-bell-notification--notification-alarm-alert-bell-block",
    "duotone": true
  },
  {
    "component": "BrowserBlock",
    "name": "Browser-Block",
    "category": "10-security-privacy",
    "keywords": "browser-block--block-access-denied-window-browser-privacy-remove",
    "duotone": true
  },
  {
    "component": "BrowserLock",
    "name": "Browser-Lock",
    "category": "10-security-privacy",
    "keywords": "browser-lock--secure-password-window-browser-lock-security-login-encryption",
    "duotone": true
  },
  {
    "component": "BugAntivirusDebugging",
    "name": "Bug-Antivirus-Debugging",
    "category": "10-security-privacy",
    "keywords": "bug-antivirus-debugging--code-bug-security-programming-secure-computer-antivirus-block-protection-malware-debugging",
    "duotone": true
  },
  {
    "component": "BugAntivirusShield",
    "name": "Bug-Antivirus-Shield",
    "category": "10-security-privacy",
    "keywords": "bug-antivirus-shield--code-bug-security-programming-secure-computer-antivirus-shield-protection-malware",
    "duotone": true
  },
  {
    "component": "BugVirusBrowser",
    "name": "Bug-Virus-Browser",
    "category": "10-security-privacy",
    "keywords": "bug-virus-browser--bug-browser-file-virus-threat-danger-internet",
    "duotone": true
  },
  {
    "component": "BugVirusDocument",
    "name": "Bug-Virus-Document",
    "category": "10-security-privacy",
    "keywords": "bug-virus-document--bug-document-file-virus-threat-danger",
    "duotone": true
  },
  {
    "component": "BugVirusFolder",
    "name": "Bug-Virus-Folder",
    "category": "10-security-privacy",
    "keywords": "bug-virus-folder--bug-document-folder-virus-threat-danger",
    "duotone": true
  },
  {
    "component": "ChatBubbleSquareBlock",
    "name": "Chat-Bubble-Square-Block",
    "category": "10-security-privacy",
    "keywords": "chat-bubble-square-block--messages-message-bubble-chat-square-block",
    "duotone": true
  },
  {
    "component": "DatabaseLock",
    "name": "Database-Lock",
    "category": "10-security-privacy",
    "keywords": "database-lock--raid-storage-code-disk-programming-database-array-hard-disc-password-security-protection-lock-secure",
    "duotone": true
  },
  {
    "component": "DeviceDatabaseEncryption1",
    "name": "Device-Database-Encryption-1",
    "category": "10-security-privacy",
    "keywords": "device-database-encryption-1",
    "duotone": true
  },
  {
    "component": "EyeOptic",
    "name": "Eye-Optic",
    "category": "10-security-privacy",
    "keywords": "eye-optic--health-medical-eye-optic",
    "duotone": true
  },
  {
    "component": "FaceScan1",
    "name": "Face-Scan-1",
    "category": "10-security-privacy",
    "keywords": "face-scan-1--identification-angle-secure-human-id-person-face-security-brackets",
    "duotone": true
  },
  {
    "component": "Fingerprint1",
    "name": "Fingerprint-1",
    "category": "10-security-privacy",
    "keywords": "fingerprint-1--identification-password-touch-id-secure-fingerprint-finger-security",
    "duotone": false
  },
  {
    "component": "Fingerprint2",
    "name": "Fingerprint-2",
    "category": "10-security-privacy",
    "keywords": "fingerprint-2--identification-password-touch-id-secure-fingerprint-finger-security",
    "duotone": false
  },
  {
    "component": "InboxBlock",
    "name": "Inbox-Block",
    "category": "10-security-privacy",
    "keywords": "inbox-block--mail-envelope-email-message-block-spam-remove",
    "duotone": true
  },
  {
    "component": "InboxLock",
    "name": "Inbox-Lock",
    "category": "10-security-privacy",
    "keywords": "inbox-lock--mail-envelope-email-message-secure-password-lock-encryption",
    "duotone": true
  },
  {
    "component": "IncognitoMode",
    "name": "Incognito-Mode",
    "category": "10-security-privacy",
    "keywords": "incognito-mode--internet-safe-mode-browser",
    "duotone": true
  },
  {
    "component": "Invisible1",
    "name": "Invisible-1",
    "category": "10-security-privacy",
    "keywords": "invisible-1--disable-eye-eyeball-hide-off-view",
    "duotone": true
  },
  {
    "component": "Invisible2",
    "name": "Invisible-2",
    "category": "10-security-privacy",
    "keywords": "invisible-2",
    "duotone": false
  },
  {
    "component": "Key",
    "name": "Key",
    "category": "10-security-privacy",
    "keywords": "key--entry-key-lock-login-pass-unlock-access",
    "duotone": false
  },
  {
    "component": "KeyholeLockCircle",
    "name": "Keyhole-Lock-Circle",
    "category": "10-security-privacy",
    "keywords": "keyhole-lock-circle--circle-frame-key-keyhole-lock-locked-secure-security",
    "duotone": true
  },
  {
    "component": "LockRotation",
    "name": "Lock-Rotation",
    "category": "10-security-privacy",
    "keywords": "lock-rotation",
    "duotone": true
  },
  {
    "component": "PadlockSquare1",
    "name": "Padlock-Square-1",
    "category": "10-security-privacy",
    "keywords": "padlock-square-1--combination-combo-lock-locked-padlock-secure-security-shield-keyhole",
    "duotone": true
  },
  {
    "component": "Shield1",
    "name": "Shield-1",
    "category": "10-security-privacy",
    "keywords": "shield-1--shield-protection-security-defend-crime-war-cover",
    "duotone": false
  },
  {
    "component": "Shield2",
    "name": "Shield-2",
    "category": "10-security-privacy",
    "keywords": "shield-2--shield-protection-security-defend-crime-war-cover",
    "duotone": false
  },
  {
    "component": "ShieldCheck",
    "name": "Shield-Check",
    "category": "10-security-privacy",
    "keywords": "shield-check--shield-protection-security-defend-crime-war-cover-check",
    "duotone": true
  },
  {
    "component": "ShieldCross",
    "name": "Shield-Cross",
    "category": "10-security-privacy",
    "keywords": "shield-cross--shield-secure-security-cross-add-plus",
    "duotone": true
  },
  {
    "component": "ThreatBrowser1",
    "name": "Threat-Browser-1",
    "category": "10-security-privacy",
    "keywords": "threat-browser-1--bug-browser-file-threat-danger-internet",
    "duotone": true
  },
  {
    "component": "ThreatDocument",
    "name": "Threat-Document",
    "category": "10-security-privacy",
    "keywords": "threat-document--bug-document-file-threat-danger",
    "duotone": true
  },
  {
    "component": "ThreatFolder",
    "name": "Threat-Folder",
    "category": "10-security-privacy",
    "keywords": "threat-folder--bug-folder-file-threat-danger",
    "duotone": true
  },
  {
    "component": "UserProtection2",
    "name": "User-Protection-2",
    "category": "10-security-privacy",
    "keywords": "user-protection-2--shield-secure-security-profile-person",
    "duotone": true
  },
  {
    "component": "VirusAntivirus",
    "name": "Virus-Antivirus",
    "category": "10-security-privacy",
    "keywords": "virus-antivirus--health-medical-covid19-flu-influenza-virus-antivirus",
    "duotone": true
  },
  {
    "component": "Visible",
    "name": "Visible",
    "category": "10-security-privacy",
    "keywords": "visible--eye-eyeball-open-view",
    "duotone": true
  },
  {
    "component": "VoiceScan2",
    "name": "Voice-Scan-2",
    "category": "10-security-privacy",
    "keywords": "voice-scan-2--identification-secure-id-soundwave-sound-voice-brackets-security",
    "duotone": true
  },
  {
    "component": "VpnConnection",
    "name": "Vpn-Connection",
    "category": "10-security-privacy",
    "keywords": "VPN-connection",
    "duotone": true
  },
  {
    "component": "BagDollar",
    "name": "Bag-Dollar",
    "category": "11-business-finance",
    "keywords": "bag-dollar--bag-payment-cash-money-finance",
    "duotone": true
  },
  {
    "component": "BagPound",
    "name": "Bag-Pound",
    "category": "11-business-finance",
    "keywords": "bag-pound--bag-payment-cash-money-finance",
    "duotone": true
  },
  {
    "component": "BagRupee",
    "name": "Bag-Rupee",
    "category": "11-business-finance",
    "keywords": "bag-rupee--bag-payment-cash-money-finance",
    "duotone": true
  },
  {
    "component": "BagYen",
    "name": "Bag-Yen",
    "category": "11-business-finance",
    "keywords": "bag-yen--bag-payment-cash-money-finance",
    "duotone": true
  },
  {
    "component": "Bill1",
    "name": "Bill-1",
    "category": "11-business-finance",
    "keywords": "bill-1--billing-bills-payment-finance-cash-currency-money-accounting",
    "duotone": true
  },
  {
    "component": "Bill2",
    "name": "Bill-2",
    "category": "11-business-finance",
    "keywords": "bill-2--currency-billing-payment-finance-cash-bill-money-accounting",
    "duotone": true
  },
  {
    "component": "Bill4",
    "name": "Bill-4",
    "category": "11-business-finance",
    "keywords": "bill-4--accounting-billing-payment-finance-cash-currency-money-bill-dollar-stack",
    "duotone": true
  },
  {
    "component": "BillCashless",
    "name": "Bill-Cashless",
    "category": "11-business-finance",
    "keywords": "bill-cashless--currency-billing-payment-finance-no-cash-bill-money-accounting-cashless",
    "duotone": true
  },
  {
    "component": "BriefcaseDollar",
    "name": "Briefcase-Dollar",
    "category": "11-business-finance",
    "keywords": "briefcase-dollar--briefcase-payment-cash-money-finance-baggage-bag",
    "duotone": true
  },
  {
    "component": "BusinessCard",
    "name": "Business-Card",
    "category": "11-business-finance",
    "keywords": "business-card--name-card-business-information-money-payment",
    "duotone": true
  },
  {
    "component": "BusinessHandshake",
    "name": "Business-Handshake",
    "category": "11-business-finance",
    "keywords": "business-handshake--deal-contract-business-money-payment-agreement",
    "duotone": true
  },
  {
    "component": "BusinessIdeaMoney",
    "name": "Business-Idea-Money",
    "category": "11-business-finance",
    "keywords": "business-idea-money",
    "duotone": true
  },
  {
    "component": "BusinessProfessionHomeOffice",
    "name": "Business-Profession-Home-Office",
    "category": "11-business-finance",
    "keywords": "business-profession-home-office--workspace-home-office-work-business-remote-working",
    "duotone": true
  },
  {
    "component": "BusinessProgressBar2",
    "name": "Business-Progress-Bar-2",
    "category": "11-business-finance",
    "keywords": "business-progress-bar-2--business-production-arrow-workflow-money-flag-timeline",
    "duotone": true
  },
  {
    "component": "BusinessUserCurriculum",
    "name": "Business-User-Curriculum",
    "category": "11-business-finance",
    "keywords": "business-user-curriculum",
    "duotone": true
  },
  {
    "component": "Calculator1",
    "name": "Calculator-1",
    "category": "11-business-finance",
    "keywords": "calculator-1--shop-shopping-pay-payment-store-cash-calculate-math",
    "duotone": true
  },
  {
    "component": "Calculator2",
    "name": "Calculator-2",
    "category": "11-business-finance",
    "keywords": "calculator-2--shop-shopping-pay-payment-store-cash-calculate-math-sign",
    "duotone": true
  },
  {
    "component": "CoinShare",
    "name": "Coin-Share",
    "category": "11-business-finance",
    "keywords": "coin-share--payment-cash-money-finance-receive-give-coin-hand",
    "duotone": true
  },
  {
    "component": "CoinsStack",
    "name": "Coins-Stack",
    "category": "11-business-finance",
    "keywords": "coins-stack--accounting-billing-payment-stack-cash-coins-currency-money-finance",
    "duotone": true
  },
  {
    "component": "CollaborationsIdea",
    "name": "Collaborations-Idea",
    "category": "11-business-finance",
    "keywords": "collaborations-idea--collaborations-idea-work",
    "duotone": true
  },
  {
    "component": "CreditCard1",
    "name": "Credit-Card-1",
    "category": "11-business-finance",
    "keywords": "credit-card-1--credit-pay-payment-debit-card-finance-plastic-money-atm",
    "duotone": true
  },
  {
    "component": "CreditCard2",
    "name": "Credit-Card-2",
    "category": "11-business-finance",
    "keywords": "credit-card-2--deposit-payment-finance-atm-withdraw-atm",
    "duotone": true
  },
  {
    "component": "DecentWorkAndEconomicGrowth",
    "name": "Decent-Work-And-Economic-Growth",
    "category": "11-business-finance",
    "keywords": "decent-work-and-economic-growth",
    "duotone": true
  },
  {
    "component": "DesktopDollar",
    "name": "Desktop-Dollar",
    "category": "11-business-finance",
    "keywords": "desktop-dollar--cash-desktop-display-device-notification-computer-money-currency",
    "duotone": true
  },
  {
    "component": "DollarCoin1",
    "name": "Dollar-Coin-1",
    "category": "11-business-finance",
    "keywords": "dollar-coin-1--accounting-billing-payment-cash-coin-currency-money-finance",
    "duotone": true
  },
  {
    "component": "DollarCoin",
    "name": "Dollar-Coin",
    "category": "11-business-finance",
    "keywords": "dollar-coin--accounting-billing-payment-cash-coin-currency-money-finance",
    "duotone": true
  },
  {
    "component": "Euro",
    "name": "Euro",
    "category": "11-business-finance",
    "keywords": "euro--exchange-payment-euro-forex-finance-foreign-currency",
    "duotone": false
  },
  {
    "component": "Gold",
    "name": "Gold",
    "category": "11-business-finance",
    "keywords": "gold--gold-money-payment-bars-finance-wealth-bullion-jewelry",
    "duotone": false
  },
  {
    "component": "InvestmentSelection",
    "name": "Investment-Selection",
    "category": "11-business-finance",
    "keywords": "investment-selection",
    "duotone": true
  },
  {
    "component": "JusticeHammer",
    "name": "Justice-Hammer",
    "category": "11-business-finance",
    "keywords": "justice-hammer--hammer-work-mallet-office-company-gavel-justice-judge-arbitration-court",
    "duotone": true
  },
  {
    "component": "JusticeScale1",
    "name": "Justice-Scale-1",
    "category": "11-business-finance",
    "keywords": "justice-scale-1--office-work-scale-justice-company-arbitration-balance-court",
    "duotone": true
  },
  {
    "component": "JusticeScale2",
    "name": "Justice-Scale-2",
    "category": "11-business-finance",
    "keywords": "justice-scale-2--office-work-scale-justice-unequal-company-arbitration-unbalance-court",
    "duotone": true
  },
  {
    "component": "Lightbulb",
    "name": "Lightbulb",
    "category": "11-business-finance",
    "keywords": "lightbulb--lighting-light-incandescent-bulb-lights",
    "duotone": true
  },
  {
    "component": "NoPoverty",
    "name": "No-Poverty",
    "category": "11-business-finance",
    "keywords": "no-poverty",
    "duotone": false
  },
  {
    "component": "Payment10",
    "name": "Payment-10",
    "category": "11-business-finance",
    "keywords": "payment-10--deposit-payment-finance-atm-transfer-dollar",
    "duotone": true
  },
  {
    "component": "PaymentCashOut3",
    "name": "Payment-Cash-Out-3",
    "category": "11-business-finance",
    "keywords": "payment-cash-out-3",
    "duotone": true
  },
  {
    "component": "SafeVault",
    "name": "Safe-Vault",
    "category": "11-business-finance",
    "keywords": "safe-vault--saving-combo-payment-safe-combination-finance",
    "duotone": true
  },
  {
    "component": "SearchDollar",
    "name": "Search-Dollar",
    "category": "11-business-finance",
    "keywords": "search-dollar--search-pay-product-currency-query-magnifying-cash-business-money-glass",
    "duotone": true
  },
  {
    "component": "Startup",
    "name": "Startup",
    "category": "11-business-finance",
    "keywords": "startup--shop-rocket-launch-startup",
    "duotone": true
  },
  {
    "component": "Stock",
    "name": "Stock",
    "category": "11-business-finance",
    "keywords": "stock--price-stock-wallstreet-dollar-money-currency-fluctuate-candlestick-business",
    "duotone": true
  },
  {
    "component": "StrategyTasks",
    "name": "Strategy-Tasks",
    "category": "11-business-finance",
    "keywords": "strategy-tasks--strategy-tasks-work",
    "duotone": true
  },
  {
    "component": "SubscriptionCashflow",
    "name": "Subscription-Cashflow",
    "category": "11-business-finance",
    "keywords": "subscription-cashflow",
    "duotone": true
  },
  {
    "component": "WalletPurse",
    "name": "Wallet-Purse",
    "category": "11-business-finance",
    "keywords": "wallet-purse--money-payment-finance-wallet-purse",
    "duotone": true
  },
  {
    "component": "Wallet",
    "name": "Wallet",
    "category": "11-business-finance",
    "keywords": "wallet--money-payment-finance-wallet",
    "duotone": true
  },
  {
    "component": "YuanCircle",
    "name": "Yuan-Circle",
    "category": "11-business-finance",
    "keywords": "yuan-circle--exchange-payment-forex-finance-yuan-foreign-currency",
    "duotone": true
  },
  {
    "component": "Yuan",
    "name": "Yuan",
    "category": "11-business-finance",
    "keywords": "yuan--exchange-payment-forex-finance-yuan-foreign-currency",
    "duotone": false
  },
  {
    "component": "Bag",
    "name": "Bag",
    "category": "12-shopping-ecommerce",
    "keywords": "bag--bag-payment-cash-money-finance",
    "duotone": true
  },
  {
    "component": "DiscountPercentBadge",
    "name": "Discount-Percent-Badge",
    "category": "12-shopping-ecommerce",
    "keywords": "discount-percent-badge--shop-shops-stores-discount-coupon",
    "duotone": true
  },
  {
    "component": "DiscountPercentCircle",
    "name": "Discount-Percent-Circle",
    "category": "12-shopping-ecommerce",
    "keywords": "discount-percent-circle--store-shop-shops-stores-discount-coupon",
    "duotone": true
  },
  {
    "component": "DiscountPercentCoupon",
    "name": "Discount-Percent-Coupon",
    "category": "12-shopping-ecommerce",
    "keywords": "discount-percent-coupon--shop-shops-stores-discount-coupon-voucher",
    "duotone": true
  },
  {
    "component": "DiscountPercentCutout",
    "name": "Discount-Percent-Cutout",
    "category": "12-shopping-ecommerce",
    "keywords": "discount-percent-cutout--store-shop-shops-stores-discount-coupon",
    "duotone": true
  },
  {
    "component": "DiscountPercentFire",
    "name": "Discount-Percent-Fire",
    "category": "12-shopping-ecommerce",
    "keywords": "discount-percent-fire--shop-shops-stores-discount-coupon-hot-trending",
    "duotone": true
  },
  {
    "component": "Gift2",
    "name": "Gift-2",
    "category": "12-shopping-ecommerce",
    "keywords": "gift-2--reward-box-social-present-gift-media-rating-bow",
    "duotone": true
  },
  {
    "component": "Gift",
    "name": "Gift",
    "category": "12-shopping-ecommerce",
    "keywords": "gift--reward-box-social-present-gift-media-rating-bow",
    "duotone": true
  },
  {
    "component": "QrCode",
    "name": "Qr-Code",
    "category": "12-shopping-ecommerce",
    "keywords": "qr-code--codes-tags-code-qr",
    "duotone": true
  },
  {
    "component": "ReceiptAdd",
    "name": "Receipt-Add",
    "category": "12-shopping-ecommerce",
    "keywords": "receipt-add--shop-shopping-pay-payment-store-cash-bill-receipt-add-plus-new",
    "duotone": true
  },
  {
    "component": "ReceiptCheck",
    "name": "Receipt-Check",
    "category": "12-shopping-ecommerce",
    "keywords": "receipt-check--shop-shopping-pay-payment-store-cash-bill-receipt-check-confirm",
    "duotone": true
  },
  {
    "component": "ReceiptSubtract",
    "name": "Receipt-Subtract",
    "category": "12-shopping-ecommerce",
    "keywords": "receipt-subtract--shop-shopping-pay-payment-store-cash-bill-receipt-subtract-minus-remove",
    "duotone": true
  },
  {
    "component": "Receipt",
    "name": "Receipt",
    "category": "12-shopping-ecommerce",
    "keywords": "receipt--shop-shopping-pay-payment-store-cash-bill-receipt",
    "duotone": true
  },
  {
    "component": "ScannerBarCode",
    "name": "Scanner-Bar-Code",
    "category": "12-shopping-ecommerce",
    "keywords": "scanner-bar-code--codes-tags-upc-barcode",
    "duotone": true
  },
  {
    "component": "ShoppingBagHandBag2",
    "name": "Shopping-Bag-Hand-Bag-2",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-bag-hand-bag-2--shopping-bag-purse-goods-item-products",
    "duotone": true
  },
  {
    "component": "ShoppingBasket1",
    "name": "Shopping-Basket-1",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-basket-1--shopping-basket",
    "duotone": true
  },
  {
    "component": "ShoppingBasket2",
    "name": "Shopping-Basket-2",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-basket-2--shopping-basket",
    "duotone": true
  },
  {
    "component": "ShoppingCart1",
    "name": "Shopping-Cart-1",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-1--shopping-cart-checkout",
    "duotone": true
  },
  {
    "component": "ShoppingCart2",
    "name": "Shopping-Cart-2",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-2--shopping-cart-checkout",
    "duotone": true
  },
  {
    "component": "ShoppingCart3",
    "name": "Shopping-Cart-3",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-3--shopping-cart-checkout",
    "duotone": true
  },
  {
    "component": "ShoppingCartAdd",
    "name": "Shopping-Cart-Add",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-add--shopping-cart-checkout-add-plus-new",
    "duotone": true
  },
  {
    "component": "ShoppingCartCheck",
    "name": "Shopping-Cart-Check",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-check--shopping-cart-checkout-check-confirm",
    "duotone": true
  },
  {
    "component": "ShoppingCartSubtract",
    "name": "Shopping-Cart-Subtract",
    "category": "12-shopping-ecommerce",
    "keywords": "shopping-cart-subtract--shopping-cart-checkout-subtract-minus-remove",
    "duotone": true
  },
  {
    "component": "Store1",
    "name": "Store-1",
    "category": "12-shopping-ecommerce",
    "keywords": "store-1--store-shop-shops-stores",
    "duotone": true
  },
  {
    "component": "Store2",
    "name": "Store-2",
    "category": "12-shopping-ecommerce",
    "keywords": "store-2--store-shop-shops-stores",
    "duotone": true
  },
  {
    "component": "StoreComputer",
    "name": "Store-Computer",
    "category": "12-shopping-ecommerce",
    "keywords": "store-computer--store-shop-shops-stores-online-computer-website-desktop-app",
    "duotone": true
  },
  {
    "component": "Tag",
    "name": "Tag",
    "category": "12-shopping-ecommerce",
    "keywords": "tag--tags-bookmark-favorite",
    "duotone": true
  },
  {
    "component": "Ticket1",
    "name": "Ticket-1",
    "category": "12-shopping-ecommerce",
    "keywords": "ticket-1--hobby-ticket-event-entertainment-stub-theater-entertainment-culture",
    "duotone": true
  },
  {
    "component": "Tickets",
    "name": "Tickets",
    "category": "12-shopping-ecommerce",
    "keywords": "tickets--hobby-ticket-event-entertainment-stub-theater-entertainment-culture",
    "duotone": true
  },
  {
    "component": "AscendingNumberOrder",
    "name": "Ascending-Number-Order",
    "category": "13-charts-data",
    "keywords": "ascending-number-order",
    "duotone": true
  },
  {
    "component": "Dashboard3",
    "name": "Dashboard-3",
    "category": "13-charts-data",
    "keywords": "dashboard-3--app-application-dashboard-home-layout-vertical",
    "duotone": false
  },
  {
    "component": "DashboardCircle",
    "name": "Dashboard-Circle",
    "category": "13-charts-data",
    "keywords": "dashboard-circle--app-application-dashboard-home-layout-circle",
    "duotone": false
  },
  {
    "component": "DescendingNumberOrder",
    "name": "Descending-Number-Order",
    "category": "13-charts-data",
    "keywords": "descending-number-order",
    "duotone": true
  },
  {
    "component": "GraphArrowDecrease",
    "name": "Graph-Arrow-Decrease",
    "category": "13-charts-data",
    "keywords": "graph-arrow-decrease--down-stats-graph-descend-right-arrow",
    "duotone": false
  },
  {
    "component": "GraphArrowIncrease",
    "name": "Graph-Arrow-Increase",
    "category": "13-charts-data",
    "keywords": "graph-arrow-increase--ascend-growth-up-arrow-stats-graph-right-grow",
    "duotone": false
  },
  {
    "component": "GraphBarDecrease",
    "name": "Graph-Bar-Decrease",
    "category": "13-charts-data",
    "keywords": "graph-bar-decrease--arrow-product-performance-down-decrease-graph-business-chart",
    "duotone": true
  },
  {
    "component": "GraphBarIncrease",
    "name": "Graph-Bar-Increase",
    "category": "13-charts-data",
    "keywords": "graph-bar-increase--up-product-performance-increase-arrow-graph-business-chart",
    "duotone": true
  },
  {
    "component": "GraphDot",
    "name": "Graph-Dot",
    "category": "13-charts-data",
    "keywords": "graph-dot--product-data-bars-analysis-analytics-graph-business-chart-dot",
    "duotone": true
  },
  {
    "component": "Graph",
    "name": "Graph",
    "category": "13-charts-data",
    "keywords": "graph--analytics-business-product-graph-data-chart-analysis",
    "duotone": true
  },
  {
    "component": "Hierarchy10",
    "name": "Hierarchy-10",
    "category": "13-charts-data",
    "keywords": "hierarchy-10--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "Hierarchy13",
    "name": "Hierarchy-13",
    "category": "13-charts-data",
    "keywords": "hierarchy-13--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "Hierarchy14",
    "name": "Hierarchy-14",
    "category": "13-charts-data",
    "keywords": "hierarchy-14--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "Hierarchy2",
    "name": "Hierarchy-2",
    "category": "13-charts-data",
    "keywords": "hierarchy-2--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "Hierarchy4",
    "name": "Hierarchy-4",
    "category": "13-charts-data",
    "keywords": "hierarchy-4--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "Hierarchy7",
    "name": "Hierarchy-7",
    "category": "13-charts-data",
    "keywords": "hierarchy-7--node-organization-links-structure-link-nodes-network-hierarchy",
    "duotone": true
  },
  {
    "component": "PieChart",
    "name": "Pie-Chart",
    "category": "13-charts-data",
    "keywords": "pie-chart--product-data-analysis-analytics-pie-business-chart",
    "duotone": true
  },
  {
    "component": "SortDescending",
    "name": "Sort-Descending",
    "category": "13-charts-data",
    "keywords": "sort-descending",
    "duotone": true
  },
  {
    "component": "StepsNumber",
    "name": "Steps-Number",
    "category": "13-charts-data",
    "keywords": "steps-number--interface-number-internet-menu-progress",
    "duotone": true
  },
  {
    "component": "TrendingContent",
    "name": "Trending-Content",
    "category": "13-charts-data",
    "keywords": "trending-content--lit-flame-torch-trending",
    "duotone": false
  },
  {
    "component": "AlarmClock",
    "name": "Alarm-Clock",
    "category": "14-time-calendar",
    "keywords": "alarm-clock--time-tock-stopwatch-measure-clock-tick",
    "duotone": true
  },
  {
    "component": "BlankCalendar",
    "name": "Blank-Calendar",
    "category": "14-time-calendar",
    "keywords": "blank-calendar--blank-calendar-date-day-month-empty",
    "duotone": true
  },
  {
    "component": "CalendarAdd",
    "name": "Calendar-Add",
    "category": "14-time-calendar",
    "keywords": "calendar-add--add-calendar-date-day-month",
    "duotone": true
  },
  {
    "component": "CalendarEdit",
    "name": "Calendar-Edit",
    "category": "14-time-calendar",
    "keywords": "calendar-edit--calendar-date-day-compose-edit-note",
    "duotone": true
  },
  {
    "component": "CalendarJumpToDate",
    "name": "Calendar-Jump-To-Date",
    "category": "14-time-calendar",
    "keywords": "calendar-jump-to-date",
    "duotone": true
  },
  {
    "component": "CalendarStar",
    "name": "Calendar-Star",
    "category": "14-time-calendar",
    "keywords": "calendar-star--calendar-date-day-favorite-like-month-star",
    "duotone": true
  },
  {
    "component": "CircleClock",
    "name": "Circle-Clock",
    "category": "14-time-calendar",
    "keywords": "circle-clock--clock-loading-measure-time-circle",
    "duotone": true
  },
  {
    "component": "FastforwardClock",
    "name": "Fastforward-Clock",
    "category": "14-time-calendar",
    "keywords": "fastforward-clock--time-clock-reset-stopwatch-circle-measure-loading",
    "duotone": true
  },
  {
    "component": "NotificationAlarm2",
    "name": "Notification-Alarm-2",
    "category": "14-time-calendar",
    "keywords": "notification-alarm-2--android-phone-mobile-device-smartphone-iphone-alert-bell-alarm",
    "duotone": true
  },
  {
    "component": "Sleep",
    "name": "Sleep",
    "category": "14-time-calendar",
    "keywords": "sleep",
    "duotone": false
  },
  {
    "component": "SquareClock",
    "name": "Square-Clock",
    "category": "14-time-calendar",
    "keywords": "square-clock--clock-loading-frame-measure-time-circle",
    "duotone": true
  },
  {
    "component": "WaitingAppointmentsCalendar",
    "name": "Waiting-Appointments-Calendar",
    "category": "14-time-calendar",
    "keywords": "waiting-appointments-calendar",
    "duotone": true
  },
  {
    "component": "Watch1",
    "name": "Watch-1",
    "category": "14-time-calendar",
    "keywords": "watch-1--device-timepiece-cirle-electronics-face-blank-watch-smart",
    "duotone": true
  },
  {
    "component": "Watch2",
    "name": "Watch-2",
    "category": "14-time-calendar",
    "keywords": "watch-2--device-square-timepiece-electronics-face-blank-watch-smart",
    "duotone": true
  },
  {
    "component": "WatchCircleCharging",
    "name": "Watch-Circle-Charging",
    "category": "14-time-calendar",
    "keywords": "watch-circle-charging--device-timepiece-circle-watch-round-charge-charging-power",
    "duotone": true
  },
  {
    "component": "WatchCircleHeartbeatMonitor1",
    "name": "Watch-Circle-Heartbeat-Monitor-1",
    "category": "14-time-calendar",
    "keywords": "watch-circle-heartbeat-monitor-1--device-timepiece-circle-watch-round-heart-beat-monitor-healthcare",
    "duotone": true
  },
  {
    "component": "WatchCircleHeartbeatMonitor2",
    "name": "Watch-Circle-Heartbeat-Monitor-2",
    "category": "14-time-calendar",
    "keywords": "watch-circle-heartbeat-monitor-2--device-timepiece-circle-watch-round-heart-beat-monitor-healthcare",
    "duotone": true
  },
  {
    "component": "WatchCircleMenu",
    "name": "Watch-Circle-Menu",
    "category": "14-time-calendar",
    "keywords": "watch-circle-menu--device-timepiece-circle-watch-round-menu-list-option-app",
    "duotone": true
  },
  {
    "component": "WatchCircleTime",
    "name": "Watch-Circle-Time",
    "category": "14-time-calendar",
    "keywords": "watch-circle-time--device-timepiece-circle-watch-round-time-clock-analog",
    "duotone": true
  },
  {
    "component": "AirplaneDisabled",
    "name": "Airplane-Disabled",
    "category": "15-maps-travel-transport",
    "keywords": "airplane-disabled--server-plane-airplane-disabled-off-wireless-mode-internet-network",
    "duotone": true
  },
  {
    "component": "AirplaneEnabled",
    "name": "Airplane-Enabled",
    "category": "15-maps-travel-transport",
    "keywords": "airplane-enabled--server-plane-airplane-enabled-on-wireless-mode-internet-network",
    "duotone": false
  },
  {
    "component": "Airplane",
    "name": "Airplane",
    "category": "15-maps-travel-transport",
    "keywords": "airplane--travel-plane-adventure-airplane-transportation",
    "duotone": false
  },
  {
    "component": "AirportPlaneTransit",
    "name": "Airport-Plane-Transit",
    "category": "15-maps-travel-transport",
    "keywords": "airport-plane-transit",
    "duotone": true
  },
  {
    "component": "AirportPlane",
    "name": "Airport-Plane",
    "category": "15-maps-travel-transport",
    "keywords": "airport-plane",
    "duotone": false
  },
  {
    "component": "AirportSecurity",
    "name": "Airport-Security",
    "category": "15-maps-travel-transport",
    "keywords": "airport-security",
    "duotone": true
  },
  {
    "component": "Anchor",
    "name": "Anchor",
    "category": "15-maps-travel-transport",
    "keywords": "anchor--anchor-marina-harbor-port-travel-places",
    "duotone": false
  },
  {
    "component": "BagSuitcase1",
    "name": "Bag-Suitcase-1",
    "category": "15-maps-travel-transport",
    "keywords": "bag-suitcase-1--product-business-briefcase",
    "duotone": true
  },
  {
    "component": "BagSuitcase2",
    "name": "Bag-Suitcase-2",
    "category": "15-maps-travel-transport",
    "keywords": "bag-suitcase-2--product-business-briefcase",
    "duotone": true
  },
  {
    "component": "Baggage",
    "name": "Baggage",
    "category": "15-maps-travel-transport",
    "keywords": "baggage--check-baggage-travel-adventure-luggage-bag-checked-airport",
    "duotone": true
  },
  {
    "component": "Beach",
    "name": "Beach",
    "category": "15-maps-travel-transport",
    "keywords": "beach--island-waves-outdoor-recreation-tree-beach-palm-wave-water-travel-places",
    "duotone": true
  },
  {
    "component": "BicycleBike",
    "name": "Bicycle-Bike",
    "category": "15-maps-travel-transport",
    "keywords": "bicycle-bike",
    "duotone": true
  },
  {
    "component": "Bus",
    "name": "Bus",
    "category": "15-maps-travel-transport",
    "keywords": "bus--transportation-travel-bus-transit-transport-motorcoach-public",
    "duotone": true
  },
  {
    "component": "CampingTent",
    "name": "Camping-Tent",
    "category": "15-maps-travel-transport",
    "keywords": "camping-tent--outdoor-recreation-camping-tent-teepee-tipi-travel-places",
    "duotone": true
  },
  {
    "component": "CarBatteryCharging",
    "name": "Car-Battery-Charging",
    "category": "15-maps-travel-transport",
    "keywords": "car-battery-charging",
    "duotone": true
  },
  {
    "component": "CarTaxi1",
    "name": "Car-Taxi-1",
    "category": "15-maps-travel-transport",
    "keywords": "car-taxi-1--transportation-travel-taxi-transport-cab-car",
    "duotone": true
  },
  {
    "component": "CompassNavigator",
    "name": "Compass-Navigator",
    "category": "15-maps-travel-transport",
    "keywords": "compass-navigator",
    "duotone": true
  },
  {
    "component": "Container",
    "name": "Container",
    "category": "15-maps-travel-transport",
    "keywords": "container--box-package-label-delivery-shipment-shipping-container",
    "duotone": true
  },
  {
    "component": "Drone",
    "name": "Drone",
    "category": "15-maps-travel-transport",
    "keywords": "drone--artificial-robotics-intelligence-machine-technology-android-flying",
    "duotone": true
  },
  {
    "component": "Earth1",
    "name": "Earth-1",
    "category": "15-maps-travel-transport",
    "keywords": "earth-1--planet-earth-globe-world",
    "duotone": true
  },
  {
    "component": "EarthAirplane",
    "name": "Earth-Airplane",
    "category": "15-maps-travel-transport",
    "keywords": "earth-airplane--travel-plane-trip-airplane-international-adventure-globe-world-airport",
    "duotone": true
  },
  {
    "component": "EmergencyExit",
    "name": "Emergency-Exit",
    "category": "15-maps-travel-transport",
    "keywords": "emergency-exit",
    "duotone": true
  },
  {
    "component": "Fragile",
    "name": "Fragile",
    "category": "15-maps-travel-transport",
    "keywords": "fragile--fragile-shipping-glass-delivery-wine-crack-shipment-sign-sticker",
    "duotone": true
  },
  {
    "component": "GasStationFuelPetroleum",
    "name": "Gas-Station-Fuel-Petroleum",
    "category": "15-maps-travel-transport",
    "keywords": "gas-station-fuel-petroleum",
    "duotone": true
  },
  {
    "component": "HighSpeedTrainFront",
    "name": "High-Speed-Train-Front",
    "category": "15-maps-travel-transport",
    "keywords": "high-speed-train-front",
    "duotone": true
  },
  {
    "component": "HotSpring",
    "name": "Hot-Spring",
    "category": "15-maps-travel-transport",
    "keywords": "hot-spring--relax-location-outdoor-recreation-spa-travel-places",
    "duotone": true
  },
  {
    "component": "HotelAirConditioner",
    "name": "Hotel-Air-Conditioner",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-air-conditioner--heating-ac-air-hvac-cool-cooling-cold-hot-conditioning-hotel",
    "duotone": true
  },
  {
    "component": "HotelBed2",
    "name": "Hotel-Bed-2",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-bed-2--bed-double-bedroom-bedrooms-queen-king-full-hotel-hotel",
    "duotone": true
  },
  {
    "component": "HotelLaundry",
    "name": "Hotel-Laundry",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-laundry--laundry-machine-hotel",
    "duotone": true
  },
  {
    "component": "HotelOneStar",
    "name": "Hotel-One-Star",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-one-star--one-star-reviews-review-rating-hotel-star",
    "duotone": true
  },
  {
    "component": "HotelShowerHead",
    "name": "Hotel-Shower-Head",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-shower-head--bathe-bath-bathroom-shower-water-head-hotel",
    "duotone": true
  },
  {
    "component": "HotelTwoStar",
    "name": "Hotel-Two-Star",
    "category": "15-maps-travel-transport",
    "keywords": "hotel-two-star--two-stars-reviews-review-rating-hotel-star",
    "duotone": true
  },
  {
    "component": "InformationDeskCustomer",
    "name": "Information-Desk-Customer",
    "category": "15-maps-travel-transport",
    "keywords": "information-desk-customer",
    "duotone": true
  },
  {
    "component": "InformationDesk",
    "name": "Information-Desk",
    "category": "15-maps-travel-transport",
    "keywords": "information-desk",
    "duotone": true
  },
  {
    "component": "LiftDisability",
    "name": "Lift-Disability",
    "category": "15-maps-travel-transport",
    "keywords": "lift-disability--arrow-up-human-down-person-user-lift-elevator-disability-wheelchair-accessible",
    "duotone": true
  },
  {
    "component": "Lift",
    "name": "Lift",
    "category": "15-maps-travel-transport",
    "keywords": "lift--arrow-up-human-down-person-user-lift-elevator",
    "duotone": true
  },
  {
    "component": "LocationCompass1",
    "name": "Location-Compass-1",
    "category": "15-maps-travel-transport",
    "keywords": "location-compass-1--arrow-compass-location-gps-map-maps-point",
    "duotone": true
  },
  {
    "component": "LocationPin3",
    "name": "Location-Pin-3",
    "category": "15-maps-travel-transport",
    "keywords": "location-pin-3--navigation-map-maps-pin-gps-location",
    "duotone": true
  },
  {
    "component": "LocationPinDisabled",
    "name": "Location-Pin-Disabled",
    "category": "15-maps-travel-transport",
    "keywords": "location-pin-disabled--navigation-map-maps-pin-gps-location-disabled-off",
    "duotone": true
  },
  {
    "component": "LocationTarget1",
    "name": "Location-Target-1",
    "category": "15-maps-travel-transport",
    "keywords": "location-target-1--navigation-location-map-services-maps-gps-target",
    "duotone": true
  },
  {
    "component": "LostAndFound",
    "name": "Lost-And-Found",
    "category": "15-maps-travel-transport",
    "keywords": "lost-and-found",
    "duotone": true
  },
  {
    "component": "MapFold",
    "name": "Map-Fold",
    "category": "15-maps-travel-transport",
    "keywords": "map-fold--navigation-map-maps-gps-travel-fold",
    "duotone": true
  },
  {
    "component": "ParachuteDrop",
    "name": "Parachute-Drop",
    "category": "15-maps-travel-transport",
    "keywords": "parachute-drop--package-box-fulfillment-cart-warehouse-shipping-delivery-drop-parachute",
    "duotone": true
  },
  {
    "component": "ParkingSign",
    "name": "Parking-Sign",
    "category": "15-maps-travel-transport",
    "keywords": "parking-sign--discount-coupon-parking-price-prices-hotel",
    "duotone": true
  },
  {
    "component": "Passport",
    "name": "Passport",
    "category": "15-maps-travel-transport",
    "keywords": "passport--travel-book-id-adventure-visa-airport",
    "duotone": true
  },
  {
    "component": "PetsAllowed",
    "name": "Pets-Allowed",
    "category": "15-maps-travel-transport",
    "keywords": "pets-allowed--travel-wayfinder-pets-allowed",
    "duotone": true
  },
  {
    "component": "PoolLadder",
    "name": "Pool-Ladder",
    "category": "15-maps-travel-transport",
    "keywords": "pool-ladder--pool-stairs-swim-swimming-water-ladder-hotel",
    "duotone": true
  },
  {
    "component": "ProductionBelt",
    "name": "Production-Belt",
    "category": "15-maps-travel-transport",
    "keywords": "production-belt--production-produce-box-belt-factory-product-package-business",
    "duotone": true
  },
  {
    "component": "SailShip",
    "name": "Sail-Ship",
    "category": "15-maps-travel-transport",
    "keywords": "sail-ship--travel-boat-transportation-transport-ocean-ship-sea-water",
    "duotone": true
  },
  {
    "component": "SchoolBusSide",
    "name": "School-Bus-Side",
    "category": "15-maps-travel-transport",
    "keywords": "school-bus-side",
    "duotone": true
  },
  {
    "component": "ShipmentAdd",
    "name": "Shipment-Add",
    "category": "15-maps-travel-transport",
    "keywords": "shipment-add--shipping-parcel-shipment-add",
    "duotone": true
  },
  {
    "component": "ShipmentCheck",
    "name": "Shipment-Check",
    "category": "15-maps-travel-transport",
    "keywords": "shipment-check--shipping-parcel-shipment-check-approved",
    "duotone": true
  },
  {
    "component": "ShipmentDownload",
    "name": "Shipment-Download",
    "category": "15-maps-travel-transport",
    "keywords": "shipment-download--shipping-parcel-shipment-download",
    "duotone": true
  },
  {
    "component": "ShipmentRemove",
    "name": "Shipment-Remove",
    "category": "15-maps-travel-transport",
    "keywords": "shipment-remove--shipping-parcel-shipment-remove-subtract",
    "duotone": true
  },
  {
    "component": "ShipmentUpload",
    "name": "Shipment-Upload",
    "category": "15-maps-travel-transport",
    "keywords": "shipment-upload--shipping-parcel-shipment-upload",
    "duotone": true
  },
  {
    "component": "ShippingBox1",
    "name": "Shipping-Box-1",
    "category": "15-maps-travel-transport",
    "keywords": "shipping-box-1--box-package-label-delivery-shipment-shipping",
    "duotone": true
  },
  {
    "component": "ShippingTruck",
    "name": "Shipping-Truck",
    "category": "15-maps-travel-transport",
    "keywords": "shipping-truck--truck-shipping-delivery-transfer",
    "duotone": true
  },
  {
    "component": "Signage3",
    "name": "Signage-3",
    "category": "15-maps-travel-transport",
    "keywords": "signage-3--street-sandwich-shops-shop-stores-board-sign-store",
    "duotone": true
  },
  {
    "component": "Signage4",
    "name": "Signage-4",
    "category": "15-maps-travel-transport",
    "keywords": "signage-4--street-billboard-shops-shop-stores-board-sign-ads-banner",
    "duotone": true
  },
  {
    "component": "SmokingArea",
    "name": "Smoking-Area",
    "category": "15-maps-travel-transport",
    "keywords": "smoking-area",
    "duotone": true
  },
  {
    "component": "Snorkle",
    "name": "Snorkle",
    "category": "15-maps-travel-transport",
    "keywords": "snorkle--diving-scuba-outdoor-recreation-ocean-mask-water-sea-snorkle-travel-places",
    "duotone": true
  },
  {
    "component": "SteeringWheel",
    "name": "Steering-Wheel",
    "category": "15-maps-travel-transport",
    "keywords": "steering-wheel",
    "duotone": true
  },
  {
    "component": "StreetRoad",
    "name": "Street-Road",
    "category": "15-maps-travel-transport",
    "keywords": "street-road",
    "duotone": true
  },
  {
    "component": "StreetSign",
    "name": "Street-Sign",
    "category": "15-maps-travel-transport",
    "keywords": "street-sign--crossroad-street-sign-metaphor-directions-travel-places",
    "duotone": true
  },
  {
    "component": "TakeOff",
    "name": "Take-Off",
    "category": "15-maps-travel-transport",
    "keywords": "take-off--travel-plane-adventure-airplane-take-off-airport",
    "duotone": true
  },
  {
    "component": "ToiletMan",
    "name": "Toilet-Man",
    "category": "15-maps-travel-transport",
    "keywords": "toilet-man--travel-wayfinder-toilet-man",
    "duotone": false
  },
  {
    "component": "ToiletSignManWoman2",
    "name": "Toilet-Sign-Man-Woman-2",
    "category": "15-maps-travel-transport",
    "keywords": "toilet-sign-man-woman-2--toilet-sign-restroom-bathroom-user-human-person",
    "duotone": false
  },
  {
    "component": "ToiletWomen",
    "name": "Toilet-Women",
    "category": "15-maps-travel-transport",
    "keywords": "toilet-women--travel-wayfinder-toilet-women",
    "duotone": false
  },
  {
    "component": "TrafficCone",
    "name": "Traffic-Cone",
    "category": "15-maps-travel-transport",
    "keywords": "traffic-cone--street-sign-traffic-cone-road",
    "duotone": true
  },
  {
    "component": "TransferMotorcycle",
    "name": "Transfer-Motorcycle",
    "category": "15-maps-travel-transport",
    "keywords": "transfer-motorcycle--motorcycle-shipping-delivery-courier-transfer",
    "duotone": true
  },
  {
    "component": "TransferVan",
    "name": "Transfer-Van",
    "category": "15-maps-travel-transport",
    "keywords": "transfer-van--van-shipping-delivery-transfer",
    "duotone": true
  },
  {
    "component": "Warehouse1",
    "name": "Warehouse-1",
    "category": "15-maps-travel-transport",
    "keywords": "warehouse-1--delivery-warehouse-shipping-fulfillment",
    "duotone": true
  },
  {
    "component": "Ambulance",
    "name": "Ambulance",
    "category": "16-health-medical",
    "keywords": "ambulance--car-emergency-health-medical-ambulance",
    "duotone": true
  },
  {
    "component": "BacteriaVirusCellsBiology",
    "name": "Bacteria-Virus-Cells-Biology",
    "category": "16-health-medical",
    "keywords": "bacteria-virus-cells-biology",
    "duotone": true
  },
  {
    "component": "Bandage",
    "name": "Bandage",
    "category": "16-health-medical",
    "keywords": "bandage--health-medical-hospital-medicine-capsule-bandage-vaccine",
    "duotone": true
  },
  {
    "component": "BloodBagDonation",
    "name": "Blood-Bag-Donation",
    "category": "16-health-medical",
    "keywords": "blood-bag-donation",
    "duotone": true
  },
  {
    "component": "BloodDonateDrop",
    "name": "Blood-Donate-Drop",
    "category": "16-health-medical",
    "keywords": "blood-donate-drop",
    "duotone": true
  },
  {
    "component": "BloodDropDonation",
    "name": "Blood-Drop-Donation",
    "category": "16-health-medical",
    "keywords": "blood-drop-donation",
    "duotone": true
  },
  {
    "component": "Bone",
    "name": "Bone",
    "category": "16-health-medical",
    "keywords": "bone--nature-pet-dog-bone-food-snack",
    "duotone": false
  },
  {
    "component": "BrailleBlind",
    "name": "Braille-Blind",
    "category": "16-health-medical",
    "keywords": "braille-blind--disability-braille-blind",
    "duotone": true
  },
  {
    "component": "BrainCognitive",
    "name": "Brain-Cognitive",
    "category": "16-health-medical",
    "keywords": "brain-cognitive--health-medical-brain-cognitive-specialities",
    "duotone": true
  },
  {
    "component": "Brain",
    "name": "Brain",
    "category": "16-health-medical",
    "keywords": "brain--medical-health-brain",
    "duotone": true
  },
  {
    "component": "Cane",
    "name": "Cane",
    "category": "16-health-medical",
    "keywords": "cane--disability-cane",
    "duotone": true
  },
  {
    "component": "CheckupMedicalReportClipboard",
    "name": "Checkup-Medical-Report-Clipboard",
    "category": "16-health-medical",
    "keywords": "checkup-medical-report-clipboard",
    "duotone": true
  },
  {
    "component": "Crutch",
    "name": "Crutch",
    "category": "16-health-medical",
    "keywords": "crutch--disability-crutch",
    "duotone": true
  },
  {
    "component": "Dna",
    "name": "Dna",
    "category": "16-health-medical",
    "keywords": "dna--science-biology-experiment-lab-science",
    "duotone": true
  },
  {
    "component": "EarHearing",
    "name": "Ear-Hearing",
    "category": "16-health-medical",
    "keywords": "ear-hearing--health-medical-hearing-ear",
    "duotone": true
  },
  {
    "component": "FluMask",
    "name": "Flu-Mask",
    "category": "16-health-medical",
    "keywords": "flu-mask--health-medical-hospital-mask-flu-vaccine-protection",
    "duotone": true
  },
  {
    "component": "GoodHealthAndWellBeing",
    "name": "Good-Health-And-Well-Being",
    "category": "16-health-medical",
    "keywords": "good-health-and-well-being",
    "duotone": true
  },
  {
    "component": "HealthCare2",
    "name": "Health-Care-2",
    "category": "16-health-medical",
    "keywords": "health-care-2--health-medical-hospital-heart-care-symbol",
    "duotone": true
  },
  {
    "component": "HearingDeaf1",
    "name": "Hearing-Deaf-1",
    "category": "16-health-medical",
    "keywords": "hearing-deaf-1--disability-hearing-deaf",
    "duotone": true
  },
  {
    "component": "HearingDeaf2",
    "name": "Hearing-Deaf-2",
    "category": "16-health-medical",
    "keywords": "hearing-deaf-2--disability-hearing-deaf",
    "duotone": true
  },
  {
    "component": "HeartRatePulseGraph",
    "name": "Heart-Rate-Pulse-Graph",
    "category": "16-health-medical",
    "keywords": "heart-rate-pulse-graph",
    "duotone": true
  },
  {
    "component": "HeartRateSearch",
    "name": "Heart-Rate-Search",
    "category": "16-health-medical",
    "keywords": "heart-rate-search--health-medical-monitor-heart-rate-search",
    "duotone": true
  },
  {
    "component": "HospitalSignCircle",
    "name": "Hospital-Sign-Circle",
    "category": "16-health-medical",
    "keywords": "hospital-sign-circle--health-sign-medical-symbol-hospital-circle-emergency",
    "duotone": true
  },
  {
    "component": "HospitalSignSquare",
    "name": "Hospital-Sign-Square",
    "category": "16-health-medical",
    "keywords": "hospital-sign-square--health-sign-medical-symbol-hospital-square-emergency",
    "duotone": true
  },
  {
    "component": "MedicalBag",
    "name": "Medical-Bag",
    "category": "16-health-medical",
    "keywords": "medical-bag--health-sign-medical-symbol-hospital-bag-medicine-medkit",
    "duotone": true
  },
  {
    "component": "MedicalCrossSignHealthcare",
    "name": "Medical-Cross-Sign-Healthcare",
    "category": "16-health-medical",
    "keywords": "medical-cross-sign-healthcare",
    "duotone": false
  },
  {
    "component": "MedicalCrossSymbol",
    "name": "Medical-Cross-Symbol",
    "category": "16-health-medical",
    "keywords": "medical-cross-symbol--health-sign-medical-symbol-hospital-emergency",
    "duotone": false
  },
  {
    "component": "MedicalFilesReportHistory",
    "name": "Medical-Files-Report-History",
    "category": "16-health-medical",
    "keywords": "medical-files-report-history",
    "duotone": true
  },
  {
    "component": "MedicalRibbon1",
    "name": "Medical-Ribbon-1",
    "category": "16-health-medical",
    "keywords": "medical-ribbon-1--ribbon-medical-cancer-health-beauty-symbol",
    "duotone": false
  },
  {
    "component": "MedicalSearchDiagnosis",
    "name": "Medical-Search-Diagnosis",
    "category": "16-health-medical",
    "keywords": "medical-search-diagnosis",
    "duotone": true
  },
  {
    "component": "MicroscopeObservationSciene",
    "name": "Microscope-Observation-Sciene",
    "category": "16-health-medical",
    "keywords": "microscope-observation-sciene",
    "duotone": true
  },
  {
    "component": "NurseAssistantEmergency",
    "name": "Nurse-Assistant-Emergency",
    "category": "16-health-medical",
    "keywords": "nurse-assistant-emergency",
    "duotone": true
  },
  {
    "component": "NurseHat",
    "name": "Nurse-Hat",
    "category": "16-health-medical",
    "keywords": "nurse-hat--health-medical-hospital-nurse-doctor-cap",
    "duotone": true
  },
  {
    "component": "OnlineMedicalCallService",
    "name": "Online-Medical-Call-Service",
    "category": "16-health-medical",
    "keywords": "online-medical-call-service",
    "duotone": true
  },
  {
    "component": "OnlineMedicalServiceMonitor",
    "name": "Online-Medical-Service-Monitor",
    "category": "16-health-medical",
    "keywords": "online-medical-service-monitor",
    "duotone": true
  },
  {
    "component": "OnlineMedicalWebService",
    "name": "Online-Medical-Web-Service",
    "category": "16-health-medical",
    "keywords": "online-medical-web-service",
    "duotone": true
  },
  {
    "component": "PetriDishLabEquipment",
    "name": "Petri-Dish-Lab-Equipment",
    "category": "16-health-medical",
    "keywords": "petri-dish-lab-equipment",
    "duotone": true
  },
  {
    "component": "Pharmacy",
    "name": "Pharmacy",
    "category": "16-health-medical",
    "keywords": "pharmacy--health-medical-pharmacy-sign-medicine-mortar-pestle",
    "duotone": true
  },
  {
    "component": "PrescriptionPillsDrugsHealthcare",
    "name": "Prescription-Pills-Drugs-Healthcare",
    "category": "16-health-medical",
    "keywords": "prescription-pills-drugs-healthcare",
    "duotone": false
  },
  {
    "component": "Stethoscope",
    "name": "Stethoscope",
    "category": "16-health-medical",
    "keywords": "stethoscope--instrument-health-medical-stethoscope",
    "duotone": true
  },
  {
    "component": "Syringe",
    "name": "Syringe",
    "category": "16-health-medical",
    "keywords": "syringe--instrument-medical-syringe-health-beauty-needle",
    "duotone": true
  },
  {
    "component": "TabletCapsule",
    "name": "Tablet-Capsule",
    "category": "16-health-medical",
    "keywords": "tablet-capsule--health-medical-hospital-medicine-capsule-tablet",
    "duotone": true
  },
  {
    "component": "Thermometer",
    "name": "Thermometer",
    "category": "16-health-medical",
    "keywords": "thermometer--temperature-thermometer-weather-level-meter-mercury-measure",
    "duotone": true
  },
  {
    "component": "Tooth",
    "name": "Tooth",
    "category": "16-health-medical",
    "keywords": "tooth--health-medical-tooth",
    "duotone": true
  },
  {
    "component": "Wheelchair1",
    "name": "Wheelchair-1",
    "category": "16-health-medical",
    "keywords": "wheelchair-1--person-access-wheelchair-accomodation-human-disability-disabled-user",
    "duotone": true
  },
  {
    "component": "Wheelchair",
    "name": "Wheelchair",
    "category": "16-health-medical",
    "keywords": "wheelchair--health-medical-hospital-wheelchair-disable-help-sign",
    "duotone": true
  },
  {
    "component": "BeerMug",
    "name": "Beer-Mug",
    "category": "17-food-drink",
    "keywords": "beer-mug--beer-cook-brewery-drink-mug-cooking-nutrition-brew-brewing-food",
    "duotone": true
  },
  {
    "component": "BeerPitch",
    "name": "Beer-Pitch",
    "category": "17-food-drink",
    "keywords": "beer-pitch--drink-glass-beer-pitch",
    "duotone": true
  },
  {
    "component": "Burger",
    "name": "Burger",
    "category": "17-food-drink",
    "keywords": "burger--burger-fast-cook-cooking-nutrition-food",
    "duotone": true
  },
  {
    "component": "BurritoFastfood",
    "name": "Burrito-Fastfood",
    "category": "17-food-drink",
    "keywords": "burrito-fastfood",
    "duotone": true
  },
  {
    "component": "CakeSlice",
    "name": "Cake-Slice",
    "category": "17-food-drink",
    "keywords": "cake-slice--cherry-cake-birthday-event-special-sweet-bake",
    "duotone": true
  },
  {
    "component": "CandyCane",
    "name": "Candy-Cane",
    "category": "17-food-drink",
    "keywords": "candy-cane--candy-sweet-cane-christmas",
    "duotone": true
  },
  {
    "component": "ChampagnePartyAlcohol",
    "name": "Champagne-Party-Alcohol",
    "category": "17-food-drink",
    "keywords": "champagne-party-alcohol",
    "duotone": true
  },
  {
    "component": "Cheese",
    "name": "Cheese",
    "category": "17-food-drink",
    "keywords": "cheese--cook-cheese-animal-products-cooking-nutrition-dairy-food",
    "duotone": true
  },
  {
    "component": "Cherries",
    "name": "Cherries",
    "category": "17-food-drink",
    "keywords": "cherries--cook-plant-cherry-plants-cooking-nutrition-vegetarian-fruit-food-cherries",
    "duotone": true
  },
  {
    "component": "ChickenGrilledStream",
    "name": "Chicken-Grilled-Stream",
    "category": "17-food-drink",
    "keywords": "chicken-grilled-stream",
    "duotone": true
  },
  {
    "component": "Cocktail",
    "name": "Cocktail",
    "category": "17-food-drink",
    "keywords": "cocktail--cook-alcohol-food-cocktail-drink-cooking-nutrition-alcoholic-beverage-glass",
    "duotone": true
  },
  {
    "component": "CoffeeBean",
    "name": "Coffee-Bean",
    "category": "17-food-drink",
    "keywords": "coffee-bean--cook-cooking-nutrition-coffee-bean",
    "duotone": true
  },
  {
    "component": "CoffeeMug",
    "name": "Coffee-Mug",
    "category": "17-food-drink",
    "keywords": "coffee-mug--coffee-cook-cup-drink-mug-cooking-nutrition-cafe-caffeine-food",
    "duotone": true
  },
  {
    "component": "CoffeeTakeawayCup",
    "name": "Coffee-Takeaway-Cup",
    "category": "17-food-drink",
    "keywords": "coffee-takeaway-cup--cup-coffee-hot-takeaway-drink-caffeine",
    "duotone": true
  },
  {
    "component": "Donut",
    "name": "Donut",
    "category": "17-food-drink",
    "keywords": "donut--dessert-donut",
    "duotone": true
  },
  {
    "component": "ForkKnife",
    "name": "Fork-Knife",
    "category": "17-food-drink",
    "keywords": "fork-knife--fork-spoon-knife-food-dine-cook-utensils-eat-restaurant-dining-kitchenware",
    "duotone": false
  },
  {
    "component": "ForkSpoon",
    "name": "Fork-Spoon",
    "category": "17-food-drink",
    "keywords": "fork-spoon--fork-spoon-food-dine-cook-utensils-eat-restaurant-dining-kitchenware",
    "duotone": false
  },
  {
    "component": "IceCream2",
    "name": "Ice-Cream-2",
    "category": "17-food-drink",
    "keywords": "ice-cream-2--cook-frozen-popsicle-freezer-nutrition-cream-stick-cold-ice-cooking",
    "duotone": true
  },
  {
    "component": "IceCream3",
    "name": "Ice-Cream-3",
    "category": "17-food-drink",
    "keywords": "ice-cream-3--cook-frozen-cone-cream-ice-cooking-nutrition-freezer-cold-food",
    "duotone": true
  },
  {
    "component": "LemonFruitSeasoning",
    "name": "Lemon-Fruit-Seasoning",
    "category": "17-food-drink",
    "keywords": "lemon-fruit-seasoning",
    "duotone": true
  },
  {
    "component": "Milkshake",
    "name": "Milkshake",
    "category": "17-food-drink",
    "keywords": "milkshake--milkshake-drink-takeaway-cup-cold-beverage",
    "duotone": true
  },
  {
    "component": "Popcorn",
    "name": "Popcorn",
    "category": "17-food-drink",
    "keywords": "popcorn--cook-corn-movie-snack-cooking-nutrition-bake-popcorn",
    "duotone": true
  },
  {
    "component": "PorkMeat",
    "name": "Pork-Meat",
    "category": "17-food-drink",
    "keywords": "pork-meat",
    "duotone": true
  },
  {
    "component": "ServingDome",
    "name": "Serving-Dome",
    "category": "17-food-drink",
    "keywords": "serving-dome--cook-tool-dome-kitchen-serving-paltter-dish-tools-food-kitchenware",
    "duotone": true
  },
  {
    "component": "Shrimp",
    "name": "Shrimp",
    "category": "17-food-drink",
    "keywords": "shrimp--sea-food-shrimp",
    "duotone": true
  },
  {
    "component": "Strawberry",
    "name": "Strawberry",
    "category": "17-food-drink",
    "keywords": "strawberry--fruit-sweet-berries-plant-strawberry",
    "duotone": true
  },
  {
    "component": "TeaCup",
    "name": "Tea-Cup",
    "category": "17-food-drink",
    "keywords": "tea-cup--herbal-cook-tea-tisane-cup-drink-cooking-nutrition-mug-food",
    "duotone": true
  },
  {
    "component": "Toast",
    "name": "Toast",
    "category": "17-food-drink",
    "keywords": "toast--bread-toast-breakfast",
    "duotone": true
  },
  {
    "component": "WaterGlass",
    "name": "Water-Glass",
    "category": "17-food-drink",
    "keywords": "water-glass--glass-water-juice-drink-liquid",
    "duotone": true
  },
  {
    "component": "Wine",
    "name": "Wine",
    "category": "17-food-drink",
    "keywords": "wine--drink-cook-glass-cooking-wine-nutrition-food",
    "duotone": true
  },
  {
    "component": "ZeroHunger",
    "name": "Zero-Hunger",
    "category": "17-food-drink",
    "keywords": "zero-hunger",
    "duotone": true
  },
  {
    "component": "AffordableAndCleanEnergy",
    "name": "Affordable-And-Clean-Energy",
    "category": "18-nature-weather",
    "keywords": "affordable-and-clean-energy",
    "duotone": true
  },
  {
    "component": "Alien",
    "name": "Alien",
    "category": "18-nature-weather",
    "keywords": "alien--science-extraterristerial-life-form-space-universe-head-astronomy",
    "duotone": true
  },
  {
    "component": "Cat1",
    "name": "Cat-1",
    "category": "18-nature-weather",
    "keywords": "cat-1--nature-head-cat-pet-animals-felyne",
    "duotone": true
  },
  {
    "component": "Celsius",
    "name": "Celsius",
    "category": "18-nature-weather",
    "keywords": "celsius--degrees-temperature-centigrade-celsius-degree-weather",
    "duotone": false
  },
  {
    "component": "CleanWaterAndSanitation",
    "name": "Clean-Water-And-Sanitation",
    "category": "18-nature-weather",
    "keywords": "clean-water-and-sanitation",
    "duotone": true
  },
  {
    "component": "Comet",
    "name": "Comet",
    "category": "18-nature-weather",
    "keywords": "comet--nature-meteor-fall-space-object-danger",
    "duotone": true
  },
  {
    "component": "Fahrenheit",
    "name": "Fahrenheit",
    "category": "18-nature-weather",
    "keywords": "fahrenheit--degrees-temperature-fahrenheit-degree-weather",
    "duotone": false
  },
  {
    "component": "Flower",
    "name": "Flower",
    "category": "18-nature-weather",
    "keywords": "flower--photos-photo-picture-camera-photography-pictures-flower-image",
    "duotone": true
  },
  {
    "component": "Galaxy1",
    "name": "Galaxy-1",
    "category": "18-nature-weather",
    "keywords": "galaxy-1--science-space-universe-astronomy",
    "duotone": true
  },
  {
    "component": "Galaxy2",
    "name": "Galaxy-2",
    "category": "18-nature-weather",
    "keywords": "galaxy-2--science-space-universe-astronomy",
    "duotone": true
  },
  {
    "component": "HumidityNone",
    "name": "Humidity-None",
    "category": "18-nature-weather",
    "keywords": "humidity-none--humidity-drop-weather",
    "duotone": true
  },
  {
    "component": "Leaf",
    "name": "Leaf",
    "category": "18-nature-weather",
    "keywords": "leaf--nature-environment-leaf-ecology-plant-plants-eco",
    "duotone": true
  },
  {
    "component": "Log",
    "name": "Log",
    "category": "18-nature-weather",
    "keywords": "log--nature-tree-plant-circle-round-log",
    "duotone": true
  },
  {
    "component": "MoonCloud",
    "name": "Moon-Cloud",
    "category": "18-nature-weather",
    "keywords": "moon-cloud--cloud-meteorology-cloudy-partly-sunny-weather",
    "duotone": true
  },
  {
    "component": "Octopus",
    "name": "Octopus",
    "category": "18-nature-weather",
    "keywords": "octopus--nature-sealife-animals",
    "duotone": true
  },
  {
    "component": "OpenUmbrella",
    "name": "Open-Umbrella",
    "category": "18-nature-weather",
    "keywords": "open-umbrella--storm-rain-umbrella-open-weather",
    "duotone": true
  },
  {
    "component": "PetPaw",
    "name": "Pet-Paw",
    "category": "18-nature-weather",
    "keywords": "pet-paw--paw-foot-animals-pets-footprint-track-hotel",
    "duotone": false
  },
  {
    "component": "Planet",
    "name": "Planet",
    "category": "18-nature-weather",
    "keywords": "planet--science-solar-system-ring-planet-saturn-space-astronomy-astronomy",
    "duotone": true
  },
  {
    "component": "PottedFlowerTulip",
    "name": "Potted-Flower-Tulip",
    "category": "18-nature-weather",
    "keywords": "potted-flower-tulip--nature-flower-plant-tree-pot",
    "duotone": true
  },
  {
    "component": "RainCloud",
    "name": "Rain-Cloud",
    "category": "18-nature-weather",
    "keywords": "rain-cloud--cloud-rain-rainy-meteorology-precipitation-weather",
    "duotone": true
  },
  {
    "component": "Rainbow",
    "name": "Rainbow",
    "category": "18-nature-weather",
    "keywords": "rainbow--nature-arch-rain-colorful-rainbow-curve-half-circle",
    "duotone": true
  },
  {
    "component": "Recycle1",
    "name": "Recycle-1",
    "category": "18-nature-weather",
    "keywords": "recycle-1--nature-sign-environment-protect-save-arrows",
    "duotone": false
  },
  {
    "component": "RockSlide",
    "name": "Rock-Slide",
    "category": "18-nature-weather",
    "keywords": "rock-slide--hill-cliff-sign-danger-stone",
    "duotone": true
  },
  {
    "component": "Rose",
    "name": "Rose",
    "category": "18-nature-weather",
    "keywords": "rose--nature-flower-rose-plant-tree",
    "duotone": true
  },
  {
    "component": "Shell",
    "name": "Shell",
    "category": "18-nature-weather",
    "keywords": "shell--nature-sealife-animals",
    "duotone": true
  },
  {
    "component": "ShovelRake",
    "name": "Shovel-Rake",
    "category": "18-nature-weather",
    "keywords": "shovel-rake--nature-crops-plants",
    "duotone": false
  },
  {
    "component": "SnowFlake",
    "name": "Snow-Flake",
    "category": "18-nature-weather",
    "keywords": "snow-flake--winter-freeze-snow-freezing-ice-cold-weather-snowflake",
    "duotone": false
  },
  {
    "component": "Sprout",
    "name": "Sprout",
    "category": "18-nature-weather",
    "keywords": "sprout",
    "duotone": true
  },
  {
    "component": "SunCloud",
    "name": "Sun-Cloud",
    "category": "18-nature-weather",
    "keywords": "sun-cloud--cloud-meteorology-cloudy-partly-sunny-weather",
    "duotone": true
  },
  {
    "component": "TidalWave",
    "name": "Tidal-Wave",
    "category": "18-nature-weather",
    "keywords": "tidal-wave--nature-ocean-wave",
    "duotone": true
  },
  {
    "component": "Tree2",
    "name": "Tree-2",
    "category": "18-nature-weather",
    "keywords": "tree-2--nature-tree-plant-circle-round-park",
    "duotone": true
  },
  {
    "component": "Tree3",
    "name": "Tree-3",
    "category": "18-nature-weather",
    "keywords": "tree-3--nature-tree-plant-cloud-shape-park",
    "duotone": true
  },
  {
    "component": "Volcano",
    "name": "Volcano",
    "category": "18-nature-weather",
    "keywords": "volcano--nature-eruption-erupt-mountain-volcano-lava-magma-explosion",
    "duotone": true
  },
  {
    "component": "WaningCresentMoon",
    "name": "Waning-Cresent-Moon",
    "category": "18-nature-weather",
    "keywords": "waning-cresent-moon--night-new-moon-crescent-weather-time-waning",
    "duotone": false
  },
  {
    "component": "WindFlow1",
    "name": "Wind-Flow-1",
    "category": "18-nature-weather",
    "keywords": "wind-flow-1--wind-high-overcast-gust-weather-meteorology-gale",
    "duotone": false
  },
  {
    "component": "WindFlow2",
    "name": "Wind-Flow-2",
    "category": "18-nature-weather",
    "keywords": "wind-flow-2--wind-flow-weather",
    "duotone": false
  },
  {
    "component": "Windmill",
    "name": "Windmill",
    "category": "18-nature-weather",
    "keywords": "windmill",
    "duotone": true
  },
  {
    "component": "AiScienceSpark",
    "name": "Ai-Science-Spark",
    "category": "19-science-education",
    "keywords": "ai-science-spark--atom-scientific-experiment-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "BookReading",
    "name": "Book-Reading",
    "category": "19-science-education",
    "keywords": "book-reading--book-reading-learning",
    "duotone": true
  },
  {
    "component": "CircleFlask",
    "name": "Circle-Flask",
    "category": "19-science-education",
    "keywords": "circle-flask--science-experiment-lab-flask-chemistry-solution",
    "duotone": false
  },
  {
    "component": "ClassLesson",
    "name": "Class-Lesson",
    "category": "19-science-education",
    "keywords": "class-lesson--class-lesson-education-teacher",
    "duotone": true
  },
  {
    "component": "DefinitionSearchBook",
    "name": "Definition-Search-Book",
    "category": "19-science-education",
    "keywords": "definition-search-book",
    "duotone": true
  },
  {
    "component": "DictionaryLanguageBook",
    "name": "Dictionary-Language-Book",
    "category": "19-science-education",
    "keywords": "dictionary-language-book",
    "duotone": true
  },
  {
    "component": "ErlenmeyerFlask",
    "name": "Erlenmeyer-Flask",
    "category": "19-science-education",
    "keywords": "erlenmeyer-flask--science-experiment-lab-flask-chemistry-solution",
    "duotone": false
  },
  {
    "component": "GlobalLearning",
    "name": "Global-Learning",
    "category": "19-science-education",
    "keywords": "global-learning--global-learning-education",
    "duotone": true
  },
  {
    "component": "GraduationCap",
    "name": "Graduation-Cap",
    "category": "19-science-education",
    "keywords": "graduation-cap--graduation-cap-education",
    "duotone": true
  },
  {
    "component": "ManualBook",
    "name": "Manual-Book",
    "category": "19-science-education",
    "keywords": "manual-book",
    "duotone": true
  },
  {
    "component": "NewsPaper",
    "name": "News-Paper",
    "category": "19-science-education",
    "keywords": "news-paper--newspaper-periodical-fold-content-entertainment",
    "duotone": true
  },
  {
    "component": "OpenBook",
    "name": "Open-Book",
    "category": "19-science-education",
    "keywords": "open-book--content-books-book-open",
    "duotone": true
  },
  {
    "component": "Podium",
    "name": "Podium",
    "category": "19-science-education",
    "keywords": "podium--work-desk-notes-company-presentation-office-podium-microphone",
    "duotone": true
  },
  {
    "component": "ProjectorBoard",
    "name": "Projector-Board",
    "category": "19-science-education",
    "keywords": "projector-board--projector-screen-work-meeting-presentation",
    "duotone": true
  },
  {
    "component": "QualityEducation",
    "name": "Quality-Education",
    "category": "19-science-education",
    "keywords": "quality-education",
    "duotone": true
  },
  {
    "component": "Script2",
    "name": "Script-2",
    "category": "19-science-education",
    "keywords": "script-2--language-programming-code",
    "duotone": true
  },
  {
    "component": "Telescope",
    "name": "Telescope",
    "category": "19-science-education",
    "keywords": "telescope--science-experiment-star-gazing-sky-night-space-universe-astronomy-astronomy",
    "duotone": true
  },
  {
    "component": "TestTube",
    "name": "Test-Tube",
    "category": "19-science-education",
    "keywords": "test-tube--science-experiment-lab-chemistry-test-tube-solution",
    "duotone": true
  },
  {
    "component": "AddLayer2",
    "name": "Add-Layer-2",
    "category": "20-design-tools",
    "keywords": "add-layer-2--layer-add-design-plus-layers-square-box",
    "duotone": true
  },
  {
    "component": "AlignBack1",
    "name": "Align-Back-1",
    "category": "20-design-tools",
    "keywords": "align-back-1--back-design-layer-layers-pile-stack-arrange-square",
    "duotone": true
  },
  {
    "component": "AlignCenter",
    "name": "Align-Center",
    "category": "20-design-tools",
    "keywords": "align-center--text-alignment-align-paragraph-centered-formatting-center",
    "duotone": false
  },
  {
    "component": "AlignFront1",
    "name": "Align-Front-1",
    "category": "20-design-tools",
    "keywords": "align-front-1--design-front-layer-layers-pile-stack-arrange-square",
    "duotone": true
  },
  {
    "component": "AlignLeft",
    "name": "Align-Left",
    "category": "20-design-tools",
    "keywords": "align-left--paragraph-text-alignment-align-left-formatting-right",
    "duotone": false
  },
  {
    "component": "AlignRight",
    "name": "Align-Right",
    "category": "20-design-tools",
    "keywords": "align-right--rag-paragraph-text-alignment-align-right-formatting-left",
    "duotone": false
  },
  {
    "component": "AutoFlash",
    "name": "Auto-Flash",
    "category": "20-design-tools",
    "keywords": "auto-flash",
    "duotone": true
  },
  {
    "component": "Brightness1",
    "name": "Brightness-1",
    "category": "20-design-tools",
    "keywords": "brightness-1--bright-adjust-brightness-adjustment-sun-raise-controls",
    "duotone": true
  },
  {
    "component": "Brightness2",
    "name": "Brightness-2",
    "category": "20-design-tools",
    "keywords": "brightness-2--bright-adjust-brightness-adjustment-sun-raise-controls-half",
    "duotone": true
  },
  {
    "component": "Brightness3",
    "name": "Brightness-3",
    "category": "20-design-tools",
    "keywords": "brightness-3--bright-adjust-brightness-adjustment-sun-raise-controls-dot-small",
    "duotone": true
  },
  {
    "component": "ColorPalette",
    "name": "Color-Palette",
    "category": "20-design-tools",
    "keywords": "color-palette--color-palette-company-office-supplies-work",
    "duotone": false
  },
  {
    "component": "ColorPicker",
    "name": "Color-Picker",
    "category": "20-design-tools",
    "keywords": "color-picker--color-colors-design-dropper-eye-eyedrop-eyedropper-painting-picker",
    "duotone": true
  },
  {
    "component": "ColorSwatches",
    "name": "Color-Swatches",
    "category": "20-design-tools",
    "keywords": "color-swatches--color-colors-design-painting-palette-sample-swatch",
    "duotone": true
  },
  {
    "component": "CompositionOval",
    "name": "Composition-Oval",
    "category": "20-design-tools",
    "keywords": "composition-oval--camera-frame-composition-photography-pictures-landscape-photo-oval",
    "duotone": false
  },
  {
    "component": "CompositionVertical",
    "name": "Composition-Vertical",
    "category": "20-design-tools",
    "keywords": "composition-vertical--camera-portrait-frame-vertical-composition-photography-photo",
    "duotone": false
  },
  {
    "component": "CompsitionHorizontal",
    "name": "Compsition-Horizontal",
    "category": "20-design-tools",
    "keywords": "compsition-horizontal--camera-horizontal-panorama-composition-photography-photo-pictures",
    "duotone": false
  },
  {
    "component": "CropSelection",
    "name": "Crop-Selection",
    "category": "20-design-tools",
    "keywords": "crop-selection--artboard-crop-design-image-picture",
    "duotone": false
  },
  {
    "component": "DarkDislayMode",
    "name": "Dark-Dislay-Mode",
    "category": "20-design-tools",
    "keywords": "dark-dislay-mode",
    "duotone": true
  },
  {
    "component": "FitToHeightSquare",
    "name": "Fit-To-Height-Square",
    "category": "20-design-tools",
    "keywords": "fit-to-height-square",
    "duotone": true
  },
  {
    "component": "Flash1",
    "name": "Flash-1",
    "category": "20-design-tools",
    "keywords": "flash-1--flash-power-connect-charge-electricity-lightning",
    "duotone": false
  },
  {
    "component": "Flash2",
    "name": "Flash-2",
    "category": "20-design-tools",
    "keywords": "flash-2--flash-power-connect-charge-electricity-lightning",
    "duotone": false
  },
  {
    "component": "Flash3",
    "name": "Flash-3",
    "category": "20-design-tools",
    "keywords": "flash-3--flash-power-connect-charge-electricity-lightning",
    "duotone": false
  },
  {
    "component": "FlashOff",
    "name": "Flash-Off",
    "category": "20-design-tools",
    "keywords": "flash-off--flash-power-connect-charge-off-electricity-lightning",
    "duotone": true
  },
  {
    "component": "FlipVerticalArrow2",
    "name": "Flip-Vertical-Arrow-2",
    "category": "20-design-tools",
    "keywords": "flip-vertical-arrow-2--arrow-design-flip-reflect-up-down",
    "duotone": true
  },
  {
    "component": "FlipVerticalCircle1",
    "name": "Flip-Vertical-Circle-1",
    "category": "20-design-tools",
    "keywords": "flip-vertical-circle-1--flip-bottom-object-work",
    "duotone": true
  },
  {
    "component": "FlipVerticalSquare2",
    "name": "Flip-Vertical-Square-2",
    "category": "20-design-tools",
    "keywords": "flip-vertical-square-2--design-up-flip-reflect-vertical",
    "duotone": true
  },
  {
    "component": "FocusPoints",
    "name": "Focus-Points",
    "category": "20-design-tools",
    "keywords": "focus-points--camera-frame-photography-pictures-photo-focus-position",
    "duotone": true
  },
  {
    "component": "InsertSide",
    "name": "Insert-Side",
    "category": "20-design-tools",
    "keywords": "insert-side--points-bullet-align-paragraph-formatting-bullets-text",
    "duotone": true
  },
  {
    "component": "InsertTopLeft",
    "name": "Insert-Top-Left",
    "category": "20-design-tools",
    "keywords": "insert-top-left--alignment-wrap-formatting-paragraph-image-left-text",
    "duotone": true
  },
  {
    "component": "InsertTopRight",
    "name": "Insert-Top-Right",
    "category": "20-design-tools",
    "keywords": "insert-top-right--paragraph-image-text-alignment-wrap-right-formatting",
    "duotone": true
  },
  {
    "component": "LassoTool",
    "name": "Lasso-Tool",
    "category": "20-design-tools",
    "keywords": "lasso-tool",
    "duotone": false
  },
  {
    "component": "Layers1",
    "name": "Layers-1",
    "category": "20-design-tools",
    "keywords": "layers-1--design-layer-layers-pile-stack-align",
    "duotone": true
  },
  {
    "component": "Layers2",
    "name": "Layers-2",
    "category": "20-design-tools",
    "keywords": "layers-2--design-layer-layers-pile-stack-align",
    "duotone": true
  },
  {
    "component": "LayoutWindow1",
    "name": "Layout-Window-1",
    "category": "20-design-tools",
    "keywords": "layout-window-1--column-layout-layouts-left-sidebar",
    "duotone": true
  },
  {
    "component": "LayoutWindow11",
    "name": "Layout-Window-11",
    "category": "20-design-tools",
    "keywords": "layout-window-11",
    "duotone": true
  },
  {
    "component": "LayoutWindow2",
    "name": "Layout-Window-2",
    "category": "20-design-tools",
    "keywords": "layout-window-2--column-header-layout-layouts-masthead-sidebar",
    "duotone": true
  },
  {
    "component": "LayoutWindow8",
    "name": "Layout-Window-8",
    "category": "20-design-tools",
    "keywords": "layout-window-8--grid-header-layout-layouts-masthead",
    "duotone": true
  },
  {
    "component": "MagicWand2",
    "name": "Magic-Wand-2",
    "category": "20-design-tools",
    "keywords": "magic-wand-2--design-magic-star-supplies-tool-wand",
    "duotone": true
  },
  {
    "component": "OrientationLandscape",
    "name": "Orientation-Landscape",
    "category": "20-design-tools",
    "keywords": "orientation-landscape--photos-photo-orientation-landscape-picture-photography-camera-pictures-image",
    "duotone": true
  },
  {
    "component": "OrientationPortrait",
    "name": "Orientation-Portrait",
    "category": "20-design-tools",
    "keywords": "orientation-portrait--photos-photo-orientation-portrait-picture-photography-camera-pictures-image",
    "duotone": true
  },
  {
    "component": "PaintBucket",
    "name": "Paint-Bucket",
    "category": "20-design-tools",
    "keywords": "paint-bucket--bucket-color-colors-design-paint-painting",
    "duotone": true
  },
  {
    "component": "PaintPalette",
    "name": "Paint-Palette",
    "category": "20-design-tools",
    "keywords": "paint-palette--color-colors-design-paint-painting-palette",
    "duotone": true
  },
  {
    "component": "Paintbrush1",
    "name": "Paintbrush-1",
    "category": "20-design-tools",
    "keywords": "paintbrush-1--brush-color-colors-design-paint-painting",
    "duotone": true
  },
  {
    "component": "Paintbrush2",
    "name": "Paintbrush-2",
    "category": "20-design-tools",
    "keywords": "paintbrush-2--brush-color-colors-design-paint-painting",
    "duotone": true
  },
  {
    "component": "PathfinderDivide",
    "name": "Pathfinder-Divide",
    "category": "20-design-tools",
    "keywords": "pathfinder-divide",
    "duotone": true
  },
  {
    "component": "PathfinderExclude",
    "name": "Pathfinder-Exclude",
    "category": "20-design-tools",
    "keywords": "pathfinder-exclude",
    "duotone": true
  },
  {
    "component": "PathfinderIntersect",
    "name": "Pathfinder-Intersect",
    "category": "20-design-tools",
    "keywords": "pathfinder-intersect",
    "duotone": true
  },
  {
    "component": "PathfinderMerge",
    "name": "Pathfinder-Merge",
    "category": "20-design-tools",
    "keywords": "pathfinder-merge",
    "duotone": true
  },
  {
    "component": "PathfinderMinusFront1",
    "name": "Pathfinder-Minus-Front-1",
    "category": "20-design-tools",
    "keywords": "pathfinder-minus-front-1",
    "duotone": true
  },
  {
    "component": "PathfinderTrim",
    "name": "Pathfinder-Trim",
    "category": "20-design-tools",
    "keywords": "pathfinder-trim",
    "duotone": true
  },
  {
    "component": "PathfinderUnion",
    "name": "Pathfinder-Union",
    "category": "20-design-tools",
    "keywords": "pathfinder-union",
    "duotone": false
  },
  {
    "component": "Pen3",
    "name": "Pen-3",
    "category": "20-design-tools",
    "keywords": "pen-3--content-creation-edit-pen-pens-write",
    "duotone": true
  },
  {
    "component": "PenDraw",
    "name": "Pen-Draw",
    "category": "20-design-tools",
    "keywords": "pen-draw",
    "duotone": false
  },
  {
    "component": "PenTool",
    "name": "Pen-Tool",
    "category": "20-design-tools",
    "keywords": "pen-tool",
    "duotone": true
  },
  {
    "component": "Pencil",
    "name": "Pencil",
    "category": "20-design-tools",
    "keywords": "pencil--change-edit-modify-pencil-write-writing",
    "duotone": false
  },
  {
    "component": "RotateAngle45",
    "name": "Rotate-Angle-45",
    "category": "20-design-tools",
    "keywords": "rotate-angle-45--rotate-angle-company-office-supplies-work",
    "duotone": true
  },
  {
    "component": "RoundCap",
    "name": "Round-Cap",
    "category": "20-design-tools",
    "keywords": "round-cap",
    "duotone": true
  },
  {
    "component": "SelectCircleArea1",
    "name": "Select-Circle-Area-1",
    "category": "20-design-tools",
    "keywords": "select-circle-area-1--select-area-object-work",
    "duotone": false
  },
  {
    "component": "SprayPaint",
    "name": "Spray-Paint",
    "category": "20-design-tools",
    "keywords": "spray-paint--can-color-colors-design-paint-painting-spray",
    "duotone": true
  },
  {
    "component": "SquareCap",
    "name": "Square-Cap",
    "category": "20-design-tools",
    "keywords": "square-cap",
    "duotone": true
  },
  {
    "component": "StraightCap",
    "name": "Straight-Cap",
    "category": "20-design-tools",
    "keywords": "straight-cap",
    "duotone": true
  },
  {
    "component": "AiGamingSpark",
    "name": "Ai-Gaming-Spark",
    "category": "21-entertainment-games",
    "keywords": "ai-gaming-spark--remote-control-controller-technology-artificial-intelligence-ai",
    "duotone": true
  },
  {
    "component": "Ball",
    "name": "Ball",
    "category": "21-entertainment-games",
    "keywords": "ball--sports-ball-sport-basketball-shopping-catergories",
    "duotone": true
  },
  {
    "component": "Balloon",
    "name": "Balloon",
    "category": "21-entertainment-games",
    "keywords": "balloon--hobby-entertainment-party-balloon",
    "duotone": true
  },
  {
    "component": "Bomb",
    "name": "Bomb",
    "category": "21-entertainment-games",
    "keywords": "bomb--delete-bomb-remove",
    "duotone": true
  },
  {
    "component": "Bow",
    "name": "Bow",
    "category": "21-entertainment-games",
    "keywords": "bow--entertainment-gaming-bow-weapon",
    "duotone": true
  },
  {
    "component": "Cards",
    "name": "Cards",
    "category": "21-entertainment-games",
    "keywords": "cards",
    "duotone": true
  },
  {
    "component": "ChessBishop",
    "name": "Chess-Bishop",
    "category": "21-entertainment-games",
    "keywords": "chess-bishop",
    "duotone": true
  },
  {
    "component": "ChessKing",
    "name": "Chess-King",
    "category": "21-entertainment-games",
    "keywords": "chess-king",
    "duotone": true
  },
  {
    "component": "ChessKnight",
    "name": "Chess-Knight",
    "category": "21-entertainment-games",
    "keywords": "chess-knight",
    "duotone": true
  },
  {
    "component": "ChessPawn",
    "name": "Chess-Pawn",
    "category": "21-entertainment-games",
    "keywords": "chess-pawn",
    "duotone": true
  },
  {
    "component": "CloudGaming1",
    "name": "Cloud-Gaming-1",
    "category": "21-entertainment-games",
    "keywords": "cloud-gaming-1--entertainment-cloud-gaming",
    "duotone": true
  },
  {
    "component": "ClubsSymbol",
    "name": "Clubs-Symbol",
    "category": "21-entertainment-games",
    "keywords": "clubs-symbol--entertainment-gaming-card-clubs-symbol",
    "duotone": false
  },
  {
    "component": "Controller1",
    "name": "Controller-1",
    "category": "21-entertainment-games",
    "keywords": "controller-1--remote-quadcopter-drones-flying-drone-control-controller-technology-fly",
    "duotone": true
  },
  {
    "component": "ControllerWireless",
    "name": "Controller-Wireless",
    "category": "21-entertainment-games",
    "keywords": "controller-wireless--remote-gaming-drones-drone-control-controller-technology-console",
    "duotone": true
  },
  {
    "component": "Controller",
    "name": "Controller",
    "category": "21-entertainment-games",
    "keywords": "controller--remote-quadcopter-drones-flying-drone-control-controller-technology-fly",
    "duotone": true
  },
  {
    "component": "DesktopGame",
    "name": "Desktop-Game",
    "category": "21-entertainment-games",
    "keywords": "desktop-game--controller-display-device-computer-games-leisure",
    "duotone": true
  },
  {
    "component": "DiamondsSymbol",
    "name": "Diamonds-Symbol",
    "category": "21-entertainment-games",
    "keywords": "diamonds-symbol--entertainment-gaming-card-diamonds-symbol",
    "duotone": false
  },
  {
    "component": "Dice1",
    "name": "Dice-1",
    "category": "21-entertainment-games",
    "keywords": "dice-1",
    "duotone": true
  },
  {
    "component": "Dice2",
    "name": "Dice-2",
    "category": "21-entertainment-games",
    "keywords": "dice-2",
    "duotone": true
  },
  {
    "component": "Dice3",
    "name": "Dice-3",
    "category": "21-entertainment-games",
    "keywords": "dice-3",
    "duotone": true
  },
  {
    "component": "Dice4",
    "name": "Dice-4",
    "category": "21-entertainment-games",
    "keywords": "dice-4",
    "duotone": true
  },
  {
    "component": "Dice5",
    "name": "Dice-5",
    "category": "21-entertainment-games",
    "keywords": "dice-5",
    "duotone": true
  },
  {
    "component": "Dice6",
    "name": "Dice-6",
    "category": "21-entertainment-games",
    "keywords": "dice-6",
    "duotone": true
  },
  {
    "component": "DicesEntertainmentGamingDices",
    "name": "Dices-Entertainment-Gaming-Dices",
    "category": "21-entertainment-games",
    "keywords": "dices-entertainment-gaming-dices",
    "duotone": true
  },
  {
    "component": "Esports",
    "name": "Esports",
    "category": "21-entertainment-games",
    "keywords": "esports--entertainment-gaming-esports",
    "duotone": true
  },
  {
    "component": "FireworksRocket",
    "name": "Fireworks-Rocket",
    "category": "21-entertainment-games",
    "keywords": "fireworks-rocket--hobby-entertainment-party-fireworks-rocket",
    "duotone": true
  },
  {
    "component": "HeartsSymbol",
    "name": "Hearts-Symbol",
    "category": "21-entertainment-games",
    "keywords": "hearts-symbol--entertainment-gaming-card-hearts-symbol",
    "duotone": false
  },
  {
    "component": "JumpObject",
    "name": "Jump-Object",
    "category": "21-entertainment-games",
    "keywords": "jump-object",
    "duotone": true
  },
  {
    "component": "ModulePuzzle1",
    "name": "Module-Puzzle-1",
    "category": "21-entertainment-games",
    "keywords": "module-puzzle-1--code-puzzle-module-programming-plugin-piece",
    "duotone": false
  },
  {
    "component": "ModulePuzzle3",
    "name": "Module-Puzzle-3",
    "category": "21-entertainment-games",
    "keywords": "module-puzzle-3--code-puzzle-module-programming-plugin-piece",
    "duotone": true
  },
  {
    "component": "OneVesusOne",
    "name": "One-Vesus-One",
    "category": "21-entertainment-games",
    "keywords": "one-vesus-one--entertainment-gaming-one-vesus-one",
    "duotone": true
  },
  {
    "component": "PartyPopper",
    "name": "Party-Popper",
    "category": "21-entertainment-games",
    "keywords": "party-popper--hobby-entertainment-party-popper-confetti-event",
    "duotone": true
  },
  {
    "component": "SpadesSymbol",
    "name": "Spades-Symbol",
    "category": "21-entertainment-games",
    "keywords": "spades-symbol--entertainment-gaming-card-spades-symbol",
    "duotone": false
  },
  {
    "component": "Trophy",
    "name": "Trophy",
    "category": "21-entertainment-games",
    "keywords": "trophy--reward-rating-trophy-social-award-media",
    "duotone": true
  },
  {
    "component": "Zodiac1",
    "name": "Zodiac-1",
    "category": "21-entertainment-games",
    "keywords": "zodiac-1--sign-astrology-stars-space-scorpio",
    "duotone": false
  },
  {
    "component": "Zodiac10",
    "name": "Zodiac-10",
    "category": "21-entertainment-games",
    "keywords": "zodiac-10--sign-astrology-stars-space-pisces",
    "duotone": false
  },
  {
    "component": "Zodiac11",
    "name": "Zodiac-11",
    "category": "21-entertainment-games",
    "keywords": "zodiac-11--sign-astrology-stars-space-sagittarius",
    "duotone": false
  },
  {
    "component": "Zodiac12",
    "name": "Zodiac-12",
    "category": "21-entertainment-games",
    "keywords": "zodiac-12--sign-astrology-stars-space-cancer",
    "duotone": false
  },
  {
    "component": "Zodiac2",
    "name": "Zodiac-2",
    "category": "21-entertainment-games",
    "keywords": "zodiac-2--sign-astrology-stars-space-virgo",
    "duotone": false
  },
  {
    "component": "Zodiac3",
    "name": "Zodiac-3",
    "category": "21-entertainment-games",
    "keywords": "zodiac-3--sign-astrology-stars-space-leo",
    "duotone": false
  },
  {
    "component": "Zodiac4",
    "name": "Zodiac-4",
    "category": "21-entertainment-games",
    "keywords": "zodiac-4--sign-astrology-stars-space-aquarius",
    "duotone": false
  },
  {
    "component": "Zodiac5",
    "name": "Zodiac-5",
    "category": "21-entertainment-games",
    "keywords": "zodiac-5--sign-astrology-stars-space-taurus",
    "duotone": false
  },
  {
    "component": "Zodiac6",
    "name": "Zodiac-6",
    "category": "21-entertainment-games",
    "keywords": "zodiac-6--sign-astrology-stars-space-capricorn",
    "duotone": false
  },
  {
    "component": "Zodiac7",
    "name": "Zodiac-7",
    "category": "21-entertainment-games",
    "keywords": "zodiac-7--sign-astrology-stars-space-ares",
    "duotone": false
  },
  {
    "component": "Zodiac8",
    "name": "Zodiac-8",
    "category": "21-entertainment-games",
    "keywords": "zodiac-8--sign-astrology-stars-space-libra",
    "duotone": false
  },
  {
    "component": "Zodiac9",
    "name": "Zodiac-9",
    "category": "21-entertainment-games",
    "keywords": "zodiac-9--sign-astrology-stars-space-gemini",
    "duotone": false
  },
  {
    "component": "ChatBubbleOvalSmiley1",
    "name": "Chat-Bubble-Oval-Smiley-1",
    "category": "22-emoji-faces",
    "keywords": "chat-bubble-oval-smiley-1--messages-message-bubble-chat-oval-smiley-smile",
    "duotone": true
  },
  {
    "component": "ChatBubbleOvalSmiley2",
    "name": "Chat-Bubble-Oval-Smiley-2",
    "category": "22-emoji-faces",
    "keywords": "chat-bubble-oval-smiley-2--messages-message-bubble-chat-oval-smiley-smile",
    "duotone": true
  },
  {
    "component": "DesktopEmoji",
    "name": "Desktop-Emoji",
    "category": "22-emoji-faces",
    "keywords": "desktop-emoji--device-display-desktop-padlock-smiley",
    "duotone": true
  },
  {
    "component": "HappyFace",
    "name": "Happy-Face",
    "category": "22-emoji-faces",
    "keywords": "happy-face--smiley-chat-message-smile-emoji-face-satisfied",
    "duotone": true
  },
  {
    "component": "SadFace",
    "name": "Sad-Face",
    "category": "22-emoji-faces",
    "keywords": "sad-face--smiley-chat-message-emoji-sad-face-unsatisfied",
    "duotone": true
  },
  {
    "component": "SmileyAngry",
    "name": "Smiley-Angry",
    "category": "22-emoji-faces",
    "keywords": "smiley-angry",
    "duotone": true
  },
  {
    "component": "SmileyCool",
    "name": "Smiley-Cool",
    "category": "22-emoji-faces",
    "keywords": "smiley-cool",
    "duotone": true
  },
  {
    "component": "SmileyCrying1",
    "name": "Smiley-Crying-1",
    "category": "22-emoji-faces",
    "keywords": "smiley-crying-1",
    "duotone": true
  },
  {
    "component": "SmileyCute",
    "name": "Smiley-Cute",
    "category": "22-emoji-faces",
    "keywords": "smiley-cute",
    "duotone": true
  },
  {
    "component": "SmileyDrool",
    "name": "Smiley-Drool",
    "category": "22-emoji-faces",
    "keywords": "smiley-drool",
    "duotone": true
  },
  {
    "component": "SmileyEmojiKissNervous",
    "name": "Smiley-Emoji-Kiss-Nervous",
    "category": "22-emoji-faces",
    "keywords": "smiley-emoji-kiss-nervous",
    "duotone": true
  },
  {
    "component": "SmileyEmojiTerrified",
    "name": "Smiley-Emoji-Terrified",
    "category": "22-emoji-faces",
    "keywords": "smiley-emoji-terrified",
    "duotone": true
  },
  {
    "component": "SmileyGrumpy",
    "name": "Smiley-Grumpy",
    "category": "22-emoji-faces",
    "keywords": "smiley-grumpy",
    "duotone": true
  },
  {
    "component": "SmileyHappy",
    "name": "Smiley-Happy",
    "category": "22-emoji-faces",
    "keywords": "smiley-happy",
    "duotone": true
  },
  {
    "component": "SmileyInLove",
    "name": "Smiley-In-Love",
    "category": "22-emoji-faces",
    "keywords": "smiley-in-love",
    "duotone": true
  },
  {
    "component": "SmileyKiss",
    "name": "Smiley-Kiss",
    "category": "22-emoji-faces",
    "keywords": "smiley-kiss",
    "duotone": true
  },
  {
    "component": "SmileyLaughing3",
    "name": "Smiley-Laughing-3",
    "category": "22-emoji-faces",
    "keywords": "smiley-laughing-3",
    "duotone": true
  },
  {
    "component": "SmileyMask",
    "name": "Smiley-Mask",
    "category": "22-emoji-faces",
    "keywords": "smiley-mask",
    "duotone": true
  },
  {
    "component": "SmileyNauseas",
    "name": "Smiley-Nauseas",
    "category": "22-emoji-faces",
    "keywords": "smiley-nauseas",
    "duotone": true
  },
  {
    "component": "SmileySmirk",
    "name": "Smiley-Smirk",
    "category": "22-emoji-faces",
    "keywords": "smiley-smirk",
    "duotone": true
  },
  {
    "component": "SmileySparks",
    "name": "Smiley-Sparks",
    "category": "22-emoji-faces",
    "keywords": "smiley-sparks",
    "duotone": true
  },
  {
    "component": "SmileySurprised",
    "name": "Smiley-Surprised",
    "category": "22-emoji-faces",
    "keywords": "smiley-surprised",
    "duotone": true
  },
  {
    "component": "SmileyThrowUp",
    "name": "Smiley-Throw-Up",
    "category": "22-emoji-faces",
    "keywords": "smiley-throw-up",
    "duotone": true
  },
  {
    "component": "SmileyVeryShocked",
    "name": "Smiley-Very-Shocked",
    "category": "22-emoji-faces",
    "keywords": "smiley-very-shocked",
    "duotone": true
  },
  {
    "component": "StraightFace",
    "name": "Straight-Face",
    "category": "22-emoji-faces",
    "keywords": "straight-face--smiley-chat-message-indifferent-emoji-face-poker",
    "duotone": true
  },
  {
    "component": "CursorClick",
    "name": "Cursor-Click",
    "category": "23-hands-gestures",
    "keywords": "cursor-click",
    "duotone": true
  },
  {
    "component": "Fist",
    "name": "Fist",
    "category": "23-hands-gestures",
    "keywords": "fist",
    "duotone": true
  },
  {
    "component": "GiveGift",
    "name": "Give-Gift",
    "category": "23-hands-gestures",
    "keywords": "give-gift--reward-social-rating-media-queen-vip-gift",
    "duotone": true
  },
  {
    "component": "HandCursor",
    "name": "Hand-Cursor",
    "category": "23-hands-gestures",
    "keywords": "hand-cursor--hand-select-cursor-finger",
    "duotone": false
  },
  {
    "component": "HandGrab",
    "name": "Hand-Grab",
    "category": "23-hands-gestures",
    "keywords": "hand-grab--hand-select-cursor-finger-grab",
    "duotone": true
  },
  {
    "component": "HandHeldTabletDrawing",
    "name": "Hand-Held-Tablet-Drawing",
    "category": "23-hands-gestures",
    "keywords": "hand-held-tablet-drawing--tablet-kindle-device-electronics-ipad-digital-drawing-canvas",
    "duotone": true
  },
  {
    "component": "HandHeldTabletWriting",
    "name": "Hand-Held-Tablet-Writing",
    "category": "23-hands-gestures",
    "keywords": "hand-held-tablet-writing--tablet-kindle-device-electronics-ipad-writing-digital-paper-notepad",
    "duotone": true
  },
  {
    "component": "HandHeld",
    "name": "Hand-Held",
    "category": "23-hands-gestures",
    "keywords": "hand-held--tablet-kindle-device-electronics-ipad-computer",
    "duotone": true
  },
  {
    "component": "InsuranceHand",
    "name": "Insurance-Hand",
    "category": "23-hands-gestures",
    "keywords": "insurance-hand--health-medical-insurance-hand-cross",
    "duotone": true
  },
  {
    "component": "Like1",
    "name": "Like-1",
    "category": "23-hands-gestures",
    "keywords": "like-1--reward-social-up-rating-media-like-thumb-hand",
    "duotone": true
  },
  {
    "component": "OkHand",
    "name": "Ok-Hand",
    "category": "23-hands-gestures",
    "keywords": "ok-hand",
    "duotone": true
  },
  {
    "component": "OneFingerDragHorizontal",
    "name": "One-Finger-Drag-Horizontal",
    "category": "23-hands-gestures",
    "keywords": "one-finger-drag-horizontal",
    "duotone": true
  },
  {
    "component": "OneFingerDragVertical",
    "name": "One-Finger-Drag-Vertical",
    "category": "23-hands-gestures",
    "keywords": "one-finger-drag-vertical",
    "duotone": true
  },
  {
    "component": "OneFingerHold",
    "name": "One-Finger-Hold",
    "category": "23-hands-gestures",
    "keywords": "one-finger-hold",
    "duotone": true
  },
  {
    "component": "OneFingerTap",
    "name": "One-Finger-Tap",
    "category": "23-hands-gestures",
    "keywords": "one-finger-tap",
    "duotone": true
  },
  {
    "component": "PeaceHand",
    "name": "Peace-Hand",
    "category": "23-hands-gestures",
    "keywords": "peace-hand",
    "duotone": true
  },
  {
    "component": "PrayingHand",
    "name": "Praying-Hand",
    "category": "23-hands-gestures",
    "keywords": "praying-hand",
    "duotone": true
  },
  {
    "component": "RockAndRollHand",
    "name": "Rock-And-Roll-Hand",
    "category": "23-hands-gestures",
    "keywords": "rock-and-roll-hand",
    "duotone": true
  },
  {
    "component": "TwoFingerDragHotizontal",
    "name": "Two-Finger-Drag-Hotizontal",
    "category": "23-hands-gestures",
    "keywords": "two-finger-drag-hotizontal",
    "duotone": true
  },
  {
    "component": "TwoFingerTap",
    "name": "Two-Finger-Tap",
    "category": "23-hands-gestures",
    "keywords": "two-finger-tap",
    "duotone": true
  },
  {
    "component": "WavingHand",
    "name": "Waving-Hand",
    "category": "23-hands-gestures",
    "keywords": "waving-hand",
    "duotone": true
  },
  {
    "component": "Amazon",
    "name": "Amazon",
    "category": "24-brands-logos",
    "keywords": "amazon",
    "duotone": true
  },
  {
    "component": "Android",
    "name": "Android",
    "category": "24-brands-logos",
    "keywords": "android--android-code-apps-bugdroid-programming",
    "duotone": true
  },
  {
    "component": "AppStore",
    "name": "App-Store",
    "category": "24-brands-logos",
    "keywords": "app-store",
    "duotone": false
  },
  {
    "component": "Apple",
    "name": "Apple",
    "category": "24-brands-logos",
    "keywords": "apple--os-system-apple",
    "duotone": true
  },
  {
    "component": "BinanceCircle",
    "name": "Binance-Circle",
    "category": "24-brands-logos",
    "keywords": "binance-circle--crypto-circle-payment-blockchain-finance-binance-currency",
    "duotone": true
  },
  {
    "component": "Bitcoin",
    "name": "Bitcoin",
    "category": "24-brands-logos",
    "keywords": "bitcoin--crypto-circle-payment-blokchain-finance-bitcoin-money-currency",
    "duotone": false
  },
  {
    "component": "Chrome",
    "name": "Chrome",
    "category": "24-brands-logos",
    "keywords": "chrome",
    "duotone": true
  },
  {
    "component": "CssThree",
    "name": "Css-Three",
    "category": "24-brands-logos",
    "keywords": "css-three--language-three-code-programming-html-css",
    "duotone": true
  },
  {
    "component": "Discord",
    "name": "Discord",
    "category": "24-brands-logos",
    "keywords": "discord",
    "duotone": true
  },
  {
    "component": "Dropbox",
    "name": "Dropbox",
    "category": "24-brands-logos",
    "keywords": "dropbox",
    "duotone": false
  },
  {
    "component": "EpicGames1",
    "name": "Epic-Games-1",
    "category": "24-brands-logos",
    "keywords": "epic-games-1--epic-games-entertainment-gaming",
    "duotone": true
  },
  {
    "component": "EthereumCircle",
    "name": "Ethereum-Circle",
    "category": "24-brands-logos",
    "keywords": "ethereum-circle--crypto-circle-payment-blockchain-finance-eth-currency",
    "duotone": true
  },
  {
    "component": "Ethereum",
    "name": "Ethereum",
    "category": "24-brands-logos",
    "keywords": "ethereum--crypto-circle-payment-blokchain-finance-ethereum-eth-currency",
    "duotone": true
  },
  {
    "component": "Facebook1",
    "name": "Facebook-1",
    "category": "24-brands-logos",
    "keywords": "facebook-1--media-facebook-social",
    "duotone": true
  },
  {
    "component": "Figma",
    "name": "Figma",
    "category": "24-brands-logos",
    "keywords": "figma",
    "duotone": true
  },
  {
    "component": "Gameboy",
    "name": "Gameboy",
    "category": "24-brands-logos",
    "keywords": "gameboy--entertainment-gaming-device-gameboy",
    "duotone": true
  },
  {
    "component": "Gmail",
    "name": "Gmail",
    "category": "24-brands-logos",
    "keywords": "gmail",
    "duotone": true
  },
  {
    "component": "GoogleDrive",
    "name": "Google-Drive",
    "category": "24-brands-logos",
    "keywords": "google-drive",
    "duotone": true
  },
  {
    "component": "Google",
    "name": "Google",
    "category": "24-brands-logos",
    "keywords": "google--media-google-social",
    "duotone": false
  },
  {
    "component": "Instagram",
    "name": "Instagram",
    "category": "24-brands-logos",
    "keywords": "instagram",
    "duotone": true
  },
  {
    "component": "Linkedin",
    "name": "Linkedin",
    "category": "24-brands-logos",
    "keywords": "linkedin--network-linkedin-professional",
    "duotone": false
  },
  {
    "component": "Meta",
    "name": "Meta",
    "category": "24-brands-logos",
    "keywords": "meta",
    "duotone": true
  },
  {
    "component": "Netflix",
    "name": "Netflix",
    "category": "24-brands-logos",
    "keywords": "netflix",
    "duotone": true
  },
  {
    "component": "NintendoSwitch",
    "name": "Nintendo-Switch",
    "category": "24-brands-logos",
    "keywords": "nintendo-switch--nintendo-switch-entertainment-gaming",
    "duotone": true
  },
  {
    "component": "Pacman",
    "name": "Pacman",
    "category": "24-brands-logos",
    "keywords": "pacman--entertainment-gaming-pacman-video",
    "duotone": true
  },
  {
    "component": "Paypal",
    "name": "Paypal",
    "category": "24-brands-logos",
    "keywords": "paypal--payment-paypal",
    "duotone": true
  },
  {
    "component": "PlayStation",
    "name": "Play-Station",
    "category": "24-brands-logos",
    "keywords": "play-station--play-station-entertainment-gaming",
    "duotone": true
  },
  {
    "component": "PlayStore",
    "name": "Play-Store",
    "category": "24-brands-logos",
    "keywords": "play-store",
    "duotone": true
  },
  {
    "component": "Slack",
    "name": "Slack",
    "category": "24-brands-logos",
    "keywords": "slack",
    "duotone": true
  },
  {
    "component": "Spotify",
    "name": "Spotify",
    "category": "24-brands-logos",
    "keywords": "spotify",
    "duotone": true
  },
  {
    "component": "Telegram",
    "name": "Telegram",
    "category": "24-brands-logos",
    "keywords": "telegram",
    "duotone": true
  },
  {
    "component": "Tiktok",
    "name": "Tiktok",
    "category": "24-brands-logos",
    "keywords": "tiktok",
    "duotone": false
  },
  {
    "component": "Tinder",
    "name": "Tinder",
    "category": "24-brands-logos",
    "keywords": "tinder",
    "duotone": false
  },
  {
    "component": "Twitter",
    "name": "Twitter",
    "category": "24-brands-logos",
    "keywords": "twitter--media-twitter-social",
    "duotone": false
  },
  {
    "component": "Whatsapp",
    "name": "Whatsapp",
    "category": "24-brands-logos",
    "keywords": "whatsapp",
    "duotone": true
  },
  {
    "component": "Windows",
    "name": "Windows",
    "category": "24-brands-logos",
    "keywords": "windows--os-system-microsoft",
    "duotone": true
  },
  {
    "component": "Xbox",
    "name": "Xbox",
    "category": "24-brands-logos",
    "keywords": "xbox--xbox-entertainment-gaming",
    "duotone": true
  },
  {
    "component": "XrpCircle",
    "name": "Xrp-Circle",
    "category": "24-brands-logos",
    "keywords": "xrp-circle--crypto-circle-payment-blockchain-finance-xrp-currency",
    "duotone": true
  },
  {
    "component": "Attribution",
    "name": "Attribution",
    "category": "25-shapes-symbols",
    "keywords": "attribution",
    "duotone": true
  },
  {
    "component": "ChristianCross1",
    "name": "Christian-Cross-1",
    "category": "25-shapes-symbols",
    "keywords": "christian-cross-1--religion-christian-cross-culture-bold",
    "duotone": false
  },
  {
    "component": "ChristianCross2",
    "name": "Christian-Cross-2",
    "category": "25-shapes-symbols",
    "keywords": "christian-cross-2--religion-christian-cross-culture-bold",
    "duotone": false
  },
  {
    "component": "Christianity",
    "name": "Christianity",
    "category": "25-shapes-symbols",
    "keywords": "christianity--religion-jesus-christianity-christ-fish-culture",
    "duotone": false
  },
  {
    "component": "Circle",
    "name": "Circle",
    "category": "25-shapes-symbols",
    "keywords": "circle--geometric-circle-round-design-shape-shapes-shape",
    "duotone": false
  },
  {
    "component": "ConeShape",
    "name": "Cone-Shape",
    "category": "25-shapes-symbols",
    "keywords": "cone",
    "duotone": true
  },
  {
    "component": "CreativeCommons",
    "name": "Creative-Commons",
    "category": "25-shapes-symbols",
    "keywords": "creative-commons",
    "duotone": true
  },
  {
    "component": "DangerousZoneSign",
    "name": "Dangerous-Zone-Sign",
    "category": "25-shapes-symbols",
    "keywords": "dangerous-zone-sign",
    "duotone": true
  },
  {
    "component": "Dhammajak",
    "name": "Dhammajak",
    "category": "25-shapes-symbols",
    "keywords": "dhammajak--religion-dhammajak-culture-bhuddhism-buddish",
    "duotone": true
  },
  {
    "component": "Diamond2",
    "name": "Diamond-2",
    "category": "25-shapes-symbols",
    "keywords": "diamond-2--diamond-money-payment-finance-wealth-jewelry",
    "duotone": true
  },
  {
    "component": "HalfStar1",
    "name": "Half-Star-1",
    "category": "25-shapes-symbols",
    "keywords": "half-star-1--reward-rating-rate-social-star-media-favorite-like-stars-half",
    "duotone": false
  },
  {
    "component": "Heart",
    "name": "Heart",
    "category": "25-shapes-symbols",
    "keywords": "heart--reward-social-rating-media-heart-it-like-favorite-love",
    "duotone": false
  },
  {
    "component": "Hexagram",
    "name": "Hexagram",
    "category": "25-shapes-symbols",
    "keywords": "hexagram--star-jew-jewish-judaism-hexagram-culture-religion-david",
    "duotone": false
  },
  {
    "component": "Hinduism",
    "name": "Hinduism",
    "category": "25-shapes-symbols",
    "keywords": "hinduism--religion-hinduism-culture-hindu",
    "duotone": false
  },
  {
    "component": "Islam",
    "name": "Islam",
    "category": "25-shapes-symbols",
    "keywords": "islam--religion-islam-moon-crescent-muslim-culture-star",
    "duotone": true
  },
  {
    "component": "PeaceSymbol",
    "name": "Peace-Symbol",
    "category": "25-shapes-symbols",
    "keywords": "peace-symbol--religion-peace-war-culture-symbol",
    "duotone": false
  },
  {
    "component": "Pentagon",
    "name": "Pentagon",
    "category": "25-shapes-symbols",
    "keywords": "pentagon--pentagon-design-geometric-shape-shapes-shape",
    "duotone": false
  },
  {
    "component": "PolkaDotCircle",
    "name": "Polka-Dot-Circle",
    "category": "25-shapes-symbols",
    "keywords": "polka-dot-circle--crypto-circle-payment-blockchain-finance-polka-dot-currency",
    "duotone": true
  },
  {
    "component": "Polygon",
    "name": "Polygon",
    "category": "25-shapes-symbols",
    "keywords": "polygon--polygon-octangle-design-geometric-shape-shapes-shape",
    "duotone": false
  },
  {
    "component": "PyramidShape",
    "name": "Pyramid-Shape",
    "category": "25-shapes-symbols",
    "keywords": "pyramid",
    "duotone": true
  },
  {
    "component": "Radioactive2",
    "name": "Radioactive-2",
    "category": "25-shapes-symbols",
    "keywords": "radioactive-2--warning-radioactive-radiation-emergency-danger-safety",
    "duotone": false
  },
  {
    "component": "SignCrossSquare",
    "name": "Sign-Cross-Square",
    "category": "25-shapes-symbols",
    "keywords": "sign-cross-square--health-sign-medical-symbol-hospital-cross-square",
    "duotone": true
  },
  {
    "component": "Skull1",
    "name": "Skull-1",
    "category": "25-shapes-symbols",
    "keywords": "skull-1--crash-death-delete-die-error-garbage-remove-skull-trash",
    "duotone": true
  },
  {
    "component": "SosHelpEmergencySign",
    "name": "Sos-Help-Emergency-Sign",
    "category": "25-shapes-symbols",
    "keywords": "sos-help-emergency-sign",
    "duotone": false
  },
  {
    "component": "SpiralShape",
    "name": "Spiral-Shape",
    "category": "25-shapes-symbols",
    "keywords": "spiral-shape",
    "duotone": false
  },
  {
    "component": "Star1",
    "name": "Star-1",
    "category": "25-shapes-symbols",
    "keywords": "star-1--reward-rating-rate-social-star-media-favorite-like-stars",
    "duotone": false
  },
  {
    "component": "Star2",
    "name": "Star-2",
    "category": "25-shapes-symbols",
    "keywords": "star-2--reward-rating-rate-social-star-media-favorite-like-stars-spark",
    "duotone": false
  },
  {
    "component": "StarBadge",
    "name": "Star-Badge",
    "category": "25-shapes-symbols",
    "keywords": "star-badge--ribbon-reward-like-social-rating-media",
    "duotone": true
  },
  {
    "component": "TriangleFlag",
    "name": "Triangle-Flag",
    "category": "25-shapes-symbols",
    "keywords": "triangle-flag--navigation-map-maps-flag-gps-location-destination-goal",
    "duotone": true
  },
  {
    "component": "WarningOctagon",
    "name": "Warning-Octagon",
    "category": "25-shapes-symbols",
    "keywords": "warning-octagon--frame-alert-warning-octagon-exclamation-caution",
    "duotone": true
  },
  {
    "component": "YinYangSymbol",
    "name": "Yin-Yang-Symbol",
    "category": "25-shapes-symbols",
    "keywords": "yin-yang-symbol--religion-tao-yin-yang-taoism-culture-symbol",
    "duotone": true
  },
  {
    "component": "Ampersand",
    "name": "Ampersand",
    "category": "26-text-symbols",
    "keywords": "ampersand",
    "duotone": false
  },
  {
    "component": "Asterisk1",
    "name": "Asterisk-1",
    "category": "26-text-symbols",
    "keywords": "asterisk-1--asterisk-star-keyboard",
    "duotone": false
  },
  {
    "component": "BulletList",
    "name": "Bullet-List",
    "category": "26-text-symbols",
    "keywords": "bullet-list--points-bullet-unordered-list-lists-bullets",
    "duotone": true
  },
  {
    "component": "DivisionCircle",
    "name": "Division-Circle",
    "category": "26-text-symbols",
    "keywords": "division-circle--interface-math-divided-by-sign-mathematics",
    "duotone": true
  },
  {
    "component": "EqualSign",
    "name": "Equal-Sign",
    "category": "26-text-symbols",
    "keywords": "equal-sign--interface-math-equal-sign-mathematics",
    "duotone": false
  },
  {
    "component": "Factorial",
    "name": "Factorial",
    "category": "26-text-symbols",
    "keywords": "factorial--interface-math-number-factorial-sign-mathematics",
    "duotone": true
  },
  {
    "component": "Heading1ParagraphStylesHeading",
    "name": "Heading-1-Paragraph-Styles-Heading",
    "category": "26-text-symbols",
    "keywords": "heading-1-paragraph-styles-heading",
    "duotone": true
  },
  {
    "component": "Heading2ParagraphStylesHeading",
    "name": "Heading-2-Paragraph-Styles-Heading",
    "category": "26-text-symbols",
    "keywords": "heading-2-paragraph-styles-heading",
    "duotone": true
  },
  {
    "component": "Heading3ParagraphStylesHeading",
    "name": "Heading-3-Paragraph-Styles-Heading",
    "category": "26-text-symbols",
    "keywords": "heading-3-paragraph-styles-heading",
    "duotone": true
  },
  {
    "component": "InputBox",
    "name": "Input-Box",
    "category": "26-text-symbols",
    "keywords": "input-box--cursor-text-formatting-type-format",
    "duotone": true
  },
  {
    "component": "NotEqualSign",
    "name": "Not-Equal-Sign",
    "category": "26-text-symbols",
    "keywords": "not-equal-sign--interface-math-not-equal-sign-mathematics",
    "duotone": true
  },
  {
    "component": "Paragraph",
    "name": "Paragraph",
    "category": "26-text-symbols",
    "keywords": "paragraph--alignment-paragraph-formatting-text",
    "duotone": false
  },
  {
    "component": "PiSymbolCircle",
    "name": "Pi-Symbol-Circle",
    "category": "26-text-symbols",
    "keywords": "pi-symbol-circle--interface-math-pi-sign-mathematics-22-7",
    "duotone": true
  },
  {
    "component": "Quotation2",
    "name": "Quotation-2",
    "category": "26-text-symbols",
    "keywords": "quotation-2--quote-quotation-format-formatting-open-close-marks-text",
    "duotone": false
  },
  {
    "component": "Sigma",
    "name": "Sigma",
    "category": "26-text-symbols",
    "keywords": "sigma--formula-text-format-sigma-formatting-sum",
    "duotone": false
  },
  {
    "component": "SignAt",
    "name": "Sign-At",
    "category": "26-text-symbols",
    "keywords": "sign-at--mail-email-at-sign-read-address",
    "duotone": false
  },
  {
    "component": "SignHashtag",
    "name": "Sign-Hashtag",
    "category": "26-text-symbols",
    "keywords": "sign-hashtag--mail-sharp-sign-hashtag-tag",
    "duotone": false
  },
  {
    "component": "SquareRootXCircle",
    "name": "Square-Root-X-Circle",
    "category": "26-text-symbols",
    "keywords": "square-root-x-circle--interface-math-square-root-sign-mathematics",
    "duotone": true
  },
  {
    "component": "TaskList",
    "name": "Task-List",
    "category": "26-text-symbols",
    "keywords": "task-list--task-list-work",
    "duotone": true
  },
  {
    "component": "TextFlowRows",
    "name": "Text-Flow-Rows",
    "category": "26-text-symbols",
    "keywords": "text-flow-rows",
    "duotone": true
  },
  {
    "component": "TextSquare",
    "name": "Text-Square",
    "category": "26-text-symbols",
    "keywords": "text-square--text-options-formatting-format-square-color-border-fill",
    "duotone": true
  },
  {
    "component": "TextStyle",
    "name": "Text-Style",
    "category": "26-text-symbols",
    "keywords": "text-style--text-style-formatting-format",
    "duotone": false
  },
  {
    "component": "UnderlineText1",
    "name": "Underline-Text-1",
    "category": "26-text-symbols",
    "keywords": "underline-text-1--text-underline-formatting-format",
    "duotone": true
  },
  {
    "component": "Bank",
    "name": "Bank",
    "category": "27-buildings-places",
    "keywords": "bank--institution-saving-bank-payment-finance",
    "duotone": true
  },
  {
    "component": "Building2",
    "name": "Building-2",
    "category": "27-buildings-places",
    "keywords": "building-2--real-home-tower-building-house-estate",
    "duotone": true
  },
  {
    "component": "Capitol",
    "name": "Capitol",
    "category": "27-buildings-places",
    "keywords": "capitol--capitol-travel-places",
    "duotone": true
  },
  {
    "component": "CityHall",
    "name": "City-Hall",
    "category": "27-buildings-places",
    "keywords": "city-hall--city-hall-travel-places",
    "duotone": true
  },
  {
    "component": "Home3",
    "name": "Home-3",
    "category": "27-buildings-places",
    "keywords": "home-3--home-house-roof-shelter",
    "duotone": true
  },
  {
    "component": "Home4",
    "name": "Home-4",
    "category": "27-buildings-places",
    "keywords": "home-4--home-house-roof-shelter",
    "duotone": true
  },
  {
    "component": "IndustryInnovationAndInfrastructure",
    "name": "Industry-Innovation-And-Infrastructure",
    "category": "27-buildings-places",
    "keywords": "industry-innovation-and-infrastructure",
    "duotone": true
  },
  {
    "component": "OfficeBuilding1",
    "name": "Office-Building-1",
    "category": "27-buildings-places",
    "keywords": "office-building-1--office-building-work",
    "duotone": true
  },
  {
    "component": "Parliament",
    "name": "Parliament",
    "category": "27-buildings-places",
    "keywords": "parliament--travel-places-parliament",
    "duotone": true
  },
  {
    "component": "PiggyBank",
    "name": "Piggy-Bank",
    "category": "27-buildings-places",
    "keywords": "piggy-bank--institution-saving-bank-payment-finance",
    "duotone": true
  },
  {
    "component": "Backpack",
    "name": "Backpack",
    "category": "28-fashion-beauty",
    "keywords": "backpack--bag-backpack-school-baggage-cloth-clothing-accessories",
    "duotone": true
  },
  {
    "component": "Beanie",
    "name": "Beanie",
    "category": "28-fashion-beauty",
    "keywords": "beanie--beanie-winter-hat-warm-cloth-clothing-wearable-accessories",
    "duotone": true
  },
  {
    "component": "BowTie",
    "name": "Bow-Tie",
    "category": "28-fashion-beauty",
    "keywords": "bow-tie--bow-tie-dress-gentleman-cloth-clothing-accessories",
    "duotone": true
  },
  {
    "component": "Crown",
    "name": "Crown",
    "category": "28-fashion-beauty",
    "keywords": "crown--reward-social-rating-media-queen-vip-king-crown",
    "duotone": false
  },
  {
    "component": "Glasses",
    "name": "Glasses",
    "category": "28-fashion-beauty",
    "keywords": "glasses--vision-sunglasses-protection-spectacles-correction-sun-eye-glasses",
    "duotone": true
  },
  {
    "component": "Lipstick",
    "name": "Lipstick",
    "category": "28-fashion-beauty",
    "keywords": "lipstick--fashion-beauty-lip-lipstick-makeup-shopping",
    "duotone": true
  },
  {
    "component": "MakeUpBrush",
    "name": "Make-Up-Brush",
    "category": "28-fashion-beauty",
    "keywords": "make-up-brush--fashion-beauty-make-up-brush",
    "duotone": true
  },
  {
    "component": "Moustache",
    "name": "Moustache",
    "category": "28-fashion-beauty",
    "keywords": "moustache--fashion-beauty-moustache-grooming",
    "duotone": false
  },
  {
    "component": "MouthLip",
    "name": "Mouth-Lip",
    "category": "28-fashion-beauty",
    "keywords": "mouth-lip--fashion-beauty-mouth-lip",
    "duotone": true
  },
  {
    "component": "Necklace",
    "name": "Necklace",
    "category": "28-fashion-beauty",
    "keywords": "necklace--diamond-money-payment-finance-wealth-accessory-necklace-jewelry",
    "duotone": true
  },
  {
    "component": "Necktie",
    "name": "Necktie",
    "category": "28-fashion-beauty",
    "keywords": "necktie--necktie-businessman-business-cloth-clothing-gentleman-accessories",
    "duotone": true
  },
  {
    "component": "TallHat",
    "name": "Tall-Hat",
    "category": "28-fashion-beauty",
    "keywords": "tall-hat--tall-hat-cloth-clothing-wearable-magician-gentleman-accessories",
    "duotone": true
  },
  {
    "component": "Chair",
    "name": "Chair",
    "category": "29-furniture-household",
    "keywords": "chair--chair-business-product-comfort-decoration-sit-furniture",
    "duotone": true
  },
  {
    "component": "Closet",
    "name": "Closet",
    "category": "29-furniture-household",
    "keywords": "closet--closet-dressing-dresser-product-decoration-cloth-clothing-cabinet-furniture",
    "duotone": true
  },
  {
    "component": "DressingTable",
    "name": "Dressing-Table",
    "category": "29-furniture-household",
    "keywords": "dressing-table--makeup-dressing-table-mirror-cabinet-product-decoration-furniture",
    "duotone": true
  },
  {
    "component": "Iron",
    "name": "Iron",
    "category": "29-furniture-household",
    "keywords": "iron--laundry-iron-heat-hotel",
    "duotone": true
  },
  {
    "component": "Ladder",
    "name": "Ladder",
    "category": "29-furniture-household",
    "keywords": "ladder--business-product-metaphor-ladder",
    "duotone": false
  },
  {
    "component": "Microwave",
    "name": "Microwave",
    "category": "29-furniture-household",
    "keywords": "microwave--cook-food-appliances-cooking-nutrition-appliance-microwave-kitchenware",
    "duotone": true
  },
  {
    "component": "Refrigerator",
    "name": "Refrigerator",
    "category": "29-furniture-household",
    "keywords": "refrigerator--fridge-cook-appliances-cooking-nutrition-freezer-appliance-food-kitchenware",
    "duotone": true
  },
  {
    "component": "Shelf",
    "name": "Shelf",
    "category": "29-furniture-household",
    "keywords": "shelf--shelf-drawer-cabinet-prodcut-decoration-furniture",
    "duotone": true
  },
  {
    "component": "TableLamp1",
    "name": "Table-Lamp-1",
    "category": "29-furniture-household",
    "keywords": "table-lamp-1--lighting-light-incandescent-bulb-lights-table-lamp",
    "duotone": true
  },
  {
    "component": "WorkspaceDesk",
    "name": "Workspace-Desk",
    "category": "29-furniture-household",
    "keywords": "workspace-desk--workspace-desk-work",
    "duotone": true
  }
];

export { Add1, AddBellNotification, AddCircle, AddLayer2, AddSquare, AffordableAndCleanEnergy, AiChipSpark, AiCloudSpark, AiEditSpark, AiEmailGeneratorSpark, AiGamingSpark, AiGenerateLandscapeImageSpark, AiGenerateMusicSpark, AiGeneratePortraitImageSpark, AiGenerateVariationSpark, AiNavigationSpark, AiNetworkSpark, AiPromptSpark, AiRedoSpark, AiScienceSpark, AiSettingsSpark, AiTechnologySpark, AiUpscaleSpark, AiVehicleSpark1, Airplane, AirplaneDisabled, AirplaneEnabled, AirportPlane, AirportPlaneTransit, AirportSecurity, AlarmClock, WarningTriangle as AlertCircle, WarningTriangle as AlertTriangle, Alien, AlignBack1, AlignCenter, AlignFront1, AlignJustify, AlignLeft, AlignRight, Alt, Amazon, Ambulance, Ampersand, Anchor, Android, AnnouncementMegaphone, AppStore, Apple, ApplicationAdd, ArchiveBox as Archive, ArchiveBox, Chair as Armchair, ArrowBendLeftDown2, ArrowBendRightDown2, ArrowCrossoverDown, ArrowCrossoverLeft, ArrowCrossoverRight, ArrowCrossoverUp, ArrowCursor1, ArrowCursor2, ArrowCurvyUpDown1, ArrowCurvyUpDown2, ArrowDown2 as ArrowDown, ArrowDown2, AscendingNumberOrder as ArrowDownAZ, ArrowDownDashedSquare, ArrowDownRight, ArrowCurvyUpDown2 as ArrowDownUp, ArrowExpand, ArrowInfiniteLoop, ArrowLeft, ArrowMove, ArrowReloadHorizontal1, ArrowReloadHorizontal2, ArrowReloadVertical1, ArrowReloadVertical2, ArrowRight, ArrowRoadmap, ArrowRoundLeft, ArrowRoundRight, ArrowShrink, ArrowShrinkDiagonal1, ArrowShrinkDiagonal2, ArrowTransferDiagonal1, ArrowTransferDiagonal2, ArrowTransferDiagonal3, ArrowUp1 as ArrowUp, ArrowUp1, ArrowUpDashedSquare, ArrowCurvyUpDown1 as ArrowUpDown, ArrowUpRight, DescendingNumberOrder as ArrowUpZA, ArtificialIntelligenceSpark, AscendingNumberOrder, Asterisk1, Attribution, AutoFlash, StarBadge as Award, BackCamera1, Backpack, BacteriaVirusCellsBiology, StarBadge as BadgeCheck, Bag, BagDollar, BagPound, BagRupee, BagSuitcase1, BagSuitcase2, BagYen, Baggage, Ball, Balloon, Bandage, Bank, Bill2 as Banknote, GraphBarIncrease as BarChart2, Graph as BarChart3, BatteryAlert1, BatteryCharging, BatteryEmpty1, BatteryEmpty2, BatteryFull1, BatteryLow1, BatteryMedium1, Beach, Beanie, BeerMug, BeerPitch, RingingBellNotification as Bell, BicycleBike, Bill1, Bill2, Bill4, BillCashless, BinanceCircle, Bitcoin, BlankCalendar, BlankNotepad, BlockBellNotification, BloodBagDonation, BloodDonateDrop, BloodDropDonation, Bluetooth, BluetoothDisabled, BluetoothSearching, Bold, Bomb, Bone, OpenBook as BookOpen, BookReading, Bookmark, Bow, BowTie, BoxSign, IndustryInnovationAndInfrastructure as Boxes, BracesCircle, Bracket, BrailleBlind, Brain, BrainCognitive, BagSuitcase1 as Briefcase, BriefcaseDollar, Brightness1, Brightness2, Brightness3, BrokenLink2, BrowserAdd, BrowserBlock, BrowserBuild, BrowserCheck, BrowserDelete, BrowserHash, BrowserLock, BrowserMultipleWindow, BrowserRemove, BrowserWebsite1, BrowserWifi, Bug, BugAntivirusDebugging, BugAntivirusShield, BugVirusBrowser, BugVirusDocument, BugVirusFolder, OfficeBuilding1 as Building, Building2, BulletList, Burger, BurritoFastfood, Bus, BusinessCard, BusinessHandshake, BusinessIdeaMoney, BusinessProfessionHomeOffice, BusinessProgressBar2, BusinessUserCurriculum, ButtonFastForward1, ButtonFastForward2, ButtonNext, ButtonPause2, ButtonPlay, ButtonPower1, ButtonPrevious, ButtonRecord3, ButtonRewind1, ButtonRewind2, ButtonStop, CakeSlice, Calculator1 as Calculator, Calculator1, Calculator2, BlankCalendar as Calendar, CalendarAdd, WaitingAppointmentsCalendar as CalendarClock, CalendarEdit, CalendarJumpToDate, CalendarAdd as CalendarPlus, CalendarStar, CallCenterSupportService, CallHangUp, Camera1 as Camera, Camera1, CameraDisabled, CameraLoading, CameraSquare, CameraVideo, CampingTent, CandyCane, Cane, Capitol, CarBatteryCharging, CarTaxi1, Cards, Cat1, CellularNetwork4g, CellularNetwork5g, CellularNetworkLte, Celsius, Chair, ChampagnePartyAlcohol, ChatBubbleOval, ChatBubbleOvalNotification, ChatBubbleOvalSmiley1, ChatBubbleOvalSmiley2, ChatBubbleSquareBlock, ChatBubbleSquareQuestion, ChatBubbleSquareWarning, ChatBubbleSquareWrite, ChatBubbleTextSquare, ChatBubbleTypingOval, ChatTwoBubblesOval, Check, CheckSquare as CheckCheck, CheckSquare as CheckCircle, CheckSquare as CheckCircle2, Check as CheckIcon, CheckSquare, CheckupMedicalReportClipboard, Cheese, Cherries, ChessBishop, ChessKing, ChessKnight, ChessPawn, ChevronDown, ChevronDown as ChevronDownIcon, ChevronLeft, ChevronLeft as ChevronLeftIcon, ChevronRight, ChevronRight as ChevronRightIcon, ChevronUp, ChevronUp as ChevronUpIcon, ChevronsUpDown, ChickenGrilledStream, ChristianCross1, ChristianCross2, Christianity, Chrome, Circle, CircleClock, CircleFlask, Circle as CircleIcon, SubtractCircle as CircleSlash, CityHall, ClassLesson, CleanWaterAndSanitation, ClipboardAdd, ClipboardCheck, EmptyClipboard as ClipboardList, ClipboardRemove, CircleClock as Clock, Closet, Cloud, CloudAdd, CloudBlock, CloudCheck, CloudDataTransfer, CloudGaming1, CloudRefresh, CloudShare, CloudWarning, CloudWifi, ClubsSymbol, Cocktail, CodeAnalysis, CodeMonitor1, CodeMonitor2, CoffeeBean, CoffeeMug, CoffeeTakeawayCup, Cog, CoinShare, DollarCoin1 as Coins, CoinsStack, CollaborationsIdea, ColorPalette, ColorPicker, ColorSwatches, Comet, Command, CompassNavigator, CompositionOval, CompositionVertical, CompsitionHorizontal, ComputerChip1, ComputerChip2, ComputerPcDesktop, ConeShape, ContactPhonebook2, Container, Controller, Controller1, ControllerWireless, AlignBack1 as Copy, CopyPaste, Return2 as CornerUpLeft, CreativeCommons, CreditCard1 as CreditCard, CreditCard1, CreditCard2, CropSelection, Crown, Crutch, CssThree, CurlyBrackets, CursorClick, CustomerSupport1, Cut, Cyborg, Cyborg2, DangerousZoneSign, DarkDislayMode, Dashboard3, DashboardCircle, Database, DatabaseCheck, DatabaseLock, DatabaseRefresh, DatabaseRemove, DatabaseServer1, DatabaseServer2, DatabaseSetting, DatabaseSubtract2RaidStorageCodeDiskProgrammingDatabaseArrayHardDiscMinus, DecentWorkAndEconomicGrowth, DefinitionSearchBook, Delete1, DeleteKeyboard, DescendingNumberOrder, DesktopChat, DesktopCheck, DesktopCode, DesktopDelete, DesktopDollar, DesktopEmoji, DesktopFavoriteStar, DesktopGame, DesktopHelp, DeviceDatabaseEncryption1, Dhammajak, Diamond2, DiamondsSymbol, Dice1, Dice2, Dice3, Dice4, Dice5, Dice6, Dice2 as Dices, DicesEntertainmentGamingDices, DictionaryLanguageBook, DisableBellNotification, DisableHeart, Discord, DiscountPercentBadge, DiscountPercentCircle, DiscountPercentCoupon, DiscountPercentCutout, DiscountPercentFire, DiscussionConverstionReply, DivisionCircle, Dna, DollarCoin, DollarCoin1, DollarCoin as DollarSign, Donut, InboxTray1 as Download, DownloadBox1, DownloadCircle, DownloadComputer, DownloadFile, DressingTable, Drone, Dropbox, EarHearing, Earpods, Earth1, EarthAirplane, Pencil as Edit2, EditImagePhoto, Eject, ElectricCord1, ElectricCord3, EmergencyExit, EmptyClipboard, EpicGames1, EqualSign, ErlenmeyerFlask, Esports, Ethereum, EthereumCircle, Euro, Expand, ExpandHorizontal1, ExpandWindow2, ShareLink as ExternalLink, Visible as Eye, Invisible1 as EyeOff, EyeOptic, FaceScan1, Facebook1, Factorial, Fahrenheit, FastforwardClock, Figma, FileAddAlternate, ClipboardCheck as FileCheck, FileCode1, FileDeleteAlternate, Pencil as FileEdit, FileAddAlternate as FilePlus2, FileRemoveAlternate, BusinessHandshake as FileSignature, TaskList as FileSpreadsheet, NewFile as FileText, FileDeleteAlternate as FileX, FilmRoll1, FilmSlate, Filter2 as Filter, Filter2, Fingerprint1, Fingerprint2, FireAlarm2, FireExtinguisherSign, FireworksRocket, Fist, FitToHeightSquare, DiscountPercentFire as Flame, Flash1, Flash2, Flash3, FlashOff, ErlenmeyerFlask as FlaskConical, FlipVerticalArrow2, FlipVerticalCircle1, FlipVerticalSquare2, FloppyDisk, Flower, FluMask, FocusPoints, NewFolder as Folder, FolderAdd, FolderCheck, FolderDelete, NewFolder as FolderOpen, ForkKnife, ForkSpoon, Fragile, FrontCamera, Galaxy1, Galaxy2, Gameboy, GasStationFuelPetroleum, GenderEquality, GifFormat, Gift, Gift2, GiveGift, Glasses, GlobalLearning, Earth1 as Globe, Gmail, Gold, GoodHealthAndWellBeing, Google, GoogleDrive, GraduationCap, Gramophone, Graph, GraphArrowDecrease, GraphArrowIncrease, GraphBarDecrease, GraphBarIncrease, GraphDot, OneFingerDragVertical as GripVerticalIcon, GroupMeetingCall, HalfStar1, Wrench as Hammer, HandCursor, HandGrab, HandHeld, HandHeldTabletDrawing, HandHeldTabletWriting, BusinessHandshake as Handshake, HangUp1, HangUp2, HappyFace, HardDisk, HardDrive1, TrafficCone as HardHat, Heading1ParagraphStylesHeading, Heading2ParagraphStylesHeading, Heading3ParagraphStylesHeading, CustomerSupport1 as Headphones, HealthCare2, HearingDeaf1, HearingDeaf2, Heart, HeartRatePulseGraph, HeartRateSearch, HeartsSymbol, HelpChat2, HelpQuestion1 as HelpCircle, HelpQuestion1, Hexagram, Hierarchy10, Hierarchy13, Hierarchy14, Hierarchy2, Hierarchy4, Hierarchy7, HighSpeedTrainFront, Highlighter, Hinduism, ArrowRoundLeft as History, Home3, Home4, HorizontalMenuCircle, HospitalSignCircle, HospitalSignSquare, HotSpring, HotelAirConditioner, HotelBed2, HotelLaundry, HotelOneStar, HotelShowerHead, HotelTwoStar, HumidityNone, ICON_CATALOG, IceCream2, IceCream3, Landscape2 as Image, ImageBlur, ImageSaturation, InboxBlock, InboxFavorite, InboxFavoriteHeart, InboxLock, InboxTray1, InboxTray2, IncognitoMode, IncomingCall, IndustryInnovationAndInfrastructure, InformationCircle as Info, InformationCircle, InformationDesk, InformationDeskCustomer, InputBox, InsertCloudVideo, InsertSide, InsertTopLeft, InsertTopRight, Instagram, InsuranceHand, InvestmentSelection, Invisible1, Invisible2, Iron, Islam, Italic, JumpObject, JusticeHammer, JusticeScale1, JusticeScale2, Key, Keyboard, KeyboardVirtual, KeyboardWireless2, KeyholeLockCircle, Ladder, Landscape2, LandscapeSetting, LaptopCamera, LaptopCharging, LassoTool, Layers1 as Layers, Layers1, Layers2, Dashboard3 as LayoutDashboard, Dashboard3 as LayoutGrid, LayoutWindow1, LayoutWindow11, LayoutWindow2, LayoutWindow8, Leaf, LemonFruitSeasoning, Lift, LiftDisability, Lightbulb, Like1, Link, LinkChain as Link2, LinkChain, Linkedin, Lipstick, List, ListOrdered, LiveVideo, FastforwardClock as Loader, SignalLoading as Loader2, LocalStorageFolder, LocationCompass1, LocationPin3, LocationPinDisabled, LocationTarget1, PadlockSquare1 as Lock, LockRotation, Log, Login1 as LogIn, Logout1 as LogOut, Login1, Logout1, Loop1, LostAndFound, MagicWand2, MagnifyingGlass, MagnifyingGlassCircle, MailSendEnvelope as Mail, MailIncoming, MailSearch, MailSendEmailMessage, MailSendEnvelope, MailSendReplyAll, MakeUpBrush, ManSymbol, ManualBook, MapFold, TriangleFlag as MapPin, MarkdownCircleProgramming, MarkdownDocumentProgramming, ArrowExpand as Maximize2, UserMultipleGroup as Medal, MedicalBag, MedicalCrossSignHealthcare, MedicalCrossSymbol, MedicalFilesReportHistory, MedicalRibbon1, MedicalSearchDiagnosis, Megaphone2, Menu, Filter2 as Merge, ChatBubbleOval as MessageCircle, ChatBubbleTextSquare as MessageSquare, ChatBubbleTextSquare as MessageSquareText, Meta, MicroscopeObservationSciene, Microwave, Milkshake, MinimizeWindow2, Subtract1 as Minus, Subtract1 as MinusIcon, MissedCall, MobilePhoneCamera, ModulePuzzle1, ModulePuzzle3, ModuleThree, Screen1 as Monitor, WaningCresentMoon as Moon, MoonCloud, HorizontalMenuCircle as MoreHorizontal, HorizontalMenuCircle as MoreHorizontalIcon, Mouse, MouseWireless, MouseWireless1, Moustache, MouthLip, MoveLeft, MoveRight, MultipleFile2, MusicEqualizer, MusicFolderSong, MusicNote1, MusicNote2, MusicNoteOff1, MusicNoteOff2, NavigationArrowOff, NavigationArrowOn, Necklace, Necktie, Netflix, Network, NewFile, NewFolder, NewStickyNote, NewsPaper, Next, NintendoSwitch, NoPoverty, NotEqualSign, NotificationAlarm2, NotificationApplication1, NotificationApplication2, NotificationMessageAlert, NurseAssistantEmergency, NurseHat, Octopus, OfficeBuilding1, OfficeWorker, OkHand, OneFingerDragHorizontal, OneFingerDragVertical, OneFingerHold, OneFingerTap, OneVesusOne, OnlineMedicalCallService, OnlineMedicalServiceMonitor, OnlineMedicalWebService, OpenBook, OpenUmbrella, OrientationLandscape, OrientationPortrait, OutgoingCall, ShippingBox1 as Package, ShipmentCheck as PackageCheck, Pacman, PadlockSquare1, PageSetting, PaintBucket, PaintPalette, Paintbrush1, Paintbrush2, Palette, MoveLeft as PanelLeftClose, Dashboard3 as PanelLeftIcon, MoveRight as PanelLeftOpen, MoveRight as PanelRightClose, MoveLeft as PanelRightOpen, Paperclip1 as Paperclip, Paperclip1, ParachuteDrop, Paragraph, ParkingSign, Parliament, PartyPopper, Passport, PathfinderDivide, PathfinderExclude, PathfinderIntersect, PathfinderMerge, PathfinderMinusFront1, PathfinderTrim, PathfinderUnion, ButtonPause2 as PauseCircle, Payment10, PaymentCashOut3, Paypal, PeaceHand, PeaceSymbol, Pen3, PenDraw, PenDraw as PenLine, PenTool, Pencil, Pentagon, DiscountPercentCircle as Percent, PetPaw, PetriDishLabEquipment, PetsAllowed, Pharmacy, Phone, PhoneMobilePhone, PhoneQr, PhoneRinging1, PhoneRinging2, PiSymbolCircle, PicturesFolderMemories, PieChart, PiggyBank, NotificationApplication1 as Pin, Planet, ButtonPlay as Play, ButtonPlay as PlayCircle, PlayList4, PlayList5, PlayList8, PlayList9, PlayListFolder, PlayStation, PlayStore, Add1 as Plus, AddCircle as PlusCircle, Podium, PolaroidFour, PoliticsCompaign, PoliticsSpeech, PoliticsVote2, PolkaDotCircle, Polygon, PoolLadder, Popcorn, PorkMeat, PottedFlowerTulip, PrayingHand, PrescriptionPillsDrugsHealthcare, Printer, ProductionBelt, ProjectorBoard, PyramidShape, QrCode, QualityEducation, Quotation2, Radio, Radioactive2, RainCloud, Rainbow, Receipt, ReceiptAdd, ReceiptCheck, ReceiptSubtract, Receipt as ReceiptText, RecordingTapeBubbleCircle, RecordingTapeBubbleSquare, Recycle1 as Recycle, Recycle1, RecycleBin2, ReducedInequalities, ArrowReloadHorizontal2 as RefreshCcw, ArrowReloadHorizontal2 as RefreshCw, Refrigerator, RemoveFormatting, Return2, RingingBellNotification, RockAndRollHand, RockSlide, FireworksRocket as Rocket, Rose, RotateAngle45, ArrowRoundLeft as RotateCcw, ArrowRoundRight as RotateCw, RoundCap, RssSquare, RssSymbol, Ruler, SadFace, SafeVault, SailShip, SatelliteDish, Scanner, Scanner3, ScannerBarCode, SchoolBusSide, Screen1, Screen2, ScreenBroadcast, ScreenCurve, ScreensaverMonitorWallpaper, Script2, Search, SearchDollar, Search as SearchIcon, SearchVisual, SearchVisual as SearchX, SelectCircleArea1, SendEmail as Send, SendEmail, DatabaseSetting as ServerCog, ServingDome, Cog as Settings, ShareLink, Shelf, Shell, Shield2 as Shield, Shield1, Shield2, WarningOctagon as ShieldAlert, ShieldCheck, ShieldCross, ChatBubbleSquareQuestion as ShieldQuestion, Shift, ShipmentAdd, ShipmentCheck, ShipmentDownload, ShipmentRemove, ShipmentUpload, ShippingBox1, ShippingTruck, Necktie as Shirt, ShoppingBagHandBag2 as ShoppingBag, ShoppingBagHandBag2, ShoppingBasket1, ShoppingBasket2, ShoppingCart1 as ShoppingCart, ShoppingCart1, ShoppingCart2, ShoppingCart3, ShoppingCartAdd, ShoppingCartCheck, ShoppingCartSubtract, ShovelRake, Shredder, Shrimp, ShrinkHorizontal1, Shuffle, Sigma, SignAt, SignCrossSquare, SignHashtag, Signage3, Signage4, SignalFull, SignalLoading, SignalLow, SignalMedium, SignalNone, Skull1, Slack, Sleep, VerticalSliderSquare as SlidersHorizontal, HappyFace as Smile, SmileyAngry, SmileyCool, SmileyCrying1, SmileyCute, SmileyDrool, SmileyEmojiKissNervous, SmileyEmojiTerrified, SmileyGrumpy, SmileyHappy, SmileyInLove, SmileyKiss, SmileyLaughing3, SmileyMask, SmileyNauseas, SmileySmirk, SmileySparks, SmileySurprised, SmileyThrowUp, SmileyVeryShocked, SmokeDetector, SmokingArea, Snorkle, SnowFlake, SongRecommendation, SortDescending, SosHelpEmergencySign, SpadesSymbol, AiRedoSpark as Sparkles, Speaker1, Speaker2, SpiralShape, SplitVertical, Spotify, SprayPaint as SprayCan, SprayPaint, Sprout, SquareBracketsCircle, SquareCap, SquareClock, SquareRootXCircle, Star1 as Star, Star1, Star2, StarBadge, Startup, SteeringWheel, StepsNumber, Stethoscope, NewStickyNote as StickyNote, Stock, Store1 as Store, Store1, Store2, StoreComputer, StraightCap, StraightFace, StrategyTasks, Strawberry, Stream, StreetRoad, StreetSign, Strikethrough, SubscriptionCashflow, Subtract1, SubtractCircle, SubtractSquare, Brightness1 as Sun, SunCloud, SynchronizeDisable, SynchronizeWarning, Syringe, TableLamp1, TabletCapsule, Tag, TakeOff, TallHat, TapeCassetteRecord, Target, Target3, TaskList, TeaCup, Telegram, Telescope, TestTube, TextFlowRows, TextSquare, TextStyle, Thermometer, ThreatBrowser1, ThreatDocument, ThreatFolder, DisableHeart as ThumbsDown, Like1 as ThumbsUp, Ticket1 as Ticket, Ticket1, Tickets, TidalWave, Tiktok, Tinder, Toast, ToiletMan, ToiletSignManWoman2, ToiletWomen, Tooth, TrafficCone, TransferMotorcycle, TransferVan, RecycleBin2 as Trash2, Tree2, Tree3, TrendingContent, GraphArrowDecrease as TrendingDown, GraphArrowIncrease as TrendingUp, TriangleFlag, Trophy, ShippingTruck as Truck, Twitter, TwoFingerDragHotizontal, TwoFingerTap, Type, Underline, UnderlineText1, Unlink, InboxTray2 as Upload, UploadBox1, UploadCircle, UploadComputer, UploadFile, UsbDrive, UserSingleNeutralMale as User, UserAddPlus, UserCheckValidate, UserCircleSingle, UserIdentifierCard, UserMultipleCircle, UserMultipleGroup, UserAddPlus as UserPlus, UserProfileFocus, UserProtection2, UserRemoveSubtract, UserCircleSingle as UserRound, UserSingleNeutralMale, UserSyncOnlineInPerson, UserMultipleGroup as Users, ForkKnife as UtensilsCrossed, VerticalSliderSquare, VideoSwapCamera, VirtualReality, VirusAntivirus, Visible, VoiceMail, VoiceMailOff, VoiceScan2, Volcano, VolumeDown, VolumeLevelHigh, VolumeLevelLow, VolumeLevelOff, VolumeMute, VolumeOff, VpnConnection, VrHeadset1, VrHeadset2, WaitingAppointmentsCalendar, Wallet, WalletPurse, WaningCresentMoon, Warehouse1, WarningOctagon, WarningTriangle, Watch1, Watch2, WatchCircleCharging, WatchCircleHeartbeatMonitor1, WatchCircleHeartbeatMonitor2, WatchCircleMenu, WatchCircleTime, WaterGlass, WaveSignal, WaveSignalSquare, WavingHand, Web, Webcam, WebcamVideo, WebcamVideoCircle, WebcamVideoOff, Whatsapp, Wheelchair, Wheelchair1, Widget, Wifi, WifiAntenna, WifiDisabled, WifiHorizontal, WifiRouter, WindFlow1, WindFlow2, Windmill, Windows, Wine, WomanSymbol, WorkspaceDesk, Wrench, Delete1 as X, Delete1 as XCircle, Delete1 as XIcon, Xbox, XrpCircle, YinYangSymbol, Yuan, YuanCircle, Flash1 as Zap, ZeroHunger, Zodiac1, Zodiac10, Zodiac11, Zodiac12, Zodiac2, Zodiac3, Zodiac4, Zodiac5, Zodiac6, Zodiac7, Zodiac8, Zodiac9, createIcon, createStrokeIcon };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map